var bv = Object.defineProperty;
var vv = (e, t, n) => t in e ? bv(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var fc = (e, t, n) => (vv(e, typeof t != "symbol" ? t + "" : t, n), n);
import { jsx as h, Fragment as Dt, jsxs as J } from "react/jsx-runtime";
import Iu from "chartjs-plugin-datalabels";
import * as U from "react";
import ct, { createContext as ai, useEffect as it, useCallback as Qe, useContext as si, Suspense as $m, useState as Xe, lazy as xe, cloneElement as Da, useRef as Ot, useMemo as Ee, memo as Nm, Fragment as kr, useLayoutEffect as Dl, Children as Cv, isValidElement as qs, forwardRef as Vt, createElement as cs, useDebugValue as Gd, useReducer as wv, useImperativeHandle as xv } from "react";
import { useLocation as Fm, Link as Qo, Outlet as Vm, useParams as Sv, useNavigate as Tv } from "react-router-dom";
import { getContrastRatio as _v, styled as Q, useTheme as qt, createTheme as jm, useThemeProps as Ze, alpha as sn, lighten as Vo, darken as da, ThemeProvider as Dv } from "@mui/material/styles";
import { CostType as Pv } from "@zappy-ride/library.calculations/dist/calcs/Base/Base.types";
import At from "lodash.get";
import Be from "@mui/material/Box";
import Pl from "@mui/material/CircularProgress";
import { Ability as Ov } from "@casl/ability";
import { createContextualCan as kv } from "@casl/react";
import Mv from "@mui/icons-material/ExpandMore";
import Lm from "@mui/material/Accordion";
import Ev from "@mui/material/AccordionDetails";
import Bm from "@mui/material/AccordionSummary";
import ve from "@mui/material/Typography";
import xa from "@mui/material/Alert";
import Iv from "@mui/material/AlertTitle";
import Ie from "@mui/material/Stack";
import Kd from "@mui/icons-material/BrokenImage";
import pr from "@mui/material/Button";
import Co from "@mui/material/Card";
import Ru from "@mui/material/CardActions";
import Ol from "@mui/material/CardContent";
import zm from "@mui/material/CardHeader";
import Rv from "@mui/material/CardMedia";
import Av from "@mui/icons-material/ChevronLeft";
import $v from "@mui/icons-material/ChevronRight";
import tn from "@mui/material/IconButton";
import { useTranslation as Zd, Trans as Vn } from "react-i18next";
import kt from "@mui/material/Divider";
import Je from "@mui/material/Grid";
import Nv from "@mui/material/Tooltip";
import kl from "@mui/material/Chip";
import Qd from "lodash/get";
import { Chart as Fv } from "react-chartjs-2";
import { _adapters as Vv, Chart as Ml, CategoryScale as jv, LinearScale as Lv, BarElement as Bv, Title as zv, Tooltip as Wv, Legend as qv, PointElement as Hv, LineElement as Uv, TimeScale as Yv, LineController as Gv, BarController as Kv, defaults as Zv } from "chart.js";
import { useForkRef as zn, FormControl as li, FormGroup as Wm, FormControlLabel as Fa, Checkbox as El, FormHelperText as ci, TextField as Il, useTheme as qm, FormLabel as Rl, InputLabel as Qv, Select as Jv, Chip as Xv, MenuItem as Hm, ListItemText as eC, InputAdornment as tC, IconButton as nC, RadioGroup as rC, Radio as Jd, Switch as oC, Autocomplete as iC, Slider as aC, TextareaAutosize as sC, ToggleButtonGroup as lC, ToggleButton as cC, styled as uC } from "@mui/material";
import { useController as Zt, useWatch as Jo, FormProvider as Um, useForm as ui, get as Kc, set as pc, appendErrors as dC, Controller as Al, useFormContext as $l, useFormState as fC, useFieldArray as pC } from "react-hook-form";
import Ym from "@mui/icons-material/Cancel";
import mC from "@mui/icons-material/Visibility";
import hC from "@mui/icons-material/VisibilityOff";
import jr from "@mui/material/useMediaQuery";
import { createSvgIcon as Lr } from "@mui/material/utils";
import Xo from "@mui/material/Fade";
import gC from "@mui/material/ButtonBase";
import Is from "react-dom";
import { ThemeContext as yC } from "@emotion/react";
import us from "@mui/material/TextField";
import Gm from "@mui/material/InputAdornment";
import bC from "@mui/material/Grow";
import vC from "@mui/material/Paper";
import CC from "@mui/material/Popper";
import wC from "@mui/material/Unstable_TrapFocus";
import Km from "@mui/material/DialogActions";
import xC from "@mui/material/List";
import SC from "@mui/material/ListItem";
import Zm from "@mui/material/DialogContent";
import Qm, { dialogClasses as Xd } from "@mui/material/Dialog";
import Zc from "@mui/material/Tab";
import Jm, { tabsClasses as TC } from "@mui/material/Tabs";
import Xm from "@mui/material/MenuList";
import ds from "@mui/material/MenuItem";
import _C from "@mui/icons-material/DoneRounded";
import DC from "@mui/icons-material/Remove";
import PC from "@mui/material/Checkbox";
import Au from "@mui/material/FormControl";
import OC from "@mui/material/FormControlLabel";
import kC from "@mui/material/FormGroup";
import $u from "@mui/material/FormHelperText";
import eh from "@mui/material/FormLabel";
import di from "@mui/material/Link";
import Or from "@mui/material/Skeleton";
import MC from "@emotion/styled";
import Nl from "@mui/icons-material/Close";
import EC from "@mui/material/DialogTitle";
import th from "@mui/icons-material/ArrowBack";
import Nu from "@mui/material/Container";
import IC from "@mui/icons-material/FilePresent";
import RC from "@mui/icons-material/UploadFile";
import AC from "@mui/icons-material/Check";
import $C from "@mui/icons-material/Delete";
import NC from "@mui/icons-material/Edit";
import FC from "@mui/material/ListItemText";
import VC from "@mui/material/InputLabel";
import nh from "@mui/material/Select";
import { useFinanceCalculations as jC } from "@zappy-ride/library.calculations";
import LC from "@mui/icons-material/AttachMoney";
import BC from "@mui/icons-material/CalendarToday";
import zC from "@mui/icons-material/MonetizationOn";
import WC from "@mui/icons-material/VpnKey";
import qC from "@mui/material/Pagination";
import HC from "@mui/material/PaginationItem";
import UC from "@mui/material/AppBar";
import YC from "@mui/material/Toolbar";
import GC from "@mui/icons-material/Public";
import KC from "@mui/icons-material/Menu";
import ZC from "@mui/material/Drawer";
import QC from "@mui/icons-material/AccountCircle";
import JC from "@mui/icons-material/Logout";
import XC from "@mui/material/Popover";
import ew from "@mui/material/ToggleButton";
import tw from "@mui/material/ToggleButtonGroup";
import nw from "@mui/material/Backdrop";
import rw from "@mui/icons-material/CelebrationOutlined";
import ow from "@mui/material/Avatar";
import iw from "@mui/material/Hidden";
import aw, { stepClasses as fa } from "@mui/material/Step";
import sw, { stepLabelClasses as Mo } from "@mui/material/StepLabel";
import lw, { StepperContext as cw } from "@mui/material/Stepper";
import uw, { SliderValueLabel as dw } from "@mui/material/Slider";
import fw from "@mui/icons-material/AdjustOutlined";
import pw from "@mui/icons-material/CheckCircle";
import mw from "@mui/icons-material/CircleOutlined";
import ef, { stepConnectorClasses as pn } from "@mui/material/StepConnector";
import { stepContentClasses as tf } from "@mui/material/StepContent";
var ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Mt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rh = {}, oh = {}, ih = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = function() {
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    if (typeof window < "u") {
      var l;
      typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
        window.dataLayer.push(arguments);
      }), (l = window).gtag.apply(l, i);
    }
  }, n = t;
  e.default = n;
})(ih);
var ah = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = s;
  var t = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
  function n(l) {
    return l.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(u, c, d) {
      return c > 0 && c + u.length !== d.length && u.search(t) > -1 && d.charAt(c - 2) !== ":" && (d.charAt(c + u.length) !== "-" || d.charAt(c - 1) === "-") && d.charAt(c - 1).search(/[^\s-]/) < 0 ? u.toLowerCase() : u.substr(1).search(/[A-Z]|\../) > -1 ? u : u.charAt(0).toUpperCase() + u.substr(1);
    });
  }
  function r(l) {
    return typeof l == "string" && l.indexOf("@") !== -1;
  }
  var o = "REDACTED (Potential Email Address)";
  function i(l) {
    return r(l) ? (console.warn("This arg looks like an email address, redacting."), o) : l;
  }
  function s() {
    var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, d = l || "";
    return u && (d = n(l)), c && (d = i(d)), d;
  }
})(ah);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.GA4 = void 0;
  var t = s(ih), n = s(ah), r = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], o = ["title", "location"], i = ["page", "hitType"];
  function s(M) {
    return M && M.__esModule ? M : { default: M };
  }
  function l(M, _) {
    if (M == null)
      return {};
    var O = u(M, _), R, N;
    if (Object.getOwnPropertySymbols) {
      var L = Object.getOwnPropertySymbols(M);
      for (N = 0; N < L.length; N++)
        R = L[N], !(_.indexOf(R) >= 0) && Object.prototype.propertyIsEnumerable.call(M, R) && (O[R] = M[R]);
    }
    return O;
  }
  function u(M, _) {
    if (M == null)
      return {};
    var O = {}, R = Object.keys(M), N, L;
    for (L = 0; L < R.length; L++)
      N = R[L], !(_.indexOf(N) >= 0) && (O[N] = M[N]);
    return O;
  }
  function c(M) {
    "@babel/helpers - typeof";
    return c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_) {
      return typeof _;
    } : function(_) {
      return _ && typeof Symbol == "function" && _.constructor === Symbol && _ !== Symbol.prototype ? "symbol" : typeof _;
    }, c(M);
  }
  function d(M) {
    return p(M) || f(M) || w(M) || m();
  }
  function m() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function f(M) {
    if (typeof Symbol < "u" && M[Symbol.iterator] != null || M["@@iterator"] != null)
      return Array.from(M);
  }
  function p(M) {
    if (Array.isArray(M))
      return v(M);
  }
  function b(M, _) {
    var O = Object.keys(M);
    if (Object.getOwnPropertySymbols) {
      var R = Object.getOwnPropertySymbols(M);
      _ && (R = R.filter(function(N) {
        return Object.getOwnPropertyDescriptor(M, N).enumerable;
      })), O.push.apply(O, R);
    }
    return O;
  }
  function g(M) {
    for (var _ = 1; _ < arguments.length; _++) {
      var O = arguments[_] != null ? arguments[_] : {};
      _ % 2 ? b(Object(O), !0).forEach(function(R) {
        P(M, R, O[R]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(M, Object.getOwnPropertyDescriptors(O)) : b(Object(O)).forEach(function(R) {
        Object.defineProperty(M, R, Object.getOwnPropertyDescriptor(O, R));
      });
    }
    return M;
  }
  function S(M, _) {
    return T(M) || x(M, _) || w(M, _) || C();
  }
  function C() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function w(M, _) {
    if (M) {
      if (typeof M == "string")
        return v(M, _);
      var O = Object.prototype.toString.call(M).slice(8, -1);
      if (O === "Object" && M.constructor && (O = M.constructor.name), O === "Map" || O === "Set")
        return Array.from(M);
      if (O === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(O))
        return v(M, _);
    }
  }
  function v(M, _) {
    (_ == null || _ > M.length) && (_ = M.length);
    for (var O = 0, R = new Array(_); O < _; O++)
      R[O] = M[O];
    return R;
  }
  function x(M, _) {
    var O = M == null ? null : typeof Symbol < "u" && M[Symbol.iterator] || M["@@iterator"];
    if (O != null) {
      var R, N, L, $, H = [], G = !0, q = !1;
      try {
        if (L = (O = O.call(M)).next, _ === 0) {
          if (Object(O) !== O)
            return;
          G = !1;
        } else
          for (; !(G = (R = L.call(O)).done) && (H.push(R.value), H.length !== _); G = !0)
            ;
      } catch (Y) {
        q = !0, N = Y;
      } finally {
        try {
          if (!G && O.return != null && ($ = O.return(), Object($) !== $))
            return;
        } finally {
          if (q)
            throw N;
        }
      }
      return H;
    }
  }
  function T(M) {
    if (Array.isArray(M))
      return M;
  }
  function E(M, _) {
    if (!(M instanceof _))
      throw new TypeError("Cannot call a class as a function");
  }
  function k(M, _) {
    for (var O = 0; O < _.length; O++) {
      var R = _[O];
      R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(M, F(R.key), R);
    }
  }
  function I(M, _, O) {
    return _ && k(M.prototype, _), O && k(M, O), Object.defineProperty(M, "prototype", { writable: !1 }), M;
  }
  function P(M, _, O) {
    return _ = F(_), _ in M ? Object.defineProperty(M, _, { value: O, enumerable: !0, configurable: !0, writable: !0 }) : M[_] = O, M;
  }
  function F(M) {
    var _ = A(M, "string");
    return c(_) === "symbol" ? _ : String(_);
  }
  function A(M, _) {
    if (c(M) !== "object" || M === null)
      return M;
    var O = M[Symbol.toPrimitive];
    if (O !== void 0) {
      var R = O.call(M, _ || "default");
      if (c(R) !== "object")
        return R;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (_ === "string" ? String : Number)(M);
  }
  var B = /* @__PURE__ */ function() {
    function M() {
      var _ = this;
      E(this, M), P(this, "reset", function() {
        _.isInitialized = !1, _._testMode = !1, _._currentMeasurementId, _._hasLoadedGA = !1, _._isQueuing = !1, _._queueGtag = [];
      }), P(this, "_gtag", function() {
        for (var O = arguments.length, R = new Array(O), N = 0; N < O; N++)
          R[N] = arguments[N];
        _._testMode || _._isQueuing ? _._queueGtag.push(R) : t.default.apply(void 0, R);
      }), P(this, "_loadGA", function(O, R) {
        var N = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
        if (!(typeof window > "u" || typeof document > "u") && !_._hasLoadedGA) {
          var L = document.createElement("script");
          L.async = !0, L.src = "".concat(N, "?id=").concat(O), R && L.setAttribute("nonce", R), document.body.appendChild(L), window.dataLayer = window.dataLayer || [], window.gtag = function() {
            window.dataLayer.push(arguments);
          }, _._hasLoadedGA = !0;
        }
      }), P(this, "_toGtagOptions", function(O) {
        if (O) {
          var R = {
            // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
            // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
            cookieUpdate: "cookie_update",
            cookieExpires: "cookie_expires",
            cookieDomain: "cookie_domain",
            cookieFlags: "cookie_flags",
            // must be in set method?
            userId: "user_id",
            clientId: "client_id",
            anonymizeIp: "anonymize_ip",
            // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
            contentGroup1: "content_group1",
            contentGroup2: "content_group2",
            contentGroup3: "content_group3",
            contentGroup4: "content_group4",
            contentGroup5: "content_group5",
            // https://support.google.com/analytics/answer/9050852?hl=en
            allowAdFeatures: "allow_google_signals",
            allowAdPersonalizationSignals: "allow_ad_personalization_signals",
            nonInteraction: "non_interaction",
            page: "page_path",
            hitCallback: "event_callback"
          }, N = Object.entries(O).reduce(function(L, $) {
            var H = S($, 2), G = H[0], q = H[1];
            return R[G] ? L[R[G]] = q : L[G] = q, L;
          }, {});
          return N;
        }
      }), P(this, "initialize", function(O) {
        var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!O)
          throw new Error("Require GA_MEASUREMENT_ID");
        var N = typeof O == "string" ? [{
          trackingId: O
        }] : O;
        _._currentMeasurementId = N[0].trackingId;
        var L = R.gaOptions, $ = R.gtagOptions, H = R.nonce, G = R.testMode, q = G === void 0 ? !1 : G, Y = R.gtagUrl;
        if (_._testMode = q, q || _._loadGA(_._currentMeasurementId, H, Y), _.isInitialized || (_._gtag("js", /* @__PURE__ */ new Date()), N.forEach(function(X) {
          var se = g(g(g({}, _._toGtagOptions(g(g({}, L), X.gaOptions))), $), X.gtagOptions);
          Object.keys(se).length ? _._gtag("config", X.trackingId, se) : _._gtag("config", X.trackingId);
        })), _.isInitialized = !0, !q) {
          var Z = d(_._queueGtag);
          for (_._queueGtag = [], _._isQueuing = !1; Z.length; ) {
            var ie = Z.shift();
            _._gtag.apply(_, d(ie)), ie[0] === "get" && (_._isQueuing = !0);
          }
        }
      }), P(this, "set", function(O) {
        if (!O) {
          console.warn("`fieldsObject` is required in .set()");
          return;
        }
        if (c(O) !== "object") {
          console.warn("Expected `fieldsObject` arg to be an Object");
          return;
        }
        Object.keys(O).length === 0 && console.warn("empty `fieldsObject` given to .set()"), _._gaCommand("set", O);
      }), P(this, "_gaCommandSendEvent", function(O, R, N, L, $) {
        _._gtag("event", R, g(g({
          event_category: O,
          event_label: N,
          value: L
        }, $ && {
          non_interaction: $.nonInteraction
        }), _._toGtagOptions($)));
      }), P(this, "_gaCommandSendEventParameters", function() {
        for (var O = arguments.length, R = new Array(O), N = 0; N < O; N++)
          R[N] = arguments[N];
        if (typeof R[0] == "string")
          _._gaCommandSendEvent.apply(_, d(R.slice(1)));
        else {
          var L = R[0], $ = L.eventCategory, H = L.eventAction, G = L.eventLabel, q = L.eventValue;
          L.hitType;
          var Y = l(L, r);
          _._gaCommandSendEvent($, H, G, q, Y);
        }
      }), P(this, "_gaCommandSendTiming", function(O, R, N, L) {
        _._gtag("event", "timing_complete", {
          name: R,
          value: N,
          event_category: O,
          event_label: L
        });
      }), P(this, "_gaCommandSendPageview", function(O, R) {
        if (R && Object.keys(R).length) {
          var N = _._toGtagOptions(R), L = N.title, $ = N.location, H = l(N, o);
          _._gtag("event", "page_view", g(g(g(g({}, O && {
            page_path: O
          }), L && {
            page_title: L
          }), $ && {
            page_location: $
          }), H));
        } else
          O ? _._gtag("event", "page_view", {
            page_path: O
          }) : _._gtag("event", "page_view");
      }), P(this, "_gaCommandSendPageviewParameters", function() {
        for (var O = arguments.length, R = new Array(O), N = 0; N < O; N++)
          R[N] = arguments[N];
        if (typeof R[0] == "string")
          _._gaCommandSendPageview.apply(_, d(R.slice(1)));
        else {
          var L = R[0], $ = L.page;
          L.hitType;
          var H = l(L, i);
          _._gaCommandSendPageview($, H);
        }
      }), P(this, "_gaCommandSend", function() {
        for (var O = arguments.length, R = new Array(O), N = 0; N < O; N++)
          R[N] = arguments[N];
        var L = typeof R[0] == "string" ? R[0] : R[0].hitType;
        switch (L) {
          case "event":
            _._gaCommandSendEventParameters.apply(_, R);
            break;
          case "pageview":
            _._gaCommandSendPageviewParameters.apply(_, R);
            break;
          case "timing":
            _._gaCommandSendTiming.apply(_, d(R.slice(1)));
            break;
          case "screenview":
          case "transaction":
          case "item":
          case "social":
          case "exception":
            console.warn("Unsupported send command: ".concat(L));
            break;
          default:
            console.warn("Send command doesn't exist: ".concat(L));
        }
      }), P(this, "_gaCommandSet", function() {
        for (var O = arguments.length, R = new Array(O), N = 0; N < O; N++)
          R[N] = arguments[N];
        typeof R[0] == "string" && (R[0] = P({}, R[0], R[1])), _._gtag("set", _._toGtagOptions(R[0]));
      }), P(this, "_gaCommand", function(O) {
        for (var R = arguments.length, N = new Array(R > 1 ? R - 1 : 0), L = 1; L < R; L++)
          N[L - 1] = arguments[L];
        switch (O) {
          case "send":
            _._gaCommandSend.apply(_, N);
            break;
          case "set":
            _._gaCommandSet.apply(_, N);
            break;
          default:
            console.warn("Command doesn't exist: ".concat(O));
        }
      }), P(this, "ga", function() {
        for (var O = arguments.length, R = new Array(O), N = 0; N < O; N++)
          R[N] = arguments[N];
        if (typeof R[0] == "string")
          _._gaCommand.apply(_, R);
        else {
          var L = R[0];
          _._gtag("get", _._currentMeasurementId, "client_id", function($) {
            _._isQueuing = !1;
            var H = _._queueGtag;
            for (L({
              get: function(Y) {
                return Y === "clientId" ? $ : Y === "trackingId" ? _._currentMeasurementId : Y === "apiVersion" ? "1" : void 0;
              }
            }); H.length; ) {
              var G = H.shift();
              _._gtag.apply(_, d(G));
            }
          }), _._isQueuing = !0;
        }
        return _.ga;
      }), P(this, "event", function(O, R) {
        if (typeof O == "string")
          _._gtag("event", O, _._toGtagOptions(R));
        else {
          var N = O.action, L = O.category, $ = O.label, H = O.value, G = O.nonInteraction, q = O.transport;
          if (!L || !N) {
            console.warn("args.category AND args.action are required in event()");
            return;
          }
          var Y = {
            hitType: "event",
            eventCategory: (0, n.default)(L),
            eventAction: (0, n.default)(N)
          };
          $ && (Y.eventLabel = (0, n.default)($)), typeof H < "u" && (typeof H != "number" ? console.warn("Expected `args.value` arg to be a Number.") : Y.eventValue = H), typeof G < "u" && (typeof G != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : Y.nonInteraction = G), typeof q < "u" && (typeof q != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(q) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), Y.transport = q)), _._gaCommand("send", Y);
        }
      }), P(this, "send", function(O) {
        _._gaCommand("send", O);
      }), this.reset();
    }
    return I(M, [{
      key: "gtag",
      value: function() {
        this._gtag.apply(this, arguments);
      }
    }]), M;
  }();
  e.GA4 = B;
  var W = new B();
  e.default = W;
})(oh);
(function(e) {
  function t(l) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
      return typeof u;
    } : function(u) {
      return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
    }, t(l);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.ReactGAImplementation = void 0;
  var n = o(oh);
  function r(l) {
    if (typeof WeakMap != "function")
      return null;
    var u = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
    return (r = function(m) {
      return m ? c : u;
    })(l);
  }
  function o(l, u) {
    if (!u && l && l.__esModule)
      return l;
    if (l === null || t(l) !== "object" && typeof l != "function")
      return { default: l };
    var c = r(u);
    if (c && c.has(l))
      return c.get(l);
    var d = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var f in l)
      if (f !== "default" && Object.prototype.hasOwnProperty.call(l, f)) {
        var p = m ? Object.getOwnPropertyDescriptor(l, f) : null;
        p && (p.get || p.set) ? Object.defineProperty(d, f, p) : d[f] = l[f];
      }
    return d.default = l, c && c.set(l, d), d;
  }
  var i = n.GA4;
  e.ReactGAImplementation = i;
  var s = n.default;
  e.default = s;
})(rh);
const Eo = /* @__PURE__ */ Mt(rh), Fu = (e, t) => {
  const { palette: n, typography: r } = e, { link: o, contrastThreshold: i } = n, { light: s, main: l } = o;
  return {
    color: _v(l, t) >= i ? l : s,
    fontWeight: r.fontWeightBold,
    textDecoration: "none"
  };
};
var sh = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = 1e3, r = 6e4, o = 36e5, i = "millisecond", s = "second", l = "minute", u = "hour", c = "day", d = "week", m = "month", f = "quarter", p = "year", b = "date", g = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, C = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, w = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
      var _ = ["th", "st", "nd", "rd"], O = M % 100;
      return "[" + M + (_[(O - 20) % 10] || _[O] || _[0]) + "]";
    } }, v = function(M, _, O) {
      var R = String(M);
      return !R || R.length >= _ ? M : "" + Array(_ + 1 - R.length).join(O) + M;
    }, x = { s: v, z: function(M) {
      var _ = -M.utcOffset(), O = Math.abs(_), R = Math.floor(O / 60), N = O % 60;
      return (_ <= 0 ? "+" : "-") + v(R, 2, "0") + ":" + v(N, 2, "0");
    }, m: function M(_, O) {
      if (_.date() < O.date())
        return -M(O, _);
      var R = 12 * (O.year() - _.year()) + (O.month() - _.month()), N = _.clone().add(R, m), L = O - N < 0, $ = _.clone().add(R + (L ? -1 : 1), m);
      return +(-(R + (O - N) / (L ? N - $ : $ - N)) || 0);
    }, a: function(M) {
      return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
    }, p: function(M) {
      return { M: m, y: p, w: d, d: c, D: b, h: u, m: l, s, ms: i, Q: f }[M] || String(M || "").toLowerCase().replace(/s$/, "");
    }, u: function(M) {
      return M === void 0;
    } }, T = "en", E = {};
    E[T] = w;
    var k = "$isDayjsObject", I = function(M) {
      return M instanceof B || !(!M || !M[k]);
    }, P = function M(_, O, R) {
      var N;
      if (!_)
        return T;
      if (typeof _ == "string") {
        var L = _.toLowerCase();
        E[L] && (N = L), O && (E[L] = O, N = L);
        var $ = _.split("-");
        if (!N && $.length > 1)
          return M($[0]);
      } else {
        var H = _.name;
        E[H] = _, N = H;
      }
      return !R && N && (T = N), N || !R && T;
    }, F = function(M, _) {
      if (I(M))
        return M.clone();
      var O = typeof _ == "object" ? _ : {};
      return O.date = M, O.args = arguments, new B(O);
    }, A = x;
    A.l = P, A.i = I, A.w = function(M, _) {
      return F(M, { locale: _.$L, utc: _.$u, x: _.$x, $offset: _.$offset });
    };
    var B = function() {
      function M(O) {
        this.$L = P(O.locale, null, !0), this.parse(O), this.$x = this.$x || O.x || {}, this[k] = !0;
      }
      var _ = M.prototype;
      return _.parse = function(O) {
        this.$d = function(R) {
          var N = R.date, L = R.utc;
          if (N === null)
            return /* @__PURE__ */ new Date(NaN);
          if (A.u(N))
            return /* @__PURE__ */ new Date();
          if (N instanceof Date)
            return new Date(N);
          if (typeof N == "string" && !/Z$/i.test(N)) {
            var $ = N.match(S);
            if ($) {
              var H = $[2] - 1 || 0, G = ($[7] || "0").substring(0, 3);
              return L ? new Date(Date.UTC($[1], H, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, G)) : new Date($[1], H, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, G);
            }
          }
          return new Date(N);
        }(O), this.init();
      }, _.init = function() {
        var O = this.$d;
        this.$y = O.getFullYear(), this.$M = O.getMonth(), this.$D = O.getDate(), this.$W = O.getDay(), this.$H = O.getHours(), this.$m = O.getMinutes(), this.$s = O.getSeconds(), this.$ms = O.getMilliseconds();
      }, _.$utils = function() {
        return A;
      }, _.isValid = function() {
        return this.$d.toString() !== g;
      }, _.isSame = function(O, R) {
        var N = F(O);
        return this.startOf(R) <= N && N <= this.endOf(R);
      }, _.isAfter = function(O, R) {
        return F(O) < this.startOf(R);
      }, _.isBefore = function(O, R) {
        return this.endOf(R) < F(O);
      }, _.$g = function(O, R, N) {
        return A.u(O) ? this[R] : this.set(N, O);
      }, _.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, _.valueOf = function() {
        return this.$d.getTime();
      }, _.startOf = function(O, R) {
        var N = this, L = !!A.u(R) || R, $ = A.p(O), H = function(fe, le) {
          var ce = A.w(N.$u ? Date.UTC(N.$y, le, fe) : new Date(N.$y, le, fe), N);
          return L ? ce : ce.endOf(c);
        }, G = function(fe, le) {
          return A.w(N.toDate()[fe].apply(N.toDate("s"), (L ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(le)), N);
        }, q = this.$W, Y = this.$M, Z = this.$D, ie = "set" + (this.$u ? "UTC" : "");
        switch ($) {
          case p:
            return L ? H(1, 0) : H(31, 11);
          case m:
            return L ? H(1, Y) : H(0, Y + 1);
          case d:
            var X = this.$locale().weekStart || 0, se = (q < X ? q + 7 : q) - X;
            return H(L ? Z - se : Z + (6 - se), Y);
          case c:
          case b:
            return G(ie + "Hours", 0);
          case u:
            return G(ie + "Minutes", 1);
          case l:
            return G(ie + "Seconds", 2);
          case s:
            return G(ie + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, _.endOf = function(O) {
        return this.startOf(O, !1);
      }, _.$set = function(O, R) {
        var N, L = A.p(O), $ = "set" + (this.$u ? "UTC" : ""), H = (N = {}, N[c] = $ + "Date", N[b] = $ + "Date", N[m] = $ + "Month", N[p] = $ + "FullYear", N[u] = $ + "Hours", N[l] = $ + "Minutes", N[s] = $ + "Seconds", N[i] = $ + "Milliseconds", N)[L], G = L === c ? this.$D + (R - this.$W) : R;
        if (L === m || L === p) {
          var q = this.clone().set(b, 1);
          q.$d[H](G), q.init(), this.$d = q.set(b, Math.min(this.$D, q.daysInMonth())).$d;
        } else
          H && this.$d[H](G);
        return this.init(), this;
      }, _.set = function(O, R) {
        return this.clone().$set(O, R);
      }, _.get = function(O) {
        return this[A.p(O)]();
      }, _.add = function(O, R) {
        var N, L = this;
        O = Number(O);
        var $ = A.p(R), H = function(Y) {
          var Z = F(L);
          return A.w(Z.date(Z.date() + Math.round(Y * O)), L);
        };
        if ($ === m)
          return this.set(m, this.$M + O);
        if ($ === p)
          return this.set(p, this.$y + O);
        if ($ === c)
          return H(1);
        if ($ === d)
          return H(7);
        var G = (N = {}, N[l] = r, N[u] = o, N[s] = n, N)[$] || 1, q = this.$d.getTime() + O * G;
        return A.w(q, this);
      }, _.subtract = function(O, R) {
        return this.add(-1 * O, R);
      }, _.format = function(O) {
        var R = this, N = this.$locale();
        if (!this.isValid())
          return N.invalidDate || g;
        var L = O || "YYYY-MM-DDTHH:mm:ssZ", $ = A.z(this), H = this.$H, G = this.$m, q = this.$M, Y = N.weekdays, Z = N.months, ie = N.meridiem, X = function(le, ce, ee, ae) {
          return le && (le[ce] || le(R, L)) || ee[ce].slice(0, ae);
        }, se = function(le) {
          return A.s(H % 12 || 12, le, "0");
        }, fe = ie || function(le, ce, ee) {
          var ae = le < 12 ? "AM" : "PM";
          return ee ? ae.toLowerCase() : ae;
        };
        return L.replace(C, function(le, ce) {
          return ce || function(ee) {
            switch (ee) {
              case "YY":
                return String(R.$y).slice(-2);
              case "YYYY":
                return A.s(R.$y, 4, "0");
              case "M":
                return q + 1;
              case "MM":
                return A.s(q + 1, 2, "0");
              case "MMM":
                return X(N.monthsShort, q, Z, 3);
              case "MMMM":
                return X(Z, q);
              case "D":
                return R.$D;
              case "DD":
                return A.s(R.$D, 2, "0");
              case "d":
                return String(R.$W);
              case "dd":
                return X(N.weekdaysMin, R.$W, Y, 2);
              case "ddd":
                return X(N.weekdaysShort, R.$W, Y, 3);
              case "dddd":
                return Y[R.$W];
              case "H":
                return String(H);
              case "HH":
                return A.s(H, 2, "0");
              case "h":
                return se(1);
              case "hh":
                return se(2);
              case "a":
                return fe(H, G, !0);
              case "A":
                return fe(H, G, !1);
              case "m":
                return String(G);
              case "mm":
                return A.s(G, 2, "0");
              case "s":
                return String(R.$s);
              case "ss":
                return A.s(R.$s, 2, "0");
              case "SSS":
                return A.s(R.$ms, 3, "0");
              case "Z":
                return $;
            }
            return null;
          }(le) || $.replace(":", "");
        });
      }, _.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, _.diff = function(O, R, N) {
        var L, $ = this, H = A.p(R), G = F(O), q = (G.utcOffset() - this.utcOffset()) * r, Y = this - G, Z = function() {
          return A.m($, G);
        };
        switch (H) {
          case p:
            L = Z() / 12;
            break;
          case m:
            L = Z();
            break;
          case f:
            L = Z() / 3;
            break;
          case d:
            L = (Y - q) / 6048e5;
            break;
          case c:
            L = (Y - q) / 864e5;
            break;
          case u:
            L = Y / o;
            break;
          case l:
            L = Y / r;
            break;
          case s:
            L = Y / n;
            break;
          default:
            L = Y;
        }
        return N ? L : A.a(L);
      }, _.daysInMonth = function() {
        return this.endOf(m).$D;
      }, _.$locale = function() {
        return E[this.$L];
      }, _.locale = function(O, R) {
        if (!O)
          return this.$L;
        var N = this.clone(), L = P(O, R, !0);
        return L && (N.$L = L), N;
      }, _.clone = function() {
        return A.w(this.$d, this);
      }, _.toDate = function() {
        return new Date(this.valueOf());
      }, _.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, _.toISOString = function() {
        return this.$d.toISOString();
      }, _.toString = function() {
        return this.$d.toUTCString();
      }, M;
    }(), W = B.prototype;
    return F.prototype = W, [["$ms", i], ["$s", s], ["$m", l], ["$H", u], ["$W", c], ["$M", m], ["$y", p], ["$D", b]].forEach(function(M) {
      W[M[1]] = function(_) {
        return this.$g(_, M[0], M[1]);
      };
    }), F.extend = function(M, _) {
      return M.$i || (M(_, B, F), M.$i = !0), F;
    }, F.locale = P, F.isDayjs = I, F.unix = function(M) {
      return F(1e3 * M);
    }, F.en = E[T], F.Ls = E, F.p = {}, F;
  });
})(sh);
var hw = sh.exports;
const Ye = /* @__PURE__ */ Mt(hw);
var lh = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    return function(n, r, o) {
      n = n || {};
      var i = r.prototype, s = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function l(c, d, m, f) {
        return i.fromToBase(c, d, m, f);
      }
      o.en.relativeTime = s, i.fromToBase = function(c, d, m, f, p) {
        for (var b, g, S, C = m.$locale().relativeTime || s, w = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], v = w.length, x = 0; x < v; x += 1) {
          var T = w[x];
          T.d && (b = f ? o(c).diff(m, T.d, !0) : m.diff(c, T.d, !0));
          var E = (n.rounding || Math.round)(Math.abs(b));
          if (S = b > 0, E <= T.r || !T.r) {
            E <= 1 && x > 0 && (T = w[x - 1]);
            var k = C[T.l];
            p && (E = p("" + E)), g = typeof k == "string" ? k.replace("%d", E) : k(E, d, T.l, S);
            break;
          }
        }
        if (d)
          return g;
        var I = S ? C.future : C.past;
        return typeof I == "function" ? I(g) : I.replace("%s", g);
      }, i.to = function(c, d) {
        return l(c, d, this, !0);
      }, i.from = function(c, d) {
        return l(c, d, this);
      };
      var u = function(c) {
        return c.$u ? o.utc() : o();
      };
      i.toNow = function(c) {
        return this.to(u(this), c);
      }, i.fromNow = function(c) {
        return this.from(u(this), c);
      };
    };
  });
})(lh);
var gw = lh.exports;
const yw = /* @__PURE__ */ Mt(gw);
var ch = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
    return function(o, i, s) {
      var l, u = function(f, p, b) {
        b === void 0 && (b = {});
        var g = new Date(f), S = function(C, w) {
          w === void 0 && (w = {});
          var v = w.timeZoneName || "short", x = C + "|" + v, T = r[x];
          return T || (T = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: C, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: v }), r[x] = T), T;
        }(p, b);
        return S.formatToParts(g);
      }, c = function(f, p) {
        for (var b = u(f, p), g = [], S = 0; S < b.length; S += 1) {
          var C = b[S], w = C.type, v = C.value, x = n[w];
          x >= 0 && (g[x] = parseInt(v, 10));
        }
        var T = g[3], E = T === 24 ? 0 : T, k = g[0] + "-" + g[1] + "-" + g[2] + " " + E + ":" + g[4] + ":" + g[5] + ":000", I = +f;
        return (s.utc(k).valueOf() - (I -= I % 1e3)) / 6e4;
      }, d = i.prototype;
      d.tz = function(f, p) {
        f === void 0 && (f = l);
        var b = this.utcOffset(), g = this.toDate(), S = g.toLocaleString("en-US", { timeZone: f }), C = Math.round((g - new Date(S)) / 1e3 / 60), w = s(S, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(g.getTimezoneOffset() / 15) - C, !0);
        if (p) {
          var v = w.utcOffset();
          w = w.add(b - v, "minute");
        }
        return w.$x.$timezone = f, w;
      }, d.offsetName = function(f) {
        var p = this.$x.$timezone || s.tz.guess(), b = u(this.valueOf(), p, { timeZoneName: f }).find(function(g) {
          return g.type.toLowerCase() === "timezonename";
        });
        return b && b.value;
      };
      var m = d.startOf;
      d.startOf = function(f, p) {
        if (!this.$x || !this.$x.$timezone)
          return m.call(this, f, p);
        var b = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return m.call(b, f, p).tz(this.$x.$timezone, !0);
      }, s.tz = function(f, p, b) {
        var g = b && p, S = b || p || l, C = c(+s(), S);
        if (typeof f != "string")
          return s(f).tz(S);
        var w = function(E, k, I) {
          var P = E - 60 * k * 1e3, F = c(P, I);
          if (k === F)
            return [P, k];
          var A = c(P -= 60 * (F - k) * 1e3, I);
          return F === A ? [P, F] : [E - 60 * Math.min(F, A) * 1e3, Math.max(F, A)];
        }(s.utc(f, g).valueOf(), C, S), v = w[0], x = w[1], T = s(v).utcOffset(x);
        return T.$x.$timezone = S, T;
      }, s.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, s.tz.setDefault = function(f) {
        l = f;
      };
    };
  });
})(ch);
var bw = ch.exports;
const uh = /* @__PURE__ */ Mt(bw);
var dh = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    return function(n, r, o) {
      o.updateLocale = function(i, s) {
        var l = o.Ls[i];
        if (l)
          return (s ? Object.keys(s) : []).forEach(function(u) {
            l[u] = s[u];
          }), l;
      };
    };
  });
})(dh);
var vw = dh.exports;
const Cw = /* @__PURE__ */ Mt(vw);
var fh = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(i, s, l) {
      var u = s.prototype;
      l.utc = function(g) {
        var S = { date: g, utc: !0, args: arguments };
        return new s(S);
      }, u.utc = function(g) {
        var S = l(this.toDate(), { locale: this.$L, utc: !0 });
        return g ? S.add(this.utcOffset(), n) : S;
      }, u.local = function() {
        return l(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var c = u.parse;
      u.parse = function(g) {
        g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
      };
      var d = u.init;
      u.init = function() {
        if (this.$u) {
          var g = this.$d;
          this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
        } else
          d.call(this);
      };
      var m = u.utcOffset;
      u.utcOffset = function(g, S) {
        var C = this.$utils().u;
        if (C(g))
          return this.$u ? 0 : C(this.$offset) ? m.call(this) : this.$offset;
        if (typeof g == "string" && (g = function(T) {
          T === void 0 && (T = "");
          var E = T.match(r);
          if (!E)
            return null;
          var k = ("" + E[0]).match(o) || ["-", 0, 0], I = k[0], P = 60 * +k[1] + +k[2];
          return P === 0 ? 0 : I === "+" ? P : -P;
        }(g), g === null))
          return this;
        var w = Math.abs(g) <= 16 ? 60 * g : g, v = this;
        if (S)
          return v.$offset = w, v.$u = g === 0, v;
        if (g !== 0) {
          var x = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (v = this.local().add(w + x, n)).$offset = w, v.$x.$localOffset = x;
        } else
          v = this.utc();
        return v;
      };
      var f = u.format;
      u.format = function(g) {
        var S = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return f.call(this, S);
      }, u.valueOf = function() {
        var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * g;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var p = u.toDate;
      u.toDate = function(g) {
        return g === "s" && this.$offset ? l(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
      };
      var b = u.diff;
      u.diff = function(g, S, C) {
        if (g && this.$u === g.$u)
          return b.call(this, g, S, C);
        var w = this.local(), v = l(g).local();
        return b.call(w, v, S, C);
      };
    };
  });
})(fh);
var ww = fh.exports;
const ph = /* @__PURE__ */ Mt(ww), xw = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "%d week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
}, Sw = [
  { l: "s", r: 1 },
  { l: "m", r: 1 },
  { l: "mm", r: 59, d: "minute" },
  { l: "h", r: 1 },
  { l: "hh", r: 23, d: "hour" },
  { l: "d", r: 1 },
  { l: "dd", r: 84, d: "day" },
  { l: "M", r: 1 },
  { l: "MM", r: 60, d: "month" },
  { l: "y", r: 1 },
  { l: "yy", d: "year" }
], Tw = {
  thresholds: Sw,
  rounding: Math.ceil
};
function _w(e) {
  const { ww: t, dd: n } = e;
  return {
    ...e,
    dd: function(r) {
      return console.log(">>>>>> aqui", r), r >= 30 ? t.replace("%d", `${Math.ceil(r / 7)}`) : n.replace("%d", `${r}`);
    }
  };
}
const Dw = {
  relativeTimeConfig: Tw,
  getLocaleConfig: _w
}, Pw = [
  { l: "s", r: 1 },
  { l: "m", r: 1 },
  { l: "mm", r: 59, d: "minute" },
  { l: "h", r: 1 },
  { l: "hh", r: 23, d: "hour" },
  { l: "d", r: 1 },
  { l: "dd", r: 29, d: "day" },
  { l: "M", r: 1 },
  { l: "MM", r: 11, d: "month" },
  { l: "y", r: 1 },
  { l: "yy", d: "year" }
], Ow = {
  thresholds: Pw
};
function kw(e) {
  return e;
}
const Mw = {
  relativeTimeConfig: Ow,
  getLocaleConfig: kw
};
Ye.extend(ph);
Ye.extend(uh);
Ye.extend(Cw);
Ye.tz.setDefault("America/New_York");
const Ew = {
  en: xw
}, nf = {
  relativeTimeExtenedInWeeks: Dw,
  default: Mw
};
var rf;
(function(e) {
  e.RelativeTimeExtenedInWeeks = "relativeTimeExtenedInWeeks", e.Default = "default";
})(rf || (rf = {}));
const Iw = (e) => {
  var o, i;
  const t = /^(\d+)(\D+)/, n = parseInt(e), r = ((i = (o = e.match(t)) == null ? void 0 : o[2]) == null ? void 0 : i.trim()) ?? "week";
  return [n, r];
}, Rw = () => {
  let e;
  const t = () => ({
    currentDate: Ye(),
    setUpRelativeTimeMode: (r) => {
      const { mode: o = "default", lngs: i = ["en"] } = r || {}, { relativeTimeConfig: s, getLocaleConfig: l } = nf[o] || nf.default;
      Ye.extend(yw, s), i.forEach((u) => {
        const c = Ew[u], d = l(c);
        Ye.updateLocale(u, {
          relativeTime: d
        });
      });
    },
    // The duration should be a string and must have followed by a unit.
    // Refer to the description of util splitNumberAndUnit
    addDurationToDate: (r, o) => {
      const [i, s] = Iw(o);
      return Ye(r).add(i, s);
    },
    addWeeksToDate: (r, o) => Ye(r).add(o, "week"),
    formatDate: (r, o = "MM/DD/YY") => r ? Ye(r).format(o) : e.currentDate.format(o),
    getDiffInWeeks: (r, o) => {
      const i = e.formatDate(r), s = e.formatDate(o ?? e.currentDate);
      return Ye(s).diff(i, "week");
    },
    getDiffInDays: (r, o) => {
      const i = e.formatDate(r), s = e.formatDate(o ?? e.currentDate);
      return Ye(s).diff(i, "day");
    },
    fromString: (r, o = "YYYY-MM-DD") => Ye(r, o),
    isOverdueDate: (r, o) => {
      const i = Ye(r);
      return Ye(o).diff(i, "day") < 0;
    },
    relativeTime: (r, o) => {
      const i = Ye(r);
      return Ye(o).from(i, !0);
    }
  });
  return { getInstance: () => (e || (e = t()), e) };
}, MY = Rw().getInstance(), Pa = {
  DCFC: "dc_fast_charging",
  Level1: "level_1",
  Level2: "level_2"
};
var mh = /* @__PURE__ */ ((e) => (e.Yes = "Yes", e.No = "No", e.Unset = "Unset", e))(mh || {}), Hs = /* @__PURE__ */ ((e) => (e.Eligible = "eligible", e.Ineligible = "ineligible", e.Forthcoming = "forthcoming", e))(Hs || {}), et;
(function(e) {
  e.assertEqual = (o) => o;
  function t(o) {
  }
  e.assertIs = t;
  function n(o) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (o) => {
    const i = {};
    for (const s of o)
      i[s] = s;
    return i;
  }, e.getValidEnumValues = (o) => {
    const i = e.objectKeys(o).filter((l) => typeof o[o[l]] != "number"), s = {};
    for (const l of i)
      s[l] = o[l];
    return e.objectValues(s);
  }, e.objectValues = (o) => e.objectKeys(o).map(function(i) {
    return o[i];
  }), e.objectKeys = typeof Object.keys == "function" ? (o) => Object.keys(o) : (o) => {
    const i = [];
    for (const s in o)
      Object.prototype.hasOwnProperty.call(o, s) && i.push(s);
    return i;
  }, e.find = (o, i) => {
    for (const s of o)
      if (i(s))
        return s;
  }, e.isInteger = typeof Number.isInteger == "function" ? (o) => Number.isInteger(o) : (o) => typeof o == "number" && isFinite(o) && Math.floor(o) === o;
  function r(o, i = " | ") {
    return o.map((s) => typeof s == "string" ? `'${s}'` : s).join(i);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (o, i) => typeof i == "bigint" ? i.toString() : i;
})(et || (et = {}));
var Qc;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(Qc || (Qc = {}));
const Oe = et.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Dr = (e) => {
  switch (typeof e) {
    case "undefined":
      return Oe.undefined;
    case "string":
      return Oe.string;
    case "number":
      return isNaN(e) ? Oe.nan : Oe.number;
    case "boolean":
      return Oe.boolean;
    case "function":
      return Oe.function;
    case "bigint":
      return Oe.bigint;
    case "symbol":
      return Oe.symbol;
    case "object":
      return Array.isArray(e) ? Oe.array : e === null ? Oe.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? Oe.promise : typeof Map < "u" && e instanceof Map ? Oe.map : typeof Set < "u" && e instanceof Set ? Oe.set : typeof Date < "u" && e instanceof Date ? Oe.date : Oe.object;
    default:
      return Oe.unknown;
  }
}, ge = et.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Aw = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class Nn extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function(i) {
      return i.message;
    }, r = { _errors: [] }, o = (i) => {
      for (const s of i.issues)
        if (s.code === "invalid_union")
          s.unionErrors.map(o);
        else if (s.code === "invalid_return_type")
          o(s.returnTypeError);
        else if (s.code === "invalid_arguments")
          o(s.argumentsError);
        else if (s.path.length === 0)
          r._errors.push(n(s));
        else {
          let l = r, u = 0;
          for (; u < s.path.length; ) {
            const c = s.path[u];
            u === s.path.length - 1 ? (l[c] = l[c] || { _errors: [] }, l[c]._errors.push(n(s))) : l[c] = l[c] || { _errors: [] }, l = l[c], u++;
          }
        }
    };
    return o(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, et.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const o of this.issues)
      o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Nn.create = (e) => new Nn(e);
const Va = (e, t) => {
  let n;
  switch (e.code) {
    case ge.invalid_type:
      e.received === Oe.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case ge.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, et.jsonStringifyReplacer)}`;
      break;
    case ge.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${et.joinValues(e.keys, ", ")}`;
      break;
    case ge.invalid_union:
      n = "Invalid input";
      break;
    case ge.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${et.joinValues(e.options)}`;
      break;
    case ge.invalid_enum_value:
      n = `Invalid enum value. Expected ${et.joinValues(e.options)}, received '${e.received}'`;
      break;
    case ge.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case ge.invalid_return_type:
      n = "Invalid function return type";
      break;
    case ge.invalid_date:
      n = "Invalid date";
      break;
    case ge.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : et.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case ge.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case ge.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case ge.custom:
      n = "Invalid input";
      break;
    case ge.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case ge.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case ge.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, et.assertNever(e);
  }
  return { message: n };
};
let hh = Va;
function $w(e) {
  hh = e;
}
function Ys() {
  return hh;
}
const Gs = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: o } = e, i = [...n, ...o.path || []], s = {
    ...o,
    path: i
  };
  let l = "";
  const u = r.filter((c) => !!c).slice().reverse();
  for (const c of u)
    l = c(s, { data: t, defaultError: l }).message;
  return {
    ...o,
    path: i,
    message: o.message || l
  };
}, Nw = [];
function ke(e, t) {
  const n = Gs({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      Ys(),
      Va
      // then global default map
    ].filter((r) => !!r)
  });
  e.common.issues.push(n);
}
class Yt {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const o of n) {
      if (o.status === "aborted")
        return ze;
      o.status === "dirty" && t.dirty(), r.push(o.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const o of n)
      r.push({
        key: await o.key,
        value: await o.value
      });
    return Yt.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const o of n) {
      const { key: i, value: s } = o;
      if (i.status === "aborted" || s.status === "aborted")
        return ze;
      i.status === "dirty" && t.dirty(), s.status === "dirty" && t.dirty(), i.value !== "__proto__" && (typeof s.value < "u" || o.alwaysSet) && (r[i.value] = s.value);
    }
    return { status: t.value, value: r };
  }
}
const ze = Object.freeze({
  status: "aborted"
}), gh = (e) => ({ status: "dirty", value: e }), nn = (e) => ({ status: "valid", value: e }), Jc = (e) => e.status === "aborted", Xc = (e) => e.status === "dirty", ja = (e) => e.status === "valid", Ks = (e) => typeof Promise < "u" && e instanceof Promise;
var Ne;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Ne || (Ne = {}));
class Xn {
  constructor(t, n, r, o) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = o;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const of = (e, t) => {
  if (ja(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new Nn(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function qe(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: o } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: o } : { errorMap: (s, l) => s.code !== "invalid_type" ? { message: l.defaultError } : typeof l.data > "u" ? { message: r ?? l.defaultError } : { message: n ?? l.defaultError }, description: o };
}
class Ge {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return Dr(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: Dr(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new Yt(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: Dr(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Ks(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const o = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Dr(t)
    }, i = this._parseSync({ data: t, path: o.path, parent: o });
    return of(o, i);
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: Dr(t)
    }, o = this._parse({ data: t, path: r.path, parent: r }), i = await (Ks(o) ? o : Promise.resolve(o));
    return of(r, i);
  }
  refine(t, n) {
    const r = (o) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(o) : n;
    return this._refinement((o, i) => {
      const s = t(o), l = () => i.addIssue({
        code: ge.custom,
        ...r(o)
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then((u) => u ? !0 : (l(), !1)) : s ? !0 : (l(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, o) => t(r) ? !0 : (o.addIssue(typeof n == "function" ? n(r, o) : n), !1));
  }
  _refinement(t) {
    return new jn({
      schema: this,
      typeName: je.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return hr.create(this, this._def);
  }
  nullable() {
    return po.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Fn.create(this, this._def);
  }
  promise() {
    return ti.create(this, this._def);
  }
  or(t) {
    return Wa.create([this, t], this._def);
  }
  and(t) {
    return qa.create(this, t, this._def);
  }
  transform(t) {
    return new jn({
      ...qe(this._def),
      schema: this,
      typeName: je.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Ka({
      ...qe(this._def),
      innerType: this,
      defaultValue: n,
      typeName: je.ZodDefault
    });
  }
  brand() {
    return new bh({
      typeName: je.ZodBranded,
      type: this,
      ...qe(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Xs({
      ...qe(this._def),
      innerType: this,
      catchValue: n,
      typeName: je.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return fs.create(this, t);
  }
  readonly() {
    return tl.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Fw = /^c[^\s-]{8,}$/i, Vw = /^[a-z][a-z0-9]*$/, jw = /^[0-9A-HJKMNP-TV-Z]{26}$/, Lw = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Bw = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, zw = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let mc;
const Ww = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, qw = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Hw = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function Uw(e, t) {
  return !!((t === "v4" || !t) && Ww.test(e) || (t === "v6" || !t) && qw.test(e));
}
class An extends Ge {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== Oe.string) {
      const i = this._getOrReturnCtx(t);
      return ke(
        i,
        {
          code: ge.invalid_type,
          expected: Oe.string,
          received: i.parsedType
        }
        //
      ), ze;
    }
    const r = new Yt();
    let o;
    for (const i of this._def.checks)
      if (i.kind === "min")
        t.data.length < i.value && (o = this._getOrReturnCtx(t, o), ke(o, {
          code: ge.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "max")
        t.data.length > i.value && (o = this._getOrReturnCtx(t, o), ke(o, {
          code: ge.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), r.dirty());
      else if (i.kind === "length") {
        const s = t.data.length > i.value, l = t.data.length < i.value;
        (s || l) && (o = this._getOrReturnCtx(t, o), s ? ke(o, {
          code: ge.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : l && ke(o, {
          code: ge.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), r.dirty());
      } else if (i.kind === "email")
        Bw.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "email",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "emoji")
        mc || (mc = new RegExp(zw, "u")), mc.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "emoji",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "uuid")
        Lw.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "uuid",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid")
        Fw.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "cuid",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "cuid2")
        Vw.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "cuid2",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "ulid")
        jw.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "ulid",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty());
      else if (i.kind === "url")
        try {
          new URL(t.data);
        } catch {
          o = this._getOrReturnCtx(t, o), ke(o, {
            validation: "url",
            code: ge.invalid_string,
            message: i.message
          }), r.dirty();
        }
      else
        i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "regex",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty())) : i.kind === "trim" ? t.data = t.data.trim() : i.kind === "includes" ? t.data.includes(i.value, i.position) || (o = this._getOrReturnCtx(t, o), ke(o, {
          code: ge.invalid_string,
          validation: { includes: i.value, position: i.position },
          message: i.message
        }), r.dirty()) : i.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : i.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : i.kind === "startsWith" ? t.data.startsWith(i.value) || (o = this._getOrReturnCtx(t, o), ke(o, {
          code: ge.invalid_string,
          validation: { startsWith: i.value },
          message: i.message
        }), r.dirty()) : i.kind === "endsWith" ? t.data.endsWith(i.value) || (o = this._getOrReturnCtx(t, o), ke(o, {
          code: ge.invalid_string,
          validation: { endsWith: i.value },
          message: i.message
        }), r.dirty()) : i.kind === "datetime" ? Hw(i).test(t.data) || (o = this._getOrReturnCtx(t, o), ke(o, {
          code: ge.invalid_string,
          validation: "datetime",
          message: i.message
        }), r.dirty()) : i.kind === "ip" ? Uw(t.data, i.version) || (o = this._getOrReturnCtx(t, o), ke(o, {
          validation: "ip",
          code: ge.invalid_string,
          message: i.message
        }), r.dirty()) : et.assertNever(i);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((o) => t.test(o), {
      validation: n,
      code: ge.invalid_string,
      ...Ne.errToObj(r)
    });
  }
  _addCheck(t) {
    return new An({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Ne.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Ne.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Ne.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Ne.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Ne.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Ne.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Ne.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Ne.errToObj(t) });
  }
  datetime(t) {
    var n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      ...Ne.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Ne.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...Ne.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Ne.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Ne.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Ne.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Ne.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Ne.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, Ne.errToObj(t));
  }
  trim() {
    return new An({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new An({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new An({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
An.create = (e) => {
  var t;
  return new An({
    checks: [],
    typeName: je.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...qe(e)
  });
};
function Yw(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, o = n > r ? n : r, i = parseInt(e.toFixed(o).replace(".", "")), s = parseInt(t.toFixed(o).replace(".", ""));
  return i % s / Math.pow(10, o);
}
class Mr extends Ge {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== Oe.number) {
      const i = this._getOrReturnCtx(t);
      return ke(i, {
        code: ge.invalid_type,
        expected: Oe.number,
        received: i.parsedType
      }), ze;
    }
    let r;
    const o = new Yt();
    for (const i of this._def.checks)
      i.kind === "int" ? et.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), o.dirty()) : i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), o.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), o.dirty()) : i.kind === "multipleOf" ? Yw(t.data, i.value) !== 0 && (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), o.dirty()) : i.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.not_finite,
        message: i.message
      }), o.dirty()) : et.assertNever(i);
    return { status: o.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ne.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ne.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ne.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ne.toString(n));
  }
  setLimit(t, n, r, o) {
    return new Mr({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ne.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Mr({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Ne.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ne.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ne.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ne.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ne.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ne.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Ne.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ne.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ne.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && et.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
Mr.create = (e) => new Mr({
  checks: [],
  typeName: je.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...qe(e)
});
class Er extends Ge {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== Oe.bigint) {
      const i = this._getOrReturnCtx(t);
      return ke(i, {
        code: ge.invalid_type,
        expected: Oe.bigint,
        received: i.parsedType
      }), ze;
    }
    let r;
    const o = new Yt();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? t.data < i.value : t.data <= i.value) && (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), o.dirty()) : i.kind === "max" ? (i.inclusive ? t.data > i.value : t.data >= i.value) && (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), o.dirty()) : i.kind === "multipleOf" ? t.data % i.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), ke(r, {
        code: ge.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), o.dirty()) : et.assertNever(i);
    return { status: o.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ne.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ne.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ne.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ne.toString(n));
  }
  setLimit(t, n, r, o) {
    return new Er({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ne.toString(o)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Er({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ne.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ne.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ne.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ne.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ne.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Er.create = (e) => {
  var t;
  return new Er({
    checks: [],
    typeName: je.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...qe(e)
  });
};
class La extends Ge {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== Oe.boolean) {
      const r = this._getOrReturnCtx(t);
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.boolean,
        received: r.parsedType
      }), ze;
    }
    return nn(t.data);
  }
}
La.create = (e) => new La({
  typeName: je.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...qe(e)
});
class uo extends Ge {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== Oe.date) {
      const i = this._getOrReturnCtx(t);
      return ke(i, {
        code: ge.invalid_type,
        expected: Oe.date,
        received: i.parsedType
      }), ze;
    }
    if (isNaN(t.data.getTime())) {
      const i = this._getOrReturnCtx(t);
      return ke(i, {
        code: ge.invalid_date
      }), ze;
    }
    const r = new Yt();
    let o;
    for (const i of this._def.checks)
      i.kind === "min" ? t.data.getTime() < i.value && (o = this._getOrReturnCtx(t, o), ke(o, {
        code: ge.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), r.dirty()) : i.kind === "max" ? t.data.getTime() > i.value && (o = this._getOrReturnCtx(t, o), ke(o, {
        code: ge.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), r.dirty()) : et.assertNever(i);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new uo({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Ne.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Ne.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
uo.create = (e) => new uo({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: je.ZodDate,
  ...qe(e)
});
class Zs extends Ge {
  _parse(t) {
    if (this._getType(t) !== Oe.symbol) {
      const r = this._getOrReturnCtx(t);
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.symbol,
        received: r.parsedType
      }), ze;
    }
    return nn(t.data);
  }
}
Zs.create = (e) => new Zs({
  typeName: je.ZodSymbol,
  ...qe(e)
});
class Ba extends Ge {
  _parse(t) {
    if (this._getType(t) !== Oe.undefined) {
      const r = this._getOrReturnCtx(t);
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.undefined,
        received: r.parsedType
      }), ze;
    }
    return nn(t.data);
  }
}
Ba.create = (e) => new Ba({
  typeName: je.ZodUndefined,
  ...qe(e)
});
class za extends Ge {
  _parse(t) {
    if (this._getType(t) !== Oe.null) {
      const r = this._getOrReturnCtx(t);
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.null,
        received: r.parsedType
      }), ze;
    }
    return nn(t.data);
  }
}
za.create = (e) => new za({
  typeName: je.ZodNull,
  ...qe(e)
});
class ei extends Ge {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return nn(t.data);
  }
}
ei.create = (e) => new ei({
  typeName: je.ZodAny,
  ...qe(e)
});
class ao extends Ge {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return nn(t.data);
  }
}
ao.create = (e) => new ao({
  typeName: je.ZodUnknown,
  ...qe(e)
});
class gr extends Ge {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return ke(n, {
      code: ge.invalid_type,
      expected: Oe.never,
      received: n.parsedType
    }), ze;
  }
}
gr.create = (e) => new gr({
  typeName: je.ZodNever,
  ...qe(e)
});
class Qs extends Ge {
  _parse(t) {
    if (this._getType(t) !== Oe.undefined) {
      const r = this._getOrReturnCtx(t);
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.void,
        received: r.parsedType
      }), ze;
    }
    return nn(t.data);
  }
}
Qs.create = (e) => new Qs({
  typeName: je.ZodVoid,
  ...qe(e)
});
class Fn extends Ge {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), o = this._def;
    if (n.parsedType !== Oe.array)
      return ke(n, {
        code: ge.invalid_type,
        expected: Oe.array,
        received: n.parsedType
      }), ze;
    if (o.exactLength !== null) {
      const s = n.data.length > o.exactLength.value, l = n.data.length < o.exactLength.value;
      (s || l) && (ke(n, {
        code: s ? ge.too_big : ge.too_small,
        minimum: l ? o.exactLength.value : void 0,
        maximum: s ? o.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: o.exactLength.message
      }), r.dirty());
    }
    if (o.minLength !== null && n.data.length < o.minLength.value && (ke(n, {
      code: ge.too_small,
      minimum: o.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.minLength.message
    }), r.dirty()), o.maxLength !== null && n.data.length > o.maxLength.value && (ke(n, {
      code: ge.too_big,
      maximum: o.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: o.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((s, l) => o.type._parseAsync(new Xn(n, s, n.path, l)))).then((s) => Yt.mergeArray(r, s));
    const i = [...n.data].map((s, l) => o.type._parseSync(new Xn(n, s, n.path, l)));
    return Yt.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new Fn({
      ...this._def,
      minLength: { value: t, message: Ne.toString(n) }
    });
  }
  max(t, n) {
    return new Fn({
      ...this._def,
      maxLength: { value: t, message: Ne.toString(n) }
    });
  }
  length(t, n) {
    return new Fn({
      ...this._def,
      exactLength: { value: t, message: Ne.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Fn.create = (e, t) => new Fn({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: je.ZodArray,
  ...qe(t)
});
function jo(e) {
  if (e instanceof wt) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = hr.create(jo(r));
    }
    return new wt({
      ...e._def,
      shape: () => t
    });
  } else
    return e instanceof Fn ? new Fn({
      ...e._def,
      type: jo(e.element)
    }) : e instanceof hr ? hr.create(jo(e.unwrap())) : e instanceof po ? po.create(jo(e.unwrap())) : e instanceof er ? er.create(e.items.map((t) => jo(t))) : e;
}
class wt extends Ge {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = et.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== Oe.object) {
      const c = this._getOrReturnCtx(t);
      return ke(c, {
        code: ge.invalid_type,
        expected: Oe.object,
        received: c.parsedType
      }), ze;
    }
    const { status: r, ctx: o } = this._processInputParams(t), { shape: i, keys: s } = this._getCached(), l = [];
    if (!(this._def.catchall instanceof gr && this._def.unknownKeys === "strip"))
      for (const c in o.data)
        s.includes(c) || l.push(c);
    const u = [];
    for (const c of s) {
      const d = i[c], m = o.data[c];
      u.push({
        key: { status: "valid", value: c },
        value: d._parse(new Xn(o, m, o.path, c)),
        alwaysSet: c in o.data
      });
    }
    if (this._def.catchall instanceof gr) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const d of l)
          u.push({
            key: { status: "valid", value: d },
            value: { status: "valid", value: o.data[d] }
          });
      else if (c === "strict")
        l.length > 0 && (ke(o, {
          code: ge.unrecognized_keys,
          keys: l
        }), r.dirty());
      else if (c !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const d of l) {
        const m = o.data[d];
        u.push({
          key: { status: "valid", value: d },
          value: c._parse(
            new Xn(o, m, o.path, d)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: d in o.data
        });
      }
    }
    return o.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const d of u) {
        const m = await d.key;
        c.push({
          key: m,
          value: await d.value,
          alwaysSet: d.alwaysSet
        });
      }
      return c;
    }).then((c) => Yt.mergeObjectSync(r, c)) : Yt.mergeObjectSync(r, u);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Ne.errToObj, new wt({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var o, i, s, l;
          const u = (s = (i = (o = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(o, n, r).message) !== null && s !== void 0 ? s : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (l = Ne.errToObj(t).message) !== null && l !== void 0 ? l : u
          } : {
            message: u
          };
        }
      } : {}
    });
  }
  strip() {
    return new wt({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new wt({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new wt({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new wt({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: je.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new wt({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return et.objectKeys(t).forEach((r) => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new wt({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return et.objectKeys(this.shape).forEach((r) => {
      t[r] || (n[r] = this.shape[r]);
    }), new wt({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return jo(this);
  }
  partial(t) {
    const n = {};
    return et.objectKeys(this.shape).forEach((r) => {
      const o = this.shape[r];
      t && !t[r] ? n[r] = o : n[r] = o.optional();
    }), new wt({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return et.objectKeys(this.shape).forEach((r) => {
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let i = this.shape[r];
        for (; i instanceof hr; )
          i = i._def.innerType;
        n[r] = i;
      }
    }), new wt({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return yh(et.objectKeys(this.shape));
  }
}
wt.create = (e, t) => new wt({
  shape: () => e,
  unknownKeys: "strip",
  catchall: gr.create(),
  typeName: je.ZodObject,
  ...qe(t)
});
wt.strictCreate = (e, t) => new wt({
  shape: () => e,
  unknownKeys: "strict",
  catchall: gr.create(),
  typeName: je.ZodObject,
  ...qe(t)
});
wt.lazycreate = (e, t) => new wt({
  shape: e,
  unknownKeys: "strip",
  catchall: gr.create(),
  typeName: je.ZodObject,
  ...qe(t)
});
class Wa extends Ge {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function o(i) {
      for (const l of i)
        if (l.result.status === "valid")
          return l.result;
      for (const l of i)
        if (l.result.status === "dirty")
          return n.common.issues.push(...l.ctx.common.issues), l.result;
      const s = i.map((l) => new Nn(l.ctx.common.issues));
      return ke(n, {
        code: ge.invalid_union,
        unionErrors: s
      }), ze;
    }
    if (n.common.async)
      return Promise.all(r.map(async (i) => {
        const s = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: n.data,
            path: n.path,
            parent: s
          }),
          ctx: s
        };
      })).then(o);
    {
      let i;
      const s = [];
      for (const u of r) {
        const c = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, d = u._parseSync({
          data: n.data,
          path: n.path,
          parent: c
        });
        if (d.status === "valid")
          return d;
        d.status === "dirty" && !i && (i = { result: d, ctx: c }), c.common.issues.length && s.push(c.common.issues);
      }
      if (i)
        return n.common.issues.push(...i.ctx.common.issues), i.result;
      const l = s.map((u) => new Nn(u));
      return ke(n, {
        code: ge.invalid_union,
        unionErrors: l
      }), ze;
    }
  }
  get options() {
    return this._def.options;
  }
}
Wa.create = (e, t) => new Wa({
  options: e,
  typeName: je.ZodUnion,
  ...qe(t)
});
const Us = (e) => e instanceof Ua ? Us(e.schema) : e instanceof jn ? Us(e.innerType()) : e instanceof Ya ? [e.value] : e instanceof Ir ? e.options : e instanceof Ga ? Object.keys(e.enum) : e instanceof Ka ? Us(e._def.innerType) : e instanceof Ba ? [void 0] : e instanceof za ? [null] : null;
class Fl extends Ge {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Oe.object)
      return ke(n, {
        code: ge.invalid_type,
        expected: Oe.object,
        received: n.parsedType
      }), ze;
    const r = this.discriminator, o = n.data[r], i = this.optionsMap.get(o);
    return i ? n.common.async ? i._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : i._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (ke(n, {
      code: ge.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), ze);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const o = /* @__PURE__ */ new Map();
    for (const i of n) {
      const s = Us(i.shape[t]);
      if (!s)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const l of s) {
        if (o.has(l))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(l)}`);
        o.set(l, i);
      }
    }
    return new Fl({
      typeName: je.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: o,
      ...qe(r)
    });
  }
}
function eu(e, t) {
  const n = Dr(e), r = Dr(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === Oe.object && r === Oe.object) {
    const o = et.objectKeys(t), i = et.objectKeys(e).filter((l) => o.indexOf(l) !== -1), s = { ...e, ...t };
    for (const l of i) {
      const u = eu(e[l], t[l]);
      if (!u.valid)
        return { valid: !1 };
      s[l] = u.data;
    }
    return { valid: !0, data: s };
  } else if (n === Oe.array && r === Oe.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const o = [];
    for (let i = 0; i < e.length; i++) {
      const s = e[i], l = t[i], u = eu(s, l);
      if (!u.valid)
        return { valid: !1 };
      o.push(u.data);
    }
    return { valid: !0, data: o };
  } else
    return n === Oe.date && r === Oe.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class qa extends Ge {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = (i, s) => {
      if (Jc(i) || Jc(s))
        return ze;
      const l = eu(i.value, s.value);
      return l.valid ? ((Xc(i) || Xc(s)) && n.dirty(), { status: n.value, value: l.data }) : (ke(r, {
        code: ge.invalid_intersection_types
      }), ze);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([i, s]) => o(i, s)) : o(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
qa.create = (e, t, n) => new qa({
  left: e,
  right: t,
  typeName: je.ZodIntersection,
  ...qe(n)
});
class er extends Ge {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Oe.array)
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.array,
        received: r.parsedType
      }), ze;
    if (r.data.length < this._def.items.length)
      return ke(r, {
        code: ge.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ze;
    !this._def.rest && r.data.length > this._def.items.length && (ke(r, {
      code: ge.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const i = [...r.data].map((s, l) => {
      const u = this._def.items[l] || this._def.rest;
      return u ? u._parse(new Xn(r, s, r.path, l)) : null;
    }).filter((s) => !!s);
    return r.common.async ? Promise.all(i).then((s) => Yt.mergeArray(n, s)) : Yt.mergeArray(n, i);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new er({
      ...this._def,
      rest: t
    });
  }
}
er.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new er({
    items: e,
    typeName: je.ZodTuple,
    rest: null,
    ...qe(t)
  });
};
class Ha extends Ge {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Oe.object)
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.object,
        received: r.parsedType
      }), ze;
    const o = [], i = this._def.keyType, s = this._def.valueType;
    for (const l in r.data)
      o.push({
        key: i._parse(new Xn(r, l, r.path, l)),
        value: s._parse(new Xn(r, r.data[l], r.path, l))
      });
    return r.common.async ? Yt.mergeObjectAsync(n, o) : Yt.mergeObjectSync(n, o);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof Ge ? new Ha({
      keyType: t,
      valueType: n,
      typeName: je.ZodRecord,
      ...qe(r)
    }) : new Ha({
      keyType: An.create(),
      valueType: t,
      typeName: je.ZodRecord,
      ...qe(n)
    });
  }
}
class Js extends Ge {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Oe.map)
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.map,
        received: r.parsedType
      }), ze;
    const o = this._def.keyType, i = this._def.valueType, s = [...r.data.entries()].map(([l, u], c) => ({
      key: o._parse(new Xn(r, l, r.path, [c, "key"])),
      value: i._parse(new Xn(r, u, r.path, [c, "value"]))
    }));
    if (r.common.async) {
      const l = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of s) {
          const c = await u.key, d = await u.value;
          if (c.status === "aborted" || d.status === "aborted")
            return ze;
          (c.status === "dirty" || d.status === "dirty") && n.dirty(), l.set(c.value, d.value);
        }
        return { status: n.value, value: l };
      });
    } else {
      const l = /* @__PURE__ */ new Map();
      for (const u of s) {
        const c = u.key, d = u.value;
        if (c.status === "aborted" || d.status === "aborted")
          return ze;
        (c.status === "dirty" || d.status === "dirty") && n.dirty(), l.set(c.value, d.value);
      }
      return { status: n.value, value: l };
    }
  }
}
Js.create = (e, t, n) => new Js({
  valueType: t,
  keyType: e,
  typeName: je.ZodMap,
  ...qe(n)
});
class fo extends Ge {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== Oe.set)
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.set,
        received: r.parsedType
      }), ze;
    const o = this._def;
    o.minSize !== null && r.data.size < o.minSize.value && (ke(r, {
      code: ge.too_small,
      minimum: o.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.minSize.message
    }), n.dirty()), o.maxSize !== null && r.data.size > o.maxSize.value && (ke(r, {
      code: ge.too_big,
      maximum: o.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: o.maxSize.message
    }), n.dirty());
    const i = this._def.valueType;
    function s(u) {
      const c = /* @__PURE__ */ new Set();
      for (const d of u) {
        if (d.status === "aborted")
          return ze;
        d.status === "dirty" && n.dirty(), c.add(d.value);
      }
      return { status: n.value, value: c };
    }
    const l = [...r.data.values()].map((u, c) => i._parse(new Xn(r, u, r.path, c)));
    return r.common.async ? Promise.all(l).then((u) => s(u)) : s(l);
  }
  min(t, n) {
    return new fo({
      ...this._def,
      minSize: { value: t, message: Ne.toString(n) }
    });
  }
  max(t, n) {
    return new fo({
      ...this._def,
      maxSize: { value: t, message: Ne.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
fo.create = (e, t) => new fo({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: je.ZodSet,
  ...qe(t)
});
class Ho extends Ge {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Oe.function)
      return ke(n, {
        code: ge.invalid_type,
        expected: Oe.function,
        received: n.parsedType
      }), ze;
    function r(l, u) {
      return Gs({
        data: l,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Ys(),
          Va
        ].filter((c) => !!c),
        issueData: {
          code: ge.invalid_arguments,
          argumentsError: u
        }
      });
    }
    function o(l, u) {
      return Gs({
        data: l,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Ys(),
          Va
        ].filter((c) => !!c),
        issueData: {
          code: ge.invalid_return_type,
          returnTypeError: u
        }
      });
    }
    const i = { errorMap: n.common.contextualErrorMap }, s = n.data;
    if (this._def.returns instanceof ti) {
      const l = this;
      return nn(async function(...u) {
        const c = new Nn([]), d = await l._def.args.parseAsync(u, i).catch((p) => {
          throw c.addIssue(r(u, p)), c;
        }), m = await Reflect.apply(s, this, d);
        return await l._def.returns._def.type.parseAsync(m, i).catch((p) => {
          throw c.addIssue(o(m, p)), c;
        });
      });
    } else {
      const l = this;
      return nn(function(...u) {
        const c = l._def.args.safeParse(u, i);
        if (!c.success)
          throw new Nn([r(u, c.error)]);
        const d = Reflect.apply(s, this, c.data), m = l._def.returns.safeParse(d, i);
        if (!m.success)
          throw new Nn([o(d, m.error)]);
        return m.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Ho({
      ...this._def,
      args: er.create(t).rest(ao.create())
    });
  }
  returns(t) {
    return new Ho({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new Ho({
      args: t || er.create([]).rest(ao.create()),
      returns: n || ao.create(),
      typeName: je.ZodFunction,
      ...qe(r)
    });
  }
}
class Ua extends Ge {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
Ua.create = (e, t) => new Ua({
  getter: e,
  typeName: je.ZodLazy,
  ...qe(t)
});
class Ya extends Ge {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return ke(n, {
        received: n.data,
        code: ge.invalid_literal,
        expected: this._def.value
      }), ze;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Ya.create = (e, t) => new Ya({
  value: e,
  typeName: je.ZodLiteral,
  ...qe(t)
});
function yh(e, t) {
  return new Ir({
    values: e,
    typeName: je.ZodEnum,
    ...qe(t)
  });
}
class Ir extends Ge {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return ke(n, {
        expected: et.joinValues(r),
        received: n.parsedType,
        code: ge.invalid_type
      }), ze;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return ke(n, {
        received: n.data,
        code: ge.invalid_enum_value,
        options: r
      }), ze;
    }
    return nn(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t) {
    return Ir.create(t);
  }
  exclude(t) {
    return Ir.create(this.options.filter((n) => !t.includes(n)));
  }
}
Ir.create = yh;
class Ga extends Ge {
  _parse(t) {
    const n = et.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== Oe.string && r.parsedType !== Oe.number) {
      const o = et.objectValues(n);
      return ke(r, {
        expected: et.joinValues(o),
        received: r.parsedType,
        code: ge.invalid_type
      }), ze;
    }
    if (n.indexOf(t.data) === -1) {
      const o = et.objectValues(n);
      return ke(r, {
        received: r.data,
        code: ge.invalid_enum_value,
        options: o
      }), ze;
    }
    return nn(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ga.create = (e, t) => new Ga({
  values: e,
  typeName: je.ZodNativeEnum,
  ...qe(t)
});
class ti extends Ge {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== Oe.promise && n.common.async === !1)
      return ke(n, {
        code: ge.invalid_type,
        expected: Oe.promise,
        received: n.parsedType
      }), ze;
    const r = n.parsedType === Oe.promise ? n.data : Promise.resolve(n.data);
    return nn(r.then((o) => this._def.type.parseAsync(o, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
ti.create = (e, t) => new ti({
  type: e,
  typeName: je.ZodPromise,
  ...qe(t)
});
class jn extends Ge {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === je.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), o = this._def.effect || null, i = {
      addIssue: (s) => {
        ke(r, s), s.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), o.type === "preprocess") {
      const s = o.transform(r.data, i);
      return r.common.issues.length ? {
        status: "dirty",
        value: r.data
      } : r.common.async ? Promise.resolve(s).then((l) => this._def.schema._parseAsync({
        data: l,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: s,
        path: r.path,
        parent: r
      });
    }
    if (o.type === "refinement") {
      const s = (l) => {
        const u = o.refinement(l, i);
        if (r.common.async)
          return Promise.resolve(u);
        if (u instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return l;
      };
      if (r.common.async === !1) {
        const l = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return l.status === "aborted" ? ze : (l.status === "dirty" && n.dirty(), s(l.value), { status: n.value, value: l.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((l) => l.status === "aborted" ? ze : (l.status === "dirty" && n.dirty(), s(l.value).then(() => ({ status: n.value, value: l.value }))));
    }
    if (o.type === "transform")
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!ja(s))
          return s;
        const l = o.transform(s.value, i);
        if (l instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: l };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => ja(s) ? Promise.resolve(o.transform(s.value, i)).then((l) => ({ status: n.value, value: l })) : s);
    et.assertNever(o);
  }
}
jn.create = (e, t, n) => new jn({
  schema: e,
  typeName: je.ZodEffects,
  effect: t,
  ...qe(n)
});
jn.createWithPreprocess = (e, t, n) => new jn({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: je.ZodEffects,
  ...qe(n)
});
class hr extends Ge {
  _parse(t) {
    return this._getType(t) === Oe.undefined ? nn(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
hr.create = (e, t) => new hr({
  innerType: e,
  typeName: je.ZodOptional,
  ...qe(t)
});
class po extends Ge {
  _parse(t) {
    return this._getType(t) === Oe.null ? nn(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
po.create = (e, t) => new po({
  innerType: e,
  typeName: je.ZodNullable,
  ...qe(t)
});
class Ka extends Ge {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === Oe.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Ka.create = (e, t) => new Ka({
  innerType: e,
  typeName: je.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...qe(t)
});
class Xs extends Ge {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, o = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Ks(o) ? o.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Nn(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: o.status === "valid" ? o.value : this._def.catchValue({
        get error() {
          return new Nn(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Xs.create = (e, t) => new Xs({
  innerType: e,
  typeName: je.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...qe(t)
});
class el extends Ge {
  _parse(t) {
    if (this._getType(t) !== Oe.nan) {
      const r = this._getOrReturnCtx(t);
      return ke(r, {
        code: ge.invalid_type,
        expected: Oe.nan,
        received: r.parsedType
      }), ze;
    }
    return { status: "valid", value: t.data };
  }
}
el.create = (e) => new el({
  typeName: je.ZodNaN,
  ...qe(e)
});
const Gw = Symbol("zod_brand");
class bh extends Ge {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class fs extends Ge {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return i.status === "aborted" ? ze : i.status === "dirty" ? (n.dirty(), gh(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const o = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return o.status === "aborted" ? ze : o.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: o.value
      }) : this._def.out._parseSync({
        data: o.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new fs({
      in: t,
      out: n,
      typeName: je.ZodPipeline
    });
  }
}
class tl extends Ge {
  _parse(t) {
    const n = this._def.innerType._parse(t);
    return ja(n) && (n.value = Object.freeze(n.value)), n;
  }
}
tl.create = (e, t) => new tl({
  innerType: e,
  typeName: je.ZodReadonly,
  ...qe(t)
});
const vh = (e, t = {}, n) => e ? ei.create().superRefine((r, o) => {
  var i, s;
  if (!e(r)) {
    const l = typeof t == "function" ? t(r) : typeof t == "string" ? { message: t } : t, u = (s = (i = l.fatal) !== null && i !== void 0 ? i : n) !== null && s !== void 0 ? s : !0, c = typeof l == "string" ? { message: l } : l;
    o.addIssue({ code: "custom", ...c, fatal: u });
  }
}) : ei.create(), Kw = {
  object: wt.lazycreate
};
var je;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(je || (je = {}));
const Zw = (e, t = {
  message: `Input not instance of ${e.name}`
}) => vh((n) => n instanceof e, t), Ch = An.create, wh = Mr.create, Qw = el.create, Jw = Er.create, xh = La.create, Xw = uo.create, ex = Zs.create, tx = Ba.create, nx = za.create, rx = ei.create, ox = ao.create, ix = gr.create, ax = Qs.create, sx = Fn.create, Sh = wt.create, lx = wt.strictCreate, cx = Wa.create, ux = Fl.create, dx = qa.create, fx = er.create, px = Ha.create, mx = Js.create, hx = fo.create, gx = Ho.create, yx = Ua.create, bx = Ya.create, vx = Ir.create, Cx = Ga.create, wx = ti.create, af = jn.create, xx = hr.create, Sx = po.create, Tx = jn.createWithPreprocess, _x = fs.create, Dx = () => Ch().optional(), Px = () => wh().optional(), Ox = () => xh().optional(), kx = {
  string: (e) => An.create({ ...e, coerce: !0 }),
  number: (e) => Mr.create({ ...e, coerce: !0 }),
  boolean: (e) => La.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Er.create({ ...e, coerce: !0 }),
  date: (e) => uo.create({ ...e, coerce: !0 })
}, Mx = ze;
var oe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Va,
  setErrorMap: $w,
  getErrorMap: Ys,
  makeIssue: Gs,
  EMPTY_PATH: Nw,
  addIssueToContext: ke,
  ParseStatus: Yt,
  INVALID: ze,
  DIRTY: gh,
  OK: nn,
  isAborted: Jc,
  isDirty: Xc,
  isValid: ja,
  isAsync: Ks,
  get util() {
    return et;
  },
  get objectUtil() {
    return Qc;
  },
  ZodParsedType: Oe,
  getParsedType: Dr,
  ZodType: Ge,
  ZodString: An,
  ZodNumber: Mr,
  ZodBigInt: Er,
  ZodBoolean: La,
  ZodDate: uo,
  ZodSymbol: Zs,
  ZodUndefined: Ba,
  ZodNull: za,
  ZodAny: ei,
  ZodUnknown: ao,
  ZodNever: gr,
  ZodVoid: Qs,
  ZodArray: Fn,
  ZodObject: wt,
  ZodUnion: Wa,
  ZodDiscriminatedUnion: Fl,
  ZodIntersection: qa,
  ZodTuple: er,
  ZodRecord: Ha,
  ZodMap: Js,
  ZodSet: fo,
  ZodFunction: Ho,
  ZodLazy: Ua,
  ZodLiteral: Ya,
  ZodEnum: Ir,
  ZodNativeEnum: Ga,
  ZodPromise: ti,
  ZodEffects: jn,
  ZodTransformer: jn,
  ZodOptional: hr,
  ZodNullable: po,
  ZodDefault: Ka,
  ZodCatch: Xs,
  ZodNaN: el,
  BRAND: Gw,
  ZodBranded: bh,
  ZodPipeline: fs,
  ZodReadonly: tl,
  custom: vh,
  Schema: Ge,
  ZodSchema: Ge,
  late: Kw,
  get ZodFirstPartyTypeKind() {
    return je;
  },
  coerce: kx,
  any: rx,
  array: sx,
  bigint: Jw,
  boolean: xh,
  date: Xw,
  discriminatedUnion: ux,
  effect: af,
  enum: vx,
  function: gx,
  instanceof: Zw,
  intersection: dx,
  lazy: yx,
  literal: bx,
  map: mx,
  nan: Qw,
  nativeEnum: Cx,
  never: ix,
  null: nx,
  nullable: Sx,
  number: wh,
  object: Sh,
  oboolean: Ox,
  onumber: Px,
  optional: xx,
  ostring: Dx,
  pipeline: _x,
  preprocess: Tx,
  promise: wx,
  record: px,
  set: hx,
  strictObject: lx,
  string: Ch,
  symbol: ex,
  transformer: af,
  tuple: fx,
  undefined: tx,
  union: cx,
  unknown: ox,
  void: ax,
  NEVER: Mx,
  ZodIssueCode: ge,
  quotelessJson: Aw,
  ZodError: Nn
});
const Ex = oe.object({
  panelCost: oe.number(),
  // default 6500
  permittingCost: oe.number(),
  // default 50
  trenchingCostPerFoot: oe.number(),
  // default 100
  concreteCostPerSqft: oe.number(),
  // default 6
  warrantyCostPerCharger: oe.object({
    // charger.current
    AC: oe.number(),
    // default 500 => level 1 and level 2 => current = "AC"
    DC: oe.number()
    //default 800
  }),
  maintenanceCostPerCharger: oe.number(),
  // default 400
  networkFeesPerCharger: oe.number(),
  // default 280
  insuranceCostPerCharger: oe.number(),
  // default 600
  chargerInstallationCost: oe.object({
    // charger.charger_type
    level_1: oe.number(),
    // default 500
    level_2: oe.number(),
    // default 3000
    dc_fast_charging: oe.number()
    // default 20000
  })
}), Ix = oe.object({
  // Step 2
  projectScenario: oe.enum([
    "knownChargersNeeded",
    "knownSpotsAvailable",
    "knownVehiclesNeedCharging"
  ]),
  // "Ports needed today" & "Ports today"
  numberOfPorts: oe.number(),
  // "Final ports in lifespan"
  numberOfProjectedPorts: oe.number(),
  // "number of chargers needed according to how many ports needed"
  numberOfProjectedChargers: oe.number().optional(),
  // "Multiple vehicles will share charger ports"
  sharingChargingSpots: oe.boolean(),
  // "Chargers will also be used for company vehicles"
  companyVehicleCharging: oe.boolean(),
  // "Total parking spots"
  totalSpots: oe.number(),
  // "Which % of these spots would you like to utilize for charging?"
  percentOfSpotsToCharge: oe.number().min(0).max(100),
  // 0 to 100
  // "Vehicles"
  numberOfVehicles: oe.number()
}), Rx = oe.object({
  /* Step 5 */
  // "Approximate Distance To Panel"
  trenchingLength: oe.number(),
  // "Ft2 of concrete slab"
  concreteNeededSqft: oe.number(),
  needNewPanel: oe.nativeEnum(mh)
});
oe.object({
  uniqueId: oe.string(),
  name: oe.string(),
  charger: oe.custom(),
  needs: Ix,
  costs: Ex,
  site: Rx,
  calculated: oe.custom().optional(),
  finance: oe.custom(),
  financeResult: oe.custom().optional()
});
const Ax = oe.object({
  costType: oe.nativeEnum(Pv),
  markup: oe.coerce.number().nonnegative().lte(100),
  milesToWork: oe.coerce.number(),
  evEfficiency: oe.coerce.number(),
  electricityCostPerKWh: oe.coerce.number()
}), $x = oe.object({
  zipcode: oe.string().min(3),
  lifespan: oe.number()
});
oe.object({
  assumptions: Ax,
  project: $x
});
const Th = {
  name: "JDP",
  programName: "ZappyRide EV Deploy"
};
oe.object({
  project: oe.object({
    lifespanYears: oe.number()
  }),
  organization: oe.object({
    organizationType: oe.string(),
    isPublic: oe.boolean(),
    isTaxExempt: oe.boolean()
  }),
  site: oe.object({
    address: oe.object({
      postcode: oe.string(),
      powerSupplier: oe.object({
        name: oe.string()
      })
    })
  }),
  costs: oe.object({
    chargerInstallationCost: oe.number(),
    customDieselPrice: oe.number().nullable(),
    customGasolinePrice: oe.number().nullable()
    // electricityCost
  })
});
oe.object({
  id: oe.string(),
  start: oe.number().min(0).max(23),
  finish: oe.number().min(0).max(23),
  chargerId: oe.string(),
  charger: oe.custom().nullable(),
  access: oe.number(),
  chargingApproach: oe.string().optional()
}).refine(({ start: e, finish: t }) => t > e, { message: "Must be smaller", path: ["finish"] });
var _h = /* @__PURE__ */ ((e) => (e.EVDeploy = "EV_DEPLOY", e.EVFleets = "EV_FLEETS", e.ChargersCatalog = "CHARGERS_CATALOG", e.VehiclesCatalog = "VEHICLES_CATALOG", e.IncentivesDashbord = "INCENTIVES_DASHBOARD", e))(_h || {});
const Nx = oe.object({
  minLength: oe.number().positive(),
  maxLength: oe.number().positive(),
  numberRequired: oe.boolean(),
  specialCharRequired: oe.boolean(),
  uppercaseRequired: oe.boolean(),
  lowercaseRequired: oe.boolean()
}), Fx = oe.object({
  cognito: oe.custom(),
  passwordPolicy: Nx
}), Vx = oe.object({
  packages: oe.array(oe.nativeEnum(_h)),
  client: oe.object({
    name: oe.string(),
    programName: oe.string()
  }),
  defaultRoute: oe.string(),
  theme: oe.custom().optional(),
  relativeTime: oe.object({
    mode: oe.string(),
    lngs: oe.array(oe.string())
  }).optional(),
  settings: oe.object({
    abilities: oe.custom().optional(),
    staticValues: oe.custom().optional(),
    components: oe.custom().optional(),
    defaultValues: oe.custom().optional(),
    validations: oe.custom().optional(),
    auth: Fx.optional(),
    tokens: oe.object({
      common: oe.string(),
      json: oe.string().optional()
    }),
    analytics: oe.array(oe.custom()).optional()
  })
});
oe.intersection(
  oe.record(oe.string(), Vx.omit({ theme: !0 })),
  oe.object({
    theme: oe.custom()
  })
);
const Dh = (e) => `${e} kW`, jx = (e, t, n, r) => {
  if (t) {
    const o = Dh(t), i = n > 1 ? ` ${n} ${r}` : "";
    return `${e} - ${o}${i}`;
  }
  return e;
}, Lx = (e, t) => {
  const { charger_type: n, kw_dc: r, kw_ac: o, num_of_ports: i } = e, s = t("port", { count: i }), l = t(n), u = n === Pa.DCFC ? r : o;
  return Object.values(Pa).includes(n) ? jx(l, u, i, s.toLowerCase()) : e.label;
}, Bx = (e, t) => {
  const { num_of_ports: n } = e, o = {
    1: "singlePort",
    2: "dualPort"
  }[n] || "multiPort";
  return t(`${o}`);
}, zx = {
  $eq: (e, t) => e === t,
  $gt: (e, t) => {
    if (typeof e == "number" && typeof t == "number")
      return e > t;
  },
  $gte: (e, t) => {
    if (typeof e == "number" && typeof t == "number")
      return e >= t;
  },
  $lt: (e, t) => {
    if (typeof e == "number" && typeof t == "number")
      return e < t;
  },
  $lte: (e, t) => {
    if (typeof e == "number" && typeof t == "number")
      return e <= t;
  },
  $inc: (e, t) => {
    if (Array.isArray(t))
      return t.includes(typeof e == "string" ? e.toLowerCase() : e);
  },
  // Truthy operator. Indicates that the compared value is truthy. Only filtering if v2 is truthy as well.
  $tty: (e, t) => t ? !!e : !0
}, EY = ({ data: e, filters: t, mapper: n }) => Object.entries(t).every(([o, i]) => {
  const s = zx[n[o]];
  return i === "" || i === "all" || Array.isArray(i) && !i.length ? !0 : s(e[o], i);
}), Wx = (e, t) => {
  const [n, r] = t.split(":"), o = Number(r);
  return e.slice().sort((i, s) => {
    let l = At(i, n, ""), u = At(s, n, "");
    return typeof l == "string" && typeof u == "string" && (l = l.toLowerCase(), u = u.toLowerCase()), l > u ? o : l < u ? -o : 0;
  });
};
function qx(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
var Hx = qx;
const sf = /* @__PURE__ */ Mt(Hx);
function Ph(e, t = "") {
  return sf(e) ? Object.entries(e).reduce((n, [r, o]) => {
    const i = t ? `${t}_${r}` : r;
    if (sf(o)) {
      const s = Ph(o, i);
      return { ...n, ...s };
    } else
      return { ...n, [i]: o };
  }, {}) : {};
}
const Oh = ai([]), IY = ({ config: e, userId: t, companyName: n, children: r, testMode: o = !1 }) => {
  const i = Fm();
  it(() => {
    Eo.isInitialized || !t || !e || Eo.initialize(e, {
      testMode: o,
      gaOptions: {
        userId: t,
        debug: process.env.NODE_ENV !== "production"
      },
      ...n && {
        gtagOptions: {
          companyName: n
        }
      }
    });
  }, [n, e, o, t]), it(() => {
    if (!Eo.isInitialized)
      return;
    const l = i.pathname + i.search;
    Eo.send({ hitType: "pageview", page: l });
  }, [i]);
  const s = Qe((l, u) => {
    if (!Eo.isInitialized)
      return;
    let c = {};
    u && (c = Ph(u)), Eo.event(l, c);
  }, []);
  return h(Oh.Provider, { value: [s], children: r });
}, Ux = () => si(Oh);
function kh({ variant: e, ...t }) {
  return h(Be, { role: "alertdialog", display: "flex", justifyContent: "center", alignItems: "center", height: e === "fullscreen" ? "100vh" : "auto", ...t, children: h(Pl, { "aria-busy": !0 }) });
}
function Yx({ children: e }) {
  return h($m, { fallback: h(kh, { height: "100%" }), children: e });
}
var nl = { exports: {} };
nl.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 800, i = 16, s = 9007199254740991, l = "[object Arguments]", u = "[object Array]", c = "[object AsyncFunction]", d = "[object Boolean]", m = "[object Date]", f = "[object Error]", p = "[object Function]", b = "[object GeneratorFunction]", g = "[object Map]", S = "[object Number]", C = "[object Null]", w = "[object Object]", v = "[object Proxy]", x = "[object RegExp]", T = "[object Set]", E = "[object String]", k = "[object Undefined]", I = "[object WeakMap]", P = "[object ArrayBuffer]", F = "[object DataView]", A = "[object Float32Array]", B = "[object Float64Array]", W = "[object Int8Array]", M = "[object Int16Array]", _ = "[object Int32Array]", O = "[object Uint8Array]", R = "[object Uint8ClampedArray]", N = "[object Uint16Array]", L = "[object Uint32Array]", $ = /[\\^$.*+?()[\]{}|]/g, H = /^\[object .+?Constructor\]$/, G = /^(?:0|[1-9]\d*)$/, q = {};
  q[A] = q[B] = q[W] = q[M] = q[_] = q[O] = q[R] = q[N] = q[L] = !0, q[l] = q[u] = q[P] = q[d] = q[F] = q[m] = q[f] = q[p] = q[g] = q[S] = q[w] = q[x] = q[T] = q[E] = q[I] = !1;
  var Y = typeof ot == "object" && ot && ot.Object === Object && ot, Z = typeof self == "object" && self && self.Object === Object && self, ie = Y || Z || Function("return this")(), X = t && !t.nodeType && t, se = X && !0 && e && !e.nodeType && e, fe = se && se.exports === X, le = fe && Y.process, ce = function() {
    try {
      var y = se && se.require && se.require("util").types;
      return y || le && le.binding && le.binding("util");
    } catch {
    }
  }(), ee = ce && ce.isTypedArray;
  function ae(y, D, V) {
    switch (V.length) {
      case 0:
        return y.call(D);
      case 1:
        return y.call(D, V[0]);
      case 2:
        return y.call(D, V[0], V[1]);
      case 3:
        return y.call(D, V[0], V[1], V[2]);
    }
    return y.apply(D, V);
  }
  function _e(y, D) {
    for (var V = -1, re = Array(y); ++V < y; )
      re[V] = D(V);
    return re;
  }
  function ue(y) {
    return function(D) {
      return y(D);
    };
  }
  function me(y, D) {
    return y == null ? void 0 : y[D];
  }
  function De(y, D) {
    return function(V) {
      return y(D(V));
    };
  }
  var he = Array.prototype, Ce = Function.prototype, K = Object.prototype, ne = ie["__core-js_shared__"], pe = Ce.toString, Me = K.hasOwnProperty, de = function() {
    var y = /[^.]+$/.exec(ne && ne.keys && ne.keys.IE_PROTO || "");
    return y ? "Symbol(src)_1." + y : "";
  }(), ye = K.toString, Te = pe.call(Object), Re = RegExp(
    "^" + pe.call(Me).replace($, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = fe ? ie.Buffer : void 0, ht = ie.Symbol, gt = ie.Uint8Array, Qt = We ? We.allocUnsafe : void 0, Lt = De(Object.getPrototypeOf, Object), yt = Object.create, dn = K.propertyIsEnumerable, Dn = he.splice, bt = ht ? ht.toStringTag : void 0, $t = function() {
    try {
      var y = ir(Object, "defineProperty");
      return y({}, "", {}), y;
    } catch {
    }
  }(), Bt = We ? We.isBuffer : void 0, rn = Math.max, Pn = Date.now, fn = ir(ie, "Map"), Pt = ir(Object, "create"), Hr = function() {
    function y() {
    }
    return function(D) {
      if (!zt(D))
        return {};
      if (yt)
        return yt(D);
      y.prototype = D;
      var V = new y();
      return y.prototype = void 0, V;
    };
  }();
  function He(y) {
    var D = -1, V = y == null ? 0 : y.length;
    for (this.clear(); ++D < V; ) {
      var re = y[D];
      this.set(re[0], re[1]);
    }
  }
  function Ut() {
    this.__data__ = Pt ? Pt(null) : {}, this.size = 0;
  }
  function On(y) {
    var D = this.has(y) && delete this.__data__[y];
    return this.size -= D ? 1 : 0, D;
  }
  function on(y) {
    var D = this.__data__;
    if (Pt) {
      var V = D[y];
      return V === r ? void 0 : V;
    }
    return Me.call(D, y) ? D[y] : void 0;
  }
  function Po(y) {
    var D = this.__data__;
    return Pt ? D[y] !== void 0 : Me.call(D, y);
  }
  function Oo(y, D) {
    var V = this.__data__;
    return this.size += this.has(y) ? 0 : 1, V[y] = Pt && D === void 0 ? r : D, this;
  }
  He.prototype.clear = Ut, He.prototype.delete = On, He.prototype.get = on, He.prototype.has = Po, He.prototype.set = Oo;
  function lt(y) {
    var D = -1, V = y == null ? 0 : y.length;
    for (this.clear(); ++D < V; ) {
      var re = y[D];
      this.set(re[0], re[1]);
    }
  }
  function _i() {
    this.__data__ = [], this.size = 0;
  }
  function Di(y) {
    var D = this.__data__, V = kn(D, y);
    if (V < 0)
      return !1;
    var re = D.length - 1;
    return V == re ? D.pop() : Dn.call(D, V, 1), --this.size, !0;
  }
  function Pi(y) {
    var D = this.__data__, V = kn(D, y);
    return V < 0 ? void 0 : D[V][1];
  }
  function Oi(y) {
    return kn(this.__data__, y) > -1;
  }
  function ki(y, D) {
    var V = this.__data__, re = kn(V, y);
    return re < 0 ? (++this.size, V.push([y, D])) : V[re][1] = D, this;
  }
  lt.prototype.clear = _i, lt.prototype.delete = Di, lt.prototype.get = Pi, lt.prototype.has = Oi, lt.prototype.set = ki;
  function vt(y) {
    var D = -1, V = y == null ? 0 : y.length;
    for (this.clear(); ++D < V; ) {
      var re = y[D];
      this.set(re[0], re[1]);
    }
  }
  function Mi() {
    this.size = 0, this.__data__ = {
      hash: new He(),
      map: new (fn || lt)(),
      string: new He()
    };
  }
  function Ei(y) {
    var D = En(this, y).delete(y);
    return this.size -= D ? 1 : 0, D;
  }
  function Ii(y) {
    return En(this, y).get(y);
  }
  function Ri(y) {
    return En(this, y).has(y);
  }
  function Ai(y, D) {
    var V = En(this, y), re = V.size;
    return V.set(y, D), this.size += V.size == re ? 0 : 1, this;
  }
  vt.prototype.clear = Mi, vt.prototype.delete = Ei, vt.prototype.get = Ii, vt.prototype.has = Ri, vt.prototype.set = Ai;
  function It(y) {
    var D = this.__data__ = new lt(y);
    this.size = D.size;
  }
  function $i() {
    this.__data__ = new lt(), this.size = 0;
  }
  function Ni(y) {
    var D = this.__data__, V = D.delete(y);
    return this.size = D.size, V;
  }
  function Fi(y) {
    return this.__data__.get(y);
  }
  function Vi(y) {
    return this.__data__.has(y);
  }
  function ji(y, D) {
    var V = this.__data__;
    if (V instanceof lt) {
      var re = V.__data__;
      if (!fn || re.length < n - 1)
        return re.push([y, D]), this.size = ++V.size, this;
      V = this.__data__ = new vt(re);
    }
    return V.set(y, D), this.size = V.size, this;
  }
  It.prototype.clear = $i, It.prototype.delete = Ni, It.prototype.get = Fi, It.prototype.has = Vi, It.prototype.set = ji;
  function qn(y, D) {
    var V = sr(y), re = !V && Jt(y), be = !V && !re && lr(y), Pe = !V && !re && !be && Gn(y), Fe = V || re || be || Pe, we = Fe ? _e(y.length, String) : [], Ve = we.length;
    for (var at in y)
      (D || Me.call(y, at)) && !(Fe && // Safari 9 has enumerable `arguments.length` in strict mode.
      (at == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      be && (at == "offset" || at == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Pe && (at == "buffer" || at == "byteLength" || at == "byteOffset") || // Skip index properties.
      Kr(at, Ve))) && we.push(at);
    return we;
  }
  function rr(y, D, V) {
    (V !== void 0 && !yn(y[D], V) || V === void 0 && !(D in y)) && or(y, D, V);
  }
  function Li(y, D, V) {
    var re = y[D];
    (!(Me.call(y, D) && yn(re, V)) || V === void 0 && !(D in y)) && or(y, D, V);
  }
  function kn(y, D) {
    for (var V = y.length; V--; )
      if (yn(y[V][0], D))
        return V;
    return -1;
  }
  function or(y, D, V) {
    D == "__proto__" && $t ? $t(y, D, {
      configurable: !0,
      enumerable: !0,
      value: V,
      writable: !0
    }) : y[D] = V;
  }
  var Bi = Qi();
  function Mn(y) {
    return y == null ? y === void 0 ? k : C : bt && bt in Object(y) ? Ji(y) : ea(y);
  }
  function Cr(y) {
    return an(y) && Mn(y) == l;
  }
  function wr(y) {
    if (!zt(y) || Hn(y))
      return !1;
    var D = Yn(y) ? Re : H;
    return D.test(oa(y));
  }
  function zi(y) {
    return an(y) && Zr(y.length) && !!q[Mn(y)];
  }
  function Ur(y) {
    if (!zt(y))
      return In(y);
    var D = Sr(y), V = [];
    for (var re in y)
      re == "constructor" && (D || !Me.call(y, re)) || V.push(re);
    return V;
  }
  function Yr(y, D, V, re, be) {
    y !== D && Bi(D, function(Pe, Fe) {
      if (be || (be = new It()), zt(Pe))
        Wi(y, D, Fe, V, Yr, re, be);
      else {
        var we = re ? re(ar(y, Fe), Pe, Fe + "", y, D, be) : void 0;
        we === void 0 && (we = Pe), rr(y, Fe, we);
      }
    }, cr);
  }
  function Wi(y, D, V, re, be, Pe, Fe) {
    var we = ar(y, V), Ve = ar(D, V), at = Fe.get(Ve);
    if (at) {
      rr(y, V, at);
      return;
    }
    var tt = Pe ? Pe(we, Ve, V + "", y, D, Fe) : void 0, Xt = tt === void 0;
    if (Xt) {
      var bn = sr(Ve), Qr = !bn && lr(Ve), ua = !bn && !Qr && Gn(Ve);
      tt = Ve, bn || Qr || ua ? sr(we) ? tt = we : ia(we) ? tt = Gi(we) : Qr ? (Xt = !1, tt = Ui(Ve, !0)) : ua ? (Xt = !1, tt = Gr(Ve, !0)) : tt = [] : aa(Ve) || Jt(Ve) ? (tt = we, Jt(we) ? tt = sa(we) : (!zt(we) || Yn(we)) && (tt = ko(Ve))) : Xt = !1;
    }
    Xt && (Fe.set(Ve, tt), be(tt, Ve, re, Pe, Fe), Fe.delete(Ve)), rr(y, V, tt);
  }
  function qi(y, D) {
    return na(ta(y, D, j), y + "");
  }
  var Hi = $t ? function(y, D) {
    return $t(y, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ca(D),
      writable: !0
    });
  } : j;
  function Ui(y, D) {
    if (D)
      return y.slice();
    var V = y.length, re = Qt ? Qt(V) : new y.constructor(V);
    return y.copy(re), re;
  }
  function Yi(y) {
    var D = new y.constructor(y.byteLength);
    return new gt(D).set(new gt(y)), D;
  }
  function Gr(y, D) {
    var V = D ? Yi(y.buffer) : y.buffer;
    return new y.constructor(V, y.byteOffset, y.length);
  }
  function Gi(y, D) {
    var V = -1, re = y.length;
    for (D || (D = Array(re)); ++V < re; )
      D[V] = y[V];
    return D;
  }
  function Ki(y, D, V, re) {
    var be = !V;
    V || (V = {});
    for (var Pe = -1, Fe = D.length; ++Pe < Fe; ) {
      var we = D[Pe], Ve = re ? re(V[we], y[we], we, V, y) : void 0;
      Ve === void 0 && (Ve = y[we]), be ? or(V, we, Ve) : Li(V, we, Ve);
    }
    return V;
  }
  function Zi(y) {
    return qi(function(D, V) {
      var re = -1, be = V.length, Pe = be > 1 ? V[be - 1] : void 0, Fe = be > 2 ? V[2] : void 0;
      for (Pe = y.length > 3 && typeof Pe == "function" ? (be--, Pe) : void 0, Fe && Xi(V[0], V[1], Fe) && (Pe = be < 3 ? void 0 : Pe, be = 1), D = Object(D); ++re < be; ) {
        var we = V[re];
        we && y(D, we, re, Pe);
      }
      return D;
    });
  }
  function Qi(y) {
    return function(D, V, re) {
      for (var be = -1, Pe = Object(D), Fe = re(D), we = Fe.length; we--; ) {
        var Ve = Fe[y ? we : ++be];
        if (V(Pe[Ve], Ve, Pe) === !1)
          break;
      }
      return D;
    };
  }
  function En(y, D) {
    var V = y.__data__;
    return xr(D) ? V[typeof D == "string" ? "string" : "hash"] : V.map;
  }
  function ir(y, D) {
    var V = me(y, D);
    return wr(V) ? V : void 0;
  }
  function Ji(y) {
    var D = Me.call(y, bt), V = y[bt];
    try {
      y[bt] = void 0;
      var re = !0;
    } catch {
    }
    var be = ye.call(y);
    return re && (D ? y[bt] = V : delete y[bt]), be;
  }
  function ko(y) {
    return typeof y.constructor == "function" && !Sr(y) ? Hr(Lt(y)) : {};
  }
  function Kr(y, D) {
    var V = typeof y;
    return D = D ?? s, !!D && (V == "number" || V != "symbol" && G.test(y)) && y > -1 && y % 1 == 0 && y < D;
  }
  function Xi(y, D, V) {
    if (!zt(V))
      return !1;
    var re = typeof D;
    return (re == "number" ? Un(V) && Kr(D, V.length) : re == "string" && D in V) ? yn(V[D], y) : !1;
  }
  function xr(y) {
    var D = typeof y;
    return D == "string" || D == "number" || D == "symbol" || D == "boolean" ? y !== "__proto__" : y === null;
  }
  function Hn(y) {
    return !!de && de in y;
  }
  function Sr(y) {
    var D = y && y.constructor, V = typeof D == "function" && D.prototype || K;
    return y === V;
  }
  function In(y) {
    var D = [];
    if (y != null)
      for (var V in Object(y))
        D.push(V);
    return D;
  }
  function ea(y) {
    return ye.call(y);
  }
  function ta(y, D, V) {
    return D = rn(D === void 0 ? y.length - 1 : D, 0), function() {
      for (var re = arguments, be = -1, Pe = rn(re.length - D, 0), Fe = Array(Pe); ++be < Pe; )
        Fe[be] = re[D + be];
      be = -1;
      for (var we = Array(D + 1); ++be < D; )
        we[be] = re[be];
      return we[D] = V(Fe), ae(y, this, we);
    };
  }
  function ar(y, D) {
    if (!(D === "constructor" && typeof y[D] == "function") && D != "__proto__")
      return y[D];
  }
  var na = ra(Hi);
  function ra(y) {
    var D = 0, V = 0;
    return function() {
      var re = Pn(), be = i - (re - V);
      if (V = re, be > 0) {
        if (++D >= o)
          return arguments[0];
      } else
        D = 0;
      return y.apply(void 0, arguments);
    };
  }
  function oa(y) {
    if (y != null) {
      try {
        return pe.call(y);
      } catch {
      }
      try {
        return y + "";
      } catch {
      }
    }
    return "";
  }
  function yn(y, D) {
    return y === D || y !== y && D !== D;
  }
  var Jt = Cr(function() {
    return arguments;
  }()) ? Cr : function(y) {
    return an(y) && Me.call(y, "callee") && !dn.call(y, "callee");
  }, sr = Array.isArray;
  function Un(y) {
    return y != null && Zr(y.length) && !Yn(y);
  }
  function ia(y) {
    return an(y) && Un(y);
  }
  var lr = Bt || te;
  function Yn(y) {
    if (!zt(y))
      return !1;
    var D = Mn(y);
    return D == p || D == b || D == c || D == v;
  }
  function Zr(y) {
    return typeof y == "number" && y > -1 && y % 1 == 0 && y <= s;
  }
  function zt(y) {
    var D = typeof y;
    return y != null && (D == "object" || D == "function");
  }
  function an(y) {
    return y != null && typeof y == "object";
  }
  function aa(y) {
    if (!an(y) || Mn(y) != w)
      return !1;
    var D = Lt(y);
    if (D === null)
      return !0;
    var V = Me.call(D, "constructor") && D.constructor;
    return typeof V == "function" && V instanceof V && pe.call(V) == Te;
  }
  var Gn = ee ? ue(ee) : zi;
  function sa(y) {
    return Ki(y, cr(y));
  }
  function cr(y) {
    return Un(y) ? qn(y, !0) : Ur(y);
  }
  var la = Zi(function(y, D, V) {
    Yr(y, D, V);
  });
  function ca(y) {
    return function() {
      return y;
    };
  }
  function j(y) {
    return y;
  }
  function te() {
    return !1;
  }
  e.exports = la;
})(nl, nl.exports);
var Gx = nl.exports;
const dt = /* @__PURE__ */ Mt(Gx), Kx = (e) => new Ov(e), Mh = ai(void 0), Vu = ai(void 0), RY = Vu.Consumer;
function Zx(e) {
  return !e || !Object.keys(e).length ? [] : Object.entries(e).flatMap(([t, n]) => Object.entries(n).flatMap(([r, o]) => o != null && o.length ? o.map(({ fields: i, conditions: s }) => ({
    subject: t,
    action: r,
    fields: i,
    conditions: s
  })) : [
    {
      subject: t,
      action: r
    }
  ]));
}
const AY = ({ abilities: e = {}, children: t }) => {
  const n = Kx(Zx(e)), [r, o] = Xe({}), i = (b, g, S) => n.can(b, g, S), s = (b, g, S) => n.rulesFor(b, g).flatMap((C) => {
    const w = C.fields || [];
    return S ? C.matchesConditions(S) ? w : [] : w;
  }), l = (b, g, S, C) => {
    const w = n.rulesFor(b, g, S).flatMap((v) => v.matchesConditions(C));
    return w.length > 0 && w.every(Boolean);
  }, u = (b, g, S) => (C) => l(b, g, S, C), c = (b, g, S) => n.rulesFor(b, g).flatMap((C) => C.matchesField(S)).every(Boolean), d = (b, g) => (S) => c(b, g, S), m = (b, g, S = "") => {
    var C;
    return (C = At(r, [g, b], []).find(({ fields: w }) => w == null ? void 0 : w.includes(S))) == null ? void 0 : C.conditions;
  }, f = (b, g, S = "") => (C) => {
    o((w) => {
      var E;
      const v = At(w, [g, b], []), x = (E = v.splice(v.findIndex(({ fields: k }) => k == null ? void 0 : k.includes(S)), 1)) == null ? void 0 : E[0], T = x == null ? void 0 : x.conditions;
      return dt({}, w, {
        [g]: {
          [b]: [
            ...v,
            {
              fields: (x == null ? void 0 : x.fields) || [S],
              conditions: dt({}, T, C)
            }
          ]
        }
      });
    });
  }, p = (b, g, S = "") => [
    m(b, g, S),
    f(b, g, S)
  ];
  return h(Vu.Provider, { value: {
    isAllowed: i,
    getAllowedFields: s,
    matchCondition: l,
    matchField: c,
    getConditionsMatcher: u,
    getFieldsMatcher: d,
    setConditionsMatchers: o,
    conditionsMatchers: r,
    useConditionsByAbility: p
  }, children: h(Mh.Provider, { value: n, children: t }) });
}, fi = () => si(Vu), pi = kv(Mh.Consumer), lf = (e) => {
  var d;
  const { matchCondition: t, conditionsMatchers: n } = fi(), r = e.I || e.do || e.action || "", o = e.of || e.a || e.an || e.this || e.on || e.subject || "", i = e.field || "", s = At(n, [o, r], []), l = (d = s == null ? void 0 : s.find(({ fields: m }) => m == null ? void 0 : m.includes(i))) == null ? void 0 : d.conditions, u = dt({}, e.matcher, l);
  if (!r || !o)
    throw new Error("ConditionalCan requires an action, a subject");
  return t(r, o, i, u) && !e.not ? h(Dt, { children: e.children }) : null;
};
function Eh({ children: e, title: t, showExpandIcon: n = !0, ...r }) {
  return J(Qx, { ...r, children: [h(Bm, { expandIcon: n ? h(Mv, {}) : null, children: typeof t == "string" ? h(ve, { variant: "h2", children: t }) : t }), h(Ev, { children: e })] });
}
const Qx = Q(Lm)(({ theme: e }) => {
  var t, n;
  return {
    borderColor: (t = e.palette.shape) == null ? void 0 : t.border,
    ".MuiAccordionSummary-expandIconWrapper": {
      color: (n = e.palette.shape) == null ? void 0 : n.border
    }
  };
}), Jx = Q(Eh)(({ theme: e }) => {
  var t;
  return {
    "&.card-accordion": {
      "*": {
        WebkitFontSmoothing: "antialiased"
      },
      padding: e.spacing(5.5, 5.75),
      borderRadius: e.shape.borderRadius,
      borderColor: (t = e.palette.shape) == null ? void 0 : t.border,
      margin: 0,
      "&:has(+ .card-accordion)": {
        marginBottom: e.spacing(4)
      },
      "&:before": {
        display: "none"
      },
      ".MuiAccordionSummary-root": {
        minHeight: "unset",
        padding: 0
      },
      ".MuiAccordionSummary-content": {
        margin: 0
      },
      ".MuiAccordionDetails-root": {
        padding: 0,
        marginTop: e.spacing(4)
      }
    }
  };
});
function tu(e) {
  return h(Jx, { ...e, className: "card-accordion", variant: "outlined" });
}
const Xx = Q(Eh)(({ theme: e }) => {
  var t, n;
  return {
    "*": {
      WebkitFontSmoothing: "antialiased"
    },
    boxShadow: "none",
    borderTop: `1px solid ${(t = e.palette.shape) == null ? void 0 : t.border}`,
    borderRadius: 0,
    backgroundColor: "transparent",
    "&.Mui-expanded": {
      margin: 0
    },
    ".MuiAccordionSummary-root": {
      paddingLeft: 0
    },
    ".MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "unset",
      borderRadius: 0,
      borderBottom: `1px solid ${(n = e.palette.shape) == null ? void 0 : n.border}`
    },
    ".MuiAccordionSummary-content": {
      "&, &.Mui-expanded": {
        margin: e.spacing(4, 0)
      }
    },
    ".MuiAccordionSummary-expandIconWrapper": {
      color: e.palette.text.primary
    },
    ".MuiAccordionDetails-root": {
      padding: e.spacing(4, 0)
    }
  };
});
function $Y({ title: e, ...t }) {
  return h(Xx, { square: !0, className: "filter-accordion", title: h(ve, { variant: "tableHeader", children: e }), ...t });
}
const eS = xe(() => import("@mui/icons-material/Add")), tS = xe(() => import("@mui/icons-material/ErrorRounded")), nS = xe(() => import("@mui/icons-material/Analytics")), rS = xe(() => import("@mui/icons-material/AnalyticsOutlined")), oS = xe(() => import("@mui/icons-material/Approval")), iS = xe(() => import("@mui/icons-material/ArrowRightAlt")), aS = xe(() => import("@mui/icons-material/Assignment")), sS = xe(() => import("@mui/icons-material/AttachMoney")), lS = xe(() => import("@mui/icons-material/Business")), cS = xe(() => import("@mui/icons-material/CalendarTodayOutlined")), uS = xe(() => import("@mui/icons-material/CallEnd")), dS = xe(() => import("@mui/icons-material/Campaign")), fS = xe(() => import("@mui/icons-material/Speed")), pS = xe(() => import("@mui/icons-material/ElectricalServices")), mS = xe(() => import("@mui/icons-material/CheckOutlined")), hS = xe(() => import("@mui/icons-material/Close")), gS = xe(() => import("@mui/icons-material/CloudQueueOutlined")), yS = xe(() => import("@mui/icons-material/ChatBubble")), bS = xe(() => import("@mui/icons-material/DateRangeOutlined")), vS = xe(() => import("@mui/icons-material/DesignServices")), CS = xe(() => import("@mui/icons-material/DirectionsWalk")), wS = xe(() => import("@mui/icons-material/Download")), xS = xe(() => import("@mui/icons-material/Edit")), SS = xe(() => import("@mui/icons-material/ElectricCar")), TS = xe(() => import("@mui/icons-material/Bolt")), _S = xe(() => import("@mui/icons-material/Engineering")), DS = xe(() => import("@mui/icons-material/EvStation")), PS = xe(() => import("@mui/icons-material/FilePresent")), OS = xe(() => import("@mui/icons-material/FilterAlt")), kS = xe(() => import("@mui/icons-material/FormatListNumbered")), MS = xe(() => import("@mui/icons-material/Forum")), ES = xe(() => import("@mui/icons-material/LocalGasStationRounded")), IS = xe(() => import("@mui/icons-material/Home")), RS = xe(() => import("@mui/icons-material/HourglassTop")), AS = xe(() => import("@mui/icons-material/MonetizationOn")), $S = xe(() => import("@mui/icons-material/MonetizationOnTwoTone")), NS = xe(() => import("@mui/icons-material/NotInterested")), FS = xe(() => import("@mui/icons-material/InfoRounded")), VS = xe(() => import("@mui/icons-material/InfoOutlined")), jS = xe(() => import("@mui/icons-material/InsertChartOutlined")), LS = xe(() => import("@mui/icons-material/LocalLibrary")), BS = xe(() => import("@mui/icons-material/MenuBook")), zS = xe(() => import("@mui/icons-material/Message")), WS = xe(() => import("@mui/icons-material/ChatBubbleOutline")), qS = xe(() => import("@mui/icons-material/LocalParking")), HS = xe(() => import("@mui/icons-material/PersonSearch")), US = xe(() => import("@mui/icons-material/Outlet")), YS = xe(() => import("@mui/icons-material/Favorite")), GS = xe(() => import("@mui/icons-material/Print")), KS = xe(() => import("@mui/icons-material/Delete")), ZS = xe(() => import("@mui/icons-material/BarChart")), QS = xe(() => import("@mui/icons-material/Upload")), JS = xe(() => import("@mui/icons-material/UploadFileOutlined")), XS = xe(() => import("@mui/icons-material/DirectionsCar")), eT = xe(() => import("@mui/icons-material/WifiRounded")), tT = xe(() => import("@mui/icons-material/WorkTwoTone")), nT = xe(() => import("@mui/icons-material/ThreeGMobiledata")), rT = xe(() => import("@mui/icons-material/FourGMobiledata")), oT = xe(() => import("@mui/icons-material/FiveG")), iT = xe(() => import("@mui/icons-material/Cable")), aT = xe(() => import("@mui/icons-material/Bluetooth")), sT = xe(() => import("@mui/icons-material/LteMobiledata")), lT = xe(() => import("@mui/icons-material/ContactSupport")), cT = xe(() => import("@mui/icons-material/Rule")), uT = xe(() => import("@mui/icons-material/CheckCircleOutlineRounded")), dT = xe(() => import("@mui/icons-material/Search")), fT = xe(() => import("@mui/icons-material/IosShare")), pT = xe(() => import("./electricVehicle-3c1f6c95.js")), mT = xe(() => import("./emissions-4dfee761.js")), hT = xe(() => import("./hybridVehicle-1c8298b7.js")), gT = xe(() => import("./nature-b7f263ff.js")), yT = xe(() => import("./organization-251ea4a6.js")), bT = xe(() => import("./roundedPlug-c99f7a43.js")), vT = xe(() => import("./squaredPlug-8383c70e.js")), CT = xe(() => import("./plugSAECombo-c036b917.js")), wT = xe(() => import("./defaultPlug-7eaa9795.js")), cf = {
  add: eS,
  alert: tS,
  analytics: nS,
  analyticsOutlined: rS,
  approval: oS,
  arrowRightAlt: iS,
  assignment: aS,
  attachMoneyIcon: sS,
  bluetooth: aT,
  business: lS,
  cable: iT,
  calendarTodayOutlined: cS,
  callEnd: uS,
  campaign: dS,
  chargeSpeed: fS,
  charging: pS,
  checkOutlined: mS,
  checkCircleOutlineRounded: uT,
  close: hS,
  cloudOutlined: gS,
  contact: yS,
  contactSupport: lT,
  dateRangeOutlined: bS,
  defaultPlug: wT,
  designServices: vS,
  directionsWalk: CS,
  download: wS,
  edit: xS,
  electricCar: SS,
  electricity: TS,
  electricVehicle: pT,
  emissions: mT,
  engineering: _S,
  evStation: DS,
  filePresent: PS,
  filterAlt: OS,
  fiveGMobileData: oT,
  formatListNumbered: kS,
  forum: MS,
  fourGMobileData: rT,
  fuel: ES,
  home: IS,
  hourGlass: RS,
  hybridVehicle: hT,
  incentives: AS,
  incentivesTwoTone: $S,
  ineligible: NS,
  info: FS,
  infoOutlined: VS,
  insertChartOutlined: jS,
  library: LS,
  lteMobileData: sT,
  menuBook: BS,
  message: zS,
  messageOutLine: WS,
  nature: gT,
  organization: yT,
  parking: qS,
  personSearch: HS,
  plug: US,
  plugSAECombo: CT,
  preferredPartners: YS,
  print: GS,
  remove: KS,
  roundedPlug: bT,
  rules: cT,
  savings: ZS,
  search: dT,
  share: fT,
  squaredPlug: vT,
  threeGMobileData: nT,
  upload: QS,
  uploadFileOutlined: JS,
  vehicle: XS,
  wifi: eT,
  workplace: tT
}, xT = [
  "electricVehicle",
  "emissions",
  "hybridVehicle",
  "nature",
  "organization",
  "roundedPlug",
  "squaredPlug",
  "plugSAECombo",
  "defaultPlug"
];
function Rr(e) {
  const [t, n] = Xe(!1);
  if (t)
    return h(Kd, { "aria-label": "broken icon" });
  if ("src" in e) {
    const { src: r, width: o, height: i, alt: s, ...l } = e;
    return h("img", { "aria-label": s, src: r, alt: s, onError: () => {
      n(!0);
    }, width: o, height: i, ...l });
  }
  if ("id" in e && e.id in cf) {
    const { id: r, size: o = 24, secondaryColor: i, color: s, ...l } = e, u = cf[e.id], c = `${r} icon`, d = xT.includes(r);
    let m = {};
    return d && (m = {
      secondaryColor: i,
      size: o
    }), h($m, { children: h(u, { "aria-label": c, color: s, sx: { fontSize: o }, ...m, ...l }) });
  }
  return h(Kd, { "aria-label": "broken icon" });
}
const ST = ({ text: e, ...t }) => e ? J(Ie, { alignItems: "center", alignSelf: "center", children: [h(Rr, { ...t }), h(ve, { variant: "fineprint", component: "span", fontWeight: "fontWeightBold", children: e })] }) : h(Rr, { ...t });
function ps({ IconProps: e, title: t, children: n, ...r }) {
  return J(xa, { icon: e && h(ST, { ...e }), ...r, children: [t && h(Iv, { children: t }), n] });
}
const TT = Q(Be, {
  shouldForwardProp: (e) => e !== "noPadding"
})(({ theme: e, noPadding: t }) => ({
  outlineStyle: "solid",
  outlineWidth: e.shape.borderWidth,
  outlineColor: e.palette.shape.border,
  borderRadius: e.shape.borderRadius,
  ...!t && {
    padding: e.spacing(4)
  }
}));
var Oa;
(function(e) {
  e.CENTER = "center", e.START = "start", e.END = "end";
})(Oa || (Oa = {}));
const _T = {
  small: 18,
  medium: 20,
  large: 22
}, DT = Q(pr, {
  shouldForwardProp: (e) => e !== "loading"
})(({ theme: e, disabled: t, variant: n, loading: r }) => {
  let i = {
    color: n === "contained" && t ? e.palette.common.white : void 0
  };
  return r && (i = {
    ...i,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: e.spacing(2.5)
  }), {
    "&.MuiButtonBase-root": i
  };
});
function wo({ loading: e, startIcon: t, loadingIcon: n, endIcon: r, disabled: o, children: i, loadingIconPosition: s = Oa.START, disableOnLoading: l = !0, ...u }) {
  const c = n ?? h(Pl, { "aria-label": "progress", color: "inherit" }), d = e && l || o;
  let m = {
    startIcon: t,
    endIcon: r
  };
  const f = () => {
    const p = Da(c, {
      key: "progress",
      size: _T[u.size]
    });
    let b = [p];
    return s === Oa.START && (b = [p, i]), s === Oa.END && (b = [i, p]), b;
  };
  return e && (m = {}), h(DT, { ...u, ...m, disabled: d, loading: e, children: e ? f() : i });
}
wo.defaultProps = {
  size: "medium"
};
function Vl(e) {
  const t = qt(), n = At(t, "presets.button.primary", {});
  return h(wo, { ...e, color: "primary", variant: "contained", ...n });
}
Vl.displayName = "PrimaryButton";
function tr(e) {
  const t = qt(), n = At(t, "presets.button.secondary", {});
  return h(wo, { ...e, color: "primary", variant: "outlined", ...n });
}
tr.displayName = "SecondaryButton";
const PT = ({ media: e }) => {
  if (e)
    return h(MT, { children: typeof e == "object" && "src" in e ? h("img", { src: e.src, alt: e.alt }) : e });
};
function NY({ title: e, description: t, media: n, cta: r }) {
  return J(OT, { variant: "outlined", role: "region", children: [h(kT, { title: h(ve, { variant: "label", textTransform: "uppercase", component: "p", children: e }) }), h(PT, { media: n }), h(ET, { hasMedia: !!n, children: h(ve, { textAlign: "center", component: "p", children: t }) }), h(IT, { children: h(Be, { children: h(tr, { to: r.to, component: Qo, size: "small", role: "link", target: "_blank", rel: "noopener noreferrer", children: r.label }) }) })] });
}
const OT = Q(Co)(({ theme: e }) => {
  var t;
  return {
    "&.MuiCard-root": {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      borderColor: (t = e.palette.shape) == null ? void 0 : t.border,
      borderTop: `8px solid ${e.palette.primary.main}`,
      textAlign: "center",
      height: 387,
      padding: e.spacing(3.5, 0, 4),
      "> *": {
        padding: e.spacing(0, 4)
      }
    }
  };
}), kT = Q(zm)(({ theme: e }) => ({
  height: 46,
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  textAlign: "center",
  marginBottom: e.spacing(4),
  ".MuiTypography-root": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "initial",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical"
  }
})), MT = Q(Rv)(({ theme: e }) => ({
  maxHeight: 60,
  marginBottom: e.spacing(6),
  "& > *": {
    maxWidth: "100%",
    maxHeight: "100%"
  }
})), ET = Q(Ol, {
  shouldForwardProp: (e) => e != "hasMedia"
})(({ hasMedia: e }) => ({
  flexGrow: 0,
  flexShrink: 0,
  overflow: "auto",
  flexBasis: `calc(100% - ${e ? 240 : 150}px)`
})), IT = Q(Ru)(({ theme: e }) => ({
  position: "absolute",
  bottom: e.spacing(4),
  width: "100%",
  "& > *": {
    padding: e.spacing(6, 0, 0),
    flex: 1,
    borderTop: `1px solid ${e.palette.shape.border}`,
    "> *": {
      width: "100%"
    }
  }
})), ka = 6, RT = Q(Ie, {
  shouldForwardProp: (e) => e !== "itemsToDisplay"
})(({ theme: e, itemsToDisplay: t }) => ({
  overflowX: "auto",
  maxWidth: `calc(100% - ${parseInt(e.spacing(ka)) / (t - 1)})`,
  scrollbarWidth: "none",
  width: "100%"
})), AT = Q(Be, {
  shouldForwardProp: (e) => e !== "itemsToDisplay"
})(({ theme: e, itemsToDisplay: t }) => {
  const n = 100 / t, r = parseInt(e.spacing(ka)) * (t - 1) / t, o = `calc(${n}% - ${r}px)`;
  return {
    maxWidth: o,
    minWidth: o
  };
});
function FY({ children: e, itemsToDisplay: t, ...n }) {
  const r = qt(), o = parseInt(r.spacing(ka)), i = Ot(null), s = Ee(() => Array.isArray(e) ? e.length <= t : !1, [e, t]), l = () => {
    var c;
    (c = i.current) == null || c.scrollTo({
      left: i.current.scrollLeft - i.current.offsetWidth - o,
      behavior: "smooth"
    });
  }, u = () => {
    var c;
    (c = i.current) == null || c.scrollTo({
      left: i.current.scrollLeft + i.current.offsetWidth + o,
      behavior: "smooth"
    });
  };
  return J(Ie, { direction: "row", spacing: ka, children: [h(uf, { disabled: s, onClick: l, children: h(Av, {}) }), h(RT, { ref: i, direction: "row", spacing: ka, itemsToDisplay: t, ...n, children: Array.isArray(e) ? e.map((c, d) => h(AT, { itemsToDisplay: t, children: c }, d)) : null }), h(uf, { disabled: s, onClick: u, children: h($v, {}) })] });
}
const uf = Q(tn)(({ theme: e }) => {
  var t;
  return {
    svg: {
      color: (t = e.palette.shape) == null ? void 0 : t.border
    }
  };
});
function Ke(e, t) {
  const n = Zd(t);
  return e != null && e.length ? e.map((r) => {
    const { t: o } = Zd(t, { keyPrefix: r });
    return o;
  }).concat(n.t) : n;
}
function VY() {
  const { getAllowedFields: e } = fi();
  return Ee(() => {
    const n = e("show", "chargerTypes");
    return n.length ? n : ["archetypes"];
  }, [e]).toString();
}
const $T = Q("span")({
  display: "inline-flex"
}), xo = ({ IconProps: e = {
  id: "infoOutlined",
  size: "medium"
}, children: t, containerProps: n, ...r }) => {
  const o = r.title && h(Nv, { ...r, children: h($T, { children: h(Rr, { ...e }) }) });
  return t && o ? J(Be, { display: "flex", alignItems: "center", gap: 2, ...n, children: [t, o] }) : t || o;
};
function df({ alignLabel: e = "left", labelVariant: t = "tableHeader", alignValue: n = "right", valueVariant: r = "tableBody", valueFormat: o, flexChildren: i = 1, item: [s, l, u, c, d = {}], t: m }) {
  const { valueFormat: f, alignValue: p } = d, b = f || o;
  return J(Je, { item: !0, display: "flex", justifyContent: "space-between", children: [h(Be, { flex: i, component: "dt", pr: 1, textAlign: e, children: h(xo, { title: u, IconProps: { id: "infoOutlined", size: 16 }, children: h(ve, { variant: t, children: s }) }) }), h(Be, { flex: i, component: "dd", m: 0, textAlign: n, children: h(ve, { variant: r, children: b && typeof l == "number" ? m(b, { value: l }) : l }) }), c !== void 0 && h(Be, { flex: 1, component: "dd", m: 0, textAlign: p || n, children: h(ve, { variant: r, children: b && typeof c == "number" ? m(b, { value: c }) : c }) })] });
}
function NT({ items: e, divider: t, aggregate: n, rowDetails: r, rowDetailsHeader: o, textWrap: i, ...s }) {
  const [l] = Ke();
  let u = 0;
  return J(FT, { container: !0, component: "dl", display: "block", margin: "0", textWrap: i, children: [r && J(Je, { item: !0, display: "flex", justifyContent: "space-between", children: [o && J(kr, { children: [h(Be, { flex: 1, component: "dt", m: 0, textAlign: "right" }), h(Be, { flex: 1, component: "dt", m: 0, textAlign: "right", children: h(ve, { variant: "tableHeader", textAlign: "left", children: o }) })] }), h(Be, { flex: 1, component: "dd", m: 0, textAlign: "right", children: h(ve, { variant: "tableHeader", children: l("total") }) })] }), e.map((c, d) => {
    const [m, f] = c;
    return n && typeof f == "number" && (u += f), J(kr, { children: [df({ ...s, item: c, t: l }), t && d !== e.length - 1 && h(kt, { role: "presentation", flexItem: !0 })] }, `${m}${f}`);
  }), n && J(Dt, { children: [h(kt, { role: "presentation", flexItem: !0 }), df({
    ...s,
    labelVariant: "tableHeader",
    item: [
      l("total"),
      s.valueFormat ? l(s.valueFormat, { value: u }) : u
    ],
    t: l
  })] })] });
}
const FT = Q(Je, { shouldForwardProp: (e) => e !== "textWrap" })(({ textWrap: e }) => ({
  textWrap: e
})), VT = Nm(NT), Ih = Q(ve)({
  display: "inline-block",
  minHeight: 16,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}), jT = Q(Be, { shouldForwardProp: (e) => e !== "columns" })(({ columns: e }) => ({
  columns: e,
  columnGap: 0
})), LT = Q(Be)({
  breakBefore: "avoid"
}), BT = { left: "start", right: "end" };
function zT(e, t, n, r) {
  if (!n)
    return t ?? r;
  if (typeof n == "string")
    return e(n, { value: t });
  const { format: o, options: i } = n;
  return e(o, { value: t, formatOptions: i });
}
function WT({ alignValue: e = "right", valueVariant: t = "tableBody", valueFormat: n, value: r, t: o, divider: i, key: s }) {
  return J(LT, { component: "dd", m: 0, textAlign: e, children: [h(Ih, { variant: t, title: r == null ? void 0 : r.toString(), children: n && typeof r == "number" ? zT(o, r, n, "-") : r }), i && h(kt, { role: "presentation", flexItem: !0 })] }, s);
}
function qT({ alignLabel: e = "left", labelVariant: t = "tableHeader", alignValue: n = "right", valueVariant: r = "tableBody", valueFormat: o, divider: i, item: { label: s, values: l, tooltip: u, format: c }, t: d }) {
  return J(Dt, { children: [J(Be, { component: "dt", textAlign: e, children: [h(xo, { containerProps: {
    justifyContent: BT[e],
    paddingY: 1.4
  }, title: u, IconProps: { id: "infoOutlined", size: 16 }, children: h(Ih, { variant: t, children: s }) }), i && h(kt, { role: "presentation", flexItem: !0 })] }), l.map((m, f) => WT({
    alignValue: n,
    valueVariant: r,
    valueFormat: c || o,
    value: m,
    t: d,
    divider: i,
    key: f
  }))] });
}
function HT({ items: e, aggregate: t, valueVariant: n, ...r }) {
  const [o] = Ke(), i = o("total"), s = e.length, l = Ee(() => (!t || e[0].values.at(-1) === i || e.map(({ values: u, aggregate: c }, d) => {
    if (c === !1) {
      u.push("-");
      return;
    }
    let m = 0;
    u.forEach((f) => {
      typeof f == "number" && (m += f);
    }), d === 0 ? u.push(i) : u.push(m);
  }), e), [t, e, i]);
  return h(jT, { component: "dl", columns: s, display: "block", children: l.map((u, c) => h(kr, { children: qT({
    ...r,
    item: u,
    valueVariant: c === 0 ? "tableHeader" : n,
    t: o
  }) }, c)) });
}
const jY = Nm(HT), UT = {
  "3G": "threeGMobileData",
  "4G": "fourGMobileData",
  "5G": "fiveGMobileData",
  LTE: "lteMobileData",
  Ethernet: "cable",
  Wifi: "wifi",
  Bluetooth: "bluetooth"
}, YT = (e) => {
  const t = [...e.cellular_support ?? []];
  return e.bluetooth && t.push("Bluetooth"), e.ethernet && t.push("Ethernet"), e.wifi && t.push("Wifi"), {
    hasConnectivity: t.length > 0,
    icons: t.map((n) => UT[n])
  };
}, GT = ({ charger: e, selected: t, onChange: n }) => {
  const [r, o] = Ke(["components.charger"]), i = Ee(() => YT(e), [e]), s = o("notApplicable"), l = Qe((d) => d || s, [s]), u = Qe((d) => o(d ? "yes" : "no"), [o]), c = Ee(() => {
    const { price: d, kw: m, amps: f, plug_types: p, cord_length: b, num_of_ports: g, form_factor: S, home_outlet: C, ocpp_version: w, oscp_version: v, vgi_capable: x, warranty: T, certified_by: E, charger_type: k } = e;
    return [
      [r("estimatedCost"), o("currency", { value: d })],
      [r("chargerType"), r(k)],
      [r("portkw"), Dh(m || 0)],
      [r("amps"), r("ampsValue", { value: f })],
      [r("plugTypes"), l(p)],
      [r("cableLength"), r("lengthValue", { value: b })],
      [r("port_other"), l(g)],
      [r("formFactor"), l(S)],
      [r("outlets"), l(C)],
      [r("ocpp"), l(w)],
      [r("oscp"), l(v)],
      [r("vehicleToGrid"), u(x)],
      [r("warranty"), r("warrantyValue", { count: T })],
      [r("certifications"), (E || []).join(", ")]
    ];
  }, [e, u, r, o, l]);
  return J(Ie, { gap: 4, children: [h(kt, { role: "presentation", flexItem: !0 }), J(Ie, { gap: 2, children: [h(ve, { variant: "tableHeader", children: r("connectivity") }), J(Ie, { direction: "row", gap: 2, children: [!i.hasConnectivity && h(ve, { variant: "tableBody", children: s }), i.icons.map((d) => h(Rr, { id: d, size: 22 }, `connection-icon-${d}`))] })] }), h(kt, { role: "presentation", flexItem: !0 }), h(VT, { divider: !0, items: c }), n && h(wo, { onClick: n, variant: t ? "contained" : "outlined", children: t ? r("selected") : o("change") })] });
}, KT = Q("img")(() => ({
  height: "160px",
  maxWidth: "100%",
  margin: "auto"
})), ZT = ({ title: e, subtitle: t, imageSrc: n, portName: r }) => J(Dt, { children: [J(Ie, { gap: 2, children: [h(ve, { variant: "tableHeader", children: e }), h(ve, { variant: "tableBody", children: t })] }), r && h(Be, { children: h(kl, { label: r, color: "primary" }) }), h(KT, { src: n, alt: e })] }), LY = ({ variant: e = "compact", charger: t, onChange: n, selected: r, ...o }) => {
  const [i] = Ke(["components.charger"]), s = Lx(t, i), l = Bx(t, i), u = e === "detailed";
  return h(TT, { ...o, children: J(Ie, { gap: 4, children: [h(ZT, { title: t.label, subtitle: s, imageSrc: t.img, portName: u ? l : void 0 }), e === "detailed" && h(GT, { selected: r, onChange: n, charger: t })] }) });
};
function ju(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
var Za;
(function(e) {
  e.event = "event", e.props = "prop";
})(Za || (Za = {}));
function fr() {
}
function QT(e) {
  var t, n = void 0;
  return function() {
    for (var r = [], o = arguments.length; o--; )
      r[o] = arguments[o];
    return t && r.length === t.length && r.every(function(i, s) {
      return i === t[s];
    }) || (t = r, n = e.apply(void 0, r)), n;
  };
}
function mo(e) {
  return !!(e || "").match(/\d/);
}
function so(e) {
  return e == null;
}
function JT(e) {
  return typeof e == "number" && isNaN(e);
}
function Rh(e) {
  return so(e) || JT(e) || typeof e == "number" && !isFinite(e);
}
function Ah(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function XT(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function e_(e, t, n) {
  var r = XT(n), o = e.search(/[1-9]/);
  return o = o === -1 ? e.length : o, e.substring(0, o) + e.substring(o, e.length).replace(r, "$1" + t);
}
function t_(e) {
  var t = Ot(e);
  t.current = e;
  var n = Ot(function() {
    for (var r = [], o = arguments.length; o--; )
      r[o] = arguments[o];
    return t.current.apply(t, r);
  });
  return n.current;
}
function Lu(e, t) {
  t === void 0 && (t = !0);
  var n = e[0] === "-", r = n && t;
  e = e.replace("-", "");
  var o = e.split("."), i = o[0], s = o[1] || "";
  return {
    beforeDecimal: i,
    afterDecimal: s,
    hasNegation: n,
    addNegation: r
  };
}
function n_(e) {
  if (!e)
    return e;
  var t = e[0] === "-";
  t && (e = e.substring(1, e.length));
  var n = e.split("."), r = n[0].replace(/^0+/, "") || "0", o = n[1] || "";
  return (t ? "-" : "") + r + (o ? "." + o : "");
}
function $h(e, t, n) {
  for (var r = "", o = n ? "0" : "", i = 0; i <= t - 1; i++)
    r += e[i] || o;
  return r;
}
function ff(e, t) {
  return Array(t + 1).join(e);
}
function Nh(e) {
  var t = e + "", n = t[0] === "-" ? "-" : "";
  n && (t = t.substring(1));
  var r = t.split(/[eE]/g), o = r[0], i = r[1];
  if (i = Number(i), !i)
    return n + o;
  o = o.replace(".", "");
  var s = 1 + i, l = o.length;
  return s < 0 ? o = "0." + ff("0", Math.abs(s)) + o : s >= l ? o = o + ff("0", s - l) : o = (o.substring(0, s) || "0") + "." + o.substring(s), n + o;
}
function pf(e, t, n) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var r = (e.indexOf(".") !== -1 || n) && t, o = Lu(e), i = o.beforeDecimal, s = o.afterDecimal, l = o.hasNegation, u = parseFloat("0." + (s || "0")), c = s.length <= t ? "0." + s : u.toFixed(t), d = c.split("."), m = i.split("").reverse().reduce(function(g, S, C) {
    return g.length > C ? (Number(g[0]) + Number(S)).toString() + g.substring(1, g.length) : S + g;
  }, d[0]), f = $h(d[1] || "", t, n), p = l ? "-" : "", b = r ? "." : "";
  return "" + p + m + b + f;
}
function Pr(e, t) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var n = e.createTextRange();
      return n.move("character", t), n.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(t, t), !0) : (e.focus(), !1);
  }
}
var Fh = QT(function(e, t) {
  for (var n = 0, r = 0, o = e.length, i = t.length; e[n] === t[n] && n < o; )
    n++;
  for (; e[o - 1 - r] === t[i - 1 - r] && i - r > n && o - r > n; )
    r++;
  return {
    from: { start: n, end: o - r },
    to: { start: n, end: i - r }
  };
});
function r_(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function hc(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function o_() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function Vh(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function jh(e, t) {
  return e === void 0 && (e = " "), typeof e == "string" ? e : e[t] || " ";
}
function i_(e) {
  var t = e.currentValue, n = e.formattedValue, r = e.currentValueIndex, o = e.formattedValueIndex;
  return t[r] === n[o];
}
function a_(e, t, n, r, o, i, s) {
  s === void 0 && (s = i_);
  var l = o.findIndex(function(x) {
    return x;
  }), u = e.slice(0, l);
  !t && !n.startsWith(u) && (t = u, n = u + n, r = r + u.length);
  for (var c = n.length, d = e.length, m = {}, f = new Array(c), p = 0; p < c; p++) {
    f[p] = -1;
    for (var b = 0, g = d; b < g; b++) {
      var S = s({
        currentValue: n,
        lastValue: t,
        formattedValue: e,
        currentValueIndex: p,
        formattedValueIndex: b
      });
      if (S && m[b] !== !0) {
        f[p] = b, m[b] = !0;
        break;
      }
    }
  }
  for (var C = r; C < c && (f[C] === -1 || !i(n[C])); )
    C++;
  var w = C === c || f[C] === -1 ? d : f[C];
  for (C = r - 1; C > 0 && f[C] === -1; )
    C--;
  var v = C === -1 || f[C] === -1 ? 0 : f[C] + 1;
  return v > w ? w : r - v < w - r ? v : w;
}
function rl(e, t, n, r) {
  var o = e.length;
  if (t = r_(t, 0, o), r === "left") {
    for (; t >= 0 && !n[t]; )
      t--;
    t === -1 && (t = n.indexOf(!0));
  } else {
    for (; t <= o && !n[t]; )
      t++;
    t > o && (t = n.lastIndexOf(!0));
  }
  return t === -1 && (t = o), t;
}
function s_(e) {
  for (var t = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), n = 0, r = t.length; n < r; n++)
    t[n] = !!(mo(e[n]) || mo(e[n - 1]));
  return t;
}
function Lh(e, t, n, r, o, i) {
  i === void 0 && (i = fr);
  var s = t_(function(b, g) {
    var S, C;
    return Rh(b) ? (C = "", S = "") : typeof b == "number" || g ? (C = typeof b == "number" ? Nh(b) : b, S = r(C)) : (C = o(b, void 0), S = r(C)), { formattedValue: S, numAsString: C };
  }), l = Xe(function() {
    return s(so(e) ? t : e, n);
  }), u = l[0], c = l[1], d = function(b, g) {
    b.formattedValue !== u.formattedValue && c({
      formattedValue: b.formattedValue,
      numAsString: b.value
    }), i(b, g);
  }, m = e, f = n;
  so(e) && (m = u.numAsString, f = !0);
  var p = s(m, f);
  return Ee(function() {
    c(p);
  }, [p.formattedValue]), [u, d];
}
function l_(e) {
  return e.replace(/[^0-9]/g, "");
}
function c_(e) {
  return e;
}
function Bh(e) {
  var t = e.type;
  t === void 0 && (t = "text");
  var n = e.displayType;
  n === void 0 && (n = "input");
  var r = e.customInput, o = e.renderText, i = e.getInputRef, s = e.format;
  s === void 0 && (s = c_);
  var l = e.removeFormatting;
  l === void 0 && (l = l_);
  var u = e.defaultValue, c = e.valueIsNumericString, d = e.onValueChange, m = e.isAllowed, f = e.onChange;
  f === void 0 && (f = fr);
  var p = e.onKeyDown;
  p === void 0 && (p = fr);
  var b = e.onMouseUp;
  b === void 0 && (b = fr);
  var g = e.onFocus;
  g === void 0 && (g = fr);
  var S = e.onBlur;
  S === void 0 && (S = fr);
  var C = e.value, w = e.getCaretBoundary;
  w === void 0 && (w = s_);
  var v = e.isValidInputCharacter;
  v === void 0 && (v = mo);
  var x = e.isCharacterSame, T = ju(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), E = Lh(C, u, !!c, s, l, d), k = E[0], I = k.formattedValue, P = k.numAsString, F = E[1], A = Ot({ formattedValue: I, numAsString: P }), B = function(ue, me) {
    A.current = { formattedValue: ue.formattedValue, numAsString: ue.value }, F(ue, me);
  }, W = Xe(!1), M = W[0], _ = W[1], O = Ot(null), R = Ot({
    setCaretTimeout: null,
    focusTimeout: null
  });
  it(function() {
    return _(!0), function() {
      clearTimeout(R.current.setCaretTimeout), clearTimeout(R.current.focusTimeout);
    };
  }, []);
  var N = s, L = function(ue, me) {
    var De = parseFloat(me);
    return {
      formattedValue: ue,
      value: me,
      floatValue: isNaN(De) ? void 0 : De
    };
  }, $ = function(ue, me, De) {
    ue.selectionStart === 0 && ue.selectionEnd === ue.value.length || (Pr(ue, me), R.current.setCaretTimeout = setTimeout(function() {
      ue.value === De && ue.selectionStart !== ue.selectionEnd && Pr(ue, me);
    }, 0));
  }, H = function(ue, me, De) {
    return rl(ue, me, w(ue), De);
  }, G = function(ue, me, De) {
    var he = w(me), Ce = a_(me, I, ue, De, he, v, x);
    return Ce = rl(me, Ce, he), Ce;
  }, q = function(ue) {
    var me = ue.formattedValue;
    me === void 0 && (me = "");
    var De = ue.input, he = ue.setCaretPosition;
    he === void 0 && (he = !0);
    var Ce = ue.source, K = ue.event, ne = ue.numAsString, pe = ue.caretPos;
    if (De) {
      if (pe === void 0 && he) {
        var Me = ue.inputValue || De.value, de = hc(De);
        De.value = me, pe = G(Me, me, de);
      }
      De.value = me, he && pe !== void 0 && $(De, pe, me);
    }
    me !== I && B(L(me, ne), { event: K, source: Ce });
  };
  it(function() {
    var ue = A.current, me = ue.formattedValue, De = ue.numAsString;
    I !== me && (I !== P || me !== De) && B(L(I, P), {
      event: void 0,
      source: Za.props
    });
  }, [I, P]);
  var Y = O.current ? hc(O.current) : void 0, Z = typeof window < "u" ? Dl : it;
  Z(function() {
    var ue = O.current;
    if (I !== A.current.formattedValue && ue) {
      var me = G(A.current.formattedValue, I, Y);
      ue.value = I, $(ue, me, I);
    }
  }, [I]);
  var ie = function(ue, me, De) {
    var he = Fh(I, ue), Ce = Object.assign(Object.assign({}, he), { lastValue: I }), K = l(ue, Ce), ne = N(K);
    if (K = l(ne, void 0), m && !m(L(ne, K))) {
      var pe = me.target, Me = hc(pe), de = G(ue, I, Me);
      return pe.value = I, $(pe, de, I), !1;
    }
    return q({
      formattedValue: ne,
      numAsString: K,
      inputValue: ue,
      event: me,
      source: De,
      setCaretPosition: !0,
      input: me.target
    }), !0;
  }, X = function(ue) {
    var me = ue.target, De = me.value, he = ie(De, ue, Za.event);
    he && f(ue);
  }, se = function(ue) {
    var me = ue.target, De = ue.key, he = me.selectionStart, Ce = me.selectionEnd, K = me.value;
    K === void 0 && (K = "");
    var ne;
    if (De === "ArrowLeft" || De === "Backspace" ? ne = Math.max(he - 1, 0) : De === "ArrowRight" ? ne = Math.min(he + 1, K.length) : De === "Delete" && (ne = he), ne === void 0 || he !== Ce) {
      p(ue);
      return;
    }
    var pe = ne;
    if (De === "ArrowLeft" || De === "ArrowRight") {
      var Me = De === "ArrowLeft" ? "left" : "right";
      pe = H(K, ne, Me), pe !== ne && ue.preventDefault();
    } else
      De === "Delete" && !v(K[ne]) ? pe = H(K, ne, "right") : De === "Backspace" && !v(K[ne]) && (pe = H(K, ne, "left"));
    pe !== ne && $(me, pe, K), ue.isUnitTestRun && $(me, pe, K), p(ue);
  }, fe = function(ue) {
    var me = ue.target, De = me.selectionStart, he = me.selectionEnd, Ce = me.value;
    if (Ce === void 0 && (Ce = ""), De === he) {
      var K = H(Ce, De);
      K !== De && $(me, K, Ce);
    }
    b(ue);
  }, le = function(ue) {
    ue.persist && ue.persist();
    var me = ue.target;
    O.current = me, R.current.focusTimeout = setTimeout(function() {
      var De = me.selectionStart, he = me.selectionEnd, Ce = me.value;
      Ce === void 0 && (Ce = "");
      var K = H(Ce, De);
      K !== De && !(De === 0 && he === Ce.length) && $(me, K, Ce), g(ue);
    }, 0);
  }, ce = function(ue) {
    O.current = null, clearTimeout(R.current.focusTimeout), clearTimeout(R.current.setCaretTimeout), S(ue);
  }, ee = M && o_() ? "numeric" : void 0, ae = Object.assign({ inputMode: ee }, T, {
    type: t,
    value: I,
    onChange: X,
    onKeyDown: se,
    onMouseUp: fe,
    onFocus: le,
    onBlur: ce
  });
  if (n === "text")
    return o ? ct.createElement(ct.Fragment, null, o(I, T) || null) : ct.createElement("span", Object.assign({}, T, { ref: i }), I);
  if (r) {
    var _e = r;
    return ct.createElement(_e, Object.assign({}, ae, { ref: i }));
  }
  return ct.createElement("input", Object.assign({}, ae, { ref: i }));
}
function ol(e, t) {
  var n = t.decimalScale, r = t.fixedDecimalScale, o = t.prefix;
  o === void 0 && (o = "");
  var i = t.suffix;
  i === void 0 && (i = "");
  var s = t.allowNegative, l = t.thousandsGroupStyle;
  if (l === void 0 && (l = "thousand"), e === "" || e === "-")
    return e;
  var u = jl(t), c = u.thousandSeparator, d = u.decimalSeparator, m = n !== 0 && e.indexOf(".") !== -1 || n && r, f = Lu(e, s), p = f.beforeDecimal, b = f.afterDecimal, g = f.addNegation;
  return n !== void 0 && (b = $h(b, n, !!r)), c && (p = e_(p, c, l)), o && (p = o + p), i && (b = b + i), g && (p = "-" + p), e = p + (m && d || "") + b, e;
}
function jl(e) {
  var t = e.decimalSeparator;
  t === void 0 && (t = ".");
  var n = e.thousandSeparator, r = e.allowedDecimalSeparators;
  return n === !0 && (n = ","), r || (r = [t, "."]), {
    decimalSeparator: t,
    thousandSeparator: n,
    allowedDecimalSeparators: r
  };
}
function u_(e, t) {
  e === void 0 && (e = "");
  var n = new RegExp("(-)"), r = new RegExp("(-)(.)*(-)"), o = n.test(e), i = r.test(e);
  return e = e.replace(/-/g, ""), o && !i && t && (e = "-" + e), e;
}
function d_(e, t) {
  return new RegExp("(^-)|[0-9]|" + Ah(e), t ? "g" : void 0);
}
function f_(e, t, n) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && !(n != null && n.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function p_(e, t, n) {
  var r;
  t === void 0 && (t = Vh(e));
  var o = n.allowNegative, i = n.prefix;
  i === void 0 && (i = "");
  var s = n.suffix;
  s === void 0 && (s = "");
  var l = n.decimalScale, u = t.from, c = t.to, d = c.start, m = c.end, f = jl(n), p = f.allowedDecimalSeparators, b = f.decimalSeparator, g = e[m] === b;
  if (mo(e) && (e === i || e === s) && t.lastValue === "")
    return e;
  if (m - d === 1 && p.indexOf(e[d]) !== -1) {
    var S = l === 0 ? "" : b;
    e = e.substring(0, d) + S + e.substring(d + 1, e.length);
  }
  var C = function(R, N, L) {
    var $ = !1, H = !1;
    i.startsWith("-") ? $ = !1 : R.startsWith("--") ? ($ = !1, H = !0) : s.startsWith("-") && R.length === s.length ? $ = !1 : R[0] === "-" && ($ = !0);
    var G = $ ? 1 : 0;
    return H && (G = 2), G && (R = R.substring(G), N -= G, L -= G), { value: R, start: N, end: L, hasNegation: $ };
  }, w = C(e, d, m), v = w.hasNegation;
  r = w, e = r.value, d = r.start, m = r.end;
  var x = C(t.lastValue, u.start, u.end), T = x.start, E = x.end, k = x.value, I = e.substring(d, m);
  e.length && k.length && (T > k.length - s.length || E < i.length) && !(I && s.startsWith(I)) && (e = k);
  var P = 0;
  e.startsWith(i) ? P += i.length : d < i.length && (P = d), e = e.substring(P), m -= P;
  var F = e.length, A = e.length - s.length;
  e.endsWith(s) ? F = A : (m > A || m > e.length - s.length) && (F = m), e = e.substring(0, F), e = u_(v ? "-" + e : e, o), e = (e.match(d_(b, !0)) || []).join("");
  var B = e.indexOf(b);
  e = e.replace(new RegExp(Ah(b), "g"), function(R, N) {
    return N === B ? "." : "";
  });
  var W = Lu(e, o), M = W.beforeDecimal, _ = W.afterDecimal, O = W.addNegation;
  return c.end - c.start < u.end - u.start && M === "" && g && !parseFloat(_) && (e = O ? "-" : ""), e;
}
function m_(e, t) {
  var n = t.prefix;
  n === void 0 && (n = "");
  var r = t.suffix;
  r === void 0 && (r = "");
  var o = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), i = e[0] === "-";
  o.fill(!1, 0, n.length + (i ? 1 : 0));
  var s = e.length;
  return o.fill(!1, s - r.length + 1, s + 1), o;
}
function h_(e) {
  var t = jl(e), n = t.thousandSeparator, r = t.decimalSeparator, o = e.prefix;
  o === void 0 && (o = "");
  var i = e.allowNegative;
  if (i === void 0 && (i = !0), n === r)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + n + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + r + ` (default value for decimalSeparator is .)
     `);
  return o.startsWith("-") && i && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + o + `
      allowNegative: ` + i + `
    `), i = !1), Object.assign(Object.assign({}, e), { allowNegative: i });
}
function g_(e) {
  e = h_(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var t = e.suffix, n = e.allowNegative, r = e.allowLeadingZeros, o = e.onKeyDown;
  o === void 0 && (o = fr);
  var i = e.onBlur;
  i === void 0 && (i = fr);
  var s = e.thousandSeparator, l = e.decimalScale, u = e.fixedDecimalScale, c = e.prefix;
  c === void 0 && (c = "");
  var d = e.defaultValue, m = e.value, f = e.valueIsNumericString, p = e.onValueChange, b = ju(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), g = jl(e), S = g.decimalSeparator, C = g.allowedDecimalSeparators, w = function(O) {
    return ol(O, e);
  }, v = function(O, R) {
    return p_(O, R, e);
  }, x = so(m) ? d : m, T = f ?? f_(x, c, t);
  so(m) ? so(d) || (T = T || typeof d == "number") : T = T || typeof m == "number";
  var E = function(O) {
    return Rh(O) ? O : (typeof O == "number" && (O = Nh(O)), T && typeof l == "number" ? pf(O, l, !!u) : O);
  }, k = Lh(E(m), E(d), !!T, w, v, p), I = k[0], P = I.numAsString, F = I.formattedValue, A = k[1], B = function(O) {
    var R = O.target, N = O.key, L = R.selectionStart, $ = R.selectionEnd, H = R.value;
    if (H === void 0 && (H = ""), L !== $) {
      o(O);
      return;
    }
    N === "Backspace" && H[0] === "-" && L === c.length + 1 && n && Pr(R, 1), l && u && (N === "Backspace" && H[L - 1] === S ? (Pr(R, L - 1), O.preventDefault()) : N === "Delete" && H[L] === S && O.preventDefault()), C != null && C.includes(N) && H[L] === S && Pr(R, L + 1);
    var G = s === !0 ? "," : s;
    N === "Backspace" && H[L - 1] === G && Pr(R, L - 1), N === "Delete" && H[L] === G && Pr(R, L + 1), o(O);
  }, W = function(O) {
    var R = P;
    if (R.match(/\d/g) || (R = ""), r || (R = n_(R)), u && l && (R = pf(R, l, u)), R !== P) {
      var N = ol(R, e);
      A({
        formattedValue: N,
        value: R,
        floatValue: parseFloat(R)
      }, {
        event: O,
        source: Za.event
      });
    }
    i(O);
  }, M = function(O) {
    return O === S ? !0 : mo(O);
  }, _ = function(O) {
    var R = O.currentValue, N = O.lastValue, L = O.formattedValue, $ = O.currentValueIndex, H = O.formattedValueIndex, G = R[$], q = L[H], Y = Fh(N, R), Z = Y.to;
    return $ >= Z.start && $ < Z.end && C && C.includes(G) && q === S ? !0 : G === q;
  };
  return Object.assign(Object.assign({}, b), {
    value: F,
    valueIsNumericString: !1,
    isValidInputCharacter: M,
    isCharacterSame: _,
    onValueChange: A,
    format: w,
    removeFormatting: v,
    getCaretBoundary: function(O) {
      return m_(O, e);
    },
    onKeyDown: B,
    onBlur: W
  });
}
function y_(e) {
  var t = g_(e);
  return ct.createElement(Bh, Object.assign({}, t));
}
function b_(e, t) {
  var n = t.format, r = t.allowEmptyFormatting, o = t.mask, i = t.patternChar;
  if (i === void 0 && (i = "#"), e === "" && !r)
    return "";
  for (var s = 0, l = n.split(""), u = 0, c = n.length; u < c; u++)
    n[u] === i && (l[u] = e[s] || jh(o, s), s += 1);
  return l.join("");
}
function v_(e, t, n) {
  t === void 0 && (t = Vh(e));
  var r = n.format, o = n.patternChar;
  o === void 0 && (o = "#");
  var i = t.from, s = t.to, l = t.lastValue;
  l === void 0 && (l = "");
  var u = function(S) {
    return r[S] === o;
  }, c = function(S, C) {
    for (var w = "", v = 0; v < S.length; v++)
      u(C + v) && mo(S[v]) && (w += S[v]);
    return w;
  }, d = function(S) {
    return S.replace(/[^0-9]/g, "");
  };
  if (!r.match(/\d/))
    return d(e);
  if (l === "" && e.length === r.length) {
    for (var m = "", f = 0; f < e.length; f++)
      if (u(f))
        mo(e[f]) && (m += e[f]);
      else if (e[f] !== r[f])
        return d(e);
    return m;
  }
  var p = l.substring(0, i.start), b = e.substring(s.start, s.end), g = l.substring(i.end);
  return "" + c(p, 0) + d(b) + c(g, i.end);
}
function C_(e, t) {
  var n = t.format, r = t.mask, o = t.patternChar;
  o === void 0 && (o = "#");
  var i = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), s = 0, l = -1, u = {};
  n.split("").forEach(function(f, p) {
    var b = void 0;
    f === o && (s++, b = jh(r, s - 1), l === -1 && e[p] === b && (l = p)), u[p] = b;
  });
  for (var c = function(f) {
    return n[f] === o && e[f] !== u[f];
  }, d = 0, m = i.length; d < m; d++)
    i[d] = d === l || c(d) || c(d - 1);
  return i[n.indexOf(o)] = !0, i;
}
function w_(e) {
  var t = e.mask;
  if (t) {
    var n = t === "string" ? t : t.toString();
    if (n.match(/\d/g))
      throw new Error("Mask " + t + " should not contain numeric character;");
  }
}
function x_(e, t) {
  return e === "" ? !0 : !(t != null && t.match(/\d/)) && typeof e == "string" && (!!e.match(/^\d+$/) || e === "");
}
function S_(e) {
  e.mask, e.allowEmptyFormatting;
  var t = e.format, n = e.inputMode;
  n === void 0 && (n = "numeric");
  var r = e.onKeyDown;
  r === void 0 && (r = fr);
  var o = e.patternChar;
  o === void 0 && (o = "#");
  var i = e.value, s = e.defaultValue, l = e.valueIsNumericString, u = ju(e, ["mask", "allowEmptyFormatting", "format", "inputMode", "onKeyDown", "patternChar", "value", "defaultValue", "valueIsNumericString"]);
  w_(e);
  var c = function(b) {
    return C_(b, e);
  }, d = function(b) {
    var g = b.key, S = b.target, C = S.selectionStart, w = S.selectionEnd, v = S.value;
    if (C !== w) {
      r(b);
      return;
    }
    var x = C;
    if (g === "Backspace" || g === "Delete") {
      var T = "right";
      if (g === "Backspace") {
        for (; x > 0 && t[x - 1] !== o; )
          x--;
        T = "left";
      } else {
        for (var E = t.length; x < E && t[x] !== o; )
          x++;
        T = "right";
      }
      x = rl(v, x, c(v), T);
    } else
      t[x] !== o && g !== "ArrowLeft" && g !== "ArrowRight" && (x = rl(v, x + 1, c(v), "right"));
    x !== C && Pr(S, x), r(b);
  }, m = so(i) ? s : i, f = l ?? x_(m, t), p = Object.assign(Object.assign({}, e), { valueIsNumericString: f });
  return Object.assign(Object.assign({}, u), {
    value: i,
    defaultValue: s,
    valueIsNumericString: f,
    inputMode: n,
    format: function(b) {
      return b_(b, p);
    },
    removeFormatting: function(b, g) {
      return v_(b, g, p);
    },
    getCaretBoundary: c,
    onKeyDown: d
  });
}
function T_(e) {
  var t = S_(e);
  return ct.createElement(Bh, Object.assign({}, t));
}
function __() {
  this.__data__ = [], this.size = 0;
}
var D_ = __;
function P_(e, t) {
  return e === t || e !== e && t !== t;
}
var Ll = P_, O_ = Ll;
function k_(e, t) {
  for (var n = e.length; n--; )
    if (O_(e[n][0], t))
      return n;
  return -1;
}
var Bl = k_, M_ = Bl, E_ = Array.prototype, I_ = E_.splice;
function R_(e) {
  var t = this.__data__, n = M_(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : I_.call(t, n, 1), --this.size, !0;
}
var A_ = R_, $_ = Bl;
function N_(e) {
  var t = this.__data__, n = $_(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var F_ = N_, V_ = Bl;
function j_(e) {
  return V_(this.__data__, e) > -1;
}
var L_ = j_, B_ = Bl;
function z_(e, t) {
  var n = this.__data__, r = B_(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var W_ = z_, q_ = D_, H_ = A_, U_ = F_, Y_ = L_, G_ = W_;
function mi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
mi.prototype.clear = q_;
mi.prototype.delete = H_;
mi.prototype.get = U_;
mi.prototype.has = Y_;
mi.prototype.set = G_;
var zl = mi, K_ = zl;
function Z_() {
  this.__data__ = new K_(), this.size = 0;
}
var Q_ = Z_;
function J_(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var X_ = J_;
function e0(e) {
  return this.__data__.get(e);
}
var t0 = e0;
function n0(e) {
  return this.__data__.has(e);
}
var r0 = n0, o0 = typeof ot == "object" && ot && ot.Object === Object && ot, zh = o0, i0 = zh, a0 = typeof self == "object" && self && self.Object === Object && self, s0 = i0 || a0 || Function("return this")(), hi = s0, l0 = hi, c0 = l0.Symbol, Wh = c0, mf = Wh, qh = Object.prototype, u0 = qh.hasOwnProperty, d0 = qh.toString, pa = mf ? mf.toStringTag : void 0;
function f0(e) {
  var t = u0.call(e, pa), n = e[pa];
  try {
    e[pa] = void 0;
    var r = !0;
  } catch {
  }
  var o = d0.call(e);
  return r && (t ? e[pa] = n : delete e[pa]), o;
}
var p0 = f0, m0 = Object.prototype, h0 = m0.toString;
function g0(e) {
  return h0.call(e);
}
var y0 = g0, hf = Wh, b0 = p0, v0 = y0, C0 = "[object Null]", w0 = "[object Undefined]", gf = hf ? hf.toStringTag : void 0;
function x0(e) {
  return e == null ? e === void 0 ? w0 : C0 : gf && gf in Object(e) ? b0(e) : v0(e);
}
var ms = x0;
function S0(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Br = S0, T0 = ms, _0 = Br, D0 = "[object AsyncFunction]", P0 = "[object Function]", O0 = "[object GeneratorFunction]", k0 = "[object Proxy]";
function M0(e) {
  if (!_0(e))
    return !1;
  var t = T0(e);
  return t == P0 || t == O0 || t == D0 || t == k0;
}
var Bu = M0, E0 = hi, I0 = E0["__core-js_shared__"], R0 = I0, gc = R0, yf = function() {
  var e = /[^.]+$/.exec(gc && gc.keys && gc.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function A0(e) {
  return !!yf && yf in e;
}
var $0 = A0, N0 = Function.prototype, F0 = N0.toString;
function V0(e) {
  if (e != null) {
    try {
      return F0.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var j0 = V0, L0 = Bu, B0 = $0, z0 = Br, W0 = j0, q0 = /[\\^$.*+?()[\]{}|]/g, H0 = /^\[object .+?Constructor\]$/, U0 = Function.prototype, Y0 = Object.prototype, G0 = U0.toString, K0 = Y0.hasOwnProperty, Z0 = RegExp(
  "^" + G0.call(K0).replace(q0, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Q0(e) {
  if (!z0(e) || B0(e))
    return !1;
  var t = L0(e) ? Z0 : H0;
  return t.test(W0(e));
}
var J0 = Q0;
function X0(e, t) {
  return e == null ? void 0 : e[t];
}
var eD = X0, tD = J0, nD = eD;
function rD(e, t) {
  var n = nD(e, t);
  return tD(n) ? n : void 0;
}
var zu = rD, oD = zu, iD = hi, aD = oD(iD, "Map"), Hh = aD, sD = zu, lD = sD(Object, "create"), Wl = lD, bf = Wl;
function cD() {
  this.__data__ = bf ? bf(null) : {}, this.size = 0;
}
var uD = cD;
function dD(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var fD = dD, pD = Wl, mD = "__lodash_hash_undefined__", hD = Object.prototype, gD = hD.hasOwnProperty;
function yD(e) {
  var t = this.__data__;
  if (pD) {
    var n = t[e];
    return n === mD ? void 0 : n;
  }
  return gD.call(t, e) ? t[e] : void 0;
}
var bD = yD, vD = Wl, CD = Object.prototype, wD = CD.hasOwnProperty;
function xD(e) {
  var t = this.__data__;
  return vD ? t[e] !== void 0 : wD.call(t, e);
}
var SD = xD, TD = Wl, _D = "__lodash_hash_undefined__";
function DD(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = TD && t === void 0 ? _D : t, this;
}
var PD = DD, OD = uD, kD = fD, MD = bD, ED = SD, ID = PD;
function gi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
gi.prototype.clear = OD;
gi.prototype.delete = kD;
gi.prototype.get = MD;
gi.prototype.has = ED;
gi.prototype.set = ID;
var RD = gi, vf = RD, AD = zl, $D = Hh;
function ND() {
  this.size = 0, this.__data__ = {
    hash: new vf(),
    map: new ($D || AD)(),
    string: new vf()
  };
}
var FD = ND;
function VD(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var jD = VD, LD = jD;
function BD(e, t) {
  var n = e.__data__;
  return LD(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var ql = BD, zD = ql;
function WD(e) {
  var t = zD(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var qD = WD, HD = ql;
function UD(e) {
  return HD(this, e).get(e);
}
var YD = UD, GD = ql;
function KD(e) {
  return GD(this, e).has(e);
}
var ZD = KD, QD = ql;
function JD(e, t) {
  var n = QD(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var XD = JD, eP = FD, tP = qD, nP = YD, rP = ZD, oP = XD;
function yi(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
yi.prototype.clear = eP;
yi.prototype.delete = tP;
yi.prototype.get = nP;
yi.prototype.has = rP;
yi.prototype.set = oP;
var iP = yi, aP = zl, sP = Hh, lP = iP, cP = 200;
function uP(e, t) {
  var n = this.__data__;
  if (n instanceof aP) {
    var r = n.__data__;
    if (!sP || r.length < cP - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new lP(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var dP = uP, fP = zl, pP = Q_, mP = X_, hP = t0, gP = r0, yP = dP;
function bi(e) {
  var t = this.__data__ = new fP(e);
  this.size = t.size;
}
bi.prototype.clear = pP;
bi.prototype.delete = mP;
bi.prototype.get = hP;
bi.prototype.has = gP;
bi.prototype.set = yP;
var bP = bi, vP = zu, CP = function() {
  try {
    var e = vP(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Uh = CP, Cf = Uh;
function wP(e, t, n) {
  t == "__proto__" && Cf ? Cf(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Wu = wP, xP = Wu, SP = Ll;
function TP(e, t, n) {
  (n !== void 0 && !SP(e[t], n) || n === void 0 && !(t in e)) && xP(e, t, n);
}
var Yh = TP;
function _P(e) {
  return function(t, n, r) {
    for (var o = -1, i = Object(t), s = r(t), l = s.length; l--; ) {
      var u = s[e ? l : ++o];
      if (n(i[u], u, i) === !1)
        break;
    }
    return t;
  };
}
var DP = _P, PP = DP, OP = PP(), kP = OP, il = { exports: {} };
il.exports;
(function(e, t) {
  var n = hi, r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, s = i ? n.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
  function u(c, d) {
    if (d)
      return c.slice();
    var m = c.length, f = l ? l(m) : new c.constructor(m);
    return c.copy(f), f;
  }
  e.exports = u;
})(il, il.exports);
var MP = il.exports, EP = hi, IP = EP.Uint8Array, RP = IP, wf = RP;
function AP(e) {
  var t = new e.constructor(e.byteLength);
  return new wf(t).set(new wf(e)), t;
}
var $P = AP, NP = $P;
function FP(e, t) {
  var n = t ? NP(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var VP = FP;
function jP(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var LP = jP, BP = Br, xf = Object.create, zP = function() {
  function e() {
  }
  return function(t) {
    if (!BP(t))
      return {};
    if (xf)
      return xf(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), WP = zP;
function qP(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var HP = qP, UP = HP, YP = UP(Object.getPrototypeOf, Object), Gh = YP, GP = Object.prototype;
function KP(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || GP;
  return e === n;
}
var Kh = KP, ZP = WP, QP = Gh, JP = Kh;
function XP(e) {
  return typeof e.constructor == "function" && !JP(e) ? ZP(QP(e)) : {};
}
var eO = XP;
function tO(e) {
  return e != null && typeof e == "object";
}
var vi = tO, nO = ms, rO = vi, oO = "[object Arguments]";
function iO(e) {
  return rO(e) && nO(e) == oO;
}
var aO = iO, Sf = aO, sO = vi, Zh = Object.prototype, lO = Zh.hasOwnProperty, cO = Zh.propertyIsEnumerable, uO = Sf(function() {
  return arguments;
}()) ? Sf : function(e) {
  return sO(e) && lO.call(e, "callee") && !cO.call(e, "callee");
}, Qh = uO, dO = Array.isArray, Jh = dO, fO = 9007199254740991;
function pO(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= fO;
}
var Xh = pO, mO = Bu, hO = Xh;
function gO(e) {
  return e != null && hO(e.length) && !mO(e);
}
var qu = gO, yO = qu, bO = vi;
function vO(e) {
  return bO(e) && yO(e);
}
var CO = vO, al = { exports: {} };
function wO() {
  return !1;
}
var xO = wO;
al.exports;
(function(e, t) {
  var n = hi, r = xO, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, s = i && i.exports === o, l = s ? n.Buffer : void 0, u = l ? l.isBuffer : void 0, c = u || r;
  e.exports = c;
})(al, al.exports);
var eg = al.exports, SO = ms, TO = Gh, _O = vi, DO = "[object Object]", PO = Function.prototype, OO = Object.prototype, tg = PO.toString, kO = OO.hasOwnProperty, MO = tg.call(Object);
function EO(e) {
  if (!_O(e) || SO(e) != DO)
    return !1;
  var t = TO(e);
  if (t === null)
    return !0;
  var n = kO.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && tg.call(n) == MO;
}
var IO = EO, RO = ms, AO = Xh, $O = vi, NO = "[object Arguments]", FO = "[object Array]", VO = "[object Boolean]", jO = "[object Date]", LO = "[object Error]", BO = "[object Function]", zO = "[object Map]", WO = "[object Number]", qO = "[object Object]", HO = "[object RegExp]", UO = "[object Set]", YO = "[object String]", GO = "[object WeakMap]", KO = "[object ArrayBuffer]", ZO = "[object DataView]", QO = "[object Float32Array]", JO = "[object Float64Array]", XO = "[object Int8Array]", ek = "[object Int16Array]", tk = "[object Int32Array]", nk = "[object Uint8Array]", rk = "[object Uint8ClampedArray]", ok = "[object Uint16Array]", ik = "[object Uint32Array]", pt = {};
pt[QO] = pt[JO] = pt[XO] = pt[ek] = pt[tk] = pt[nk] = pt[rk] = pt[ok] = pt[ik] = !0;
pt[NO] = pt[FO] = pt[KO] = pt[VO] = pt[ZO] = pt[jO] = pt[LO] = pt[BO] = pt[zO] = pt[WO] = pt[qO] = pt[HO] = pt[UO] = pt[YO] = pt[GO] = !1;
function ak(e) {
  return $O(e) && AO(e.length) && !!pt[RO(e)];
}
var sk = ak;
function lk(e) {
  return function(t) {
    return e(t);
  };
}
var ck = lk, sl = { exports: {} };
sl.exports;
(function(e, t) {
  var n = zh, r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, s = i && n.process, l = function() {
    try {
      var u = o && o.require && o.require("util").types;
      return u || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(sl, sl.exports);
var uk = sl.exports, dk = sk, fk = ck, Tf = uk, _f = Tf && Tf.isTypedArray, pk = _f ? fk(_f) : dk, ng = pk;
function mk(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var rg = mk, hk = Wu, gk = Ll, yk = Object.prototype, bk = yk.hasOwnProperty;
function vk(e, t, n) {
  var r = e[t];
  (!(bk.call(e, t) && gk(r, n)) || n === void 0 && !(t in e)) && hk(e, t, n);
}
var Ck = vk, wk = Ck, xk = Wu;
function Sk(e, t, n, r) {
  var o = !n;
  n || (n = {});
  for (var i = -1, s = t.length; ++i < s; ) {
    var l = t[i], u = r ? r(n[l], e[l], l, n, e) : void 0;
    u === void 0 && (u = e[l]), o ? xk(n, l, u) : wk(n, l, u);
  }
  return n;
}
var Tk = Sk;
function _k(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var og = _k, Dk = 9007199254740991, Pk = /^(?:0|[1-9]\d*)$/;
function Ok(e, t) {
  var n = typeof e;
  return t = t ?? Dk, !!t && (n == "number" || n != "symbol" && Pk.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ig = Ok, kk = og, Mk = Qh, Ek = Jh, Ik = eg, Rk = ig, Ak = ng, $k = Object.prototype, Nk = $k.hasOwnProperty;
function Fk(e, t) {
  var n = Ek(e), r = !n && Mk(e), o = !n && !r && Ik(e), i = !n && !r && !o && Ak(e), s = n || r || o || i, l = s ? kk(e.length, String) : [], u = l.length;
  for (var c in e)
    (t || Nk.call(e, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    Rk(c, u))) && l.push(c);
  return l;
}
var Vk = Fk;
function jk(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var Lk = jk, Bk = Br, zk = Kh, Wk = Lk, qk = Object.prototype, Hk = qk.hasOwnProperty;
function Uk(e) {
  if (!Bk(e))
    return Wk(e);
  var t = zk(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !Hk.call(e, r)) || n.push(r);
  return n;
}
var Yk = Uk, Gk = Vk, Kk = Yk, Zk = qu;
function Qk(e) {
  return Zk(e) ? Gk(e, !0) : Kk(e);
}
var ag = Qk, Jk = Tk, Xk = ag;
function eM(e) {
  return Jk(e, Xk(e));
}
var tM = eM, Df = Yh, nM = MP, rM = VP, oM = LP, iM = eO, Pf = Qh, Of = Jh, aM = CO, sM = eg, lM = Bu, cM = Br, uM = IO, dM = ng, kf = rg, fM = tM;
function pM(e, t, n, r, o, i, s) {
  var l = kf(e, n), u = kf(t, n), c = s.get(u);
  if (c) {
    Df(e, n, c);
    return;
  }
  var d = i ? i(l, u, n + "", e, t, s) : void 0, m = d === void 0;
  if (m) {
    var f = Of(u), p = !f && sM(u), b = !f && !p && dM(u);
    d = u, f || p || b ? Of(l) ? d = l : aM(l) ? d = oM(l) : p ? (m = !1, d = nM(u, !0)) : b ? (m = !1, d = rM(u, !0)) : d = [] : uM(u) || Pf(u) ? (d = l, Pf(l) ? d = fM(l) : (!cM(l) || lM(l)) && (d = iM(u))) : m = !1;
  }
  m && (s.set(u, d), o(d, u, r, i, s), s.delete(u)), Df(e, n, d);
}
var mM = pM, hM = bP, gM = Yh, yM = kP, bM = mM, vM = Br, CM = ag, wM = rg;
function sg(e, t, n, r, o) {
  e !== t && yM(t, function(i, s) {
    if (o || (o = new hM()), vM(i))
      bM(e, t, s, n, sg, r, o);
    else {
      var l = r ? r(wM(e, s), i, s + "", e, t, o) : void 0;
      l === void 0 && (l = i), gM(e, s, l);
    }
  }, CM);
}
var xM = sg;
function SM(e) {
  return e;
}
var Hu = SM;
function TM(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var _M = TM, DM = _M, Mf = Math.max;
function PM(e, t, n) {
  return t = Mf(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, o = -1, i = Mf(r.length - t, 0), s = Array(i); ++o < i; )
      s[o] = r[t + o];
    o = -1;
    for (var l = Array(t + 1); ++o < t; )
      l[o] = r[o];
    return l[t] = n(s), DM(e, this, l);
  };
}
var OM = PM;
function kM(e) {
  return function() {
    return e;
  };
}
var MM = kM, EM = MM, Ef = Uh, IM = Hu, RM = Ef ? function(e, t) {
  return Ef(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: EM(t),
    writable: !0
  });
} : IM, AM = RM, $M = 800, NM = 16, FM = Date.now;
function VM(e) {
  var t = 0, n = 0;
  return function() {
    var r = FM(), o = NM - (r - n);
    if (n = r, o > 0) {
      if (++t >= $M)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var jM = VM, LM = AM, BM = jM, zM = BM(LM), WM = zM, qM = Hu, HM = OM, UM = WM;
function YM(e, t) {
  return UM(HM(e, t, qM), e + "");
}
var GM = YM, KM = Ll, ZM = qu, QM = ig, JM = Br;
function XM(e, t, n) {
  if (!JM(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? ZM(n) && QM(t, n.length) : r == "string" && t in n) ? KM(n[t], e) : !1;
}
var e1 = XM, t1 = GM, n1 = e1;
function r1(e) {
  return t1(function(t, n) {
    var r = -1, o = n.length, i = o > 1 ? n[o - 1] : void 0, s = o > 2 ? n[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (o--, i) : void 0, s && n1(n[0], n[1], s) && (i = o < 3 ? void 0 : i, o = 1), t = Object(t); ++r < o; ) {
      var l = n[r];
      l && e(t, l, r, i);
    }
    return t;
  });
}
var o1 = r1, i1 = xM, a1 = o1, s1 = a1(function(e, t, n) {
  i1(e, t, n);
}), l1 = s1;
const ll = /* @__PURE__ */ Mt(l1), { palette: { augmentColor: c1 } } = jm({}), en = (e, t = "primary", n = e == null ? void 0 : e.primary) => {
  let r = Qd(e, t);
  if (!r)
    return n;
  if (typeof r == "string" && (r = { main: r }), !r.contrastText) {
    const o = Qd(r, "main");
    r = c1({ color: { main: o } });
  }
  return r.main ? r : { main: r };
}, u1 = (e) => {
  const { custom: t, grey: n, background: r, text: o, shape: i } = e ?? {}, s = t == null ? void 0 : t.reduce((l, u, c) => (l[u.name.replace(/\s/g, "")] = {
    ...en(e, `custom.${c}.value`)
  }, l), {});
  return dt(s, Object.keys(n || {}).reduce((l, u) => (l[`grey_${u}`] = {
    ...en(e, `grey.${u}`)
  }, l), {})), dt(s, Object.keys(r || {}).reduce((l, u) => (l[`background_${u}`] = {
    ...en(e, `background.${u}`)
  }, l), {})), dt(s, Object.keys(i || {}).reduce((l, u) => (l[`shape_${u}`] = {
    ...en(e, `shape.${u}`)
  }, l), {})), dt(s, Object.keys(o || {}).reduce((l, u) => (l[`text_${u}`] = {
    ...en(e, `text.${u}`)
  }, l), {})), s;
};
var lg = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    return function(n, r) {
      var o = r.prototype, i = o.format;
      o.format = function(s) {
        var l = this, u = this.$locale();
        if (!this.isValid())
          return i.bind(this)(s);
        var c = this.$utils(), d = (s || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(m) {
          switch (m) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return u.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return u.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return c.s(l.week(), m === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return c.s(l.isoWeek(), m === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return c.s(String(l.$H === 0 ? 24 : l.$H), m === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return m;
          }
        });
        return i.bind(this)(d);
      };
    };
  });
})(lg);
var d1 = lg.exports;
const f1 = /* @__PURE__ */ Mt(d1);
var cg = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d\d/, i = /\d\d?/, s = /\d*[^-_:/,()\s\d]+/, l = {}, u = function(g) {
      return (g = +g) + (g > 68 ? 1900 : 2e3);
    }, c = function(g) {
      return function(S) {
        this[g] = +S;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
      (this.zone || (this.zone = {})).offset = function(S) {
        if (!S || S === "Z")
          return 0;
        var C = S.match(/([+-]|\d\d)/g), w = 60 * C[1] + (+C[2] || 0);
        return w === 0 ? 0 : C[0] === "+" ? -w : w;
      }(g);
    }], m = function(g) {
      var S = l[g];
      return S && (S.indexOf ? S : S.s.concat(S.f));
    }, f = function(g, S) {
      var C, w = l.meridiem;
      if (w) {
        for (var v = 1; v <= 24; v += 1)
          if (g.indexOf(w(v, 0, S)) > -1) {
            C = v > 12;
            break;
          }
      } else
        C = g === (S ? "pm" : "PM");
      return C;
    }, p = { A: [s, function(g) {
      this.afternoon = f(g, !1);
    }], a: [s, function(g) {
      this.afternoon = f(g, !0);
    }], S: [/\d/, function(g) {
      this.milliseconds = 100 * +g;
    }], SS: [o, function(g) {
      this.milliseconds = 10 * +g;
    }], SSS: [/\d{3}/, function(g) {
      this.milliseconds = +g;
    }], s: [i, c("seconds")], ss: [i, c("seconds")], m: [i, c("minutes")], mm: [i, c("minutes")], H: [i, c("hours")], h: [i, c("hours")], HH: [i, c("hours")], hh: [i, c("hours")], D: [i, c("day")], DD: [o, c("day")], Do: [s, function(g) {
      var S = l.ordinal, C = g.match(/\d+/);
      if (this.day = C[0], S)
        for (var w = 1; w <= 31; w += 1)
          S(w).replace(/\[|\]/g, "") === g && (this.day = w);
    }], M: [i, c("month")], MM: [o, c("month")], MMM: [s, function(g) {
      var S = m("months"), C = (m("monthsShort") || S.map(function(w) {
        return w.slice(0, 3);
      })).indexOf(g) + 1;
      if (C < 1)
        throw new Error();
      this.month = C % 12 || C;
    }], MMMM: [s, function(g) {
      var S = m("months").indexOf(g) + 1;
      if (S < 1)
        throw new Error();
      this.month = S % 12 || S;
    }], Y: [/[+-]?\d+/, c("year")], YY: [o, function(g) {
      this.year = u(g);
    }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
    function b(g) {
      var S, C;
      S = g, C = l && l.formats;
      for (var w = (g = S.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(P, F, A) {
        var B = A && A.toUpperCase();
        return F || C[A] || n[A] || C[B].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(W, M, _) {
          return M || _.slice(1);
        });
      })).match(r), v = w.length, x = 0; x < v; x += 1) {
        var T = w[x], E = p[T], k = E && E[0], I = E && E[1];
        w[x] = I ? { regex: k, parser: I } : T.replace(/^\[|\]$/g, "");
      }
      return function(P) {
        for (var F = {}, A = 0, B = 0; A < v; A += 1) {
          var W = w[A];
          if (typeof W == "string")
            B += W.length;
          else {
            var M = W.regex, _ = W.parser, O = P.slice(B), R = M.exec(O)[0];
            _.call(F, R), P = P.replace(R, "");
          }
        }
        return function(N) {
          var L = N.afternoon;
          if (L !== void 0) {
            var $ = N.hours;
            L ? $ < 12 && (N.hours += 12) : $ === 12 && (N.hours = 0), delete N.afternoon;
          }
        }(F), F;
      };
    }
    return function(g, S, C) {
      C.p.customParseFormat = !0, g && g.parseTwoDigitYear && (u = g.parseTwoDigitYear);
      var w = S.prototype, v = w.parse;
      w.parse = function(x) {
        var T = x.date, E = x.utc, k = x.args;
        this.$u = E;
        var I = k[1];
        if (typeof I == "string") {
          var P = k[2] === !0, F = k[3] === !0, A = P || F, B = k[2];
          F && (B = k[2]), l = this.$locale(), !P && B && (l = C.Ls[B]), this.$d = function(O, R, N) {
            try {
              if (["x", "X"].indexOf(R) > -1)
                return new Date((R === "X" ? 1e3 : 1) * O);
              var L = b(R)(O), $ = L.year, H = L.month, G = L.day, q = L.hours, Y = L.minutes, Z = L.seconds, ie = L.milliseconds, X = L.zone, se = /* @__PURE__ */ new Date(), fe = G || ($ || H ? 1 : se.getDate()), le = $ || se.getFullYear(), ce = 0;
              $ && !H || (ce = H > 0 ? H - 1 : se.getMonth());
              var ee = q || 0, ae = Y || 0, _e = Z || 0, ue = ie || 0;
              return X ? new Date(Date.UTC(le, ce, fe, ee, ae, _e, ue + 60 * X.offset * 1e3)) : N ? new Date(Date.UTC(le, ce, fe, ee, ae, _e, ue)) : new Date(le, ce, fe, ee, ae, _e, ue);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(T, I, E), this.init(), B && B !== !0 && (this.$L = this.locale(B).$L), A && T != this.format(I) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
        } else if (I instanceof Array)
          for (var W = I.length, M = 1; M <= W; M += 1) {
            k[1] = I[M - 1];
            var _ = C.apply(this, k);
            if (_.isValid()) {
              this.$d = _.$d, this.$L = _.$L, this.init();
              break;
            }
            M === W && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          v.call(this, x);
      };
    };
  });
})(cg);
var p1 = cg.exports;
const m1 = /* @__PURE__ */ Mt(p1);
var ug = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = "day";
    return function(r, o, i) {
      var s = function(c) {
        return c.add(4 - c.isoWeekday(), n);
      }, l = o.prototype;
      l.isoWeekYear = function() {
        return s(this).year();
      }, l.isoWeek = function(c) {
        if (!this.$utils().u(c))
          return this.add(7 * (c - this.isoWeek()), n);
        var d, m, f, p, b = s(this), g = (d = this.isoWeekYear(), m = this.$u, f = (m ? i.utc : i)().year(d).startOf("year"), p = 4 - f.isoWeekday(), f.isoWeekday() > 4 && (p += 7), f.add(p, n));
        return b.diff(g, "week") + 1;
      }, l.isoWeekday = function(c) {
        return this.$utils().u(c) ? this.day() || 7 : this.day(this.day() % 7 ? c : c - 7);
      };
      var u = l.startOf;
      l.startOf = function(c, d) {
        var m = this.$utils(), f = !!m.u(d) || d;
        return m.p(c) === "isoweek" ? f ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : u.bind(this)(c, d);
      };
    };
  });
})(ug);
var h1 = ug.exports;
const g1 = /* @__PURE__ */ Mt(h1);
var dg = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, o, i) {
      var s = o.prototype, l = s.format;
      i.en.formats = n, s.format = function(u) {
        u === void 0 && (u = "YYYY-MM-DDTHH:mm:ssZ");
        var c = this.$locale().formats, d = function(m, f) {
          return m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(p, b, g) {
            var S = g && g.toUpperCase();
            return b || f[g] || n[g] || f[S].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(C, w, v) {
              return w || v.slice(1);
            });
          });
        }(u, c === void 0 ? {} : c);
        return l.call(this, d);
      };
    };
  });
})(dg);
var y1 = dg.exports;
const b1 = /* @__PURE__ */ Mt(y1);
var fg = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(ot, function() {
    var n = "month", r = "quarter";
    return function(o, i) {
      var s = i.prototype;
      s.quarter = function(c) {
        return this.$utils().u(c) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (c - 1));
      };
      var l = s.add;
      s.add = function(c, d) {
        return c = Number(c), this.$utils().p(d) === r ? this.add(3 * c, n) : l.bind(this)(c, d);
      };
      var u = s.startOf;
      s.startOf = function(c, d) {
        var m = this.$utils(), f = !!m.u(d) || d;
        if (m.p(c) === r) {
          var p = this.quarter() - 1;
          return f ? this.month(3 * p).startOf(n).startOf("day") : this.month(3 * p + 2).endOf(n).endOf("day");
        }
        return u.bind(this)(c, d);
      };
    };
  });
})(fg);
var v1 = fg.exports;
const C1 = /* @__PURE__ */ Mt(v1);
Ye.extend(f1);
Ye.extend(C1);
Ye.extend(b1);
Ye.extend(m1);
Ye.extend(g1);
const w1 = {
  datetime: "MMM D, YYYY, h:mm:ss a",
  millisecond: "h:mm:ss.SSS a",
  second: "h:mm:ss a",
  minute: "h:mm a",
  hour: "hA",
  day: "MMM D",
  week: "ll",
  month: "MMM YYYY",
  quarter: "[Q]Q - YYYY",
  year: "YYYY"
};
Vv._date.override({
  formats: () => w1,
  parse: function(e, t) {
    const n = typeof e;
    return e === null || n === "undefined" ? null : n === "string" && typeof t == "string" ? Ye(e, t).isValid() ? Ye(e, t).valueOf() : null : e instanceof Ye ? null : Ye(e).isValid() ? Ye(e).valueOf() : null;
  },
  format: function(e, t) {
    return Ye(e).format(t);
  },
  add: function(e, t, n) {
    return Ye(e).add(t, n).valueOf();
  },
  diff: function(e, t, n) {
    return Ye(e).diff(Ye(t), n);
  },
  startOf: function(e, t, n) {
    if (t === "isoWeek") {
      const r = typeof n == "number" && n > 0 && n < 7 ? n : 1;
      return Ye(e).isoWeekday(r).startOf("day").valueOf();
    }
    return Ye(e).startOf(t).valueOf();
  },
  endOf: function(e, t) {
    return Ye(e).endOf(t).valueOf();
  }
});
const pg = {
  width: "100%",
  height: "400px",
  className: "chart-print-config"
}, x1 = {
  responsive: !0,
  scales: {
    x: { stacked: !0 },
    y: { stacked: !0 }
  },
  maintainAspectRatio: !1,
  layout: {
    padding: {
      top: 50
    }
  },
  plugins: {
    legend: {
      display: !1
    },
    tooltip: {
      filter: (e) => {
        const { backgroundColor: t } = e.element.options;
        return !(t === "transparent" || t === "#0000");
      }
    },
    datalabels: {
      anchor: "end",
      align: "center",
      display: !1
    }
  }
};
Ml.register(jv, Lv, Bv, zv, Wv, qv, Iu, Hv, Uv, Yv, Gv, Kv);
function nu({ ariaLabelledby: e, type: t, options: n, data: r, boxProps: o }) {
  const i = ll({}, pg, o), { typography: s } = qt();
  return it(() => {
    s && (Zv.font.family = s.fontFamily);
  }, [s]), r ? h(Be, { ...i, children: h(Fv, { type: t, options: n, data: r, "aria-labelledby": e, plugins: [Iu] }) }) : null;
}
function BY({ ariaLabelledby: e, options: t, data: n, boxProps: r = {}, uptrendColor: o, downTrendColor: i, totalColor: s, ...l }) {
  var F, A, B;
  const u = qt(), [c] = Ke(), { palette: d, presets: m } = u, f = en(d, (F = m == null ? void 0 : m.charts) == null ? void 0 : F.color1), p = en(d, (A = m == null ? void 0 : m.charts) == null ? void 0 : A.color2, d.secondary), b = en(d, (B = m == null ? void 0 : m.charts) == null ? void 0 : B.color3), g = o || f.main, S = i || p.main, C = s || b.main, w = Qe((W) => W < 0 ? S : g, [S, g]), { labels: v, datasets: [x] } = n, T = x.data, E = Ee(() => {
    const W = {
      data: [],
      backgroundColor: []
    };
    let M = 0, _ = 0;
    return T.forEach((O) => {
      M += O, W.data.push([_, M]), W.backgroundColor.push(w(O)), _ = M;
    }), W.data.push([0, M]), W.backgroundColor.push(C), W;
  }, [T, w, C]);
  v && v[v.length - 1] !== c("total") && v.push(c("total"));
  const k = { labels: v, datasets: [E] }, I = Ee(() => ll({
    options: {
      scales: {
        y: {
          ticks: {
            callback: (W) => c("common.currency", { value: W })
          }
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: (W) => {
            const M = W.raw;
            if (Array.isArray(M)) {
              const _ = M[1] - M[0];
              return ol(String(_), {
                thousandSeparator: !0,
                decimalScale: 2
              });
            }
            return ol(String(M), {
              thousandSeparator: !0,
              decimalScale: 2
            });
          }
        }
      }
    }
  }, x1, t), [t, c]), P = Ee(() => ll({}, pg, r, l), [r, l]);
  return h(Be, { ...P, children: h(nu, { type: "bar", options: I, data: k, plugins: [Iu], "aria-labelledby": e }) });
}
function z() {
  return z = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, z.apply(this, arguments);
}
function $e(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var ru = { exports: {} }, Rs = { exports: {} }, nt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var If;
function S1() {
  if (If)
    return nt;
  If = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function v(T) {
    if (typeof T == "object" && T !== null) {
      var E = T.$$typeof;
      switch (E) {
        case t:
          switch (T = T.type, T) {
            case u:
            case c:
            case r:
            case i:
            case o:
            case m:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case l:
                case d:
                case b:
                case p:
                case s:
                  return T;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function x(T) {
    return v(T) === c;
  }
  return nt.AsyncMode = u, nt.ConcurrentMode = c, nt.ContextConsumer = l, nt.ContextProvider = s, nt.Element = t, nt.ForwardRef = d, nt.Fragment = r, nt.Lazy = b, nt.Memo = p, nt.Portal = n, nt.Profiler = i, nt.StrictMode = o, nt.Suspense = m, nt.isAsyncMode = function(T) {
    return x(T) || v(T) === u;
  }, nt.isConcurrentMode = x, nt.isContextConsumer = function(T) {
    return v(T) === l;
  }, nt.isContextProvider = function(T) {
    return v(T) === s;
  }, nt.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, nt.isForwardRef = function(T) {
    return v(T) === d;
  }, nt.isFragment = function(T) {
    return v(T) === r;
  }, nt.isLazy = function(T) {
    return v(T) === b;
  }, nt.isMemo = function(T) {
    return v(T) === p;
  }, nt.isPortal = function(T) {
    return v(T) === n;
  }, nt.isProfiler = function(T) {
    return v(T) === i;
  }, nt.isStrictMode = function(T) {
    return v(T) === o;
  }, nt.isSuspense = function(T) {
    return v(T) === m;
  }, nt.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === r || T === c || T === i || T === o || T === m || T === f || typeof T == "object" && T !== null && (T.$$typeof === b || T.$$typeof === p || T.$$typeof === s || T.$$typeof === l || T.$$typeof === d || T.$$typeof === S || T.$$typeof === C || T.$$typeof === w || T.$$typeof === g);
  }, nt.typeOf = v, nt;
}
var rt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rf;
function T1() {
  return Rf || (Rf = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, S = e ? Symbol.for("react.fundamental") : 60117, C = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function v(ee) {
      return typeof ee == "string" || typeof ee == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      ee === r || ee === c || ee === i || ee === o || ee === m || ee === f || typeof ee == "object" && ee !== null && (ee.$$typeof === b || ee.$$typeof === p || ee.$$typeof === s || ee.$$typeof === l || ee.$$typeof === d || ee.$$typeof === S || ee.$$typeof === C || ee.$$typeof === w || ee.$$typeof === g);
    }
    function x(ee) {
      if (typeof ee == "object" && ee !== null) {
        var ae = ee.$$typeof;
        switch (ae) {
          case t:
            var _e = ee.type;
            switch (_e) {
              case u:
              case c:
              case r:
              case i:
              case o:
              case m:
                return _e;
              default:
                var ue = _e && _e.$$typeof;
                switch (ue) {
                  case l:
                  case d:
                  case b:
                  case p:
                  case s:
                    return ue;
                  default:
                    return ae;
                }
            }
          case n:
            return ae;
        }
      }
    }
    var T = u, E = c, k = l, I = s, P = t, F = d, A = r, B = b, W = p, M = n, _ = i, O = o, R = m, N = !1;
    function L(ee) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(ee) || x(ee) === u;
    }
    function $(ee) {
      return x(ee) === c;
    }
    function H(ee) {
      return x(ee) === l;
    }
    function G(ee) {
      return x(ee) === s;
    }
    function q(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === t;
    }
    function Y(ee) {
      return x(ee) === d;
    }
    function Z(ee) {
      return x(ee) === r;
    }
    function ie(ee) {
      return x(ee) === b;
    }
    function X(ee) {
      return x(ee) === p;
    }
    function se(ee) {
      return x(ee) === n;
    }
    function fe(ee) {
      return x(ee) === i;
    }
    function le(ee) {
      return x(ee) === o;
    }
    function ce(ee) {
      return x(ee) === m;
    }
    rt.AsyncMode = T, rt.ConcurrentMode = E, rt.ContextConsumer = k, rt.ContextProvider = I, rt.Element = P, rt.ForwardRef = F, rt.Fragment = A, rt.Lazy = B, rt.Memo = W, rt.Portal = M, rt.Profiler = _, rt.StrictMode = O, rt.Suspense = R, rt.isAsyncMode = L, rt.isConcurrentMode = $, rt.isContextConsumer = H, rt.isContextProvider = G, rt.isElement = q, rt.isForwardRef = Y, rt.isFragment = Z, rt.isLazy = ie, rt.isMemo = X, rt.isPortal = se, rt.isProfiler = fe, rt.isStrictMode = le, rt.isSuspense = ce, rt.isValidElementType = v, rt.typeOf = x;
  }()), rt;
}
var Af;
function mg() {
  return Af || (Af = 1, process.env.NODE_ENV === "production" ? Rs.exports = S1() : Rs.exports = T1()), Rs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var yc, $f;
function _1() {
  if ($f)
    return yc;
  $f = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, l = 0; l < 10; l++)
        s["_" + String.fromCharCode(l)] = l;
      var u = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return yc = o() ? Object.assign : function(i, s) {
    for (var l, u = r(i), c, d = 1; d < arguments.length; d++) {
      l = Object(arguments[d]);
      for (var m in l)
        t.call(l, m) && (u[m] = l[m]);
      if (e) {
        c = e(l);
        for (var f = 0; f < c.length; f++)
          n.call(l, c[f]) && (u[c[f]] = l[c[f]]);
      }
    }
    return u;
  }, yc;
}
var bc, Nf;
function Uu() {
  if (Nf)
    return bc;
  Nf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return bc = e, bc;
}
var vc, Ff;
function hg() {
  return Ff || (Ff = 1, vc = Function.call.bind(Object.prototype.hasOwnProperty)), vc;
}
var Cc, Vf;
function D1() {
  if (Vf)
    return Cc;
  Vf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Uu(), n = {}, r = hg();
    e = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, l, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var m;
          try {
            if (typeof i[d] != "function") {
              var f = Error(
                (u || "React class") + ": " + l + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            m = i[d](s, d, u, l, null, t);
          } catch (b) {
            m = b;
          }
          if (m && !(m instanceof Error) && e(
            (u || "React class") + ": type specification of " + l + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + l + " type: " + m.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Cc = o, Cc;
}
var wc, jf;
function P1() {
  if (jf)
    return wc;
  jf = 1;
  var e = mg(), t = _1(), n = Uu(), r = hg(), o = D1(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var u = "Warning: " + l;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return wc = function(l, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function m($) {
      var H = $ && (c && $[c] || $[d]);
      if (typeof H == "function")
        return H;
    }
    var f = "<<anonymous>>", p = {
      array: C("array"),
      bigint: C("bigint"),
      bool: C("boolean"),
      func: C("function"),
      number: C("number"),
      object: C("object"),
      string: C("string"),
      symbol: C("symbol"),
      any: w(),
      arrayOf: v,
      element: x(),
      elementType: T(),
      instanceOf: E,
      node: F(),
      objectOf: I,
      oneOf: k,
      oneOfType: P,
      shape: B,
      exact: W
    };
    function b($, H) {
      return $ === H ? $ !== 0 || 1 / $ === 1 / H : $ !== $ && H !== H;
    }
    function g($, H) {
      this.message = $, this.data = H && typeof H == "object" ? H : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function S($) {
      if (process.env.NODE_ENV !== "production")
        var H = {}, G = 0;
      function q(Z, ie, X, se, fe, le, ce) {
        if (se = se || f, le = le || X, ce !== n) {
          if (u) {
            var ee = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw ee.name = "Invariant Violation", ee;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ae = se + ":" + X;
            !H[ae] && // Avoid spamming the console because they are often not actionable except for lib authors
            G < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + le + "` prop on `" + se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), H[ae] = !0, G++);
          }
        }
        return ie[X] == null ? Z ? ie[X] === null ? new g("The " + fe + " `" + le + "` is marked as required " + ("in `" + se + "`, but its value is `null`.")) : new g("The " + fe + " `" + le + "` is marked as required in " + ("`" + se + "`, but its value is `undefined`.")) : null : $(ie, X, se, fe, le);
      }
      var Y = q.bind(null, !1);
      return Y.isRequired = q.bind(null, !0), Y;
    }
    function C($) {
      function H(G, q, Y, Z, ie, X) {
        var se = G[q], fe = O(se);
        if (fe !== $) {
          var le = R(se);
          return new g(
            "Invalid " + Z + " `" + ie + "` of type " + ("`" + le + "` supplied to `" + Y + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return S(H);
    }
    function w() {
      return S(s);
    }
    function v($) {
      function H(G, q, Y, Z, ie) {
        if (typeof $ != "function")
          return new g("Property `" + ie + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var X = G[q];
        if (!Array.isArray(X)) {
          var se = O(X);
          return new g("Invalid " + Z + " `" + ie + "` of type " + ("`" + se + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var fe = 0; fe < X.length; fe++) {
          var le = $(X, fe, Y, Z, ie + "[" + fe + "]", n);
          if (le instanceof Error)
            return le;
        }
        return null;
      }
      return S(H);
    }
    function x() {
      function $(H, G, q, Y, Z) {
        var ie = H[G];
        if (!l(ie)) {
          var X = O(ie);
          return new g("Invalid " + Y + " `" + Z + "` of type " + ("`" + X + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return S($);
    }
    function T() {
      function $(H, G, q, Y, Z) {
        var ie = H[G];
        if (!e.isValidElementType(ie)) {
          var X = O(ie);
          return new g("Invalid " + Y + " `" + Z + "` of type " + ("`" + X + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return S($);
    }
    function E($) {
      function H(G, q, Y, Z, ie) {
        if (!(G[q] instanceof $)) {
          var X = $.name || f, se = L(G[q]);
          return new g("Invalid " + Z + " `" + ie + "` of type " + ("`" + se + "` supplied to `" + Y + "`, expected ") + ("instance of `" + X + "`."));
        }
        return null;
      }
      return S(H);
    }
    function k($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function H(G, q, Y, Z, ie) {
        for (var X = G[q], se = 0; se < $.length; se++)
          if (b(X, $[se]))
            return null;
        var fe = JSON.stringify($, function(ce, ee) {
          var ae = R(ee);
          return ae === "symbol" ? String(ee) : ee;
        });
        return new g("Invalid " + Z + " `" + ie + "` of value `" + String(X) + "` " + ("supplied to `" + Y + "`, expected one of " + fe + "."));
      }
      return S(H);
    }
    function I($) {
      function H(G, q, Y, Z, ie) {
        if (typeof $ != "function")
          return new g("Property `" + ie + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var X = G[q], se = O(X);
        if (se !== "object")
          return new g("Invalid " + Z + " `" + ie + "` of type " + ("`" + se + "` supplied to `" + Y + "`, expected an object."));
        for (var fe in X)
          if (r(X, fe)) {
            var le = $(X, fe, Y, Z, ie + "." + fe, n);
            if (le instanceof Error)
              return le;
          }
        return null;
      }
      return S(H);
    }
    function P($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var H = 0; H < $.length; H++) {
        var G = $[H];
        if (typeof G != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + N(G) + " at index " + H + "."
          ), s;
      }
      function q(Y, Z, ie, X, se) {
        for (var fe = [], le = 0; le < $.length; le++) {
          var ce = $[le], ee = ce(Y, Z, ie, X, se, n);
          if (ee == null)
            return null;
          ee.data && r(ee.data, "expectedType") && fe.push(ee.data.expectedType);
        }
        var ae = fe.length > 0 ? ", expected one of type [" + fe.join(", ") + "]" : "";
        return new g("Invalid " + X + " `" + se + "` supplied to " + ("`" + ie + "`" + ae + "."));
      }
      return S(q);
    }
    function F() {
      function $(H, G, q, Y, Z) {
        return M(H[G]) ? null : new g("Invalid " + Y + " `" + Z + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return S($);
    }
    function A($, H, G, q, Y) {
      return new g(
        ($ || "React class") + ": " + H + " type `" + G + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function B($) {
      function H(G, q, Y, Z, ie) {
        var X = G[q], se = O(X);
        if (se !== "object")
          return new g("Invalid " + Z + " `" + ie + "` of type `" + se + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var fe in $) {
          var le = $[fe];
          if (typeof le != "function")
            return A(Y, Z, ie, fe, R(le));
          var ce = le(X, fe, Y, Z, ie + "." + fe, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return S(H);
    }
    function W($) {
      function H(G, q, Y, Z, ie) {
        var X = G[q], se = O(X);
        if (se !== "object")
          return new g("Invalid " + Z + " `" + ie + "` of type `" + se + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var fe = t({}, G[q], $);
        for (var le in fe) {
          var ce = $[le];
          if (r($, le) && typeof ce != "function")
            return A(Y, Z, ie, le, R(ce));
          if (!ce)
            return new g(
              "Invalid " + Z + " `" + ie + "` key `" + le + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(G[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var ee = ce(X, le, Y, Z, ie + "." + le, n);
          if (ee)
            return ee;
        }
        return null;
      }
      return S(H);
    }
    function M($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(M);
          if ($ === null || l($))
            return !0;
          var H = m($);
          if (H) {
            var G = H.call($), q;
            if (H !== $.entries) {
              for (; !(q = G.next()).done; )
                if (!M(q.value))
                  return !1;
            } else
              for (; !(q = G.next()).done; ) {
                var Y = q.value;
                if (Y && !M(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function _($, H) {
      return $ === "symbol" ? !0 : H ? H["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && H instanceof Symbol : !1;
    }
    function O($) {
      var H = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : _(H, $) ? "symbol" : H;
    }
    function R($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var H = O($);
      if (H === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return H;
    }
    function N($) {
      var H = R($);
      switch (H) {
        case "array":
        case "object":
          return "an " + H;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + H;
        default:
          return H;
      }
    }
    function L($) {
      return !$.constructor || !$.constructor.name ? f : $.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, wc;
}
var xc, Lf;
function O1() {
  if (Lf)
    return xc;
  Lf = 1;
  var e = Uu();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, xc = function() {
    function r(s, l, u, c, d, m) {
      if (m !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, xc;
}
if (process.env.NODE_ENV !== "production") {
  var k1 = mg(), M1 = !0;
  ru.exports = P1()(k1.isElement, M1);
} else
  ru.exports = O1()();
var E1 = ru.exports;
const a = /* @__PURE__ */ Mt(E1), I1 = a.oneOfType([a.func, a.object]), Tn = I1;
function Sc(e) {
  return e && e.ownerDocument || document;
}
function R1(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
const A1 = typeof window < "u" ? U.useLayoutEffect : U.useEffect, Ar = A1;
let Bf = 0;
function $1(e) {
  const [t, n] = U.useState(e), r = e || t;
  return U.useEffect(() => {
    t == null && (Bf += 1, n(`mui-${Bf}`));
  }, [t]), r;
}
const zf = U["useId".toString()];
function Hl(e) {
  if (zf !== void 0) {
    const t = zf();
    return e ?? t;
  }
  return $1(e);
}
function $r({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = U.useRef(e !== void 0), [i, s] = U.useState(t), l = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    U.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: c
    } = U.useRef(t);
    U.useEffect(() => {
      !o && c !== t && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const u = U.useCallback((c) => {
    o || s(c);
  }, []);
  return [l, u];
}
function Ae(e) {
  const t = U.useRef(e);
  return Ar(() => {
    t.current = e;
  }), U.useRef((...n) => (
    // @ts-expect-error hide `this`
    // tslint:disable-next-line:ban-comma-operator
    (0, t.current)(...n)
  )).current;
}
function nr(...e) {
  return U.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      R1(n, t);
    });
  }, e);
}
function st(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      r[o] = e[o].reduce((i, s) => {
        if (s) {
          const l = t(s);
          l !== "" && i.push(l), n && n[s] && i.push(n[s]);
        }
        return i;
      }, []).join(" ");
    }
  ), r;
}
const Wf = (e) => e, N1 = () => {
  let e = Wf;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = Wf;
    }
  };
}, F1 = N1(), V1 = F1, j1 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ut(e, t, n = "Mui") {
  const r = j1[t];
  return r ? `${n}-${r}` : `${V1.generate(e)}-${t}`;
}
function ft(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = ut(e, o, n);
  }), r;
}
function L1(e) {
  return typeof e == "string";
}
function B1(e, t, n) {
  return e === void 0 || L1(e) ? t : z({}, t, {
    ownerState: z({}, t.ownerState, n)
  });
}
function z1(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function zr(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function gg(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = gg(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function mt() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = gg(e)) && (r && (r += " "), r += t);
  return r;
}
function qf(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function W1(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const p = mt(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), b = z({}, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), g = z({}, n, o, r);
    return p.length > 0 && (g.className = p), Object.keys(b).length > 0 && (g.style = b), {
      props: g,
      internalRef: void 0
    };
  }
  const s = z1(z({}, o, r)), l = qf(r), u = qf(o), c = t(s), d = mt(c == null ? void 0 : c.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), m = z({}, c == null ? void 0 : c.style, n == null ? void 0 : n.style, o == null ? void 0 : o.style, r == null ? void 0 : r.style), f = z({}, c, n, u, l);
  return d.length > 0 && (f.className = d), Object.keys(m).length > 0 && (f.style = m), {
    props: f,
    internalRef: c.ref
  };
}
const q1 = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function xt(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: o,
    skipResolvingSlotProps: i = !1
  } = e, s = $e(e, q1), l = i ? {} : zr(r, o), {
    props: u,
    internalRef: c
  } = W1(z({}, s, {
    externalSlotProps: l
  })), d = nr(c, l == null ? void 0 : l.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return B1(n, z({}, u, {
    ref: d
  }), o);
}
const Zn = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), Yu = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: r
}) => {
  const o = n ?? r;
  let i;
  if (e != null)
    i = e;
  else if (o.includes(t))
    i = t;
  else if (o.length > 0)
    i = o[0];
  else
    throw new Error("MUI: The `views` prop must contain at least one view");
  return {
    views: o,
    openTo: i
  };
}, Ma = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: r,
  minDate: o,
  isDateDisabled: i,
  utils: s,
  timezone: l
}) => {
  const u = s.startOfDay(s.dateWithTimezone(void 0, l));
  n && s.isBefore(o, u) && (o = u), t && s.isAfter(r, u) && (r = u);
  let c = e, d = e;
  for (s.isBefore(e, o) && (c = o, d = null), s.isAfter(e, r) && (d && (d = r), c = null); c || d; ) {
    if (c && s.isAfter(c, r) && (c = null), d && s.isBefore(d, o) && (d = null), c) {
      if (!i(c))
        return c;
      c = s.addDays(c, 1);
    }
    if (d) {
      if (!i(d))
        return d;
      d = s.addDays(d, -1);
    }
  }
  return null;
}, H1 = (e, t) => t == null || !e.isValid(t) ? null : t, Gt = (e, t, n) => t == null || !e.isValid(t) ? n : t, U1 = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), Gu = (e, t) => {
  const r = [e.startOfYear(t)];
  for (; r.length < 12; ) {
    const o = r[r.length - 1];
    r.push(e.addMonths(o, 1));
  }
  return r;
}, ou = (e, t, n) => {
  let r = t;
  return r = e.setHours(r, e.getHours(n)), r = e.setMinutes(r, e.getMinutes(n)), r = e.setSeconds(r, e.getSeconds(n)), r;
}, Ku = (e, t, n) => n === "date" ? e.startOfDay(e.dateWithTimezone(void 0, t)) : e.dateWithTimezone(void 0, t), $n = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, Y1 = ["year", "month", "day"], Uo = (e) => Y1.includes(e), Qa = (e, {
  format: t,
  views: n
}, r) => {
  if (t != null)
    return t;
  const o = e.formats;
  return Zn(n, ["year"]) ? o.year : Zn(n, ["month"]) ? o.month : Zn(n, ["day"]) ? o.dayOfMonth : Zn(n, ["month", "year"]) ? `${o.month} ${o.year}` : Zn(n, ["day", "month"]) ? `${o.month} ${o.dayOfMonth}` : r ? /en/.test(e.getCurrentLocaleCode()) ? o.normalDateWithWeekday : o.normalDate : o.keyboardDate;
}, G1 = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((r) => e.addDays(n, r));
}, yg = ["hours", "minutes", "seconds"], ni = (e) => yg.includes(e), _r = (e) => yg.includes(e) || e === "meridiem", K1 = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, Ja = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, Z1 = (e, t, n, r) => {
  const o = Ja(r.getHours(e), t, n);
  return r.setHours(e, o);
}, Hf = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), hs = (e, t) => (n, r) => e ? t.isAfter(n, r) : Hf(n, t) > Hf(r, t), cl = (e, {
  format: t,
  views: n,
  ampm: r
}) => {
  if (t != null)
    return t;
  const o = e.formats;
  return Zn(n, ["hours"]) ? r ? `${o.hours12h} ${o.meridiem}` : o.hours24h : Zn(n, ["minutes"]) ? o.minutes : Zn(n, ["seconds"]) ? o.seconds : Zn(n, ["minutes", "seconds"]) ? `${o.minutes}:${o.seconds}` : Zn(n, ["hours", "minutes", "seconds"]) ? r ? `${o.hours12h}:${o.minutes}:${o.seconds} ${o.meridiem}` : `${o.hours24h}:${o.minutes}:${o.seconds}` : r ? `${o.hours12h}:${o.minutes} ${o.meridiem}` : `${o.hours24h}:${o.minutes}`;
}, Rn = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, Q1 = (e) => Math.max(...e.map((t) => {
  var n;
  return (n = Rn[t.type]) != null ? n : 1;
})), ma = (e, t, n) => {
  if (t === Rn.year)
    return e.startOfYear(n);
  if (t === Rn.month)
    return e.startOfMonth(n);
  if (t === Rn.day)
    return e.startOfDay(n);
  let r = n;
  return t < Rn.minutes && (r = e.setMinutes(r, 0)), t < Rn.seconds && (r = e.setSeconds(r, 0)), t < Rn.milliseconds && (r = e.setMilliseconds(r, 0)), r;
}, J1 = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: r,
  getTodayDate: o
}) => {
  var i;
  let s = o ? o() : ma(t, n, Ku(t, r));
  e.minDate != null && t.isAfterDay(e.minDate, s) && (s = ma(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, s) && (s = ma(t, n, e.maxDate));
  const l = hs((i = e.disableIgnoringDatePartForTimeValidation) != null ? i : !1, t);
  return e.minTime != null && l(e.minTime, s) && (s = ma(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : ou(t, s, e.minTime))), e.maxTime != null && l(s, e.maxTime) && (s = ma(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : ou(t, s, e.maxTime))), s;
}, Zu = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, X1 = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, Ul = (e, t, n) => {
  const r = [], o = e.dateWithTimezone(void 0, t), i = e.startOfWeek(o), s = e.endOfWeek(o);
  let l = i;
  for (; e.isBefore(l, s); )
    r.push(l), l = e.addDays(l, 1);
  return r.map((u) => e.formatByString(u, n));
}, bg = (e, t, n, r) => {
  switch (n) {
    case "month":
      return Gu(e, e.dateWithTimezone(void 0, t)).map((o) => e.formatByString(o, r));
    case "weekDay":
      return Ul(e, t, r);
    case "meridiem": {
      const o = e.dateWithTimezone(void 0, t);
      return [e.startOfDay(o), e.endOfDay(o)].map((i) => e.formatByString(i, r));
    }
    default:
      return [];
  }
}, vg = (e, t, n) => {
  let r = t;
  for (r = Number(r).toString(); r.length < n; )
    r = `0${r}`;
  return r;
}, Cg = (e, t, n, r, o) => {
  if (process.env.NODE_ENV !== "production" && o.type !== "day" && o.contentType === "digit-with-letter")
    throw new Error([`MUI: The token "${o.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (o.type === "day" && o.contentType === "digit-with-letter") {
    const s = e.setDate(r.longestMonth, n);
    return e.formatByString(s, o.format);
  }
  const i = n.toString();
  return o.hasLeadingZerosInInput ? vg(e, i, o.maxLength) : i;
}, eE = (e, t, n, r, o, i, s) => {
  const l = X1(r), u = r === "Home", c = r === "End", d = n.value === "" || u || c, m = () => {
    const p = o[n.type]({
      currentDate: i,
      format: n.format,
      contentType: n.contentType
    }), b = (w) => Cg(e, t, w, p, n), g = n.type === "minutes" && s != null && s.minutesStep ? s.minutesStep : 1;
    let C = parseInt(n.value, 10) + l * g;
    if (d) {
      if (n.type === "year" && !c && !u)
        return e.formatByString(e.dateWithTimezone(void 0, t), n.format);
      l > 0 || u ? C = p.minimum : C = p.maximum;
    }
    return C % g !== 0 && ((l < 0 || u) && (C += g - (g + C) % g), (l > 0 || c) && (C -= C % g)), C > p.maximum ? b(p.minimum + (C - p.maximum - 1) % (p.maximum - p.minimum + 1)) : C < p.minimum ? b(p.maximum - (p.minimum - C - 1) % (p.maximum - p.minimum + 1)) : b(C);
  }, f = () => {
    const p = bg(e, t, n.type, n.format);
    if (p.length === 0)
      return n.value;
    if (d)
      return l > 0 || u ? p[0] : p[p.length - 1];
    const g = (p.indexOf(n.value) + p.length + l) % p.length;
    return p[g];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? m() : f();
}, Qu = (e, t) => {
  let n = e.value || e.placeholder;
  const r = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (n = Number(n).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !r && n.length === 1 && (n = `${n}‎`), t === "input-rtl" && (n = `⁨${n}⁩`), n;
}, Wo = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), wg = (e, t) => {
  let n = 0, r = t ? 1 : 0;
  const o = [];
  for (let i = 0; i < e.length; i += 1) {
    const s = e[i], l = Qu(s, t ? "input-rtl" : "input-ltr"), u = `${s.startSeparator}${l}${s.endSeparator}`, c = Wo(u).length, d = u.length, m = Wo(l), f = r + l.indexOf(m[0]) + s.startSeparator.length, p = f + m.length;
    o.push(z({}, s, {
      start: n,
      end: n + c,
      startInInput: f,
      endInInput: p
    })), n += c, r += d;
  }
  return o;
}, tE = (e, t, n, r, o) => {
  switch (r.type) {
    case "year":
      return n.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.dateWithTimezone(void 0, t), o).length,
        format: o
      });
    case "month":
      return n.fieldMonthPlaceholder({
        contentType: r.contentType,
        format: o
      });
    case "day":
      return n.fieldDayPlaceholder({
        format: o
      });
    case "weekDay":
      return n.fieldWeekDayPlaceholder({
        contentType: r.contentType,
        format: o
      });
    case "hours":
      return n.fieldHoursPlaceholder({
        format: o
      });
    case "minutes":
      return n.fieldMinutesPlaceholder({
        format: o
      });
    case "seconds":
      return n.fieldSecondsPlaceholder({
        format: o
      });
    case "meridiem":
      return n.fieldMeridiemPlaceholder({
        format: o
      });
    default:
      return o;
  }
}, Uf = (e, t, n, r) => {
  if (process.env.NODE_ENV !== "production" && Zu(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), r);
}, xg = (e, t, n) => e.formatByString(e.dateWithTimezone(void 0, t), n).length === 4, Sg = (e, t, n, r, o) => {
  if (n !== "digit")
    return !1;
  const i = e.dateWithTimezone(void 0, t);
  switch (r) {
    case "year":
      return xg(e, t, o) ? e.formatByString(e.setYear(i, 1), o) === "0001" : e.formatByString(e.setYear(i, 2001), o) === "01";
    case "month":
      return e.formatByString(e.startOfYear(i), o).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(i), o).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(i), o).length > 1;
    case "hours":
      return e.formatByString(e.setHours(i, 1), o).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(i, 1), o).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(i, 1), o).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, nE = (e, t) => {
  const n = [], {
    start: r,
    end: o
  } = e.escapedCharacters, i = new RegExp(`(\\${r}[^\\${o}]*\\${o})+`, "g");
  let s = null;
  for (; s = i.exec(t); )
    n.push({
      start: s.index,
      end: i.lastIndex - 1
    });
  return n;
}, Yf = (e, t, n, r, o, i, s, l) => {
  let u = "";
  const c = [], d = e.date(), m = (v) => {
    if (v === "")
      return null;
    const x = Zu(e, v), T = Sg(e, t, x.contentType, x.type, v), E = s ? T : x.contentType === "digit", k = o != null && e.isValid(o);
    let I = k ? e.formatByString(o, v) : "", P = null;
    if (E)
      if (T)
        P = I === "" ? e.formatByString(d, v).length : I.length;
      else {
        if (x.maxLength == null)
          throw new Error(`MUI: The token ${v} should have a 'maxDigitNumber' property on it's adapter`);
        P = x.maxLength, k && (I = vg(e, I, P));
      }
    return c.push(z({}, x, {
      format: v,
      maxLength: P,
      value: I,
      placeholder: tE(e, t, n, x, v),
      hasLeadingZeros: T,
      hasLeadingZerosInFormat: T,
      hasLeadingZerosInInput: E,
      startSeparator: c.length === 0 ? u : "",
      endSeparator: "",
      modified: !1
    })), null;
  };
  let f = 10, p = r, b = e.expandFormat(r);
  for (; b !== p; )
    if (p = b, b = e.expandFormat(p), f -= 1, f < 0)
      throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
  const g = b, S = nE(e, g), C = new RegExp(`^(${Object.keys(e.formatTokenMap).sort((v, x) => x.length - v.length).join("|")})`, "g");
  let w = "";
  for (let v = 0; v < g.length; v += 1) {
    const x = S.find((P) => P.start <= v && P.end >= v), T = g[v], E = x != null, k = `${w}${g.slice(v)}`, I = C.test(k);
    !E && T.match(/([A-Za-z]+)/) && I ? (w = k.slice(0, C.lastIndex), v += C.lastIndex - 1) : E && (x == null ? void 0 : x.start) === v || (x == null ? void 0 : x.end) === v || (m(w), w = "", c.length === 0 ? u += T : c[c.length - 1].endSeparator += T);
  }
  return m(w), c.map((v) => {
    const x = (T) => {
      let E = T;
      return l && E !== null && E.includes(" ") && (E = `⁩${E}⁦`), i === "spacious" && ["/", ".", "-"].includes(E) && (E = ` ${E} `), E;
    };
    return v.startSeparator = x(v.startSeparator), v.endSeparator = x(v.endSeparator), v;
  });
}, rE = (e, t) => {
  const n = t.some((l) => l.type === "day"), r = [], o = [];
  for (let l = 0; l < t.length; l += 1) {
    const u = t[l];
    n && u.type === "weekDay" || (r.push(u.format), o.push(Qu(u, "non-input")));
  }
  const i = r.join(" "), s = o.join(" ");
  return e.parse(s, i);
}, oE = (e, t) => {
  const r = e.map((o) => {
    const i = Qu(o, t ? "input-rtl" : "input-ltr");
    return `${o.startSeparator}${i}${o.endSeparator}`;
  }).join("");
  return t ? `⁦${r}⁩` : r;
}, iE = (e, t) => {
  const n = e.dateWithTimezone(void 0, t), r = e.endOfYear(n), o = e.endOfDay(n), {
    maxDaysInMonth: i,
    longestMonth: s
  } = Gu(e, n).reduce((l, u) => {
    const c = e.getDaysInMonth(u);
    return c > l.maxDaysInMonth ? {
      maxDaysInMonth: c,
      longestMonth: u
    } : l;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: l
    }) => ({
      minimum: 0,
      maximum: xg(e, t, l) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(r) + 1
    }),
    day: ({
      currentDate: l
    }) => ({
      minimum: 1,
      maximum: l != null && e.isValid(l) ? e.getDaysInMonth(l) : i,
      longestMonth: s
    }),
    weekDay: ({
      format: l,
      contentType: u
    }) => {
      if (u === "digit") {
        const c = Ul(e, t, l).map(Number);
        return {
          minimum: Math.min(...c),
          maximum: Math.max(...c)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: l
    }) => {
      const u = e.getHours(o);
      return e.formatByString(e.endOfDay(n), l) !== u.toString() ? {
        minimum: 1,
        maximum: Number(e.formatByString(e.startOfDay(n), l))
      } : {
        minimum: 0,
        maximum: u
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(o)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(o)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let Gf = !1;
const Kf = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !Gf) {
    const n = [];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((o) => !n.includes(o.type));
    r && (console.warn(`MUI: The field component you are using is not compatible with the "${r.type} date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), Gf = !0);
  }
}, aE = (e, t, n, r, o) => {
  switch (n.type) {
    case "year":
      return e.setYear(o, e.getYear(r));
    case "month":
      return e.setMonth(o, e.getMonth(r));
    case "weekDay": {
      const i = Ul(e, t, n.format), s = e.formatByString(r, n.format), l = i.indexOf(s), c = i.indexOf(n.value) - l;
      return e.addDays(r, c);
    }
    case "day":
      return e.setDate(o, e.getDate(r));
    case "meridiem": {
      const i = e.getHours(r) < 12, s = e.getHours(o);
      return i && s >= 12 ? e.addHours(o, -12) : !i && s < 12 ? e.addHours(o, 12) : o;
    }
    case "hours":
      return e.setHours(o, e.getHours(r));
    case "minutes":
      return e.setMinutes(o, e.getMinutes(r));
    case "seconds":
      return e.setSeconds(o, e.getSeconds(r));
    default:
      return o;
  }
}, Zf = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
}, Qf = (e, t, n, r, o, i) => (
  // cloning sections before sort to avoid mutating it
  [...r].sort((s, l) => Zf[s.type] - Zf[l.type]).reduce((s, l) => !i || l.modified ? aE(e, t, l, n, s) : s, o)
), sE = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, lE = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((u, c) => {
      const d = c === 0 ? null : c - 1, m = c === e.length - 1 ? null : c + 1;
      n[c] = {
        leftIndex: d,
        rightIndex: m
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, o = {};
  let i = 0, s = 0, l = e.length - 1;
  for (; l >= 0; ) {
    s = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (u, c) => {
        var d;
        return c >= i && ((d = u.endSeparator) == null ? void 0 : d.includes(" ")) && // Special case where the spaces were not there in the initial input
        u.endSeparator !== " / ";
      }
    ), s === -1 && (s = e.length - 1);
    for (let u = s; u >= i; u -= 1)
      o[u] = l, r[l] = u, l -= 1;
    i = s + 1;
  }
  return e.forEach((u, c) => {
    const d = o[c], m = d === 0 ? null : r[d - 1], f = d === e.length - 1 ? null : r[d + 1];
    n[c] = {
      leftIndex: m,
      rightIndex: f
    };
  }), {
    neighbors: n,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
}, cE = ["value", "referenceDate"], Nt = {
  emptyValue: null,
  getTodayValue: Ku,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, r = $e(e, cE);
    return t != null && r.utils.isValid(t) ? t : n ?? J1(r);
  },
  cleanValue: H1,
  areValuesEqual: U1,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, Ju = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, r, o) => !e.isValid(t) && !!n ? n : wg(o(t), r),
  getValueStrFromSections: oE,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, uE = ["localeText"], ul = /* @__PURE__ */ U.createContext(null);
process.env.NODE_ENV !== "production" && (ul.displayName = "MuiPickersAdapterContext");
const Xu = function(t) {
  var n;
  const {
    localeText: r
  } = t, o = $e(t, uE), {
    utils: i,
    localeText: s
  } = (n = U.useContext(ul)) != null ? n : {
    utils: void 0,
    localeText: void 0
  }, l = Ze({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: o,
    name: "MuiLocalizationProvider"
  }), {
    children: u,
    dateAdapter: c,
    dateFormats: d,
    dateLibInstance: m,
    adapterLocale: f,
    localeText: p
  } = l, b = U.useMemo(() => z({}, p, s, r), [p, s, r]), g = U.useMemo(() => {
    if (!c)
      return i || null;
    const w = new c({
      locale: f,
      formats: d,
      instance: m
    });
    if (!w.isMUIAdapter)
      throw new Error(["MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return w;
  }, [c, f, d, m, i]), S = U.useMemo(() => g ? {
    minDate: g.date("1900-01-01T00:00:00.000"),
    maxDate: g.date("2099-12-31T00:00:00.000")
  } : null, [g]), C = U.useMemo(() => ({
    utils: g,
    defaultDates: S,
    localeText: b
  }), [S, g, b]);
  return /* @__PURE__ */ h(ul.Provider, {
    value: C,
    children: u
  });
};
process.env.NODE_ENV !== "production" && (Xu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: a.any,
  children: a.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: a.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: a.shape({
    dayOfMonth: a.string,
    fullDate: a.string,
    fullDateTime: a.string,
    fullDateTime12h: a.string,
    fullDateTime24h: a.string,
    fullDateWithWeekday: a.string,
    fullTime: a.string,
    fullTime12h: a.string,
    fullTime24h: a.string,
    hours12h: a.string,
    hours24h: a.string,
    keyboardDate: a.string,
    keyboardDateTime: a.string,
    keyboardDateTime12h: a.string,
    keyboardDateTime24h: a.string,
    meridiem: a.string,
    minutes: a.string,
    month: a.string,
    monthAndDate: a.string,
    monthAndYear: a.string,
    monthShort: a.string,
    normalDate: a.string,
    normalDateWithWeekday: a.string,
    seconds: a.string,
    shortDate: a.string,
    weekday: a.string,
    weekdayShort: a.string,
    year: a.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: a.any,
  /**
   * Locale for components texts
   */
  localeText: a.object
});
const dE = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: z({}, e)
      }
    }
  }
}), Tg = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "open previous view",
  openNextView: "open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange placeholders
  start: "Start",
  end: "End",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose date, selected date is ${t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose time, selected time is ${t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa"
}, fE = Tg;
dE(Tg);
const Wn = () => {
  const e = U.useContext(ul);
  if (e === null)
    throw new Error(["MUI: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = U.useMemo(() => z({}, fE, e.localeText), [e.localeText]);
  return U.useMemo(() => z({}, e, {
    localeText: t
  }), [e, t]);
}, Ue = () => Wn().utils, So = () => Wn().defaultDates, jt = () => Wn().localeText, Wr = (e) => {
  const t = Ue(), n = U.useRef();
  return n.current === void 0 && (n.current = t.dateWithTimezone(void 0, e)), n.current;
};
function _g(e) {
  return ut("MuiPickersToolbar", e);
}
ft("MuiPickersToolbar", ["root", "content"]);
const pE = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return st({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", n && "penIconButtonLandscape"]
  }, _g, t);
}, mE = Q("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => z({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, t.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), hE = Q("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  ownerState: e
}) => {
  var t;
  return {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: e.isLandscape ? "flex-start" : "space-between",
    flexDirection: e.isLandscape ? (t = e.landscapeDirection) != null ? t : "column" : "row",
    flex: 1,
    alignItems: e.isLandscape ? "flex-start" : "center"
  };
}), ed = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: o,
    className: i,
    toolbarTitle: s,
    hidden: l,
    titleId: u
  } = r, c = r, d = pE(c);
  return l ? null : /* @__PURE__ */ J(mE, {
    ref: n,
    className: mt(d.root, i),
    ownerState: c,
    children: [/* @__PURE__ */ h(ve, {
      color: "text.secondary",
      variant: "overline",
      id: u,
      children: s
    }), /* @__PURE__ */ h(hE, {
      className: d.content,
      ownerState: c,
      children: o
    })]
  });
});
function gE(e) {
  return ut("MuiDatePickerToolbar", e);
}
ft("MuiDatePickerToolbar", ["root", "title"]);
const yE = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views"], bE = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    title: ["title"]
  }, gE, t);
}, vE = Q(ed, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), CE = Q(ve, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})(({
  ownerState: e
}) => z({}, e.isLandscape && {
  margin: "auto 16px auto auto"
})), Dg = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: o,
    isLandscape: i,
    toolbarFormat: s,
    toolbarPlaceholder: l = "––",
    views: u
  } = r, c = $e(r, yE), d = Ue(), m = jt(), f = bE(r), p = U.useMemo(() => {
    if (!o)
      return l;
    const g = Qa(d, {
      format: s,
      views: u
    }, !0);
    return d.formatByString(o, g);
  }, [o, s, l, d, u]), b = r;
  return /* @__PURE__ */ h(vE, z({
    ref: n,
    toolbarTitle: m.datePickerToolbarTitle,
    isLandscape: i,
    className: f.root
  }, c, {
    children: /* @__PURE__ */ h(CE, {
      variant: "h4",
      align: i ? "left" : "center",
      ownerState: b,
      className: f.title,
      children: p
    })
  }));
});
process.env.NODE_ENV !== "production" && (Dg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  classes: a.object,
  /**
   * className applied to the root component.
   */
  className: a.string,
  disabled: a.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: a.bool,
  isLandscape: a.bool.isRequired,
  onChange: a.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: a.func.isRequired,
  readOnly: a.bool,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  titleId: a.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: a.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: a.node,
  value: a.any,
  /**
   * Currently visible picker view.
   */
  view: a.oneOf(["day", "month", "year"]).isRequired,
  views: a.arrayOf(a.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const gs = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((t, n) => z({}, t, {
      [`${n.slice(0, 1).toLowerCase()}${n.slice(1)}`]: e[n]
    }), {});
};
function Pg(e, t) {
  var n, r, o, i;
  const s = Ue(), l = So(), u = Ze({
    props: e,
    name: t
  }), c = U.useMemo(() => {
    var m;
    return ((m = u.localeText) == null ? void 0 : m.toolbarTitle) == null ? u.localeText : z({}, u.localeText, {
      datePickerToolbarTitle: u.localeText.toolbarTitle
    });
  }, [u.localeText]), d = (n = u.slots) != null ? n : gs(u.components);
  return z({}, u, {
    localeText: c
  }, Yu({
    views: u.views,
    openTo: u.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: (r = u.disableFuture) != null ? r : !1,
    disablePast: (o = u.disablePast) != null ? o : !1,
    minDate: Gt(s, u.minDate, l.minDate),
    maxDate: Gt(s, u.maxDate, l.maxDate),
    slots: z({
      toolbar: Dg
    }, d),
    slotProps: (i = u.slotProps) != null ? i : u.componentsProps
  });
}
const wE = Lr(/* @__PURE__ */ h("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), xE = Lr(/* @__PURE__ */ h("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), SE = Lr(/* @__PURE__ */ h("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), Og = Lr(/* @__PURE__ */ h("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), TE = Lr(/* @__PURE__ */ J(U.Fragment, {
  children: [/* @__PURE__ */ h("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ h("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"), _E = Lr(/* @__PURE__ */ h("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange"), DE = Lr(/* @__PURE__ */ J(U.Fragment, {
  children: [/* @__PURE__ */ h("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ h("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time"), PE = Lr(/* @__PURE__ */ h("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function OE(e) {
  return ut("MuiPickersArrowSwitcher", e);
}
ft("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
const kE = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"], ME = ["ownerState"], EE = ["ownerState"], IE = Q("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), RE = Q("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), Jf = Q(tn, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})(({
  ownerState: e
}) => z({}, e.hidden && {
  visibility: "hidden"
})), AE = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, OE, t);
}, kg = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s;
  const u = qt().direction === "rtl", c = Ze({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: d,
    className: m,
    slots: f,
    slotProps: p,
    isNextDisabled: b,
    isNextHidden: g,
    onGoToNext: S,
    nextLabel: C,
    isPreviousDisabled: w,
    isPreviousHidden: v,
    onGoToPrevious: x,
    previousLabel: T
  } = c, E = $e(c, kE), k = c, I = AE(k), P = {
    isDisabled: b,
    isHidden: g,
    goTo: S,
    label: C
  }, F = {
    isDisabled: w,
    isHidden: v,
    goTo: x,
    label: T
  }, A = (r = f == null ? void 0 : f.previousIconButton) != null ? r : Jf, B = xt({
    elementType: A,
    externalSlotProps: p == null ? void 0 : p.previousIconButton,
    additionalProps: {
      size: "medium",
      title: F.label,
      "aria-label": F.label,
      disabled: F.isDisabled,
      edge: "end",
      onClick: F.goTo
    },
    ownerState: z({}, k, {
      hidden: F.isHidden
    }),
    className: I.button
  }), W = (o = f == null ? void 0 : f.nextIconButton) != null ? o : Jf, M = xt({
    elementType: W,
    externalSlotProps: p == null ? void 0 : p.nextIconButton,
    additionalProps: {
      size: "medium",
      title: P.label,
      "aria-label": P.label,
      disabled: P.isDisabled,
      edge: "start",
      onClick: P.goTo
    },
    ownerState: z({}, k, {
      hidden: P.isHidden
    }),
    className: I.button
  }), _ = (i = f == null ? void 0 : f.leftArrowIcon) != null ? i : xE, O = xt({
    elementType: _,
    externalSlotProps: p == null ? void 0 : p.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), R = $e(O, ME), N = (s = f == null ? void 0 : f.rightArrowIcon) != null ? s : SE, L = xt({
    elementType: N,
    externalSlotProps: p == null ? void 0 : p.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), $ = $e(L, EE);
  return /* @__PURE__ */ J(IE, z({
    ref: n,
    className: mt(I.root, m),
    ownerState: k
  }, E, {
    children: [/* @__PURE__ */ h(A, z({}, B, {
      children: u ? /* @__PURE__ */ h(N, z({}, $)) : /* @__PURE__ */ h(_, z({}, R))
    })), d ? /* @__PURE__ */ h(ve, {
      variant: "subtitle1",
      component: "span",
      children: d
    }) : /* @__PURE__ */ h(RE, {
      className: I.spacer,
      ownerState: k
    }), /* @__PURE__ */ h(W, z({}, M, {
      children: u ? /* @__PURE__ */ h(_, z({}, R)) : /* @__PURE__ */ h(N, z({}, $))
    }))]
  }));
}), Xa = 36, Yl = 2, Gl = 320, $E = 280, Kl = 334, Mg = 232, Sa = 48, NE = Q(Qm)({
  [`& .${Xd.container}`]: {
    outline: 0
  },
  [`& .${Xd.paper}`]: {
    outline: 0,
    minWidth: Gl
  }
}), FE = Q(Zm)({
  "&:first-of-type": {
    padding: 0
  }
});
function VE(e) {
  var t, n;
  const {
    children: r,
    onDismiss: o,
    open: i,
    slots: s,
    slotProps: l
  } = e, u = (t = s == null ? void 0 : s.dialog) != null ? t : NE, c = (n = s == null ? void 0 : s.mobileTransition) != null ? n : Xo;
  return /* @__PURE__ */ h(u, z({
    open: i,
    onClose: o
  }, l == null ? void 0 : l.dialog, {
    TransitionComponent: c,
    TransitionProps: l == null ? void 0 : l.mobileTransition,
    PaperComponent: s == null ? void 0 : s.mobilePaper,
    PaperProps: l == null ? void 0 : l.mobilePaper,
    children: /* @__PURE__ */ h(FE, {
      children: r
    })
  }));
}
function jE(e) {
  return ut("MuiPickersPopper", e);
}
ft("MuiPickersPopper", ["root", "paper"]);
function Lo(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const LE = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation()), t && t(n);
}, dl = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? dl(t.shadowRoot) : t : null;
}, td = "@media (pointer: fine)", BE = "@media (prefers-reduced-motion: reduce)", Yo = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), Xf = Yo && Yo[1] ? parseInt(Yo[1], 10) : null, ep = Yo && Yo[2] ? parseInt(Yo[2], 10) : null, zE = Xf && Xf < 10 || ep && ep < 13 || !1, Eg = () => jr(BE, {
  defaultMatches: !1
}) || zE, WE = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], qE = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    paper: ["paper"]
  }, jE, t);
}, HE = Q(CC, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), UE = Q(vC, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  ownerState: e
}) => z({
  outline: 0,
  transformOrigin: "top center"
}, e.placement.includes("top") && {
  transformOrigin: "bottom center"
}));
function YE(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function GE(e, t) {
  const n = U.useRef(!1), r = U.useRef(!1), o = U.useRef(null), i = U.useRef(!1);
  U.useEffect(() => {
    if (!e)
      return;
    function u() {
      i.current = !0;
    }
    return document.addEventListener("mousedown", u, !0), document.addEventListener("touchstart", u, !0), () => {
      document.removeEventListener("mousedown", u, !0), document.removeEventListener("touchstart", u, !0), i.current = !1;
    };
  }, [e]);
  const s = Ae((u) => {
    if (!i.current)
      return;
    const c = r.current;
    r.current = !1;
    const d = Sc(o.current);
    if (!o.current || // is a TouchEvent?
    "clientX" in u && YE(u, d))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let m;
    u.composedPath ? m = u.composedPath().indexOf(o.current) > -1 : m = !d.documentElement.contains(u.target) || o.current.contains(u.target), !m && !c && t(u);
  }), l = () => {
    r.current = !0;
  };
  return U.useEffect(() => {
    if (e) {
      const u = Sc(o.current), c = () => {
        n.current = !0;
      };
      return u.addEventListener("touchstart", s), u.addEventListener("touchmove", c), () => {
        u.removeEventListener("touchstart", s), u.removeEventListener("touchmove", c);
      };
    }
  }, [e, s]), U.useEffect(() => {
    if (e) {
      const u = Sc(o.current);
      return u.addEventListener("click", s), () => {
        u.removeEventListener("click", s), r.current = !1;
      };
    }
  }, [e, s]), [o, l, l];
}
const KE = /* @__PURE__ */ U.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: o,
    children: i,
    paperSlotProps: s,
    paperClasses: l,
    onPaperClick: u,
    onPaperTouchStart: c
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, d = $e(e, WE), m = z({}, o, {
    placement: r
  }), f = xt({
    elementType: n,
    externalSlotProps: s,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: l,
    ownerState: m
  });
  return /* @__PURE__ */ h(n, z({}, d, f, {
    onClick: (p) => {
      var b;
      u(p), (b = f.onClick) == null || b.call(f, p);
    },
    onTouchStart: (p) => {
      var b;
      c(p), (b = f.onTouchStart) == null || b.call(f, p);
    },
    ownerState: m,
    children: i
  }));
});
function ZE(e) {
  var t, n, r, o;
  const i = Ze({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: s,
    children: l,
    containerRef: u = null,
    shouldRestoreFocus: c,
    onBlur: d,
    onDismiss: m,
    open: f,
    role: p,
    placement: b,
    slots: g,
    slotProps: S,
    reduceAnimations: C
  } = i;
  U.useEffect(() => {
    function L($) {
      f && ($.key === "Escape" || $.key === "Esc") && m();
    }
    return document.addEventListener("keydown", L), () => {
      document.removeEventListener("keydown", L);
    };
  }, [m, f]);
  const w = U.useRef(null);
  U.useEffect(() => {
    p === "tooltip" || c && !c() || (f ? w.current = dl(document) : w.current && w.current instanceof HTMLElement && setTimeout(() => {
      w.current instanceof HTMLElement && w.current.focus();
    }));
  }, [f, p, c]);
  const [v, x, T] = GE(f, d ?? m), E = U.useRef(null), k = nr(E, u), I = nr(k, v), P = i, F = qE(P), A = Eg(), B = C ?? A, W = (L) => {
    L.key === "Escape" && (L.stopPropagation(), m());
  }, M = ((t = g == null ? void 0 : g.desktopTransition) != null ? t : B) ? Xo : bC, _ = (n = g == null ? void 0 : g.desktopTrapFocus) != null ? n : wC, O = (r = g == null ? void 0 : g.desktopPaper) != null ? r : UE, R = (o = g == null ? void 0 : g.popper) != null ? o : HE, N = xt({
    elementType: R,
    externalSlotProps: S == null ? void 0 : S.popper,
    additionalProps: {
      transition: !0,
      role: p,
      open: f,
      anchorEl: s,
      placement: b,
      onKeyDown: W
    },
    className: F.root,
    ownerState: i
  });
  return /* @__PURE__ */ h(R, z({}, N, {
    children: ({
      TransitionProps: L,
      placement: $
    }) => /* @__PURE__ */ h(_, z({
      open: f,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: p === "tooltip",
      isEnabled: () => !0
    }, S == null ? void 0 : S.desktopTrapFocus, {
      children: /* @__PURE__ */ h(M, z({}, L, S == null ? void 0 : S.desktopTransition, {
        children: /* @__PURE__ */ h(KE, {
          PaperComponent: O,
          ownerState: P,
          popperPlacement: $,
          ref: I,
          onPaperClick: x,
          onPaperTouchStart: T,
          paperClasses: F.paper,
          paperSlotProps: S == null ? void 0 : S.desktopPaper,
          children: l
        })
      }))
    }))
  }));
}
function QE(e) {
  return ut("MuiPickersToolbarText", e);
}
const tp = ft("MuiPickersToolbarText", ["root", "selected"]), JE = ["className", "selected", "value"], XE = (e) => {
  const {
    classes: t,
    selected: n
  } = e;
  return st({
    root: ["root", n && "selected"]
  }, QE, t);
}, eI = Q(ve, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${tp.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  transition: e.transitions.create("color"),
  color: (e.vars || e).palette.text.secondary,
  [`&.${tp.selected}`]: {
    color: (e.vars || e).palette.text.primary
  }
})), nd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiPickersToolbarText"
  }), {
    className: o,
    value: i
  } = r, s = $e(r, JE), l = XE(r);
  return /* @__PURE__ */ h(eI, z({
    ref: n,
    className: mt(o, l.root),
    component: "span"
  }, s, {
    children: i
  }));
}), tI = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], nI = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"]
  }, _g, t);
}, rI = Q(pr, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), mn = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiPickersToolbarButton"
  }), {
    align: o,
    className: i,
    selected: s,
    typographyClassName: l,
    value: u,
    variant: c,
    width: d
  } = r, m = $e(r, tI), f = nI(r);
  return /* @__PURE__ */ h(rI, z({
    variant: "text",
    ref: n,
    className: mt(i, f.root)
  }, d ? {
    sx: {
      width: d
    }
  } : {}, m, {
    children: /* @__PURE__ */ h(nd, {
      align: o,
      className: l,
      variant: c,
      value: u,
      selected: s
    })
  }));
}), rd = ({
  timezone: e,
  value: t,
  defaultValue: n,
  onChange: r,
  valueManager: o
}) => {
  var i, s;
  const l = Ue(), u = U.useRef(n), c = (i = t ?? u.current) != null ? i : o.emptyValue, d = U.useMemo(() => o.getTimezone(l, c), [l, o, c]), m = Ae((g) => d == null ? g : o.setTimezone(l, d, g)), f = (s = e ?? d) != null ? s : "default", p = U.useMemo(() => o.setTimezone(l, f, c), [o, l, f, c]), b = Ae((g, ...S) => {
    const C = m(g);
    r == null || r(C, ...S);
  });
  return {
    value: p,
    handleValueChange: b,
    timezone: f
  };
}, Ci = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: r,
  onChange: o,
  valueManager: i
}) => {
  const [s, l] = $r({
    name: e,
    state: "value",
    controlled: n,
    default: r ?? i.emptyValue
  }), u = Ae((c, ...d) => {
    l(c), o == null || o(c, ...d);
  });
  return rd({
    timezone: t,
    value: s,
    defaultValue: void 0,
    onChange: u,
    valueManager: i
  });
};
function Ig(e, t, n, r) {
  const {
    value: o,
    onError: i
  } = e, s = Wn(), l = U.useRef(r), u = t({
    adapter: s,
    value: o,
    props: e
  });
  return U.useEffect(() => {
    i && !n(u, l.current) && i(u, o), l.current = u;
  }, [n, i, l, u, o]), u;
}
const oI = (e) => {
  const t = Ue(), n = jt(), r = Wn(), i = qt().direction === "rtl", {
    valueManager: s,
    fieldValueManager: l,
    valueType: u,
    validator: c,
    internalProps: d,
    internalProps: {
      value: m,
      defaultValue: f,
      referenceDate: p,
      onChange: b,
      format: g,
      formatDensity: S = "dense",
      selectedSections: C,
      onSelectedSectionsChange: w,
      shouldRespectLeadingZeros: v = !1,
      timezone: x
    }
  } = e, {
    timezone: T,
    value: E,
    handleValueChange: k
  } = rd({
    timezone: x,
    value: m,
    defaultValue: f,
    onChange: b,
    valueManager: s
  }), I = U.useMemo(() => iE(t, T), [t, T]), P = U.useCallback((Y, Z = null) => l.getSectionsFromValue(t, Y, Z, i, (ie) => Yf(t, T, n, g, ie, S, v, i)), [l, g, n, i, v, t, S, T]), F = U.useMemo(() => l.getValueStrFromSections(P(s.emptyValue), i), [l, P, s.emptyValue, i]), [A, B] = U.useState(() => {
    const Y = P(E);
    Kf(Y, u);
    const Z = {
      sections: Y,
      value: E,
      referenceValue: s.emptyValue,
      tempValueStrAndroid: null
    }, ie = Q1(Y), X = s.getInitialReferenceValue({
      referenceDate: p,
      value: E,
      utils: t,
      props: d,
      granularity: ie,
      timezone: T
    });
    return z({}, Z, {
      referenceValue: X
    });
  }), [W, M] = $r({
    controlled: C,
    default: null,
    name: "useField",
    state: "selectedSectionIndexes"
  }), _ = (Y) => {
    M(Y), w == null || w(Y), B((Z) => z({}, Z, {
      selectedSectionQuery: null
    }));
  }, O = U.useMemo(() => {
    if (W == null)
      return null;
    if (W === "all")
      return {
        startIndex: 0,
        endIndex: A.sections.length - 1,
        shouldSelectBoundarySelectors: !0
      };
    if (typeof W == "number")
      return {
        startIndex: W,
        endIndex: W
      };
    if (typeof W == "string") {
      const Y = A.sections.findIndex((Z) => Z.type === W);
      return {
        startIndex: Y,
        endIndex: Y
      };
    }
    return W;
  }, [W, A.sections]), R = ({
    value: Y,
    referenceValue: Z,
    sections: ie
  }) => {
    if (B((se) => z({}, se, {
      sections: ie,
      value: Y,
      referenceValue: Z,
      tempValueStrAndroid: null
    })), s.areValuesEqual(t, A.value, Y))
      return;
    const X = {
      validationError: c({
        adapter: r,
        value: Y,
        props: z({}, d, {
          value: Y,
          timezone: T
        })
      })
    };
    k(Y, X);
  }, N = (Y, Z) => {
    const ie = [...A.sections];
    return ie[Y] = z({}, ie[Y], {
      value: Z,
      modified: !0
    }), wg(ie, i);
  }, L = () => {
    R({
      value: s.emptyValue,
      referenceValue: A.referenceValue,
      sections: P(s.emptyValue)
    });
  }, $ = () => {
    if (O == null)
      return;
    const Y = A.sections[O.startIndex], Z = l.getActiveDateManager(t, A, Y), X = Z.getSections(A.sections).filter((ce) => ce.value !== "").length === (Y.value === "" ? 0 : 1), se = N(O.startIndex, ""), fe = X ? null : t.date(/* @__PURE__ */ new Date("")), le = Z.getNewValuesFromNewActiveDate(fe);
    (fe != null && !t.isValid(fe)) != (Z.date != null && !t.isValid(Z.date)) ? R(z({}, le, {
      sections: se
    })) : B((ce) => z({}, ce, le, {
      sections: se,
      tempValueStrAndroid: null
    }));
  }, H = (Y) => {
    const Z = (se, fe) => {
      const le = t.parse(se, g);
      if (le == null || !t.isValid(le))
        return null;
      const ce = Yf(t, T, n, g, le, S, v, i);
      return Qf(t, T, le, ce, fe, !1);
    }, ie = l.parseValueStr(Y, A.referenceValue, Z), X = l.updateReferenceValue(t, ie, A.referenceValue);
    R({
      value: ie,
      referenceValue: X,
      sections: P(ie, A.sections)
    });
  }, G = ({
    activeSection: Y,
    newSectionValue: Z,
    shouldGoToNextSection: ie
  }) => {
    ie && O && O.startIndex < A.sections.length - 1 ? _(O.startIndex + 1) : O && O.startIndex !== O.endIndex && _(O.startIndex);
    const X = l.getActiveDateManager(t, A, Y), se = N(O.startIndex, Z), fe = X.getSections(se), le = rE(t, fe);
    let ce, ee;
    if (le != null && t.isValid(le)) {
      const ae = Qf(t, T, le, fe, X.referenceDate, !0);
      ce = X.getNewValuesFromNewActiveDate(ae), ee = !0;
    } else
      ce = X.getNewValuesFromNewActiveDate(le), ee = (le != null && !t.isValid(le)) != (X.date != null && !t.isValid(X.date));
    return ee ? R(z({}, ce, {
      sections: se
    })) : B((ae) => z({}, ae, ce, {
      sections: se,
      tempValueStrAndroid: null
    }));
  }, q = (Y) => B((Z) => z({}, Z, {
    tempValueStrAndroid: Y
  }));
  return U.useEffect(() => {
    const Y = P(A.value);
    Kf(Y, u), B((Z) => z({}, Z, {
      sections: Y
    }));
  }, [g, t.locale]), U.useEffect(() => {
    let Y = !1;
    s.areValuesEqual(t, A.value, E) ? Y = s.getTimezone(t, A.value) !== s.getTimezone(t, E) : Y = !0, Y && B((Z) => z({}, Z, {
      value: E,
      referenceValue: l.updateReferenceValue(t, E, Z.referenceValue),
      sections: P(E)
    }));
  }, [E]), {
    state: A,
    selectedSectionIndexes: O,
    setSelectedSections: _,
    clearValue: L,
    clearActiveSection: $,
    updateSectionValue: G,
    updateValueFromValueStr: H,
    setTempAndroidValueStr: q,
    sectionsValueBoundaries: I,
    placeholder: F,
    timezone: T
  };
}, iI = 5e3, Io = (e) => e.saveQuery != null, aI = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  setTempAndroidValueStr: r,
  timezone: o
}) => {
  const i = Ue(), [s, l] = U.useState(null), u = Ae(() => l(null));
  U.useEffect(() => {
    var p;
    s != null && ((p = e[s.sectionIndex]) == null ? void 0 : p.type) !== s.sectionType && u();
  }, [e, s, u]), U.useEffect(() => {
    if (s != null) {
      const p = setTimeout(() => u(), iI);
      return () => {
        window.clearTimeout(p);
      };
    }
    return () => {
    };
  }, [s, u]);
  const c = ({
    keyPressed: p,
    sectionIndex: b
  }, g, S) => {
    const C = p.toLowerCase(), w = e[b];
    if (s != null && (!S || S(s.value)) && s.sectionIndex === b) {
      const x = `${s.value}${C}`, T = g(x, w);
      if (!Io(T))
        return l({
          sectionIndex: b,
          value: x,
          sectionType: w.type
        }), T;
    }
    const v = g(C, w);
    return Io(v) && !v.saveQuery ? (u(), null) : (l({
      sectionIndex: b,
      value: C,
      sectionType: w.type
    }), Io(v) ? null : v);
  }, d = (p) => {
    const b = (C, w, v) => {
      const x = w.filter((T) => T.toLowerCase().startsWith(v));
      return x.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: x[0],
        shouldGoToNextSection: x.length === 1
      };
    }, g = (C, w, v, x) => {
      const T = (E) => bg(i, o, w.type, E);
      if (w.contentType === "letter")
        return b(w.format, T(w.format), C);
      if (v && x != null && Zu(i, v).contentType === "letter") {
        const E = T(v), k = b(v, E, C);
        return Io(k) ? {
          saveQuery: !1
        } : z({}, k, {
          sectionValue: x(k.sectionValue, E)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return c(p, (C, w) => {
      switch (w.type) {
        case "month": {
          const v = (x) => Uf(i, x, i.formats.month, w.format);
          return g(C, w, i.formats.month, v);
        }
        case "weekDay": {
          const v = (x, T) => T.indexOf(x).toString();
          return g(C, w, i.formats.weekday, v);
        }
        case "meridiem":
          return g(C, w);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, m = (p) => {
    const b = (S, C) => {
      const w = +`${S}`, v = n[C.type]({
        currentDate: null,
        format: C.format,
        contentType: C.contentType
      });
      if (w > v.maximum)
        return {
          saveQuery: !1
        };
      if (w < v.minimum)
        return {
          saveQuery: !0
        };
      const x = +`${S}0` > v.maximum || S.length === v.maximum.toString().length;
      return {
        sectionValue: Cg(i, o, w, v, C),
        shouldGoToNextSection: x
      };
    };
    return c(p, (S, C) => {
      if (C.contentType === "digit" || C.contentType === "digit-with-letter")
        return b(S, C);
      if (C.type === "month") {
        const w = Sg(i, o, "digit", "month", "MM"), v = b(S, {
          type: C.type,
          format: "MM",
          hasLeadingZerosInFormat: w,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (Io(v))
          return v;
        const x = Uf(i, v.sectionValue, "MM", C.format);
        return z({}, v, {
          sectionValue: x
        });
      }
      if (C.type === "weekDay") {
        const w = b(S, C);
        if (Io(w))
          return w;
        const v = Ul(i, o, C.format)[Number(w.sectionValue) - 1];
        return z({}, w, {
          sectionValue: v
        });
      }
      return {
        saveQuery: !1
      };
    }, (S) => !Number.isNaN(Number(S)));
  };
  return {
    applyCharacterEditing: Ae((p) => {
      const b = e[p.sectionIndex], S = !Number.isNaN(Number(p.keyPressed)) ? m(p) : d(p);
      S == null ? r(null) : t({
        activeSection: b,
        newSectionValue: S.sectionValue,
        shouldGoToNextSection: S.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: u
  };
}, sI = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error", "clearable", "onClear", "disabled"], od = (e) => {
  const t = Ue(), {
    state: n,
    selectedSectionIndexes: r,
    setSelectedSections: o,
    clearValue: i,
    clearActiveSection: s,
    updateSectionValue: l,
    updateValueFromValueStr: u,
    setTempAndroidValueStr: c,
    sectionsValueBoundaries: d,
    placeholder: m,
    timezone: f
  } = oI(e), {
    inputRef: p,
    internalProps: b,
    internalProps: {
      readOnly: g = !1,
      unstableFieldRef: S,
      minutesStep: C
    },
    forwardedProps: {
      onClick: w,
      onKeyDown: v,
      onFocus: x,
      onBlur: T,
      onMouseUp: E,
      onPaste: k,
      error: I,
      clearable: P,
      onClear: F,
      disabled: A
    },
    fieldValueManager: B,
    valueManager: W,
    validator: M
  } = e, _ = $e(e.forwardedProps, sI), {
    applyCharacterEditing: O,
    resetCharacterQuery: R
  } = aI({
    sections: n.sections,
    updateSectionValue: l,
    sectionsValueBoundaries: d,
    setTempAndroidValueStr: c,
    timezone: f
  }), N = U.useRef(null), L = nr(p, N), $ = U.useRef(void 0), G = qt().direction === "rtl", q = U.useMemo(() => lE(n.sections, G), [n.sections, G]), Y = () => {
    var K;
    if (g) {
      o(null);
      return;
    }
    const ne = (K = N.current.selectionStart) != null ? K : 0;
    let pe;
    ne <= n.sections[0].startInInput || ne >= n.sections[n.sections.length - 1].endInInput ? pe = 1 : pe = n.sections.findIndex((de) => de.startInInput - de.startSeparator.length > ne);
    const Me = pe === -1 ? n.sections.length - 1 : pe - 1;
    o(Me);
  }, Z = Ae((K, ...ne) => {
    K.isDefaultPrevented() || (w == null || w(K, ...ne), Y());
  }), ie = Ae((K) => {
    E == null || E(K), K.preventDefault();
  }), X = Ae((...K) => {
    x == null || x(...K);
    const ne = N.current;
    window.clearTimeout($.current), $.current = setTimeout(() => {
      !ne || ne !== N.current || r != null || g || (// avoid selecting all sections when focusing empty field without value
      ne.value.length && Number(ne.selectionEnd) - Number(ne.selectionStart) === ne.value.length ? o("all") : Y());
    });
  }), se = Ae((...K) => {
    T == null || T(...K), o(null);
  }), fe = Ae((K) => {
    if (k == null || k(K), g) {
      K.preventDefault();
      return;
    }
    const ne = K.clipboardData.getData("text");
    if (r && r.startIndex === r.endIndex) {
      const pe = n.sections[r.startIndex], Me = /^[a-zA-Z]+$/.test(ne), de = /^[0-9]+$/.test(ne), ye = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(ne);
      if (pe.contentType === "letter" && Me || pe.contentType === "digit" && de || pe.contentType === "digit-with-letter" && ye) {
        R(), l({
          activeSection: pe,
          newSectionValue: ne,
          shouldGoToNextSection: !0
        }), K.preventDefault();
        return;
      }
      if (Me || de) {
        K.preventDefault();
        return;
      }
    }
    K.preventDefault(), R(), u(ne);
  }), le = Ae((K) => {
    if (g)
      return;
    const ne = K.target.value;
    if (ne === "") {
      R(), i();
      return;
    }
    const pe = K.nativeEvent.data, Me = pe && pe.length > 1, de = Me ? pe : ne, ye = Wo(de);
    if (r == null || Me) {
      u(Me ? pe : ye);
      return;
    }
    let Te;
    if (r.startIndex === 0 && r.endIndex === n.sections.length - 1 && ye.length === 1)
      Te = ye;
    else {
      const Re = Wo(B.getValueStrFromSections(n.sections, G));
      let We = -1, ht = -1;
      for (let yt = 0; yt < Re.length; yt += 1)
        We === -1 && Re[yt] !== ye[yt] && (We = yt), ht === -1 && Re[Re.length - yt - 1] !== ye[ye.length - yt - 1] && (ht = yt);
      const gt = n.sections[r.startIndex];
      if (We < gt.start || Re.length - ht - 1 > gt.end)
        return;
      const Lt = ye.length - Re.length + gt.end - Wo(gt.endSeparator || "").length;
      Te = ye.slice(gt.start + Wo(gt.startSeparator || "").length, Lt);
    }
    if (Te.length === 0) {
      sE() ? c(de) : (R(), s());
      return;
    }
    O({
      keyPressed: Te,
      sectionIndex: r.startIndex
    });
  }), ce = Ae((K) => {
    switch (v == null || v(K), !0) {
      case (K.key === "a" && (K.ctrlKey || K.metaKey)): {
        K.preventDefault(), o("all");
        break;
      }
      case K.key === "ArrowRight": {
        if (K.preventDefault(), r == null)
          o(q.startIndex);
        else if (r.startIndex !== r.endIndex)
          o(r.endIndex);
        else {
          const ne = q.neighbors[r.startIndex].rightIndex;
          ne !== null && o(ne);
        }
        break;
      }
      case K.key === "ArrowLeft": {
        if (K.preventDefault(), r == null)
          o(q.endIndex);
        else if (r.startIndex !== r.endIndex)
          o(r.startIndex);
        else {
          const ne = q.neighbors[r.startIndex].leftIndex;
          ne !== null && o(ne);
        }
        break;
      }
      case K.key === "Delete": {
        if (K.preventDefault(), g)
          break;
        r == null || r.startIndex === 0 && r.endIndex === n.sections.length - 1 ? i() : s(), R();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(K.key): {
        if (K.preventDefault(), g || r == null)
          break;
        const ne = n.sections[r.startIndex], pe = B.getActiveDateManager(t, n, ne), Me = eE(t, f, ne, K.key, d, pe.date, {
          minutesStep: C
        });
        l({
          activeSection: ne,
          newSectionValue: Me,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  Ar(() => {
    if (!N.current)
      return;
    if (r == null) {
      N.current.scrollLeft && (N.current.scrollLeft = 0);
      return;
    }
    const K = n.sections[r.startIndex], ne = n.sections[r.endIndex];
    let pe = K.startInInput, Me = ne.endInInput;
    if (r.shouldSelectBoundarySelectors && (pe -= K.startSeparator.length, Me += ne.endSeparator.length), pe !== N.current.selectionStart || Me !== N.current.selectionEnd) {
      const de = N.current.scrollTop;
      N.current === dl(document) && N.current.setSelectionRange(pe, Me), N.current.scrollTop = de;
    }
  });
  const ee = Ig(z({}, b, {
    value: n.value,
    timezone: f
  }), M, W.isSameError, W.defaultErrorState), ae = U.useMemo(() => I !== void 0 ? I : W.hasError(ee), [W, ee, I]);
  U.useEffect(() => {
    !ae && !r && R();
  }, [n.referenceValue, r, ae]), U.useEffect(() => (N.current && N.current === document.activeElement && o("all"), () => window.clearTimeout($.current)), []), U.useEffect(() => {
    n.tempValueStrAndroid != null && r != null && (R(), s());
  }, [n.tempValueStrAndroid]);
  const _e = U.useMemo(() => {
    var K;
    return (K = n.tempValueStrAndroid) != null ? K : B.getValueStrFromSections(n.sections, G);
  }, [n.sections, B, n.tempValueStrAndroid, G]), ue = U.useMemo(() => r == null || n.sections[r.startIndex].contentType === "letter" ? "text" : "numeric", [r, n.sections]), me = N.current && N.current === dl(document), De = W.areValuesEqual(t, n.value, W.emptyValue), he = !me && De;
  U.useImperativeHandle(S, () => ({
    getSections: () => n.sections,
    getActiveSectionIndex: () => {
      var K, ne;
      const pe = (K = N.current.selectionStart) != null ? K : 0, Me = (ne = N.current.selectionEnd) != null ? ne : 0;
      if (pe === 0 && Me === 0)
        return null;
      const de = pe <= n.sections[0].startInInput ? 1 : n.sections.findIndex((ye) => ye.startInInput - ye.startSeparator.length > pe);
      return de === -1 ? n.sections.length - 1 : de - 1;
    },
    setSelectedSections: (K) => o(K)
  }));
  const Ce = Ae((K, ...ne) => {
    var pe;
    K.preventDefault(), F == null || F(K, ...ne), i(), N == null || (pe = N.current) == null || pe.focus(), o(0);
  });
  return z({
    placeholder: m,
    autoComplete: "off",
    disabled: !!A
  }, _, {
    value: he ? "" : _e,
    inputMode: ue,
    readOnly: g,
    onClick: Z,
    onFocus: X,
    onBlur: se,
    onPaste: fe,
    onChange: le,
    onKeyDown: ce,
    onMouseUp: ie,
    onClear: Ce,
    error: ae,
    ref: L,
    clearable: !!(P && !De && !g && !A)
  });
}, lI = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const r = U.useRef(typeof e == "boolean").current, [o, i] = U.useState(!1);
  U.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      i(e);
    }
  }, [r, e]);
  const s = U.useCallback((l) => {
    r || i(l), l && t && t(), !l && n && n();
  }, [r, t, n]);
  return {
    isOpen: o,
    setIsOpen: s
  };
}, cI = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: o
  } = e, i = !o && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? i && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? i ? !0 : n(r.lastPublishedValue) : !1;
}, uI = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: o,
    closeOnSelect: i
  } = e, s = !o && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? s && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && i ? s ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, dI = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, fI = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  validator: o
}) => {
  const {
    onAccept: i,
    onChange: s,
    value: l,
    defaultValue: u,
    closeOnSelect: c = r === "desktop",
    selectedSections: d,
    onSelectedSectionsChange: m,
    timezone: f
  } = e, {
    current: p
  } = U.useRef(u), {
    current: b
  } = U.useRef(l !== void 0);
  process.env.NODE_ENV !== "production" && (U.useEffect(() => {
    b !== (l !== void 0) && console.error([`MUI: A component is changing the ${b ? "" : "un"}controlled value of a picker to be ${b ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [l]), U.useEffect(() => {
    !b && p !== u && console.error(["MUI: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(p)]));
  const g = Ue(), S = Wn(), [C, w] = $r({
    controlled: d,
    default: null,
    name: "usePickerValue",
    state: "selectedSections"
  }), {
    isOpen: v,
    setIsOpen: x
  } = lI(e), [T, E] = U.useState(() => {
    let X;
    return l !== void 0 ? X = l : p !== void 0 ? X = p : X = t.emptyValue, {
      draft: X,
      lastPublishedValue: X,
      lastCommittedValue: X,
      lastControlledValue: l,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: k,
    handleValueChange: I
  } = rd({
    timezone: f,
    value: l,
    defaultValue: p,
    onChange: s,
    valueManager: t
  });
  Ig(z({}, e, {
    value: T.draft,
    timezone: k
  }), o, t.isSameError, t.defaultErrorState);
  const P = Ae((X) => {
    const se = {
      action: X,
      dateState: T,
      hasChanged: (ee) => !t.areValuesEqual(g, X.value, ee),
      isControlled: b,
      closeOnSelect: c
    }, fe = cI(se), le = uI(se), ce = dI(se);
    if (E((ee) => z({}, ee, {
      draft: X.value,
      lastPublishedValue: fe ? X.value : ee.lastPublishedValue,
      lastCommittedValue: le ? X.value : ee.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), fe) {
      const ae = {
        validationError: X.name === "setValueFromField" ? X.context.validationError : o({
          adapter: S,
          value: X.value,
          props: z({}, e, {
            value: X.value,
            timezone: k
          })
        })
      };
      X.name === "setValueFromShortcut" && X.shortcut != null && (ae.shortcut = X.shortcut), I(X.value, ae);
    }
    le && i && i(X.value), ce && x(!1);
  });
  if (l !== void 0 && (T.lastControlledValue === void 0 || !t.areValuesEqual(g, T.lastControlledValue, l))) {
    const X = t.areValuesEqual(g, T.draft, l);
    E((se) => z({}, se, {
      lastControlledValue: l
    }, X ? {} : {
      lastCommittedValue: l,
      lastPublishedValue: l,
      draft: l,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const F = Ae(() => {
    P({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), A = Ae(() => {
    P({
      value: T.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), B = Ae(() => {
    P({
      value: T.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), W = Ae(() => {
    P({
      value: T.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), M = Ae(() => {
    P({
      value: t.getTodayValue(g, k, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), _ = Ae(() => x(!0)), O = Ae(() => x(!1)), R = Ae((X, se = "partial") => P({
    name: "setValueFromView",
    value: X,
    selectionState: se
  })), N = Ae((X, se, fe) => P({
    name: "setValueFromShortcut",
    value: X,
    changeImportance: se ?? "accept",
    shortcut: fe
  })), L = Ae((X, se) => P({
    name: "setValueFromField",
    value: X,
    context: se
  })), $ = Ae((X) => {
    w(X), m == null || m(X);
  }), H = {
    onClear: F,
    onAccept: A,
    onDismiss: B,
    onCancel: W,
    onSetToday: M,
    onOpen: _,
    onClose: O
  }, G = {
    value: T.draft,
    onChange: L,
    selectedSections: C,
    onSelectedSectionsChange: $
  }, q = U.useMemo(() => t.cleanValue(g, T.draft), [g, t, T.draft]), Y = {
    value: q,
    onChange: R,
    onClose: O,
    open: v,
    onSelectedSectionsChange: $
  }, ie = z({}, H, {
    value: q,
    onChange: R,
    onSelectShortcut: N,
    isValid: (X) => {
      const se = o({
        adapter: S,
        value: X,
        props: z({}, e, {
          value: X,
          timezone: k
        })
      });
      return !t.hasError(se);
    }
  });
  return {
    open: v,
    fieldProps: G,
    viewProps: Y,
    layoutProps: ie,
    actions: H
  };
};
let Tc = !1;
function ys({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: o,
  autoFocus: i,
  focusedView: s,
  onFocusedViewChange: l
}) {
  var u, c;
  process.env.NODE_ENV !== "production" && (Tc || (r != null && !o.includes(r) && (console.warn(`MUI: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${o.join('", "')}"]\`.`), Tc = !0), r == null && n != null && !o.includes(n) && (console.warn(`MUI: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${o.join('", "')}"]\`.`), Tc = !0)));
  const d = U.useRef(n), m = U.useRef(o), f = U.useRef(o.includes(n) ? n : o[0]), [p, b] = $r({
    name: "useViews",
    state: "view",
    controlled: r,
    default: f.current
  }), g = U.useRef(i ? p : null), [S, C] = $r({
    name: "useViews",
    state: "focusedView",
    controlled: s,
    default: g.current
  });
  U.useEffect(() => {
    (d.current && d.current !== n || m.current && m.current.some((P) => !o.includes(P))) && (b(o.includes(n) ? n : o[0]), m.current = o, d.current = n);
  }, [n, b, p, o]);
  const w = o.indexOf(p), v = (u = o[w - 1]) != null ? u : null, x = (c = o[w + 1]) != null ? c : null, T = Ae((P, F) => {
    C(F ? P : (A) => P === A ? null : A), l == null || l(P, F);
  }), E = Ae((P) => {
    T(P, !0), P !== p && (b(P), t && t(P));
  }), k = Ae(() => {
    x && E(x);
  }), I = Ae((P, F, A) => {
    const B = F === "finish", W = A ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but we it's not the final view given all `views` -> overall selection state should be `partial`.
      o.indexOf(A) < o.length - 1
    ) : !!x;
    if (e(P, B && W ? "partial" : F, A), A && A !== p) {
      const _ = o[o.indexOf(A) + 1];
      _ && E(_);
    } else
      B && k();
  });
  return {
    view: p,
    setView: E,
    focusedView: S,
    setFocusedView: T,
    nextView: x,
    previousView: v,
    // Always return up to date default view instead of the initial one (i.e. defaultView.current)
    defaultView: o.includes(n) ? n : o[0],
    goToNextView: k,
    setValueAndGoToNextView: I
  };
}
const pI = ["className", "sx"], mI = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  inputRef: r,
  autoFocusView: o
}) => {
  const {
    onChange: i,
    open: s,
    onSelectedSectionsChange: l,
    onClose: u
  } = t, {
    views: c,
    openTo: d,
    onViewChange: m,
    disableOpenPicker: f,
    viewRenderers: p,
    timezone: b
  } = e, g = $e(e, pI), {
    view: S,
    setView: C,
    defaultView: w,
    focusedView: v,
    setFocusedView: x,
    setValueAndGoToNextView: T
  } = ys({
    view: void 0,
    views: c,
    openTo: d,
    onChange: i,
    onViewChange: m,
    autoFocus: o
  }), {
    hasUIView: E,
    viewModeLookup: k
  } = U.useMemo(() => c.reduce((M, _) => {
    let O;
    return f ? O = "field" : p[_] != null ? O = "UI" : O = "field", M.viewModeLookup[_] = O, O === "UI" && (M.hasUIView = !0), M;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [f, p, c]), I = U.useMemo(() => c.reduce((M, _) => p[_] != null && ni(_) ? M + 1 : M, 0), [p, c]), P = k[S], F = Ae(() => P === "UI"), [A, B] = U.useState(P === "UI" ? S : null);
  return A !== S && k[S] === "UI" && B(S), Ar(() => {
    P === "field" && s && (u(), setTimeout(() => {
      r == null || r.current.focus(), l(S);
    }));
  }, [S]), Ar(() => {
    if (!s)
      return;
    let M = S;
    P === "field" && A != null && (M = A), M !== w && k[M] === "UI" && k[w] === "UI" && (M = w), M !== S && C(M), x(M, !0);
  }, [s]), {
    hasUIView: E,
    shouldRestoreFocus: F,
    layoutProps: {
      views: c,
      view: A,
      onViewChange: C
    },
    renderCurrentView: () => {
      if (A == null)
        return null;
      const M = p[A];
      return M == null ? null : M(z({}, g, n, t, {
        views: c,
        timezone: b,
        onChange: T,
        view: A,
        onViewChange: C,
        focusedView: v,
        onFocusedViewChange: x,
        showViewSwitcher: I > 1,
        timeViewsCount: I
      }));
    }
  };
};
function np() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const hI = (e, t) => {
  const [n, r] = U.useState(np);
  return Ar(() => {
    const i = () => {
      r(np());
    };
    return window.addEventListener("orientationchange", i), () => {
      window.removeEventListener("orientationchange", i);
    };
  }, []), Lo(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, gI = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: o
  } = e, i = hI(n.views, o);
  return {
    layoutProps: z({}, n, t, {
      isLandscape: i,
      wrapperVariant: r,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
}, yI = (e, t = "warning") => {
  let n = !1;
  const r = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    n || (n = !0, t === "error" ? console.error(r) : console.warn(r));
  };
}, bI = yI(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), Rg = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  inputRef: o,
  additionalViewProps: i,
  validator: s,
  autoFocusView: l
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && bI();
  const u = fI({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: r,
    validator: s
  }), c = mI({
    props: e,
    inputRef: o,
    additionalViewProps: i,
    autoFocusView: l,
    propsFromPickerValue: u.viewProps
  }), d = gI({
    props: e,
    wrapperVariant: r,
    propsFromPickerValue: u.layoutProps,
    propsFromPickerViews: c.layoutProps
  });
  return {
    // Picker value
    open: u.open,
    actions: u.actions,
    fieldProps: u.fieldProps,
    // Picker views
    renderCurrentView: c.renderCurrentView,
    hasUIView: c.hasUIView,
    shouldRestoreFocus: c.shouldRestoreFocus,
    // Picker layout
    layoutProps: d.layoutProps
  };
};
function Ag(e) {
  return ut("MuiPickersLayout", e);
}
const _c = ft("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "shortcuts"]), vI = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function $g(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: r,
    onSetToday: o,
    actions: i
  } = e, s = $e(e, vI), l = jt();
  if (i == null || i.length === 0)
    return null;
  const u = i == null ? void 0 : i.map((c) => {
    switch (c) {
      case "clear":
        return /* @__PURE__ */ h(pr, {
          onClick: n,
          children: l.clearButtonLabel
        }, c);
      case "cancel":
        return /* @__PURE__ */ h(pr, {
          onClick: r,
          children: l.cancelButtonLabel
        }, c);
      case "accept":
        return /* @__PURE__ */ h(pr, {
          onClick: t,
          children: l.okButtonLabel
        }, c);
      case "today":
        return /* @__PURE__ */ h(pr, {
          onClick: o,
          children: l.todayButtonLabel
        }, c);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ h(Km, z({}, s, {
    children: u
  }));
}
process.env.NODE_ENV !== "production" && ($g.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: a.arrayOf(a.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: a.bool,
  onAccept: a.func.isRequired,
  onCancel: a.func.isRequired,
  onClear: a.func.isRequired,
  onSetToday: a.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
});
const CI = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], wI = ["getValue"];
function Ng(e) {
  const {
    items: t,
    changeImportance: n,
    onChange: r,
    isValid: o
  } = e, i = $e(e, CI);
  if (t == null || t.length === 0)
    return null;
  const s = t.map((l) => {
    let {
      getValue: u
    } = l, c = $e(l, wI);
    const d = u({
      isValid: o
    });
    return {
      label: c.label,
      onClick: () => {
        r(d, n, c);
      },
      disabled: !o(d)
    };
  });
  return /* @__PURE__ */ h(xC, z({
    dense: !0,
    sx: [{
      maxHeight: Kl,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(i.sx) ? i.sx : [i.sx]]
  }, i, {
    children: s.map((l) => /* @__PURE__ */ h(SC, {
      children: /* @__PURE__ */ h(kl, z({}, l))
    }, l.label))
  }));
}
process.env.NODE_ENV !== "production" && (Ng.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: a.oneOf(["accept", "set"]),
  className: a.string,
  component: a.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: a.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: a.bool,
  isLandscape: a.bool.isRequired,
  isValid: a.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default `[]`
   */
  items: a.arrayOf(a.shape({
    getValue: a.func.isRequired,
    label: a.string.isRequired
  })),
  onChange: a.func.isRequired,
  style: a.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: a.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
});
function xI(e) {
  return e.view !== null;
}
const SI = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return st({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, Ag, t);
}, TI = (e) => {
  var t, n;
  const {
    wrapperVariant: r,
    onAccept: o,
    onClear: i,
    onCancel: s,
    onSetToday: l,
    view: u,
    views: c,
    onViewChange: d,
    value: m,
    onChange: f,
    onSelectShortcut: p,
    isValid: b,
    isLandscape: g,
    disabled: S,
    readOnly: C,
    children: w,
    components: v,
    componentsProps: x,
    slots: T,
    slotProps: E
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, k = T ?? gs(v), I = E ?? x, P = SI(e), F = (t = k == null ? void 0 : k.actionBar) != null ? t : $g, A = xt({
    elementType: F,
    externalSlotProps: I == null ? void 0 : I.actionBar,
    additionalProps: {
      onAccept: o,
      onClear: i,
      onCancel: s,
      onSetToday: l,
      actions: r === "desktop" ? [] : ["cancel", "accept"],
      className: P.actionBar
    },
    ownerState: z({}, e, {
      wrapperVariant: r
    })
  }), B = /* @__PURE__ */ h(F, z({}, A)), W = k == null ? void 0 : k.toolbar, M = xt({
    elementType: W,
    externalSlotProps: I == null ? void 0 : I.toolbar,
    additionalProps: {
      isLandscape: g,
      onChange: f,
      value: m,
      view: u,
      onViewChange: d,
      views: c,
      disabled: S,
      readOnly: C,
      className: P.toolbar
    },
    ownerState: z({}, e, {
      wrapperVariant: r
    })
  }), _ = xI(M) && W ? /* @__PURE__ */ h(W, z({}, M)) : null, O = w, R = k == null ? void 0 : k.tabs, N = u && R ? /* @__PURE__ */ h(R, z({
    view: u,
    onViewChange: d
  }, I == null ? void 0 : I.tabs)) : null, L = (n = k == null ? void 0 : k.shortcuts) != null ? n : Ng, $ = xt({
    elementType: L,
    externalSlotProps: I == null ? void 0 : I.shortcuts,
    additionalProps: {
      isValid: b,
      isLandscape: g,
      onChange: p,
      className: P.shortcuts
    },
    ownerState: {
      isValid: b,
      isLandscape: g,
      onChange: p,
      className: P.shortcuts,
      wrapperVariant: r
    }
  }), H = u && L ? /* @__PURE__ */ h(L, z({}, $)) : null;
  return {
    toolbar: _,
    content: O,
    tabs: N,
    actionBar: B,
    shortcuts: H
  };
}, _I = TI, DI = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return st({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, Ag, n);
}, Fg = Q("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${_c.toolbar}`]: t.isLandscape ? {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  } : {
    gridColumn: "2 / 4",
    gridRow: 1
  },
  [`.${_c.shortcuts}`]: t.isLandscape ? {
    gridColumn: "2 / 4",
    gridRow: 1
  } : {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  },
  [`& .${_c.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  }
}));
Fg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: a.elementType,
  ownerState: a.shape({
    isLandscape: a.bool.isRequired
  }).isRequired,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
};
const PI = Q("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), id = function(t) {
  const n = Ze({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: r,
    content: o,
    tabs: i,
    actionBar: s,
    shortcuts: l
  } = _I(n), {
    sx: u,
    className: c,
    isLandscape: d,
    ref: m,
    wrapperVariant: f
  } = n, p = n, b = DI(p);
  return /* @__PURE__ */ J(Fg, {
    ref: m,
    sx: u,
    className: mt(c, b.root),
    ownerState: p,
    children: [d ? l : r, d ? r : l, /* @__PURE__ */ h(PI, {
      className: b.contentWrapper,
      children: f === "desktop" ? /* @__PURE__ */ J(U.Fragment, {
        children: [o, i]
      }) : /* @__PURE__ */ J(U.Fragment, {
        children: [i, o]
      })
    }), s]
  });
};
process.env.NODE_ENV !== "production" && (id.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: a.node,
  classes: a.object,
  className: a.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  disabled: a.bool,
  isLandscape: a.bool.isRequired,
  isValid: a.func.isRequired,
  onAccept: a.func.isRequired,
  onCancel: a.func.isRequired,
  onChange: a.func.isRequired,
  onClear: a.func.isRequired,
  onClose: a.func.isRequired,
  onDismiss: a.func.isRequired,
  onOpen: a.func.isRequired,
  onSelectShortcut: a.func.isRequired,
  onSetToday: a.func.isRequired,
  onViewChange: a.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  value: a.any,
  view: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: a.arrayOf(a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: a.oneOf(["desktop", "mobile"])
});
function OI(e, {
  disableFuture: t,
  maxDate: n,
  timezone: r
}) {
  const o = Ue();
  return U.useMemo(() => {
    const i = o.dateWithTimezone(void 0, r), s = o.startOfMonth(t && o.isBefore(i, n) ? i : n);
    return !o.isAfter(s, e);
  }, [t, n, e, o, r]);
}
function kI(e, {
  disablePast: t,
  minDate: n,
  timezone: r
}) {
  const o = Ue();
  return U.useMemo(() => {
    const i = o.dateWithTimezone(void 0, r), s = o.startOfMonth(t && o.isAfter(i, n) ? i : n);
    return !o.isBefore(s, e);
  }, [t, n, e, o, r]);
}
function Zl(e, t, n, r) {
  const o = Ue(), i = K1(e, o), s = U.useCallback((l) => {
    const u = e == null ? null : Z1(e, l, !!t, o);
    n(u, r ?? "partial");
  }, [t, e, n, r, o]);
  return {
    meridiemMode: i,
    handleMeridiemChange: s
  };
}
const iu = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], au = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableClock", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], Vg = ["minDateTime", "maxDateTime"], MI = [...iu, ...au, ...Vg], wi = (e) => MI.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {}), EI = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "readOnly", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef"], ad = (e, t) => {
  const n = z({}, e), r = {}, o = (i) => {
    n.hasOwnProperty(i) && (r[i] = n[i], delete n[i]);
  };
  return EI.forEach(o), t === "date" ? iu.forEach(o) : t === "time" ? au.forEach(o) : t === "date-time" && (iu.forEach(o), au.forEach(o), Vg.forEach(o)), {
    forwardedProps: n,
    internalProps: r
  };
}, To = ({
  props: e,
  value: t,
  adapter: n
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: r,
    shouldDisableMonth: o,
    shouldDisableYear: i,
    disablePast: s,
    disableFuture: l,
    timezone: u
  } = e, c = n.utils.dateWithTimezone(void 0, u), d = Gt(n.utils, e.minDate, n.defaultDates.minDate), m = Gt(n.utils, e.maxDate, n.defaultDates.maxDate);
  switch (!0) {
    case !n.utils.isValid(t):
      return "invalidDate";
    case !!(r && r(t)):
      return "shouldDisableDate";
    case !!(o && o(t)):
      return "shouldDisableMonth";
    case !!(i && i(t)):
      return "shouldDisableYear";
    case !!(l && n.utils.isAfterDay(t, c)):
      return "disableFuture";
    case !!(s && n.utils.isBeforeDay(t, c)):
      return "disablePast";
    case !!(d && n.utils.isBeforeDay(t, d)):
      return "minDate";
    case !!(m && n.utils.isAfterDay(t, m)):
      return "maxDate";
    default:
      return null;
  }
}, bs = ({
  adapter: e,
  value: t,
  props: n
}) => {
  if (t === null)
    return null;
  const {
    minTime: r,
    maxTime: o,
    minutesStep: i,
    shouldDisableClock: s,
    shouldDisableTime: l,
    disableIgnoringDatePartForTimeValidation: u = !1,
    disablePast: c,
    disableFuture: d,
    timezone: m
  } = n, f = e.utils.dateWithTimezone(void 0, m), p = hs(u, e.utils);
  switch (!0) {
    case !e.utils.isValid(t):
      return "invalidDate";
    case !!(r && p(r, t)):
      return "minTime";
    case !!(o && p(t, o)):
      return "maxTime";
    case !!(d && e.utils.isAfter(t, f)):
      return "disableFuture";
    case !!(c && e.utils.isBefore(t, f)):
      return "disablePast";
    case !!(l && l(t, "hours")):
      return "shouldDisableTime-hours";
    case !!(l && l(t, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(l && l(t, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(s && s(e.utils.getHours(t), "hours")):
      return "shouldDisableClock-hours";
    case !!(s && s(e.utils.getMinutes(t), "minutes")):
      return "shouldDisableClock-minutes";
    case !!(s && s(e.utils.getSeconds(t), "seconds")):
      return "shouldDisableClock-seconds";
    case !!(i && e.utils.getMinutes(t) % i !== 0):
      return "minutesStep";
    default:
      return null;
  }
}, Ql = ({
  props: e,
  value: t,
  adapter: n
}) => {
  const r = To({
    adapter: n,
    value: t,
    props: e
  });
  return r !== null ? r : bs({
    adapter: n,
    value: t,
    props: e
  });
};
function II(e) {
  return ut("MuiPickersDay", e);
}
const Jr = ft("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), RI = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], AI = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: r,
    today: o,
    disabled: i,
    outsideCurrentMonth: s,
    showDaysOutsideCurrentMonth: l,
    classes: u
  } = e, c = s && !l;
  return st({
    root: ["root", t && !c && "selected", i && "disabled", !n && "dayWithMargin", !r && o && "today", s && l && "dayOutsideMonth", c && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, II, u);
}, jg = ({
  theme: e,
  ownerState: t
}) => z({}, e.typography.caption, {
  width: Xa,
  height: Xa,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : sn(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : sn(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${Jr.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Jr.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${Jr.disabled}:not(.${Jr.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Jr.disabled}&.${Jr.selected}`]: {
    opacity: 0.6
  }
}, !t.disableMargin && {
  margin: `0 ${Yl}px`
}, t.outsideCurrentMonth && t.showDaysOutsideCurrentMonth && {
  color: (e.vars || e).palette.text.secondary
}, !t.disableHighlightToday && t.today && {
  [`&:not(.${Jr.selected})`]: {
    border: `1px solid ${(e.vars || e).palette.text.secondary}`
  }
}), Lg = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, $I = Q(gC, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: Lg
})(jg), NI = Q("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: Lg
})(({
  theme: e,
  ownerState: t
}) => z({}, jg({
  theme: e,
  ownerState: t
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), ha = () => {
}, Bg = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: o = !1,
    className: i,
    day: s,
    disabled: l = !1,
    disableHighlightToday: u = !1,
    disableMargin: c = !1,
    isAnimating: d,
    onClick: m,
    onDaySelect: f,
    onFocus: p = ha,
    onBlur: b = ha,
    onKeyDown: g = ha,
    onMouseDown: S = ha,
    onMouseEnter: C = ha,
    outsideCurrentMonth: w,
    selected: v = !1,
    showDaysOutsideCurrentMonth: x = !1,
    children: T,
    today: E = !1
  } = r, k = $e(r, RI), I = z({}, r, {
    autoFocus: o,
    disabled: l,
    disableHighlightToday: u,
    disableMargin: c,
    selected: v,
    showDaysOutsideCurrentMonth: x,
    today: E
  }), P = AI(I), F = Ue(), A = U.useRef(null), B = nr(A, n);
  Ar(() => {
    o && !l && !d && !w && A.current.focus();
  }, [o, l, d, w]);
  const W = (_) => {
    S(_), w && _.preventDefault();
  }, M = (_) => {
    l || f(s), w && _.currentTarget.focus(), m && m(_);
  };
  return w && !x ? /* @__PURE__ */ h(NI, {
    className: mt(P.root, P.hiddenDaySpacingFiller, i),
    ownerState: I,
    role: k.role
  }) : /* @__PURE__ */ h($I, z({
    className: mt(P.root, i),
    ref: B,
    centerRipple: !0,
    disabled: l,
    tabIndex: v ? 0 : -1,
    onKeyDown: (_) => g(_, s),
    onFocus: (_) => p(_, s),
    onBlur: (_) => b(_, s),
    onMouseEnter: (_) => C(_, s),
    onClick: M,
    onMouseDown: W
  }, k, {
    ownerState: I,
    children: T || F.format(s, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (Bg.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: a.oneOfType([a.func, a.shape({
    current: a.shape({
      focusVisible: a.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  component: a.elementType,
  /**
   * The date to show.
   */
  day: a.any.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: a.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: a.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: a.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: a.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: a.string,
  isAnimating: a.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: a.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: a.bool.isRequired,
  onBlur: a.func,
  onDaySelect: a.func.isRequired,
  onFocus: a.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: a.func,
  onKeyDown: a.func,
  onMouseEnter: a.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: a.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: a.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  style: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * @default 0
   */
  tabIndex: a.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: a.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: a.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: a.oneOfType([a.func, a.shape({
    current: a.shape({
      pulsate: a.func.isRequired,
      start: a.func.isRequired,
      stop: a.func.isRequired
    })
  })])
});
const FI = /* @__PURE__ */ U.memo(Bg);
function su(e, t) {
  return su = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, su(e, t);
}
function sd(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, su(e, t);
}
function VI(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function jI(e, t) {
  e.classList ? e.classList.add(t) : VI(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function rp(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function LI(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = rp(e.className, t) : e.setAttribute("class", rp(e.className && e.className.baseVal || "", t));
}
const op = {
  disabled: !1
};
var BI = process.env.NODE_ENV !== "production" ? a.oneOfType([a.number, a.shape({
  enter: a.number,
  exit: a.number,
  appear: a.number
}).isRequired]) : null, zI = process.env.NODE_ENV !== "production" ? a.oneOfType([a.string, a.shape({
  enter: a.string,
  exit: a.string,
  active: a.string
}), a.shape({
  enter: a.string,
  enterDone: a.string,
  enterActive: a.string,
  exit: a.string,
  exitDone: a.string,
  exitActive: a.string
})]) : null;
const fl = ct.createContext(null);
var zg = function(t) {
  return t.scrollTop;
}, Ta = "unmounted", eo = "exited", to = "entering", Bo = "entered", lu = "exiting", vr = /* @__PURE__ */ function(e) {
  sd(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var s = o, l = s && !s.isMounting ? r.enter : r.appear, u;
    return i.appearStatus = null, r.in ? l ? (u = eo, i.appearStatus = to) : u = Bo : r.unmountOnExit || r.mountOnEnter ? u = Ta : u = eo, i.state = {
      status: u
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(o, i) {
    var s = o.in;
    return s && i.status === Ta ? {
      status: eo
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== to && s !== Bo && (i = to) : (s === to || s === Bo) && (i = lu);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, i, s, l;
    return i = s = l = o, o != null && typeof o != "number" && (i = o.exit, s = o.enter, l = o.appear !== void 0 ? o.appear : s), {
      exit: i,
      enter: s,
      appear: l
    };
  }, n.updateStatus = function(o, i) {
    if (o === void 0 && (o = !1), i !== null)
      if (this.cancelNextCallback(), i === to) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : Is.findDOMNode(this);
          s && zg(s);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else
      this.props.unmountOnExit && this.state.status === eo && this.setState({
        status: Ta
      });
  }, n.performEnter = function(o) {
    var i = this, s = this.props.enter, l = this.context ? this.context.isMounting : o, u = this.props.nodeRef ? [l] : [Is.findDOMNode(this), l], c = u[0], d = u[1], m = this.getTimeouts(), f = l ? m.appear : m.enter;
    if (!o && !s || op.disabled) {
      this.safeSetState({
        status: Bo
      }, function() {
        i.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, d), this.safeSetState({
      status: to
    }, function() {
      i.props.onEntering(c, d), i.onTransitionEnd(f, function() {
        i.safeSetState({
          status: Bo
        }, function() {
          i.props.onEntered(c, d);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, i = this.props.exit, s = this.getTimeouts(), l = this.props.nodeRef ? void 0 : Is.findDOMNode(this);
    if (!i || op.disabled) {
      this.safeSetState({
        status: eo
      }, function() {
        o.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: lu
    }, function() {
      o.props.onExiting(l), o.onTransitionEnd(s.exit, function() {
        o.safeSetState({
          status: eo
        }, function() {
          o.props.onExited(l);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, n.setNextCallback = function(o) {
    var i = this, s = !0;
    return this.nextCallback = function(l) {
      s && (s = !1, i.nextCallback = null, o(l));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var s = this.props.nodeRef ? this.props.nodeRef.current : Is.findDOMNode(this), l = o == null && !this.props.addEndListener;
    if (!s || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], c = u[0], d = u[1];
      this.props.addEndListener(c, d);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === Ta)
      return null;
    var i = this.props, s = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var l = $e(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ ct.createElement(fl.Provider, {
        value: null
      }, typeof s == "function" ? s(o, l) : ct.cloneElement(ct.Children.only(s), l))
    );
  }, t;
}(ct.Component);
vr.contextType = fl;
vr.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: a.shape({
    current: typeof Element > "u" ? a.any : function(e, t, n, r, o, i) {
      var s = e[t];
      return a.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: a.oneOfType([a.func.isRequired, a.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: a.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: a.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: a.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: a.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: a.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: a.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = BI;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: a.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: a.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: a.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: a.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: a.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: a.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: a.func
} : {};
function Ro() {
}
vr.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ro,
  onEntering: Ro,
  onEntered: Ro,
  onExit: Ro,
  onExiting: Ro,
  onExited: Ro
};
vr.UNMOUNTED = Ta;
vr.EXITED = eo;
vr.ENTERING = to;
vr.ENTERED = Bo;
vr.EXITING = lu;
const Wg = vr;
var WI = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return jI(t, r);
  });
}, Dc = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return LI(t, r);
  });
}, ld = /* @__PURE__ */ function(e) {
  sd(t, e);
  function t() {
    for (var r, o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(l, u) {
      var c = r.resolveArguments(l, u), d = c[0], m = c[1];
      r.removeClasses(d, "exit"), r.addClass(d, m ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(l, u);
    }, r.onEntering = function(l, u) {
      var c = r.resolveArguments(l, u), d = c[0], m = c[1], f = m ? "appear" : "enter";
      r.addClass(d, f, "active"), r.props.onEntering && r.props.onEntering(l, u);
    }, r.onEntered = function(l, u) {
      var c = r.resolveArguments(l, u), d = c[0], m = c[1], f = m ? "appear" : "enter";
      r.removeClasses(d, f), r.addClass(d, f, "done"), r.props.onEntered && r.props.onEntered(l, u);
    }, r.onExit = function(l) {
      var u = r.resolveArguments(l), c = u[0];
      r.removeClasses(c, "appear"), r.removeClasses(c, "enter"), r.addClass(c, "exit", "base"), r.props.onExit && r.props.onExit(l);
    }, r.onExiting = function(l) {
      var u = r.resolveArguments(l), c = u[0];
      r.addClass(c, "exit", "active"), r.props.onExiting && r.props.onExiting(l);
    }, r.onExited = function(l) {
      var u = r.resolveArguments(l), c = u[0];
      r.removeClasses(c, "exit"), r.addClass(c, "exit", "done"), r.props.onExited && r.props.onExited(l);
    }, r.resolveArguments = function(l, u) {
      return r.props.nodeRef ? [r.props.nodeRef.current, l] : [l, u];
    }, r.getClassNames = function(l) {
      var u = r.props.classNames, c = typeof u == "string", d = c && u ? u + "-" : "", m = c ? "" + d + l : u[l], f = c ? m + "-active" : u[l + "Active"], p = c ? m + "-done" : u[l + "Done"];
      return {
        baseClassName: m,
        activeClassName: f,
        doneClassName: p
      };
    }, r;
  }
  var n = t.prototype;
  return n.addClass = function(o, i, s) {
    var l = this.getClassNames(i)[s + "ClassName"], u = this.getClassNames("enter"), c = u.doneClassName;
    i === "appear" && s === "done" && c && (l += " " + c), s === "active" && o && zg(o), l && (this.appliedClasses[i][s] = l, WI(o, l));
  }, n.removeClasses = function(o, i) {
    var s = this.appliedClasses[i], l = s.base, u = s.active, c = s.done;
    this.appliedClasses[i] = {}, l && Dc(o, l), u && Dc(o, u), c && Dc(o, c);
  }, n.render = function() {
    var o = this.props;
    o.classNames;
    var i = $e(o, ["classNames"]);
    return /* @__PURE__ */ ct.createElement(Wg, z({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(ct.Component);
ld.defaultProps = {
  classNames: ""
};
ld.propTypes = process.env.NODE_ENV !== "production" ? z({}, Wg.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: zI,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: a.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: a.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: a.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: a.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: a.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: a.func
}) : {};
const qI = ld;
function HI(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cd(e, t) {
  var n = function(i) {
    return t && qs(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && Cv.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function UI(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (r[i] = o, o = []) : o.push(i);
  var s, l = {};
  for (var u in t) {
    if (r[u])
      for (s = 0; s < r[u].length; s++) {
        var c = r[u][s];
        l[r[u][s]] = n(c);
      }
    l[u] = n(u);
  }
  for (s = 0; s < o.length; s++)
    l[o[s]] = n(o[s]);
  return l;
}
function oo(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function YI(e, t) {
  return cd(e.children, function(n) {
    return Da(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: oo(n, "appear", e),
      enter: oo(n, "enter", e),
      exit: oo(n, "exit", e)
    });
  });
}
function GI(e, t, n) {
  var r = cd(e.children), o = UI(t, r);
  return Object.keys(o).forEach(function(i) {
    var s = o[i];
    if (qs(s)) {
      var l = i in t, u = i in r, c = t[i], d = qs(c) && !c.props.in;
      u && (!l || d) ? o[i] = Da(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: oo(s, "exit", e),
        enter: oo(s, "enter", e)
      }) : !u && l && !d ? o[i] = Da(s, {
        in: !1
      }) : u && l && qs(c) && (o[i] = Da(s, {
        onExited: n.bind(null, s),
        in: c.props.in,
        exit: oo(s, "exit", e),
        enter: oo(s, "enter", e)
      }));
    }
  }), o;
}
var KI = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, ZI = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, ud = /* @__PURE__ */ function(e) {
  sd(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var s = i.handleExited.bind(HI(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var s = i.children, l = i.handleExited, u = i.firstRender;
    return {
      children: u ? YI(o, l) : GI(o, s, l),
      firstRender: !1
    };
  }, n.handleExited = function(o, i) {
    var s = cd(this.props.children);
    o.key in s || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(l) {
      var u = z({}, l.children);
      return delete u[o.key], {
        children: u
      };
    }));
  }, n.render = function() {
    var o = this.props, i = o.component, s = o.childFactory, l = $e(o, ["component", "childFactory"]), u = this.state.contextValue, c = KI(this.state.children).map(s);
    return delete l.appear, delete l.enter, delete l.exit, i === null ? /* @__PURE__ */ ct.createElement(fl.Provider, {
      value: u
    }, c) : /* @__PURE__ */ ct.createElement(fl.Provider, {
      value: u
    }, /* @__PURE__ */ ct.createElement(i, l, c));
  }, t;
}(ct.Component);
ud.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: a.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: a.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: a.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: a.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: a.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: a.func
} : {};
ud.defaultProps = ZI;
const qg = ud, QI = (e) => ut("MuiPickersSlideTransition", e), vn = ft("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), JI = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], XI = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, r = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return st(r, QI, t);
}, eR = Q(qg, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${vn["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${vn["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${vn.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${vn.slideExit}`]: t.slideExit
  }, {
    [`.${vn["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${vn["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${vn["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${vn["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${vn.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${vn.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${vn["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${vn["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function tR(e) {
  const t = Ze({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: r,
    reduceAnimations: o,
    transKey: i
    // extracting `classes` from `other`
  } = t, s = $e(t, JI), l = XI(t), u = qt();
  if (o)
    return /* @__PURE__ */ h("div", {
      className: mt(l.root, r),
      children: n
    });
  const c = {
    exit: l.exit,
    enterActive: l.enterActive,
    enter: l.enter,
    exitActive: l.exitActive
  };
  return /* @__PURE__ */ h(eR, {
    className: mt(l.root, r),
    childFactory: (d) => /* @__PURE__ */ U.cloneElement(d, {
      classNames: c
    }),
    role: "presentation",
    children: /* @__PURE__ */ h(qI, z({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: u.transitions.duration.complex,
      classNames: c
    }, s, {
      children: n
    }), i)
  });
}
const Hg = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: r,
  maxDate: o,
  disableFuture: i,
  disablePast: s,
  timezone: l
}) => {
  const u = Wn();
  return U.useCallback((c) => To({
    adapter: u,
    value: c,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: r,
      maxDate: o,
      disableFuture: i,
      disablePast: s,
      timezone: l
    }
  }) !== null, [u, e, t, n, r, o, i, s, l]);
}, nR = (e) => ut("MuiDayCalendar", e);
ft("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const rR = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], oR = ["ownerState"], iR = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, nR, t);
}, Ug = (Xa + Yl * 2) * 6, aR = Q("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), sR = Q("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), lR = Q(ve, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), cR = Q(ve, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), uR = Q(ve, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => z({}, e.typography.caption, {
  width: Xa,
  height: Xa,
  padding: 0,
  margin: `0 ${Yl}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), dR = Q("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: Ug
}), fR = Q(tR, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: Ug
}), pR = Q("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), mR = Q("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${Yl}px 0`,
  display: "flex",
  justifyContent: "center"
});
function hR(e) {
  var t, n, r;
  let {
    parentProps: o,
    day: i,
    focusableDay: s,
    selectedDays: l,
    isDateDisabled: u,
    currentMonthNumber: c,
    isViewFocused: d
  } = e, m = $e(e, rR);
  const {
    disabled: f,
    disableHighlightToday: p,
    isMonthSwitchingAnimating: b,
    showDaysOutsideCurrentMonth: g,
    components: S,
    componentsProps: C,
    slots: w,
    slotProps: v,
    timezone: x
  } = o, T = Ue(), E = Wr(x), k = s !== null && T.isSameDay(i, s), I = l.some((R) => T.isSameDay(R, i)), P = T.isSameDay(i, E), F = (t = (n = w == null ? void 0 : w.day) != null ? n : S == null ? void 0 : S.Day) != null ? t : FI, A = xt({
    elementType: F,
    externalSlotProps: (r = v == null ? void 0 : v.day) != null ? r : C == null ? void 0 : C.day,
    additionalProps: z({
      disableHighlightToday: p,
      showDaysOutsideCurrentMonth: g,
      role: "gridcell",
      isAnimating: b,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": T.toJsDate(i).valueOf()
    }, m),
    ownerState: z({}, o, {
      day: i,
      selected: I
    })
  }), B = $e(A, oR), W = U.useMemo(() => f || u(i), [f, u, i]), M = U.useMemo(() => T.getMonth(i) !== c, [T, i, c]), _ = U.useMemo(() => {
    const R = T.startOfMonth(T.setMonth(i, c));
    return g ? T.isSameDay(i, T.startOfWeek(R)) : T.isSameDay(i, R);
  }, [c, i, g, T]), O = U.useMemo(() => {
    const R = T.endOfMonth(T.setMonth(i, c));
    return g ? T.isSameDay(i, T.endOfWeek(R)) : T.isSameDay(i, R);
  }, [c, i, g, T]);
  return /* @__PURE__ */ h(F, z({}, B, {
    day: i,
    disabled: W,
    autoFocus: d && k,
    today: P,
    outsideCurrentMonth: M,
    isFirstVisibleCell: _,
    isLastVisibleCell: O,
    selected: I,
    tabIndex: k ? 0 : -1,
    "aria-selected": I,
    "aria-current": P ? "date" : void 0
  }));
}
function gR(e) {
  const t = Ze({
    props: e,
    name: "MuiDayCalendar"
  }), {
    onFocusedDayChange: n,
    className: r,
    currentMonth: o,
    selectedDays: i,
    focusedDay: s,
    loading: l,
    onSelectedDaysChange: u,
    onMonthSwitchingAnimationEnd: c,
    readOnly: d,
    reduceAnimations: m,
    renderLoading: f = () => /* @__PURE__ */ h("span", {
      children: "..."
    }),
    slideDirection: p,
    TransitionProps: b,
    disablePast: g,
    disableFuture: S,
    minDate: C,
    maxDate: w,
    shouldDisableDate: v,
    shouldDisableMonth: x,
    shouldDisableYear: T,
    dayOfWeekFormatter: E,
    hasFocus: k,
    onFocusedViewChange: I,
    gridLabelId: P,
    displayWeekNumber: F,
    fixedWeekNumber: A,
    autoFocus: B,
    timezone: W
  } = t, M = Wr(W), _ = Ue(), O = iR(t), N = qt().direction === "rtl", L = E || ((he, Ce) => _.format(Ce, "weekdayShort").charAt(0).toUpperCase()), $ = Hg({
    shouldDisableDate: v,
    shouldDisableMonth: x,
    shouldDisableYear: T,
    minDate: C,
    maxDate: w,
    disablePast: g,
    disableFuture: S,
    timezone: W
  }), H = jt(), [G, q] = $r({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: k,
    default: B ?? !1
  }), [Y, Z] = U.useState(() => s || M), ie = Ae((he) => {
    d || u(he);
  }), X = (he) => {
    $(he) || (n(he), Z(he), I == null || I(!0), q(!0));
  }, se = Ae((he, Ce) => {
    switch (he.key) {
      case "ArrowUp":
        X(_.addDays(Ce, -7)), he.preventDefault();
        break;
      case "ArrowDown":
        X(_.addDays(Ce, 7)), he.preventDefault();
        break;
      case "ArrowLeft": {
        const K = _.addDays(Ce, N ? 1 : -1), ne = _.addMonths(Ce, N ? 1 : -1), pe = Ma({
          utils: _,
          date: K,
          minDate: N ? K : _.startOfMonth(ne),
          maxDate: N ? _.endOfMonth(ne) : K,
          isDateDisabled: $,
          timezone: W
        });
        X(pe || K), he.preventDefault();
        break;
      }
      case "ArrowRight": {
        const K = _.addDays(Ce, N ? -1 : 1), ne = _.addMonths(Ce, N ? -1 : 1), pe = Ma({
          utils: _,
          date: K,
          minDate: N ? _.startOfMonth(ne) : K,
          maxDate: N ? K : _.endOfMonth(ne),
          isDateDisabled: $,
          timezone: W
        });
        X(pe || K), he.preventDefault();
        break;
      }
      case "Home":
        X(_.startOfWeek(Ce)), he.preventDefault();
        break;
      case "End":
        X(_.endOfWeek(Ce)), he.preventDefault();
        break;
      case "PageUp":
        X(_.addMonths(Ce, 1)), he.preventDefault();
        break;
      case "PageDown":
        X(_.addMonths(Ce, -1)), he.preventDefault();
        break;
    }
  }), fe = Ae((he, Ce) => X(Ce)), le = Ae((he, Ce) => {
    G && _.isSameDay(Y, Ce) && (I == null || I(!1));
  }), ce = _.getMonth(o), ee = U.useMemo(() => i.filter((he) => !!he).map((he) => _.startOfDay(he)), [_, i]), ae = ce, _e = U.useMemo(() => /* @__PURE__ */ U.createRef(), [ae]), ue = _.startOfWeek(M), me = U.useMemo(() => {
    const he = _.startOfMonth(o), Ce = _.endOfMonth(o);
    return $(Y) || _.isAfterDay(Y, Ce) || _.isBeforeDay(Y, he) ? Ma({
      utils: _,
      date: Y,
      minDate: he,
      maxDate: Ce,
      disablePast: g,
      disableFuture: S,
      isDateDisabled: $,
      timezone: W
    }) : Y;
  }, [o, S, g, Y, $, _, W]), De = U.useMemo(() => {
    const he = _.setTimezone(o, W), Ce = _.getWeekArray(he);
    let K = _.addMonths(he, 1);
    for (; A && Ce.length < A; ) {
      const ne = _.getWeekArray(K), pe = _.isSameDay(Ce[Ce.length - 1][0], ne[0][0]);
      ne.slice(pe ? 1 : 0).forEach((Me) => {
        Ce.length < A && Ce.push(Me);
      }), K = _.addMonths(K, 1);
    }
    return Ce;
  }, [o, A, _, W]);
  return /* @__PURE__ */ J(aR, {
    role: "grid",
    "aria-labelledby": P,
    className: O.root,
    children: [/* @__PURE__ */ J(sR, {
      role: "row",
      className: O.header,
      children: [F && /* @__PURE__ */ h(cR, {
        variant: "caption",
        role: "columnheader",
        "aria-label": H.calendarWeekNumberHeaderLabel,
        className: O.weekNumberLabel,
        children: H.calendarWeekNumberHeaderText
      }), G1(_, M).map((he, Ce) => {
        var K;
        const ne = _.format(he, "weekdayShort");
        return /* @__PURE__ */ h(lR, {
          variant: "caption",
          role: "columnheader",
          "aria-label": _.format(_.addDays(ue, Ce), "weekday"),
          className: O.weekDayLabel,
          children: (K = L == null ? void 0 : L(ne, he)) != null ? K : ne
        }, ne + Ce.toString());
      })]
    }), l ? /* @__PURE__ */ h(dR, {
      className: O.loadingContainer,
      children: f()
    }) : /* @__PURE__ */ h(fR, z({
      transKey: ae,
      onExited: c,
      reduceAnimations: m,
      slideDirection: p,
      className: mt(r, O.slideTransition)
    }, b, {
      nodeRef: _e,
      children: /* @__PURE__ */ h(pR, {
        ref: _e,
        role: "rowgroup",
        className: O.monthContainer,
        children: De.map((he, Ce) => /* @__PURE__ */ J(mR, {
          role: "row",
          className: O.weekContainer,
          "aria-rowindex": Ce + 1,
          children: [F && /* @__PURE__ */ h(uR, {
            className: O.weekNumber,
            role: "rowheader",
            "aria-label": H.calendarWeekNumberAriaLabelText(_.getWeekNumber(he[0])),
            children: H.calendarWeekNumberText(_.getWeekNumber(he[0]))
          }), he.map((K, ne) => /* @__PURE__ */ h(hR, {
            parentProps: t,
            day: K,
            selectedDays: ee,
            focusableDay: me,
            onKeyDown: se,
            onFocus: fe,
            onBlur: le,
            onDaySelect: ie,
            isDateDisabled: $,
            currentMonthNumber: ce,
            isViewFocused: G,
            "aria-colindex": ne + 1
          }, K.toString()))]
        }, `week-${he[0]}`))
      })
    }))]
  });
}
const yR = (e, t, n) => (r, o) => {
  switch (o.type) {
    case "changeMonth":
      return z({}, r, {
        slideDirection: o.direction,
        currentMonth: o.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "finishMonthSwitchingAnimation":
      return z({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && o.focusedDay != null && n.isSameDay(o.focusedDay, r.focusedDay))
        return r;
      const i = o.focusedDay != null && !t && !n.isSameMonth(r.currentMonth, o.focusedDay);
      return z({}, r, {
        focusedDay: o.focusedDay,
        isMonthSwitchingAnimating: i && !e && !o.withoutMonthSwitchingAnimation,
        currentMonth: i ? n.startOfMonth(o.focusedDay) : r.currentMonth,
        slideDirection: o.focusedDay != null && n.isAfterDay(o.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, bR = (e) => {
  const {
    value: t,
    referenceDate: n,
    defaultCalendarMonth: r,
    disableFuture: o,
    disablePast: i,
    disableSwitchToMonthOnDayFocus: s = !1,
    maxDate: l,
    minDate: u,
    onMonthChange: c,
    reduceAnimations: d,
    shouldDisableDate: m,
    timezone: f
  } = e, p = Wr(f), b = Ue(), g = U.useRef(yR(!!d, s, b)).current, S = U.useMemo(
    () => {
      let I = null;
      return n ? I = n : r && (I = b.startOfMonth(r)), Nt.getInitialReferenceValue({
        value: t,
        utils: b,
        timezone: f,
        props: e,
        referenceDate: I,
        granularity: Rn.day
      });
    },
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), [C, w] = U.useReducer(g, {
    isMonthSwitchingAnimating: !1,
    focusedDay: b.isValid(t) ? t : p,
    currentMonth: b.startOfMonth(S),
    slideDirection: "left"
  }), v = U.useCallback((I) => {
    w(z({
      type: "changeMonth"
    }, I)), c && c(I.newMonth);
  }, [c]), x = U.useCallback((I) => {
    const P = I;
    b.isSameMonth(P, C.currentMonth) || v({
      newMonth: b.startOfMonth(P),
      direction: b.isAfterDay(P, C.currentMonth) ? "left" : "right"
    });
  }, [C.currentMonth, v, b]), T = Hg({
    shouldDisableDate: m,
    minDate: u,
    maxDate: l,
    disableFuture: o,
    disablePast: i,
    timezone: f
  }), E = U.useCallback(() => {
    w({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), k = Ae((I, P) => {
    T(I) || w({
      type: "changeFocusedDay",
      focusedDay: I,
      withoutMonthSwitchingAnimation: P
    });
  });
  return {
    referenceDate: S,
    calendarState: C,
    changeMonth: x,
    changeFocusedDay: k,
    isDateDisabled: T,
    onMonthSwitchingAnimationEnd: E,
    handleChangeMonth: v
  };
}, vR = ["props", "getOpenDialogAriaText"], CR = ["ownerState"], wR = ["ownerState"], dd = (e) => {
  var t, n, r, o, i;
  let {
    props: s,
    getOpenDialogAriaText: l
  } = e, u = $e(e, vR);
  const {
    slots: c,
    slotProps: d,
    className: m,
    sx: f,
    format: p,
    formatDensity: b,
    timezone: g,
    name: S,
    label: C,
    inputRef: w,
    readOnly: v,
    disabled: x,
    autoFocus: T,
    localeText: E,
    reduceAnimations: k
  } = s, I = Ue(), P = U.useRef(null), F = U.useRef(null), A = Hl(), B = (t = d == null || (n = d.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: W,
    actions: M,
    hasUIView: _,
    layoutProps: O,
    renderCurrentView: R,
    shouldRestoreFocus: N,
    fieldProps: L
  } = Rg(z({}, u, {
    props: s,
    inputRef: P,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), $ = (r = c.inputAdornment) != null ? r : Gm, H = xt({
    elementType: $,
    externalSlotProps: d == null ? void 0 : d.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: s
  }), G = $e(H, CR), q = (o = c.openPickerButton) != null ? o : tn, Y = xt({
    elementType: q,
    externalSlotProps: d == null ? void 0 : d.openPickerButton,
    additionalProps: {
      disabled: x || v,
      onClick: W ? M.onClose : M.onOpen,
      "aria-label": l(L.value, I),
      edge: G.position
    },
    ownerState: s
  }), Z = $e(Y, wR), ie = c.openPickerIcon, X = c.field, se = xt({
    elementType: X,
    externalSlotProps: d == null ? void 0 : d.field,
    additionalProps: z({}, L, B && {
      id: A
    }, {
      readOnly: v,
      disabled: x,
      className: m,
      sx: f,
      format: p,
      formatDensity: b,
      timezone: g,
      label: C,
      name: S,
      autoFocus: T && !s.open,
      focused: W ? !0 : void 0
    }),
    ownerState: s
  });
  _ && (se.InputProps = z({}, se.InputProps, {
    ref: F,
    [`${G.position}Adornment`]: /* @__PURE__ */ h($, z({}, G, {
      children: /* @__PURE__ */ h(q, z({}, Z, {
        children: /* @__PURE__ */ h(ie, z({}, d == null ? void 0 : d.openPickerIcon))
      }))
    }))
  }));
  const fe = z({
    textField: c.textField,
    clearIcon: c.clearIcon,
    clearButton: c.clearButton
  }, se.slots), le = (i = c.layout) != null ? i : id, ce = nr(P, se.inputRef, w);
  let ee = A;
  B && (C ? ee = `${A}-label` : ee = void 0);
  const ae = z({}, d, {
    toolbar: z({}, d == null ? void 0 : d.toolbar, {
      titleId: A
    }),
    popper: z({
      "aria-labelledby": ee
    }, d == null ? void 0 : d.popper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ J(Xu, {
      localeText: E,
      children: [/* @__PURE__ */ h(X, z({}, se, {
        slots: fe,
        slotProps: ae,
        inputRef: ce
      })), /* @__PURE__ */ h(ZE, z({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: F.current
      }, M, {
        open: W,
        slots: c,
        slotProps: ae,
        shouldRestoreFocus: N,
        reduceAnimations: k,
        children: /* @__PURE__ */ h(le, z({}, O, ae == null ? void 0 : ae.layout, {
          slots: c,
          slotProps: ae,
          children: R()
        }))
      }))]
    })
  };
}, xR = (e) => {
  var t, n, r;
  const o = Ue(), i = So();
  return z({}, e, {
    disablePast: (t = e.disablePast) != null ? t : !1,
    disableFuture: (n = e.disableFuture) != null ? n : !1,
    format: (r = e.format) != null ? r : o.formats.keyboardDate,
    minDate: Gt(o, e.minDate, i.minDate),
    maxDate: Gt(o, e.maxDate, i.maxDate)
  });
}, SR = ({
  props: e,
  inputRef: t
}) => {
  const n = xR(e), {
    forwardedProps: r,
    internalProps: o
  } = ad(n, "date");
  return od({
    inputRef: t,
    forwardedProps: r,
    internalProps: o,
    valueManager: Nt,
    fieldValueManager: Ju,
    validator: To,
    valueType: "date"
  });
}, TR = ["ownerState"], fd = ({
  clearable: e,
  fieldProps: t,
  InputProps: n,
  onClear: r,
  slots: o,
  slotProps: i,
  components: s,
  componentsProps: l
}) => {
  var u, c, d, m, f, p;
  const b = jt(), g = (u = (c = o == null ? void 0 : o.clearButton) != null ? c : s == null ? void 0 : s.ClearButton) != null ? u : tn, S = xt({
    elementType: g,
    externalSlotProps: (d = i == null ? void 0 : i.clearButton) != null ? d : l == null ? void 0 : l.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: b.fieldClearLabel
    }
  }), C = $e(S, TR), w = (m = (f = o == null ? void 0 : o.clearIcon) != null ? f : s == null ? void 0 : s.ClearIcon) != null ? m : PE, v = xt({
    elementType: w,
    externalSlotProps: (p = i == null ? void 0 : i.clearIcon) != null ? p : l == null ? void 0 : l.clearIcon,
    ownerState: {}
  }), x = z({}, n, {
    endAdornment: /* @__PURE__ */ J(U.Fragment, {
      children: [e && /* @__PURE__ */ h(Gm, {
        position: "end",
        sx: {
          marginRight: n != null && n.endAdornment ? -1 : -1.5
        },
        children: /* @__PURE__ */ h(g, z({}, C, {
          onClick: r,
          children: /* @__PURE__ */ h(w, z({
            fontSize: "small"
          }, v))
        }))
      }), n == null ? void 0 : n.endAdornment]
    })
  }), T = z({}, t, {
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(t.sx) ? t.sx : [t.sx]]
  });
  return {
    InputProps: x,
    fieldProps: T
  };
}, _R = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], DR = ["inputRef"], PR = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], pd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i;
  const s = Ze({
    props: t,
    name: "MuiDateField"
  }), {
    components: l,
    componentsProps: u,
    slots: c,
    slotProps: d,
    InputProps: m,
    inputProps: f
  } = s, p = $e(s, _R), b = s, g = (r = (o = c == null ? void 0 : c.textField) != null ? o : l == null ? void 0 : l.TextField) != null ? r : us, S = xt({
    elementType: g,
    externalSlotProps: (i = d == null ? void 0 : d.textField) != null ? i : u == null ? void 0 : u.textField,
    externalForwardedProps: p,
    ownerState: b
  }), {
    inputRef: C
  } = S, w = $e(S, DR);
  w.inputProps = z({}, f, w.inputProps), w.InputProps = z({}, m, w.InputProps);
  const v = SR({
    props: w,
    inputRef: C
  }), {
    ref: x,
    onPaste: T,
    onKeyDown: E,
    inputMode: k,
    readOnly: I,
    clearable: P,
    onClear: F
  } = v, A = $e(v, PR), {
    InputProps: B,
    fieldProps: W
  } = fd({
    onClear: F,
    clearable: P,
    fieldProps: A,
    InputProps: A.InputProps,
    slots: c,
    slotProps: d,
    components: l,
    componentsProps: u
  });
  return /* @__PURE__ */ h(g, z({
    ref: n
  }, W, {
    InputProps: z({}, B, {
      readOnly: I
    }),
    inputProps: z({}, A.inputProps, {
      inputMode: k,
      onPaste: T,
      onKeyDown: E,
      ref: x
    })
  }));
});
process.env.NODE_ENV !== "production" && (pd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: a.bool,
  className: a.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: a.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: a.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: a.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: a.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: a.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: a.bool,
  /**
   * The helper text content.
   */
  helperText: a.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: a.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: a.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: a.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: a.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: a.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: a.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Name attribute of the `input` element.
   */
  name: a.string,
  onBlur: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  onFocus: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: a.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: a.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: a.bool,
  /**
   * The size of the component.
   */
  size: a.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  style: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: a.oneOfType([a.func, a.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: a.oneOf(["filled", "outlined", "standard"])
});
const OR = (e) => ut("MuiPickersFadeTransitionGroup", e);
ft("MuiPickersFadeTransitionGroup", ["root"]);
const kR = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"]
  }, OR, t);
}, MR = Q(qg, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function Yg(e) {
  const t = Ze({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: r,
    reduceAnimations: o,
    transKey: i
  } = t, s = kR(t), l = qt();
  return o ? n : /* @__PURE__ */ h(MR, {
    className: mt(s.root, r),
    children: /* @__PURE__ */ h(Xo, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: l.transitions.duration.enteringScreen,
        enter: l.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, i)
  });
}
function ER(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
function lo() {
  return lo = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, lo.apply(this, arguments);
}
function Gg(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function cu() {
  return cu = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cu.apply(this, arguments);
}
function zo(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Kg(e) {
  if (!zo(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = Kg(e[n]);
  }), t;
}
function pl(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? cu({}, e) : e;
  return zo(e) && zo(t) && Object.keys(t).forEach((o) => {
    o !== "__proto__" && (zo(t[o]) && o in e && zo(e[o]) ? r[o] = pl(e[o], t[o], n) : n.clone ? r[o] = zo(t[o]) ? Kg(t[o]) : t[o] : r[o] = t[o]);
  }), r;
}
function Zg(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : ER(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const IR = ["values", "unit", "step"], RR = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => lo({}, n, {
    [r.key]: r.val
  }), {});
};
function AR(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = e, o = Gg(e, IR), i = RR(t), s = Object.keys(i);
  function l(f) {
    return `@media (min-width:${typeof t[f] == "number" ? t[f] : f}${n})`;
  }
  function u(f) {
    return `@media (max-width:${(typeof t[f] == "number" ? t[f] : f) - r / 100}${n})`;
  }
  function c(f, p) {
    const b = s.indexOf(p);
    return `@media (min-width:${typeof t[f] == "number" ? t[f] : f}${n}) and (max-width:${(b !== -1 && typeof t[s[b]] == "number" ? t[s[b]] : p) - r / 100}${n})`;
  }
  function d(f) {
    return s.indexOf(f) + 1 < s.length ? c(f, s[s.indexOf(f) + 1]) : l(f);
  }
  function m(f) {
    const p = s.indexOf(f);
    return p === 0 ? l(s[1]) : p === s.length - 1 ? u(s[p]) : c(f, s[s.indexOf(f) + 1]).replace("@media", "@media not all and");
  }
  return lo({
    keys: s,
    values: i,
    up: l,
    down: u,
    between: c,
    only: d,
    not: m,
    unit: n
  }, o);
}
const $R = {
  borderRadius: 4
}, NR = $R, FR = process.env.NODE_ENV !== "production" ? a.oneOfType([a.number, a.string, a.object, a.array]) : {}, qr = FR;
function Ea(e, t) {
  return t ? pl(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const md = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, ip = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${md[e]}px)`
};
function yr(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || ip;
    return t.reduce((s, l, u) => (s[i.up(i.keys[u])] = n(t[u]), s), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || ip;
    return Object.keys(t).reduce((s, l) => {
      if (Object.keys(i.values || md).indexOf(l) !== -1) {
        const u = i.up(l);
        s[u] = n(t[l], l);
      } else {
        const u = l;
        s[u] = t[u];
      }
      return s;
    }, {});
  }
  return n(t);
}
function VR(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((r, o) => {
    const i = e.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function jR(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function Jl(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function ml(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = Jl(e, n) || r, t && (o = t(o, r, e)), o;
}
function Et(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (s) => {
    if (s[t] == null)
      return null;
    const l = s[t], u = s.theme, c = Jl(u, r) || {};
    return yr(s, l, (m) => {
      let f = ml(c, o, m);
      return m === f && typeof m == "string" && (f = ml(c, o, `${t}${m === "default" ? "" : Zg(m)}`, m)), n === !1 ? f : {
        [n]: f
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: qr
  } : {}, i.filterProps = [t], i;
}
function LR(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const BR = {
  m: "margin",
  p: "padding"
}, zR = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, ap = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, WR = LR((e) => {
  if (e.length > 2)
    if (ap[e])
      e = ap[e];
    else
      return [e];
  const [t, n] = e.split(""), r = BR[t], o = zR[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), Xl = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], ec = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], qR = [...Xl, ...ec];
function vs(e, t, n, r) {
  var o;
  const i = (o = Jl(e, t, !1)) != null ? o : n;
  return typeof i == "number" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${s}.`), i * s) : Array.isArray(i) ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > i.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(i)}.`, `${s} > ${i.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), i[s]) : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function Qg(e) {
  return vs(e, "spacing", 8, "spacing");
}
function Cs(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), r = e(n);
  return t >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function HR(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = Cs(t, n), r), {});
}
function UR(e, t, n, r) {
  if (t.indexOf(n) === -1)
    return null;
  const o = WR(n), i = HR(o, r), s = e[n];
  return yr(e, s, i);
}
function Jg(e, t) {
  const n = Qg(e.theme);
  return Object.keys(e).map((r) => UR(e, t, r, n)).reduce(Ea, {});
}
function St(e) {
  return Jg(e, Xl);
}
St.propTypes = process.env.NODE_ENV !== "production" ? Xl.reduce((e, t) => (e[t] = qr, e), {}) : {};
St.filterProps = Xl;
function Tt(e) {
  return Jg(e, ec);
}
Tt.propTypes = process.env.NODE_ENV !== "production" ? ec.reduce((e, t) => (e[t] = qr, e), {}) : {};
Tt.filterProps = ec;
process.env.NODE_ENV !== "production" && qR.reduce((e, t) => (e[t] = qr, e), {});
function YR(e = 8) {
  if (e.mui)
    return e;
  const t = Qg({
    spacing: e
  }), n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const s = t(i);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function tc(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? Ea(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function xn(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function _n(e, t) {
  return Et({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const GR = _n("border", xn), KR = _n("borderTop", xn), ZR = _n("borderRight", xn), QR = _n("borderBottom", xn), JR = _n("borderLeft", xn), XR = _n("borderColor"), eA = _n("borderTopColor"), tA = _n("borderRightColor"), nA = _n("borderBottomColor"), rA = _n("borderLeftColor"), oA = _n("outline", xn), iA = _n("outlineColor"), nc = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = vs(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Cs(t, r)
    });
    return yr(e, e.borderRadius, n);
  }
  return null;
};
nc.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: qr
} : {};
nc.filterProps = ["borderRadius"];
tc(GR, KR, ZR, QR, JR, XR, eA, tA, nA, rA, nc, oA, iA);
const rc = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = vs(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Cs(t, r)
    });
    return yr(e, e.gap, n);
  }
  return null;
};
rc.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: qr
} : {};
rc.filterProps = ["gap"];
const oc = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = vs(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Cs(t, r)
    });
    return yr(e, e.columnGap, n);
  }
  return null;
};
oc.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: qr
} : {};
oc.filterProps = ["columnGap"];
const ic = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = vs(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Cs(t, r)
    });
    return yr(e, e.rowGap, n);
  }
  return null;
};
ic.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: qr
} : {};
ic.filterProps = ["rowGap"];
const aA = Et({
  prop: "gridColumn"
}), sA = Et({
  prop: "gridRow"
}), lA = Et({
  prop: "gridAutoFlow"
}), cA = Et({
  prop: "gridAutoColumns"
}), uA = Et({
  prop: "gridAutoRows"
}), dA = Et({
  prop: "gridTemplateColumns"
}), fA = Et({
  prop: "gridTemplateRows"
}), pA = Et({
  prop: "gridTemplateAreas"
}), mA = Et({
  prop: "gridArea"
});
tc(rc, oc, ic, aA, sA, lA, cA, uA, dA, fA, pA, mA);
function Go(e, t) {
  return t === "grey" ? t : e;
}
const hA = Et({
  prop: "color",
  themeKey: "palette",
  transform: Go
}), gA = Et({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Go
}), yA = Et({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Go
});
tc(hA, gA, yA);
function hn(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const bA = Et({
  prop: "width",
  transform: hn
}), hd = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, o;
      const i = ((r = e.theme) == null || (r = r.breakpoints) == null || (r = r.values) == null ? void 0 : r[n]) || md[n];
      return i ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${i}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: i
      } : {
        maxWidth: hn(n)
      };
    };
    return yr(e, e.maxWidth, t);
  }
  return null;
};
hd.filterProps = ["maxWidth"];
const vA = Et({
  prop: "minWidth",
  transform: hn
}), CA = Et({
  prop: "height",
  transform: hn
}), wA = Et({
  prop: "maxHeight",
  transform: hn
}), xA = Et({
  prop: "minHeight",
  transform: hn
});
Et({
  prop: "size",
  cssProperty: "width",
  transform: hn
});
Et({
  prop: "size",
  cssProperty: "height",
  transform: hn
});
const SA = Et({
  prop: "boxSizing"
});
tc(bA, hd, vA, CA, wA, xA, SA);
const TA = {
  // borders
  border: {
    themeKey: "borders",
    transform: xn
  },
  borderTop: {
    themeKey: "borders",
    transform: xn
  },
  borderRight: {
    themeKey: "borders",
    transform: xn
  },
  borderBottom: {
    themeKey: "borders",
    transform: xn
  },
  borderLeft: {
    themeKey: "borders",
    transform: xn
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: xn
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: nc
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Go
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Go
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Go
  },
  // spacing
  p: {
    style: Tt
  },
  pt: {
    style: Tt
  },
  pr: {
    style: Tt
  },
  pb: {
    style: Tt
  },
  pl: {
    style: Tt
  },
  px: {
    style: Tt
  },
  py: {
    style: Tt
  },
  padding: {
    style: Tt
  },
  paddingTop: {
    style: Tt
  },
  paddingRight: {
    style: Tt
  },
  paddingBottom: {
    style: Tt
  },
  paddingLeft: {
    style: Tt
  },
  paddingX: {
    style: Tt
  },
  paddingY: {
    style: Tt
  },
  paddingInline: {
    style: Tt
  },
  paddingInlineStart: {
    style: Tt
  },
  paddingInlineEnd: {
    style: Tt
  },
  paddingBlock: {
    style: Tt
  },
  paddingBlockStart: {
    style: Tt
  },
  paddingBlockEnd: {
    style: Tt
  },
  m: {
    style: St
  },
  mt: {
    style: St
  },
  mr: {
    style: St
  },
  mb: {
    style: St
  },
  ml: {
    style: St
  },
  mx: {
    style: St
  },
  my: {
    style: St
  },
  margin: {
    style: St
  },
  marginTop: {
    style: St
  },
  marginRight: {
    style: St
  },
  marginBottom: {
    style: St
  },
  marginLeft: {
    style: St
  },
  marginX: {
    style: St
  },
  marginY: {
    style: St
  },
  marginInline: {
    style: St
  },
  marginInlineStart: {
    style: St
  },
  marginInlineEnd: {
    style: St
  },
  marginBlock: {
    style: St
  },
  marginBlockStart: {
    style: St
  },
  marginBlockEnd: {
    style: St
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: rc
  },
  rowGap: {
    style: ic
  },
  columnGap: {
    style: oc
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: hn
  },
  maxWidth: {
    style: hd
  },
  minWidth: {
    transform: hn
  },
  height: {
    transform: hn
  },
  maxHeight: {
    transform: hn
  },
  minHeight: {
    transform: hn
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
}, Xg = TA;
function _A(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function DA(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function PA() {
  function e(n, r, o, i) {
    const s = {
      [n]: r,
      theme: o
    }, l = i[n];
    if (!l)
      return {
        [n]: r
      };
    const {
      cssProperty: u = n,
      themeKey: c,
      transform: d,
      style: m
    } = l;
    if (r == null)
      return null;
    if (c === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const f = Jl(o, c) || {};
    return m ? m(s) : yr(s, r, (b) => {
      let g = ml(f, d, b);
      return b === g && typeof b == "string" && (g = ml(f, d, `${n}${b === "default" ? "" : Zg(b)}`, b)), u === !1 ? g : {
        [u]: g
      };
    });
  }
  function t(n) {
    var r;
    const {
      sx: o,
      theme: i = {}
    } = n || {};
    if (!o)
      return null;
    const s = (r = i.unstable_sxConfig) != null ? r : Xg;
    function l(u) {
      let c = u;
      if (typeof u == "function")
        c = u(i);
      else if (typeof u != "object")
        return u;
      if (!c)
        return null;
      const d = VR(i.breakpoints), m = Object.keys(d);
      let f = d;
      return Object.keys(c).forEach((p) => {
        const b = DA(c[p], i);
        if (b != null)
          if (typeof b == "object")
            if (s[p])
              f = Ea(f, e(p, b, i, s));
            else {
              const g = yr({
                theme: i
              }, b, (S) => ({
                [p]: S
              }));
              _A(g, b) ? f[p] = t({
                sx: b,
                theme: i
              }) : f = Ea(f, g);
            }
          else
            f = Ea(f, e(p, b, i, s));
      }), jR(m, f);
    }
    return Array.isArray(o) ? o.map(l) : l(o);
  }
  return t;
}
const ey = PA();
ey.filterProps = ["sx"];
const OA = ey, kA = ["breakpoints", "palette", "spacing", "shape"];
function MA(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {}
  } = e, s = Gg(e, kA), l = AR(n), u = YR(o);
  let c = pl({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: lo({
      mode: "light"
    }, r),
    spacing: u,
    shape: lo({}, NR, i)
  }, s);
  return c = t.reduce((d, m) => pl(d, m), c), c.unstable_sxConfig = lo({}, Xg, s == null ? void 0 : s.unstable_sxConfig), c.unstable_sx = function(m) {
    return OA({
      sx: m,
      theme: this
    });
  }, c;
}
function EA(e) {
  return Object.keys(e).length === 0;
}
function IA(e = null) {
  const t = U.useContext(yC);
  return !t || EA(t) ? e : t;
}
const RA = MA();
function ty(e = RA) {
  return IA(e);
}
function AA(e) {
  return ut("MuiPickersMonth", e);
}
const As = ft("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), $A = ["autoFocus", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow"], NA = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return st({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, AA, r);
}, FA = Q("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})(({
  ownerState: e
}) => ({
  flexBasis: e.monthsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), VA = Q("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${As.disabled}`]: t.disabled
  }, {
    [`&.${As.selected}`]: t.selected
  }]
})(({
  theme: e
}) => z({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : sn(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : sn(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${As.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${As.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), jA = /* @__PURE__ */ U.memo(function(t) {
  const n = Ze({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: r,
    children: o,
    disabled: i,
    selected: s,
    value: l,
    tabIndex: u,
    onClick: c,
    onKeyDown: d,
    onFocus: m,
    onBlur: f,
    "aria-current": p,
    "aria-label": b
    // We don't want to forward this prop to the root element
  } = n, g = $e(n, $A), S = U.useRef(null), C = NA(n);
  return Ar(() => {
    if (r) {
      var w;
      (w = S.current) == null || w.focus();
    }
  }, [r]), /* @__PURE__ */ h(FA, z({
    className: C.root,
    ownerState: n
  }, g, {
    children: /* @__PURE__ */ h(VA, {
      ref: S,
      disabled: i,
      type: "button",
      role: "radio",
      tabIndex: i ? -1 : u,
      "aria-current": p,
      "aria-checked": s,
      "aria-label": b,
      onClick: (w) => c(w, l),
      onKeyDown: (w) => d(w, l),
      onFocus: (w) => m(w, l),
      onBlur: (w) => f(w, l),
      className: C.monthButton,
      ownerState: n,
      children: o
    })
  }));
});
function LA(e) {
  return ut("MuiMonthCalendar", e);
}
ft("MuiMonthCalendar", ["root"]);
const BA = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId"], zA = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"]
  }, LA, t);
};
function WA(e, t) {
  const n = Ue(), r = So(), o = Ze({
    props: e,
    name: t
  });
  return z({
    disableFuture: !1,
    disablePast: !1
  }, o, {
    minDate: Gt(n, o.minDate, r.minDate),
    maxDate: Gt(n, o.maxDate, r.maxDate)
  });
}
const qA = Q("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: Gl,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), ny = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = WA(t, "MuiMonthCalendar"), {
    className: o,
    value: i,
    defaultValue: s,
    referenceDate: l,
    disabled: u,
    disableFuture: c,
    disablePast: d,
    maxDate: m,
    minDate: f,
    onChange: p,
    shouldDisableMonth: b,
    readOnly: g,
    disableHighlightToday: S,
    autoFocus: C = !1,
    onMonthFocus: w,
    hasFocus: v,
    onFocusedViewChange: x,
    monthsPerRow: T = 3,
    timezone: E,
    gridLabelId: k
  } = r, I = $e(r, BA), {
    value: P,
    handleValueChange: F,
    timezone: A
  } = Ci({
    name: "MonthCalendar",
    timezone: E,
    value: i,
    defaultValue: s,
    onChange: p,
    valueManager: Nt
  }), B = Wr(A), W = ty(), M = Ue(), _ = U.useMemo(
    () => Nt.getInitialReferenceValue({
      value: P,
      utils: M,
      props: r,
      timezone: A,
      referenceDate: l,
      granularity: Rn.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), O = r, R = zA(O), N = U.useMemo(() => M.getMonth(B), [M, B]), L = U.useMemo(() => P != null ? M.getMonth(P) : S ? null : M.getMonth(_), [P, M, S, _]), [$, H] = U.useState(() => L || N), [G, q] = $r({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: v,
    default: C ?? !1
  }), Y = Ae((ce) => {
    q(ce), x && x(ce);
  }), Z = U.useCallback((ce) => {
    const ee = M.startOfMonth(d && M.isAfter(B, f) ? B : f), ae = M.startOfMonth(c && M.isBefore(B, m) ? B : m), _e = M.startOfMonth(ce);
    return M.isBefore(_e, ee) || M.isAfter(_e, ae) ? !0 : b ? b(_e) : !1;
  }, [c, d, m, f, B, b, M]), ie = Ae((ce, ee) => {
    if (g)
      return;
    const ae = M.setMonth(P ?? _, ee);
    F(ae);
  }), X = Ae((ce) => {
    Z(M.setMonth(P ?? _, ce)) || (H(ce), Y(!0), w && w(ce));
  });
  U.useEffect(() => {
    H((ce) => L !== null && ce !== L ? L : ce);
  }, [L]);
  const se = Ae((ce, ee) => {
    switch (ce.key) {
      case "ArrowUp":
        X((12 + ee - 3) % 12), ce.preventDefault();
        break;
      case "ArrowDown":
        X((12 + ee + 3) % 12), ce.preventDefault();
        break;
      case "ArrowLeft":
        X((12 + ee + (W.direction === "ltr" ? -1 : 1)) % 12), ce.preventDefault();
        break;
      case "ArrowRight":
        X((12 + ee + (W.direction === "ltr" ? 1 : -1)) % 12), ce.preventDefault();
        break;
    }
  }), fe = Ae((ce, ee) => {
    X(ee);
  }), le = Ae((ce, ee) => {
    $ === ee && Y(!1);
  });
  return /* @__PURE__ */ h(qA, z({
    ref: n,
    className: mt(R.root, o),
    ownerState: O,
    role: "radiogroup",
    "aria-labelledby": k
  }, I, {
    children: Gu(M, P ?? _).map((ce) => {
      const ee = M.getMonth(ce), ae = M.format(ce, "monthShort"), _e = M.format(ce, "month"), ue = ee === L, me = u || Z(ce);
      return /* @__PURE__ */ h(jA, {
        selected: ue,
        value: ee,
        onClick: ie,
        onKeyDown: se,
        autoFocus: G && ee === $,
        disabled: me,
        tabIndex: ee === $ ? 0 : -1,
        onFocus: fe,
        onBlur: le,
        "aria-current": N === ee ? "date" : void 0,
        "aria-label": _e,
        monthsPerRow: T,
        children: ae
      }, ae);
    })
  }));
});
process.env.NODE_ENV !== "production" && (ny.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * className applied to the root element.
   */
  className: a.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true` picker is disabled
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  gridLabelId: a.string,
  hasFocus: a.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: a.func,
  onFocusedViewChange: a.func,
  onMonthFocus: a.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: a.any,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any
});
function HA(e) {
  return ut("MuiPickersYear", e);
}
const $s = ft("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), UA = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"], YA = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return st({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, HA, r);
}, GA = Q("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})(({
  ownerState: e
}) => ({
  flexBasis: e.yearsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), KA = Q("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${$s.disabled}`]: t.disabled
  }, {
    [`&.${$s.selected}`]: t.selected
  }]
})(({
  theme: e
}) => z({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : sn(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : sn(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${$s.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${$s.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), ZA = /* @__PURE__ */ U.memo(function(t) {
  const n = Ze({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: r,
    className: o,
    children: i,
    disabled: s,
    selected: l,
    value: u,
    tabIndex: c,
    onClick: d,
    onKeyDown: m,
    onFocus: f,
    onBlur: p,
    "aria-current": b
    // We don't want to forward this prop to the root element
  } = n, g = $e(n, UA), S = U.useRef(null), C = YA(n);
  return U.useEffect(() => {
    r && S.current.focus();
  }, [r]), /* @__PURE__ */ h(GA, z({
    className: mt(C.root, o),
    ownerState: n
  }, g, {
    children: /* @__PURE__ */ h(KA, {
      ref: S,
      disabled: s,
      type: "button",
      role: "radio",
      tabIndex: s ? -1 : c,
      "aria-current": b,
      "aria-checked": l,
      onClick: (w) => d(w, u),
      onKeyDown: (w) => m(w, u),
      onFocus: (w) => f(w, u),
      onBlur: (w) => p(w, u),
      className: C.yearButton,
      ownerState: n,
      children: i
    })
  }));
});
function QA(e) {
  return ut("MuiYearCalendar", e);
}
ft("MuiYearCalendar", ["root"]);
const JA = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId"], XA = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"]
  }, QA, t);
};
function e$(e, t) {
  var n;
  const r = Ue(), o = So(), i = Ze({
    props: e,
    name: t
  });
  return z({
    disablePast: !1,
    disableFuture: !1
  }, i, {
    yearsPerRow: (n = i.yearsPerRow) != null ? n : 3,
    minDate: Gt(r, i.minDate, o.minDate),
    maxDate: Gt(r, i.maxDate, o.maxDate)
  });
}
const t$ = Q("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: Gl,
  maxHeight: $E,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), ry = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = e$(t, "MuiYearCalendar"), {
    autoFocus: o,
    className: i,
    value: s,
    defaultValue: l,
    referenceDate: u,
    disabled: c,
    disableFuture: d,
    disablePast: m,
    maxDate: f,
    minDate: p,
    onChange: b,
    readOnly: g,
    shouldDisableYear: S,
    disableHighlightToday: C,
    onYearFocus: w,
    hasFocus: v,
    onFocusedViewChange: x,
    yearsPerRow: T,
    timezone: E,
    gridLabelId: k
  } = r, I = $e(r, JA), {
    value: P,
    handleValueChange: F,
    timezone: A
  } = Ci({
    name: "YearCalendar",
    timezone: E,
    value: s,
    defaultValue: l,
    onChange: b,
    valueManager: Nt
  }), B = Wr(A), W = ty(), M = Ue(), _ = U.useMemo(
    () => Nt.getInitialReferenceValue({
      value: P,
      utils: M,
      props: r,
      timezone: A,
      referenceDate: u,
      granularity: Rn.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), O = r, R = XA(O), N = U.useMemo(() => M.getYear(B), [M, B]), L = U.useMemo(() => P != null ? M.getYear(P) : C ? null : M.getYear(_), [P, M, C, _]), [$, H] = U.useState(() => L || N), [G, q] = $r({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: v,
    default: o ?? !1
  }), Y = Ae((ae) => {
    q(ae), x && x(ae);
  }), Z = U.useCallback((ae) => {
    if (m && M.isBeforeYear(ae, B) || d && M.isAfterYear(ae, B) || p && M.isBeforeYear(ae, p) || f && M.isAfterYear(ae, f))
      return !0;
    if (!S)
      return !1;
    const _e = M.startOfYear(ae);
    return S(_e);
  }, [d, m, f, p, B, S, M]), ie = Ae((ae, _e) => {
    if (g)
      return;
    const ue = M.setYear(P ?? _, _e);
    F(ue);
  }), X = Ae((ae) => {
    Z(M.setYear(P ?? _, ae)) || (H(ae), Y(!0), w == null || w(ae));
  });
  U.useEffect(() => {
    H((ae) => L !== null && ae !== L ? L : ae);
  }, [L]);
  const se = Ae((ae, _e) => {
    switch (ae.key) {
      case "ArrowUp":
        X(_e - T), ae.preventDefault();
        break;
      case "ArrowDown":
        X(_e + T), ae.preventDefault();
        break;
      case "ArrowLeft":
        X(_e + (W.direction === "ltr" ? -1 : 1)), ae.preventDefault();
        break;
      case "ArrowRight":
        X(_e + (W.direction === "ltr" ? 1 : -1)), ae.preventDefault();
        break;
    }
  }), fe = Ae((ae, _e) => {
    X(_e);
  }), le = Ae((ae, _e) => {
    $ === _e && Y(!1);
  }), ce = U.useRef(null), ee = nr(n, ce);
  return U.useEffect(() => {
    if (o || ce.current === null)
      return;
    const ae = ce.current.querySelector('[tabindex="0"]');
    if (!ae)
      return;
    const _e = ae.offsetHeight, ue = ae.offsetTop, me = ce.current.clientHeight, De = ce.current.scrollTop, he = ue + _e;
    _e > me || ue < De || (ce.current.scrollTop = he - me / 2 - _e / 2);
  }, [o]), /* @__PURE__ */ h(t$, z({
    ref: ee,
    className: mt(R.root, i),
    ownerState: O,
    role: "radiogroup",
    "aria-labelledby": k
  }, I, {
    children: M.getYearRange(p, f).map((ae) => {
      const _e = M.getYear(ae), ue = _e === L, me = c || Z(ae);
      return /* @__PURE__ */ h(ZA, {
        selected: ue,
        value: _e,
        onClick: ie,
        onKeyDown: se,
        autoFocus: G && _e === $,
        disabled: me,
        tabIndex: _e === $ ? 0 : -1,
        onFocus: fe,
        onBlur: le,
        "aria-current": N === _e ? "date" : void 0,
        yearsPerRow: T,
        children: M.format(ae, "year")
      }, M.format(ae, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (ry.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * className applied to the root element.
   */
  className: a.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true` picker is disabled
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  gridLabelId: a.string,
  hasFocus: a.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: a.func,
  onFocusedViewChange: a.func,
  onYearFocus: a.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: a.any,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: a.oneOf([3, 4])
});
const n$ = (e) => ut("MuiPickersCalendarHeader", e), r$ = ft("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), o$ = ["slots", "slotProps", "components", "componentsProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone"], i$ = ["ownerState"], a$ = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, n$, t);
}, s$ = Q("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
}), l$ = Q("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => z({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), c$ = Q("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), u$ = Q(tn, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})(({
  ownerState: e
}) => z({
  marginRight: "auto"
}, e.view === "year" && {
  [`.${r$.switchViewIcon}`]: {
    transform: "rotate(180deg)"
  }
})), d$ = Q(wE, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), oy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s;
  const l = jt(), u = Ue(), c = Ze({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: d,
    slotProps: m,
    components: f,
    currentMonth: p,
    disabled: b,
    disableFuture: g,
    disablePast: S,
    maxDate: C,
    minDate: w,
    onMonthChange: v,
    onViewChange: x,
    view: T,
    reduceAnimations: E,
    views: k,
    labelId: I,
    className: P,
    timezone: F
  } = c, A = $e(c, o$), B = c, W = a$(c), M = (r = (o = d == null ? void 0 : d.switchViewButton) != null ? o : f == null ? void 0 : f.SwitchViewButton) != null ? r : u$, _ = xt({
    elementType: M,
    externalSlotProps: m == null ? void 0 : m.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": l.calendarViewSwitchingButtonAriaLabel(T)
    },
    ownerState: B,
    className: W.switchViewButton
  }), O = (i = (s = d == null ? void 0 : d.switchViewIcon) != null ? s : f == null ? void 0 : f.SwitchViewIcon) != null ? i : d$, R = xt({
    elementType: O,
    externalSlotProps: m == null ? void 0 : m.switchViewIcon,
    ownerState: void 0,
    className: W.switchViewIcon
  }), N = $e(R, i$), L = () => v(u.addMonths(p, 1), "left"), $ = () => v(u.addMonths(p, -1), "right"), H = OI(p, {
    disableFuture: g,
    maxDate: C,
    timezone: F
  }), G = kI(p, {
    disablePast: S,
    minDate: w,
    timezone: F
  }), q = () => {
    if (!(k.length === 1 || !x || b))
      if (k.length === 2)
        x(k.find((Y) => Y !== T) || k[0]);
      else {
        const Y = k.indexOf(T) !== 0 ? 0 : 1;
        x(k[Y]);
      }
  };
  return k.length === 1 && k[0] === "year" ? null : /* @__PURE__ */ J(s$, z({}, A, {
    ownerState: B,
    className: mt(P, W.root),
    ref: n,
    children: [/* @__PURE__ */ J(l$, {
      role: "presentation",
      onClick: q,
      ownerState: B,
      "aria-live": "polite",
      className: W.labelContainer,
      children: [/* @__PURE__ */ h(Yg, {
        reduceAnimations: E,
        transKey: u.format(p, "monthAndYear"),
        children: /* @__PURE__ */ h(c$, {
          id: I,
          ownerState: B,
          className: W.label,
          children: u.format(p, "monthAndYear")
        })
      }), k.length > 1 && !b && /* @__PURE__ */ h(M, z({}, _, {
        children: /* @__PURE__ */ h(O, z({}, N))
      }))]
    }), /* @__PURE__ */ h(Xo, {
      in: T === "day",
      children: /* @__PURE__ */ h(kg, {
        slots: d,
        slotProps: m,
        onGoToPrevious: $,
        isPreviousDisabled: G,
        previousLabel: l.previousMonth,
        onGoToNext: L,
        isNextDisabled: H,
        nextLabel: l.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (oy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * className applied to the root element.
   */
  className: a.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  currentMonth: a.any.isRequired,
  disabled: a.bool,
  disableFuture: a.bool,
  disablePast: a.bool,
  labelId: a.string,
  maxDate: a.any.isRequired,
  minDate: a.any.isRequired,
  onMonthChange: a.func.isRequired,
  onViewChange: a.func,
  reduceAnimations: a.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  timezone: a.string.isRequired,
  view: a.oneOf(["day", "month", "year"]).isRequired,
  views: a.arrayOf(a.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const ac = Q("div")({
  overflow: "hidden",
  width: Gl,
  maxHeight: Kl,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), f$ = (e) => ut("MuiDateCalendar", e);
ft("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const p$ = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "defaultCalendarMonth", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "components", "componentsProps", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"], m$ = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, f$, t);
};
function h$(e, t) {
  var n, r, o, i, s, l, u;
  const c = Ue(), d = So(), m = Eg(), f = Ze({
    props: e,
    name: t
  });
  return z({}, f, {
    loading: (n = f.loading) != null ? n : !1,
    disablePast: (r = f.disablePast) != null ? r : !1,
    disableFuture: (o = f.disableFuture) != null ? o : !1,
    openTo: (i = f.openTo) != null ? i : "day",
    views: (s = f.views) != null ? s : ["year", "day"],
    reduceAnimations: (l = f.reduceAnimations) != null ? l : m,
    renderLoading: (u = f.renderLoading) != null ? u : () => /* @__PURE__ */ h("span", {
      children: "..."
    }),
    minDate: Gt(c, f.minDate, d.minDate),
    maxDate: Gt(c, f.maxDate, d.maxDate)
  });
}
const g$ = Q(ac, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: Kl
}), y$ = Q(Yg, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), gd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i;
  const s = Ue(), l = Hl(), u = h$(t, "MuiDateCalendar"), {
    autoFocus: c,
    onViewChange: d,
    value: m,
    defaultValue: f,
    referenceDate: p,
    disableFuture: b,
    disablePast: g,
    defaultCalendarMonth: S,
    onChange: C,
    onYearChange: w,
    onMonthChange: v,
    reduceAnimations: x,
    shouldDisableDate: T,
    shouldDisableMonth: E,
    shouldDisableYear: k,
    view: I,
    views: P,
    openTo: F,
    className: A,
    disabled: B,
    readOnly: W,
    minDate: M,
    maxDate: _,
    disableHighlightToday: O,
    focusedView: R,
    onFocusedViewChange: N,
    showDaysOutsideCurrentMonth: L,
    fixedWeekNumber: $,
    dayOfWeekFormatter: H,
    components: G,
    componentsProps: q,
    slots: Y,
    slotProps: Z,
    loading: ie,
    renderLoading: X,
    displayWeekNumber: se,
    yearsPerRow: fe,
    monthsPerRow: le,
    timezone: ce
  } = u, ee = $e(u, p$), {
    value: ae,
    handleValueChange: _e,
    timezone: ue
  } = Ci({
    name: "DateCalendar",
    timezone: ce,
    value: m,
    defaultValue: f,
    onChange: C,
    valueManager: Nt
  }), {
    view: me,
    setView: De,
    focusedView: he,
    setFocusedView: Ce,
    goToNextView: K,
    setValueAndGoToNextView: ne
  } = ys({
    view: I,
    views: P,
    openTo: F,
    onChange: _e,
    onViewChange: d,
    autoFocus: c,
    focusedView: R,
    onFocusedViewChange: N
  }), {
    referenceDate: pe,
    calendarState: Me,
    changeFocusedDay: de,
    changeMonth: ye,
    handleChangeMonth: Te,
    isDateDisabled: Re,
    onMonthSwitchingAnimationEnd: We
  } = bR({
    value: ae,
    defaultCalendarMonth: S,
    referenceDate: p,
    reduceAnimations: x,
    onMonthChange: v,
    minDate: M,
    maxDate: _,
    shouldDisableDate: T,
    disablePast: g,
    disableFuture: b,
    timezone: ue
  }), ht = B && ae || M, gt = B && ae || _, Qt = `${l}-grid-label`, Lt = he !== null, yt = (r = (o = Y == null ? void 0 : Y.calendarHeader) != null ? o : G == null ? void 0 : G.CalendarHeader) != null ? r : oy, dn = xt({
    elementType: yt,
    externalSlotProps: (i = Z == null ? void 0 : Z.calendarHeader) != null ? i : q == null ? void 0 : q.calendarHeader,
    additionalProps: {
      views: P,
      view: me,
      currentMonth: Me.currentMonth,
      onViewChange: De,
      onMonthChange: (He, Ut) => Te({
        newMonth: He,
        direction: Ut
      }),
      minDate: ht,
      maxDate: gt,
      disabled: B,
      disablePast: g,
      disableFuture: b,
      reduceAnimations: x,
      timezone: ue,
      labelId: Qt,
      slots: Y,
      slotProps: Z
    },
    ownerState: u
  }), Dn = Ae((He) => {
    const Ut = s.startOfMonth(He), On = s.endOfMonth(He), on = Re(He) ? Ma({
      utils: s,
      date: He,
      minDate: s.isBefore(M, Ut) ? Ut : M,
      maxDate: s.isAfter(_, On) ? On : _,
      disablePast: g,
      disableFuture: b,
      isDateDisabled: Re,
      timezone: ue
    }) : He;
    on ? (ne(on, "finish"), v == null || v(Ut)) : (K(), ye(Ut)), de(on, !0);
  }), bt = Ae((He) => {
    const Ut = s.startOfYear(He), On = s.endOfYear(He), on = Re(He) ? Ma({
      utils: s,
      date: He,
      minDate: s.isBefore(M, Ut) ? Ut : M,
      maxDate: s.isAfter(_, On) ? On : _,
      disablePast: g,
      disableFuture: b,
      isDateDisabled: Re,
      timezone: ue
    }) : He;
    on ? (ne(on, "finish"), w == null || w(on)) : (K(), ye(Ut)), de(on, !0);
  }), $t = Ae((He) => _e(He && ou(s, He, ae ?? pe), "finish", me));
  U.useEffect(() => {
    ae != null && s.isValid(ae) && ye(ae);
  }, [ae]);
  const Bt = u, rn = m$(Bt), Pn = {
    disablePast: g,
    disableFuture: b,
    maxDate: _,
    minDate: M
  }, fn = {
    disableHighlightToday: O,
    readOnly: W,
    disabled: B,
    timezone: ue,
    gridLabelId: Qt
  }, Pt = U.useRef(me);
  U.useEffect(() => {
    Pt.current !== me && (he === Pt.current && Ce(me, !0), Pt.current = me);
  }, [he, Ce, me]);
  const Hr = U.useMemo(() => [ae], [ae]);
  return /* @__PURE__ */ J(g$, z({
    ref: n,
    className: mt(rn.root, A),
    ownerState: Bt
  }, ee, {
    children: [/* @__PURE__ */ h(yt, z({}, dn)), /* @__PURE__ */ h(y$, {
      reduceAnimations: x,
      className: rn.viewTransitionContainer,
      transKey: me,
      ownerState: Bt,
      children: /* @__PURE__ */ J("div", {
        children: [me === "year" && /* @__PURE__ */ h(ry, z({}, Pn, fn, {
          value: ae,
          onChange: bt,
          shouldDisableYear: k,
          hasFocus: Lt,
          onFocusedViewChange: (He) => Ce("year", He),
          yearsPerRow: fe,
          referenceDate: pe
        })), me === "month" && /* @__PURE__ */ h(ny, z({}, Pn, fn, {
          hasFocus: Lt,
          className: A,
          value: ae,
          onChange: Dn,
          shouldDisableMonth: E,
          onFocusedViewChange: (He) => Ce("month", He),
          monthsPerRow: le,
          referenceDate: pe
        })), me === "day" && /* @__PURE__ */ h(gR, z({}, Me, Pn, fn, {
          onMonthSwitchingAnimationEnd: We,
          onFocusedDayChange: de,
          reduceAnimations: x,
          selectedDays: Hr,
          onSelectedDaysChange: $t,
          shouldDisableDate: T,
          shouldDisableMonth: E,
          shouldDisableYear: k,
          hasFocus: Lt,
          onFocusedViewChange: (He) => Ce("day", He),
          showDaysOutsideCurrentMonth: L,
          fixedWeekNumber: $,
          dayOfWeekFormatter: H,
          displayWeekNumber: se,
          components: G,
          componentsProps: q,
          slots: Y,
          slotProps: Z,
          loading: ie,
          renderLoading: X
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (gd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  classes: a.object,
  className: a.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: a.oneOf([3, 4])
});
const Sn = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: o,
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minDate: p,
  maxDate: b,
  shouldDisableDate: g,
  shouldDisableMonth: S,
  shouldDisableYear: C,
  reduceAnimations: w,
  onMonthChange: v,
  monthsPerRow: x,
  onYearChange: T,
  yearsPerRow: E,
  defaultCalendarMonth: k,
  components: I,
  componentsProps: P,
  slots: F,
  slotProps: A,
  loading: B,
  renderLoading: W,
  disableHighlightToday: M,
  readOnly: _,
  disabled: O,
  showDaysOutsideCurrentMonth: R,
  dayOfWeekFormatter: N,
  sx: L,
  autoFocus: $,
  fixedWeekNumber: H,
  displayWeekNumber: G,
  timezone: q
}) => /* @__PURE__ */ h(gd, {
  view: e,
  onViewChange: t,
  views: n.filter(Uo),
  focusedView: r && Uo(r) ? r : null,
  onFocusedViewChange: o,
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minDate: p,
  maxDate: b,
  shouldDisableDate: g,
  shouldDisableMonth: S,
  shouldDisableYear: C,
  reduceAnimations: w,
  onMonthChange: v,
  monthsPerRow: x,
  onYearChange: T,
  yearsPerRow: E,
  defaultCalendarMonth: k,
  components: I,
  componentsProps: P,
  slots: F,
  slotProps: A,
  loading: B,
  renderLoading: W,
  disableHighlightToday: M,
  readOnly: _,
  disabled: O,
  showDaysOutsideCurrentMonth: R,
  dayOfWeekFormatter: N,
  sx: L,
  autoFocus: $,
  fixedWeekNumber: H,
  displayWeekNumber: G,
  timezone: q
}), iy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s;
  const l = jt(), u = Ue(), c = Pg(t, "MuiDesktopDatePicker"), d = z({
    day: Sn,
    month: Sn,
    year: Sn
  }, c.viewRenderers), m = z({}, c, {
    viewRenderers: d,
    format: Qa(u, c, !1),
    yearsPerRow: (r = c.yearsPerRow) != null ? r : 4,
    slots: z({
      openPickerIcon: Og,
      field: pd
    }, c.slots),
    slotProps: z({}, c.slotProps, {
      field: (p) => {
        var b;
        return z({}, zr((b = c.slotProps) == null ? void 0 : b.field, p), wi(c), {
          ref: n
        });
      },
      toolbar: z({
        hidden: !0
      }, (o = c.slotProps) == null ? void 0 : o.toolbar)
    })
  }), {
    renderPicker: f
  } = dd({
    props: m,
    valueManager: Nt,
    valueType: "date",
    getOpenDialogAriaText: (i = (s = m.localeText) == null ? void 0 : s.openDatePickerDialogue) != null ? i : l.openDatePickerDialogue,
    validator: To
  });
  return f();
});
iy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    day: a.func,
    month: a.func,
    year: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: a.oneOf([3, 4])
};
const b$ = ["props", "getOpenDialogAriaText"], yd = (e) => {
  var t, n, r;
  let {
    props: o,
    getOpenDialogAriaText: i
  } = e, s = $e(e, b$);
  const {
    slots: l,
    slotProps: u,
    className: c,
    sx: d,
    format: m,
    formatDensity: f,
    timezone: p,
    name: b,
    label: g,
    inputRef: S,
    readOnly: C,
    disabled: w,
    localeText: v
  } = o, x = Ue(), T = U.useRef(null), E = Hl(), k = (t = u == null || (n = u.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: I,
    actions: P,
    layoutProps: F,
    renderCurrentView: A,
    fieldProps: B
  } = Rg(z({}, s, {
    props: o,
    inputRef: T,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), W = l.field, M = xt({
    elementType: W,
    externalSlotProps: u == null ? void 0 : u.field,
    additionalProps: z({}, B, k && {
      id: E
    }, !(w || C) && {
      onClick: P.onOpen,
      onKeyDown: LE(P.onOpen)
    }, {
      readOnly: C ?? !0,
      disabled: w,
      className: c,
      sx: d,
      format: m,
      formatDensity: f,
      timezone: p,
      label: g,
      name: b
    }),
    ownerState: o
  });
  M.inputProps = z({}, M.inputProps, {
    "aria-label": i(B.value, x)
  });
  const _ = z({
    textField: l.textField
  }, M.slots), O = (r = l.layout) != null ? r : id, R = nr(T, M.inputRef, S);
  let N = E;
  k && (g ? N = `${E}-label` : N = void 0);
  const L = z({}, u, {
    toolbar: z({}, u == null ? void 0 : u.toolbar, {
      titleId: E
    }),
    mobilePaper: z({
      "aria-labelledby": N
    }, u == null ? void 0 : u.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ J(Xu, {
      localeText: v,
      children: [/* @__PURE__ */ h(W, z({}, M, {
        slots: _,
        slotProps: L,
        inputRef: R
      })), /* @__PURE__ */ h(VE, z({}, P, {
        open: I,
        slots: l,
        slotProps: L,
        children: /* @__PURE__ */ h(O, z({}, F, L == null ? void 0 : L.layout, {
          slots: l,
          slotProps: L,
          children: A()
        }))
      }))]
    })
  };
}, bd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i;
  const s = jt(), l = Ue(), u = Pg(t, "MuiMobileDatePicker"), c = z({
    day: Sn,
    month: Sn,
    year: Sn
  }, u.viewRenderers), d = z({}, u, {
    viewRenderers: c,
    format: Qa(l, u, !1),
    slots: z({
      field: pd
    }, u.slots),
    slotProps: z({}, u.slotProps, {
      field: (f) => {
        var p;
        return z({}, zr((p = u.slotProps) == null ? void 0 : p.field, f), wi(u), {
          ref: n
        });
      },
      toolbar: z({
        hidden: !1
      }, (r = u.slotProps) == null ? void 0 : r.toolbar)
    })
  }), {
    renderPicker: m
  } = yd({
    props: d,
    valueManager: Nt,
    valueType: "date",
    getOpenDialogAriaText: (o = (i = d.localeText) == null ? void 0 : i.openDatePickerDialogue) != null ? o : s.openDatePickerDialogue,
    validator: To
  });
  return m();
});
bd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    day: a.func,
    month: a.func,
    year: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: a.oneOf([3, 4])
};
const v$ = ["desktopModeMediaQuery"], vd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: o = td
  } = r, i = $e(r, v$);
  return jr(o, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ h(iy, z({
    ref: n
  }, i)) : /* @__PURE__ */ h(bd, z({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (vd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: a.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    day: a.func,
    month: a.func,
    year: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: a.oneOf([3, 4])
});
const C$ = (e) => {
  var t, n, r, o, i, s, l, u;
  const c = Ue(), d = So(), f = ((t = e.ampm) != null ? t : c.is12HourCycleInCurrentLocale()) ? c.formats.keyboardDateTime12h : c.formats.keyboardDateTime24h;
  return z({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (r = e.disableFuture) != null ? r : !1,
    format: (o = e.format) != null ? o : f,
    disableIgnoringDatePartForTimeValidation: !!(e.minDateTime || e.maxDateTime),
    minDate: Gt(c, (i = e.minDateTime) != null ? i : e.minDate, d.minDate),
    maxDate: Gt(c, (s = e.maxDateTime) != null ? s : e.maxDate, d.maxDate),
    minTime: (l = e.minDateTime) != null ? l : e.minTime,
    maxTime: (u = e.maxDateTime) != null ? u : e.maxTime
  });
}, w$ = ({
  props: e,
  inputRef: t
}) => {
  const n = C$(e), {
    forwardedProps: r,
    internalProps: o
  } = ad(n, "date-time");
  return od({
    inputRef: t,
    forwardedProps: r,
    internalProps: o,
    valueManager: Nt,
    fieldValueManager: Ju,
    validator: Ql,
    valueType: "date-time"
  });
}, x$ = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], S$ = ["inputRef"], T$ = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Cd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i;
  const s = Ze({
    props: t,
    name: "MuiDateTimeField"
  }), {
    components: l,
    componentsProps: u,
    slots: c,
    slotProps: d,
    InputProps: m,
    inputProps: f
  } = s, p = $e(s, x$), b = s, g = (r = (o = c == null ? void 0 : c.textField) != null ? o : l == null ? void 0 : l.TextField) != null ? r : us, S = xt({
    elementType: g,
    externalSlotProps: (i = d == null ? void 0 : d.textField) != null ? i : u == null ? void 0 : u.textField,
    externalForwardedProps: p,
    ownerState: b
  }), {
    inputRef: C
  } = S, w = $e(S, S$);
  w.inputProps = z({}, f, w.inputProps), w.InputProps = z({}, m, w.InputProps);
  const v = w$({
    props: w,
    inputRef: C
  }), {
    ref: x,
    onPaste: T,
    onKeyDown: E,
    inputMode: k,
    readOnly: I,
    clearable: P,
    onClear: F
  } = v, A = $e(v, T$), {
    InputProps: B,
    fieldProps: W
  } = fd({
    onClear: F,
    clearable: P,
    fieldProps: A,
    InputProps: A.InputProps,
    slots: c,
    slotProps: d,
    components: l,
    componentsProps: u
  });
  return /* @__PURE__ */ h(g, z({
    ref: n
  }, W, {
    InputProps: z({}, B, {
      readOnly: I
    }),
    inputProps: z({}, A.inputProps, {
      inputMode: k,
      onPaste: T,
      onKeyDown: E,
      ref: x
    })
  }));
});
process.env.NODE_ENV !== "production" && (Cd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: a.bool,
  className: a.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: a.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: a.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: a.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: a.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: a.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: a.bool,
  /**
   * The helper text content.
   */
  helperText: a.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: a.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: a.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: a.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: a.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: a.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: a.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: a.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Name attribute of the `input` element.
   */
  name: a.string,
  onBlur: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  onFocus: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: a.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: a.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: a.bool,
  /**
   * The size of the component.
   */
  size: a.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  style: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: a.oneOfType([a.func, a.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: a.oneOf(["filled", "outlined", "standard"])
});
function _$(e) {
  return ut("MuiDateTimePickerTabs", e);
}
ft("MuiDateTimePickerTabs", ["root"]);
const D$ = (e) => Uo(e) ? "date" : "time", P$ = (e) => e === "date" ? "day" : "hours", O$ = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"]
  }, _$, t);
}, k$ = Q(Jm, {
  name: "MuiDateTimePickerTabs",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  boxShadow: `0 -1px 0 0 inset ${(e.vars || e).palette.divider}`,
  "&:last-child": {
    boxShadow: `0 1px 0 0 inset ${(e.vars || e).palette.divider}`,
    [`& .${TC.indicator}`]: {
      bottom: "auto",
      top: 0
    }
  }
})), ay = function(t) {
  const n = Ze({
    props: t,
    name: "MuiDateTimePickerTabs"
  }), {
    dateIcon: r = /* @__PURE__ */ h(_E, {}),
    onViewChange: o,
    timeIcon: i = /* @__PURE__ */ h(DE, {}),
    view: s,
    hidden: l = typeof window > "u" || window.innerHeight < 667
  } = n, u = jt(), c = O$(n), d = (m, f) => {
    o(P$(f));
  };
  return l ? null : /* @__PURE__ */ J(k$, {
    ownerState: n,
    variant: "fullWidth",
    value: D$(s),
    onChange: d,
    className: c.root,
    children: [/* @__PURE__ */ h(Zc, {
      value: "date",
      "aria-label": u.dateTableLabel,
      icon: /* @__PURE__ */ h(U.Fragment, {
        children: r
      })
    }), /* @__PURE__ */ h(Zc, {
      value: "time",
      "aria-label": u.timeTableLabel,
      icon: /* @__PURE__ */ h(U.Fragment, {
        children: i
      })
    })]
  });
};
process.env.NODE_ENV !== "production" && (ay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * Date tab icon.
   * @default DateRange
   */
  dateIcon: a.node,
  /**
   * Toggles visibility of the tabs allowing view switching.
   * @default `window.innerHeight < 667` for `DesktopDateTimePicker` and `MobileDateTimePicker`, `displayStaticWrapperAs === 'desktop'` for `StaticDateTimePicker`
   */
  hidden: a.bool,
  /**
   * Callback called when a tab is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: a.func.isRequired,
  /**
   * Time tab icon.
   * @default Time
   */
  timeIcon: a.node,
  /**
   * Currently visible picker view.
   */
  view: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired
});
function M$(e) {
  return ut("MuiDateTimePickerToolbar", e);
}
const Pc = ft("MuiDateTimePickerToolbar", ["root", "dateContainer", "timeContainer", "timeDigitsContainer", "separator", "timeLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), E$ = ["ampm", "ampmInClock", "value", "onChange", "view", "isLandscape", "onViewChange", "toolbarFormat", "toolbarPlaceholder", "views", "disabled", "readOnly", "toolbarVariant"], I$ = (e) => {
  const {
    classes: t,
    theme: n,
    isLandscape: r
  } = e, o = {
    root: ["root"],
    dateContainer: ["dateContainer"],
    timeContainer: ["timeContainer", n.direction === "rtl" && "timeLabelReverse"],
    timeDigitsContainer: ["timeDigitsContainer", n.direction === "rtl" && "timeLabelReverse"],
    separator: ["separator"],
    ampmSelection: ["ampmSelection", r && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return st(o, M$, t);
}, sy = Q(ed, {
  name: "MuiDateTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  paddingLeft: t.toolbarVariant === "desktop" && !t.isLandscape ? 24 : 16,
  paddingRight: t.toolbarVariant === "desktop" && !t.isLandscape ? 0 : 16,
  borderBottom: t.toolbarVariant === "desktop" ? `1px solid ${(e.vars || e).palette.divider}` : void 0,
  borderRight: t.toolbarVariant === "desktop" && t.isLandscape ? `1px solid ${(e.vars || e).palette.divider}` : void 0,
  justifyContent: "space-around",
  position: "relative"
}));
sy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: a.elementType,
  classes: a.object,
  className: a.string,
  isLandscape: a.bool.isRequired,
  isMobileKeyboardViewOpen: a.bool,
  landscapeDirection: a.oneOf(["column", "row"]),
  ownerState: a.object.isRequired,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  toggleMobileKeyboardView: a.func,
  toolbarTitle: a.node,
  viewType: a.oneOf(["date", "time"])
};
const R$ = Q("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "DateContainer",
  overridesResolver: (e, t) => t.dateContainer
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
}), ly = Q("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeContainer",
  overridesResolver: (e, t) => t.timeContainer
})(({
  theme: e,
  ownerState: t
}) => {
  const n = t.isLandscape && t.toolbarVariant !== "desktop" ? "column" : "row";
  return z({
    display: "flex",
    flexDirection: n
  }, t.toolbarVariant === "desktop" && z({}, !t.isLandscape && {
    gap: 9,
    marginRight: 4,
    alignSelf: "flex-end"
  }), e.direction === "rtl" && {
    flexDirection: `${n}-reverse`
  });
}), A$ = Q("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeDigitsContainer",
  overridesResolver: (e, t) => t.timeDigitsContainer
})(({
  theme: e,
  ownerState: t
}) => z({
  display: "flex"
}, t.toolbarVariant === "desktop" && {
  gap: 1.5
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
ly.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: a.elementType,
  ownerState: a.object.isRequired,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
};
const sp = Q(nd, {
  name: "MuiDateTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(({
  ownerState: e
}) => ({
  margin: e.toolbarVariant === "desktop" ? 0 : "0 4px 0 2px",
  cursor: "default"
})), $$ = Q("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${Pc.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${Pc.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => z({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  width: "100%"
}, {
  [`& .${Pc.ampmLabel}`]: {
    fontSize: 17
  }
}));
function cy(e) {
  const t = Ze({
    props: e,
    name: "MuiDateTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: o,
    onChange: i,
    view: s,
    isLandscape: l,
    onViewChange: u,
    toolbarFormat: c,
    toolbarPlaceholder: d = "––",
    views: m,
    disabled: f,
    readOnly: p,
    toolbarVariant: b = "mobile"
  } = t, g = $e(t, E$), S = t, C = Ue(), {
    meridiemMode: w,
    handleMeridiemChange: v
  } = Zl(o, n, i), x = !!(n && !r), T = b === "desktop", E = jt(), k = qt(), I = I$(z({}, S, {
    theme: k
  })), P = (A) => n ? C.format(A, "hours12h") : C.format(A, "hours24h"), F = U.useMemo(() => o ? c ? C.formatByString(o, c) : C.format(o, "shortDate") : d, [o, c, d, C]);
  return /* @__PURE__ */ J(sy, z({
    toolbarTitle: E.dateTimePickerToolbarTitle,
    isLandscape: l,
    className: I.root
  }, g, {
    ownerState: S,
    children: [/* @__PURE__ */ J(R$, {
      className: I.dateContainer,
      ownerState: S,
      children: [m.includes("year") && /* @__PURE__ */ h(mn, {
        tabIndex: -1,
        variant: "subtitle1",
        onClick: () => u("year"),
        selected: s === "year",
        value: o ? C.format(o, "year") : "–"
      }), m.includes("day") && /* @__PURE__ */ h(mn, {
        tabIndex: -1,
        variant: T ? "h5" : "h4",
        onClick: () => u("day"),
        selected: s === "day",
        value: F
      })]
    }), /* @__PURE__ */ J(ly, {
      className: I.timeContainer,
      ownerState: S,
      children: [/* @__PURE__ */ J(A$, {
        className: I.timeDigitsContainer,
        ownerState: S,
        children: [m.includes("hours") && /* @__PURE__ */ h(mn, {
          variant: T ? "h5" : "h3",
          width: T && !l ? Sa : void 0,
          onClick: () => u("hours"),
          selected: s === "hours",
          value: o ? P(o) : "--"
        }), m.includes("minutes") && /* @__PURE__ */ J(U.Fragment, {
          children: [/* @__PURE__ */ h(sp, {
            variant: T ? "h5" : "h3",
            value: ":",
            className: I.separator,
            ownerState: S
          }), /* @__PURE__ */ h(mn, {
            variant: T ? "h5" : "h3",
            width: T && !l ? Sa : void 0,
            onClick: () => u("minutes"),
            selected: s === "minutes",
            value: o ? C.format(o, "minutes") : "--"
          })]
        }), m.includes("seconds") && /* @__PURE__ */ J(U.Fragment, {
          children: [/* @__PURE__ */ h(sp, {
            variant: T ? "h5" : "h3",
            value: ":",
            className: I.separator,
            ownerState: S
          }), /* @__PURE__ */ h(mn, {
            variant: T ? "h5" : "h3",
            width: T && !l ? Sa : void 0,
            onClick: () => u("seconds"),
            selected: s === "seconds",
            value: o ? C.format(o, "seconds") : "--"
          })]
        })]
      }), x && !T && /* @__PURE__ */ J($$, {
        className: I.ampmSelection,
        ownerState: S,
        children: [/* @__PURE__ */ h(mn, {
          variant: "subtitle2",
          selected: w === "am",
          typographyClassName: I.ampmLabel,
          value: $n(C, "am"),
          onClick: p ? void 0 : () => v("am"),
          disabled: f
        }), /* @__PURE__ */ h(mn, {
          variant: "subtitle2",
          selected: w === "pm",
          typographyClassName: I.ampmLabel,
          value: $n(C, "pm"),
          onClick: p ? void 0 : () => v("pm"),
          disabled: f
        })]
      }), n && T && /* @__PURE__ */ h(mn, {
        variant: "h5",
        onClick: () => u("meridiem"),
        selected: s === "meridiem",
        value: o && w ? $n(C, w) : "--",
        width: Sa
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (cy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: a.bool,
  ampmInClock: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  /**
   * className applied to the root component.
   */
  className: a.string,
  disabled: a.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: a.bool,
  isLandscape: a.bool.isRequired,
  onChange: a.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: a.func.isRequired,
  readOnly: a.bool,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  titleId: a.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: a.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: a.node,
  toolbarVariant: a.oneOf(["desktop", "mobile"]),
  value: a.any,
  /**
   * Currently visible picker view.
   */
  view: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired,
  views: a.arrayOf(a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired
});
function uy(e, t) {
  var n, r, o, i, s, l, u, c, d, m, f;
  const p = Ue(), b = So(), g = Ze({
    props: e,
    name: t
  }), S = (n = g.ampm) != null ? n : p.is12HourCycleInCurrentLocale(), C = U.useMemo(() => {
    var x;
    return ((x = g.localeText) == null ? void 0 : x.toolbarTitle) == null ? g.localeText : z({}, g.localeText, {
      dateTimePickerToolbarTitle: g.localeText.toolbarTitle
    });
  }, [g.localeText]), w = (r = g.slots) != null ? r : gs(g.components), v = (o = g.slotProps) != null ? o : g.componentsProps;
  return z({}, g, Yu({
    views: g.views,
    openTo: g.openTo,
    defaultViews: ["year", "day", "hours", "minutes"],
    defaultOpenTo: "day"
  }), {
    ampm: S,
    localeText: C,
    orientation: (i = g.orientation) != null ? i : "portrait",
    // TODO: Remove from public API
    disableIgnoringDatePartForTimeValidation: (s = g.disableIgnoringDatePartForTimeValidation) != null ? s : !!(g.minDateTime || g.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
    g.disablePast || g.disableFuture),
    disableFuture: (l = g.disableFuture) != null ? l : !1,
    disablePast: (u = g.disablePast) != null ? u : !1,
    minDate: Gt(p, (c = g.minDateTime) != null ? c : g.minDate, b.minDate),
    maxDate: Gt(p, (d = g.maxDateTime) != null ? d : g.maxDate, b.maxDate),
    minTime: (m = g.minDateTime) != null ? m : g.minTime,
    maxTime: (f = g.maxDateTime) != null ? f : g.maxTime,
    slots: z({
      toolbar: cy,
      tabs: ay
    }, w),
    slotProps: z({}, v, {
      toolbar: z({
        ampm: S
      }, v == null ? void 0 : v.toolbar)
    })
  });
}
function N$(e) {
  return ut("MuiMultiSectionDigitalClock", e);
}
ft("MuiMultiSectionDigitalClock", ["root"]);
function F$(e) {
  return ut("MuiMultiSectionDigitalClockSection", e);
}
const V$ = ft("MuiMultiSectionDigitalClockSection", ["root", "item"]), j$ = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], L$ = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    item: ["item"]
  }, F$, t);
}, B$ = Q(Xm, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  maxHeight: Mg,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: t.alreadyRendered ? "smooth" : "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(e.vars || e).palette.divider}`
  },
  "&:after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  }
})), z$ = Q(ds, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: Sa,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : sn(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : sn(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), W$ = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r;
  const o = U.useRef(null), i = nr(n, o), s = U.useRef(null), l = Ze({
    props: t,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: u,
    onChange: c,
    className: d,
    disabled: m,
    readOnly: f,
    items: p,
    active: b,
    slots: g,
    slotProps: S,
    skipDisabled: C
  } = l, w = $e(l, j$), v = U.useMemo(() => z({}, l, {
    alreadyRendered: !!o.current
  }), [l]), x = L$(v), T = (r = g == null ? void 0 : g.digitalClockSectionItem) != null ? r : z$;
  return U.useEffect(() => {
    if (o.current === null)
      return;
    const E = o.current.querySelector('[role="option"][aria-selected="true"]');
    if (b && u && E && E.focus(), !E || s.current === E)
      return;
    s.current = E;
    const k = E.offsetTop;
    o.current.scrollTop = k - 4;
  }), /* @__PURE__ */ h(B$, z({
    ref: i,
    className: mt(x.root, d),
    ownerState: v,
    autoFocusItem: u && b,
    role: "listbox"
  }, w, {
    children: p.map((E) => {
      var k, I;
      if (C && (k = E.isDisabled) != null && k.call(E, E.value))
        return null;
      const P = E.isSelected(E.value);
      return /* @__PURE__ */ h(T, z({
        onClick: () => !f && c(E.value),
        selected: P,
        disabled: m || ((I = E.isDisabled) == null ? void 0 : I.call(E, E.value)),
        disableRipple: f,
        role: "option",
        "aria-disabled": f,
        "aria-label": E.ariaLabel,
        "aria-selected": P,
        className: x.item
      }, S == null ? void 0 : S.digitalClockSectionItem, {
        children: E.label
      }), E.label);
    })
  }));
}), q$ = ({
  now: e,
  value: t,
  utils: n,
  ampm: r,
  isDisabled: o,
  resolveAriaLabel: i,
  timeStep: s
}) => {
  const l = t ? n.getHours(t) : null, u = [], c = (m) => l === null ? !1 : r ? m === 12 ? l === 12 || l === 0 : l === m || l - 12 === m : l === m, d = r ? 11 : 23;
  for (let m = 0; m <= d; m += s) {
    let f = n.format(n.setHours(e, m), r ? "hours12h" : "hours24h");
    const p = i(parseInt(f, 10).toString());
    f = n.formatNumber(f), u.push({
      value: m,
      label: f,
      isSelected: c,
      isDisabled: o,
      ariaLabel: p
    });
  }
  return u;
}, lp = ({
  value: e,
  utils: t,
  isDisabled: n,
  timeStep: r,
  resolveLabel: o,
  resolveAriaLabel: i,
  hasValue: s = !0
}) => {
  const l = (u) => e === null ? !1 : s && e === u;
  return [...Array.from({
    length: Math.ceil(60 / r)
  }, (u, c) => {
    const d = r * c;
    return {
      value: d,
      label: t.formatNumber(o(d)),
      isDisabled: n,
      isSelected: l,
      ariaLabel: i(d.toString())
    };
  })];
}, wd = ({
  value: e,
  referenceDate: t,
  utils: n,
  props: r,
  timezone: o
}) => {
  const i = U.useMemo(
    () => Nt.getInitialReferenceValue({
      value: e,
      utils: n,
      props: r,
      referenceDate: t,
      granularity: Rn.day,
      timezone: o,
      getTodayDate: () => Ku(n, o, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return e ?? i;
}, H$ = ["ampm", "timeSteps", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], U$ = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"]
  }, N$, t);
}, Y$ = Q(ac, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
})), dy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ue(), o = Ze({
    props: t,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: i = r.is12HourCycleInCurrentLocale(),
    timeSteps: s,
    autoFocus: l,
    components: u,
    componentsProps: c,
    slots: d,
    slotProps: m,
    value: f,
    defaultValue: p,
    referenceDate: b,
    disableIgnoringDatePartForTimeValidation: g = !1,
    maxTime: S,
    minTime: C,
    disableFuture: w,
    disablePast: v,
    minutesStep: x = 1,
    shouldDisableClock: T,
    shouldDisableTime: E,
    onChange: k,
    view: I,
    views: P = ["hours", "minutes"],
    openTo: F,
    onViewChange: A,
    focusedView: B,
    onFocusedViewChange: W,
    className: M,
    disabled: _,
    readOnly: O,
    skipDisabled: R = !1,
    timezone: N
  } = o, L = $e(o, H$), {
    value: $,
    handleValueChange: H,
    timezone: G
  } = Ci({
    name: "MultiSectionDigitalClock",
    timezone: N,
    value: f,
    defaultValue: p,
    onChange: k,
    valueManager: Nt
  }), q = jt(), Y = Wr(G), Z = U.useMemo(() => z({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, s), [s]), ie = wd({
    value: $,
    referenceDate: b,
    utils: r,
    props: o,
    timezone: G
  }), X = Ae((K, ne, pe) => H(K, ne, pe)), se = U.useMemo(() => !i || !P.includes("hours") || P.includes("meridiem") ? P : [...P, "meridiem"], [i, P]), {
    view: fe,
    setValueAndGoToNextView: le,
    focusedView: ce
  } = ys({
    view: I,
    views: se,
    openTo: F,
    onViewChange: A,
    onChange: X,
    focusedView: B,
    onFocusedViewChange: W
  }), ee = Ae((K) => {
    le(K, "finish", "meridiem");
  }), {
    meridiemMode: ae,
    handleMeridiemChange: _e
  } = Zl(ie, i, ee, "finish"), ue = U.useCallback((K, ne) => {
    const pe = hs(g, r), Me = ne === "hours" || ne === "minutes" && se.includes("seconds"), de = ({
      start: Te,
      end: Re
    }) => !(C && pe(C, Re) || S && pe(Te, S) || w && pe(Te, Y) || v && pe(Y, Me ? Re : Te)), ye = (Te, Re = 1) => {
      if (Te % Re !== 0 || T != null && T(Te, ne))
        return !1;
      if (E)
        switch (ne) {
          case "hours":
            return !E(r.setHours(ie, Te), "hours");
          case "minutes":
            return !E(r.setMinutes(ie, Te), "minutes");
          case "seconds":
            return !E(r.setSeconds(ie, Te), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (ne) {
      case "hours": {
        const Te = Ja(K, ae, i), Re = r.setHours(ie, Te), We = r.setSeconds(r.setMinutes(Re, 0), 0), ht = r.setSeconds(r.setMinutes(Re, 59), 59);
        return !de({
          start: We,
          end: ht
        }) || !ye(Te);
      }
      case "minutes": {
        const Te = r.setMinutes(ie, K), Re = r.setSeconds(Te, 0), We = r.setSeconds(Te, 59);
        return !de({
          start: Re,
          end: We
        }) || !ye(K, x);
      }
      case "seconds": {
        const Te = r.setSeconds(ie, K);
        return !de({
          start: Te,
          end: Te
        }) || !ye(K);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, ie, g, S, ae, C, x, T, E, r, w, v, Y, se]), me = U.useCallback((K) => {
    switch (K) {
      case "hours":
        return {
          onChange: (ne) => {
            const pe = Ja(ne, ae, i);
            le(r.setHours(ie, pe), "finish", "hours");
          },
          items: q$({
            now: Y,
            value: $,
            ampm: i,
            utils: r,
            isDisabled: (ne) => _ || ue(ne, "hours"),
            timeStep: Z.hours,
            resolveAriaLabel: q.hoursClockNumberText
          })
        };
      case "minutes":
        return {
          onChange: (ne) => {
            le(r.setMinutes(ie, ne), "finish", "minutes");
          },
          items: lp({
            value: r.getMinutes(ie),
            utils: r,
            isDisabled: (ne) => _ || ue(ne, "minutes"),
            resolveLabel: (ne) => r.format(r.setMinutes(Y, ne), "minutes"),
            timeStep: Z.minutes,
            hasValue: !!$,
            resolveAriaLabel: q.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (ne) => {
            le(r.setSeconds(ie, ne), "finish", "seconds");
          },
          items: lp({
            value: r.getSeconds(ie),
            utils: r,
            isDisabled: (ne) => _ || ue(ne, "seconds"),
            resolveLabel: (ne) => r.format(r.setSeconds(Y, ne), "seconds"),
            timeStep: Z.seconds,
            hasValue: !!$,
            resolveAriaLabel: q.secondsClockNumberText
          })
        };
      case "meridiem": {
        const ne = $n(r, "am"), pe = $n(r, "pm");
        return {
          onChange: _e,
          items: [{
            value: "am",
            label: ne,
            isSelected: () => !!$ && ae === "am",
            ariaLabel: ne
          }, {
            value: "pm",
            label: pe,
            isSelected: () => !!$ && ae === "pm",
            ariaLabel: pe
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${K} found.`);
    }
  }, [Y, $, i, r, Z.hours, Z.minutes, Z.seconds, q.hoursClockNumberText, q.minutesClockNumberText, q.secondsClockNumberText, ae, le, ie, _, ue, _e]), De = U.useMemo(() => se.reduce((K, ne) => z({}, K, {
    [ne]: me(ne)
  }), {}), [se, me]), he = o, Ce = U$(he);
  return /* @__PURE__ */ h(Y$, z({
    ref: n,
    className: mt(Ce.root, M),
    ownerState: he,
    role: "group"
  }, L, {
    children: Object.entries(De).map(([K, ne]) => /* @__PURE__ */ h(W$, {
      items: ne.items,
      onChange: ne.onChange,
      active: fe === K,
      autoFocus: l ?? ce === K,
      disabled: _,
      readOnly: O,
      slots: d ?? u,
      slotProps: m ?? c,
      skipDisabled: R,
      "aria-label": q.selectViewText(K)
    }, K))
  }));
});
process.env.NODE_ENV !== "production" && (dy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: a.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: a.shape({
    hours: a.number,
    minutes: a.number,
    seconds: a.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
const G$ = Q("div")({
  display: "flex",
  margin: "0 auto"
});
function K$(e) {
  return ut("MuiTimeClock", e);
}
ft("MuiTimeClock", ["root", "arrowSwitcher"]);
const ri = 220, Jn = 36, es = {
  x: ri / 2,
  y: ri / 2
}, fy = {
  x: es.x,
  y: 0
}, Z$ = fy.x - es.x, Q$ = fy.y - es.y, J$ = (e) => e * (180 / Math.PI), py = (e, t, n) => {
  const r = t - es.x, o = n - es.y, i = Math.atan2(Z$, Q$) - Math.atan2(r, o);
  let s = J$(i);
  s = Math.round(s / e) * e, s %= 360;
  const l = Math.floor(s / e) || 0, u = r ** 2 + o ** 2, c = Math.sqrt(u);
  return {
    value: l,
    distance: c
  };
}, X$ = (e, t, n = 1) => {
  const r = n * 6;
  let {
    value: o
  } = py(r, e, t);
  return o = o * n % 60, o;
}, eN = (e, t, n) => {
  const {
    value: r,
    distance: o
  } = py(30, e, t);
  let i = r || 12;
  return n ? i %= 12 : o < ri / 2 - Jn && (i += 12, i %= 24), i;
};
function tN(e) {
  return ut("MuiClockPointer", e);
}
ft("MuiClockPointer", ["root", "thumb"]);
const nN = ["className", "hasSelected", "isInner", "type", "viewValue"], rN = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    thumb: ["thumb"]
  }, tN, t);
}, oN = Q("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => z({
  width: 2,
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px"
}, t.shouldAnimate && {
  transition: e.transitions.create(["transform", "height"])
})), iN = Q("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e,
  ownerState: t
}) => z({
  width: 4,
  height: 4,
  backgroundColor: (e.vars || e).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${Jn / 2}px)`,
  border: `${(Jn - 4) / 2}px solid ${(e.vars || e).palette.primary.main}`,
  boxSizing: "content-box"
}, t.hasSelected && {
  backgroundColor: (e.vars || e).palette.primary.main
}));
function aN(e) {
  const t = Ze({
    props: e,
    name: "MuiClockPointer"
  }), {
    className: n,
    isInner: r,
    type: o,
    viewValue: i
  } = t, s = $e(t, nN), l = U.useRef(o);
  U.useEffect(() => {
    l.current = o;
  }, [o]);
  const u = z({}, t, {
    shouldAnimate: l.current !== o
  }), c = rN(u);
  return /* @__PURE__ */ h(oN, z({
    style: (() => {
      let f = 360 / (o === "hours" ? 12 : 60) * i;
      return o === "hours" && i > 12 && (f -= 360), {
        height: Math.round((r ? 0.26 : 0.4) * ri),
        transform: `rotateZ(${f}deg)`
      };
    })(),
    className: mt(n, c.root),
    ownerState: u
  }, s, {
    children: /* @__PURE__ */ h(iN, {
      ownerState: u,
      className: c.thumb
    })
  }));
}
function sN(e) {
  return ut("MuiClock", e);
}
ft("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText"]);
const lN = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton"],
    pmButton: ["pmButton"],
    meridiemText: ["meridiemText"]
  }, sN, t);
}, cN = Q("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), uN = Q("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (e, t) => t.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), dN = Q("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), fN = Q("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (e, t) => t.squareMask
})(({
  ownerState: e
}) => z({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none"
}, e.disabled ? {} : {
  "@media (pointer: fine)": {
    cursor: "pointer",
    borderRadius: "50%"
  },
  "&:active": {
    cursor: "move"
  }
})), pN = Q("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (e, t) => t.pin
})(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), mN = Q(tn, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (e, t) => t.amButton
})(({
  theme: e,
  ownerState: t
}) => z({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  left: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: Jn
}, t.meridiemMode === "am" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), hN = Q(tn, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (e, t) => t.pmButton
})(({
  theme: e,
  ownerState: t
}) => z({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  right: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: Jn
}, t.meridiemMode === "pm" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), cp = Q(ve, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (e, t) => t.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function gN(e) {
  const t = Ze({
    props: e,
    name: "MuiClock"
  }), {
    ampm: n,
    ampmInClock: r,
    autoFocus: o,
    children: i,
    value: s,
    handleMeridiemChange: l,
    isTimeDisabled: u,
    meridiemMode: c,
    minutesStep: d = 1,
    onChange: m,
    selectedId: f,
    type: p,
    viewValue: b,
    disabled: g,
    readOnly: S,
    className: C
  } = t, w = t, v = Ue(), x = jt(), T = U.useRef(!1), E = lN(w), k = u(b, p), I = !n && p === "hours" && (b < 1 || b > 12), P = (L, $) => {
    g || S || u(L, p) || m(L, $);
  }, F = (L, $) => {
    let {
      offsetX: H,
      offsetY: G
    } = L;
    if (H === void 0) {
      const Y = L.target.getBoundingClientRect();
      H = L.changedTouches[0].clientX - Y.left, G = L.changedTouches[0].clientY - Y.top;
    }
    const q = p === "seconds" || p === "minutes" ? X$(H, G, d) : eN(H, G, !!n);
    P(q, $);
  }, A = (L) => {
    T.current = !0, F(L, "shallow");
  }, B = (L) => {
    T.current && (F(L, "finish"), T.current = !1);
  }, W = (L) => {
    L.buttons > 0 && F(L.nativeEvent, "shallow");
  }, M = (L) => {
    T.current && (T.current = !1), F(L.nativeEvent, "finish");
  }, _ = U.useMemo(() => p === "hours" ? !0 : b % 5 === 0, [p, b]), O = p === "minutes" ? d : 1, R = U.useRef(null);
  Ar(() => {
    o && R.current.focus();
  }, [o]);
  const N = (L) => {
    if (!T.current)
      switch (L.key) {
        case "Home":
          P(0, "partial"), L.preventDefault();
          break;
        case "End":
          P(p === "minutes" ? 59 : 23, "partial"), L.preventDefault();
          break;
        case "ArrowUp":
          P(b + O, "partial"), L.preventDefault();
          break;
        case "ArrowDown":
          P(b - O, "partial"), L.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ J(cN, {
    className: mt(C, E.root),
    children: [/* @__PURE__ */ J(uN, {
      className: E.clock,
      children: [/* @__PURE__ */ h(fN, {
        onTouchMove: A,
        onTouchEnd: B,
        onMouseUp: M,
        onMouseMove: W,
        ownerState: {
          disabled: g
        },
        className: E.squareMask
      }), !k && /* @__PURE__ */ J(U.Fragment, {
        children: [/* @__PURE__ */ h(pN, {
          className: E.pin
        }), s != null && /* @__PURE__ */ h(aN, {
          type: p,
          viewValue: b,
          isInner: I,
          hasSelected: _
        })]
      }), /* @__PURE__ */ h(dN, {
        "aria-activedescendant": f,
        "aria-label": x.clockLabelText(p, s, v),
        ref: R,
        role: "listbox",
        onKeyDown: N,
        tabIndex: 0,
        className: E.wrapper,
        children: i
      })]
    }), n && r && /* @__PURE__ */ J(U.Fragment, {
      children: [/* @__PURE__ */ h(mN, {
        onClick: S ? void 0 : () => l("am"),
        disabled: g || c === null,
        ownerState: w,
        className: E.amButton,
        title: $n(v, "am"),
        children: /* @__PURE__ */ h(cp, {
          variant: "caption",
          className: E.meridiemText,
          children: $n(v, "am")
        })
      }), /* @__PURE__ */ h(hN, {
        disabled: g || c === null,
        onClick: S ? void 0 : () => l("pm"),
        ownerState: w,
        className: E.pmButton,
        title: $n(v, "pm"),
        children: /* @__PURE__ */ h(cp, {
          variant: "caption",
          className: E.meridiemText,
          children: $n(v, "pm")
        })
      })]
    })]
  });
}
function yN(e) {
  return ut("MuiClockNumber", e);
}
const Ns = ft("MuiClockNumber", ["root", "selected", "disabled"]), bN = ["className", "disabled", "index", "inner", "label", "selected"], vN = (e) => {
  const {
    classes: t,
    selected: n,
    disabled: r
  } = e;
  return st({
    root: ["root", n && "selected", r && "disabled"]
  }, yN, t);
}, CN = Q("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${Ns.disabled}`]: t.disabled
  }, {
    [`&.${Ns.selected}`]: t.selected
  }]
})(({
  theme: e,
  ownerState: t
}) => z({
  height: Jn,
  width: Jn,
  position: "absolute",
  left: `calc((100% - ${Jn}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (e.vars || e).palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  [`&.${Ns.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText
  },
  [`&.${Ns.disabled}`]: {
    pointerEvents: "none",
    color: (e.vars || e).palette.text.disabled
  }
}, t.inner && z({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary
})));
function my(e) {
  const t = Ze({
    props: e,
    name: "MuiClockNumber"
  }), {
    className: n,
    disabled: r,
    index: o,
    inner: i,
    label: s,
    selected: l
  } = t, u = $e(t, bN), c = t, d = vN(c), m = o % 12 / 12 * Math.PI * 2 - Math.PI / 2, f = (ri - Jn - 2) / 2 * (i ? 0.65 : 1), p = Math.round(Math.cos(m) * f), b = Math.round(Math.sin(m) * f);
  return /* @__PURE__ */ h(CN, z({
    className: mt(n, d.root),
    "aria-disabled": r ? !0 : void 0,
    "aria-selected": l ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${p}px, ${b + (ri - Jn) / 2}px`
    },
    ownerState: c
  }, u, {
    children: s
  }));
}
const wN = ({
  ampm: e,
  value: t,
  getClockNumberText: n,
  isDisabled: r,
  selectedId: o,
  utils: i
}) => {
  const s = t ? i.getHours(t) : null, l = [], u = e ? 1 : 0, c = e ? 12 : 23, d = (m) => s === null ? !1 : e ? m === 12 ? s === 12 || s === 0 : s === m || s - 12 === m : s === m;
  for (let m = u; m <= c; m += 1) {
    let f = m.toString();
    m === 0 && (f = "00");
    const p = !e && (m === 0 || m > 12);
    f = i.formatNumber(f);
    const b = d(m);
    l.push(/* @__PURE__ */ h(my, {
      id: b ? o : void 0,
      index: m,
      inner: p,
      selected: b,
      disabled: r(m),
      label: f,
      "aria-label": n(f)
    }, m));
  }
  return l;
}, up = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: r,
  selectedId: o
}) => {
  const i = e.formatNumber;
  return [[5, i("05")], [10, i("10")], [15, i("15")], [20, i("20")], [25, i("25")], [30, i("30")], [35, i("35")], [40, i("40")], [45, i("45")], [50, i("50")], [55, i("55")], [0, i("00")]].map(([s, l], u) => {
    const c = s === t;
    return /* @__PURE__ */ h(my, {
      label: l,
      id: c ? o : void 0,
      index: u + 1,
      inner: !1,
      disabled: n(s),
      selected: c,
      "aria-label": r(l)
    }, s);
  });
}, xN = ["ampm", "ampmInClock", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], SN = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, K$, t);
}, TN = Q(ac, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), _N = Q(kg, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), DN = ["hours", "minutes"], hy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ue(), o = Ze({
    props: t,
    name: "MuiTimeClock"
  }), {
    ampm: i = r.is12HourCycleInCurrentLocale(),
    ampmInClock: s = !1,
    autoFocus: l,
    components: u,
    componentsProps: c,
    slots: d,
    slotProps: m,
    value: f,
    defaultValue: p,
    referenceDate: b,
    disableIgnoringDatePartForTimeValidation: g = !1,
    maxTime: S,
    minTime: C,
    disableFuture: w,
    disablePast: v,
    minutesStep: x = 1,
    shouldDisableClock: T,
    shouldDisableTime: E,
    showViewSwitcher: k,
    onChange: I,
    view: P,
    views: F = DN,
    openTo: A,
    onViewChange: B,
    focusedView: W,
    onFocusedViewChange: M,
    className: _,
    disabled: O,
    readOnly: R,
    timezone: N
  } = o, L = $e(o, xN), $ = d ?? gs(u), H = m ?? c, {
    value: G,
    handleValueChange: q,
    timezone: Y
  } = Ci({
    name: "TimeClock",
    timezone: N,
    value: f,
    defaultValue: p,
    onChange: I,
    valueManager: Nt
  }), Z = wd({
    value: G,
    referenceDate: b,
    utils: r,
    props: o,
    timezone: Y
  }), ie = jt(), X = Wr(Y), {
    view: se,
    setView: fe,
    previousView: le,
    nextView: ce,
    setValueAndGoToNextView: ee
  } = ys({
    view: P,
    views: F,
    openTo: A,
    onViewChange: B,
    onChange: q,
    focusedView: W,
    onFocusedViewChange: M
  }), {
    meridiemMode: ae,
    handleMeridiemChange: _e
  } = Zl(Z, i, ee), ue = U.useCallback((K, ne) => {
    const pe = hs(g, r), Me = ne === "hours" || ne === "minutes" && F.includes("seconds"), de = ({
      start: Te,
      end: Re
    }) => !(C && pe(C, Re) || S && pe(Te, S) || w && pe(Te, X) || v && pe(X, Me ? Re : Te)), ye = (Te, Re = 1) => {
      if (Te % Re !== 0 || T != null && T(Te, ne))
        return !1;
      if (E)
        switch (ne) {
          case "hours":
            return !E(r.setHours(Z, Te), "hours");
          case "minutes":
            return !E(r.setMinutes(Z, Te), "minutes");
          case "seconds":
            return !E(r.setSeconds(Z, Te), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (ne) {
      case "hours": {
        const Te = Ja(K, ae, i), Re = r.setHours(Z, Te), We = r.setSeconds(r.setMinutes(Re, 0), 0), ht = r.setSeconds(r.setMinutes(Re, 59), 59);
        return !de({
          start: We,
          end: ht
        }) || !ye(Te);
      }
      case "minutes": {
        const Te = r.setMinutes(Z, K), Re = r.setSeconds(Te, 0), We = r.setSeconds(Te, 59);
        return !de({
          start: Re,
          end: We
        }) || !ye(K, x);
      }
      case "seconds": {
        const Te = r.setSeconds(Z, K);
        return !de({
          start: Te,
          end: Te
        }) || !ye(K);
      }
      default:
        throw new Error("not supported");
    }
  }, [i, Z, g, S, ae, C, x, T, E, r, w, v, X, F]), me = Hl(), De = U.useMemo(() => {
    switch (se) {
      case "hours": {
        const K = (ne, pe) => {
          const Me = Ja(ne, ae, i);
          ee(r.setHours(Z, Me), pe);
        };
        return {
          onChange: K,
          viewValue: r.getHours(Z),
          children: wN({
            value: G,
            utils: r,
            ampm: i,
            onChange: K,
            getClockNumberText: ie.hoursClockNumberText,
            isDisabled: (ne) => O || ue(ne, "hours"),
            selectedId: me
          })
        };
      }
      case "minutes": {
        const K = r.getMinutes(Z), ne = (pe, Me) => {
          ee(r.setMinutes(Z, pe), Me);
        };
        return {
          viewValue: K,
          onChange: ne,
          children: up({
            utils: r,
            value: K,
            onChange: ne,
            getClockNumberText: ie.minutesClockNumberText,
            isDisabled: (pe) => O || ue(pe, "minutes"),
            selectedId: me
          })
        };
      }
      case "seconds": {
        const K = r.getSeconds(Z), ne = (pe, Me) => {
          ee(r.setSeconds(Z, pe), Me);
        };
        return {
          viewValue: K,
          onChange: ne,
          children: up({
            utils: r,
            value: K,
            onChange: ne,
            getClockNumberText: ie.secondsClockNumberText,
            isDisabled: (pe) => O || ue(pe, "seconds"),
            selectedId: me
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [se, r, G, i, ie.hoursClockNumberText, ie.minutesClockNumberText, ie.secondsClockNumberText, ae, ee, Z, ue, me, O]), he = o, Ce = SN(he);
  return /* @__PURE__ */ J(TN, z({
    ref: n,
    className: mt(Ce.root, _),
    ownerState: he
  }, L, {
    children: [/* @__PURE__ */ h(gN, z({
      autoFocus: l ?? !!W,
      ampmInClock: s && F.includes("hours"),
      value: G,
      type: se,
      ampm: i,
      minutesStep: x,
      isTimeDisabled: ue,
      meridiemMode: ae,
      handleMeridiemChange: _e,
      selectedId: me,
      disabled: O,
      readOnly: R
    }, De)), k && /* @__PURE__ */ h(_N, {
      className: Ce.arrowSwitcher,
      slots: $,
      slotProps: H,
      onGoToPrevious: () => fe(le),
      isPreviousDisabled: !le,
      previousLabel: ie.openPreviousView,
      onGoToNext: () => fe(ce),
      isNextDisabled: !ce,
      nextLabel: ie.openNextView,
      ownerState: he
    })]
  }));
});
process.env.NODE_ENV !== "production" && (hy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: a.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  showViewSwitcher: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function PN(e) {
  return ut("MuiDigitalClock", e);
}
const ON = ft("MuiDigitalClock", ["root", "list", "item"]), kN = ["ampm", "timeStep", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], MN = (e) => {
  const {
    classes: t
  } = e;
  return st({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, PN, t);
}, EN = Q(ac, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: e.alreadyRendered ? "smooth" : "auto"
  },
  maxHeight: Mg
})), IN = Q(Xm, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  padding: 0
}), RN = Q(ds, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : sn(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : sn(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), gy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i;
  const s = Ue(), l = U.useRef(null), u = nr(n, l), c = Ze({
    props: t,
    name: "MuiDigitalClock"
  }), {
    ampm: d = s.is12HourCycleInCurrentLocale(),
    timeStep: m = 30,
    autoFocus: f,
    components: p,
    componentsProps: b,
    slots: g,
    slotProps: S,
    value: C,
    defaultValue: w,
    referenceDate: v,
    disableIgnoringDatePartForTimeValidation: x = !1,
    maxTime: T,
    minTime: E,
    disableFuture: k,
    disablePast: I,
    minutesStep: P = 1,
    shouldDisableClock: F,
    shouldDisableTime: A,
    onChange: B,
    view: W,
    openTo: M,
    onViewChange: _,
    focusedView: O,
    onFocusedViewChange: R,
    className: N,
    disabled: L,
    readOnly: $,
    views: H = ["hours"],
    skipDisabled: G = !1,
    timezone: q
  } = c, Y = $e(c, kN), {
    value: Z,
    handleValueChange: ie,
    timezone: X
  } = Ci({
    name: "DigitalClock",
    timezone: q,
    value: C,
    defaultValue: w,
    onChange: B,
    valueManager: Nt
  }), se = jt(), fe = Wr(X), le = U.useMemo(() => z({}, c, {
    alreadyRendered: !!l.current
  }), [c]), ce = MN(le), ee = (r = (o = g == null ? void 0 : g.digitalClockItem) != null ? o : p == null ? void 0 : p.DigitalClockItem) != null ? r : RN, ae = xt({
    elementType: ee,
    externalSlotProps: (i = S == null ? void 0 : S.digitalClockItem) != null ? i : b == null ? void 0 : b.digitalClockItem,
    ownerState: {},
    className: ce.item
  }), _e = wd({
    value: Z,
    referenceDate: v,
    utils: s,
    props: c,
    timezone: X
  }), ue = Ae((K) => ie(K, "finish", "hours")), {
    setValueAndGoToNextView: me
  } = ys({
    view: W,
    views: H,
    openTo: M,
    onViewChange: _,
    onChange: ue,
    focusedView: O,
    onFocusedViewChange: R
  }), De = Ae((K) => {
    me(K, "finish");
  });
  U.useEffect(() => {
    if (l.current === null)
      return;
    const K = l.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
    if (!K)
      return;
    const ne = K.offsetTop;
    l.current.scrollTop = ne - 4;
  });
  const he = U.useCallback((K) => {
    const ne = hs(x, s), pe = () => !(E && ne(E, K) || T && ne(K, T) || k && ne(K, fe) || I && ne(fe, K)), Me = () => s.getMinutes(K) % P !== 0 || F != null && F(s.toJsDate(K).getTime(), "hours") ? !1 : A ? !A(K, "hours") : !0;
    return !pe() || !Me();
  }, [x, s, E, T, k, fe, I, P, F, A]), Ce = U.useMemo(() => {
    const K = s.startOfDay(_e);
    return [K, ...Array.from({
      length: Math.ceil(24 * 60 / m) - 1
    }, (ne, pe) => s.addMinutes(K, m * (pe + 1)))];
  }, [_e, m, s]);
  return /* @__PURE__ */ h(EN, z({
    ref: u,
    className: mt(ce.root, N),
    ownerState: le
  }, Y, {
    children: /* @__PURE__ */ h(IN, {
      autoFocusItem: f || !!O,
      role: "listbox",
      "aria-label": se.timePickerToolbarTitle,
      className: ce.list,
      children: Ce.map((K) => {
        if (G && he(K))
          return null;
        const ne = s.isEqual(K, Z);
        return /* @__PURE__ */ h(ee, z({
          onClick: () => !$ && De(K),
          selected: ne,
          disabled: L || he(K),
          disableRipple: $,
          role: "option",
          "aria-disabled": $,
          "aria-selected": ne
        }, ae, {
          children: s.format(K, d ? "fullTime12h" : "fullTime24h")
        }), s.toISO(K));
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (gy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: a.object,
  className: a.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Controlled focused view.
   */
  focusedView: a.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: a.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: a.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: a.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours"]),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["hours"]))
});
const Ko = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o,
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minTime: p,
  maxTime: b,
  shouldDisableTime: g,
  shouldDisableClock: S,
  minutesStep: C,
  ampm: w,
  ampmInClock: v,
  components: x,
  componentsProps: T,
  slots: E,
  slotProps: k,
  readOnly: I,
  disabled: P,
  sx: F,
  autoFocus: A,
  showViewSwitcher: B,
  disableIgnoringDatePartForTimeValidation: W,
  timezone: M
}) => /* @__PURE__ */ h(hy, {
  view: e,
  onViewChange: t,
  focusedView: n && ni(n) ? n : null,
  onFocusedViewChange: r,
  views: o.filter(ni),
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minTime: p,
  maxTime: b,
  shouldDisableTime: g,
  shouldDisableClock: S,
  minutesStep: C,
  ampm: w,
  ampmInClock: v,
  components: x,
  componentsProps: T,
  slots: E,
  slotProps: k,
  readOnly: I,
  disabled: P,
  sx: F,
  autoFocus: A,
  showViewSwitcher: B,
  disableIgnoringDatePartForTimeValidation: W,
  timezone: M
}), yy = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o,
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minTime: p,
  maxTime: b,
  shouldDisableTime: g,
  shouldDisableClock: S,
  minutesStep: C,
  ampm: w,
  components: v,
  componentsProps: x,
  slots: T,
  slotProps: E,
  readOnly: k,
  disabled: I,
  sx: P,
  autoFocus: F,
  disableIgnoringDatePartForTimeValidation: A,
  timeSteps: B,
  skipDisabled: W,
  timezone: M
}) => /* @__PURE__ */ h(gy, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o.filter(ni),
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minTime: p,
  maxTime: b,
  shouldDisableTime: g,
  shouldDisableClock: S,
  minutesStep: C,
  ampm: w,
  components: v,
  componentsProps: x,
  slots: T,
  slotProps: E,
  readOnly: k,
  disabled: I,
  sx: P,
  autoFocus: F,
  disableIgnoringDatePartForTimeValidation: A,
  timeStep: B == null ? void 0 : B.minutes,
  skipDisabled: W,
  timezone: M
}), uu = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o,
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minTime: p,
  maxTime: b,
  shouldDisableTime: g,
  shouldDisableClock: S,
  minutesStep: C,
  ampm: w,
  components: v,
  componentsProps: x,
  slots: T,
  slotProps: E,
  readOnly: k,
  disabled: I,
  sx: P,
  autoFocus: F,
  disableIgnoringDatePartForTimeValidation: A,
  timeSteps: B,
  skipDisabled: W,
  timezone: M
}) => /* @__PURE__ */ h(dy, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: o.filter(ni),
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minTime: p,
  maxTime: b,
  shouldDisableTime: g,
  shouldDisableClock: S,
  minutesStep: C,
  ampm: w,
  components: v,
  componentsProps: x,
  slots: T,
  slotProps: E,
  readOnly: k,
  disabled: I,
  sx: P,
  autoFocus: F,
  disableIgnoringDatePartForTimeValidation: A,
  timeSteps: B,
  skipDisabled: W,
  timezone: M
}), Xr = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: o,
  value: i,
  defaultValue: s,
  referenceDate: l,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: m,
  disablePast: f,
  minDate: p,
  minTime: b,
  maxDate: g,
  maxTime: S,
  shouldDisableDate: C,
  shouldDisableMonth: w,
  shouldDisableYear: v,
  shouldDisableTime: x,
  shouldDisableClock: T,
  reduceAnimations: E,
  minutesStep: k,
  ampm: I,
  onMonthChange: P,
  monthsPerRow: F,
  onYearChange: A,
  yearsPerRow: B,
  defaultCalendarMonth: W,
  components: M,
  componentsProps: _,
  slots: O,
  slotProps: R,
  loading: N,
  renderLoading: L,
  disableHighlightToday: $,
  readOnly: H,
  disabled: G,
  showDaysOutsideCurrentMonth: q,
  dayOfWeekFormatter: Y,
  sx: Z,
  autoFocus: ie,
  fixedWeekNumber: X,
  displayWeekNumber: se,
  timezone: fe,
  disableIgnoringDatePartForTimeValidation: le,
  timeSteps: ce,
  skipDisabled: ee,
  timeViewsCount: ae,
  shouldRenderTimeInASingleColumn: _e
}) => {
  var ue, me;
  const De = !!((ue = zr((me = R == null ? void 0 : R.actionBar) != null ? me : _ == null ? void 0 : _.actionBar, {})) != null && (ue = ue.actions) != null && ue.length), he = {
    view: _r(e) ? e : "hours",
    onViewChange: t,
    focusedView: r && _r(r) ? r : null,
    onFocusedViewChange: o,
    views: n.filter(_r),
    value: i,
    defaultValue: s,
    referenceDate: l,
    onChange: u,
    className: c,
    classes: d,
    disableFuture: m,
    disablePast: f,
    minTime: b,
    maxTime: S,
    shouldDisableTime: x,
    shouldDisableClock: T,
    minutesStep: k,
    ampm: I,
    components: M,
    componentsProps: _,
    slots: O,
    slotProps: R,
    readOnly: H,
    disabled: G,
    autoFocus: ie,
    disableIgnoringDatePartForTimeValidation: le,
    timeSteps: ce,
    skipDisabled: ee,
    timezone: fe
  };
  return /* @__PURE__ */ J(U.Fragment, {
    children: [/* @__PURE__ */ J(G$, {
      children: [/* @__PURE__ */ h(gd, {
        view: Uo(e) ? e : "day",
        onViewChange: t,
        views: n.filter(Uo),
        focusedView: r && Uo(r) ? r : null,
        onFocusedViewChange: o,
        value: i,
        defaultValue: s,
        referenceDate: l,
        onChange: u,
        className: c,
        classes: d,
        disableFuture: m,
        disablePast: f,
        minDate: p,
        maxDate: g,
        shouldDisableDate: C,
        shouldDisableMonth: w,
        shouldDisableYear: v,
        reduceAnimations: E,
        onMonthChange: P,
        monthsPerRow: F,
        onYearChange: A,
        yearsPerRow: B,
        defaultCalendarMonth: W,
        components: M,
        componentsProps: _,
        slots: O,
        slotProps: R,
        loading: N,
        renderLoading: L,
        disableHighlightToday: $,
        readOnly: H,
        disabled: G,
        showDaysOutsideCurrentMonth: q,
        dayOfWeekFormatter: Y,
        sx: Z,
        autoFocus: ie,
        fixedWeekNumber: X,
        displayWeekNumber: se,
        timezone: fe
      }), ae > 0 && /* @__PURE__ */ J(U.Fragment, {
        children: [/* @__PURE__ */ h(kt, {
          orientation: "vertical"
        }), _e ? yy(z({}, he, {
          view: "hours",
          views: ["hours"],
          focusedView: r && _r(r) ? "hours" : null,
          sx: z({
            width: "auto",
            [`&.${ON.root}`]: {
              maxHeight: Kl
            }
          }, Array.isArray(Z) ? Z : [Z])
        })) : uu(z({}, he, {
          view: _r(e) ? e : "hours",
          views: n.filter(_r),
          focusedView: r && _r(r) ? r : null,
          sx: z({
            borderBottom: 0,
            width: "auto",
            [`.${V$.root}`]: {
              maxHeight: "100%"
            }
          }, Array.isArray(Z) ? Z : [Z])
        }))]
      })]
    }), De && /* @__PURE__ */ h(kt, {})]
  });
}, AN = ["views", "format"], by = (e, t) => {
  let {
    views: n,
    format: r
  } = t, o = $e(t, AN);
  if (r)
    return r;
  const i = [], s = [];
  if (n.forEach((c) => {
    ni(c) ? s.push(c) : i.push(c);
  }), s.length === 0)
    return Qa(e, z({
      views: i
    }, o), !1);
  if (i.length === 0)
    return cl(e, z({
      views: s
    }, o));
  const l = cl(e, z({
    views: s
  }, o));
  return `${Qa(e, z({
    views: i
  }, o), !1)} ${l}`;
}, $N = (e, t, n) => n ? t.filter((r) => !_r(r) || r === "hours") : e ? [...t, "meridiem"] : t, NN = (e, t) => {
  var n, r;
  return 24 * 60 / (((n = e.hours) != null ? n : 1) * ((r = e.minutes) != null ? r : 5)) <= t;
};
function vy({
  thresholdToRenderTimeInASingleColumn: e,
  ampm: t,
  timeSteps: n,
  views: r
}) {
  const o = e ?? 24, i = z({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, n), s = NN(i, o);
  return {
    thresholdToRenderTimeInASingleColumn: o,
    timeSteps: i,
    shouldRenderTimeInASingleColumn: s,
    views: $N(t, r, s)
  };
}
const Cy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s, l, u, c;
  const d = jt(), m = Ue(), f = uy(t, "MuiDesktopDateTimePicker"), {
    shouldRenderTimeInASingleColumn: p,
    thresholdToRenderTimeInASingleColumn: b,
    views: g,
    timeSteps: S
  } = vy(f), C = !f.viewRenderers || Object.keys(f.viewRenderers).length === 0, w = (
    // we can only ensure the expected two-column layout if none of the renderers are overridden
    C ? {
      day: Xr,
      month: Xr,
      year: Xr,
      hours: Xr,
      minutes: Xr,
      seconds: Xr,
      meridiem: Xr
    } : z({
      day: Sn,
      month: Sn,
      year: Sn,
      hours: null,
      minutes: null,
      seconds: null,
      meridiem: null
    }, f.viewRenderers)
  ), v = (r = f.ampmInClock) != null ? r : !0, x = C ? ["accept"] : [], T = z({}, f, {
    viewRenderers: w,
    format: by(m, f),
    views: g,
    yearsPerRow: (o = f.yearsPerRow) != null ? o : 4,
    ampmInClock: v,
    timeSteps: S,
    thresholdToRenderTimeInASingleColumn: b,
    shouldRenderTimeInASingleColumn: p,
    slots: z({
      field: Cd,
      openPickerIcon: Og
    }, f.slots),
    slotProps: z({}, f.slotProps, {
      field: (k) => {
        var I;
        return z({}, zr((I = f.slotProps) == null ? void 0 : I.field, k), wi(f), {
          ref: n
        });
      },
      toolbar: z({
        hidden: !0,
        ampmInClock: v,
        toolbarVariant: C ? "desktop" : "mobile"
      }, (i = f.slotProps) == null ? void 0 : i.toolbar),
      tabs: z({
        hidden: !0
      }, (s = f.slotProps) == null ? void 0 : s.tabs),
      actionBar: z({
        actions: x
      }, (l = f.slotProps) == null ? void 0 : l.actionBar)
    })
  }), {
    renderPicker: E
  } = dd({
    props: T,
    valueManager: Nt,
    valueType: "date-time",
    getOpenDialogAriaText: (u = (c = T.localeText) == null ? void 0 : c.openDatePickerDialogue) != null ? u : d.openDatePickerDialogue,
    validator: Ql
  });
  return E();
});
Cy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: a.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: a.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: a.shape({
    hours: a.number,
    minutes: a.number,
    seconds: a.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    day: a.func,
    hours: a.func,
    meridiem: a.func,
    minutes: a.func,
    month: a.func,
    seconds: a.func,
    year: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: a.oneOf([3, 4])
};
const wy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s, l;
  const u = jt(), c = Ue(), d = uy(t, "MuiMobileDateTimePicker"), m = z({
    day: Sn,
    month: Sn,
    year: Sn,
    hours: Ko,
    minutes: Ko,
    seconds: Ko
  }, d.viewRenderers), f = (r = d.ampmInClock) != null ? r : !1, p = z({}, d, {
    viewRenderers: m,
    format: by(c, d),
    ampmInClock: f,
    slots: z({
      field: Cd
    }, d.slots),
    slotProps: z({}, d.slotProps, {
      field: (g) => {
        var S;
        return z({}, zr((S = d.slotProps) == null ? void 0 : S.field, g), wi(d), {
          ref: n
        });
      },
      toolbar: z({
        hidden: !1,
        ampmInClock: f
      }, (o = d.slotProps) == null ? void 0 : o.toolbar),
      tabs: z({
        hidden: !1
      }, (i = d.slotProps) == null ? void 0 : i.tabs)
    })
  }), {
    renderPicker: b
  } = yd({
    props: p,
    valueManager: Nt,
    valueType: "date-time",
    getOpenDialogAriaText: (s = (l = p.localeText) == null ? void 0 : l.openDatePickerDialogue) != null ? s : u.openDatePickerDialogue,
    validator: Ql
  });
  return b();
});
wy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: a.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    day: a.func,
    hours: a.func,
    minutes: a.func,
    month: a.func,
    seconds: a.func,
    year: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: a.oneOf([3, 4])
};
const FN = ["desktopModeMediaQuery"], xd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiDateTimePicker"
  }), {
    desktopModeMediaQuery: o = td
  } = r, i = $e(r, FN);
  return jr(o, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ h(Cy, z({
    ref: n
  }, i)) : /* @__PURE__ */ h(wy, z({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (xd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: a.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: a.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: a.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: a.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: a.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: a.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable date.
   */
  maxDate: a.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: a.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable date.
   */
  minDate: a.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: a.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: a.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: a.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: a.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: a.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: a.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: a.shape({
    hours: a.number,
    minutes: a.number,
    seconds: a.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    day: a.func,
    hours: a.func,
    meridiem: a.func,
    minutes: a.func,
    month: a.func,
    seconds: a.func,
    year: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: a.oneOf([3, 4])
});
const VN = (e) => {
  var t, n, r, o;
  const i = Ue(), l = ((t = e.ampm) != null ? t : i.is12HourCycleInCurrentLocale()) ? i.formats.fullTime12h : i.formats.fullTime24h;
  return z({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (r = e.disableFuture) != null ? r : !1,
    format: (o = e.format) != null ? o : l
  });
}, jN = ({
  props: e,
  inputRef: t
}) => {
  const n = VN(e), {
    forwardedProps: r,
    internalProps: o
  } = ad(n, "time");
  return od({
    inputRef: t,
    forwardedProps: r,
    internalProps: o,
    valueManager: Nt,
    fieldValueManager: Ju,
    validator: bs,
    valueType: "time"
  });
}, LN = ["slots", "slotProps", "components", "componentsProps", "InputProps", "inputProps"], BN = ["inputRef"], zN = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], Sd = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i;
  const s = Ze({
    props: t,
    name: "MuiTimeField"
  }), {
    slots: l,
    slotProps: u,
    components: c,
    componentsProps: d,
    InputProps: m,
    inputProps: f
  } = s, p = $e(s, LN), b = s, g = (r = (o = l == null ? void 0 : l.textField) != null ? o : c == null ? void 0 : c.TextField) != null ? r : us, S = xt({
    elementType: g,
    externalSlotProps: (i = u == null ? void 0 : u.textField) != null ? i : d == null ? void 0 : d.textField,
    externalForwardedProps: p,
    ownerState: b
  }), {
    inputRef: C
  } = S, w = $e(S, BN);
  w.inputProps = z({}, f, w.inputProps), w.InputProps = z({}, m, w.InputProps);
  const v = jN({
    props: w,
    inputRef: C
  }), {
    ref: x,
    onPaste: T,
    onKeyDown: E,
    inputMode: k,
    readOnly: I,
    clearable: P,
    onClear: F
  } = v, A = $e(v, zN), {
    InputProps: B,
    fieldProps: W
  } = fd({
    onClear: F,
    clearable: P,
    fieldProps: A,
    InputProps: A.InputProps,
    slots: l,
    slotProps: u,
    components: c,
    componentsProps: d
  });
  return /* @__PURE__ */ h(g, z({
    ref: n
  }, W, {
    InputProps: z({}, B, {
      readOnly: I
    }),
    inputProps: z({}, A.inputProps, {
      inputMode: k,
      onPaste: T,
      onKeyDown: E,
      ref: x
    })
  }));
});
process.env.NODE_ENV !== "production" && (Sd.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: a.bool,
  className: a.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: a.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: a.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: a.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: a.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: a.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: a.bool,
  /**
   * The helper text content.
   */
  helperText: a.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: a.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: a.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: a.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: a.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: a.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: a.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Name attribute of the `input` element.
   */
  name: a.string,
  onBlur: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  onFocus: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: a.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: a.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: a.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: a.bool,
  /**
   * The size of the component.
   */
  size: a.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  style: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: a.oneOfType([a.func, a.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: a.oneOf(["filled", "outlined", "standard"])
});
function WN(e) {
  return ut("MuiTimePickerToolbar", e);
}
const Ia = ft("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), qN = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly"], HN = (e) => {
  const {
    theme: t,
    isLandscape: n,
    classes: r
  } = e, o = {
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", n && "hourMinuteLabelLandscape", t.direction === "rtl" && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", n && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return st(o, WN, r);
}, UN = Q(ed, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), YN = Q(nd, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), xy = Q("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (e, t) => [{
    [`&.${Ia.hourMinuteLabelLandscape}`]: t.hourMinuteLabelLandscape,
    [`&.${Ia.hourMinuteLabelReverse}`]: t.hourMinuteLabelReverse
  }, t.hourMinuteLabel]
})(({
  theme: e,
  ownerState: t
}) => z({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end"
}, t.isLandscape && {
  marginTop: "auto"
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
xy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: a.elementType,
  ownerState: a.object.isRequired,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
};
const Sy = Q("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${Ia.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${Ia.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => z({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  flexBasis: "100%"
}, {
  [`& .${Ia.ampmLabel}`]: {
    fontSize: 17
  }
}));
Sy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: a.elementType,
  ownerState: a.object.isRequired,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object])
};
function Ty(e) {
  const t = Ze({
    props: e,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: o,
    isLandscape: i,
    onChange: s,
    view: l,
    onViewChange: u,
    views: c,
    disabled: d,
    readOnly: m
  } = t, f = $e(t, qN), p = Ue(), b = jt(), g = qt(), S = !!(n && !r && c.includes("hours")), {
    meridiemMode: C,
    handleMeridiemChange: w
  } = Zl(o, n, s), v = (k) => n ? p.format(k, "hours12h") : p.format(k, "hours24h"), x = t, T = HN(z({}, x, {
    theme: g
  })), E = /* @__PURE__ */ h(YN, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: T.separator
  });
  return /* @__PURE__ */ J(UN, z({
    landscapeDirection: "row",
    toolbarTitle: b.timePickerToolbarTitle,
    isLandscape: i,
    ownerState: x,
    className: T.root
  }, f, {
    children: [/* @__PURE__ */ J(xy, {
      className: T.hourMinuteLabel,
      ownerState: x,
      children: [Lo(c, "hours") && /* @__PURE__ */ h(mn, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => u("hours"),
        selected: l === "hours",
        value: o ? v(o) : "--"
      }), Lo(c, ["hours", "minutes"]) && E, Lo(c, "minutes") && /* @__PURE__ */ h(mn, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => u("minutes"),
        selected: l === "minutes",
        value: o ? p.format(o, "minutes") : "--"
      }), Lo(c, ["minutes", "seconds"]) && E, Lo(c, "seconds") && /* @__PURE__ */ h(mn, {
        variant: "h3",
        onClick: () => u("seconds"),
        selected: l === "seconds",
        value: o ? p.format(o, "seconds") : "--"
      })]
    }), S && /* @__PURE__ */ J(Sy, {
      className: T.ampmSelection,
      ownerState: x,
      children: [/* @__PURE__ */ h(mn, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: C === "am",
        typographyClassName: T.ampmLabel,
        value: $n(p, "am"),
        onClick: m ? void 0 : () => w("am"),
        disabled: d
      }), /* @__PURE__ */ h(mn, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: C === "pm",
        typographyClassName: T.ampmLabel,
        value: $n(p, "pm"),
        onClick: m ? void 0 : () => w("pm"),
        disabled: d
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (Ty.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: a.bool,
  ampmInClock: a.bool,
  classes: a.object,
  /**
   * className applied to the root component.
   */
  className: a.string,
  disabled: a.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: a.bool,
  isLandscape: a.bool.isRequired,
  onChange: a.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: a.func.isRequired,
  readOnly: a.bool,
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  titleId: a.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: a.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: a.node,
  value: a.any,
  /**
   * Currently visible picker view.
   */
  view: a.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  views: a.arrayOf(a.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function _y(e, t) {
  var n, r, o, i, s;
  const l = Ue(), u = Ze({
    props: e,
    name: t
  }), c = (n = u.ampm) != null ? n : l.is12HourCycleInCurrentLocale(), d = U.useMemo(() => {
    var p;
    return ((p = u.localeText) == null ? void 0 : p.toolbarTitle) == null ? u.localeText : z({}, u.localeText, {
      timePickerToolbarTitle: u.localeText.toolbarTitle
    });
  }, [u.localeText]), m = (r = u.slots) != null ? r : gs(u.components), f = (o = u.slotProps) != null ? o : u.componentsProps;
  return z({}, u, {
    ampm: c,
    localeText: d
  }, Yu({
    views: u.views,
    openTo: u.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: (i = u.disableFuture) != null ? i : !1,
    disablePast: (s = u.disablePast) != null ? s : !1,
    slots: z({
      toolbar: Ty
    }, m),
    slotProps: z({}, f, {
      toolbar: z({
        ampm: c,
        ampmInClock: u.ampmInClock
      }, f == null ? void 0 : f.toolbar)
    })
  });
}
const Dy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s, l, u;
  const c = jt(), d = Ue(), m = _y(t, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: f,
    views: p,
    timeSteps: b
  } = vy(m), g = f ? yy : uu, S = z({
    hours: g,
    minutes: g,
    seconds: g,
    meridiem: g
  }, m.viewRenderers), C = (r = m.ampmInClock) != null ? r : !0, w = f ? [] : ["accept"], x = ((o = S.hours) == null ? void 0 : o.name) === uu.name ? p : p.filter((k) => k !== "meridiem"), T = z({}, m, {
    ampmInClock: C,
    timeSteps: b,
    viewRenderers: S,
    format: cl(d, m),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: f ? ["hours"] : x,
    slots: z({
      field: Sd,
      openPickerIcon: TE
    }, m.slots),
    slotProps: z({}, m.slotProps, {
      field: (k) => {
        var I;
        return z({}, zr((I = m.slotProps) == null ? void 0 : I.field, k), wi(m), {
          ref: n
        });
      },
      toolbar: z({
        hidden: !0,
        ampmInClock: C
      }, (i = m.slotProps) == null ? void 0 : i.toolbar),
      actionBar: z({
        actions: w
      }, (s = m.slotProps) == null ? void 0 : s.actionBar)
    })
  }), {
    renderPicker: E
  } = dd({
    props: T,
    valueManager: Nt,
    valueType: "time",
    getOpenDialogAriaText: (l = (u = T.localeText) == null ? void 0 : u.openTimePickerDialogue) != null ? l : c.openTimePickerDialogue,
    validator: bs
  });
  return E();
});
Dy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: a.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: a.shape({
    hours: a.number,
    minutes: a.number,
    seconds: a.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    hours: a.func,
    meridiem: a.func,
    minutes: a.func,
    seconds: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const Py = /* @__PURE__ */ U.forwardRef(function(t, n) {
  var r, o, i, s;
  const l = jt(), u = Ue(), c = _y(t, "MuiMobileTimePicker"), d = z({
    hours: Ko,
    minutes: Ko,
    seconds: Ko
  }, c.viewRenderers), m = (r = c.ampmInClock) != null ? r : !1, f = z({}, c, {
    ampmInClock: m,
    viewRenderers: d,
    format: cl(u, c),
    slots: z({
      field: Sd
    }, c.slots),
    slotProps: z({}, c.slotProps, {
      field: (b) => {
        var g;
        return z({}, zr((g = c.slotProps) == null ? void 0 : g.field, b), wi(c), {
          ref: n
        });
      },
      toolbar: z({
        hidden: !1,
        ampmInClock: m
      }, (o = c.slotProps) == null ? void 0 : o.toolbar)
    })
  }), {
    renderPicker: p
  } = yd({
    props: f,
    valueManager: Nt,
    valueType: "time",
    getOpenDialogAriaText: (i = (s = f.localeText) == null ? void 0 : s.openTimePickerDialogue) != null ? i : l.openTimePickerDialogue,
    validator: bs
  });
  return p();
});
Py.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    hours: a.func,
    minutes: a.func,
    seconds: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const GN = ["desktopModeMediaQuery"], Oy = /* @__PURE__ */ U.forwardRef(function(t, n) {
  const r = Ze({
    props: t,
    name: "MuiTimePicker"
  }), {
    desktopModeMediaQuery: o = td
  } = r, i = $e(r, GN);
  return jr(o, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ h(Dy, z({
    ref: n
  }, i)) : /* @__PURE__ */ h(Py, z({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (Oy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: a.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: a.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: a.bool,
  /**
   * Class name applied to the root element.
   */
  className: a.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: a.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: a.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: a.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: a.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: a.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: a.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: a.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: a.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: a.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: a.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: a.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: a.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Tn,
  /**
   * The label content.
   */
  label: a.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: a.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: a.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: a.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: a.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: a.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: a.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: a.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: a.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: a.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: a.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: a.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: a.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: a.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: a.oneOf(["landscape", "portrait"]),
  readOnly: a.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: a.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: a.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: a.oneOfType([a.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), a.number, a.shape({
    endIndex: a.number.isRequired,
    startIndex: a.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: a.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: a.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: a.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: a.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: a.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: a.oneOfType([a.arrayOf(a.oneOfType([a.func, a.object, a.bool])), a.func, a.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: a.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: a.shape({
    hours: a.number,
    minutes: a.number,
    seconds: a.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: a.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: a.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: a.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: a.shape({
    hours: a.func,
    meridiem: a.func,
    minutes: a.func,
    seconds: a.func
  }),
  /**
   * Available views.
   */
  views: a.arrayOf(a.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function du(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function KN(e) {
  if (Array.isArray(e))
    return e;
}
function ZN(e) {
  if (Array.isArray(e))
    return du(e);
}
function QN(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function JN(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function XN(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, s, l;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (u) {
      i = !0, l = u;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return r;
  }
}
function eF() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function tF() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Se(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(o) {
      return Object.getOwnPropertyDescriptor(n, o).enumerable;
    }))), r.forEach(function(o) {
      QN(e, o, n[o]);
    });
  }
  return e;
}
function nF(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Le(e, t) {
  return t = t ?? {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : nF(Object(t)).forEach(function(n) {
    Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
  }), e;
}
function Ft(e, t) {
  if (e == null)
    return {};
  var n = rF(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function rF(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function oF(e, t) {
  return KN(e) || XN(e, t) || ky(e, t) || eF();
}
function Nr(e) {
  return ZN(e) || JN(e) || ky(e) || tF();
}
function iF(e) {
  "@swc/helpers - typeof";
  return e && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e;
}
function ky(e, t) {
  if (e) {
    if (typeof e == "string")
      return du(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return du(e, t);
  }
}
var aF = ai({ onError: function(e) {
  return e == null ? void 0 : e.message;
} }), Ht = function() {
  var e;
  return (e = si(aF)) === null || e === void 0 ? void 0 : e.onError;
};
function sF(e) {
  var t;
  return { value: typeof ((t = e.transform) === null || t === void 0 ? void 0 : t.input) == "function" ? e.transform.input(e.value) : e.value, onChange: function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    var i, s, l;
    typeof ((l = e.transform) === null || l === void 0 ? void 0 : l.output) == "function" ? e.onChange((i = e.transform).output.apply(i, Nr(r))) : (s = e).onChange.apply(s, Nr(r));
  } };
}
var My = Vt(function(e, t) {
  var n = e.validation, r = n === void 0 ? {} : n, o = e.parseError, i = e.type, s = e.required, l = e.name, u = e.control, c = e.component, d = c === void 0 ? Il : c, m = e.inputRef, f = e.transform, p = Ft(e, ["validation", "parseError", "type", "required", "name", "control", "component", "inputRef", "transform"]), b = Ht(), g = o || b, S = Se({}, r, s && !r.required && { required: "This field is required" }, i === "email" && !r.pattern && { pattern: { value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: "Please enter a valid email address" } }), C = Zt({ name: l, control: u, disabled: p.disabled, rules: S }), w = C.field, v = C.fieldState, x = v.error, T = sF({ value: w.value, onChange: w.onChange, transform: f }), E = T.value, k = T.onChange, I = zn(w.ref, m);
  return h(d, Le(Se({}, p), { name: w.name, value: E ?? "", onChange: function(P) {
    k(i === "number" && P.target.value ? +P.target.value : P.target.value), typeof p.onChange == "function" && p.onChange(P);
  }, onBlur: w.onBlur, required: s, type: i, error: !!x, helperText: x ? typeof g == "function" ? g(x) : x.message : p.helperText, ref: t, inputRef: I }));
});
My.displayName = "TextFieldElement";
var Ey = My;
function ws(e) {
  var t = e.handleSubmit, n = e.children, r = e.FormProps, o = e.formContext, i = e.onSuccess, s = e.onError, l = Ft(e, ["handleSubmit", "children", "FormProps", "formContext", "onSuccess", "onError"]);
  return o ? (typeof i == "function" && typeof t == "function" && console.warn("Property `onSuccess` will be ignored because handleSubmit is provided"), h(Um, Le(Se({}, o), { children: h("form", Le(Se({ noValidate: !0 }, r), { onSubmit: t || (i ? o.handleSubmit(i, s) : function() {
    return console.log("submit handler `onSuccess` is missing");
  }), children: n })) }))) : h(lF, Se({ onSuccess: i, onError: s, FormProps: r, children: n }, l));
}
function lF(e) {
  var t = e.onSuccess, n = e.onError, r = e.FormProps, o = e.children, i = Ft(e, ["onSuccess", "onError", "FormProps", "children"]), s = ui(Se({}, i)), l = s.handleSubmit;
  return h(Um, Le(Se({}, s), { children: h("form", Le(Se({ onSubmit: l(t || function() {
    return console.log("submit handler `onSuccess` is missing");
  }, n), noValidate: !0 }, r), { children: o })) }));
}
var Iy = { disableFuture: "Date must be in the past", maxDate: "Date is later than the maximum allowed date", disablePast: "Past date is not allowed", invalidDate: "Date is invalid", minDate: "Date is earlier than the minimum allowed date", shouldDisableDate: "Date is not allowed", shouldDisableMonth: "Month is not allowed", shouldDisableYear: "Year is not allowed" }, cF = Vt(function(e, t) {
  var n = e.parseError, r = e.name, o = e.required, i = e.validation, s = i === void 0 ? {} : i, l = e.inputProps, u = e.control, c = e.textReadOnly, d = e.slotProps, m = e.overwriteErrorMessages, f = e.inputRef, p = Ft(e, ["parseError", "name", "required", "validation", "inputProps", "control", "textReadOnly", "slotProps", "overwriteErrorMessages", "inputRef"]), b = Wn(), g = Ht(), S = n || g, C = Se({}, Iy, m), w = Le(Se({}, s, o && !s.required && { required: "This field is required" }), { validate: Se({ internal: function(P) {
    var F, A, B = P == null || !b.utils.isValid(P) ? null : b.utils.getTimezone(P), W = To({ props: { shouldDisableDate: p.shouldDisableDate, shouldDisableMonth: p.shouldDisableMonth, shouldDisableYear: p.shouldDisableYear, disablePast: !!p.disablePast, disableFuture: !!p.disableFuture, minDate: p.minDate, maxDate: p.maxDate, timezone: (A = (F = p.timezone) !== null && F !== void 0 ? F : B) !== null && A !== void 0 ? A : "default" }, value: P, adapter: b });
    return W == null || C[W];
  } }, s.validate) }), v = Zt({ name: r, control: u, rules: w, disabled: p.disabled, defaultValue: null }), x = v.field, T = v.fieldState, E = T.error, k = zn(x.ref, f);
  x != null && x.value && typeof (x == null ? void 0 : x.value) == "string" && (x.value = new Date(x.value));
  var I = E ? typeof S == "function" ? S(E) : E.message : null;
  return h(vd, Le(Se({}, p, x), { ref: t, inputRef: k, onClose: function() {
    for (var P = arguments.length, F = new Array(P), A = 0; A < P; A++)
      F[A] = arguments[A];
    var B;
    x.onBlur(), p.onClose && (B = p).onClose.apply(B, Nr(F));
  }, onChange: function(P, F) {
    x.onChange(P, F), typeof p.onChange == "function" && p.onChange(P, F);
  }, slotProps: Le(Se({}, d), { textField: Le(Se({}, l), { required: o, onBlur: function(P) {
    x.onBlur(), typeof (l == null ? void 0 : l.onBlur) == "function" && l.onBlur(P);
  }, error: !!I, helperText: I || (l == null ? void 0 : l.helperText) || p.helperText, inputProps: Se({ readOnly: !!c }, l == null ? void 0 : l.inputProps) }) }) }));
});
cF.displayName = "DatePickerElement";
var uF = Vt(function(e, t) {
  var n = e.parseError, r = e.name, o = e.required, i = e.validation, s = i === void 0 ? {} : i, l = e.inputProps, u = e.control, c = e.slotProps, d = e.overwriteErrorMessages, m = e.inputRef, f = Ft(e, ["parseError", "name", "required", "validation", "inputProps", "control", "slotProps", "overwriteErrorMessages", "inputRef"]), p = Wn(), b = Ht(), g = n || b, S = Se({}, Iy, d), C = Le(Se({}, s, o && !s.required && { required: "This field is required" }), { validate: Se({ internal: function(k) {
    var I, P, F = k == null || !p.utils.isValid(k) ? null : p.utils.getTimezone(k), A = To({ props: { shouldDisableDate: f.shouldDisableDate, shouldDisableMonth: f.shouldDisableMonth, shouldDisableYear: f.shouldDisableYear, disablePast: !!f.disablePast, disableFuture: !!f.disableFuture, minDate: f.minDate, maxDate: f.maxDate, timezone: (P = (I = f.timezone) !== null && I !== void 0 ? I : F) !== null && P !== void 0 ? P : "default" }, value: k, adapter: p });
    return A == null || S[A];
  } }, s.validate) }), w = Zt({ name: r, control: u, rules: C, disabled: f.disabled, defaultValue: null }), v = w.field, x = w.fieldState, T = x.error, E = zn(v.ref, m);
  return v != null && v.value && typeof (v == null ? void 0 : v.value) == "string" && (v.value = new Date(v.value)), h(bd, Le(Se({}, f, v), { ref: t, inputRef: E, onClose: function() {
    for (var k = arguments.length, I = new Array(k), P = 0; P < k; P++)
      I[P] = arguments[P];
    var F;
    v.onBlur(), f.onClose && (F = f).onClose.apply(F, Nr(I));
  }, onChange: function(k, I) {
    v.onChange(k, I), typeof f.onChange == "function" && f.onChange(k, I);
  }, slotProps: Le(Se({}, c), { textField: Le(Se({}, l), { required: o, error: !!T, helperText: T ? typeof g == "function" ? g(T) : T.message : (l == null ? void 0 : l.helperText) || f.helperText }) }) }));
});
uF.displayName = "MobileDatePickerElement";
var dF = { disableFuture: "Date must be in the past", maxDate: "Date is later than the maximum allowed date", disablePast: "Past date is not allowed", invalidDate: "Date is invalid", minDate: "Date is earlier than the minimum allowed date", shouldDisableDate: "Date is not allowed", shouldDisableMonth: "Month is not allowed", shouldDisableYear: "Year is not allowed", minTime: "Time is earlier than the minimum allowed", maxTime: "Time is later than the maximum allowed", "shouldDisableTime-hours": "Specified hour is disabled", "shouldDisableTime-minutes": "Specified minute is disabled", "shouldDisableTime-seconds": "Specified second is disabled", "shouldDisableClock-hours": "Specified hour on the clock is disabled", "shouldDisableClock-minutes": "Specified minute on the clock is disabled", "shouldDisableClock-seconds": "Specified second on the clock is disabled", minutesStep: "Invalid minutes step" }, fF = Vt(function(e, t) {
  var n = e.parseError, r = e.name, o = e.required, i = e.validation, s = i === void 0 ? {} : i, l = e.inputProps, u = e.control, c = e.textReadOnly, d = e.slotProps, m = e.overwriteErrorMessages, f = e.inputRef, p = Ft(e, ["parseError", "name", "required", "validation", "inputProps", "control", "textReadOnly", "slotProps", "overwriteErrorMessages", "inputRef"]), b = Wn(), g = Ht(), S = n || g, C = Se({}, dF, m), w = Le(Se({}, s, o && !s.required && { required: "This field is required" }), { validate: Se({ internal: function(I) {
    var P, F, A = I == null || !b.utils.isValid(I) ? null : b.utils.getTimezone(I), B = Ql({ props: { shouldDisableDate: p.shouldDisableDate, shouldDisableMonth: p.shouldDisableMonth, shouldDisableYear: p.shouldDisableYear, disablePast: !!p.disablePast, disableFuture: !!p.disableFuture, minDate: p.minDate, maxDate: p.maxDate, timezone: (F = (P = p.timezone) !== null && P !== void 0 ? P : A) !== null && F !== void 0 ? F : "default", disableIgnoringDatePartForTimeValidation: p.disableIgnoringDatePartForTimeValidation, maxTime: p.maxTime, minTime: p.minTime, minutesStep: p.minutesStep, shouldDisableTime: p.shouldDisableTime }, value: I, adapter: b });
    return B == null || C[B];
  } }, s.validate) }), v = Zt({ name: r, rules: w, control: u, disabled: p.disabled, defaultValue: null }), x = v.field, T = v.fieldState, E = T.error, k = zn(x.ref, f);
  return x != null && x.value && typeof (x == null ? void 0 : x.value) == "string" && (x.value = new Date(x.value)), h(xd, Le(Se({}, p, x), { ref: t, inputRef: k, onClose: function() {
    for (var I = arguments.length, P = new Array(I), F = 0; F < I; F++)
      P[F] = arguments[F];
    var A;
    x.onBlur(), p.onClose && (A = p).onClose.apply(A, Nr(P));
  }, onChange: function(I, P) {
    x.onChange(I, P), typeof p.onChange == "function" && p.onChange(I, P);
  }, slotProps: Le(Se({}, d), { textField: Le(Se({}, l), { required: o, error: !!E, helperText: E ? typeof S == "function" ? S(E) : E.message : (l == null ? void 0 : l.helperText) || p.helperText, inputProps: Se({ readOnly: c }, l == null ? void 0 : l.inputProps) }) }) }));
});
fF.displayName = "DateTimePickerElement";
var pF = { invalidDate: "Time is invalid", minTime: "Time is earlier than the minimum allowed", maxTime: "Time is later than the maximum allowed", disableFuture: "Future time is disabled", disablePast: "Past time is disabled", "shouldDisableTime-hours": "Specified hour is disabled", "shouldDisableTime-minutes": "Specified minute is disabled", "shouldDisableTime-seconds": "Specified second is disabled", "shouldDisableClock-hours": "Specified hour on the clock is disabled", "shouldDisableClock-minutes": "Specified minute on the clock is disabled", "shouldDisableClock-seconds": "Specified second on the clock is disabled", minutesStep: "Invalid minutes step" }, mF = Vt(function(e, t) {
  var n = e.parseError, r = e.name, o = e.required, i = e.validation, s = i === void 0 ? {} : i, l = e.inputProps, u = e.control, c = e.textReadOnly, d = e.slotProps, m = e.overwriteErrorMessages, f = e.inputRef, p = Ft(e, ["parseError", "name", "required", "validation", "inputProps", "control", "textReadOnly", "slotProps", "overwriteErrorMessages", "inputRef"]), b = Wn(), g = Ht(), S = n || g, C = Se({}, pF, m), w = Le(Se({}, s, o && !s.required && { required: "This field is required" }), { validate: Se({ internal: function(I) {
    var P, F, A = I == null || !b.utils.isValid(I) ? null : b.utils.getTimezone(I), B = bs({ props: { minTime: p.minTime, maxTime: p.maxTime, minutesStep: p.minutesStep, shouldDisableClock: p.shouldDisableClock, shouldDisableTime: p.shouldDisableTime, disableIgnoringDatePartForTimeValidation: p.disableIgnoringDatePartForTimeValidation, disablePast: !!p.disablePast, disableFuture: !!p.disableFuture, timezone: (F = (P = p.timezone) !== null && P !== void 0 ? P : A) !== null && F !== void 0 ? F : "default" }, value: I, adapter: b });
    return B == null || C[B];
  } }, s.validate) }), v = Zt({ name: r, control: u, rules: w, disabled: p.disabled, defaultValue: null }), x = v.field, T = v.fieldState, E = T.error, k = zn(x.ref, f);
  return x != null && x.value && typeof (x == null ? void 0 : x.value) == "string" && (x.value = new Date(x.value)), h(Oy, Le(Se({}, p, x), { ref: t, inputRef: k, onClose: function() {
    for (var I = arguments.length, P = new Array(I), F = 0; F < I; F++)
      P[F] = arguments[F];
    var A;
    x.onBlur(), p.onClose && (A = p).onClose.apply(A, Nr(P));
  }, onChange: function(I, P) {
    x.onChange(I, P), typeof p.onChange == "function" && p.onChange(I, P);
  }, slotProps: Le(Se({}, d), { textField: Le(Se({}, l), { required: o, error: !!E, helperText: E ? typeof S == "function" ? S(E) : E.message : (l == null ? void 0 : l.helperText) || p.helperText, inputProps: Se({ readOnly: c }, l == null ? void 0 : l.inputProps) }) }) }));
});
mF.displayName = "TimePickerElement";
var Ry = Vt(function(e, t) {
  var n = e.name, r = e.validation, o = r === void 0 ? {} : r, i = e.required, s = e.parseError, l = e.label, u = e.control, c = e.helperText, d = e.labelProps, m = e.inputRef, f = Ft(e, ["name", "validation", "required", "parseError", "label", "control", "helperText", "labelProps", "inputRef"]), p = Ht(), b = s || p, g = Se({}, o, i && !o.required && { required: "This field is required" }), S = Zt({ name: n, control: u, disabled: f.disabled, rules: g }), C = S.field, w = S.fieldState, v = w.error, x = zn(C.ref, m), T = v ? typeof b == "function" ? b(v) : v.message : c;
  return J(li, { required: i, error: !!v, ref: t, children: [h(Wm, { row: !0, children: h(Fa, Le(Se({}, d), { label: l || "", control: h(El, Le(Se({}, f), { color: f.color || "primary", sx: Nr(Array.isArray(f.sx) ? f.sx : [f.sx]).concat([{ color: v ? "error.main" : void 0 }]), value: C.value, checked: !!C.value, onChange: function(E) {
    C.onChange(!C.value), typeof f.onChange == "function" && f.onChange(E, !C.value);
  }, inputRef: x })) })) }), T && h(ci, { error: !!v, children: T })] });
});
Ry.displayName = "CheckboxElement";
var hF = Ry, gF = Vt(function(e, t) {
  var n, r, o = e.name, i = e.required, s = e.valueKey, l = s === void 0 ? "id" : s, u = e.labelKey, c = u === void 0 ? "label" : u, d = e.options, m = d === void 0 ? [] : d, f = e.parseError, p = e.type, b = e.objectOnChange, g = e.validation, S = g === void 0 ? {} : g, C = e.control, w = e.inputRef, v = Ft(e, ["name", "required", "valueKey", "labelKey", "options", "parseError", "type", "objectOnChange", "validation", "control", "inputRef"]), x = Ht(), T = f || x, E = !!(!((n = v.SelectProps) === null || n === void 0) && n.native), k = E ? "option" : Hm, I = Se({}, S, i && !S.required && { required: "This field is required" }), P = Zt({ name: o, rules: I, disabled: v.disabled, control: C }), F = P.field, A = P.fieldState, B = A.error, W = zn(F.ref, w);
  p === "number" && iF(F.value) < "u" && (v.InputLabelProps = v.InputLabelProps || {}, v.InputLabelProps.shrink = !0);
  var M, _ = (M = (r = F.value) === null || r === void 0 ? void 0 : r[l]) !== null && M !== void 0 ? M : F.value;
  return J(Il, Le(Se({}, v), { name: o, value: _ ?? "", onBlur: F.onBlur, ref: t, onChange: function(O) {
    var R = O.target.value;
    p === "number" && R && (R = Number(R)), F.onChange(R), typeof v.onChange == "function" && (b && (R = m.find(function(N) {
      return N[l] === R;
    })), v.onChange(R));
  }, select: !0, required: i, error: !!B, helperText: B ? typeof T == "function" ? T(B) : B.message : v.helperText, inputRef: W, children: [E && h("option", {}), m.map(function(O) {
    var R, N;
    return cs(k, { key: "".concat(o, "_").concat(O[l]), value: (R = O == null ? void 0 : O[l]) !== null && R !== void 0 ? R : O, disabled: (N = O == null ? void 0 : O.disabled) !== null && N !== void 0 ? N : !1 }, O[c]);
  })] }));
});
gF.displayName = "SelectElement";
var yF = Vt(function(e, t) {
  var n = e.helperText, r = e.options, o = e.label, i = e.name, s = e.parseError, l = e.required, u = e.labelKey, c = u === void 0 ? "label" : u, d = e.valueKey, m = d === void 0 ? "id" : d, f = e.returnObject, p = e.disabled, b = e.row, g = e.control, S = e.checkboxColor, C = e.rules, w = e.labelProps, v = Ft(e, ["helperText", "options", "label", "name", "parseError", "required", "labelKey", "valueKey", "returnObject", "disabled", "row", "control", "checkboxColor", "rules", "labelProps"]), x = qm(), T = Ht(), E = s || T, k = Zt({ name: i, rules: l ? { required: "This field is required" } : C, disabled: p, control: g }), I = k.field, P = I.value, F = P === void 0 ? [] : P, A = I.onChange, B = k.fieldState, W = B.error, M = W ? typeof E == "function" ? E(W) : W.message : n, _ = function(O) {
    var R = Nr(F);
    F.findIndex(function(N) {
      return f ? N[m] === O : N === O;
    }) === -1 ? R.push(f ? r.find(function(N) {
      return N[m] === O;
    }) : O) : R.splice(F.findIndex(function(N) {
      return f ? N[m] === O : N === O;
    }), 1), A(R), typeof v.onChange == "function" && v.onChange(R);
  };
  return J(li, { error: !!W, required: l, ref: t, children: [o && h(Rl, { error: !!W, children: o }), h(Wm, { row: b, children: r.map(function(O) {
    var R = O[m];
    R || console.error("CheckboxButtonGroup: valueKey ".concat(m, " does not exist on option"), O);
    var N = F.findIndex(function(L) {
      return f ? L[m] === R : L === R;
    }) !== -1;
    return cs(Fa, Le(Se({}, w), { control: h(El, { sx: { color: W ? x.palette.error.main : void 0 }, color: S || "primary", value: R, checked: N, disabled: p, onChange: function() {
      return _(R);
    } }), label: O[c], key: R }));
  }) }), M && h(ci, { children: M })] });
});
yF.displayName = "CheckboxButtonGroup";
var bF = 48, vF = 8, CF = Vt(function(e, t) {
  var n, r, o, i = e.options, s = e.label, l = s === void 0 ? "" : s, u = e.itemKey, c = u === void 0 ? "id" : u, d = e.itemValue, m = d === void 0 ? "" : d, f = e.itemLabel, p = f === void 0 ? "label" : f, b = e.required, g = b === void 0 ? !1 : b, S = e.validation, C = S === void 0 ? {} : S, w = e.parseError, v = e.name, x = e.menuMaxHeight, T = x === void 0 ? bF * 4.5 + vF : x, E = e.menuMaxWidth, k = E === void 0 ? 250 : E, I = e.minWidth, P = I === void 0 ? 120 : I, F = e.helperText, A = e.showChips, B = e.preserveOrder, W = e.control, M = e.showCheckbox, _ = e.formControlProps, O = e.inputRef, R = Ft(e, ["options", "label", "itemKey", "itemValue", "itemLabel", "required", "validation", "parseError", "name", "menuMaxHeight", "menuMaxWidth", "minWidth", "helperText", "showChips", "preserveOrder", "control", "showCheckbox", "formControlProps", "inputRef"]), N = Ht(), L = w || N, $ = function(fe) {
    var le, ce;
    return (ce = (le = i.find(function(ee) {
      var ae;
      return ((ae = ee[m || c]) !== null && ae !== void 0 ? ae : ee) === fe;
    })) === null || le === void 0 ? void 0 : le[p]) !== null && ce !== void 0 ? ce : fe;
  }, H = Se({}, C, g && !C.required && { required: "This field is required" }), G = Zt({ name: v, rules: H, disabled: R.disabled, control: W }), q = G.field, Y = G.fieldState, Z = Y.error, ie = zn(q.ref, O), X = Z ? typeof L == "function" ? L(Z) : Z.message : F, se;
  return J(li, Le(Se({}, _), { style: Le(Se({}, _ == null ? void 0 : _.style), { minWidth: P }), variant: R.variant, fullWidth: R.fullWidth, error: !!Z, size: R.size, ref: t, children: [l && h(Qv, { size: R.size === "small" ? "small" : void 0, error: !!Z, htmlFor: R.id || "select-multi-select-".concat(v), required: g, children: l }), h(Jv, Le(Se({}, R), { id: R.id || "select-multi-select-".concat(v), multiple: !0, label: l || void 0, error: !!Z, value: q.value || [], required: g, onChange: q.onChange, onBlur: q.onBlur, MenuProps: Le(Se({}, R.MenuProps), { PaperProps: Se({}, (se = (n = R.MenuProps) === null || n === void 0 ? void 0 : n.PaperProps) !== null && se !== void 0 ? se : { style: Se({ maxHeight: T, width: k }, (o = R.MenuProps) === null || o === void 0 || (r = o.PaperProps) === null || r === void 0 ? void 0 : r.style) }) }), renderValue: typeof R.renderValue == "function" ? R.renderValue : A ? function(fe) {
    return h("div", { style: { display: "flex", flexWrap: "wrap" }, children: (B ? i.filter(function(le) {
      return fe.includes(le);
    }) : fe || []).map(function(le) {
      return h(Xv, { label: $(le), style: { display: "flex", flexWrap: "wrap" }, onDelete: function() {
        q.onChange(q.value.filter(function(ce) {
          return ce !== le;
        }));
      }, deleteIcon: h(Ym, { onMouseDown: function(ce) {
        ce.stopPropagation();
      } }) }, le);
    }) });
  } : function(fe) {
    return Array.isArray(fe) ? fe.map($).join(", ") : "";
  }, inputRef: ie, children: i.map(function(fe) {
    var le = fe[m || c] || fe, ce = Array.isArray(q.value) ? q.value.includes(le) : !1;
    return J(Hm, { value: le, sx: { fontWeight: function(ee) {
      return ce ? ee.typography.fontWeightBold : ee.typography.fontWeightRegular;
    } }, children: [M && h(El, { checked: ce }), h(eC, { primary: fe[p] || fe })] }, le);
  }) })), X && h(ci, { error: !!Z, children: X })] }));
});
CF.displayName = "MultiSelectElement";
var Ay = Vt(function(e, t) {
  var n = e.iconColor, r = e.renderIcon, o = r === void 0 ? function(c) {
    return c ? h(mC, {}) : h(hC, {});
  } : r, i = Ft(e, ["iconColor", "renderIcon"]), s = oF(Xe(!0), 2), l = s[0], u = s[1];
  return h(Ey, Le(Se({}, i), { ref: t, InputProps: { endAdornment: h(tC, { position: "end", children: h(nC, { onMouseDown: function(c) {
    return c.preventDefault();
  }, onClick: function() {
    return u(!l);
  }, tabIndex: -1, color: n ?? "default", children: o(l) }) }) }, type: l ? "password" : "text" }));
});
Ay.displayName = "PasswordElement";
var $y = Ay, Ny = Vt(function(e, t) {
  var n = e.helperText, r = e.options, o = e.label, i = e.name, s = e.parseError, l = e.labelKey, u = l === void 0 ? "label" : l, c = e.valueKey, d = c === void 0 ? "id" : c, m = e.required, f = e.emptyOptionLabel, p = e.returnObject, b = e.row, g = e.control, S = e.type, C = e.labelProps, w = e.disabled, v = e.formLabelProps, x = Ft(e, ["helperText", "options", "label", "name", "parseError", "labelKey", "valueKey", "required", "emptyOptionLabel", "returnObject", "row", "control", "type", "labelProps", "disabled", "formLabelProps"]), T = qm(), E = Ht(), k = s || E, I = Zt({ name: i, rules: m ? { required: "This field is required" } : void 0, disabled: w, control: g }), P = I.field, F = I.fieldState, A = F.error, B = A ? typeof k == "function" ? k(A) : A.message : n, W = function(M) {
    var _ = M.target.value, O = p ? r.find(function(R) {
      return R[d] === _;
    }) : _;
    P.onChange(O), typeof x.onChange == "function" && x.onChange(O);
  };
  return J(li, { error: !!A, ref: t, children: [o && h(Rl, Le(Se({}, v), { required: m, error: !!A, children: o })), J(rC, { onChange: W, name: i, row: b, value: P.value || "", children: [f && h(Fa, Le(Se({}, C), { control: h(Jd, { sx: { color: A ? T.palette.error.main : void 0 }, checked: !P.value }), label: f, value: "" })), r.map(function(M) {
    var _, O = M[d];
    O || console.error("CheckboxButtonGroup: valueKey ".concat(d, " does not exist on option"), M);
    var R = p ? (_ = P.value) === null || _ === void 0 ? void 0 : _[d] : P.value;
    S === "number" && (R = Number(R));
    var N = R === O;
    return cs(Fa, Le(Se({}, C), { control: h(Jd, { sx: { color: A ? T.palette.error.main : void 0 }, disabled: w, checked: N }), value: O, label: M[u], key: O }));
  })] }), B && h(ci, { children: B })] });
});
Ny.displayName = "RadioButtonGroup";
var wF = Ny, Fy = Vt(function(e, t) {
  var n = e.name, r = e.control, o = e.switchProps, i = Ft(e, ["name", "control", "switchProps"]), s = Zt({ name: n, control: r, disabled: i.disabled }), l = s.field, u = zn(l.ref, o == null ? void 0 : o.ref);
  return h(Fa, Se({ ref: t, control: h(oC, Le(Se({}, o), { name: l.name, value: l.value, onChange: function(c, d) {
    l.onChange(c, d), typeof (o == null ? void 0 : o.onChange) == "function" && o.onChange(c, d);
  }, onBlur: function(c) {
    l.onBlur(), typeof (o == null ? void 0 : o.onBlur) == "function" && (o == null || o.onBlur(c));
  }, ref: u, checked: !!l.value })) }, i));
});
Fy.displayName = "SwitchElement";
var Vy = Fy, jy = Vt(function(e, t) {
  var n = e.passwordFieldName, r = e.customInvalidFieldMessage, o = e.control, i = Ft(e, ["passwordFieldName", "customInvalidFieldMessage", "control"]), s = Jo({ name: n, control: o }), l = r ?? "Password should match";
  return h($y, Le(Se({ control: o }, i), { ref: t, validation: { validate: function(u) {
    return u === s || l;
  } } }));
});
jy.displayName = "PasswordRepeatElement";
var xF = jy, SF = Vt(function(e, t) {
  var n, r = e.textFieldProps, o = e.autocompleteProps, i = e.name, s = e.control, l = e.options, u = e.loading, c = e.showCheckbox, d = e.rules, m = e.loadingIndicator, f = e.required, p = e.multiple, b = e.matchId, g = e.label, S = e.parseError, C = Ht(), w = S || C, v = Se({}, d, f && { required: (d == null ? void 0 : d.required) || "This field is required" }), x = m || h(Pl, { color: "inherit", size: 20 }), T = Zt({ name: i, control: s, disabled: o == null ? void 0 : o.disabled, rules: v }), E = T.field, k = T.fieldState, I = k.error, P = zn(E.ref, r == null ? void 0 : r.inputRef), F = p ? E.value || [] : (n = E.value) !== null && n !== void 0 ? n : null, A, B;
  return b && (F = p ? (E.value || []).map(function(W) {
    return l.find(function(M) {
      var _;
      return ((_ = M.id) !== null && _ !== void 0 ? _ : M) === W;
    });
  }) : (A = l.find(function(W) {
    var M;
    return ((M = W.id) !== null && M !== void 0 ? M : W) === E.value;
  })) !== null && A !== void 0 ? A : null), h(iC, Le(Se({}, o), { value: F, loading: u, multiple: p, options: l, disableCloseOnSelect: typeof (o == null ? void 0 : o.disableCloseOnSelect) == "boolean" ? o.disableCloseOnSelect : !!p, isOptionEqualToValue: o != null && o.isOptionEqualToValue ? o.isOptionEqualToValue : function(W, M) {
    var _;
    return M ? W.id === ((_ = M == null ? void 0 : M.id) !== null && _ !== void 0 ? _ : M) : !1;
  }, getOptionLabel: o != null && o.getOptionLabel ? o.getOptionLabel : function(W) {
    var M;
    return "".concat((M = W == null ? void 0 : W.label) !== null && M !== void 0 ? M : W);
  }, onChange: function(W, M, _, O) {
    var R = M, N;
    b && (R = Array.isArray(M) ? M.map(function(L) {
      var $;
      return ($ = L == null ? void 0 : L.id) !== null && $ !== void 0 ? $ : L;
    }) : (N = M == null ? void 0 : M.id) !== null && N !== void 0 ? N : M), E.onChange(R), o != null && o.onChange && o.onChange(W, M, _, O);
  }, ref: t, renderOption: (B = o == null ? void 0 : o.renderOption) !== null && B !== void 0 ? B : c ? function(W, M, _) {
    var O = _.selected, R;
    return J("li", Le(Se({}, W), { children: [h(El, { sx: { marginRight: 1 }, checked: O }), (o == null || (R = o.getOptionLabel) === null || R === void 0 ? void 0 : R.call(o, M)) || M.label || M] }));
  } : void 0, onBlur: function(W) {
    E.onBlur(), typeof (o == null ? void 0 : o.onBlur) == "function" && o.onBlur(W);
  }, renderInput: function(W) {
    return h(Il, Le(Se({ name: i, required: d != null && d.required ? !0 : f, label: g }, r, W), { error: !!I, InputLabelProps: Se({}, W.InputLabelProps, r == null ? void 0 : r.InputLabelProps), InputProps: Se(Le(Se({}, W.InputProps), { endAdornment: J(Dt, { children: [u ? x : null, W.InputProps.endAdornment] }) }), r == null ? void 0 : r.InputProps), inputProps: Se({}, W.inputProps, r == null ? void 0 : r.inputProps), helperText: I ? typeof w == "function" ? w(I) : I.message : r == null ? void 0 : r.helperText, inputRef: P }));
  } }));
});
SF.displayName = "AutocompleteElement";
var Ly = Vt(function(e, t) {
  var n = e.name, r = e.control, o = e.label, i = e.rules, s = i === void 0 ? {} : i, l = e.parseError, u = e.required, c = e.formControlProps, d = Ft(e, ["name", "control", "label", "rules", "parseError", "required", "formControlProps"]), m = Ht(), f = l || m, p = Se({}, s, u && !s.required && { required: "This field is required" }), b = Zt({ name: n, control: r, disabled: d.disabled, rules: p }), g = b.field, S = b.fieldState, C = S.error, w = S.invalid, v = C ? typeof f == "function" ? f(C) : C.message : null;
  return J(li, Le(Se({ error: w, required: u, fullWidth: !0 }, c), { ref: t, children: [o && h(Rl, { component: "legend", error: w, children: o }), h(aC, Le(Se({}, d), { value: g.value, onChange: g.onChange, valueLabelDisplay: d.valueLabelDisplay || "auto" })), v && h(ci, { error: w, children: v })] }));
});
Ly.displayName = "SliderElement";
var TF = Ly;
function _F(e) {
  var t = e.name, n = e.control, r = e.label, o = e.validation, i = o === void 0 ? {} : o, s = e.required, l = e.options, u = l === void 0 ? [] : l, c = e.parseError, d = e.helperText, m = e.formLabelProps, f = e.enforceAtLeastOneSelected, p = f === void 0 ? !1 : f, b = e.exclusive, g = Ft(e, ["name", "control", "label", "validation", "required", "options", "parseError", "helperText", "formLabelProps", "enforceAtLeastOneSelected", "exclusive"]), S = Ht(), C = c || S, w = Se({}, i, s && !i.required && { validation: "This field is required" }), v = s || !!(i != null && i.required), x = Zt({ name: t, control: n, rules: w, disabled: g.disabled }), T = x.field, E = x.fieldState, k = E.error, I = k ? typeof C == "function" ? C(k) : k.message : d;
  return J(li, { error: !!k, required: v, fullWidth: g == null ? void 0 : g.fullWidth, children: [r && h(Rl, Le(Se({}, m), { error: !!k, required: v, sx: Se({ mb: 1 }, m == null ? void 0 : m.sx), children: r })), h(lC, Le(Se({}, g), { exclusive: b, value: T.value, onBlur: T.onBlur, onChange: function(P, F) {
    p && (b && F === null || !b && F.length === 0) || (T.onChange(F), typeof g.onChange == "function" && g.onChange(P, F));
  }, children: u.map(function(P) {
    var F = P.label, A = P.id, B = Ft(P, ["label", "id"]);
    return cs(cC, Le(Se({ value: A }, B), { key: A }), F);
  }) })), I && h(ci, { children: I })] });
}
var DF = Vt(function(e, t) {
  var n = e.validation, r = n === void 0 ? {} : n, o = e.parseError, i = e.required, s = e.name, l = e.control, u = e.rows, c = e.resizeStyle, d = e.inputRef, m = e.inputProps, f = Ft(e, ["validation", "parseError", "required", "name", "control", "rows", "resizeStyle", "inputRef", "inputProps"]), p = Ht(), b = o || p, g = Se({}, r, i && !r.required && { required: "This field is required" }), S = Zt({ name: s, control: l, rules: g, disabled: f.disabled }), C = S.field, w = S.fieldState, v = w.error, x = zn(C.ref, d), T;
  return h(Il, Le(Se({}, f), { name: s, value: (T = C.value) !== null && T !== void 0 ? T : "", onChange: function(E) {
    C.onChange(E.target.value), typeof f.onChange == "function" && f.onChange(E);
  }, onBlur: C.onBlur, required: i, error: !!v, helperText: v ? typeof b == "function" ? b(v) : v.message : f.helperText, inputRef: x, multiline: !0, InputProps: { inputComponent: sC, inputProps: Se({ minRows: u, style: { resize: c || "both" } }, m || {}) }, ref: t }));
});
DF.displayName = "TextareaAutosizeElement";
var PF = "Expected a function", By = "__lodash_hash_undefined__", zy = 1 / 0, Wy = 9007199254740991, OF = "[object Arguments]", kF = "[object Function]", MF = "[object GeneratorFunction]", EF = "[object Symbol]", IF = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, RF = /^\w*$/, AF = /^\./, $F = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, NF = /[\\^$.*+?()[\]{}|]/g, FF = /\\(\\)?/g, VF = /^\[object .+?Constructor\]$/, jF = /^(?:0|[1-9]\d*)$/, LF = typeof ot == "object" && ot && ot.Object === Object && ot, BF = typeof self == "object" && self && self.Object === Object && self, Td = LF || BF || Function("return this")();
function zF(e, t) {
  return e == null ? void 0 : e[t];
}
function WF(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
var qF = Array.prototype, HF = Function.prototype, _d = Object.prototype, Oc = Td["__core-js_shared__"], dp = function() {
  var e = /[^.]+$/.exec(Oc && Oc.keys && Oc.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), qy = HF.toString, xs = _d.hasOwnProperty, Dd = _d.toString, UF = RegExp(
  "^" + qy.call(xs).replace(NF, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), fp = Td.Symbol, YF = _d.propertyIsEnumerable, GF = qF.splice, KF = Hy(Td, "Map"), ts = Hy(Object, "create"), pp = fp ? fp.prototype : void 0, mp = pp ? pp.toString : void 0;
function ho(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function ZF() {
  this.__data__ = ts ? ts(null) : {};
}
function QF(e) {
  return this.has(e) && delete this.__data__[e];
}
function JF(e) {
  var t = this.__data__;
  if (ts) {
    var n = t[e];
    return n === By ? void 0 : n;
  }
  return xs.call(t, e) ? t[e] : void 0;
}
function XF(e) {
  var t = this.__data__;
  return ts ? t[e] !== void 0 : xs.call(t, e);
}
function eV(e, t) {
  var n = this.__data__;
  return n[e] = ts && t === void 0 ? By : t, this;
}
ho.prototype.clear = ZF;
ho.prototype.delete = QF;
ho.prototype.get = JF;
ho.prototype.has = XF;
ho.prototype.set = eV;
function xi(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function tV() {
  this.__data__ = [];
}
function nV(e) {
  var t = this.__data__, n = sc(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : GF.call(t, n, 1), !0;
}
function rV(e) {
  var t = this.__data__, n = sc(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function oV(e) {
  return sc(this.__data__, e) > -1;
}
function iV(e, t) {
  var n = this.__data__, r = sc(n, e);
  return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
}
xi.prototype.clear = tV;
xi.prototype.delete = nV;
xi.prototype.get = rV;
xi.prototype.has = oV;
xi.prototype.set = iV;
function _o(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
function aV() {
  this.__data__ = {
    hash: new ho(),
    map: new (KF || xi)(),
    string: new ho()
  };
}
function sV(e) {
  return lc(this, e).delete(e);
}
function lV(e) {
  return lc(this, e).get(e);
}
function cV(e) {
  return lc(this, e).has(e);
}
function uV(e, t) {
  return lc(this, e).set(e, t), this;
}
_o.prototype.clear = aV;
_o.prototype.delete = sV;
_o.prototype.get = lV;
_o.prototype.has = cV;
_o.prototype.set = uV;
function sc(e, t) {
  for (var n = e.length; n--; )
    if (SV(e[n][0], t))
      return n;
  return -1;
}
function dV(e, t) {
  return e != null && xs.call(e, t);
}
function fV(e) {
  if (!Gy(e) || vV(e))
    return !1;
  var t = Uy(e) || WF(e) ? UF : VF;
  return t.test(xV(e));
}
function pV(e) {
  if (typeof e == "string")
    return e;
  if (kd(e))
    return mp ? mp.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -zy ? "-0" : t;
}
function mV(e) {
  return Od(e) ? e : CV(e);
}
function lc(e, t) {
  var n = e.__data__;
  return bV(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Hy(e, t) {
  var n = zF(e, t);
  return fV(n) ? n : void 0;
}
function hV(e, t, n) {
  t = yV(t, e) ? [t] : mV(t);
  for (var r, o = -1, s = t.length; ++o < s; ) {
    var i = wV(t[o]);
    if (!(r = e != null && n(e, i)))
      break;
    e = e[i];
  }
  if (r)
    return r;
  var s = e ? e.length : 0;
  return !!s && Yy(s) && gV(i, s) && (Od(e) || TV(e));
}
function gV(e, t) {
  return t = t ?? Wy, !!t && (typeof e == "number" || jF.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function yV(e, t) {
  if (Od(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || kd(e) ? !0 : RF.test(e) || !IF.test(e) || t != null && e in Object(t);
}
function bV(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function vV(e) {
  return !!dp && dp in e;
}
var CV = Pd(function(e) {
  e = PV(e);
  var t = [];
  return AF.test(e) && t.push(""), e.replace($F, function(n, r, o, i) {
    t.push(o ? i.replace(FF, "$1") : r || n);
  }), t;
});
function wV(e) {
  if (typeof e == "string" || kd(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -zy ? "-0" : t;
}
function xV(e) {
  if (e != null) {
    try {
      return qy.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function Pd(e, t) {
  if (typeof e != "function" || t && typeof t != "function")
    throw new TypeError(PF);
  var n = function() {
    var r = arguments, o = t ? t.apply(this, r) : r[0], i = n.cache;
    if (i.has(o))
      return i.get(o);
    var s = e.apply(this, r);
    return n.cache = i.set(o, s), s;
  };
  return n.cache = new (Pd.Cache || _o)(), n;
}
Pd.Cache = _o;
function SV(e, t) {
  return e === t || e !== e && t !== t;
}
function TV(e) {
  return DV(e) && xs.call(e, "callee") && (!YF.call(e, "callee") || Dd.call(e) == OF);
}
var Od = Array.isArray;
function _V(e) {
  return e != null && Yy(e.length) && !Uy(e);
}
function DV(e) {
  return Ky(e) && _V(e);
}
function Uy(e) {
  var t = Gy(e) ? Dd.call(e) : "";
  return t == kF || t == MF;
}
function Yy(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Wy;
}
function Gy(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Ky(e) {
  return !!e && typeof e == "object";
}
function kd(e) {
  return typeof e == "symbol" || Ky(e) && Dd.call(e) == EF;
}
function PV(e) {
  return e == null ? "" : pV(e);
}
function OV(e, t) {
  return e != null && hV(e, t, dV);
}
var kV = OV;
const MV = /* @__PURE__ */ Mt(kV), EV = {
  small: 20,
  medium: 24,
  large: 35
}, Md = Q(Be, {
  shouldForwardProp: (e) => !["size", "isChecked", "color", "disabled"].includes(e)
})(({ theme: e, color: t = "primary", size: n = "medium" }) => {
  const r = EV[n], o = `${r * 0.75}px`, i = `${r}px`, s = MV(e, `palette.[${t}].main`) ? t : "primary", l = e.palette[s];
  return {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: i,
    height: i,
    "& > svg": {
      position: "absolute",
      fontSize: r * 0.75,
      fill: e.palette.common.white
    },
    "&:before": {
      boxSizing: "border-box",
      content: '""',
      display: "block",
      borderStyle: "solid",
      borderRadius: e.shape.checkboxBorderRadius,
      borderWidth: e.shape.borderWidth,
      borderColor: l.main,
      width: o,
      height: o
    },
    "&.disabled:before": {
      borderColor: e.palette.action.disabled
    },
    "&.checked:before": {
      borderColor: "transparent",
      backgroundColor: l.main
    },
    "&.checked.disabled:before": {
      backgroundColor: e.palette.action.disabled
    }
  };
});
function IV(e) {
  return h(Md, { as: "span", "aria-label": "icon-checked", ...e, children: h(_C, { "aria-label": "checkmark" }) });
}
function RV(e) {
  return h(Md, { as: "span", "aria-label": "icon-indeterminate", ...e, children: h(DC, { "aria-label": "checkmark" }) });
}
const AV = Q(hF)(({ theme: e }) => ({
  "& + .MuiFormControlLabel-label": e.typography.body
})), kc = (e) => Object.keys(e).filter((t) => e[t]).join(" "), Zy = ({ disabled: e, size: t, color: n }) => ({
  icon: h(Md, { className: kc({ disabled: e }), as: "span", size: t, color: n }),
  checkedIcon: h(IV, { className: kc({ disabled: e, checked: !0 }), size: t, color: n }),
  indeterminateIcon: h(RV, { className: kc({ disabled: e, checked: !0 }), size: t, color: n })
});
function Ed(e) {
  const { size: t, color: n, disabled: r } = e, o = Ee(() => Zy({ disabled: r, color: n, size: t }), [r, n, t]);
  return h(AV, { ...e, ...o, color: n });
}
function Qy(e) {
  const { size: t, color: n, disabled: r } = e, o = Ee(() => Zy({ disabled: r, color: n, size: t }), [r, n, t]);
  return h(PC, { ...e, ...o, color: n });
}
function zY({ helperText: e, options: t, label: n, name: r, parseError: o, required: i, labelKey: s = "label", valueKey: l = "id", returnObject: u, disabled: c, row: d, control: m, labelProps: f, ...p }) {
  const b = Ht(), g = o || b, { field: { value: S = [], onChange: C }, fieldState: { error: w } } = Zt({
    name: r,
    control: m
  });
  e = w ? typeof g == "function" ? g(w) : w.message : e;
  const v = (x) => {
    const T = [...S];
    S.findIndex((k) => u ? k[l] === x : k === x) === -1 ? T.push(u ? t.find((k) => k[l] === x) : x) : T.splice(S.findIndex((k) => u ? k[l] === x : k === x), 1), C(T), typeof p.onChange == "function" && p.onChange(T);
  };
  return J(Au, { error: !!w, required: i, children: [n && h(eh, { error: !!w, children: n }), h($V, { row: d, children: t.map((x) => {
    const { [l]: T, [s]: E, ...k } = x;
    T || console.error(`CheckboxButtonGroup: valueKey ${l} does not exist on option`, x);
    const I = S.findIndex((P) => u ? P[l] === T : P === T) !== -1;
    return cs(OC, { ...f, control: h(Qy, { value: T, checked: I, disabled: c, onChange: () => v(T), ...k }), label: E, key: T });
  }) }), e && h($u, { children: e })] });
}
const $V = Q(kC)({
  ".PrivateSwitchBase-root": {
    paddingLeft: 0
  }
}), NV = Q(Ie)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
});
function Jy({ children: e, title: t, IconProps: n }) {
  return J(NV, { columnGap: typeof e == "string" ? 1 : 2, children: [e, h(xo, { title: t, IconProps: n })] });
}
function Xy(e, t) {
  const n = (r) => h(pi, { ...t, children: h(e, { ...r }) });
  return n.displayName = "WithAbility", n;
}
const FV = Q(di)(({ theme: e }) => {
  const { salesContactButton: t } = e.presets ?? {}, { main: n, contrastText: r } = en(e.palette, t == null ? void 0 : t.buttonBackgroundColor);
  return {
    position: "fixed",
    bottom: "10vh",
    right: "2.5vw",
    width: "4rem",
    height: "4rem",
    borderRadius: "50%",
    display: "grid",
    justifyContent: "center",
    alignContent: "center",
    backgroundColor: n,
    color: r,
    cursor: "pointer"
  };
}), VV = Q(Be)(({ theme: e }) => {
  const { salesContactButton: t } = e.presets ?? {}, { main: n, contrastText: r } = en(e.palette, t == null ? void 0 : t.bannerBackgroundColor);
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "sticky",
    bottom: 0,
    width: "100%",
    backgroundColor: n,
    color: r,
    padding: e.spacing(2)
  };
}), jV = Q(wo)(({ theme: e }) => {
  const { salesContactButton: t } = e.presets ?? {}, { main: n, contrastText: r } = en(e.palette, t == null ? void 0 : t.buttonBackgroundColor);
  return {
    "&.MuiTypography-root": {
      backgroundColor: n,
      color: r
    },
    "&:hover": {
      textDecoration: "underline"
    }
  };
}), LV = ({ linkText: e, linkURL: t, variant: n = "button", onClick: r }) => {
  const o = qt(), { salesContactButton: i = { icon: "contact" } } = o.presets ?? {}, s = {
    href: t,
    target: "_blank",
    title: e,
    "aria-label": "Contact Us will open in a new tab",
    rel: "noopener noreferrer",
    role: "link"
  };
  return h(Dt, { children: n === "button" ? h(FV, { className: "noprint", ...s, onClick: r, children: h(Rr, { id: i.icon }) }) : h(VV, { children: h(jV, { component: di, size: "small", ...s, onClick: r, children: e }) }) });
}, BV = Xy(LV, {
  I: "show",
  on: "app",
  field: "contactUs",
  children: void 0
});
function wn(e, t) {
  let n;
  typeof t == "object" ? n = Object.fromEntries(
    Object.entries(t).filter(([, o]) => o !== void 0)
  ) : n = t;
  const r = `${e}?${new URLSearchParams(n)}`;
  return decodeURIComponent(r.toString());
}
function zV(e, t) {
  return e.reduce(
    (n, r) => (n[r[t]] = r, n),
    {}
  );
}
var fu = { exports: {} }, Mc = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hp;
function WV() {
  if (hp)
    return Mc;
  hp = 1;
  var e = ct;
  function t(u, c) {
    return u === c && (u !== 0 || 1 / u === 1 / c) || u !== u && c !== c;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, o = e.useRef, i = e.useEffect, s = e.useMemo, l = e.useDebugValue;
  return Mc.useSyncExternalStoreWithSelector = function(u, c, d, m, f) {
    var p = o(null);
    if (p.current === null) {
      var b = { hasValue: !1, value: null };
      p.current = b;
    } else
      b = p.current;
    p = s(function() {
      function S(T) {
        if (!C) {
          if (C = !0, w = T, T = m(T), f !== void 0 && b.hasValue) {
            var E = b.value;
            if (f(E, T))
              return v = E;
          }
          return v = T;
        }
        if (E = v, n(w, T))
          return E;
        var k = m(T);
        return f !== void 0 && f(E, k) ? E : (w = T, v = k);
      }
      var C = !1, w, v, x = d === void 0 ? null : d;
      return [function() {
        return S(c());
      }, x === null ? void 0 : function() {
        return S(x());
      }];
    }, [c, d, m, f]);
    var g = r(u, p[0], p[1]);
    return i(function() {
      b.hasValue = !0, b.value = g;
    }, [g]), l(g), g;
  }, Mc;
}
var Ec = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gp;
function qV() {
  return gp || (gp = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = ct;
    function t(c, d) {
      return c === d && (c !== 0 || 1 / c === 1 / d) || c !== c && d !== d;
    }
    var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, o = e.useRef, i = e.useEffect, s = e.useMemo, l = e.useDebugValue;
    function u(c, d, m, f, p) {
      var b = o(null), g;
      b.current === null ? (g = {
        hasValue: !1,
        value: null
      }, b.current = g) : g = b.current;
      var S = s(function() {
        var x = !1, T, E, k = function(A) {
          if (!x) {
            x = !0, T = A;
            var B = f(A);
            if (p !== void 0 && g.hasValue) {
              var W = g.value;
              if (p(W, B))
                return E = W, W;
            }
            return E = B, B;
          }
          var M = T, _ = E;
          if (n(M, A))
            return _;
          var O = f(A);
          return p !== void 0 && p(_, O) ? _ : (T = A, E = O, O);
        }, I = m === void 0 ? null : m, P = function() {
          return k(d());
        }, F = I === null ? void 0 : function() {
          return k(I());
        };
        return [P, F];
      }, [d, m, f, p]), C = S[0], w = S[1], v = r(c, C, w);
      return i(function() {
        g.hasValue = !0, g.value = v;
      }, [v]), l(v), v;
    }
    Ec.useSyncExternalStoreWithSelector = u, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ec;
}
process.env.NODE_ENV === "production" ? fu.exports = WV() : fu.exports = qV();
var HV = fu.exports, Qn = (
  // prettier-ignore
  // @ts-ignore
  "default" in U ? U.default : U
), yp = Symbol.for("react-redux-context"), bp = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function UV() {
  if (!Qn.createContext)
    return {};
  const e = bp[yp] ?? (bp[yp] = /* @__PURE__ */ new Map());
  let t = e.get(Qn.createContext);
  return t || (t = Qn.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(Qn.createContext, t)), t;
}
var go = /* @__PURE__ */ UV(), YV = () => {
  throw new Error("uSES not initialized!");
};
function Id(e = go) {
  return function() {
    const n = Qn.useContext(e);
    if (process.env.NODE_ENV !== "production" && !n)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return n;
  };
}
var eb = /* @__PURE__ */ Id(), tb = YV, GV = (e) => {
  tb = e;
}, KV = (e, t) => e === t;
function ZV(e = go) {
  const t = e === go ? eb : Id(e), n = (r, o = {}) => {
    const { equalityFn: i = KV, devModeChecks: s = {} } = typeof o == "function" ? { equalityFn: o } : o;
    if (process.env.NODE_ENV !== "production") {
      if (!r)
        throw new Error("You must pass a selector to useSelector");
      if (typeof r != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const {
      store: l,
      subscription: u,
      getServerState: c,
      stabilityCheck: d,
      identityFunctionCheck: m
    } = t(), f = Qn.useRef(!0), p = Qn.useCallback(
      {
        [r.name](g) {
          const S = r(g);
          if (process.env.NODE_ENV !== "production") {
            const {
              identityFunctionCheck: C,
              stabilityCheck: w
            } = {
              stabilityCheck: d,
              identityFunctionCheck: m,
              ...s
            };
            if (w === "always" || w === "once" && f.current) {
              const v = r(g);
              if (!i(S, v)) {
                let x;
                try {
                  throw new Error();
                } catch (T) {
                  ({ stack: x } = T);
                }
                console.warn(
                  "Selector " + (r.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: g,
                    selected: S,
                    selected2: v,
                    stack: x
                  }
                );
              }
            }
            if ((C === "always" || C === "once" && f.current) && S === g) {
              let v;
              try {
                throw new Error();
              } catch (x) {
                ({ stack: v } = x);
              }
              console.warn(
                "Selector " + (r.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: v }
              );
            }
            f.current && (f.current = !1);
          }
          return S;
        }
      }[r.name],
      [r, d, s.stabilityCheck]
    ), b = tb(
      u.addNestedSub,
      l.getState,
      c || l.getState,
      p,
      i
    );
    return Qn.useDebugValue(b), b;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var Ss = /* @__PURE__ */ ZV();
function QV(e) {
  e();
}
var JV = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
JV ? Qn.useLayoutEffect : Qn.useEffect;
function vp(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function hl(e, t) {
  if (vp(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (let o = 0; o < n.length; o++)
    if (!Object.prototype.hasOwnProperty.call(t, n[o]) || !vp(e[n[o]], t[n[o]]))
      return !1;
  return !0;
}
function nb(e = go) {
  const t = e === go ? eb : (
    // @ts-ignore
    Id(e)
  ), n = () => {
    const { store: r } = t();
    return r;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var rb = /* @__PURE__ */ nb();
function XV(e = go) {
  const t = e === go ? rb : nb(e), n = () => t().dispatch;
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var ob = /* @__PURE__ */ XV(), ej = QV;
GV(HV.useSyncExternalStoreWithSelector);
function pu(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var Ic = () => Math.random().toString(36).substring(7).split("").join("."), tj = {
  INIT: `@@redux/INIT${Ic()}`,
  REPLACE: `@@redux/REPLACE${Ic()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Ic()}`
}, Ra = tj;
function br(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function nj(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (ij(e))
    return "date";
  if (oj(e))
    return "error";
  const n = rj(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function rj(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function oj(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function ij(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function aj(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = nj(e)), t;
}
function Cp(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function sj(e, t, n, r) {
  const o = Object.keys(t), i = n && n.type === Ra.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (o.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!br(e))
    return `The ${i} has unexpected type of "${aj(e)}". Expected argument to be an object with the following keys: "${o.join('", "')}"`;
  const s = Object.keys(e).filter((l) => !t.hasOwnProperty(l) && !r[l]);
  if (s.forEach((l) => {
    r[l] = !0;
  }), !(n && n.type === Ra.REPLACE) && s.length > 0)
    return `Unexpected ${s.length > 1 ? "keys" : "key"} "${s.join('", "')}" found in ${i}. Expected to find one of the known reducer keys instead: "${o.join('", "')}". Unexpected keys will be ignored.`;
}
function lj(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: Ra.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? pu(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: Ra.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? pu(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${Ra.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function cj(e) {
  const t = Object.keys(e), n = {};
  for (let s = 0; s < t.length; s++) {
    const l = t[s];
    process.env.NODE_ENV !== "production" && typeof e[l] > "u" && Cp(`No reducer provided for key "${l}"`), typeof e[l] == "function" && (n[l] = e[l]);
  }
  const r = Object.keys(n);
  let o;
  process.env.NODE_ENV !== "production" && (o = {});
  let i;
  try {
    lj(n);
  } catch (s) {
    i = s;
  }
  return function(l = {}, u) {
    if (i)
      throw i;
    if (process.env.NODE_ENV !== "production") {
      const m = sj(l, n, u, o);
      m && Cp(m);
    }
    let c = !1;
    const d = {};
    for (let m = 0; m < r.length; m++) {
      const f = r[m], p = n[f], b = l[f], g = p(b, u);
      if (typeof g > "u") {
        const S = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? pu(14) : `When called with an action of type ${S ? `"${String(S)}"` : "(unknown type)"}, the slice reducer for key "${f}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      d[f] = g, c = c || g !== b;
    }
    return c = c || r.length !== Object.keys(l).length, c ? d : l;
  };
}
function ib(e) {
  return br(e) && "type" in e && typeof e.type == "string";
}
var Rd = Symbol.for("immer-nothing"), Aa = Symbol.for("immer-draftable"), un = Symbol.for("immer-state"), ab = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Rt(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = ab[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var yo = Object.getPrototypeOf;
function Ln(e) {
  return !!e && !!e[un];
}
function Bn(e) {
  var t;
  return e ? sb(e) || Array.isArray(e) || !!e[Aa] || !!((t = e.constructor) != null && t[Aa]) || Ts(e) || _s(e) : !1;
}
var uj = Object.prototype.constructor.toString();
function sb(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = yo(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === uj;
}
function dj(e) {
  return Ln(e) || Rt(15, e), e[un].base_;
}
function oi(e, t) {
  bo(e) === 0 ? Object.entries(e).forEach(([n, r]) => {
    t(n, r, e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function bo(e) {
  const t = e[un];
  return t ? t.type_ : Array.isArray(e) ? 1 : Ts(e) ? 2 : _s(e) ? 3 : 0;
}
function ns(e, t) {
  return bo(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Rc(e, t) {
  return bo(e) === 2 ? e.get(t) : e[t];
}
function lb(e, t, n) {
  const r = bo(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function fj(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Ts(e) {
  return e instanceof Map;
}
function _s(e) {
  return e instanceof Set;
}
function no(e) {
  return e.copy_ || e.base_;
}
function mu(e, t) {
  if (Ts(e))
    return new Map(e);
  if (_s(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  if (!t && sb(e))
    return yo(e) ? { ...e } : Object.assign(/* @__PURE__ */ Object.create(null), e);
  const n = Object.getOwnPropertyDescriptors(e);
  delete n[un];
  let r = Reflect.ownKeys(n);
  for (let o = 0; o < r.length; o++) {
    const i = r[o], s = n[i];
    s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (n[i] = {
      configurable: !0,
      writable: !0,
      // could live with !!desc.set as well here...
      enumerable: s.enumerable,
      value: e[i]
    });
  }
  return Object.create(yo(e), n);
}
function Ad(e, t = !1) {
  return cc(e) || Ln(e) || !Bn(e) || (bo(e) > 1 && (e.set = e.add = e.clear = e.delete = pj), Object.freeze(e), t && oi(e, (n, r) => Ad(r, !0))), e;
}
function pj() {
  Rt(2);
}
function cc(e) {
  return Object.isFrozen(e);
}
var hu = {};
function vo(e) {
  const t = hu[e];
  return t || Rt(0, e), t;
}
function mj(e, t) {
  hu[e] || (hu[e] = t);
}
var rs;
function cb() {
  return rs;
}
function hj(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function wp(e, t) {
  t && (vo("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function gu(e) {
  yu(e), e.drafts_.forEach(gj), e.drafts_ = null;
}
function yu(e) {
  e === rs && (rs = e.parent_);
}
function xp(e) {
  return rs = hj(rs, e);
}
function gj(e) {
  const t = e[un];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Sp(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[un].modified_ && (gu(t), Rt(4)), Bn(e) && (e = gl(t, e), t.parent_ || yl(t, e)), t.patches_ && vo("Patches").generateReplacementPatches_(
    n[un].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = gl(t, n, []), gu(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Rd ? e : void 0;
}
function gl(e, t, n) {
  if (cc(t))
    return t;
  const r = t[un];
  if (!r)
    return oi(
      t,
      (o, i) => Tp(e, r, t, o, i, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return yl(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const o = r.copy_;
    let i = o, s = !1;
    r.type_ === 3 && (i = new Set(o), o.clear(), s = !0), oi(
      i,
      (l, u) => Tp(e, r, o, l, u, n, s)
    ), yl(e, o, !1), n && e.patches_ && vo("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function Tp(e, t, n, r, o, i, s) {
  if (process.env.NODE_ENV !== "production" && o === n && Rt(5), Ln(o)) {
    const l = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ns(t.assigned_, r) ? i.concat(r) : void 0, u = gl(e, o, l);
    if (lb(n, r, u), Ln(u))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    s && n.add(o);
  if (Bn(o) && !cc(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    gl(e, o), (!t || !t.scope_.parent_) && yl(e, o);
  }
}
function yl(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Ad(t, n);
}
function yj(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : cb(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = r, i = $d;
  n && (o = [r], i = os);
  const { revoke: s, proxy: l } = Proxy.revocable(o, i);
  return r.draft_ = l, r.revoke_ = s, l;
}
var $d = {
  get(e, t) {
    if (t === un)
      return e;
    const n = no(e);
    if (!ns(n, t))
      return bj(e, n, t);
    const r = n[t];
    return e.finalized_ || !Bn(r) ? r : r === Ac(e.base_, t) ? ($c(e), e.copy_[t] = vu(r, e)) : r;
  },
  has(e, t) {
    return t in no(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(no(e));
  },
  set(e, t, n) {
    const r = ub(no(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const o = Ac(no(e), t), i = o == null ? void 0 : o[un];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (fj(n, o) && (n !== void 0 || ns(e.base_, t)))
        return !0;
      $c(e), bu(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Ac(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, $c(e), bu(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = no(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Rt(11);
  },
  getPrototypeOf(e) {
    return yo(e.base_);
  },
  setPrototypeOf() {
    Rt(12);
  }
}, os = {};
oi($d, (e, t) => {
  os[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
os.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Rt(13), os.set.call(this, e, t, void 0);
};
os.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Rt(14), $d.set.call(this, e[0], t, n, e[0]);
};
function Ac(e, t) {
  const n = e[un];
  return (n ? no(n) : e)[t];
}
function bj(e, t, n) {
  var o;
  const r = ub(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = r.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function ub(e, t) {
  if (!(t in e))
    return;
  let n = yo(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = yo(n);
  }
}
function bu(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && bu(e.parent_));
}
function $c(e) {
  e.copy_ || (e.copy_ = mu(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var vj = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const s = this;
        return function(u = i, ...c) {
          return s.produce(u, (d) => n.call(this, d, ...c));
        };
      }
      typeof n != "function" && Rt(6), r !== void 0 && typeof r != "function" && Rt(7);
      let o;
      if (Bn(t)) {
        const i = xp(this), s = vu(t, void 0);
        let l = !0;
        try {
          o = n(s), l = !1;
        } finally {
          l ? gu(i) : yu(i);
        }
        return wp(i, r), Sp(o, i);
      } else if (!t || typeof t != "object") {
        if (o = n(t), o === void 0 && (o = t), o === Rd && (o = void 0), this.autoFreeze_ && Ad(o, !0), r) {
          const i = [], s = [];
          vo("Patches").generateReplacementPatches_(t, o, i, s), r(i, s);
        }
        return o;
      } else
        Rt(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (s, ...l) => this.produceWithPatches(s, (u) => t(u, ...l));
      let r, o;
      return [this.produce(t, n, (s, l) => {
        r = s, o = l;
      }), r, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Bn(e) || Rt(8), Ln(e) && (e = db(e));
    const t = xp(this), n = vu(e, void 0);
    return n[un].isManual_ = !0, yu(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[un];
    (!n || !n.isManual_) && Rt(9);
    const { scope_: r } = n;
    return wp(r, t), Sp(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const o = t[n];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = vo("Patches").applyPatches_;
    return Ln(e) ? r(e, t) : this.produce(
      e,
      (o) => r(o, t)
    );
  }
};
function vu(e, t) {
  const n = Ts(e) ? vo("MapSet").proxyMap_(e, t) : _s(e) ? vo("MapSet").proxySet_(e, t) : yj(e, t);
  return (t ? t.scope_ : cb()).drafts_.push(n), n;
}
function db(e) {
  return Ln(e) || Rt(10, e), fb(e);
}
function fb(e) {
  if (!Bn(e) || cc(e))
    return e;
  const t = e[un];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = mu(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = mu(e, !0);
  return oi(n, (r, o) => {
    lb(n, r, fb(o));
  }), t && (t.finalized_ = !1), n;
}
function Cj() {
  process.env.NODE_ENV !== "production" && ab.push(
    'Sets cannot have "replace" patches.',
    function(f) {
      return "Unsupported patch operation: " + f;
    },
    function(f) {
      return "Cannot apply patch, path doesn't resolve: " + f;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  const t = "replace", n = "add", r = "remove";
  function o(f, p, b, g) {
    switch (f.type_) {
      case 0:
      case 2:
        return s(
          f,
          p,
          b,
          g
        );
      case 1:
        return i(f, p, b, g);
      case 3:
        return l(
          f,
          p,
          b,
          g
        );
    }
  }
  function i(f, p, b, g) {
    let { base_: S, assigned_: C } = f, w = f.copy_;
    w.length < S.length && ([S, w] = [w, S], [b, g] = [g, b]);
    for (let v = 0; v < S.length; v++)
      if (C[v] && w[v] !== S[v]) {
        const x = p.concat([v]);
        b.push({
          op: t,
          path: x,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: m(w[v])
        }), g.push({
          op: t,
          path: x,
          value: m(S[v])
        });
      }
    for (let v = S.length; v < w.length; v++) {
      const x = p.concat([v]);
      b.push({
        op: n,
        path: x,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: m(w[v])
      });
    }
    for (let v = w.length - 1; S.length <= v; --v) {
      const x = p.concat([v]);
      g.push({
        op: r,
        path: x
      });
    }
  }
  function s(f, p, b, g) {
    const { base_: S, copy_: C } = f;
    oi(f.assigned_, (w, v) => {
      const x = Rc(S, w), T = Rc(C, w), E = v ? ns(S, w) ? t : n : r;
      if (x === T && E === t)
        return;
      const k = p.concat(w);
      b.push(E === r ? { op: E, path: k } : { op: E, path: k, value: T }), g.push(
        E === n ? { op: r, path: k } : E === r ? { op: n, path: k, value: m(x) } : { op: t, path: k, value: m(x) }
      );
    });
  }
  function l(f, p, b, g) {
    let { base_: S, copy_: C } = f, w = 0;
    S.forEach((v) => {
      if (!C.has(v)) {
        const x = p.concat([w]);
        b.push({
          op: r,
          path: x,
          value: v
        }), g.unshift({
          op: n,
          path: x,
          value: v
        });
      }
      w++;
    }), w = 0, C.forEach((v) => {
      if (!S.has(v)) {
        const x = p.concat([w]);
        b.push({
          op: n,
          path: x,
          value: v
        }), g.unshift({
          op: r,
          path: x,
          value: v
        });
      }
      w++;
    });
  }
  function u(f, p, b, g) {
    b.push({
      op: t,
      path: [],
      value: p === Rd ? void 0 : p
    }), g.push({
      op: t,
      path: [],
      value: f
    });
  }
  function c(f, p) {
    return p.forEach((b) => {
      const { path: g, op: S } = b;
      let C = f;
      for (let T = 0; T < g.length - 1; T++) {
        const E = bo(C);
        let k = g[T];
        typeof k != "string" && typeof k != "number" && (k = "" + k), (E === 0 || E === 1) && (k === "__proto__" || k === "constructor") && Rt(16 + 3), typeof C == "function" && k === "prototype" && Rt(16 + 3), C = Rc(C, k), typeof C != "object" && Rt(16 + 2, g.join("/"));
      }
      const w = bo(C), v = d(b.value), x = g[g.length - 1];
      switch (S) {
        case t:
          switch (w) {
            case 2:
              return C.set(x, v);
            case 3:
              Rt(16);
            default:
              return C[x] = v;
          }
        case n:
          switch (w) {
            case 1:
              return x === "-" ? C.push(v) : C.splice(x, 0, v);
            case 2:
              return C.set(x, v);
            case 3:
              return C.add(v);
            default:
              return C[x] = v;
          }
        case r:
          switch (w) {
            case 1:
              return C.splice(x, 1);
            case 2:
              return C.delete(x);
            case 3:
              return C.delete(b.value);
            default:
              return delete C[x];
          }
        default:
          Rt(16 + 1, S);
      }
    }), f;
  }
  function d(f) {
    if (!Bn(f))
      return f;
    if (Array.isArray(f))
      return f.map(d);
    if (Ts(f))
      return new Map(
        Array.from(f.entries()).map(([b, g]) => [b, d(g)])
      );
    if (_s(f))
      return new Set(Array.from(f).map(d));
    const p = Object.create(yo(f));
    for (const b in f)
      p[b] = d(f[b]);
    return ns(f, Aa) && (p[Aa] = f[Aa]), p;
  }
  function m(f) {
    return Ln(f) ? d(f) : f;
  }
  mj("Patches", {
    applyPatches_: c,
    generatePatches_: o,
    generateReplacementPatches_: u
  });
}
var gn = new vj(), Ds = gn.produce, pb = gn.produceWithPatches.bind(
  gn
);
gn.setAutoFreeze.bind(gn);
gn.setUseStrictShallowCopy.bind(gn);
var _p = gn.applyPatches.bind(gn);
gn.createDraft.bind(gn);
gn.finishDraft.bind(gn);
var wj = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let r = !1;
    try {
      const o = {};
      e(o) === o && (r = !0);
    } catch {
    }
    if (r) {
      let o;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: o } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, xj = (e, t, n) => {
  const { memoize: r, memoizeOptions: o } = t, { inputSelectorResults: i, inputSelectorResultsCopy: s } = e, l = r(() => ({}), ...o);
  if (!(l.apply(null, i) === l.apply(null, s))) {
    let c;
    try {
      throw new Error();
    } catch (d) {
      ({ stack: c } = d);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: s,
        stack: c
      }
    );
  }
}, Sj = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function Tj(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function _j(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function Dj(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (r) => typeof r == "function" ? `function ${r.name || "unnamed"}()` : typeof r
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var Dp = (e) => Array.isArray(e) ? e : [e];
function Pj(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return Dj(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function Pp(e, t) {
  const n = [], { length: r } = e;
  for (let o = 0; o < r; o++)
    n.push(e[o].apply(null, t));
  return n;
}
var Oj = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: r } = {
    ...Sj,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: wj
    },
    inputStabilityCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: xj
    }
  };
}, kj = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, Mj = typeof WeakRef < "u" ? WeakRef : kj, Ej = 0, Op = 1;
function Fs() {
  return {
    s: Ej,
    v: void 0,
    o: null,
    p: null
  };
}
function is(e, t = {}) {
  let n = Fs();
  const { resultEqualityCheck: r } = t;
  let o, i = 0;
  function s() {
    var m;
    let l = n;
    const { length: u } = arguments;
    for (let f = 0, p = u; f < p; f++) {
      const b = arguments[f];
      if (typeof b == "function" || typeof b == "object" && b !== null) {
        let g = l.o;
        g === null && (l.o = g = /* @__PURE__ */ new WeakMap());
        const S = g.get(b);
        S === void 0 ? (l = Fs(), g.set(b, l)) : l = S;
      } else {
        let g = l.p;
        g === null && (l.p = g = /* @__PURE__ */ new Map());
        const S = g.get(b);
        S === void 0 ? (l = Fs(), g.set(b, l)) : l = S;
      }
    }
    const c = l;
    let d;
    if (l.s === Op ? d = l.v : (d = e.apply(null, arguments), i++), c.s = Op, r) {
      const f = ((m = o == null ? void 0 : o.deref) == null ? void 0 : m.call(o)) ?? o;
      f != null && r(f, d) && (d = f, i !== 0 && i--), o = typeof d == "object" && d !== null || typeof d == "function" ? new Mj(d) : d;
    }
    return c.v = d, d;
  }
  return s.clearCache = () => {
    n = Fs(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function mb(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, r = (...o) => {
    let i = 0, s = 0, l, u = {}, c = o.pop();
    typeof c == "object" && (u = c, c = o.pop()), Tj(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const d = {
      ...n,
      ...u
    }, {
      memoize: m,
      memoizeOptions: f = [],
      argsMemoize: p = is,
      argsMemoizeOptions: b = [],
      devModeChecks: g = {}
    } = d, S = Dp(f), C = Dp(b), w = Pj(o), v = m(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...S);
    let x = !0;
    const T = p(function() {
      s++;
      const k = Pp(
        w,
        arguments
      );
      if (l = v.apply(null, k), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: I, inputStabilityCheck: P } = Oj(x, g);
        if (I.shouldRun && I.run(
          c,
          k,
          l
        ), P.shouldRun) {
          const F = Pp(
            w,
            arguments
          );
          P.run(
            { inputSelectorResults: k, inputSelectorResultsCopy: F },
            { memoize: m, memoizeOptions: S },
            arguments
          );
        }
        x && (x = !1);
      }
      return l;
    }, ...C);
    return Object.assign(T, {
      resultFunc: c,
      memoizedResultFunc: v,
      dependencies: w,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: m,
      argsMemoize: p
    });
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var ln = /* @__PURE__ */ mb(is), Ij = Object.assign(
  (e, t = ln) => {
    _j(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), r = n.map(
      (i) => e[i]
    );
    return t(
      r,
      (...i) => i.reduce((s, l, u) => (s[n[u]] = l, s), {})
    );
  },
  { withTypes: () => Ij }
), Rj = (...e) => {
  const t = mb(...e);
  return (...n) => {
    const r = t(...n), o = (i, ...s) => r(Ln(i) ? db(i) : i, ...s);
    return Object.assign(o, r), o;
  };
};
Rj(is);
var Aj = (e) => e && typeof e.match == "function";
function cn(e, t) {
  function n(...r) {
    if (t) {
      let o = t(...r);
      if (!o)
        throw new Error(process.env.NODE_ENV === "production" ? _t(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: o.payload,
        ..."meta" in o && {
          meta: o.meta
        },
        ..."error" in o && {
          error: o.error
        }
      };
    }
    return {
      type: e,
      payload: r[0]
    };
  }
  return n.toString = () => `${e}`, n.type = e, n.match = (r) => ib(r) && r.type === e, n;
}
function kp(e) {
  return Bn(e) ? Ds(e, () => {
  }) : e;
}
function Mp(e, t, n) {
  if (e.has(t)) {
    let o = e.get(t);
    return n.update && (o = n.update(o, t, e), e.set(t, o)), o;
  }
  if (!n.insert)
    throw new Error(process.env.NODE_ENV === "production" ? _t(10) : "No insert provided for key not already in map");
  const r = n.insert(t, e);
  return e.set(t, r), r;
}
var _a = "RTK_autoBatch", ga = () => (e) => ({
  payload: e,
  meta: {
    [_a]: !0
  }
});
process.env.NODE_ENV;
function hb(e) {
  const t = {}, n = [];
  let r;
  const o = {
    addCase(i, s) {
      if (process.env.NODE_ENV !== "production") {
        if (n.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? _t(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (r)
          throw new Error(process.env.NODE_ENV === "production" ? _t(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const l = typeof i == "string" ? i : i.type;
      if (!l)
        throw new Error(process.env.NODE_ENV === "production" ? _t(28) : "`builder.addCase` cannot be called with an empty action type");
      if (l in t)
        throw new Error(process.env.NODE_ENV === "production" ? _t(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${l}'`);
      return t[l] = s, o;
    },
    addMatcher(i, s) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error(process.env.NODE_ENV === "production" ? _t(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return n.push({
        matcher: i,
        reducer: s
      }), o;
    },
    addDefaultCase(i) {
      if (process.env.NODE_ENV !== "production" && r)
        throw new Error(process.env.NODE_ENV === "production" ? _t(31) : "`builder.addDefaultCase` can only be called once");
      return r = i, o;
    }
  };
  return e(o), [t, n, r];
}
function $j(e) {
  return typeof e == "function";
}
function Nj(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? _t(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [n, r, o] = hb(t), i;
  if ($j(e))
    i = () => kp(e());
  else {
    const l = kp(e);
    i = () => l;
  }
  function s(l = i(), u) {
    let c = [n[u.type], ...r.filter(({
      matcher: d
    }) => d(u)).map(({
      reducer: d
    }) => d)];
    return c.filter((d) => !!d).length === 0 && (c = [o]), c.reduce((d, m) => {
      if (m)
        if (Ln(d)) {
          const p = m(d, u);
          return p === void 0 ? d : p;
        } else {
          if (Bn(d))
            return Ds(d, (f) => m(f, u));
          {
            const f = m(d, u);
            if (f === void 0) {
              if (d === null)
                return d;
              throw new Error(process.env.NODE_ENV === "production" ? _t(9) : "A case reducer on a non-draftable value must not return undefined");
            }
            return f;
          }
        }
      return d;
    }, l);
  }
  return s.getInitialState = i, s;
}
var Fj = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", gb = (e = 21) => {
  let t = "", n = e;
  for (; n--; )
    t += Fj[Math.random() * 64 | 0];
  return t;
}, yb = (e, t) => Aj(e) ? e.match(t) : e(t);
function Fr(...e) {
  return (t) => e.some((n) => yb(n, t));
}
function $a(...e) {
  return (t) => e.every((n) => yb(n, t));
}
function uc(e, t) {
  if (!e || !e.meta)
    return !1;
  const n = typeof e.meta.requestId == "string", r = t.indexOf(e.meta.requestStatus) > -1;
  return n && r;
}
function Ps(e) {
  return typeof e[0] == "function" && "pending" in e[0] && "fulfilled" in e[0] && "rejected" in e[0];
}
function Nd(...e) {
  return e.length === 0 ? (t) => uc(t, ["pending"]) : Ps(e) ? (t) => {
    const n = e.map((o) => o.pending);
    return Fr(...n)(t);
  } : Nd()(e[0]);
}
function ii(...e) {
  return e.length === 0 ? (t) => uc(t, ["rejected"]) : Ps(e) ? (t) => {
    const n = e.map((o) => o.rejected);
    return Fr(...n)(t);
  } : ii()(e[0]);
}
function dc(...e) {
  const t = (n) => n && n.meta && n.meta.rejectedWithValue;
  return e.length === 0 ? (n) => $a(ii(...e), t)(n) : Ps(e) ? (n) => $a(ii(...e), t)(n) : dc()(e[0]);
}
function Vr(...e) {
  return e.length === 0 ? (t) => uc(t, ["fulfilled"]) : Ps(e) ? (t) => {
    const n = e.map((o) => o.fulfilled);
    return Fr(...n)(t);
  } : Vr()(e[0]);
}
function Cu(...e) {
  return e.length === 0 ? (t) => uc(t, ["pending", "fulfilled", "rejected"]) : Ps(e) ? (t) => {
    const n = [];
    for (const o of e)
      n.push(o.pending, o.rejected, o.fulfilled);
    return Fr(...n)(t);
  } : Cu()(e[0]);
}
var Vj = ["name", "message", "stack", "code"], Nc = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    fc(this, "_type");
    this.payload = e, this.meta = t;
  }
}, Ep = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    fc(this, "_type");
    this.payload = e, this.meta = t;
  }
}, jj = (e) => {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n of Vj)
      typeof e[n] == "string" && (t[n] = e[n]);
    return t;
  }
  return {
    message: String(e)
  };
}, bl = /* @__PURE__ */ (() => {
  function e(t, n, r) {
    const o = cn(t + "/fulfilled", (u, c, d, m) => ({
      payload: u,
      meta: {
        ...m || {},
        arg: d,
        requestId: c,
        requestStatus: "fulfilled"
      }
    })), i = cn(t + "/pending", (u, c, d) => ({
      payload: void 0,
      meta: {
        ...d || {},
        arg: c,
        requestId: u,
        requestStatus: "pending"
      }
    })), s = cn(t + "/rejected", (u, c, d, m, f) => ({
      payload: m,
      error: (r && r.serializeError || jj)(u || "Rejected"),
      meta: {
        ...f || {},
        arg: d,
        requestId: c,
        rejectedWithValue: !!m,
        requestStatus: "rejected",
        aborted: (u == null ? void 0 : u.name) === "AbortError",
        condition: (u == null ? void 0 : u.name) === "ConditionError"
      }
    }));
    function l(u) {
      return (c, d, m) => {
        const f = r != null && r.idGenerator ? r.idGenerator(u) : gb(), p = new AbortController();
        let b;
        function g(C) {
          b = C, p.abort();
        }
        const S = async function() {
          var v, x;
          let C;
          try {
            let T = (v = r == null ? void 0 : r.condition) == null ? void 0 : v.call(r, u, {
              getState: d,
              extra: m
            });
            if (Bj(T) && (T = await T), T === !1 || p.signal.aborted)
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            const E = new Promise((k, I) => p.signal.addEventListener("abort", () => I({
              name: "AbortError",
              message: b || "Aborted"
            })));
            c(i(f, u, (x = r == null ? void 0 : r.getPendingMeta) == null ? void 0 : x.call(r, {
              requestId: f,
              arg: u
            }, {
              getState: d,
              extra: m
            }))), C = await Promise.race([E, Promise.resolve(n(u, {
              dispatch: c,
              getState: d,
              extra: m,
              requestId: f,
              signal: p.signal,
              abort: g,
              rejectWithValue: (k, I) => new Nc(k, I),
              fulfillWithValue: (k, I) => new Ep(k, I)
            })).then((k) => {
              if (k instanceof Nc)
                throw k;
              return k instanceof Ep ? o(k.payload, f, u, k.meta) : o(k, f, u);
            })]);
          } catch (T) {
            C = T instanceof Nc ? s(null, f, u, T.payload, T.meta) : s(T, f, u);
          }
          return r && !r.dispatchConditionRejection && s.match(C) && C.meta.condition || c(C), C;
        }();
        return Object.assign(S, {
          abort: g,
          requestId: f,
          arg: u,
          unwrap() {
            return S.then(Lj);
          }
        });
      };
    }
    return Object.assign(l, {
      pending: i,
      rejected: s,
      fulfilled: o,
      settled: Fr(s, o),
      typePrefix: t
    });
  }
  return e.withTypes = () => e, e;
})();
function Lj(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function Bj(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var zj = Symbol.for("rtk-slice-createasyncthunk");
function Wj(e, t) {
  return `${e}/${t}`;
}
function qj({
  creators: e
} = {}) {
  var n;
  const t = (n = e == null ? void 0 : e.asyncThunk) == null ? void 0 : n[zj];
  return function(o) {
    const {
      name: i,
      reducerPath: s = i
    } = o;
    if (!i)
      throw new Error(process.env.NODE_ENV === "production" ? _t(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && o.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const l = (typeof o.reducers == "function" ? o.reducers(Uj()) : o.reducers) || {}, u = Object.keys(l), c = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, d = {
      addCase(S, C) {
        const w = typeof S == "string" ? S : S.type;
        if (!w)
          throw new Error(process.env.NODE_ENV === "production" ? _t(12) : "`context.addCase` cannot be called with an empty action type");
        if (w in c.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? _t(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + w);
        return c.sliceCaseReducersByType[w] = C, d;
      },
      addMatcher(S, C) {
        return c.sliceMatchers.push({
          matcher: S,
          reducer: C
        }), d;
      },
      exposeAction(S, C) {
        return c.actionCreators[S] = C, d;
      },
      exposeCaseReducer(S, C) {
        return c.sliceCaseReducersByName[S] = C, d;
      }
    };
    u.forEach((S) => {
      const C = l[S], w = {
        reducerName: S,
        type: Wj(i, S),
        createNotation: typeof o.reducers == "function"
      };
      Gj(C) ? Zj(w, C, d, t) : Yj(w, C, d);
    });
    function m() {
      if (process.env.NODE_ENV !== "production" && typeof o.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? _t(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [S = {}, C = [], w = void 0] = typeof o.extraReducers == "function" ? hb(o.extraReducers) : [o.extraReducers], v = {
        ...S,
        ...c.sliceCaseReducersByType
      };
      return Nj(o.initialState, (x) => {
        for (let T in v)
          x.addCase(T, v[T]);
        for (let T of c.sliceMatchers)
          x.addMatcher(T.matcher, T.reducer);
        for (let T of C)
          x.addMatcher(T.matcher, T.reducer);
        w && x.addDefaultCase(w);
      });
    }
    const f = (S) => S, p = /* @__PURE__ */ new WeakMap();
    let b;
    const g = {
      name: i,
      reducerPath: s,
      reducer(S, C) {
        return b || (b = m()), b(S, C);
      },
      actions: c.actionCreators,
      caseReducers: c.sliceCaseReducersByName,
      getInitialState() {
        return b || (b = m()), b.getInitialState();
      },
      getSelectors(S = f) {
        const C = Mp(p, this, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return Mp(C, S, {
          insert: () => {
            const w = {};
            for (const [v, x] of Object.entries(o.selectors ?? {}))
              w[v] = Hj(this, x, S, this !== g);
            return w;
          }
        });
      },
      selectSlice(S) {
        let C = S[this.reducerPath];
        if (typeof C > "u") {
          if (this !== g)
            C = this.getInitialState();
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? _t(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return C;
      },
      get selectors() {
        return this.getSelectors(this.selectSlice);
      },
      injectInto(S, {
        reducerPath: C,
        ...w
      } = {}) {
        const v = C ?? this.reducerPath;
        return S.inject({
          reducerPath: v,
          reducer: this.reducer
        }, w), {
          ...this,
          reducerPath: v
        };
      }
    };
    return g;
  };
}
function Hj(e, t, n, r) {
  function o(i, ...s) {
    let l = n.call(e, i);
    if (typeof l > "u") {
      if (r)
        l = e.getInitialState();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? _t(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return t(l, ...s);
  }
  return o.unwrapped = t, o;
}
var dr = qj();
function Uj() {
  function e(t, n) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...n
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...n) {
          return t(...n);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, n) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: n
      };
    },
    asyncThunk: e
  };
}
function Yj({
  type: e,
  reducerName: t,
  createNotation: n
}, r, o) {
  let i, s;
  if ("reducer" in r) {
    if (n && !Kj(r))
      throw new Error(process.env.NODE_ENV === "production" ? _t(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    i = r.reducer, s = r.prepare;
  } else
    i = r;
  o.addCase(e, i).exposeCaseReducer(t, i).exposeAction(t, s ? cn(e, s) : cn(e));
}
function Gj(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function Kj(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function Zj({
  type: e,
  reducerName: t
}, n, r, o) {
  if (!o)
    throw new Error(process.env.NODE_ENV === "production" ? _t(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: i,
    fulfilled: s,
    pending: l,
    rejected: u,
    settled: c,
    options: d
  } = n, m = o(e, i, d);
  r.exposeAction(t, m), s && r.addCase(m.fulfilled, s), l && r.addCase(m.pending, l), u && r.addCase(m.rejected, u), c && r.addMatcher(m.settled, c), r.exposeCaseReducer(t, {
    fulfilled: s || Vs,
    pending: l || Vs,
    rejected: u || Vs,
    settled: c || Vs
  });
}
function Vs() {
}
var Fd = "listenerMiddleware";
cn(`${Fd}/add`);
cn(`${Fd}/removeAll`);
cn(`${Fd}/remove`);
function _t(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
const Do = (e) => e.config, Qj = ln(
  [Do, (e, t, n) => ({ id: t, fallback: n })],
  ({ config: e }, { id: t, fallback: n }) => {
    var r;
    return At((r = e == null ? void 0 : e.settings) == null ? void 0 : r.components, t, n);
  }
), Jj = ln(
  [Do, (e, t, n) => ({ id: t, fallback: n })],
  ({ config: e }, { id: t, fallback: n }) => At(e, t, n)
);
ln(
  [Do, (e, t) => t],
  ({ config: e }, t) => t.map((n) => {
    var r;
    return At((r = e == null ? void 0 : e.settings) == null ? void 0 : r.components, n);
  })
);
const Xj = ln(
  [Do, (e, t, n) => ({ id: t, fallback: n })],
  ({ config: e }, { id: t, fallback: n }) => {
    var r;
    return At((r = e == null ? void 0 : e.settings) == null ? void 0 : r.staticValues, t, n);
  }
);
ln(
  [Do, (e, t, n) => ({ id: t, fallback: n })],
  ({ config: e }, { id: t, fallback: n }) => {
    var r;
    return At((r = e == null ? void 0 : e.settings) == null ? void 0 : r.defaultValues, t, n);
  }
);
ln(
  [Do, (e, t, n) => ({ id: t, fallback: n })],
  ({ config: e }, { id: t, fallback: n }) => {
    var r;
    return At((r = e == null ? void 0 : e.settings) == null ? void 0 : r.validations, t, n);
  }
);
const eL = ln(
  [Do, (e, t, n) => ({ id: t, fallback: n })],
  ({ config: e }, { id: t, fallback: n }) => At(e == null ? void 0 : e.settings, t, n)
), Vd = (e, t) => Ss((n) => Qj(n, e, t)), tL = (e, t) => Ss((n) => Xj(n, e, t)), nL = (e, t) => Ss((n) => eL(n, e, t)), bb = (e, t) => Ss((n) => Jj(n, e, t)), Ip = 3, rL = 200;
async function Rp(e, t) {
  let n = Ip;
  for (; n > 0; )
    try {
      const r = await fetch(e, t);
      if (!r.ok)
        throw new Error();
      return r;
    } catch {
      await oL(rL);
    } finally {
      n -= 1;
    }
  throw new Error(`Failed after ${Ip} tries.`);
}
function oL(e) {
  return new Promise((t) => setTimeout(t, e));
}
const iL = process.env.REACT_APP_ZR_API_GATEWAY_URL, aL = {
  config: null,
  status: "idle"
}, Fc = bl(
  "config",
  async ({ domain: e, config: t }) => {
    let n = null;
    if (process.env.NODE_ENV === "development")
      n = await Rp(process.env.REACT_APP_LOCAL_CONFIG ?? "/dev.json");
    else {
      const i = new URL(`${iL}/client/config`);
      i.searchParams.set("domain", e), i.searchParams.set("config", t), n = await Rp(i.toString());
    }
    if (!(n != null && n.ok))
      throw new Error("Couldn't fetch configuration");
    const r = await n.json(), o = Object.keys(r).filter((i) => i !== "theme")[0];
    return {
      theme: r.theme,
      ...r[o]
    };
  }
), sL = dr({
  name: "config",
  initialState: aL,
  reducers: {
    updateStaticValues(e, { payload: t }) {
      e.config && (e.config.settings.staticValues = dt({}, e.config.settings.staticValues, t));
    }
  },
  extraReducers(e) {
    e.addCase(Fc.pending, (t) => {
      t.status = "loading";
    }).addCase(Fc.fulfilled, (t, n) => {
      t.status = "succeeded", t.config = dt({}, t.config, n.payload);
    }).addCase(Fc.rejected, (t) => {
      t.status = "failed", console.warn("Failed to fetch custom config.");
    });
  }
});
sL.actions;
var vb = /* @__PURE__ */ ((e) => (e.uninitialized = "uninitialized", e.pending = "pending", e.fulfilled = "fulfilled", e.rejected = "rejected", e))(vb || {});
function lL(e) {
  return {
    status: e,
    isUninitialized: e === "uninitialized",
    isLoading: e === "pending",
    isSuccess: e === "fulfilled",
    isError: e === "rejected"
    /* rejected */
  };
}
function cL(e) {
  return new RegExp("(^|:)//").test(e);
}
var uL = (e) => e.replace(/\/$/, ""), dL = (e) => e.replace(/^\//, "");
function fL(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  if (cL(t))
    return t;
  const n = e.endsWith("/") || !t.startsWith("?") ? "/" : "";
  return e = uL(e), t = dL(t), `${e}${n}${t}`;
}
var Ap = (e) => [].concat(...e);
function pL() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
function mL() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
var $p = br;
function Cb(e, t) {
  if (e === t || !($p(e) && $p(t) || Array.isArray(e) && Array.isArray(t)))
    return t;
  const n = Object.keys(t), r = Object.keys(e);
  let o = n.length === r.length;
  const i = Array.isArray(t) ? [] : {};
  for (const s of n)
    i[s] = Cb(e[s], t[s]), o && (o = e[s] === i[s]);
  return o ? e : i;
}
var Np = (...e) => fetch(...e), hL = (e) => e.status >= 200 && e.status <= 299, gL = (e) => (
  /*applicat*/
  /ion\/(vnd\.api\+)?json/.test(e.get("content-type") || "")
);
function Fp(e) {
  if (!br(e))
    return e;
  const t = {
    ...e
  };
  for (const [n, r] of Object.entries(t))
    r === void 0 && delete t[n];
  return t;
}
function jd({
  baseUrl: e,
  prepareHeaders: t = (m) => m,
  fetchFn: n = Np,
  paramsSerializer: r,
  isJsonContentType: o = gL,
  jsonContentType: i = "application/json",
  jsonReplacer: s,
  timeout: l,
  responseHandler: u,
  validateStatus: c,
  ...d
} = {}) {
  return typeof fetch > "u" && n === Np && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), async (f, p) => {
    const {
      signal: b,
      getState: g,
      extra: S,
      endpoint: C,
      forced: w,
      type: v
    } = p;
    let x, {
      url: T,
      headers: E = new Headers(d.headers),
      params: k = void 0,
      responseHandler: I = u ?? "json",
      validateStatus: P = c ?? hL,
      timeout: F = l,
      ...A
    } = typeof f == "string" ? {
      url: f
    } : f, B = {
      ...d,
      signal: b,
      ...A
    };
    E = new Headers(Fp(E)), B.headers = await t(E, {
      getState: g,
      extra: S,
      endpoint: C,
      forced: w,
      type: v
    }) || E;
    const W = (G) => typeof G == "object" && (br(G) || Array.isArray(G) || typeof G.toJSON == "function");
    if (!B.headers.has("content-type") && W(B.body) && B.headers.set("content-type", i), W(B.body) && o(B.headers) && (B.body = JSON.stringify(B.body, s)), k) {
      const G = ~T.indexOf("?") ? "&" : "?", q = r ? r(k) : new URLSearchParams(Fp(k));
      T += G + q;
    }
    T = fL(e, T);
    const M = new Request(T, B);
    x = {
      request: new Request(T, B)
    };
    let O, R = !1, N = F && setTimeout(() => {
      R = !0, p.abort();
    }, F);
    try {
      O = await n(M);
    } catch (G) {
      return {
        error: {
          status: R ? "TIMEOUT_ERROR" : "FETCH_ERROR",
          error: String(G)
        },
        meta: x
      };
    } finally {
      N && clearTimeout(N);
    }
    const L = O.clone();
    x.response = L;
    let $, H = "";
    try {
      let G;
      if (await Promise.all([
        m(O, I).then((q) => $ = q, (q) => G = q),
        // see https://github.com/node-fetch/node-fetch/issues/665#issuecomment-538995182
        // we *have* to "use up" both streams at the same time or they will stop running in node-fetch scenarios
        L.text().then((q) => H = q, () => {
        })
      ]), G)
        throw G;
    } catch (G) {
      return {
        error: {
          status: "PARSING_ERROR",
          originalStatus: O.status,
          data: H,
          error: String(G)
        },
        meta: x
      };
    }
    return P(O, $) ? {
      data: $,
      meta: x
    } : {
      error: {
        status: O.status,
        data: $
      },
      meta: x
    };
  };
  async function m(f, p) {
    if (typeof p == "function")
      return p(f);
    if (p === "content-type" && (p = o(f.headers) ? "json" : "text"), p === "json") {
      const b = await f.text();
      return b.length ? JSON.parse(b) : null;
    }
    return f.text();
  }
}
var Vp = class {
  constructor(e, t = void 0) {
    this.value = e, this.meta = t;
  }
}, Ld = /* @__PURE__ */ cn("__rtkq/focused"), wb = /* @__PURE__ */ cn("__rtkq/unfocused"), Bd = /* @__PURE__ */ cn("__rtkq/online"), xb = /* @__PURE__ */ cn("__rtkq/offline");
function Sb(e) {
  return e.type === "query";
}
function yL(e) {
  return e.type === "mutation";
}
function zd(e, t, n, r, o, i) {
  return bL(e) ? e(t, n, r, o).map(wu).map(i) : Array.isArray(e) ? e.map(wu).map(i) : [];
}
function bL(e) {
  return typeof e == "function";
}
function wu(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function jp(e) {
  return e != null;
}
function Zo(e) {
  let t = 0;
  for (const n in e)
    t++;
  return t;
}
var as = Symbol("forceQueryFn"), xu = (e) => typeof e[as] == "function";
function vL({
  serializeQueryArgs: e,
  queryThunk: t,
  mutationThunk: n,
  api: r,
  context: o
}) {
  const i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), {
    unsubscribeQueryResult: l,
    removeMutationResult: u,
    updateSubscriptionOptions: c
  } = r.internalActions;
  return {
    buildInitiateQuery: g,
    buildInitiateMutation: S,
    getRunningQueryThunk: d,
    getRunningMutationThunk: m,
    getRunningQueriesThunk: f,
    getRunningMutationsThunk: p
  };
  function d(C, w) {
    return (v) => {
      var E;
      const x = o.endpointDefinitions[C], T = e({
        queryArgs: w,
        endpointDefinition: x,
        endpointName: C
      });
      return (E = i.get(v)) == null ? void 0 : E[T];
    };
  }
  function m(C, w) {
    return (v) => {
      var x;
      return (x = s.get(v)) == null ? void 0 : x[w];
    };
  }
  function f() {
    return (C) => Object.values(i.get(C) || {}).filter(jp);
  }
  function p() {
    return (C) => Object.values(s.get(C) || {}).filter(jp);
  }
  function b(C) {
    if (process.env.NODE_ENV !== "production") {
      if (b.triggered)
        return;
      const w = C(r.internalActions.internal_getRTKQSubscriptions());
      if (b.triggered = !0, typeof w != "object" || typeof (w == null ? void 0 : w.type) == "string")
        throw new Error(process.env.NODE_ENV === "production" ? _t(34) : `Warning: Middleware for RTK-Query API at reducerPath "${r.reducerPath}" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function g(C, w) {
    const v = (x, {
      subscribe: T = !0,
      forceRefetch: E,
      subscriptionOptions: k,
      [as]: I
    } = {}) => (P, F) => {
      var G;
      const A = e({
        queryArgs: x,
        endpointDefinition: w,
        endpointName: C
      }), B = t({
        type: "query",
        subscribe: T,
        forceRefetch: E,
        subscriptionOptions: k,
        endpointName: C,
        originalArgs: x,
        queryCacheKey: A,
        [as]: I
      }), W = r.endpoints[C].select(x), M = P(B), _ = W(F());
      b(P);
      const {
        requestId: O,
        abort: R
      } = M, N = _.requestId !== O, L = (G = i.get(P)) == null ? void 0 : G[A], $ = () => W(F()), H = Object.assign(I ? (
        // a query has been forced (upsertQueryData)
        // -> we want to resolve it once data has been written with the data that will be written
        M.then($)
      ) : N && !L ? (
        // a query has been skipped due to a condition and we do not have any currently running query
        // -> we want to resolve it immediately with the current data
        Promise.resolve(_)
      ) : (
        // query just started or one is already in flight
        // -> wait for the running query, then resolve with data from after that
        Promise.all([L, M]).then($)
      ), {
        arg: x,
        requestId: O,
        subscriptionOptions: k,
        queryCacheKey: A,
        abort: R,
        async unwrap() {
          const q = await H;
          if (q.isError)
            throw q.error;
          return q.data;
        },
        refetch: () => P(v(x, {
          subscribe: !1,
          forceRefetch: !0
        })),
        unsubscribe() {
          T && P(l({
            queryCacheKey: A,
            requestId: O
          }));
        },
        updateSubscriptionOptions(q) {
          H.subscriptionOptions = q, P(c({
            endpointName: C,
            requestId: O,
            queryCacheKey: A,
            options: q
          }));
        }
      });
      if (!L && !N && !I) {
        const q = i.get(P) || {};
        q[A] = H, i.set(P, q), H.then(() => {
          delete q[A], Zo(q) || i.delete(P);
        });
      }
      return H;
    };
    return v;
  }
  function S(C) {
    return (w, {
      track: v = !0,
      fixedCacheKey: x
    } = {}) => (T, E) => {
      const k = n({
        type: "mutation",
        endpointName: C,
        originalArgs: w,
        track: v,
        fixedCacheKey: x
      }), I = T(k);
      b(T);
      const {
        requestId: P,
        abort: F,
        unwrap: A
      } = I, B = I.unwrap().then((O) => ({
        data: O
      })).catch((O) => ({
        error: O
      })), W = () => {
        T(u({
          requestId: P,
          fixedCacheKey: x
        }));
      }, M = Object.assign(B, {
        arg: I.arg,
        requestId: P,
        abort: F,
        unwrap: A,
        reset: W
      }), _ = s.get(T) || {};
      return s.set(T, _), _[P] = M, M.then(() => {
        delete _[P], Zo(_) || s.delete(T);
      }), x && (_[x] = M, M.then(() => {
        _[x] === M && (delete _[x], Zo(_) || s.delete(T));
      })), M;
    };
  }
}
function Lp(e) {
  return e;
}
function CL({
  reducerPath: e,
  baseQuery: t,
  context: {
    endpointDefinitions: n
  },
  serializeQueryArgs: r,
  api: o,
  assertTagType: i
}) {
  const s = (w, v, x, T) => (E, k) => {
    const I = n[w], P = r({
      queryArgs: v,
      endpointDefinition: I,
      endpointName: w
    });
    if (E(o.internalActions.queryResultPatched({
      queryCacheKey: P,
      patches: x
    })), !T)
      return;
    const F = o.endpoints[w].select(v)(
      // Work around TS 4.1 mismatch
      k()
    ), A = zd(I.providesTags, F.data, void 0, v, {}, i);
    E(o.internalActions.updateProvidedBy({
      queryCacheKey: P,
      providedTags: A
    }));
  }, l = (w, v, x, T = !0) => (E, k) => {
    const P = o.endpoints[w].select(v)(
      // Work around TS 4.1 mismatch
      k()
    );
    let F = {
      patches: [],
      inversePatches: [],
      undo: () => E(o.util.patchQueryData(w, v, F.inversePatches, T))
    };
    if (P.status === "uninitialized")
      return F;
    let A;
    if ("data" in P)
      if (Bn(P.data)) {
        const [B, W, M] = pb(P.data, x);
        F.patches.push(...W), F.inversePatches.push(...M), A = B;
      } else
        A = x(P.data), F.patches.push({
          op: "replace",
          path: [],
          value: A
        }), F.inversePatches.push({
          op: "replace",
          path: [],
          value: P.data
        });
    return E(o.util.patchQueryData(w, v, F.patches, T)), F;
  }, u = (w, v, x) => (T) => T(o.endpoints[w].initiate(v, {
    subscribe: !1,
    forceRefetch: !0,
    [as]: () => ({
      data: x
    })
  })), c = async (w, {
    signal: v,
    abort: x,
    rejectWithValue: T,
    fulfillWithValue: E,
    dispatch: k,
    getState: I,
    extra: P
  }) => {
    const F = n[w.endpointName];
    try {
      let A = Lp, B;
      const W = {
        signal: v,
        abort: x,
        dispatch: k,
        getState: I,
        extra: P,
        endpoint: w.endpointName,
        type: w.type,
        forced: w.type === "query" ? d(w, I()) : void 0
      }, M = w.type === "query" ? w[as] : void 0;
      if (M ? B = M() : F.query ? (B = await t(F.query(w.originalArgs), W, F.extraOptions), F.transformResponse && (A = F.transformResponse)) : B = await F.queryFn(w.originalArgs, W, F.extraOptions, (_) => t(_, W, F.extraOptions)), typeof process < "u" && process.env.NODE_ENV === "development") {
        const _ = F.query ? "`baseQuery`" : "`queryFn`";
        let O;
        if (!B)
          O = `${_} did not return anything.`;
        else if (typeof B != "object")
          O = `${_} did not return an object.`;
        else if (B.error && B.data)
          O = `${_} returned an object containing both \`error\` and \`result\`.`;
        else if (B.error === void 0 && B.data === void 0)
          O = `${_} returned an object containing neither a valid \`error\` and \`result\`. At least one of them should not be \`undefined\``;
        else
          for (const R of Object.keys(B))
            if (R !== "error" && R !== "data" && R !== "meta") {
              O = `The object returned by ${_} has the unknown property ${R}.`;
              break;
            }
        O && console.error(`Error encountered handling the endpoint ${w.endpointName}.
              ${O}
              It needs to return an object with either the shape \`{ data: <value> }\` or \`{ error: <value> }\` that may contain an optional \`meta\` property.
              Object returned was:`, B);
      }
      if (B.error)
        throw new Vp(B.error, B.meta);
      return E(await A(B.data, B.meta, w.originalArgs), {
        fulfilledTimeStamp: Date.now(),
        baseQueryMeta: B.meta,
        [_a]: !0
      });
    } catch (A) {
      let B = A;
      if (B instanceof Vp) {
        let W = Lp;
        F.query && F.transformErrorResponse && (W = F.transformErrorResponse);
        try {
          return T(await W(B.value, B.meta, w.originalArgs), {
            baseQueryMeta: B.meta,
            [_a]: !0
          });
        } catch (M) {
          B = M;
        }
      }
      throw typeof process < "u" && process.env.NODE_ENV !== "production" ? console.error(`An unhandled error occurred processing a request for the endpoint "${w.endpointName}".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, B) : console.error(B), B;
    }
  };
  function d(w, v) {
    var I, P, F;
    const x = (P = (I = v[e]) == null ? void 0 : I.queries) == null ? void 0 : P[w.queryCacheKey], T = (F = v[e]) == null ? void 0 : F.config.refetchOnMountOrArgChange, E = x == null ? void 0 : x.fulfilledTimeStamp, k = w.forceRefetch ?? (w.subscribe && T);
    return k ? k === !0 || (Number(/* @__PURE__ */ new Date()) - Number(E)) / 1e3 >= k : !1;
  }
  const m = bl(`${e}/executeQuery`, c, {
    getPendingMeta() {
      return {
        startedTimeStamp: Date.now(),
        [_a]: !0
      };
    },
    condition(w, {
      getState: v
    }) {
      var F, A, B;
      const x = v(), T = (A = (F = x[e]) == null ? void 0 : F.queries) == null ? void 0 : A[w.queryCacheKey], E = T == null ? void 0 : T.fulfilledTimeStamp, k = w.originalArgs, I = T == null ? void 0 : T.originalArgs, P = n[w.endpointName];
      return xu(w) ? !0 : (T == null ? void 0 : T.status) === "pending" ? !1 : d(w, x) || Sb(P) && ((B = P == null ? void 0 : P.forceRefetch) != null && B.call(P, {
        currentArg: k,
        previousArg: I,
        endpointState: T,
        state: x
      })) ? !0 : !E;
    },
    dispatchConditionRejection: !0
  }), f = bl(`${e}/executeMutation`, c, {
    getPendingMeta() {
      return {
        startedTimeStamp: Date.now(),
        [_a]: !0
      };
    }
  }), p = (w) => "force" in w, b = (w) => "ifOlderThan" in w, g = (w, v, x) => (T, E) => {
    const k = p(x) && x.force, I = b(x) && x.ifOlderThan, P = (A = !0) => o.endpoints[w].initiate(v, {
      forceRefetch: A
    }), F = o.endpoints[w].select(v)(E());
    if (k)
      T(P());
    else if (I) {
      const A = F == null ? void 0 : F.fulfilledTimeStamp;
      if (!A) {
        T(P());
        return;
      }
      (Number(/* @__PURE__ */ new Date()) - Number(new Date(A))) / 1e3 >= I && T(P());
    } else
      T(P(!1));
  };
  function S(w) {
    return (v) => {
      var x, T;
      return ((T = (x = v == null ? void 0 : v.meta) == null ? void 0 : x.arg) == null ? void 0 : T.endpointName) === w;
    };
  }
  function C(w, v) {
    return {
      matchPending: $a(Nd(w), S(v)),
      matchFulfilled: $a(Vr(w), S(v)),
      matchRejected: $a(ii(w), S(v))
    };
  }
  return {
    queryThunk: m,
    mutationThunk: f,
    prefetch: g,
    updateQueryData: l,
    upsertQueryData: u,
    patchQueryData: s,
    buildMatchThunkActions: C
  };
}
function Tb(e, t, n, r) {
  return zd(n[e.meta.arg.endpointName][t], Vr(e) ? e.payload : void 0, dc(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, r);
}
function js(e, t, n) {
  const r = e[t];
  r && n(r);
}
function ss(e) {
  return ("arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) ?? e.requestId;
}
function Bp(e, t, n) {
  const r = e[ss(t)];
  r && n(r);
}
var ya = {};
function wL({
  reducerPath: e,
  queryThunk: t,
  mutationThunk: n,
  context: {
    endpointDefinitions: r,
    apiUid: o,
    extractRehydrationInfo: i,
    hasRehydrationInfo: s
  },
  assertTagType: l,
  config: u
}) {
  const c = cn(`${e}/resetApiState`), d = dr({
    name: `${e}/queries`,
    initialState: ya,
    reducers: {
      removeQueryResult: {
        reducer(v, {
          payload: {
            queryCacheKey: x
          }
        }) {
          delete v[x];
        },
        prepare: ga()
      },
      queryResultPatched: {
        reducer(v, {
          payload: {
            queryCacheKey: x,
            patches: T
          }
        }) {
          js(v, x, (E) => {
            E.data = _p(E.data, T.concat());
          });
        },
        prepare: ga()
      }
    },
    extraReducers(v) {
      v.addCase(t.pending, (x, {
        meta: T,
        meta: {
          arg: E
        }
      }) => {
        var I;
        const k = xu(E);
        x[I = E.queryCacheKey] ?? (x[I] = {
          status: "uninitialized",
          endpointName: E.endpointName
        }), js(x, E.queryCacheKey, (P) => {
          P.status = "pending", P.requestId = k && P.requestId ? (
            // for `upsertQuery` **updates**, keep the current `requestId`
            P.requestId
          ) : (
            // for normal queries or `upsertQuery` **inserts** always update the `requestId`
            T.requestId
          ), E.originalArgs !== void 0 && (P.originalArgs = E.originalArgs), P.startedTimeStamp = T.startedTimeStamp;
        });
      }).addCase(t.fulfilled, (x, {
        meta: T,
        payload: E
      }) => {
        js(x, T.arg.queryCacheKey, (k) => {
          if (k.requestId !== T.requestId && !xu(T.arg))
            return;
          const {
            merge: I
          } = r[T.arg.endpointName];
          if (k.status = "fulfilled", I)
            if (k.data !== void 0) {
              const {
                fulfilledTimeStamp: P,
                arg: F,
                baseQueryMeta: A,
                requestId: B
              } = T;
              let W = Ds(k.data, (M) => I(M, E, {
                arg: F.originalArgs,
                baseQueryMeta: A,
                fulfilledTimeStamp: P,
                requestId: B
              }));
              k.data = W;
            } else
              k.data = E;
          else
            k.data = r[T.arg.endpointName].structuralSharing ?? !0 ? Cb(Ln(k.data) ? dj(k.data) : k.data, E) : E;
          delete k.error, k.fulfilledTimeStamp = T.fulfilledTimeStamp;
        });
      }).addCase(t.rejected, (x, {
        meta: {
          condition: T,
          arg: E,
          requestId: k
        },
        error: I,
        payload: P
      }) => {
        js(x, E.queryCacheKey, (F) => {
          if (!T) {
            if (F.requestId !== k)
              return;
            F.status = "rejected", F.error = P ?? I;
          }
        });
      }).addMatcher(s, (x, T) => {
        const {
          queries: E
        } = i(T);
        for (const [k, I] of Object.entries(E))
          // do not rehydrate entries that were currently in flight.
          ((I == null ? void 0 : I.status) === "fulfilled" || (I == null ? void 0 : I.status) === "rejected") && (x[k] = I);
      });
    }
  }), m = dr({
    name: `${e}/mutations`,
    initialState: ya,
    reducers: {
      removeMutationResult: {
        reducer(v, {
          payload: x
        }) {
          const T = ss(x);
          T in v && delete v[T];
        },
        prepare: ga()
      }
    },
    extraReducers(v) {
      v.addCase(n.pending, (x, {
        meta: T,
        meta: {
          requestId: E,
          arg: k,
          startedTimeStamp: I
        }
      }) => {
        k.track && (x[ss(T)] = {
          requestId: E,
          status: "pending",
          endpointName: k.endpointName,
          startedTimeStamp: I
        });
      }).addCase(n.fulfilled, (x, {
        payload: T,
        meta: E
      }) => {
        E.arg.track && Bp(x, E, (k) => {
          k.requestId === E.requestId && (k.status = "fulfilled", k.data = T, k.fulfilledTimeStamp = E.fulfilledTimeStamp);
        });
      }).addCase(n.rejected, (x, {
        payload: T,
        error: E,
        meta: k
      }) => {
        k.arg.track && Bp(x, k, (I) => {
          I.requestId === k.requestId && (I.status = "rejected", I.error = T ?? E);
        });
      }).addMatcher(s, (x, T) => {
        const {
          mutations: E
        } = i(T);
        for (const [k, I] of Object.entries(E))
          // do not rehydrate entries that were currently in flight.
          ((I == null ? void 0 : I.status) === "fulfilled" || (I == null ? void 0 : I.status) === "rejected") && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
          k !== (I == null ? void 0 : I.requestId) && (x[k] = I);
      });
    }
  }), f = dr({
    name: `${e}/invalidation`,
    initialState: ya,
    reducers: {
      updateProvidedBy: {
        reducer(v, x) {
          var k, I;
          const {
            queryCacheKey: T,
            providedTags: E
          } = x.payload;
          for (const P of Object.values(v))
            for (const F of Object.values(P)) {
              const A = F.indexOf(T);
              A !== -1 && F.splice(A, 1);
            }
          for (const {
            type: P,
            id: F
          } of E) {
            const A = (k = v[P] ?? (v[P] = {}))[I = F || "__internal_without_id"] ?? (k[I] = []);
            A.includes(T) || A.push(T);
          }
        },
        prepare: ga()
      }
    },
    extraReducers(v) {
      v.addCase(d.actions.removeQueryResult, (x, {
        payload: {
          queryCacheKey: T
        }
      }) => {
        for (const E of Object.values(x))
          for (const k of Object.values(E)) {
            const I = k.indexOf(T);
            I !== -1 && k.splice(I, 1);
          }
      }).addMatcher(s, (x, T) => {
        var k, I;
        const {
          provided: E
        } = i(T);
        for (const [P, F] of Object.entries(E))
          for (const [A, B] of Object.entries(F)) {
            const W = (k = x[P] ?? (x[P] = {}))[I = A || "__internal_without_id"] ?? (k[I] = []);
            for (const M of B)
              W.includes(M) || W.push(M);
          }
      }).addMatcher(Fr(Vr(t), dc(t)), (x, T) => {
        const E = Tb(T, "providesTags", r, l), {
          queryCacheKey: k
        } = T.meta.arg;
        f.caseReducers.updateProvidedBy(x, f.actions.updateProvidedBy({
          queryCacheKey: k,
          providedTags: E
        }));
      });
    }
  }), p = dr({
    name: `${e}/subscriptions`,
    initialState: ya,
    reducers: {
      updateSubscriptionOptions(v, x) {
      },
      unsubscribeQueryResult(v, x) {
      },
      internal_getRTKQSubscriptions() {
      }
    }
  }), b = dr({
    name: `${e}/internalSubscriptions`,
    initialState: ya,
    reducers: {
      subscriptionsUpdated: {
        reducer(v, x) {
          return _p(v, x.payload);
        },
        prepare: ga()
      }
    }
  }), g = dr({
    name: `${e}/config`,
    initialState: {
      online: pL(),
      focused: mL(),
      middlewareRegistered: !1,
      ...u
    },
    reducers: {
      middlewareRegistered(v, {
        payload: x
      }) {
        v.middlewareRegistered = v.middlewareRegistered === "conflict" || o !== x ? "conflict" : !0;
      }
    },
    extraReducers: (v) => {
      v.addCase(Bd, (x) => {
        x.online = !0;
      }).addCase(xb, (x) => {
        x.online = !1;
      }).addCase(Ld, (x) => {
        x.focused = !0;
      }).addCase(wb, (x) => {
        x.focused = !1;
      }).addMatcher(s, (x) => ({
        ...x
      }));
    }
  }), S = cj({
    queries: d.reducer,
    mutations: m.reducer,
    provided: f.reducer,
    subscriptions: b.reducer,
    config: g.reducer
  }), C = (v, x) => S(c.match(x) ? void 0 : v, x), w = {
    ...g.actions,
    ...d.actions,
    ...p.actions,
    ...b.actions,
    ...m.actions,
    ...f.actions,
    resetApiState: c
  };
  return {
    reducer: C,
    actions: w
  };
}
var io = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), _b = {
  status: "uninitialized"
  /* uninitialized */
}, zp = /* @__PURE__ */ Ds(_b, () => {
}), Wp = /* @__PURE__ */ Ds(_b, () => {
});
function xL({
  serializeQueryArgs: e,
  reducerPath: t
}) {
  const n = (d) => zp, r = (d) => Wp;
  return {
    buildQuerySelector: s,
    buildMutationSelector: l,
    selectInvalidatedBy: u,
    selectCachedArgsForQuery: c
  };
  function o(d) {
    return {
      ...d,
      ...lL(d.status)
    };
  }
  function i(d) {
    const m = d[t];
    if (process.env.NODE_ENV !== "production" && !m) {
      if (i.triggered)
        return m;
      i.triggered = !0, console.error(`Error: No data found at \`state.${t}\`. Did you forget to add the reducer to the store?`);
    }
    return m;
  }
  function s(d, m) {
    return (f) => {
      const p = e({
        queryArgs: f,
        endpointDefinition: m,
        endpointName: d
      });
      return ln(f === io ? n : (S) => {
        var C, w;
        return ((w = (C = i(S)) == null ? void 0 : C.queries) == null ? void 0 : w[p]) ?? zp;
      }, o);
    };
  }
  function l() {
    return (d) => {
      let m;
      return typeof d == "object" ? m = ss(d) ?? io : m = d, ln(m === io ? r : (b) => {
        var g, S;
        return ((S = (g = i(b)) == null ? void 0 : g.mutations) == null ? void 0 : S[m]) ?? Wp;
      }, o);
    };
  }
  function u(d, m) {
    const f = d[t], p = /* @__PURE__ */ new Set();
    for (const b of m.map(wu)) {
      const g = f.provided[b.type];
      if (!g)
        continue;
      let S = (b.id !== void 0 ? (
        // id given: invalidate all queries that provide this type & id
        g[b.id]
      ) : (
        // no id: invalidate all queries that provide this type
        Ap(Object.values(g))
      )) ?? [];
      for (const C of S)
        p.add(C);
    }
    return Ap(Array.from(p.values()).map((b) => {
      const g = f.queries[b];
      return g ? [{
        queryCacheKey: b,
        endpointName: g.endpointName,
        originalArgs: g.originalArgs
      }] : [];
    }));
  }
  function c(d, m) {
    return Object.values(d[t].queries).filter(
      (f) => (f == null ? void 0 : f.endpointName) === m && f.status !== "uninitialized"
      /* uninitialized */
    ).map((f) => f.originalArgs);
  }
}
var Ao = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, qp = ({
  endpointName: e,
  queryArgs: t
}) => {
  let n = "";
  const r = Ao == null ? void 0 : Ao.get(t);
  if (typeof r == "string")
    n = r;
  else {
    const o = JSON.stringify(t, (i, s) => br(s) ? Object.keys(s).sort().reduce((l, u) => (l[u] = s[u], l), {}) : s);
    br(t) && (Ao == null || Ao.set(t, o)), n = o;
  }
  return `${e}(${n})`;
};
function SL(...e) {
  return function(n) {
    const r = is((c) => {
      var d;
      return (d = n.extractRehydrationInfo) == null ? void 0 : d.call(n, c, {
        reducerPath: n.reducerPath ?? "api"
      });
    }), o = {
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1,
      invalidationBehavior: "delayed",
      ...n,
      extractRehydrationInfo: r,
      serializeQueryArgs(c) {
        let d = qp;
        if ("serializeQueryArgs" in c.endpointDefinition) {
          const m = c.endpointDefinition.serializeQueryArgs;
          d = (f) => {
            const p = m(f);
            return typeof p == "string" ? p : qp({
              ...f,
              queryArgs: p
            });
          };
        } else
          n.serializeQueryArgs && (d = n.serializeQueryArgs);
        return d(c);
      },
      tagTypes: [...n.tagTypes || []]
    }, i = {
      endpointDefinitions: {},
      batch(c) {
        c();
      },
      apiUid: gb(),
      extractRehydrationInfo: r,
      hasRehydrationInfo: is((c) => r(c) != null)
    }, s = {
      injectEndpoints: u,
      enhanceEndpoints({
        addTagTypes: c,
        endpoints: d
      }) {
        if (c)
          for (const m of c)
            o.tagTypes.includes(m) || o.tagTypes.push(m);
        if (d)
          for (const [m, f] of Object.entries(d))
            typeof f == "function" ? f(i.endpointDefinitions[m]) : Object.assign(i.endpointDefinitions[m] || {}, f);
        return s;
      }
    }, l = e.map((c) => c.init(s, o, i));
    function u(c) {
      const d = c.endpoints({
        query: (m) => ({
          ...m,
          type: "query"
          /* query */
        }),
        mutation: (m) => ({
          ...m,
          type: "mutation"
          /* mutation */
        })
      });
      for (const [m, f] of Object.entries(d)) {
        if (!c.overrideExisting && m in i.endpointDefinitions) {
          typeof process < "u" && process.env.NODE_ENV === "development" && console.error(`called \`injectEndpoints\` to override already-existing endpointName ${m} without specifying \`overrideExisting: true\``);
          continue;
        }
        i.endpointDefinitions[m] = f;
        for (const p of l)
          p.injectEndpoint(m, f);
      }
      return s;
    }
    return s.injectEndpoints({
      endpoints: n.endpoints
    });
  };
}
function TL(e) {
  for (let t in e)
    return !1;
  return !0;
}
var _L = 2147483647 / 1e3 - 1, DL = ({
  reducerPath: e,
  api: t,
  context: n,
  internalState: r
}) => {
  const {
    removeQueryResult: o,
    unsubscribeQueryResult: i
  } = t.internalActions;
  function s(d) {
    const m = r.currentSubscriptions[d];
    return !!m && !TL(m);
  }
  const l = {}, u = (d, m, f) => {
    var p;
    if (i.match(d)) {
      const b = m.getState()[e], {
        queryCacheKey: g
      } = d.payload;
      c(g, (p = b.queries[g]) == null ? void 0 : p.endpointName, m, b.config);
    }
    if (t.util.resetApiState.match(d))
      for (const [b, g] of Object.entries(l))
        g && clearTimeout(g), delete l[b];
    if (n.hasRehydrationInfo(d)) {
      const b = m.getState()[e], {
        queries: g
      } = n.extractRehydrationInfo(d);
      for (const [S, C] of Object.entries(g))
        c(S, C == null ? void 0 : C.endpointName, m, b.config);
    }
  };
  function c(d, m, f, p) {
    const b = n.endpointDefinitions[m], g = (b == null ? void 0 : b.keepUnusedDataFor) ?? p.keepUnusedDataFor;
    if (g === 1 / 0)
      return;
    const S = Math.max(0, Math.min(g, _L));
    if (!s(d)) {
      const C = l[d];
      C && clearTimeout(C), l[d] = setTimeout(() => {
        s(d) || f.dispatch(o({
          queryCacheKey: d
        })), delete l[d];
      }, S * 1e3);
    }
  }
  return u;
}, PL = ({
  reducerPath: e,
  context: t,
  context: {
    endpointDefinitions: n
  },
  mutationThunk: r,
  queryThunk: o,
  api: i,
  assertTagType: s,
  refetchQuery: l,
  internalState: u
}) => {
  const {
    removeQueryResult: c
  } = i.internalActions, d = Fr(Vr(r), dc(r)), m = Fr(Vr(r, o), ii(r, o));
  let f = [];
  const p = (S, C) => {
    d(S) ? g(Tb(S, "invalidatesTags", n, s), C) : m(S) ? g([], C) : i.util.invalidateTags.match(S) && g(zd(S.payload, void 0, void 0, void 0, void 0, s), C);
  };
  function b(S) {
    var C, w;
    for (const v in S.queries)
      if (((C = S.queries[v]) == null ? void 0 : C.status) === "pending")
        return !0;
    for (const v in S.mutations)
      if (((w = S.mutations[v]) == null ? void 0 : w.status) === "pending")
        return !0;
    return !1;
  }
  function g(S, C) {
    const w = C.getState(), v = w[e];
    if (f.push(...S), v.config.invalidationBehavior === "delayed" && b(v))
      return;
    const x = f;
    if (f = [], x.length === 0)
      return;
    const T = i.util.selectInvalidatedBy(w, x);
    t.batch(() => {
      const E = Array.from(T.values());
      for (const {
        queryCacheKey: k
      } of E) {
        const I = v.queries[k], P = u.currentSubscriptions[k] ?? {};
        I && (Zo(P) === 0 ? C.dispatch(c({
          queryCacheKey: k
        })) : I.status !== "uninitialized" && C.dispatch(l(I, k)));
      }
    });
  }
  return p;
}, OL = ({
  reducerPath: e,
  queryThunk: t,
  api: n,
  refetchQuery: r,
  internalState: o
}) => {
  const i = {}, s = (f, p) => {
    (n.internalActions.updateSubscriptionOptions.match(f) || n.internalActions.unsubscribeQueryResult.match(f)) && u(f.payload, p), (t.pending.match(f) || t.rejected.match(f) && f.meta.condition) && u(f.meta.arg, p), (t.fulfilled.match(f) || t.rejected.match(f) && !f.meta.condition) && l(f.meta.arg, p), n.util.resetApiState.match(f) && d();
  };
  function l({
    queryCacheKey: f
  }, p) {
    const g = p.getState()[e].queries[f], S = o.currentSubscriptions[f];
    if (!g || g.status === "uninitialized")
      return;
    const C = m(S);
    if (!Number.isFinite(C))
      return;
    const w = i[f];
    w != null && w.timeout && (clearTimeout(w.timeout), w.timeout = void 0);
    const v = Date.now() + C, x = i[f] = {
      nextPollTimestamp: v,
      pollingInterval: C,
      timeout: setTimeout(() => {
        x.timeout = void 0, p.dispatch(r(g, f));
      }, C)
    };
  }
  function u({
    queryCacheKey: f
  }, p) {
    const g = p.getState()[e].queries[f], S = o.currentSubscriptions[f];
    if (!g || g.status === "uninitialized")
      return;
    const C = m(S);
    if (!Number.isFinite(C)) {
      c(f);
      return;
    }
    const w = i[f], v = Date.now() + C;
    (!w || v < w.nextPollTimestamp) && l({
      queryCacheKey: f
    }, p);
  }
  function c(f) {
    const p = i[f];
    p != null && p.timeout && clearTimeout(p.timeout), delete i[f];
  }
  function d() {
    for (const f of Object.keys(i))
      c(f);
  }
  function m(f = {}) {
    let p = Number.POSITIVE_INFINITY;
    for (let b in f)
      f[b].pollingInterval && (p = Math.min(f[b].pollingInterval, p));
    return p;
  }
  return s;
}, kL = ({
  reducerPath: e,
  context: t,
  api: n,
  refetchQuery: r,
  internalState: o
}) => {
  const {
    removeQueryResult: i
  } = n.internalActions, s = (u, c) => {
    Ld.match(u) && l(c, "refetchOnFocus"), Bd.match(u) && l(c, "refetchOnReconnect");
  };
  function l(u, c) {
    const d = u.getState()[e], m = d.queries, f = o.currentSubscriptions;
    t.batch(() => {
      for (const p of Object.keys(f)) {
        const b = m[p], g = f[p];
        if (!g || !b)
          continue;
        (Object.values(g).some((C) => C[c] === !0) || Object.values(g).every((C) => C[c] === void 0) && d.config[c]) && (Zo(g) === 0 ? u.dispatch(i({
          queryCacheKey: p
        })) : b.status !== "uninitialized" && u.dispatch(r(b, p)));
      }
    });
  }
  return s;
}, Hp = new Error("Promise never resolved before cacheEntryRemoved."), ML = ({
  api: e,
  reducerPath: t,
  context: n,
  queryThunk: r,
  mutationThunk: o,
  internalState: i
}) => {
  const s = Cu(r), l = Cu(o), u = Vr(r, o), c = {}, d = (p, b, g) => {
    const S = m(p);
    if (r.pending.match(p)) {
      const C = g[t].queries[S], w = b.getState()[t].queries[S];
      !C && w && f(p.meta.arg.endpointName, p.meta.arg.originalArgs, S, b, p.meta.requestId);
    } else if (o.pending.match(p))
      b.getState()[t].mutations[S] && f(p.meta.arg.endpointName, p.meta.arg.originalArgs, S, b, p.meta.requestId);
    else if (u(p)) {
      const C = c[S];
      C != null && C.valueResolved && (C.valueResolved({
        data: p.payload,
        meta: p.meta.baseQueryMeta
      }), delete C.valueResolved);
    } else if (e.internalActions.removeQueryResult.match(p) || e.internalActions.removeMutationResult.match(p)) {
      const C = c[S];
      C && (delete c[S], C.cacheEntryRemoved());
    } else if (e.util.resetApiState.match(p))
      for (const [C, w] of Object.entries(c))
        delete c[C], w.cacheEntryRemoved();
  };
  function m(p) {
    return s(p) ? p.meta.arg.queryCacheKey : l(p) ? p.meta.requestId : e.internalActions.removeQueryResult.match(p) ? p.payload.queryCacheKey : e.internalActions.removeMutationResult.match(p) ? ss(p.payload) : "";
  }
  function f(p, b, g, S, C) {
    const w = n.endpointDefinitions[p], v = w == null ? void 0 : w.onCacheEntryAdded;
    if (!v)
      return;
    let x = {};
    const T = new Promise((A) => {
      x.cacheEntryRemoved = A;
    }), E = Promise.race([new Promise((A) => {
      x.valueResolved = A;
    }), T.then(() => {
      throw Hp;
    })]);
    E.catch(() => {
    }), c[g] = x;
    const k = e.endpoints[p].select(w.type === "query" ? b : g), I = S.dispatch((A, B, W) => W), P = {
      ...S,
      getCacheEntry: () => k(S.getState()),
      requestId: C,
      extra: I,
      updateCachedData: w.type === "query" ? (A) => S.dispatch(e.util.updateQueryData(p, b, A)) : void 0,
      cacheDataLoaded: E,
      cacheEntryRemoved: T
    }, F = v(b, P);
    Promise.resolve(F).catch((A) => {
      if (A !== Hp)
        throw A;
    });
  }
  return d;
}, EL = ({
  api: e,
  context: t,
  queryThunk: n,
  mutationThunk: r
}) => {
  const o = Nd(n, r), i = ii(n, r), s = Vr(n, r), l = {};
  return (c, d) => {
    var m, f;
    if (o(c)) {
      const {
        requestId: p,
        arg: {
          endpointName: b,
          originalArgs: g
        }
      } = c.meta, S = t.endpointDefinitions[b], C = S == null ? void 0 : S.onQueryStarted;
      if (C) {
        const w = {}, v = new Promise((k, I) => {
          w.resolve = k, w.reject = I;
        });
        v.catch(() => {
        }), l[p] = w;
        const x = e.endpoints[b].select(S.type === "query" ? g : p), T = d.dispatch((k, I, P) => P), E = {
          ...d,
          getCacheEntry: () => x(d.getState()),
          requestId: p,
          extra: T,
          updateCachedData: S.type === "query" ? (k) => d.dispatch(e.util.updateQueryData(b, g, k)) : void 0,
          queryFulfilled: v
        };
        C(g, E);
      }
    } else if (s(c)) {
      const {
        requestId: p,
        baseQueryMeta: b
      } = c.meta;
      (m = l[p]) == null || m.resolve({
        data: c.payload,
        meta: b
      }), delete l[p];
    } else if (i(c)) {
      const {
        requestId: p,
        rejectedWithValue: b,
        baseQueryMeta: g
      } = c.meta;
      (f = l[p]) == null || f.reject({
        error: c.payload ?? c.error,
        isUnhandledError: !b,
        meta: g
      }), delete l[p];
    }
  };
}, IL = ({
  api: e,
  context: {
    apiUid: t
  },
  reducerPath: n
}) => (r, o) => {
  var i, s;
  e.util.resetApiState.match(r) && o.dispatch(e.internalActions.middlewareRegistered(t)), typeof process < "u" && process.env.NODE_ENV === "development" && e.internalActions.middlewareRegistered.match(r) && r.payload === t && ((s = (i = o.getState()[n]) == null ? void 0 : i.config) == null ? void 0 : s.middlewareRegistered) === "conflict" && console.warn(`There is a mismatch between slice and middleware for the reducerPath "${n}".
You can only have one api per reducer path, this will lead to crashes in various situations!${n === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""}`);
}, RL = ({
  api: e,
  queryThunk: t,
  internalState: n
}) => {
  const r = `${e.reducerPath}/subscriptions`;
  let o = null, i = null;
  const {
    updateSubscriptionOptions: s,
    unsubscribeQueryResult: l
  } = e.internalActions, u = (p, b) => {
    var S, C, w;
    if (s.match(b)) {
      const {
        queryCacheKey: v,
        requestId: x,
        options: T
      } = b.payload;
      return (S = p == null ? void 0 : p[v]) != null && S[x] && (p[v][x] = T), !0;
    }
    if (l.match(b)) {
      const {
        queryCacheKey: v,
        requestId: x
      } = b.payload;
      return p[v] && delete p[v][x], !0;
    }
    if (e.internalActions.removeQueryResult.match(b))
      return delete p[b.payload.queryCacheKey], !0;
    if (t.pending.match(b)) {
      const {
        meta: {
          arg: v,
          requestId: x
        }
      } = b, T = p[C = v.queryCacheKey] ?? (p[C] = {});
      return T[`${x}_running`] = {}, v.subscribe && (T[x] = v.subscriptionOptions ?? T[x] ?? {}), !0;
    }
    let g = !1;
    if (t.fulfilled.match(b) || t.rejected.match(b)) {
      const v = p[b.meta.arg.queryCacheKey] || {}, x = `${b.meta.requestId}_running`;
      g || (g = !!v[x]), delete v[x];
    }
    if (t.rejected.match(b)) {
      const {
        meta: {
          condition: v,
          arg: x,
          requestId: T
        }
      } = b;
      if (v && x.subscribe) {
        const E = p[w = x.queryCacheKey] ?? (p[w] = {});
        E[T] = x.subscriptionOptions ?? E[T] ?? {}, g = !0;
      }
    }
    return g;
  }, c = () => n.currentSubscriptions, f = {
    getSubscriptions: c,
    getSubscriptionCount: (p) => {
      const g = c()[p] ?? {};
      return Zo(g);
    },
    isRequestSubscribed: (p, b) => {
      var S;
      const g = c();
      return !!((S = g == null ? void 0 : g[p]) != null && S[b]);
    }
  };
  return (p, b) => {
    if (o || (o = JSON.parse(JSON.stringify(n.currentSubscriptions))), e.util.resetApiState.match(p))
      return o = n.currentSubscriptions = {}, i = null, [!0, !1];
    if (e.internalActions.internal_getRTKQSubscriptions.match(p))
      return [!1, f];
    const g = u(n.currentSubscriptions, p);
    let S = !0;
    if (g) {
      i || (i = setTimeout(() => {
        const v = JSON.parse(JSON.stringify(n.currentSubscriptions)), [, x] = pb(o, () => v);
        b.next(e.internalActions.subscriptionsUpdated(x)), o = v, i = null;
      }, 500));
      const C = typeof p.type == "string" && !!p.type.startsWith(r), w = t.rejected.match(p) && p.meta.condition && !!p.meta.arg.subscribe;
      S = !C && !w;
    }
    return [S, !1];
  };
};
function AL(e) {
  const {
    reducerPath: t,
    queryThunk: n,
    api: r,
    context: o
  } = e, {
    apiUid: i
  } = o, s = {
    invalidateTags: cn(`${t}/invalidateTags`)
  }, l = (m) => m.type.startsWith(`${t}/`), u = [IL, DL, PL, OL, ML, EL];
  return {
    middleware: (m) => {
      let f = !1;
      const b = {
        ...e,
        internalState: {
          currentSubscriptions: {}
        },
        refetchQuery: d,
        isThisApiSliceAction: l
      }, g = u.map((w) => w(b)), S = RL(b), C = kL(b);
      return (w) => (v) => {
        if (!ib(v))
          return w(v);
        f || (f = !0, m.dispatch(r.internalActions.middlewareRegistered(i)));
        const x = {
          ...m,
          next: w
        }, T = m.getState(), [E, k] = S(v, x, T);
        let I;
        if (E ? I = w(v) : I = k, m.getState()[t] && (C(v, x, T), l(v) || o.hasRehydrationInfo(v)))
          for (let P of g)
            P(v, x, T);
        return I;
      };
    },
    actions: s
  };
  function d(m, f, p = {}) {
    return n({
      type: "query",
      endpointName: m.endpointName,
      originalArgs: m.originalArgs,
      subscribe: !1,
      forceRefetch: !0,
      queryCacheKey: f,
      ...p
    });
  }
}
function Tr(e, ...t) {
  return Object.assign(e, ...t);
}
var Up = /* @__PURE__ */ Symbol(), $L = () => ({
  name: Up,
  init(e, {
    baseQuery: t,
    tagTypes: n,
    reducerPath: r,
    serializeQueryArgs: o,
    keepUnusedDataFor: i,
    refetchOnMountOrArgChange: s,
    refetchOnFocus: l,
    refetchOnReconnect: u,
    invalidationBehavior: c
  }, d) {
    Cj();
    const m = (R) => (typeof process < "u" && process.env.NODE_ENV === "development" && (n.includes(R.type) || console.error(`Tag type '${R.type}' was used, but not specified in \`tagTypes\`!`)), R);
    Object.assign(e, {
      reducerPath: r,
      endpoints: {},
      internalActions: {
        onOnline: Bd,
        onOffline: xb,
        onFocus: Ld,
        onFocusLost: wb
      },
      util: {}
    });
    const {
      queryThunk: f,
      mutationThunk: p,
      patchQueryData: b,
      updateQueryData: g,
      upsertQueryData: S,
      prefetch: C,
      buildMatchThunkActions: w
    } = CL({
      baseQuery: t,
      reducerPath: r,
      context: d,
      api: e,
      serializeQueryArgs: o,
      assertTagType: m
    }), {
      reducer: v,
      actions: x
    } = wL({
      context: d,
      queryThunk: f,
      mutationThunk: p,
      reducerPath: r,
      assertTagType: m,
      config: {
        refetchOnFocus: l,
        refetchOnReconnect: u,
        refetchOnMountOrArgChange: s,
        keepUnusedDataFor: i,
        reducerPath: r,
        invalidationBehavior: c
      }
    });
    Tr(e.util, {
      patchQueryData: b,
      updateQueryData: g,
      upsertQueryData: S,
      prefetch: C,
      resetApiState: x.resetApiState
    }), Tr(e.internalActions, x);
    const {
      middleware: T,
      actions: E
    } = AL({
      reducerPath: r,
      context: d,
      queryThunk: f,
      mutationThunk: p,
      api: e,
      assertTagType: m
    });
    Tr(e.util, E), Tr(e, {
      reducer: v,
      middleware: T
    });
    const {
      buildQuerySelector: k,
      buildMutationSelector: I,
      selectInvalidatedBy: P,
      selectCachedArgsForQuery: F
    } = xL({
      serializeQueryArgs: o,
      reducerPath: r
    });
    Tr(e.util, {
      selectInvalidatedBy: P,
      selectCachedArgsForQuery: F
    });
    const {
      buildInitiateQuery: A,
      buildInitiateMutation: B,
      getRunningMutationThunk: W,
      getRunningMutationsThunk: M,
      getRunningQueriesThunk: _,
      getRunningQueryThunk: O
    } = vL({
      queryThunk: f,
      mutationThunk: p,
      api: e,
      serializeQueryArgs: o,
      context: d
    });
    return Tr(e.util, {
      getRunningMutationThunk: W,
      getRunningMutationsThunk: M,
      getRunningQueryThunk: O,
      getRunningQueriesThunk: _
    }), {
      name: Up,
      injectEndpoint(R, N) {
        var $;
        const L = e;
        ($ = L.endpoints)[R] ?? ($[R] = {}), Sb(N) ? Tr(L.endpoints[R], {
          name: R,
          select: k(R, N),
          initiate: A(R, N)
        }, w(f, R)) : yL(N) && Tr(L.endpoints[R], {
          name: R,
          select: I(),
          initiate: B(R)
        }, w(p, R));
      }
    };
  }
});
function Yp(e, t, n, r) {
  const o = Ee(() => ({
    queryArgs: e,
    serialized: typeof e == "object" ? t({
      queryArgs: e,
      endpointDefinition: n,
      endpointName: r
    }) : e
  }), [e, t, n, r]), i = Ot(o);
  return it(() => {
    i.current.serialized !== o.serialized && (i.current = o);
  }, [o]), i.current.serialized === o.serialized ? i.current.queryArgs : e;
}
var Vc = Symbol();
function jc(e) {
  const t = Ot(e);
  return it(() => {
    hl(t.current, e) || (t.current = e);
  }, [e]), hl(t.current, e) ? t.current : e;
}
var $o = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, NL = ({
  endpointName: e,
  queryArgs: t
}) => {
  let n = "";
  const r = $o == null ? void 0 : $o.get(t);
  if (typeof r == "string")
    n = r;
  else {
    const o = JSON.stringify(t, (i, s) => br(s) ? Object.keys(s).sort().reduce((l, u) => (l[u] = s[u], l), {}) : s);
    br(t) && ($o == null || $o.set(t, o)), n = o;
  }
  return `${e}(${n})`;
}, FL = typeof window < "u" && window.document && window.document.createElement ? Dl : it, VL = (e) => e.isUninitialized ? {
  ...e,
  isUninitialized: !1,
  isFetching: !0,
  isLoading: e.data === void 0,
  status: vb.pending
} : e;
function jL({
  api: e,
  moduleOptions: {
    batch: t,
    hooks: {
      useDispatch: n,
      useSelector: r,
      useStore: o
    },
    unstable__sideEffectsInRender: i
  },
  serializeQueryArgs: s,
  context: l
}) {
  const u = i ? (p) => p() : it;
  return {
    buildQueryHooks: m,
    buildMutationHook: f,
    usePrefetch: d
  };
  function c(p, b, g) {
    if (b != null && b.endpointName && p.isUninitialized) {
      const {
        endpointName: T
      } = b, E = l.endpointDefinitions[T];
      s({
        queryArgs: b.originalArgs,
        endpointDefinition: E,
        endpointName: T
      }) === s({
        queryArgs: g,
        endpointDefinition: E,
        endpointName: T
      }) && (b = void 0);
    }
    let S = p.isSuccess ? p.data : b == null ? void 0 : b.data;
    S === void 0 && (S = p.data);
    const C = S !== void 0, w = p.isLoading, v = !C && w, x = p.isSuccess || w && C;
    return {
      ...p,
      data: S,
      currentData: p.data,
      isFetching: w,
      isLoading: v,
      isSuccess: x
    };
  }
  function d(p, b) {
    const g = n(), S = jc(b);
    return Qe((C, w) => g(e.util.prefetch(p, C, {
      ...S,
      ...w
    })), [p, g, S]);
  }
  function m(p) {
    const b = (C, {
      refetchOnReconnect: w,
      refetchOnFocus: v,
      refetchOnMountOrArgChange: x,
      skip: T = !1,
      pollingInterval: E = 0
    } = {}) => {
      const {
        initiate: k
      } = e.endpoints[p], I = n(), P = Ot();
      if (!P.current) {
        const N = I(e.internalActions.internal_getRTKQSubscriptions());
        if (process.env.NODE_ENV !== "production" && (typeof N != "object" || typeof (N == null ? void 0 : N.type) == "string"))
          throw new Error(process.env.NODE_ENV === "production" ? _t(37) : `Warning: Middleware for RTK-Query API at reducerPath "${e.reducerPath}" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
        P.current = N;
      }
      const F = Yp(
        T ? io : C,
        // Even if the user provided a per-endpoint `serializeQueryArgs` with
        // a consistent return value, _here_ we want to use the default behavior
        // so we can tell if _anything_ actually changed. Otherwise, we can end up
        // with a case where the query args did change but the serialization doesn't,
        // and then we never try to initiate a refetch.
        NL,
        l.endpointDefinitions[p],
        p
      ), A = jc({
        refetchOnReconnect: w,
        refetchOnFocus: v,
        pollingInterval: E
      }), B = Ot(!1), W = Ot();
      let {
        queryCacheKey: M,
        requestId: _
      } = W.current || {}, O = !1;
      M && _ && (O = P.current.isRequestSubscribed(M, _));
      const R = !O && B.current;
      return u(() => {
        B.current = O;
      }), u(() => {
        R && (W.current = void 0);
      }, [R]), u(() => {
        var $;
        const N = W.current;
        if (typeof process < "u" && process.env.NODE_ENV === "removeMeOnCompilation" && console.log(R), F === io) {
          N == null || N.unsubscribe(), W.current = void 0;
          return;
        }
        const L = ($ = W.current) == null ? void 0 : $.subscriptionOptions;
        if (!N || N.arg !== F) {
          N == null || N.unsubscribe();
          const H = I(k(F, {
            subscriptionOptions: A,
            forceRefetch: x
          }));
          W.current = H;
        } else
          A !== L && N.updateSubscriptionOptions(A);
      }, [I, k, x, F, A, R]), it(() => () => {
        var N;
        (N = W.current) == null || N.unsubscribe(), W.current = void 0;
      }, []), Ee(() => ({
        /**
         * A method to manually refetch data for the query
         */
        refetch: () => {
          var N;
          if (!W.current)
            throw new Error(process.env.NODE_ENV === "production" ? _t(38) : "Cannot refetch a query that has not been started yet.");
          return (N = W.current) == null ? void 0 : N.refetch();
        }
      }), []);
    }, g = ({
      refetchOnReconnect: C,
      refetchOnFocus: w,
      pollingInterval: v = 0
    } = {}) => {
      const {
        initiate: x
      } = e.endpoints[p], T = n(), [E, k] = Xe(Vc), I = Ot(), P = jc({
        refetchOnReconnect: C,
        refetchOnFocus: w,
        pollingInterval: v
      });
      u(() => {
        var W, M;
        const B = (W = I.current) == null ? void 0 : W.subscriptionOptions;
        P !== B && ((M = I.current) == null || M.updateSubscriptionOptions(P));
      }, [P]);
      const F = Ot(P);
      u(() => {
        F.current = P;
      }, [P]);
      const A = Qe(function(B, W = !1) {
        let M;
        return t(() => {
          var _;
          (_ = I.current) == null || _.unsubscribe(), I.current = M = T(x(B, {
            subscriptionOptions: F.current,
            forceRefetch: !W
          })), k(B);
        }), M;
      }, [T, x]);
      return it(() => () => {
        var B;
        (B = I == null ? void 0 : I.current) == null || B.unsubscribe();
      }, []), it(() => {
        E !== Vc && !I.current && A(E, !0);
      }, [E, A]), Ee(() => [A, E], [A, E]);
    }, S = (C, {
      skip: w = !1,
      selectFromResult: v
    } = {}) => {
      const {
        select: x
      } = e.endpoints[p], T = Yp(w ? io : C, s, l.endpointDefinitions[p], p), E = Ot(), k = Ee(() => ln([x(T), (B, W) => W, (B) => T], c), [x, T]), I = Ee(() => v ? ln([k], v, {
        devModeChecks: {
          identityFunctionCheck: "never"
        }
      }) : k, [k, v]), P = r((B) => I(B, E.current), hl), F = o(), A = k(F.getState(), E.current);
      return FL(() => {
        E.current = A;
      }, [A]), P;
    };
    return {
      useQueryState: S,
      useQuerySubscription: b,
      useLazyQuerySubscription: g,
      useLazyQuery(C) {
        const [w, v] = g(C), x = S(v, {
          ...C,
          skip: v === Vc
        }), T = Ee(() => ({
          lastArg: v
        }), [v]);
        return Ee(() => [w, x, T], [w, x, T]);
      },
      useQuery(C, w) {
        const v = b(C, w), x = S(C, {
          selectFromResult: C === io || w != null && w.skip ? void 0 : VL,
          ...w
        }), {
          data: T,
          status: E,
          isLoading: k,
          isSuccess: I,
          isError: P,
          error: F
        } = x;
        return Gd({
          data: T,
          status: E,
          isLoading: k,
          isSuccess: I,
          isError: P,
          error: F
        }), Ee(() => ({
          ...x,
          ...v
        }), [x, v]);
      }
    };
  }
  function f(p) {
    return ({
      selectFromResult: b,
      fixedCacheKey: g
    } = {}) => {
      const {
        select: S,
        initiate: C
      } = e.endpoints[p], w = n(), [v, x] = Xe();
      it(() => () => {
        v != null && v.arg.fixedCacheKey || v == null || v.reset();
      }, [v]);
      const T = Qe(function($) {
        const H = w(C($, {
          fixedCacheKey: g
        }));
        return x(H), H;
      }, [w, C, g]), {
        requestId: E
      } = v || {}, k = Ee(() => S({
        fixedCacheKey: g,
        requestId: v == null ? void 0 : v.requestId
      }), [g, v, S]), I = Ee(() => b ? ln([k], b) : k, [b, k]), P = r(I, hl), F = g == null ? v == null ? void 0 : v.arg.originalArgs : void 0, A = Qe(() => {
        t(() => {
          v && x(void 0), g && w(e.internalActions.removeMutationResult({
            requestId: E,
            fixedCacheKey: g
          }));
        });
      }, [w, g, v, E]), {
        endpointName: B,
        data: W,
        status: M,
        isLoading: _,
        isSuccess: O,
        isError: R,
        error: N
      } = P;
      Gd({
        endpointName: B,
        data: W,
        status: M,
        isLoading: _,
        isSuccess: O,
        isError: R,
        error: N
      });
      const L = Ee(() => ({
        ...P,
        originalArgs: F,
        reset: A
      }), [P, F, A]);
      return Ee(() => [T, L], [T, L]);
    };
  }
}
function LL(e) {
  return e.type === "query";
}
function BL(e) {
  return e.type === "mutation";
}
function Lc(e) {
  return e.replace(e[0], e[0].toUpperCase());
}
function Ls(e, ...t) {
  return Object.assign(e, ...t);
}
function zL(e) {
  let t = 0;
  for (const n in e)
    t++;
  return t;
}
var WL = /* @__PURE__ */ Symbol(), qL = ({
  batch: e = ej,
  hooks: t = {
    useDispatch: ob,
    useSelector: Ss,
    useStore: rb
  },
  unstable__sideEffectsInRender: n = !1,
  ...r
} = {}) => {
  if (process.env.NODE_ENV !== "production") {
    const o = ["useDispatch", "useSelector", "useStore"];
    let i = !1;
    for (const s of o)
      if (zL(r) > 0 && (r[s] && (i || (console.warn("As of RTK 2.0, the hooks now need to be specified as one object, provided under a `hooks` key:\n`reactHooksModule({ hooks: { useDispatch, useSelector, useStore } })`"), i = !0)), t[s] = r[s]), typeof t[s] != "function")
        throw new Error(process.env.NODE_ENV === "production" ? _t(36) : `When using custom hooks for context, all ${o.length} hooks need to be provided: ${o.join(", ")}.
Hook ${s} was either not provided or not a function.`);
  }
  return {
    name: WL,
    init(o, {
      serializeQueryArgs: i
    }, s) {
      const l = o, {
        buildQueryHooks: u,
        buildMutationHook: c,
        usePrefetch: d
      } = jL({
        api: o,
        moduleOptions: {
          batch: e,
          hooks: t,
          unstable__sideEffectsInRender: n
        },
        serializeQueryArgs: i,
        context: s
      });
      return Ls(l, {
        usePrefetch: d
      }), Ls(s, {
        batch: e
      }), {
        injectEndpoint(m, f) {
          if (LL(f)) {
            const {
              useQuery: p,
              useLazyQuery: b,
              useLazyQuerySubscription: g,
              useQueryState: S,
              useQuerySubscription: C
            } = u(m);
            Ls(l.endpoints[m], {
              useQuery: p,
              useLazyQuery: b,
              useLazyQuerySubscription: g,
              useQueryState: S,
              useQuerySubscription: C
            }), o[`use${Lc(m)}Query`] = p, o[`useLazy${Lc(m)}Query`] = b;
          } else if (BL(f)) {
            const p = c(m);
            Ls(l.endpoints[m], {
              useMutation: p
            }), o[`use${Lc(m)}Mutation`] = p;
          }
        }
      };
    }
  };
}, Wd = /* @__PURE__ */ SL($L(), qL());
function HL(e) {
  return e.slice(0, 1).toUpperCase() + e.slice(1, e.length);
}
function vl(e, t) {
  return e.split(t).map((n) => HL(n)).join(" ");
}
var Db = /* @__PURE__ */ ((e) => (e.SUPPORT = "SUPPORT", e.FEEDBACK = "FEEDBACK", e.ERROR = "ERROR", e))(Db || {}), qo = /* @__PURE__ */ ((e) => (e.CHARGERS = "chargers", e.VEHICLES = "vehicles", e.BOTH = "both", e))(qo || {});
const UL = {
  type: {
    attrId: "type",
    attrLabel: "type"
  },
  subtype: {
    attrId: "subtype",
    attrLabel: "subtype"
  },
  handle: {
    attrId: "handle",
    attrLabel: "name"
  }
}, YL = {
  ice: {
    fuel: "gas,diesel"
  },
  ev: {
    fuel: "BEV"
    // PHEV
  }
};
function GL({ postcode: e, mode: t }) {
  return t === qo.BOTH ? wn("/commercial/incentives", { postcode: e }) : wn("/commercial/incentives", { postcode: e, incentive_focus: t });
}
function KL(e, t) {
  let n = e;
  if (t !== qo.BOTH) {
    const r = qo.CHARGERS ? qo.VEHICLES : qo.CHARGERS;
    n = e.filter((o) => {
      var i;
      return !((i = o.incentive_focus) != null && i.includes(r));
    });
  }
  return n.map(({ grantor_type: r, incentive_nature: o, ...i }) => ({
    ...i,
    grantor_type: vl(r, "_"),
    incentive_nature: vl(o, "_")
  }));
}
const ZL = (e) => ({
  ...e,
  // converting fuel cost from cent/kWh to $/kWh
  regional_fuel_cost: e.regional_fuel_cost.map((t) => ({
    ...t,
    commercial_electricity: (t.commercial_electricity ?? 0) / 100
  })),
  // converting tax from percent to fraction
  regional_financial_references: e.regional_financial_references.map((t) => {
    var n;
    return {
      ...t,
      sales_tax: {
        ...t.sales_tax,
        combined: (((n = t.sales_tax) == null ? void 0 : n.combined) ?? 0) / 100
      }
    };
  })
}), QL = (e) => e.map(({ value: t, display_name: n, description: r }) => ({
  id: t,
  label: n,
  description: r
})), Wt = {
  PASSENGER: "Passenger",
  COMMERCIAL: "Commercial",
  TRU: "TRU",
  BEV_DRIVE_SYSTEM: "BEV Drive System"
}, JL = {
  // for vehicles they are first letter Uppercase
  Sedan: Wt.PASSENGER,
  Crossover: Wt.PASSENGER,
  SUV: Wt.PASSENGER,
  Hatchback: Wt.PASSENGER,
  Coupe: Wt.PASSENGER,
  Minivan: Wt.PASSENGER,
  "Station Wagon": Wt.PASSENGER,
  // for archetypes they are lowercase
  sedan: Wt.PASSENGER,
  crossover: Wt.PASSENGER,
  suv: Wt.PASSENGER,
  hatchback: Wt.PASSENGER,
  coupe: Wt.PASSENGER,
  minivan: Wt.PASSENGER,
  "station wagon": Wt.PASSENGER,
  // tru acronym
  tru: Wt.TRU,
  // bev drive system
  bev_drive_system: Wt.BEV_DRIVE_SYSTEM
}, Gp = 1.609344, XL = {
  "kwh per km": 100 * Gp,
  "kwh per mile": 100,
  "kwh per 100 miles": 1,
  "kwh per 100 km": Gp,
  "kwh per hour": 1
};
function Pb({ form_factor: e }) {
  return JL[e] || vl(e, "_");
}
function Ob(e) {
  return Pb(e) === Wt.PASSENGER;
}
function e2(e) {
  const { form_factor: t, subtype: n } = e;
  return Ob(e) ? vl(t, " ") : n;
}
function kb(e) {
  const { model: t, trim: n, model_year: r } = e, o = `${t || ""} ${n || ""}`.trim();
  return Ob(e) && r ? o.concat(` (${r})`) : o;
}
function t2(e) {
  return `${e.make || ""} ${kb(e)}`.trim();
}
function n2(e) {
  var t, n;
  return (n = (t = e.images) == null ? void 0 : t.find(({ url_thumbnail: r }) => r)) == null ? void 0 : n.url_full;
}
function Mb({
  electric_efficiency_unit: e,
  electric_efficiency: t
}) {
  return (XL[e] || 100) * (t ?? 1);
}
function r2(e) {
  return Mb(e);
}
function o2({ ac_charging_power: e, battery_capacity: t }) {
  const n = Math.min(e ?? 0, 7.7) * 0.85;
  return n && t ? t / n : null;
}
function i2({ dc_charging_power: e, battery_capacity: t }) {
  return e && t ? t / e * 1.15 : null;
}
function a2(e) {
  return 33.7 / (Mb(e) / 100);
}
function s2(e) {
  return l2(e, "ev");
}
function l2(e, t) {
  return {
    ...e,
    kind: t,
    image_url: n2(e),
    model: kb(e),
    name: t2(e),
    type: Pb(e),
    subtype: e2(e),
    electric_efficiency: r2(e),
    ac_time_to_full_charge: o2(e),
    dc_time_to_full_charge: i2(e),
    miles_per_galon_e: a2(e)
  };
}
const c2 = (e) => e.map(s2), u2 = process.env.REACT_APP_ZR_API_URL, d2 = process.env.REACT_APP_ZR_API_GATEWAY_URL, f2 = [
  "location",
  "vehicles",
  "vehicles-aggregation",
  "electric-vehicles",
  "fossil-vehicles",
  "archetypes",
  "generic-vehicles",
  "organization-types",
  "chargers",
  "chargers-aggregation",
  "incentives",
  "suppliers",
  "postcodes",
  "mappings"
], p2 = jd({
  baseUrl: u2,
  prepareHeaders(e, { getState: t, endpoint: n }) {
    var o;
    const r = process.env.REACT_APP_COMMON_TOKEN ?? ((o = t().config.config) == null ? void 0 : o.settings.tokens.common);
    return n === "sendNotification" ? e.set("x-api-key", r) : e.set("Authorization", `Bearer ${r}`), e;
  }
}), Su = Wd({
  reducerPath: "baseApi",
  keepUnusedDataFor: 3600,
  // cache timeout
  tagTypes: f2,
  baseQuery: p2,
  endpoints: (e) => ({
    getLocationByPostcode: e.query({
      query: (t) => wn("/location", { postcode: t }),
      transformResponse: (t) => ZL(t.location),
      providesTags: (t, n, r) => [{ type: "location", postcode: r }]
    }),
    // TODO: migrate to unified API once it works
    getEVsByPostcode: e.query({
      query: (t) => wn("/commercial/vehicles", { postcode: t, fuel_type: "BEV" }),
      transformResponse: (t) => c2(t.vehicles),
      providesTags: (t, n, r) => [{ type: "electric-vehicles", postcode: r }]
    }),
    // TODO: migrate to unified API once it works
    getGenericVehicles: e.query({
      query: () => "archetype-vehicles",
      transformResponse: (t) => t.archetypes,
      providesTags: ["generic-vehicles"]
    }),
    getOrganizationTypes: e.query({
      query: (t) => wn("/organization-types", { values: t }),
      transformResponse: (t) => QL(t["organization-types"]),
      providesTags: ["organization-types"]
    }),
    getChargers: e.query({
      query: (t) => wn("/unified-chargers", t || { types: "archetypes" }),
      transformResponse: (t) => zV(t.chargers, "charger_id"),
      providesTags: ["chargers"]
    }),
    getChargersAggregation: e.query({
      query: (t) => wn("/unified-chargers/aggregation", {
        attrId: "charger_id",
        attrLabel: "label",
        types: "archetypes",
        ...t || void 0
      }),
      transformResponse: (t) => t.aggregation,
      providesTags: (t, n, r) => [{ type: "chargers-aggregation", filters: r }]
    }),
    sendNotification: e.mutation({
      query: ({ integration_id: t, ...n }) => ({
        url: `${d2}/consumer`,
        method: "POST",
        body: {
          integration_id: t,
          ...n
        }
      })
    }),
    getCommercialIncentives: e.query({
      query: (t) => GL(t),
      transformResponse: (t, n, { mode: r }) => KL(t.incentives, r),
      providesTags: (t, n, { mode: r }) => [{ type: "incentives", mode: r }]
    }),
    getPowerSuppliers: e.query({
      query: ({ postcode: t, includeRates: n }) => wn(
        "/powersuppliers",
        n ? { postcode: t, include_rates: "true" } : { postcode: t }
      ),
      transformResponse: (t) => t.suppliers,
      providesTags: (t, n, r) => [{ type: "suppliers", postcode: r }]
    }),
    getPostcodesBySupplier: e.query({
      query: (t) => wn("/powersupplierspostcodes", { suppliers: t.join(",") }),
      transformResponse: (t) => t.postcodes,
      providesTags: (t, n, r) => [{ type: "postcodes", suppliers: r }]
    }),
    getVehicles: e.query({
      query: ({ postcode: t, handle: n }) => wn("/commercial/unified-vehicles", { postcode: t, handle: n }),
      transformResponse: (t) => t.vehicles,
      providesTags: (t, n, { postcode: r, handle: o }) => [{ type: "vehicles", postcode: r, handle: o }]
    }),
    getVehiclesAggregation: e.query({
      query: ({ variant: t, kind: n, ...r }) => wn("/commercial/unified-vehicles/aggregate", {
        ...UL[t],
        ...YL[n],
        ...r
      }),
      transformResponse: (t) => t.vehicles,
      providesTags: (t, n, r) => [{ type: "vehicles-aggregation", params: r }]
    }),
    getVehiclesMapping: e.query({
      query: (t) => wn("/commercial/unified-vehicles/mappings", t),
      transformResponse: (t) => t.mappings[0],
      providesTags: (t, n, r) => [{ type: "mappings", params: r }]
    })
  })
});
bl("baseApi/getValidationPostcodes", async (e, { dispatch: t, rejectWithValue: n }) => {
  var r;
  try {
    const i = (r = (await t(
      Su.endpoints.getPowerSuppliers.initiate({ postcode: e })
    )).data) == null ? void 0 : r.map((l) => l.name);
    if (!(i != null && i.length))
      return n({ message: "No suppliers found" });
    const { data: s } = await t(
      Su.endpoints.getPostcodesBySupplier.initiate(i)
    );
    return {
      address: {
        postcode: e,
        powerSupplier: {
          name: i[0]
        }
      },
      availablePostcodes: s
    };
  } catch (o) {
    return n(o);
  }
});
const {
  useGetLocationByPostcodeQuery: WY,
  useLazyGetLocationByPostcodeQuery: qY,
  useGetEVsByPostcodeQuery: HY,
  useGetGenericVehiclesQuery: UY,
  useLazyGetOrganizationTypesQuery: YY,
  useGetChargersQuery: GY,
  useGetChargersAggregationQuery: KY,
  useLazyGetChargersAggregationQuery: ZY,
  useSendNotificationMutation: m2,
  useLazyGetCommercialIncentivesQuery: QY,
  useGetCommercialIncentivesQuery: h2,
  useGetVehiclesQuery: JY,
  useGetVehiclesAggregationQuery: XY,
  useLazyGetVehiclesAggregationQuery: eG,
  useGetVehiclesMappingQuery: tG
} = Su, Bs = (e) => Object.entries(e).reduce(
  (t, [
    ,
    {
      value: n,
      i18n: { fallback: r }
    }
  ]) => (t.push({ id: n, label: r }), t),
  []
), g2 = (e) => Object.entries(e == null ? void 0 : e.suppliers).reduce((t, [, { id: n, name: r, rates: o = [] }]) => (t.push({ id: n, name: r, rates: o }), t), []), y2 = process.env.REACT_APP_ZR_JSON_API_BASE_URL, b2 = process.env.REACT_APP_ZR_JSON_ORGANIZATION_TYPES, v2 = process.env.REACT_APP_ZR_JSON_OPERATION_DAYS, C2 = process.env.REACT_APP_ZR_JSON_OPERATION_MONTHS, w2 = process.env.REACT_APP_ZR_JSON_CHARGING_WINDOWS_HOURS, x2 = process.env.REACT_APP_ZR_API_URL, S2 = jd({
  baseUrl: y2,
  prepareHeaders(e, { getState: t, endpoint: n }) {
    var o, i;
    const r = {
      common: process.env.REACT_APP_COMMON_TOKEN ?? ((o = t().config.config) == null ? void 0 : o.settings.tokens.common),
      json: process.env.REACT_APP_JSON_TOKEN ?? ((i = t().config.config) == null ? void 0 : i.settings.tokens.common)
    };
    return n === "getUtilitiesRatesOptions" ? e.set("Authorization", `Bearer ${r.common}`) : e.set("x-api-key", r.json), e;
  }
});
Wd({
  reducerPath: "jsonApiSlice",
  keepUnusedDataFor: 3600,
  tagTypes: [
    "OrganizationTypesOptions",
    "OperationDaysOptions",
    "OperationMonthsOptions",
    "ChargingWindowHoursOptions",
    "UtilitiesRatesOptions"
  ],
  baseQuery: S2,
  endpoints: (e) => ({
    getOrganizationTypesOptions: e.query({
      query: () => ({
        url: `getclient?key=${b2}`
      }),
      transformResponse: (t) => Bs(t),
      providesTags: ["OrganizationTypesOptions"]
    }),
    getOperationDaysOptions: e.query({
      query: () => ({
        url: `getclient?key=${v2}`
      }),
      transformResponse: (t) => Bs(t),
      providesTags: ["OperationDaysOptions"]
    }),
    getOperationMonthsOptions: e.query({
      query: () => ({
        url: `getclient?key=${C2}`
      }),
      transformResponse: (t) => Bs(t),
      providesTags: ["OperationMonthsOptions"]
    }),
    getChargingWindowHoursOptions: e.query({
      query: () => ({
        url: `getclient?key=${w2}`
      }),
      transformResponse: (t) => Bs(t),
      providesTags: ["ChargingWindowHoursOptions"]
    }),
    getUtilitiesRatesOptions: e.query({
      query: () => `${x2}/powersuppliers?include_rates`,
      transformResponse: (t) => g2(t),
      providesTags: ["UtilitiesRatesOptions"]
    })
  })
});
const T2 = process.env.REACT_APP_ZR_INCENTIVES_API_URL, Kp = jd({
  baseUrl: T2,
  prepareHeaders(e, { getState: t }) {
    var r;
    const n = process.env.REACT_APP_COMMON_TOKEN ?? ((r = t().config.config) == null ? void 0 : r.settings.tokens.common);
    return e.set("Authorization", `Bearer ${n}`), e;
  }
}), _2 = ({
  incentives: e,
  userIncentives: t,
  totalIncentives: n
}) => {
  const r = e.map((o) => {
    o.eligibility;
    const { handle: i } = o, { eligibility: s, estimatedAmount: l } = (t == null ? void 0 : t[i]) ?? {};
    return {
      ...o,
      eligibility: s ?? o.eligibility,
      estimated_amount: l ?? o.estimated_amount
    };
  });
  return n({ incentivesList: r }).totalIncentivesAvailable;
}, Bc = Wd({
  reducerPath: "incentivesApiSlice",
  keepUnusedDataFor: 3600,
  tagTypes: ["incentives"],
  baseQuery: Kp,
  endpoints: (e) => ({
    getIncentivesMetadata: e.query({
      queryFn: async ({ params: t, body: n, userIncentives: r, totalIncentives: o }, i, s) => {
        const { data: l, error: u } = await Kp(
          {
            method: "POST",
            url: "project?include_incentive_metadata",
            body: n,
            params: t
          },
          i,
          s
        );
        if (!l && u)
          return { error: u };
        const {
          evaluations: { incentives: c }
        } = l, d = _2({ incentives: c, userIncentives: r, totalIncentives: o });
        return {
          data: {
            data: c,
            total: d
          }
        };
      },
      providesTags: ["incentives"]
    })
  })
}), D2 = {
  data: [],
  total: 0,
  status: "idle"
}, P2 = dr({
  name: "incentives",
  initialState: D2,
  reducers: {
    updateIncentivesState: (e, t) => {
      e.data = t.payload.data, e.total = t.payload.total;
    }
  },
  extraReducers: (e) => {
    e.addMatcher(Bc.endpoints.getIncentivesMetadata.matchPending, (t) => {
      t.status = "loading";
    }).addMatcher(
      Bc.endpoints.getIncentivesMetadata.matchFulfilled,
      (t, { payload: n }) => {
        t.status = "success", t.data = n.data, t.total = n.total;
      }
    ).addMatcher(Bc.endpoints.getIncentivesMetadata.matchRejected, (t) => {
      t.status = "error";
    });
  }
}), O2 = (e) => e.incentives;
ln(O2, (e) => e);
P2.actions;
const k2 = (e, { payload: t }) => {
  e.isActive = t;
}, M2 = dr({
  name: "globalLoader",
  initialState: {
    isActive: !0
  },
  reducers: {
    updateGlobalLoadingState: k2
  }
});
M2.actions;
const Eb = ai({ isLoading: !0 }), nG = ({ isLoading: e, children: t }) => h(Eb.Provider, { value: { isLoading: e }, children: t }), E2 = () => si(Eb), Tu = MC(Or)(() => ({
  marginBottom: "0"
}));
Tu.defaultProps = {
  width: "100%",
  height: "100%"
};
function Ib({ children: e, skeletonStyles: t, ...n }) {
  const { isLoading: r } = E2();
  return ct.isValidElement(e) ? J(Dt, { children: [r && h(Xo, { appear: r, in: r, children: h(Ie, { gridTemplateRows: "1fr", ...e.props, ...n, children: ct.Children.map(e.props.children, (o) => {
    if (o.props.children) {
      const { children: i, ...s } = o.props;
      return ct.cloneElement(o, {
        ...s
      }, ct.Children.map(i, (l) => h(Tu, { sx: t, children: ct.cloneElement(l) })));
    }
    return h(Tu, { sx: t, children: ct.cloneElement(o) });
  }) }) }), !r && h(Xo, { appear: !r, in: !r, timeout: 500, children: e })] }) : null;
}
const rG = Object.assign(({ children: e, skeletonStyles: t, ...n }) => h(Ib, { skeletonStyles: t, children: h(Ie, { ...n, children: e }) }), {
  displayName: "LoadingContainer"
});
function I2({ title: e, subtitle: t, isMain: n = !0 }) {
  const r = typeof e == "string", o = typeof t == "string";
  return e || t ? h(Je, { container: !0, children: J(Je, { item: !0, xs: 12, children: [e && r && h(ve, { variant: n ? "h1" : "h3", gutterBottom: n, children: e }), e && !r && e, t && o && h(ve, { "data-testid": n ? "subtitle" : void 0, children: t }), t && !o && t] }) }) : null;
}
const Rb = ({ children: e, variant: t = "h1", ...n }) => h(Dt, { children: e && typeof e == "string" ? h(ve, { variant: t, gutterBottom: !0, sx: { whiteSpace: "pre-line" }, ...n, children: e }) : e }), R2 = (e) => h(Rb, { variant: "body1", ...e }), Na = 4, Zp = 5, _u = 6, A2 = 6, Qp = 8, $2 = 8, N2 = Q(({ children: e, className: t, role: n, ...r }) => h(Ie, { className: t, role: n, ...r, children: e }), { shouldForwardProp: (e) => e !== "columnWidths" })(({ theme: e, spaced: t, mb: n, mt: r, rowGap: o, cols: i = 2, columnGap: s, alignRight: l, columnWidths: u, fullbleedLastChild: c }) => ({
  display: "grid",
  justifyContent: "start",
  gridTemplateColumns: u ? u.join(" ") : `repeat(${i}, 1fr)`,
  columnGap: e.spacing(s ?? A2),
  rowGap: e.spacing(o ?? _u),
  "&&": {
    marginBottom: n || t && e.spacing(Na),
    ...r && { marginTop: r }
  },
  ...l && {
    justifyContent: "end",
    columnGap: e.spacing(s ?? 4)
  },
  ...c && {
    "& > *:last-child:nth-of-type(odd)": {
      gridColumn: "1 / -1"
    }
  },
  [e.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
    columnGap: 0,
    rowGap: e.spacing(o ?? _u)
  }
})), oG = ({ children: e, title: t, subtitle: n, divider: r }) => J(Ie, { direction: "column", gap: Zp, mt: Na * (n ? 1 : 2), mb: Na, children: [h(I2, { title: t, subtitle: n, isMain: !1 }), h(Ie, { direction: "column", spacing: Na, gap: Zp, children: e }), r && h(kt, {})] }), F2 = Q(({ children: e, ...t }) => h(Ib, { ...t, children: h(Ie, { ...t, children: e }) }))(({ theme: e, rowGap: t }) => ({
  rowGap: e.spacing(t ?? _u)
})), V2 = Q(kt)(({ theme: e }) => ({
  marginTop: e.spacing(Qp),
  marginBottom: e.spacing(Qp)
})), j2 = Q(Be)(({ theme: e, my: t = $2 }) => ({
  marginTop: e.spacing(Number(t)),
  marginBottom: e.spacing(Number(t))
})), L2 = (e) => h(Rb, { variant: "h3", ...e }), Kt = ({ children: e, ...t }) => h(Ie, { rowGap: Na, ...t, children: e });
Kt.Title = L2;
Kt.SubTitle = R2;
Kt.Content = F2;
Kt.Divider = V2;
Kt.Row = N2;
Kt.Spacer = j2;
const Ab = Q(xo)(({ theme: e }) => ({
  "&": {
    position: "absolute",
    right: e.spacing(-6),
    cursor: "default",
    pointerEvents: "auto"
  }
})), B2 = ({ TooltipProps: e, ...t }) => {
  const { title: n, IconProps: r, ...o } = e ?? {};
  return h(z2, { hasTootipContent: !!n, children: h(us, { ...t, InputProps: {
    ...n && {
      endAdornment: h(Ab, { title: n, IconProps: r, ...o })
    },
    ...t.InputProps
  } }) });
}, z2 = Q(Be, {
  shouldForwardProp: (e) => e != "hasTootipContent"
})(({ hasTootipContent: e, theme: t }) => ({
  ...e && { paddingRight: t.spacing(6) }
}));
B2.displayName = "TextField";
const mr = ({ TooltipProps: e, ...t }) => {
  const { title: n, IconProps: r, ...o } = e ?? {};
  return h(W2, { hasTootipContent: !!n, ...t, InputProps: {
    ...n && {
      endAdornment: h(Ab, { title: n, IconProps: r, ...o })
    },
    ...t.InputProps
  } });
}, W2 = Q(Ey, {
  shouldForwardProp: (e) => e != "hasTootipContent"
})(({ hasTootipContent: e, theme: t }) => ({
  ...e && { paddingRight: t.spacing(6) }
}));
mr.displayName = "FormTextField";
var Jp = function(e, t, n) {
  if (e && "reportValidity" in e) {
    var r = Kc(n, t);
    e.setCustomValidity(r && r.message || ""), e.reportValidity();
  }
}, $b = function(e, t) {
  var n = function(o) {
    var i = t.fields[o];
    i && i.ref && "reportValidity" in i.ref ? Jp(i.ref, o, e) : i.refs && i.refs.forEach(function(s) {
      return Jp(s, o, e);
    });
  };
  for (var r in t.fields)
    n(r);
}, q2 = function(e, t) {
  t.shouldUseNativeValidation && $b(e, t);
  var n = {};
  for (var r in e) {
    var o = Kc(t.fields, r), i = Object.assign(e[r] || {}, { ref: o && o.ref });
    if (H2(t.names || Object.keys(e), r)) {
      var s = Object.assign({}, Kc(n, r));
      pc(s, "root", i), pc(n, r, s);
    } else
      pc(n, r, i);
  }
  return n;
}, H2 = function(e, t) {
  return e.some(function(n) {
    return n.startsWith(t + ".");
  });
}, U2 = function(e, t) {
  for (var n = {}; e.length; ) {
    var r = e[0], o = r.code, i = r.message, s = r.path.join(".");
    if (!n[s])
      if ("unionErrors" in r) {
        var l = r.unionErrors[0].errors[0];
        n[s] = { message: l.message, type: l.code };
      } else
        n[s] = { message: i, type: o };
    if ("unionErrors" in r && r.unionErrors.forEach(function(d) {
      return d.errors.forEach(function(m) {
        return e.push(m);
      });
    }), t) {
      var u = n[s].types, c = u && u[r.code];
      n[s] = dC(s, t, n, o, c ? [].concat(c, r.message) : r.message);
    }
    e.shift();
  }
  return n;
}, Os = function(e, t, n) {
  return n === void 0 && (n = {}), function(r, o, i) {
    try {
      return Promise.resolve(function(s, l) {
        try {
          var u = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(c) {
            return i.shouldUseNativeValidation && $b({}, i), { errors: {}, values: n.raw ? r : c };
          });
        } catch (c) {
          return l(c);
        }
        return u && u.then ? u.then(void 0, l) : u;
      }(0, function(s) {
        if (function(l) {
          return l.errors != null;
        }(s))
          return { values: {}, errors: q2(U2(s.errors, !i.shouldUseNativeValidation && i.criteriaMode === "all"), i) };
        throw s;
      }));
    } catch (s) {
      return Promise.reject(s);
    }
  };
};
function ks({ title: e, primaryAction: t, secondaryAction: n, onClose: r, isOpen: o, primaryEnabled: i, secondaryEnabled: s, primaryButtonLabel: l, secondaryButtonLabel: u, children: c, showCloseButton: d, closeButtonEnabled: m, CloseButtonIcon: f, primaryButtonProps: p, secondaryButtonProps: b, ...g }) {
  const S = f || Nl, C = Ee(() => {
    if (n && u || t && l)
      return J(Km, { children: [n && u && h(tr, { ...b, onClick: n, disabled: !s, "data-testid": "modal-secondary-action", children: u }), t && l && h(wo, { color: "primary", variant: "contained", ...p, onClick: t, disabled: !i, fullWidth: !0, "data-testid": "modal-primary-action", children: l })] });
  }, [
    t,
    l,
    p,
    i,
    n,
    u,
    b,
    s
  ]);
  return J(Qm, { ...g, open: o, onClose: r, children: [J(EC, { children: [e, d && r && h(tn, { onClick: r, disabled: !m, children: h(S, {}) })] }), h(Zm, { dividers: !0, children: c }), C] });
}
ks.defaultProps = {
  showCloseButton: !0,
  isOpen: !1,
  primaryEnabled: !0,
  secondaryEnabled: !0,
  closeButtonEnabled: !0
};
function qd({ title: e, isOpen: t, isSubmitting: n, isSuccess: r, isError: o, defaultValues: i, children: s, schema: l, secondaryButtonLabel: u, primaryButtonLabelValues: c, onClose: d, onSubmit: m }) {
  const [f] = Ke(), p = Ee(() => {
    const { fallback: w = f("send"), success: v = f("success"), error: x = f("retry"), loading: T = f("sending") } = c ?? {};
    return o ? x : n ? T : r ? v : w;
  }, [o, n, r, c, f]), b = ui({
    values: i,
    resolver: Os(l),
    mode: "onChange"
  }), g = (w) => {
    r || m(w);
  }, S = () => {
    n || (d(), b.reset());
  }, C = Ee(() => r ? f("close") : u ?? f("cancel"), [r, u, f]);
  return J(ks, { title: e, isOpen: t, onClose: S, secondaryAction: S, secondaryButtonLabel: C, secondaryEnabled: !n, primaryButtonLabel: p, primaryAction: () => b.handleSubmit(g)(), primaryEnabled: b.formState.isValid && !n && !r, primaryButtonProps: { loading: n }, disableEscapeKeyDown: !0, children: [h(ws, { onSuccess: g, formContext: b, children: s }), o ? h(ve, { color: "error", children: f("error") }) : null] });
}
const Y2 = oe.object({
  name: oe.string().max(40).nonempty(),
  email: oe.string().email().nonempty(),
  subject: oe.string().max(55).nonempty(),
  issueDescription: oe.string().max(500).nonempty()
});
function G2({ isOpen: e, isSubmitting: t, isSuccess: n, isError: r, defaultValues: o, onClose: i, onSubmit: s }) {
  const [l] = Ke(["components.supportModal"]);
  return h(qd, { title: l("title"), isOpen: e, onClose: i, isSubmitting: t, isSuccess: n, isError: r, defaultValues: o, onSubmit: s, schema: Y2, children: J(Kt, { children: [h(mr, { name: "name", label: l("name"), disabled: n, inputProps: { "aria-label": "user name" } }), h(mr, { name: "email", label: l("email"), disabled: n, inputProps: { "aria-label": "user email" } }), h(mr, { name: "subject", label: l("subject"), disabled: n, inputProps: { "aria-label": "support request subject" } }), h(mr, { name: "issueDescription", multiline: !0, rows: 4, label: l("issueDescription"), disabled: n, inputProps: { "aria-label": "support request description" } })] }) });
}
function K2(e) {
  const [t, n] = Xe(!1), r = nL("pubSub.destination"), { email: o = "", sub: i = "", family_name: s = "", given_name: l = "" } = (e == null ? void 0 : e.attributes) ?? {}, u = `${l.trim()} ${s.trim()}`, [c, { isLoading: d, isSuccess: m, isError: f, reset: p }] = m2();
  return {
    isError: f,
    isSuccess: m,
    isOpen: t,
    isSubmitting: d,
    defaultValues: { name: u, email: o },
    openSupportModal: () => n(!0),
    onSubmit: async (C) => {
      await c({
        integration_id: Db.SUPPORT,
        input_id: i,
        destination: r,
        ...C
      });
    },
    onClose: () => {
      p(), n(!1);
    }
  };
}
function Z2({ SupportModalProps: e, onClick: t }) {
  const n = Vd("contactUs", {}), { openSupportModal: r, ...o } = K2(e == null ? void 0 : e.userInfo), { isAllowed: i } = fi(), s = i("show", "app", "supportModal");
  return J(Dt, { children: [h(BV, { ...n, onClick: (u) => {
    u.stopPropagation(), s && (u.preventDefault(), r()), t == null || t(u);
  } }), s ? h(G2, { ...o }) : null] });
}
const Q2 = Q(tr)({
  position: "absolute",
  left: 0
});
function iG({ returnUrl: e, title: t, subtitle: n, children: r }) {
  const [o] = Ke();
  return J(Ie, { position: "relative", children: [e ? h(Q2, { component: Qo, replace: !0, to: e, startIcon: h(th, { fontSize: "small" }), "data-testid": "catalog-return-button", children: o("back") }) : null, J(Ie, { textAlign: "center", mb: 6, children: [t ? h(ve, { "data-testid": "catalog-title", variant: "h1", children: t }) : null, n ? h(ve, { "data-testid": "catalog-subtitle", children: n }) : null] }), r] });
}
const Nb = (e) => {
  const { title: t, IconProps: n, ...r } = e.TooltipProps ?? {};
  return J(kr, { children: [e.children, t ? h(J2, { title: t, IconProps: n, ...r }) : null] });
}, J2 = Q(xo)(({ theme: e }) => ({
  position: "absolute",
  right: e.spacing(-6),
  cursor: "default",
  pointerEvents: "auto"
})), X2 = "YYYY-MM-DD";
function aG({ parseError: e, name: t, required: n, inputProps: r, control: o, textReadOnly: i, slotProps: s, TooltipProps: l, ...u }) {
  const c = Ht(), d = e || c, m = !!(l != null && l.title), f = { ...u, hasTooltip: m };
  return h(Al, { name: t, control: o, defaultValue: null, render: ({ field: p, fieldState: { error: b } }) => (typeof p.value == "string" && (p.value = Ye(p.value)), h(eB, { ...f, ...p, ref: (g) => {
    p.ref(g == null ? void 0 : g.querySelector("input"));
  }, onClose: (...g) => {
    p.onBlur(), u.onClose && u.onClose(...g);
  }, onChange: (g, S) => {
    const C = (g == null ? void 0 : g.format(X2)) ?? "";
    p.onChange(C, S), typeof u.onChange == "function" && u.onChange(C, S);
  }, slotProps: {
    ...s,
    textField: {
      ...r,
      required: n,
      error: !!b,
      helperText: b ? typeof d == "function" ? d(b) : b.message : (r == null ? void 0 : r.helperText) || u.helperText,
      inputProps: {
        readOnly: !!i,
        ...r == null ? void 0 : r.inputProps
      }
    }
  }, slots: {
    inputAdornment: (g) => h(Nb, { ...g, TooltipProps: l })
  } })) });
}
const eB = Q(vd, {
  shouldForwardProp: (e) => e !== "hasTooltip"
})(({ theme: e, hasTooltip: t }) => ({
  ".MuiInputBase-root": {
    ...t && { width: `calc(100% - ${e.spacing(6)})` }
  }
})), tB = "YYYY-MM-DD HH:mm:ss";
function sG({ parseError: e, name: t, required: n, validation: r = {}, inputProps: o, control: i, textReadOnly: s, slotProps: l, TooltipProps: u, ...c }) {
  const d = Ht(), m = e || d, f = !!(u != null && u.title), p = { ...c, hasTooltip: f };
  return n && !r.required && (r.required = "This field is required"), h(Al, { name: t, rules: r, control: i, defaultValue: "", render: ({ field: b, fieldState: { error: g } }) => (b != null && b.value && typeof (b == null ? void 0 : b.value) == "string" && (b.value = Ye(b.value)), h(nB, { ...p, ...b, ref: (S) => {
    b.ref(S == null ? void 0 : S.querySelector("input"));
  }, onClose: (...S) => {
    b.onBlur(), c.onClose && c.onClose(...S);
  }, onChange: (S, C) => {
    const w = (S == null ? void 0 : S.format(tB)) ?? "";
    b.onChange(w, C), typeof c.onChange == "function" && c.onChange(w, C);
  }, slotProps: {
    ...l,
    textField: {
      ...o,
      required: n,
      error: !!g,
      helperText: g ? typeof m == "function" ? m(g) : g.message : (o == null ? void 0 : o.helperText) || c.helperText,
      inputProps: {
        readOnly: s,
        ...o == null ? void 0 : o.inputProps
      }
    }
  }, slots: {
    inputAdornment: (S) => h(Nb, { ...S, TooltipProps: u })
  } })) });
}
const nB = Q(xd, {
  shouldForwardProp: (e) => e !== "hasTooltip"
})(({ theme: e, hasTooltip: t }) => ({
  ".MuiInputBase-root": {
    ...t && { width: `calc(100% - ${e.spacing(6)})` }
  }
}));
function lG({ disclaimerName: e, variant: t, ...n }) {
  return h(pi, { I: "show", on: "disclaimers", field: e, children: h(ve, { variant: t, ...n }) });
}
function Si(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(s) {
      s(i);
    });
  }
  return new (n || (n = Promise))(function(i, s) {
    function l(d) {
      try {
        c(r.next(d));
      } catch (m) {
        s(m);
      }
    }
    function u(d) {
      try {
        c(r.throw(d));
      } catch (m) {
        s(m);
      }
    }
    function c(d) {
      d.done ? i(d.value) : o(d.value).then(l, u);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
function Ti(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, s;
  return s = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function l(c) {
    return function(d) {
      return u([c, d]);
    };
  }
  function u(c) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; s && (s = 0, c[0] && (n = 0)), n; )
      try {
        if (r = 1, o && (i = c[0] & 2 ? o.return : c[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, c[1])).done)
          return i;
        switch (o = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return n.label++, { value: c[1], done: !1 };
          case 5:
            n.label++, o = c[1], c = [0];
            continue;
          case 7:
            c = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              n = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              n.label = c[1];
              break;
            }
            if (c[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = c;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(c);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        c = t.call(e, n);
      } catch (d) {
        c = [6, d], o = 0;
      } finally {
        r = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Xp(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), o, i = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(o = r.next()).done; )
      i.push(o.value);
  } catch (l) {
    s = { error: l };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s)
        throw s.error;
    }
  }
  return i;
}
function em(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var rB = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Ms(e, t) {
  var n = oB(e);
  if (typeof n.path != "string") {
    var r = e.webkitRelativePath;
    Object.defineProperty(n, "path", {
      value: typeof t == "string" ? t : typeof r == "string" && r.length > 0 ? r : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return n;
}
function oB(e) {
  var t = e.name, n = t && t.lastIndexOf(".") !== -1;
  if (n && !e.type) {
    var r = t.split(".").pop().toLowerCase(), o = rB.get(r);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var iB = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function aB(e) {
  return Si(this, void 0, void 0, function() {
    return Ti(this, function(t) {
      return Cl(e) && sB(e.dataTransfer) ? [2, dB(e.dataTransfer, e.type)] : lB(e) ? [2, cB(e)] : Array.isArray(e) && e.every(function(n) {
        return "getFile" in n && typeof n.getFile == "function";
      }) ? [2, uB(e)] : [2, []];
    });
  });
}
function sB(e) {
  return Cl(e);
}
function lB(e) {
  return Cl(e) && Cl(e.target);
}
function Cl(e) {
  return typeof e == "object" && e !== null;
}
function cB(e) {
  return Du(e.target.files).map(function(t) {
    return Ms(t);
  });
}
function uB(e) {
  return Si(this, void 0, void 0, function() {
    var t;
    return Ti(this, function(n) {
      switch (n.label) {
        case 0:
          return [4, Promise.all(e.map(function(r) {
            return r.getFile();
          }))];
        case 1:
          return t = n.sent(), [2, t.map(function(r) {
            return Ms(r);
          })];
      }
    });
  });
}
function dB(e, t) {
  return Si(this, void 0, void 0, function() {
    var n, r;
    return Ti(this, function(o) {
      switch (o.label) {
        case 0:
          return e.items ? (n = Du(e.items).filter(function(i) {
            return i.kind === "file";
          }), t !== "drop" ? [2, n] : [4, Promise.all(n.map(fB))]) : [3, 2];
        case 1:
          return r = o.sent(), [2, tm(Fb(r))];
        case 2:
          return [2, tm(Du(e.files).map(function(i) {
            return Ms(i);
          }))];
      }
    });
  });
}
function tm(e) {
  return e.filter(function(t) {
    return iB.indexOf(t.name) === -1;
  });
}
function Du(e) {
  if (e === null)
    return [];
  for (var t = [], n = 0; n < e.length; n++) {
    var r = e[n];
    t.push(r);
  }
  return t;
}
function fB(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return nm(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? Vb(t) : nm(e);
}
function Fb(e) {
  return e.reduce(function(t, n) {
    return em(em([], Xp(t), !1), Xp(Array.isArray(n) ? Fb(n) : [n]), !1);
  }, []);
}
function nm(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var n = Ms(t);
  return Promise.resolve(n);
}
function pB(e) {
  return Si(this, void 0, void 0, function() {
    return Ti(this, function(t) {
      return [2, e.isDirectory ? Vb(e) : mB(e)];
    });
  });
}
function Vb(e) {
  var t = e.createReader();
  return new Promise(function(n, r) {
    var o = [];
    function i() {
      var s = this;
      t.readEntries(function(l) {
        return Si(s, void 0, void 0, function() {
          var u, c, d;
          return Ti(this, function(m) {
            switch (m.label) {
              case 0:
                if (l.length)
                  return [3, 5];
                m.label = 1;
              case 1:
                return m.trys.push([1, 3, , 4]), [4, Promise.all(o)];
              case 2:
                return u = m.sent(), n(u), [3, 4];
              case 3:
                return c = m.sent(), r(c), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                d = Promise.all(l.map(pB)), o.push(d), i(), m.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(l) {
        r(l);
      });
    }
    i();
  });
}
function mB(e) {
  return Si(this, void 0, void 0, function() {
    return Ti(this, function(t) {
      return [2, new Promise(function(n, r) {
        e.file(function(o) {
          var i = Ms(o, e.fullPath);
          n(i);
        }, function(o) {
          r(o);
        });
      })];
    });
  });
}
var hB = function(e, t) {
  if (e && t) {
    var n = Array.isArray(t) ? t : t.split(","), r = e.name || "", o = (e.type || "").toLowerCase(), i = o.replace(/\/.*$/, "");
    return n.some(function(s) {
      var l = s.trim().toLowerCase();
      return l.charAt(0) === "." ? r.toLowerCase().endsWith(l) : l.endsWith("/*") ? i === l.replace(/\/.*$/, "") : o === l;
    });
  }
  return !0;
};
function rm(e) {
  return bB(e) || yB(e) || Lb(e) || gB();
}
function gB() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yB(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function bB(e) {
  if (Array.isArray(e))
    return Pu(e);
}
function om(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function im(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? om(Object(n), !0).forEach(function(r) {
      jb(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : om(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function jb(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ls(e, t) {
  return wB(e) || CB(e, t) || Lb(e, t) || vB();
}
function vB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lb(e, t) {
  if (e) {
    if (typeof e == "string")
      return Pu(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Pu(e, t);
  }
}
function Pu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function CB(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, s, l;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (u) {
      i = !0, l = u;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return r;
  }
}
function wB(e) {
  if (Array.isArray(e))
    return e;
}
var xB = "file-invalid-type", SB = "file-too-large", TB = "file-too-small", _B = "too-many-files", DB = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var n = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: xB,
    message: "File type must be ".concat(n)
  };
}, am = function(t) {
  return {
    code: SB,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, sm = function(t) {
  return {
    code: TB,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, PB = {
  code: _B,
  message: "Too many files"
};
function Bb(e, t) {
  var n = e.type === "application/x-moz-file" || hB(e, t);
  return [n, n ? null : DB(t)];
}
function zb(e, t, n) {
  if (ro(e.size))
    if (ro(t) && ro(n)) {
      if (e.size > n)
        return [!1, am(n)];
      if (e.size < t)
        return [!1, sm(t)];
    } else {
      if (ro(t) && e.size < t)
        return [!1, sm(t)];
      if (ro(n) && e.size > n)
        return [!1, am(n)];
    }
  return [!0, null];
}
function ro(e) {
  return e != null;
}
function OB(e) {
  var t = e.files, n = e.accept, r = e.minSize, o = e.maxSize, i = e.multiple, s = e.maxFiles, l = e.validator;
  return !i && t.length > 1 || i && s >= 1 && t.length > s ? !1 : t.every(function(u) {
    var c = Bb(u, n), d = ls(c, 1), m = d[0], f = zb(u, r, o), p = ls(f, 1), b = p[0], g = l ? l(u) : null;
    return m && b && !g;
  });
}
function wl(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function zs(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function lm(e) {
  e.preventDefault();
}
function kB(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function MB(e) {
  return e.indexOf("Edge/") !== -1;
}
function EB() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return kB(e) || MB(e);
}
function Kn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
      i[s - 1] = arguments[s];
    return t.some(function(l) {
      return !wl(r) && l && l.apply(void 0, [r].concat(i)), wl(r);
    });
  };
}
function IB() {
  return "showOpenFilePicker" in window;
}
function RB(e) {
  if (ro(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = ls(n, 2), o = r[0], i = r[1], s = !0;
      return Wb(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), s = !1), (!Array.isArray(i) || !i.every(qb)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), s = !1), s;
    }).reduce(function(n, r) {
      var o = ls(r, 2), i = o[0], s = o[1];
      return im(im({}, n), {}, jb({}, i, s));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function AB(e) {
  if (ro(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = ls(n, 2), o = r[0], i = r[1];
      return [].concat(rm(t), [o], rm(i));
    }, []).filter(function(t) {
      return Wb(t) || qb(t);
    }).join(",");
}
function $B(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function NB(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Wb(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function qb(e) {
  return /^.*\.[\w]+$/.test(e);
}
var FB = ["children"], VB = ["open"], jB = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], LB = ["refKey", "onChange", "onClick"];
function BB(e) {
  return qB(e) || WB(e) || Hb(e) || zB();
}
function zB() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WB(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function qB(e) {
  if (Array.isArray(e))
    return Ou(e);
}
function zc(e, t) {
  return YB(e) || UB(e, t) || Hb(e, t) || HB();
}
function HB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Hb(e, t) {
  if (e) {
    if (typeof e == "string")
      return Ou(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Ou(e, t);
  }
}
function Ou(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function UB(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, s, l;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (u) {
      i = !0, l = u;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return r;
  }
}
function YB(e) {
  if (Array.isArray(e))
    return e;
}
function cm(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cm(Object(n), !0).forEach(function(r) {
      ku(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cm(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function ku(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function xl(e, t) {
  if (e == null)
    return {};
  var n = GB(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function GB(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var Hd = /* @__PURE__ */ Vt(function(e, t) {
  var n = e.children, r = xl(e, FB), o = Yb(r), i = o.open, s = xl(o, VB);
  return xv(t, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ ct.createElement(kr, null, n(Ct(Ct({}, s), {}, {
    open: i
  })));
});
Hd.displayName = "Dropzone";
var Ub = {
  disabled: !1,
  getFilesFromEvent: aB,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Hd.defaultProps = Ub;
Hd.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: a.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: a.objectOf(a.arrayOf(a.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: a.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: a.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: a.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: a.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: a.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: a.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: a.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: a.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: a.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: a.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: a.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: a.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: a.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: a.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: a.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: a.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: a.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: a.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: a.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: a.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: a.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: a.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: a.func
};
var Mu = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Yb() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Ct(Ct({}, Ub), e), n = t.accept, r = t.disabled, o = t.getFilesFromEvent, i = t.maxSize, s = t.minSize, l = t.multiple, u = t.maxFiles, c = t.onDragEnter, d = t.onDragLeave, m = t.onDragOver, f = t.onDrop, p = t.onDropAccepted, b = t.onDropRejected, g = t.onFileDialogCancel, S = t.onFileDialogOpen, C = t.useFsAccessApi, w = t.autoFocus, v = t.preventDropOnDocument, x = t.noClick, T = t.noKeyboard, E = t.noDrag, k = t.noDragEventsBubbling, I = t.onError, P = t.validator, F = Ee(function() {
    return AB(n);
  }, [n]), A = Ee(function() {
    return RB(n);
  }, [n]), B = Ee(function() {
    return typeof S == "function" ? S : um;
  }, [S]), W = Ee(function() {
    return typeof g == "function" ? g : um;
  }, [g]), M = Ot(null), _ = Ot(null), O = wv(KB, Mu), R = zc(O, 2), N = R[0], L = R[1], $ = N.isFocused, H = N.isFileDialogActive, G = Ot(typeof window < "u" && window.isSecureContext && C && IB()), q = function() {
    !G.current && H && setTimeout(function() {
      if (_.current) {
        var ye = _.current.files;
        ye.length || (L({
          type: "closeDialog"
        }), W());
      }
    }, 300);
  };
  it(function() {
    return window.addEventListener("focus", q, !1), function() {
      window.removeEventListener("focus", q, !1);
    };
  }, [_, H, W, G]);
  var Y = Ot([]), Z = function(ye) {
    M.current && M.current.contains(ye.target) || (ye.preventDefault(), Y.current = []);
  };
  it(function() {
    return v && (document.addEventListener("dragover", lm, !1), document.addEventListener("drop", Z, !1)), function() {
      v && (document.removeEventListener("dragover", lm), document.removeEventListener("drop", Z));
    };
  }, [M, v]), it(function() {
    return !r && w && M.current && M.current.focus(), function() {
    };
  }, [M, w, r]);
  var ie = Qe(function(de) {
    I ? I(de) : console.error(de);
  }, [I]), X = Qe(function(de) {
    de.preventDefault(), de.persist(), K(de), Y.current = [].concat(BB(Y.current), [de.target]), zs(de) && Promise.resolve(o(de)).then(function(ye) {
      if (!(wl(de) && !k)) {
        var Te = ye.length, Re = Te > 0 && OB({
          files: ye,
          accept: F,
          minSize: s,
          maxSize: i,
          multiple: l,
          maxFiles: u,
          validator: P
        }), We = Te > 0 && !Re;
        L({
          isDragAccept: Re,
          isDragReject: We,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), c && c(de);
      }
    }).catch(function(ye) {
      return ie(ye);
    });
  }, [o, c, ie, k, F, s, i, l, u, P]), se = Qe(function(de) {
    de.preventDefault(), de.persist(), K(de);
    var ye = zs(de);
    if (ye && de.dataTransfer)
      try {
        de.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return ye && m && m(de), !1;
  }, [m, k]), fe = Qe(function(de) {
    de.preventDefault(), de.persist(), K(de);
    var ye = Y.current.filter(function(Re) {
      return M.current && M.current.contains(Re);
    }), Te = ye.indexOf(de.target);
    Te !== -1 && ye.splice(Te, 1), Y.current = ye, !(ye.length > 0) && (L({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), zs(de) && d && d(de));
  }, [M, d, k]), le = Qe(function(de, ye) {
    var Te = [], Re = [];
    de.forEach(function(We) {
      var ht = Bb(We, F), gt = zc(ht, 2), Qt = gt[0], Lt = gt[1], yt = zb(We, s, i), dn = zc(yt, 2), Dn = dn[0], bt = dn[1], $t = P ? P(We) : null;
      if (Qt && Dn && !$t)
        Te.push(We);
      else {
        var Bt = [Lt, bt];
        $t && (Bt = Bt.concat($t)), Re.push({
          file: We,
          errors: Bt.filter(function(rn) {
            return rn;
          })
        });
      }
    }), (!l && Te.length > 1 || l && u >= 1 && Te.length > u) && (Te.forEach(function(We) {
      Re.push({
        file: We,
        errors: [PB]
      });
    }), Te.splice(0)), L({
      acceptedFiles: Te,
      fileRejections: Re,
      type: "setFiles"
    }), f && f(Te, Re, ye), Re.length > 0 && b && b(Re, ye), Te.length > 0 && p && p(Te, ye);
  }, [L, l, F, s, i, u, f, p, b, P]), ce = Qe(function(de) {
    de.preventDefault(), de.persist(), K(de), Y.current = [], zs(de) && Promise.resolve(o(de)).then(function(ye) {
      wl(de) && !k || le(ye, de);
    }).catch(function(ye) {
      return ie(ye);
    }), L({
      type: "reset"
    });
  }, [o, le, ie, k]), ee = Qe(function() {
    if (G.current) {
      L({
        type: "openDialog"
      }), B();
      var de = {
        multiple: l,
        types: A
      };
      window.showOpenFilePicker(de).then(function(ye) {
        return o(ye);
      }).then(function(ye) {
        le(ye, null), L({
          type: "closeDialog"
        });
      }).catch(function(ye) {
        $B(ye) ? (W(ye), L({
          type: "closeDialog"
        })) : NB(ye) ? (G.current = !1, _.current ? (_.current.value = null, _.current.click()) : ie(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ie(ye);
      });
      return;
    }
    _.current && (L({
      type: "openDialog"
    }), B(), _.current.value = null, _.current.click());
  }, [L, B, W, C, le, ie, A, l]), ae = Qe(function(de) {
    !M.current || !M.current.isEqualNode(de.target) || (de.key === " " || de.key === "Enter" || de.keyCode === 32 || de.keyCode === 13) && (de.preventDefault(), ee());
  }, [M, ee]), _e = Qe(function() {
    L({
      type: "focus"
    });
  }, []), ue = Qe(function() {
    L({
      type: "blur"
    });
  }, []), me = Qe(function() {
    x || (EB() ? setTimeout(ee, 0) : ee());
  }, [x, ee]), De = function(ye) {
    return r ? null : ye;
  }, he = function(ye) {
    return T ? null : De(ye);
  }, Ce = function(ye) {
    return E ? null : De(ye);
  }, K = function(ye) {
    k && ye.stopPropagation();
  }, ne = Ee(function() {
    return function() {
      var de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ye = de.refKey, Te = ye === void 0 ? "ref" : ye, Re = de.role, We = de.onKeyDown, ht = de.onFocus, gt = de.onBlur, Qt = de.onClick, Lt = de.onDragEnter, yt = de.onDragOver, dn = de.onDragLeave, Dn = de.onDrop, bt = xl(de, jB);
      return Ct(Ct(ku({
        onKeyDown: he(Kn(We, ae)),
        onFocus: he(Kn(ht, _e)),
        onBlur: he(Kn(gt, ue)),
        onClick: De(Kn(Qt, me)),
        onDragEnter: Ce(Kn(Lt, X)),
        onDragOver: Ce(Kn(yt, se)),
        onDragLeave: Ce(Kn(dn, fe)),
        onDrop: Ce(Kn(Dn, ce)),
        role: typeof Re == "string" && Re !== "" ? Re : "presentation"
      }, Te, M), !r && !T ? {
        tabIndex: 0
      } : {}), bt);
    };
  }, [M, ae, _e, ue, me, X, se, fe, ce, T, E, r]), pe = Qe(function(de) {
    de.stopPropagation();
  }, []), Me = Ee(function() {
    return function() {
      var de = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ye = de.refKey, Te = ye === void 0 ? "ref" : ye, Re = de.onChange, We = de.onClick, ht = xl(de, LB), gt = ku({
        accept: F,
        multiple: l,
        type: "file",
        style: {
          display: "none"
        },
        onChange: De(Kn(Re, ce)),
        onClick: De(Kn(We, pe)),
        tabIndex: -1
      }, Te, _);
      return Ct(Ct({}, gt), ht);
    };
  }, [_, n, l, ce, r]);
  return Ct(Ct({}, N), {}, {
    isFocused: $ && !r,
    getRootProps: ne,
    getInputProps: Me,
    rootRef: M,
    inputRef: _,
    open: De(ee)
  });
}
function KB(e, t) {
  switch (t.type) {
    case "focus":
      return Ct(Ct({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Ct(Ct({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Ct(Ct({}, Mu), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Ct(Ct({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Ct(Ct({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Ct(Ct({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return Ct({}, Mu);
    default:
      return e;
  }
}
function um() {
}
/**
 * filesize
 *
 * @copyright 2023 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 10.1.0
 */
const ZB = "array", QB = "bit", dm = "bits", JB = "byte", fm = "bytes", No = "", XB = "exponent", ez = "function", pm = "iec", tz = "Invalid number", nz = "Invalid rounding method", Wc = "jedec", rz = "object", mm = ".", oz = "round", iz = "s", az = "si", sz = "kbit", lz = "kB", cz = " ", uz = "string", dz = "0", qc = {
  symbol: {
    iec: {
      bits: ["bit", "Kibit", "Mibit", "Gibit", "Tibit", "Pibit", "Eibit", "Zibit", "Yibit"],
      bytes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
    },
    jedec: {
      bits: ["bit", "Kbit", "Mbit", "Gbit", "Tbit", "Pbit", "Ebit", "Zbit", "Ybit"],
      bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    }
  },
  fullform: {
    iec: ["", "kibi", "mebi", "gibi", "tebi", "pebi", "exbi", "zebi", "yobi"],
    jedec: ["", "kilo", "mega", "giga", "tera", "peta", "exa", "zetta", "yotta"]
  }
};
function fz(e, {
  bits: t = !1,
  pad: n = !1,
  base: r = -1,
  round: o = 2,
  locale: i = No,
  localeOptions: s = {},
  separator: l = No,
  spacer: u = cz,
  symbols: c = {},
  standard: d = No,
  output: m = uz,
  fullform: f = !1,
  fullforms: p = [],
  exponent: b = -1,
  roundingMethod: g = oz,
  precision: S = 0
} = {}) {
  let C = b, w = Number(e), v = [], x = 0, T = No;
  d === az ? (r = 10, d = Wc) : d === pm || d === Wc ? r = 2 : r === 2 ? d = pm : (r = 10, d = Wc);
  const E = r === 10 ? 1e3 : 1024, k = f === !0, I = w < 0, P = Math[g];
  if (typeof e != "bigint" && isNaN(e))
    throw new TypeError(tz);
  if (typeof P !== ez)
    throw new TypeError(nz);
  if (I && (w = -w), (C === -1 || isNaN(C)) && (C = Math.floor(Math.log(w) / Math.log(E)), C < 0 && (C = 0)), C > 8 && (S > 0 && (S += 8 - C), C = 8), m === XB)
    return C;
  if (w === 0)
    v[0] = 0, T = v[1] = qc.symbol[d][t ? dm : fm][C];
  else {
    x = w / (r === 2 ? Math.pow(2, C * 10) : Math.pow(1e3, C)), t && (x = x * 8, x >= E && C < 8 && (x = x / E, C++));
    const F = Math.pow(10, C > 0 ? o : 0);
    v[0] = P(x * F) / F, v[0] === E && C < 8 && b === -1 && (v[0] = 1, C++), T = v[1] = r === 10 && C === 1 ? t ? sz : lz : qc.symbol[d][t ? dm : fm][C];
  }
  if (I && (v[0] = -v[0]), S > 0 && (v[0] = v[0].toPrecision(S)), v[1] = c[v[1]] || v[1], i === !0 ? v[0] = v[0].toLocaleString() : i.length > 0 ? v[0] = v[0].toLocaleString(i, s) : l.length > 0 && (v[0] = v[0].toString().replace(mm, l)), n && Number.isInteger(v[0]) === !1 && o > 0) {
    const F = l || mm, A = v[0].toString().split(F), B = A[1] || No, W = B.length, M = o - W;
    v[0] = `${A[0]}${F}${B.padEnd(W + M, dz)}`;
  }
  return k && (v[1] = p[C] ? p[C] : qc.fullform[d][C] + (t ? QB : JB) + (v[0] === 1 ? No : iz)), m === ZB ? v : m === rz ? {
    value: v[0],
    symbol: v[1],
    exponent: C,
    unit: T
  } : v.join(u);
}
const pz = ({ sizes: e, accept: t, maxFiles: n, t: r, maxSize: o }) => ({
  accept: t,
  maxFiles: n,
  maxSize: o,
  // Used to inject the image dimensions to use in the validator
  getFilesFromEvent: async (i) => {
    var c, d, m;
    if (i.type === "dragenter") {
      const f = (c = i.dataTransfer) == null ? void 0 : c.items;
      if (!f)
        return [];
      const p = [];
      for (let b = 0; b < f.length; b++) {
        const g = f[b];
        g.kind === "file" && p.push(g);
      }
      return p;
    }
    const s = Array.isArray(i) ? i : i.type === "drop" ? (d = i.dataTransfer) == null ? void 0 : d.files : (m = i.target) == null ? void 0 : m.files;
    if (!s)
      return [];
    const l = [];
    for (let f = 0; f < s.length; f++) {
      const p = s[f];
      if (p instanceof FileSystemFileHandle) {
        const b = await p.getFile();
        l.push(b);
      } else
        l.push(p);
    }
    if (!e)
      return l;
    const u = [];
    for (let f = 0; f < l.length; f++) {
      const p = l[f];
      if (!p.type.includes("image"))
        u.push(Promise.resolve(p));
      else {
        const b = p, g = new Promise((S) => {
          const C = new Image();
          C.onload = function() {
            b.width = C.width, b.height = C.height, S(b);
          }, C.src = URL.createObjectURL(b);
        });
        u.push(g);
      }
    }
    return await Promise.all(u);
  },
  validator: ({ width: i, height: s }) => {
    if (e && i && s) {
      const { maxWidth: l, maxHeight: u } = e;
      if (i > l || s > u)
        return {
          type: "error",
          message: r("imageDimensionsError", { maxWidth: l, maxHeight: u })
        };
    }
    return null;
  }
});
function mz(e, t, n, r) {
  return t ? e.palette.success.main : n ? e.palette.error.main : r ? e.palette.primary.main : e.palette.grey[500];
}
const hz = Q(Au, {
  shouldForwardProp: (e) => e !== "success"
})(({ success: e, error: t, focused: n, theme: r, disabled: o }) => ({
  cursor: "pointer",
  margin: r.spacing(2, 0),
  "& .MuiPaper-root": {
    borderWidth: n || t || e ? 2 : 1,
    borderStyle: "dashed",
    borderColor: mz(r, e, t, n),
    padding: "1em",
    minHeight: "13em"
  },
  "& .MuiStack-root.empty-state p": {
    marginBottom: 0
  },
  pointerEvents: o ? "none" : "auto",
  "& .MuiSvgIcon-root": {
    opacity: o ? 0.5 : 1
  }
})), gz = Q(Co)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "2em",
  minHeight: "17em",
  borderRadius: "5px"
})), yz = Q(RC)(({ theme: e }) => ({
  borderRadius: "50%",
  backgroundColor: e.palette.primary.main,
  color: e.palette.primary.contrastText,
  width: "4em",
  padding: "1em",
  height: "4em"
})), bz = Q(IC)(({ theme: e }) => ({
  borderRadius: "50%",
  backgroundColor: e.palette.primary.main,
  color: e.palette.primary.contrastText,
  width: "3em",
  padding: "0.75em",
  height: "3em"
})), vz = Q(Nl)(({ theme: e }) => ({
  color: e.palette.primary.main
})), hm = "components.dragDropFileUpload", Cz = "file-too-large";
function wz({ name: e, label: t, maxFiles: n = 1, accept: r, sizes: o, displayFileDetails: i = !0, showLabel: s = !0, fullWidth: l = !0, customLabelComponent: u, maxSize: c, ...d }) {
  const [m] = Ke([hm]), f = r ? Object.values(r) : void 0, p = o ? m("acceptedSizes", { maxWidth: o.maxWidth, maxHeight: o.maxHeight }) : void 0, b = Ee(() => pz({ sizes: o, maxFiles: n, accept: r, t: m, maxSize: c }), [o, n, r, m, c]), { register: g, setValue: S, watch: C, setError: w, clearErrors: v, formState: { errors: x, isSubmitting: T } } = $l(), E = Qe((q, Y, Z = {}) => {
    S(q, Y, ll({}, { shouldDirty: !0, shouldValidate: !0 }, Z));
  }, [S]), k = C(e), I = Ee(() => k && !Array.isArray(k) ? [k] : k, [k]), P = x[e], F = Qe(async (q, Y) => {
    if (P && !Y.length)
      v(e);
    else if (Y.length) {
      const { code: Z, message: ie } = At(Y[0], "errors.0"), se = Z === Cz ? m("fileSizeError", { maxSize: fz(c || 0) }) : ie;
      w(e, {
        type: "error",
        message: se
      });
    }
    if (q.length)
      if (n === 1) {
        let Z = q[0];
        //mocking the instanceof, since FileSystemFileHandle is not available in jsdom
        !(Z instanceof File) && Z[Symbol.toStringTag] === "FileSystemFileHandle" && typeof Z.getFile == "function" && (Z = await Z.getFile()), E(e, Z);
      } else
        E(e, I ? [...I, ...q] : q);
  }, [P, v, e, n, c, w, m, E, I]), A = !!(n && ((I == null ? void 0 : I.length) ?? 0) >= n), B = T || d.disabled, { getRootProps: W, getInputProps: M, isFocused: _, isDragAccept: O, isDragReject: R } = Yb({
    ...b,
    onDrop: F,
    // disable if we've a selection
    disabled: B || A
  }), N = Qe((q) => {
    const Y = [m("bytes"), m("kb"), m("mb"), m("gb"), m("tb")];
    if (q === 0)
      return m("n/a");
    const Z = Math.floor(Math.log(q) / Math.log(1024));
    return Z === 0 ? `${q} ${Y[Z]}` : `${(q / Math.pow(1024, Z)).toFixed(1)} ${Y[Z]}`;
  }, [m]), L = () => {
    E(e, null);
  }, $ = g(e), H = M(), G = {
    ...$,
    ...H
  };
  return J(Nu, { disableGutters: !0, children: [s && !u && h(ve, { variant: "h3", children: t }), s && (u || null), h(hz, { disabled: B, error: R || !!P, focused: _, success: O, fullWidth: l, children: J(gz, { ...W(), "aria-label": "drop-zone", variant: "outlined", children: [h("input", { type: "file", "aria-label": t || "file", ...G }), i && (I != null && I.length) ? J(Je, { container: !0, spacing: 6, justifyContent: "space-between", alignItems: "center", children: [h(Je, { item: !0, xs: 3, children: h(bz, {}) }), h(Je, { item: !0, xs: 7, children: I.map(({ name: q, size: Y }) => J(Ie, { children: [h(ve, { children: q }), Y && h(ve, { children: N(Y) })] }, q)) }), h(Je, { item: !0, xs: 2, justifyContent: "flex-end", children: h(tn, { "data-testid": "close-button", color: "secondary", onClick: L, children: h(vz, {}) }) })] }) : J(Ie, { className: "empty-state", justifyContent: "center", alignItems: "center", textAlign: "center", children: [h(yz, {}), h(eh, { children: h(Vn, { i18nKey: `${hm}.dropDescription`, components: { p: h("p", {}), strong: h("strong", {}) }, values: { label: t }, ns: "common" }) })] })] }) }), h(Be, { children: P != null && P.message ? h($u, { error: !0, "data-testid": "uploaded-file-error", children: P.message }) : null }), f || p ? J(ve, { children: [m("allowedFilesFormats", { formats: f }), p && m("allowedSizes", { sizes: p }), n > 1 && m("allowedMaxFiles", { maxFiles: n })] }) : null] });
}
function xz({ name: e, onChange: t, onDelete: n }) {
  const [r, o] = Xe(!1), [i, s] = Xe(e), l = r ? "text" : "hidden", u = (m) => s(m.target.value), c = () => {
    t(i), o(!1);
  }, d = () => {
    s(e), o(!1);
  };
  return J(Ie, { direction: "row", children: [h(Be, { flex: 1, alignSelf: "center", children: r ? h(us, { size: "small", fullWidth: !0, type: l, value: i, onChange: u, error: !i.length }) : h(ve, { height: "100%", children: e }) }), r ? J(Dt, { children: [h(tn, { "aria-label": "save", onClick: c, disabled: !i.length, color: "success", children: h(AC, {}) }), h(tn, { "aria-label": "cancel", onClick: d, color: "error", children: h(Nl, {}) })] }) : h(tn, { "aria-label": "edit", onClick: () => o(!0), color: "primary", children: h(NC, {}) }), h(tn, { "aria-label": "delete", onClick: n, color: "primary", children: h($C, {}) })] });
}
const Sz = oe.array(oe.instanceof(File)), Tz = "components.dragDropFileUpload";
function _z({ maxFiles: e = 0, ...t }) {
  const [n] = Ke([Tz]), r = ui({
    resolver: Os(Sh({ [t.name]: Sz })),
    mode: "onChange"
  }), { watch: o, setValue: i } = r, s = o(t.name), l = () => {
    alert("Files should upload");
  }, u = (d, m) => {
    const f = s == null ? void 0 : s[d];
    if (!f)
      return;
    const { name: p, size: b, type: g, ...S } = f, C = p.split(".").pop(), w = m.split(".").pop(), v = C === w ? m : `${m}.${C}`, x = [...s];
    x[d] = new File([f.slice(0, b)], v, { type: g, ...S }), i(t.name, x);
  }, c = (d) => {
    const m = s == null ? void 0 : s.filter((f, p) => d !== p);
    i(t.name, m);
  };
  return h(ws, { formContext: r, onSuccess: l, children: J(Ie, { direction: "row", columnGap: 3, children: [h(Be, { flex: 1, children: h(wz, { maxFiles: e, ...t, displayFileDetails: !1 }) }), J(Ie, { flex: 2, justifyContent: s != null && s.length ? "space-between" : "end", mt: 8, children: [h(Be, { maxHeight: "19em", overflow: "scroll", children: s == null ? void 0 : s.map((d, m) => J(kr, { children: [h(xz, { name: d.name, onChange: (f) => u(m, f), onDelete: () => c(m) }), h(kt, {})] }, `${d.name}${m}`)) }), h(pr, { type: "submit", variant: "contained", color: "primary", disabled: !(s != null && s.length), children: n("upload") })] })] }) });
}
const Dz = Q(Or, { shouldForwardProp: (e) => e !== "fullWidth" })(({ fullWidth: e }) => ({
  width: e ? "100%" : "auto",
  maxWidth: e ? "inherit" : "fit-content",
  transform: "scale(1, 1)"
}));
function Pz({ isLoading: e, fullWidth: t, children: n }) {
  return e ? h(Dz, { fullWidth: t, "data-testid": "skeleton-loader", children: h(gm, { children: n }) }) : h(gm, { children: n });
}
function Gb({ valueKey: e = "id", labelKey: t = "label", options: n, children: r, isLoading: o, defaultValue: i, value: s, onChange: l, TooltipProps: u, ...c }) {
  const { title: d, IconProps: m, ...f } = u ?? {};
  return J(Pz, { isLoading: o, fullWidth: c.fullWidth, children: [h(nh, { ...c, value: !n && !r ? "" : s ?? i, onChange: l, disabled: o || c.disabled, displayEmpty: !0, children: r || (n == null ? void 0 : n.map((p) => {
    const b = At(p, e, p), g = At(p, t, p);
    return h(ds, { value: b, children: h(ve, { variant: "body", children: g }) }, b);
  })) }), d ? h(Oz, { role: "tooltip", title: d, IconProps: m, ...f, isDisabled: c.disabled }) : null] });
}
const gm = Q(Ie)(({ theme: e }) => {
  var t;
  return {
    flexDirection: "row",
    columnGap: e.spacing(2),
    alignItems: "center",
    "& .MuiInputBase-root": {
      flex: 1
    },
    // To fix helper text alignment
    "& + .MuiFormHelperText-root": {
      marginLeft: 0
    },
    ".MuiSelect-icon": {
      color: (t = e.palette.shape) == null ? void 0 : t.border
    }
  };
}), Oz = Q(xo, {
  shouldForwardProp: (e) => e !== "isDisabled"
})(({ isDisabled: e, theme: t }) => ({
  ...e && {
    color: t.palette.text.disabled
  }
}));
function Ud({ id: e, name: t, label: n, helperText: r, formControlProps: o, ...i }) {
  const s = i.valueKey || "id";
  return h(Al, { name: t, render: ({ field: { onBlur: l, onChange: u, value: c }, fieldState: { error: d }, formState: { isSubmitting: m } }) => {
    c = (c == null ? void 0 : c[s]) ?? c ?? "", r = d ? d.message : r;
    const f = `label-${e || t}`;
    return J(Au, { ...o, variant: i.variant, fullWidth: i.fullWidth, error: !!d, size: i.size, disabled: m || i.disabled, children: [n && h(VC, { size: i.size === "small" ? "small" : void 0, error: !!d, id: f, children: n }), h(Gb, { id: e || t, labelId: f, name: t, onBlur: l, value: c, onChange: u, error: !!d, ...i }), r && h($u, { children: r })] });
  } });
}
function kz({ selected: e, value: t, displayMode: n, options: r, onChange: o, t: i }) {
  if (!(e != null && e.length))
    return null;
  if (n === "count" && e.length > 1)
    return i("displayCount", { value: t.length });
  const s = e.map((l) => {
    var u;
    return (u = r == null ? void 0 : r.find(({ id: c }) => l === c)) == null ? void 0 : u.label;
  });
  return n === "chips" ? h(Ie, { flexWrap: "wrap", direction: "row", gap: 1, children: s.map((l, u) => h(kl, { label: l, onDelete: () => o == null ? void 0 : o(t.filter((c) => c !== l)), deleteIcon: h(Ym, { onMouseDown: (c) => c.stopPropagation() }) }, e[u])) }) : r != null && r.length && typeof r[0] == "object" ? h(Dt, { children: s.join(", ") }) : h(Dt, { children: e == null ? void 0 : e.join(", ") });
}
function Kb({ options: e, itemKey: t = "id", itemValue: n = "", itemLabel: r = "label", required: o = !1, name: i, helperText: s, displayMode: l, showCheckbox: u, ...c }) {
  const [d] = Ke();
  return h(Al, { name: i, render: ({ field: { value: m, onChange: f, onBlur: p }, fieldState: { error: b } }) => (s = b ? b.message : s, h(Ud, { ...c, multiple: !0, renderValue: (g) => kz({
    selected: g,
    value: m,
    displayMode: l,
    options: e,
    onChange: f,
    t: d
  }), helperText: s, name: i, error: !!b, value: m || [], required: o, onChange: f, onBlur: p, children: e == null ? void 0 : e.map((g) => {
    const S = typeof g == "object" ? g[n || t] : g, C = typeof g == "object" ? g[r] : g, w = Array.isArray(m) ? m.includes(S) : !1;
    return J(ds, { value: S, children: [u && h(Qy, { checked: w }), typeof C == "string" ? h(FC, { primary: C, primaryTypographyProps: { variant: "body" } }) : C] }, S);
  }) })) });
}
function Mz({ dependsOn: e, fieldsToFilter: t, options: n, name: r, ...o }) {
  const i = Jo({ name: e }), s = Jo({ name: r }), { setValue: l } = $l(), u = Ee(() => n == null ? void 0 : n.filter((c) => !(t || e).some((d, m) => !i[m] || c[d] !== i[m])), [i, e, t, n]);
  return it(() => {
    if (!s || !(u != null && u.length))
      return;
    (u == null ? void 0 : u.some((d) => d.id === s)) || l(r, "");
  }, [u, r, s, l]), o.multiple ? h(Kb, { options: u, name: r, ...o }) : h(Ud, { options: u, name: r, ...o });
}
function co(e) {
  return e.dependsOn ? h(Mz, { ...e }) : e.multiple ? h(Kb, { ...e }) : h(Ud, { ...e });
}
function cG({ showAllOption: e, ...t }) {
  const [n, r] = Ke(["components.charger"]), o = Ee(() => {
    const i = [
      { id: Pa.Level1, label: n("level_1") },
      { id: Pa.Level2, label: n("level_2") },
      { id: Pa.DCFC, label: n("dc_fast_charging") }
    ];
    return e && i.push({ id: "all", label: r("all") }), i;
  }, [e, r, n]);
  return h(co, { ...t, label: n("chargerType"), options: o });
}
var Sl = { exports: {} };
Sl.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 9007199254740991, i = "[object Arguments]", s = "[object Array]", l = "[object Boolean]", u = "[object Date]", c = "[object Error]", d = "[object Function]", m = "[object GeneratorFunction]", f = "[object Map]", p = "[object Number]", b = "[object Object]", g = "[object Promise]", S = "[object RegExp]", C = "[object Set]", w = "[object String]", v = "[object Symbol]", x = "[object WeakMap]", T = "[object ArrayBuffer]", E = "[object DataView]", k = "[object Float32Array]", I = "[object Float64Array]", P = "[object Int8Array]", F = "[object Int16Array]", A = "[object Int32Array]", B = "[object Uint8Array]", W = "[object Uint8ClampedArray]", M = "[object Uint16Array]", _ = "[object Uint32Array]", O = /[\\^$.*+?()[\]{}|]/g, R = /\w*$/, N = /^\[object .+?Constructor\]$/, L = /^(?:0|[1-9]\d*)$/, $ = {};
  $[i] = $[s] = $[T] = $[E] = $[l] = $[u] = $[k] = $[I] = $[P] = $[F] = $[A] = $[f] = $[p] = $[b] = $[S] = $[C] = $[w] = $[v] = $[B] = $[W] = $[M] = $[_] = !0, $[c] = $[d] = $[x] = !1;
  var H = typeof ot == "object" && ot && ot.Object === Object && ot, G = typeof self == "object" && self && self.Object === Object && self, q = H || G || Function("return this")(), Y = t && !t.nodeType && t, Z = Y && !0 && e && !e.nodeType && e, ie = Z && Z.exports === Y;
  function X(j, te) {
    return j.set(te[0], te[1]), j;
  }
  function se(j, te) {
    return j.add(te), j;
  }
  function fe(j, te) {
    for (var y = -1, D = j ? j.length : 0; ++y < D && te(j[y], y, j) !== !1; )
      ;
    return j;
  }
  function le(j, te) {
    for (var y = -1, D = te.length, V = j.length; ++y < D; )
      j[V + y] = te[y];
    return j;
  }
  function ce(j, te, y, D) {
    var V = -1, re = j ? j.length : 0;
    for (D && re && (y = j[++V]); ++V < re; )
      y = te(y, j[V], V, j);
    return y;
  }
  function ee(j, te) {
    for (var y = -1, D = Array(j); ++y < j; )
      D[y] = te(y);
    return D;
  }
  function ae(j, te) {
    return j == null ? void 0 : j[te];
  }
  function _e(j) {
    var te = !1;
    if (j != null && typeof j.toString != "function")
      try {
        te = !!(j + "");
      } catch {
      }
    return te;
  }
  function ue(j) {
    var te = -1, y = Array(j.size);
    return j.forEach(function(D, V) {
      y[++te] = [V, D];
    }), y;
  }
  function me(j, te) {
    return function(y) {
      return j(te(y));
    };
  }
  function De(j) {
    var te = -1, y = Array(j.size);
    return j.forEach(function(D) {
      y[++te] = D;
    }), y;
  }
  var he = Array.prototype, Ce = Function.prototype, K = Object.prototype, ne = q["__core-js_shared__"], pe = function() {
    var j = /[^.]+$/.exec(ne && ne.keys && ne.keys.IE_PROTO || "");
    return j ? "Symbol(src)_1." + j : "";
  }(), Me = Ce.toString, de = K.hasOwnProperty, ye = K.toString, Te = RegExp(
    "^" + Me.call(de).replace(O, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = ie ? q.Buffer : void 0, We = q.Symbol, ht = q.Uint8Array, gt = me(Object.getPrototypeOf, Object), Qt = Object.create, Lt = K.propertyIsEnumerable, yt = he.splice, dn = Object.getOwnPropertySymbols, Dn = Re ? Re.isBuffer : void 0, bt = me(Object.keys, Object), $t = Hn(q, "DataView"), Bt = Hn(q, "Map"), rn = Hn(q, "Promise"), Pn = Hn(q, "Set"), fn = Hn(q, "WeakMap"), Pt = Hn(Object, "create"), Hr = Jt($t), He = Jt(Bt), Ut = Jt(rn), On = Jt(Pn), on = Jt(fn), Po = We ? We.prototype : void 0, Oo = Po ? Po.valueOf : void 0;
  function lt(j) {
    var te = -1, y = j ? j.length : 0;
    for (this.clear(); ++te < y; ) {
      var D = j[te];
      this.set(D[0], D[1]);
    }
  }
  function _i() {
    this.__data__ = Pt ? Pt(null) : {};
  }
  function Di(j) {
    return this.has(j) && delete this.__data__[j];
  }
  function Pi(j) {
    var te = this.__data__;
    if (Pt) {
      var y = te[j];
      return y === r ? void 0 : y;
    }
    return de.call(te, j) ? te[j] : void 0;
  }
  function Oi(j) {
    var te = this.__data__;
    return Pt ? te[j] !== void 0 : de.call(te, j);
  }
  function ki(j, te) {
    var y = this.__data__;
    return y[j] = Pt && te === void 0 ? r : te, this;
  }
  lt.prototype.clear = _i, lt.prototype.delete = Di, lt.prototype.get = Pi, lt.prototype.has = Oi, lt.prototype.set = ki;
  function vt(j) {
    var te = -1, y = j ? j.length : 0;
    for (this.clear(); ++te < y; ) {
      var D = j[te];
      this.set(D[0], D[1]);
    }
  }
  function Mi() {
    this.__data__ = [];
  }
  function Ei(j) {
    var te = this.__data__, y = wr(te, j);
    if (y < 0)
      return !1;
    var D = te.length - 1;
    return y == D ? te.pop() : yt.call(te, y, 1), !0;
  }
  function Ii(j) {
    var te = this.__data__, y = wr(te, j);
    return y < 0 ? void 0 : te[y][1];
  }
  function Ri(j) {
    return wr(this.__data__, j) > -1;
  }
  function Ai(j, te) {
    var y = this.__data__, D = wr(y, j);
    return D < 0 ? y.push([j, te]) : y[D][1] = te, this;
  }
  vt.prototype.clear = Mi, vt.prototype.delete = Ei, vt.prototype.get = Ii, vt.prototype.has = Ri, vt.prototype.set = Ai;
  function It(j) {
    var te = -1, y = j ? j.length : 0;
    for (this.clear(); ++te < y; ) {
      var D = j[te];
      this.set(D[0], D[1]);
    }
  }
  function $i() {
    this.__data__ = {
      hash: new lt(),
      map: new (Bt || vt)(),
      string: new lt()
    };
  }
  function Ni(j) {
    return xr(this, j).delete(j);
  }
  function Fi(j) {
    return xr(this, j).get(j);
  }
  function Vi(j) {
    return xr(this, j).has(j);
  }
  function ji(j, te) {
    return xr(this, j).set(j, te), this;
  }
  It.prototype.clear = $i, It.prototype.delete = Ni, It.prototype.get = Fi, It.prototype.has = Vi, It.prototype.set = ji;
  function qn(j) {
    this.__data__ = new vt(j);
  }
  function rr() {
    this.__data__ = new vt();
  }
  function Li(j) {
    return this.__data__.delete(j);
  }
  function kn(j) {
    return this.__data__.get(j);
  }
  function or(j) {
    return this.__data__.has(j);
  }
  function Bi(j, te) {
    var y = this.__data__;
    if (y instanceof vt) {
      var D = y.__data__;
      if (!Bt || D.length < n - 1)
        return D.push([j, te]), this;
      y = this.__data__ = new It(D);
    }
    return y.set(j, te), this;
  }
  qn.prototype.clear = rr, qn.prototype.delete = Li, qn.prototype.get = kn, qn.prototype.has = or, qn.prototype.set = Bi;
  function Mn(j, te) {
    var y = lr(j) || ia(j) ? ee(j.length, String) : [], D = y.length, V = !!D;
    for (var re in j)
      (te || de.call(j, re)) && !(V && (re == "length" || na(re, D))) && y.push(re);
    return y;
  }
  function Cr(j, te, y) {
    var D = j[te];
    (!(de.call(j, te) && Un(D, y)) || y === void 0 && !(te in j)) && (j[te] = y);
  }
  function wr(j, te) {
    for (var y = j.length; y--; )
      if (Un(j[y][0], te))
        return y;
    return -1;
  }
  function zi(j, te) {
    return j && ko(te, cr(te), j);
  }
  function Ur(j, te, y, D, V, re, be) {
    var Pe;
    if (D && (Pe = re ? D(j, V, re, be) : D(j)), Pe !== void 0)
      return Pe;
    if (!Gn(j))
      return j;
    var Fe = lr(j);
    if (Fe) {
      if (Pe = ea(j), !te)
        return Ji(j, Pe);
    } else {
      var we = In(j), Ve = we == d || we == m;
      if (zt(j))
        return Yi(j, te);
      if (we == b || we == i || Ve && !re) {
        if (_e(j))
          return re ? j : {};
        if (Pe = ta(Ve ? {} : j), !te)
          return Kr(j, zi(Pe, j));
      } else {
        if (!$[we])
          return re ? j : {};
        Pe = ar(j, we, Ur, te);
      }
    }
    be || (be = new qn());
    var at = be.get(j);
    if (at)
      return at;
    if (be.set(j, Pe), !Fe)
      var tt = y ? Xi(j) : cr(j);
    return fe(tt || j, function(Xt, bn) {
      tt && (bn = Xt, Xt = j[bn]), Cr(Pe, bn, Ur(Xt, te, y, D, bn, j, be));
    }), Pe;
  }
  function Yr(j) {
    return Gn(j) ? Qt(j) : {};
  }
  function Wi(j, te, y) {
    var D = te(j);
    return lr(j) ? D : le(D, y(j));
  }
  function qi(j) {
    return ye.call(j);
  }
  function Hi(j) {
    if (!Gn(j) || oa(j))
      return !1;
    var te = an(j) || _e(j) ? Te : N;
    return te.test(Jt(j));
  }
  function Ui(j) {
    if (!yn(j))
      return bt(j);
    var te = [];
    for (var y in Object(j))
      de.call(j, y) && y != "constructor" && te.push(y);
    return te;
  }
  function Yi(j, te) {
    if (te)
      return j.slice();
    var y = new j.constructor(j.length);
    return j.copy(y), y;
  }
  function Gr(j) {
    var te = new j.constructor(j.byteLength);
    return new ht(te).set(new ht(j)), te;
  }
  function Gi(j, te) {
    var y = te ? Gr(j.buffer) : j.buffer;
    return new j.constructor(y, j.byteOffset, j.byteLength);
  }
  function Ki(j, te, y) {
    var D = te ? y(ue(j), !0) : ue(j);
    return ce(D, X, new j.constructor());
  }
  function Zi(j) {
    var te = new j.constructor(j.source, R.exec(j));
    return te.lastIndex = j.lastIndex, te;
  }
  function Qi(j, te, y) {
    var D = te ? y(De(j), !0) : De(j);
    return ce(D, se, new j.constructor());
  }
  function En(j) {
    return Oo ? Object(Oo.call(j)) : {};
  }
  function ir(j, te) {
    var y = te ? Gr(j.buffer) : j.buffer;
    return new j.constructor(y, j.byteOffset, j.length);
  }
  function Ji(j, te) {
    var y = -1, D = j.length;
    for (te || (te = Array(D)); ++y < D; )
      te[y] = j[y];
    return te;
  }
  function ko(j, te, y, D) {
    y || (y = {});
    for (var V = -1, re = te.length; ++V < re; ) {
      var be = te[V], Pe = D ? D(y[be], j[be], be, y, j) : void 0;
      Cr(y, be, Pe === void 0 ? j[be] : Pe);
    }
    return y;
  }
  function Kr(j, te) {
    return ko(j, Sr(j), te);
  }
  function Xi(j) {
    return Wi(j, cr, Sr);
  }
  function xr(j, te) {
    var y = j.__data__;
    return ra(te) ? y[typeof te == "string" ? "string" : "hash"] : y.map;
  }
  function Hn(j, te) {
    var y = ae(j, te);
    return Hi(y) ? y : void 0;
  }
  var Sr = dn ? me(dn, Object) : la, In = qi;
  ($t && In(new $t(new ArrayBuffer(1))) != E || Bt && In(new Bt()) != f || rn && In(rn.resolve()) != g || Pn && In(new Pn()) != C || fn && In(new fn()) != x) && (In = function(j) {
    var te = ye.call(j), y = te == b ? j.constructor : void 0, D = y ? Jt(y) : void 0;
    if (D)
      switch (D) {
        case Hr:
          return E;
        case He:
          return f;
        case Ut:
          return g;
        case On:
          return C;
        case on:
          return x;
      }
    return te;
  });
  function ea(j) {
    var te = j.length, y = j.constructor(te);
    return te && typeof j[0] == "string" && de.call(j, "index") && (y.index = j.index, y.input = j.input), y;
  }
  function ta(j) {
    return typeof j.constructor == "function" && !yn(j) ? Yr(gt(j)) : {};
  }
  function ar(j, te, y, D) {
    var V = j.constructor;
    switch (te) {
      case T:
        return Gr(j);
      case l:
      case u:
        return new V(+j);
      case E:
        return Gi(j, D);
      case k:
      case I:
      case P:
      case F:
      case A:
      case B:
      case W:
      case M:
      case _:
        return ir(j, D);
      case f:
        return Ki(j, D, y);
      case p:
      case w:
        return new V(j);
      case S:
        return Zi(j);
      case C:
        return Qi(j, D, y);
      case v:
        return En(j);
    }
  }
  function na(j, te) {
    return te = te ?? o, !!te && (typeof j == "number" || L.test(j)) && j > -1 && j % 1 == 0 && j < te;
  }
  function ra(j) {
    var te = typeof j;
    return te == "string" || te == "number" || te == "symbol" || te == "boolean" ? j !== "__proto__" : j === null;
  }
  function oa(j) {
    return !!pe && pe in j;
  }
  function yn(j) {
    var te = j && j.constructor, y = typeof te == "function" && te.prototype || K;
    return j === y;
  }
  function Jt(j) {
    if (j != null) {
      try {
        return Me.call(j);
      } catch {
      }
      try {
        return j + "";
      } catch {
      }
    }
    return "";
  }
  function sr(j) {
    return Ur(j, !0, !0);
  }
  function Un(j, te) {
    return j === te || j !== j && te !== te;
  }
  function ia(j) {
    return Zr(j) && de.call(j, "callee") && (!Lt.call(j, "callee") || ye.call(j) == i);
  }
  var lr = Array.isArray;
  function Yn(j) {
    return j != null && aa(j.length) && !an(j);
  }
  function Zr(j) {
    return sa(j) && Yn(j);
  }
  var zt = Dn || ca;
  function an(j) {
    var te = Gn(j) ? ye.call(j) : "";
    return te == d || te == m;
  }
  function aa(j) {
    return typeof j == "number" && j > -1 && j % 1 == 0 && j <= o;
  }
  function Gn(j) {
    var te = typeof j;
    return !!j && (te == "object" || te == "function");
  }
  function sa(j) {
    return !!j && typeof j == "object";
  }
  function cr(j) {
    return Yn(j) ? Mn(j) : Ui(j);
  }
  function la() {
    return [];
  }
  function ca() {
    return !1;
  }
  e.exports = sr;
})(Sl, Sl.exports);
var Ez = Sl.exports;
const Iz = /* @__PURE__ */ Mt(Ez);
var ym = 1 / 0, Rz = 9007199254740991, Az = 17976931348623157e292, bm = 0 / 0, Hc = 4294967295, $z = "[object Symbol]", Nz = /^\s+|\s+$/g, Fz = /^[-+]0x[0-9a-f]+$/i, Vz = /^0b[01]+$/i, jz = /^0o[0-7]+$/i, Lz = parseInt;
function Bz(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var zz = Object.prototype, Wz = zz.toString, qz = Math.min;
function vm(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Hz(e) {
  return !!e && typeof e == "object";
}
function Uz(e) {
  return typeof e == "symbol" || Hz(e) && Wz.call(e) == $z;
}
function Yz(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Kz(e), e === ym || e === -ym) {
    var t = e < 0 ? -1 : 1;
    return t * Az;
  }
  return e === e ? e : 0;
}
function Gz(e) {
  var t = Yz(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function Kz(e) {
  if (typeof e == "number")
    return e;
  if (Uz(e))
    return bm;
  if (vm(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = vm(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Nz, "");
  var n = Vz.test(e);
  return n || jz.test(e) ? Lz(e.slice(2), n ? 2 : 8) : Fz.test(e) ? bm : +e;
}
function Zz(e) {
  return e;
}
function Qz(e, t) {
  if (e = Gz(e), e < 1 || e > Rz)
    return [];
  var n = Hc, r = qz(e, Hc);
  t = typeof t == "function" ? t : Zz, e -= Hc;
  for (var o = Bz(r, t); ++n < e; )
    t(n);
  return o;
}
var Jz = Qz;
const Xz = /* @__PURE__ */ Mt(Jz), Es = (e) => Object.assign((t) => {
  const { isSubmitting: n } = fC();
  return h(e, { sx: {
    pointerEvents: n || t.disabled ? "none" : "auto"
  }, ...t, disabled: n || t.disabled });
}, {
  displayName: "EnhancedComponent"
}), eW = Q(Ie)(() => ({
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "inherit",
  gridColumnEnd: "2 span"
})), uG = ({ name: e, renderFunction: t, renderActions: n, renderSpacer: r }) => {
  const { fields: o, ...i } = pC({
    name: e
  });
  return J(Dt, { children: [o == null ? void 0 : o.map((s, l) => t(`${e}.${l}`, s, i, l)), (o == null ? void 0 : o.length) > 0 && r, h(eW, { children: n(i, o) })] });
}, ba = Es(mr), dG = Es($y), fG = Es(xF), pG = Es(Vy), mG = Es(_z), tW = Vt(function(t, n) {
  const { onChange: r, ...o } = t;
  return h(y_, { getInputRef: n, onValueChange: (i) => {
    r && r({
      target: {
        name: t.name,
        value: typeof i.floatValue == "number" ? i.floatValue : null
      }
    });
  }, ...o });
}), Eu = ({ numericInputProps: e, ...t }) => {
  const { InputProps: n } = t;
  return h(mr, { ...t, InputProps: {
    ...n,
    inputComponent: tW,
    inputProps: { ...e }
  } });
};
function hG({ defaultValue: e, value: t, ...n }) {
  const [r, o] = Xe(e || t);
  return it(() => {
    t !== r && o(t);
  }, [t, r]), h(Gb, { defaultValue: e, value: r, ...n });
}
const Zb = {
  financeType: "cash",
  salesTax: 20,
  annualFees: 300,
  subscriptionFee: 0,
  salesTaxPayment: "upfront",
  yearlyDepreciation: 10,
  financeTerm: 5,
  downPayment: 20,
  interestRate: 5,
  residualValue: 20
}, Cm = [
  {
    id: "cash",
    label: "Cash"
  },
  {
    id: "lease",
    label: "Lease"
  },
  {
    id: "finance",
    label: "Finance"
  },
  {
    id: "caas",
    label: "Charging as a Service"
  }
];
function Ws(e, t = 2) {
  return +(typeof e == "string" ? parseFloat(e) : e).toFixed(t);
}
function nW({ boxProps: e, selectedSetId: t, financeType: n, financeTypes: r = Cm.map((c) => c.id), financeData: o, sets: i, statusProps: s, isPreviewMode: l, onFinanceUpdated: u }) {
  var M;
  const [c] = Ke(["financials"]), { getValues: d, setValue: m } = $l(), { lifespanYears: f } = d(), [p, b] = Xe(!0), { isAllowed: g } = fi(), S = g("show", "financeForm", "allSets"), C = Ee(() => {
    const _ = (i == null ? void 0 : i.map((O) => ({
      id: O.id,
      label: O.name
    }))) ?? [];
    return S && i.length > 1 && _.push({
      id: "all",
      label: c("set.all")
    }), _;
  }, [i, S, c]), w = Ee(() => Cm.filter((_) => r.includes(_.id)), [r]), v = Ee(() => {
    let _ = f;
    return n === "lease" ? _ = f < 5 ? f : 5 : n === "finance" && (_ = f < 7 ? f : 7), (o == null ? void 0 : o.financeTerm) > _ && m("financeForm.financeTerm", _), Xz(_, (O) => {
      const R = { count: O + 1, months: (O + 1) * 12 };
      return {
        id: O + 1,
        label: c("financeTerm.year", R)
      };
    });
  }, [f, c, n, m, o == null ? void 0 : o.financeTerm]), x = Ee(() => s != null && s.isError ? c("applyButton.error") : c("applyButton.default"), [s, c]), T = jC(), E = Qe((_) => {
    _ == null || _.preventDefault();
    const O = (R) => {
      const N = Iz(i), L = ($, H) => {
        var G, q;
        if ($.finance = { ...o }, $.prices) {
          $.financeResult = {};
          const Y = dt({}, $, {
            finance: {
              financeTerm: o.financeTerm,
              annualFees: Number(o.annualFees)
            }
          }), Z = {
            id: Y.id,
            count: Y.count,
            finance: dt({}, Zb, o),
            price: $.price,
            opex: 0
          };
          $.financeResult.electricVehicle = T.calculateFinancePerObject(f, {
            ...Z,
            price: ((G = $ == null ? void 0 : $.prices) == null ? void 0 : G.electric) ?? 0
          }), $.financeResult.fossilVehicle = T.calculateFinancePerObject(f, {
            ...Z,
            price: ((q = $ == null ? void 0 : $.prices) == null ? void 0 : q.fossil) ?? 0
          });
        }
        N[H] = $;
      };
      R === -1 ? N.forEach(L) : L({ ...N[R] }, R), m("sets", N), u(N, R, t);
    };
    if (t === "all")
      O(-1);
    else {
      const R = i.findIndex((N) => N.id === t);
      O(R);
    }
  }, [T, o, f, u, t, m, i]);
  it(() => {
    const _ = i.find((O) => O.id === t);
    _ && !_.financeResult && E();
  }, [t]);
  const k = (_) => {
    _.preventDefault();
    const O = (1 - Number(_.target.value) / 100) ** f;
    m("financeForm.residualValue", Number((O * 100).toFixed(2)));
  };
  if (!o)
    return h(kh, {});
  const { salesTax: I, msrp: P, residualValue: F, downPayment: A, interestRate: B } = o, W = ((M = i.find((_) => _.id === t)) == null ? void 0 : M.count) ?? 1;
  return h("form", { onSubmit: E, children: J(Be, { marginY: 5, ...e, children: [J(Je, { container: !0, spacing: 10, children: [h(Je, { item: !0, xs: 12, sm: 6, children: h(co, { name: "selectedSetId", label: c("set.title"), fullWidth: !0, options: C, "data-testid": "finance-form-setid", disabled: l }) }), h(Je, { item: !0, xs: 12, sm: 6, children: h(co, { name: "financeForm.financeType", label: c("financeType.title"), fullWidth: !0, options: w, "data-testid": "finance-form-financetype", disabled: l }) })] }), h(Be, { marginY: 3, children: h(tu, { title: c("expandable.title"), expanded: p, onChange: () => b((_) => !_), children: J(Je, { container: !0, columnSpacing: 10, rowSpacing: 4, children: [n === "caas" && J(Dt, { children: [h(Je, { item: !0, xs: 12, sm: 6, children: h(ba, { fullWidth: !0, label: c("caas.subscriptionPayment"), type: "number", placeholder: "199", inputProps: { min: 0, required: !0, step: ".01" }, name: "financeForm.subscriptionFee", "data-testid": "finance-form-subscriptionfee" }) }), h(Je, { item: !0, xs: 12, sm: 6, display: "flex", alignItems: "center", mt: 4.5, children: h(Ed, { name: "financeForm.caasElectricityCovered", label: h(Vn, { t: c, i18nKey: "caas.caasElectricityCovered" }), "data-testid": "finance-form-caaselectricitycovered" }) })] }), n !== "caas" && h(Je, { item: !0, xs: 12, sm: 6, display: "flex", alignItems: "center", gap: 2, children: h(ba, { fullWidth: !0, label: c("salesTax.title"), type: "number", placeholder: "20", inputProps: { min: 0, max: 100, required: !0, step: ".01" }, helperText: c("salesTax.helper", {
    percentage: I,
    value: Ws(I / 100 * P * W)
  }), name: "financeForm.salesTax", "data-testid": "finance-form-salestax", disabled: l, TooltipProps: {
    title: c("salesTax.tooltip")
  } }) }), n !== "caas" && h(pi, { do: "show", on: "financeForm", field: "registrationFees", children: h(Je, { item: !0, xs: 12, sm: 6, display: "flex", alignItems: "center", gap: 2, children: h(Eu, { fullWidth: !0, label: c("registrationFees.title"), type: "number", placeholder: "300", inputProps: { min: 0, required: !0 }, name: "financeForm.annualFees", helperText: " ", "data-testid": "finance-form-annualfees", TooltipProps: { title: c("registrationFees.tooltip") } }) }) }), n !== "cash" && n !== "caas" && J(Dt, { children: [h(Je, { item: !0, xs: 12, sm: 6, children: h(wF, { label: h(Jy, { title: c("salesTaxPayment.tooltip"), children: c("salesTaxPayment.title") }), name: "financeForm.salesTaxPayment", row: !0, options: [
    { id: "upfront", label: c("salesTaxPayment.option1") },
    { id: "over time", label: c("salesTaxPayment.option2") }
  ], "data-testid": "finance-form-salestaxpayment" }) }), h(Je, { item: !0, xs: 12, sm: 6, display: "flex", alignItems: "center", gap: 2, marginBottom: 8, children: h(ba, { fullWidth: !0, label: c("annualDepreciation.title"), type: "number", placeholder: "20", onChange: k, inputProps: { min: 0, max: 100, required: !0, step: ".01" }, helperText: c("annualDepreciation.helper", {
    percentage: F,
    value: f
  }), name: "financeForm.yearlyDepreciation", "data-testid": "finance-form-yearlydepreciation", TooltipProps: {
    title: c("annualDepreciation.tooltip")
  } }) }), h(Je, { item: !0, xs: 12, sm: 6, children: h(co, { name: "financeForm.financeTerm", label: c("financeTerm.title"), fullWidth: !0, options: v, "data-testid": "finance-form-financeterm" }) }), h(Je, { item: !0, xs: 12, sm: 6, children: h(ba, { fullWidth: !0, label: c("downPayment.title"), type: "number", placeholder: "20", inputProps: { min: 0, max: 100, required: !0, step: ".01" }, helperText: c("downPayment.helper", {
    percentage: A,
    value: Ws(A / 100 * P)
  }), name: "financeForm.downPayment", "data-testid": "finance-form-downpayment" }) }), h(Je, { item: !0, xs: 12, sm: 6, children: h(Eu, { fullWidth: !0, label: c("interestRate.title"), type: "number", placeholder: "5", inputProps: { min: 0, max: 100, required: !0, step: ".01" }, helperText: c("interestRate.helper", {
    value: Ws(B / 2400, 5)
  }), name: "financeForm.interestRate", "data-testid": "finance-form-interestrate" }) }), h(Je, { item: !0, xs: 12, sm: 6, children: h(ba, { disabled: !0, fullWidth: !0, label: c("residualValue.title"), type: "number", placeholder: "20", inputProps: { min: 0, max: 100, required: !0, step: ".01" }, helperText: c("residualValue.helper", {
    percentage: F,
    years: f,
    value: Ws(F / 100 * P)
  }), name: "financeForm.residualValue", "data-testid": "finance-form-residualvalue" }) })] })] }) }) }), h(Je, { className: "noprint", container: !0, justifyContent: "flex-end", children: h(wo, { type: "submit", variant: "contained", color: s != null && s.isError ? "error" : "primary", "data-testid": "finance-form-submit", disabled: l, children: x }) })] }) });
}
const rW = oe.object({
  financeType: oe.custom(),
  financeTerm: oe.coerce.number(),
  salesTax: oe.coerce.number(),
  annualFees: oe.coerce.number(),
  subscriptionFee: oe.coerce.number(),
  salesTaxPayment: oe.custom(),
  yearlyDepreciation: oe.coerce.number(),
  downPayment: oe.coerce.number(),
  interestRate: oe.coerce.number(),
  residualValue: oe.coerce.number()
}), oW = oe.record(oe.string(), rW), gG = oe.object({
  selectedVehicleSet: oe.coerce.number(),
  vehicleSets: oW
});
function iW(e) {
  return e.type === "previous" || e.type === "next" ? h(HC, { ...e }) : null;
}
const aW = 9;
function Qb({ items: e, itemsPerPage: t = aW, itemsCategory: n = "", SortComponentProps: r, ListWrapper: o, renderItem: i, keyExtractor: s }) {
  const [l, u] = Xe(1), [c] = Ke(), d = o || Kt, m = e.length, f = Ee(() => Math.min(l * t, e.length), [l, e.length, t]), p = Ee(() => Math.ceil(e.length / t) || 1, [e.length, t]), b = Ee(() => e.slice((l - 1) * t, l * t), [l, e, t]), g = (C, w) => u(w), S = () => b.length ? h(d, { children: b.map((C, w) => h("div", { role: "region", children: i({
    item: C,
    index: w,
    shownItems: b,
    items: e,
    pageProps: { currentPage: l, itemsPerPage: t }
  }) }, s(C, w))) }) : h(cW, { severity: "error", IconProps: { id: "search" }, children: h(Vn, { t: c, i18nKey: "noResults" }) });
  return it(() => {
    u(1);
  }, [e.length]), J(sW, { children: [r != null && r.sortingOptions ? J(wm, { children: [h(ve, { variant: "label", children: c("countDisplay", {
    category: n,
    count: f,
    totalItems: m
  }) }), h(co, { name: "sort", options: r.sortingOptions, label: c("sortBy"), "aria-labelledby": "sort-by-label" })] }) : null, h(S, {}), J(wm, { children: [h(ve, { variant: "label", py: 1.5, children: c("paginationInfo", {
    currentPage: l,
    totalPages: p
  }) }), h(lW, { page: l, count: Math.ceil(m / t), onChange: g, renderItem: iW })] })] });
}
const sW = Q(Ie)(({ theme: e }) => ({
  display: "grid",
  gap: e.spacing(4),
  gridTemplateRows: "auto 1fr auto",
  flex: "1"
})), wm = Q(Kt)(({ theme: e }) => ({
  alignItems: "end",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: e.spacing(4)
})), lW = Q(qC)(({ theme: e }) => {
  var t;
  return {
    ".MuiPagination-ul": {
      gap: e.spacing(1.5)
    },
    ".MuiPaginationItem-previousNext": {
      color: (t = e.palette.shape) == null ? void 0 : t.border
    }
  };
}), cW = Q(ps)({
  height: "max-content"
}), uW = Q(Co, {
  shouldForwardProp: (e) => e !== "spreadContent"
})(({ spreadContent: e, theme: t }) => ({
  display: e ? "grid" : "block",
  paddingTop: t.spacing(10),
  paddingBottom: t.spacing(10),
  [t.breakpoints.down("md")]: {
    padding: t.spacing(4)
  }
})), dW = Q(Nu)`
  display: grid;
  & > form {
    display: grid;
  }
`;
function Jb({ children: e, spreadContent: t, maxWidth: n = "md" }) {
  return h(uW, { className: "noprintshadow", spreadContent: t, children: h(dW, { maxWidth: n, children: e }) });
}
const Xb = Q(Co)(({ theme: e }) => ({
  padding: e.spacing(4),
  [e.breakpoints.down("md")]: {
    display: "none"
  }
}));
function yG({ children: e, internalHeaderProps: t }) {
  return J(Ie, { display: "grid", gridTemplateRows: "auto 1fr", gap: 6, children: [h(Xb, { ...t, children: e }), h(Jb, { maxWidth: "lg", children: h(Vm, {}) })] });
}
function ev({ src: e, alt: t, to: n, height: r = "100%", width: o = "auto", target: i = "_self" }) {
  return n ? h(di, { href: n, role: "link", height: "100%", target: i, rel: i === "_blank" ? "noreferrer noopener" : "", children: h("img", { src: e, alt: t, "aria-label": t, height: r, width: o }) }) : h("img", { src: e, alt: t, "aria-label": t, height: r, width: o });
}
const fW = Q(Ie)(({ theme: e }) => {
  var i;
  const { backgroundColor: t } = ((i = e.presets) == null ? void 0 : i.footer) ?? {}, { main: n, contrastText: r } = en(e.palette, t), { color: o } = Fu(e, n);
  return {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    columnGap: e.spacing(10),
    backgroundColor: n,
    color: r,
    alignItems: "center",
    [e.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
      rowGap: e.spacing(2)
    },
    img: {
      height: "inherit"
    },
    "& .MuiLink-root": {
      color: o
    }
  };
}), pW = h(di, { variant: "fineprint", target: "_blank", rel: "noreferrer noopener" });
function mW({ dynamicValues: e, linksProps: t = {}, py: n = 4, px: r = 4 }) {
  var m, f;
  const o = qt(), { fontFamily: i, fontWeight: s } = ((m = o.presets) == null ? void 0 : m.footer) ?? {}, [l] = Ke(), { id: u = "", defaultValue: c = [] } = t, d = l(u, { defaultValue: c, returnObjects: !0 });
  return J(fW, { component: "footer", py: n, px: r, children: [J(Ie, { direction: "column", gap: 3, children: [h(ve, { variant: "fineprint", fontFamily: i, fontWeight: s, children: h(Vn, { t: l, i18nKey: "footer", values: e }) }), d.length > 0 && h(Ie, { direction: "row", gap: 3, children: (f = d.map) == null ? void 0 : f.call(d, (p, b) => h(Vn, { i18nKey: p, t: l, components: {
    italic: h("i", {}),
    bold: h("strong", {}),
    b: h("strong", {}),
    a: pW
  } }, `links.${b}`)) })] }), h(pi, { do: "show", on: "footer", field: "logo", children: J(Ie, { gap: 1, alignItems: "flex-end", display: "flex", height: "1.5em", direction: "row", justifySelf: "flex-end", children: [h(ve, { variant: "fineprint", children: "powered by" }), h(ev, { src: "/ZappyRide.png", alt: "powered by ZappyRide", to: "/" })] }) })] });
}
function hW({ configuration: e = "footer", ...t }) {
  const n = Vd(e), { name: r, programName: o } = bb("client", Th), i = Object.assign({}, n, t);
  return h(mW, { ...i, dynamicValues: { clientName: r, clientProgramName: o } });
}
function Yd({ palette: e, presets: t, typography: n }) {
  const { backgroundColor: r, fontFamily: o, fontWeight: i } = (t == null ? void 0 : t.header) ?? {}, { main: s, contrastText: l } = en(e, r);
  return {
    fontWeight: At(n, `${i}`, i) ?? 500,
    backgroundColor: s,
    color: l,
    fontFamily: o ?? "inherit"
  };
}
function gW() {
  var l, u, c;
  const { i18n: e, t } = Ke(), n = ((l = e.options) == null ? void 0 : l.supportedLngs) || [], r = ((u = e.options) == null ? void 0 : u.fallbackLng) || [], o = (c = e.options) == null ? void 0 : c.lng, i = n.filter((d) => n.filter((m) => m.startsWith(d)).length === 1 && d !== "cimode" && (d === o || !(r != null && r.includes(d)))) || [], s = Qe((d) => {
    e.changeLanguage(d);
  }, [e]);
  return !i || i.length < 2 ? null : h(tv, { displayEmpty: !0, disableUnderline: !0, defaultValue: i[0], role: "listbox", "aria-label": "language", variant: "standard", renderValue: () => h(Be, { display: "flex", flexDirection: "row", children: h(GC, { color: "inherit" }) }), onChange: (d) => s(d.target.value), children: i.map((d) => h(ds, { value: d, role: "option", children: t([`languages.${d}`, `languages.${d.split("-")[0]}`]) }, d)) });
}
const tv = Q(nh)({
  backgroundColor: "unset",
  height: "auto",
  minWidth: "auto",
  borderRadius: 0,
  color: "inherit",
  "& .MuiSvgIcon-root": {
    color: "inherit"
  }
});
tv.defaultProps = {
  MenuProps: {
    PaperProps: {
      sx: (e) => {
        const { backgroundColor: t, color: n } = Yd(e);
        return {
          backgroundColor: t,
          color: n,
          borderRadius: 0,
          boxShadow: "none",
          padding: e.spacing(0, 0, 0, 2),
          "&& .MuiMenuItem-root": {
            borderLeftStyle: "solid",
            borderLeftColor: "transparent",
            borderLeftWidth: "2px",
            backgroundColor: "transparent",
            padding: e.spacing(0, 1.25),
            minHeight: "initial",
            marginBottom: e.spacing(2.5),
            lineHeight: "unset",
            borderRadius: 0,
            "&:hover": {
              background: "transparent"
            },
            "&.Mui-selected": {
              borderLeftColor: "inherit",
              backgroundColor: "transparent"
            }
          }
        };
      }
    }
  }
};
const yW = {
  primaryButton: Vl,
  secondaryButton: tr
};
function nv({ items: e }) {
  const t = jr((o) => o.breakpoints.up("sm")), { pathname: n } = Fm(), [r] = Ke();
  return h(Dt, { children: e.map(({ id: o, text: i, i18nKey: s = i, variant: l = "link", spacing: u, ...c }) => {
    const d = n === c.to;
    if (l === "link")
      return h(ve, { className: d ? "selected" : "", variant: "body", component: Qo, marginLeft: u, "aria-label": "list item", ...c, children: r(s, i) }, o);
    const m = yW[l];
    return h(m, { component: Qo, sx: { ml: t && u, mt: !t && u }, role: "button", "aria-label": `button ${i}`, ...c, children: i }, o);
  }) });
}
const bW = Q(Ie)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  "a:not(:first-of-type)": {
    marginLeft: e.spacing(6)
  },
  "a:not(.MuiButtonBase-root)": {
    color: "inherit",
    textDecoration: "none",
    borderBottom: "2px solid transparent",
    "&.selected, &:hover": {
      borderBottomColor: "inherit"
    }
  }
}));
function vW({ items: e }) {
  return h(bW, { children: h(nv, { items: e }) });
}
const CW = Q(tn)(({ theme: e, color: t }) => {
  const n = {
    borderStyle: "solid",
    borderWidth: e.shape.buttonBorderWidth,
    "&.text": {
      border: "none"
    }
  }, r = e.palette.action.disabled, o = t === "inherit" ? "primary" : t, { main: i, dark: s, contrastText: l } = e.palette[o];
  return {
    ...n,
    "&.outlined": {
      color: i,
      borderColor: sn(i, 0.5),
      backgroundColor: l,
      "&:hover": {
        borderColor: i,
        backgroundColor: sn(i, 0.04)
      },
      "&.Mui-disabled": {
        color: r,
        borderColor: r
      }
    },
    "&.contained": {
      backgroundColor: i,
      color: l,
      "&:hover": {
        backgroundColor: s
      },
      "&.Mui-disabled": {
        backgroundColor: r
      }
    },
    "&.text:hover": {
      backgroundColor: sn(i, 0.04)
    },
    "&.text.Mui-disabled": {
      color: r
    },
    "&.MuiIconButton-sizeSmall": {
      padding: e.spacing(1.325)
    },
    "&.MuiIconButton-sizeMedium": {
      padding: e.spacing(2.325)
    },
    "&.MuiIconButton-sizeLarge": {
      padding: e.spacing(3.325)
    }
  };
});
function Tl({ variant: e = "outlined", color: t = "primary", children: n, ...r }) {
  return h(CW, { className: e, variant: e, color: t, ...r, children: n });
}
const wW = Q(ZC)(({ theme: e }) => {
  var t;
  return {
    ".MuiPaper-root": {
      height: "100vh",
      scrollbarWidth: "none",
      alignItems: "center",
      padding: e.spacing(6),
      "&::-webkit-scrollbar": {
        display: "none"
      },
      "a.MuiTypography-root": {
        width: "100%",
        color: "inherit",
        textDecoration: "none",
        textAlign: "center",
        padding: e.spacing(6, 0),
        "&:not(:last-of-type):not(.selected)": {
          borderBottom: `1px solid ${(t = e.palette.shape) == null ? void 0 : t.border}`
        },
        "&.selected": {
          borderBottom: `2px solid  ${e.palette.primary.main}`,
          backgroundColor: "transparent",
          fontWeight: "bold"
        }
      },
      ".btn-close-menu": {
        marginTop: e.spacing(6)
      }
    }
  };
});
function xW({ items: e }) {
  const [t, n] = Xe(!1), r = () => {
    n(!t);
  };
  return h(Dt, { children: J(Tl, { variant: "text", color: "inherit", "aria-label": "menu", onClick: r, children: [h(KC, {}), J(wW, { role: "menu", "aria-labelledby": "menu", anchor: "top", open: t, onClose: r, transitionDuration: 0, children: [h(nv, { items: e }), h(Tl, { className: "btn-close-menu", variant: "outlined", "aria-label": "close menu", onClick: r, children: h(Nl, {}) })] })] }) });
}
function rv({ items: e = [] }) {
  const t = jr((n) => n.breakpoints.down("md"));
  return J(Dt, { children: [h(lf, { do: "show", on: "header", field: "desktopMenu", matcher: { isDesktop: !t }, children: h(vW, { items: e }) }), h(lf, { do: "show", on: "header", field: "mobileMenu", matcher: { isMobile: t }, children: h(xW, { items: e }) })] });
}
rv.defaultProps = {
  config: {
    showOnDesktop: !0,
    showOnMobile: !0
  },
  items: []
};
function SW({ userInfo: e, hasUnsavedChanges: t, onSaveAndLogout: n }) {
  var E;
  const [r, o] = Xe(null), [i, s] = Xe(!1), [l, u] = Xe(!1), [c, d] = Xe(!1), [m, f] = Ke(["components.header.usermenu"]), p = !!r, b = e == null ? void 0 : e.username, g = (E = e == null ? void 0 : e.attributes) == null ? void 0 : E["custom:group"], S = (k) => {
    o(k.currentTarget);
  }, C = () => {
    o(null);
  }, w = () => {
    l || s(!1);
  }, v = async () => {
    t ? (s(!0), C()) : await x();
  }, x = async () => {
    n && (d(!1), u(!0), await n().catch(() => {
      d(!0);
    }).finally(() => {
      u(!1);
    }));
  }, T = Ee(() => m(c ? "modal.primaryButtonErrorLabel" : l ? "modal.primaryButtonLoadingLabel" : "modal.primaryButtonLabel"), [c, l, m]);
  return b ? J(Be, { children: [h(TW, { id: "icon-button", "aria-controls": p ? "user-menu" : void 0, "aria-haspopup": "true", "aria-expanded": p ? "true" : void 0, onClick: S, "aria-label": "current user", color: "inherit", children: h(QC, {}) }), h(XC, { id: "user-menu", open: p, anchorEl: r, onClose: C, "aria-labelledby": "icon-button", anchorOrigin: {
    vertical: "bottom",
    horizontal: "right"
  }, transformOrigin: {
    vertical: "top",
    horizontal: "right"
  }, role: "menu", children: J(Ie, { flexDirection: "row", gap: 8, p: 5, boxSizing: "border-box", children: [J(Ie, { justifyContent: "center", gap: 1, children: [h(ve, { variant: "body", children: b }), g ? h(ve, { variant: "fineprint", children: g }) : null] }), h(tr, { startIcon: h(JC, {}), onClick: v, "aria-label": "logout button", children: f("logout") })] }) }), h(ks, { title: m("modal.title"), isOpen: i, onClose: w, primaryButtonProps: {
    loading: l
  }, primaryButtonLabel: T, primaryAction: x, secondaryButtonLabel: m("modal.secondaryButtonLabel"), secondaryEnabled: !l, secondaryAction: w, "aria-label": "save and exit dialog", children: h(ve, { children: m(c ? "modal.errorDescription" : "modal.description") }) })] }) : null;
}
const TW = Q(tn)(({ theme: e }) => ({
  color: Yd(e).color
})), _W = Q(UC)`
  box-shadow: none;
  height: 4.5em;
`, DW = Q(Ie)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  flex: 1,
  justifyContent: "flex-end",
  gap: e.spacing(1),
  alignItems: "center",
  "& > *:first-of-type + *": {
    marginLeft: e.spacing(0)
  }
})), PW = Q(YC)(({ theme: e }) => ({
  paddingTop: e.spacing(5),
  paddingBottom: e.spacing(5),
  height: "100%"
}));
function OW({ LogoProps: e, menuItems: t, UserMenuProps: n }) {
  return h(_W, { position: "static", component: "nav", role: "navigation", children: J(PW, { children: [h(ev, { ...e, target: "_blank" }), J(DW, { children: [h(pi, { do: "show", on: "header", field: "languageSwitcher", children: h(gW, {}) }), n && h(SW, { ...n }), t && h(rv, { items: t })] })] }) });
}
function kW({ headerType: e = "header", UserMenuProps: t, menuItems: n }) {
  var l, u;
  const r = qt(), { logo: o, ...i } = Vd(e, {}), s = {
    alt: "brand header logo",
    to: "/",
    src: ((u = (l = r.resources) == null ? void 0 : l.logo) == null ? void 0 : u.url) ?? "ZappyRide.png",
    ...o
  };
  return h(OW, { menuItems: n, UserMenuProps: t, LogoProps: s, ...i });
}
const MW = ({ clientName: e, clientProgramName: t }) => {
  const [n, r] = Ke(["components.leavingAppModal"]), [o, i] = Xe(""), s = tL("safeDomains"), l = Qe((d) => {
    if (!(d.target instanceof HTMLElement))
      return;
    const m = d.target.closest("a");
    !m || !(m.hostname && window.location.hostname !== m.hostname) || s.some((p) => m.hostname.match(p)) || (d.preventDefault(), i(m.href));
  }, [s]);
  it(() => (document.addEventListener("click", l), () => {
    document.removeEventListener("click", l);
  }), [l]);
  const u = () => {
    i("");
  };
  return h(ks, { showCloseButton: !0, isOpen: !!o, onClose: u, secondaryAction: u, primaryAction: () => {
    window.open(o, "_blank"), u();
  }, primaryButtonLabel: r("continue"), title: n("title", { clientProgramName: t }), secondaryButtonLabel: r("back"), children: h(ve, { variant: "body", children: n("message", { clientName: e, clientProgramName: t }) }) });
}, EW = Xy(MW, {
  I: "show",
  on: "app",
  field: "leavingAppModal",
  children: void 0
}), IW = Q(Ie)(({ theme: e }) => ({
  padding: e.spacing(10, 6),
  [e.breakpoints.only("xs")]: {
    padding: e.spacing(4)
  }
}));
function bG({ UserMenuProps: e, SupportModalProps: t, menuItems: n, children: r }) {
  const [o] = Ux(), i = bb("client", Th), s = Qe(() => {
    o("Contact Us");
  }, [o]);
  return J(Je, { container: !0, display: "grid", minHeight: "100vh", gridTemplateRows: { xs: "0fr auto 0fr", md: "auto 1fr" }, children: [h(kW, { UserMenuProps: e, menuItems: n }), h(IW, { spacing: { xs: 4, md: 6 }, display: "grid", gridTemplateRows: "1fr", children: r ?? h(Vm, {}) }), h(hW, { px: { xs: 4, md: 6 }, py: 4 }), h(Z2, { SupportModalProps: t, onClick: s }), h(EW, { clientName: i == null ? void 0 : i.name, clientProgramName: i == null ? void 0 : i.programName })] });
}
const RW = [
  {
    title: "firstTitle",
    text: "firstText"
  },
  {
    title: "secondTitle",
    text: "secondText"
  },
  {
    title: "thirdTitle",
    text: "thirdText"
  },
  {
    title: "fourthTitle",
    text: "fourthText"
  }
], va = {
  type: "bar",
  options: {
    responsive: !0,
    maintainAspectRatio: !1,
    layout: {
      padding: {
        top: 8
      }
    },
    plugins: {
      legend: {
        position: "top",
        display: !0,
        align: "end"
      },
      datalabels: {
        anchor: "end",
        align: "center",
        display: !1
      },
      tooltip: {
        displayColors: !0
      }
    }
  },
  data: {
    datasets: [
      {
        borderWidth: 1,
        stack: "Stack 0"
      }
    ]
  },
  boxProps: {
    width: "100%",
    height: "400px"
  }
}, Cn = {
  options: {
    responsive: !0,
    maintainAspectRatio: !1,
    layout: {
      padding: {
        top: 8
      }
    },
    scales: {
      x: {
        stacked: !0
      },
      y: {
        stacked: !0
      }
    },
    plugins: {
      legend: {
        position: "top",
        display: !0,
        align: "end"
      },
      datalabels: {
        anchor: "end",
        align: "center",
        display: !1
      },
      tooltip: {
        displayColors: !1
      }
    }
  },
  type: "bar",
  data: {
    datasets: [
      {
        stack: "Stack 0"
      },
      {
        stack: "Stack 1"
      }
    ]
  },
  boxProps: {
    width: "100%",
    height: "400px"
  }
}, Ca = {
  type: "line",
  options: {
    maintainAspectRatio: !1,
    layout: {
      padding: {
        top: 8
      }
    },
    plugins: {
      datalabels: {
        display: !1
      },
      tooltip: {
        usePointStyle: !0
      }
    }
  },
  data: {
    datasets: [
      {
        borderWidth: 5
      }
    ]
  },
  boxProps: {
    width: "100%",
    height: "400px"
  }
}, xm = {
  cash: { totalCostToOwn: 0, principal: 0, interest: 0, taxesFees: 0 },
  lease: { totalCostToOwn: 0, principal: 0, interest: 0, taxesFees: 0, depreciation: 0 },
  finance: { totalCostToOwn: 0, principal: 0, interest: 0, taxesFees: 0 },
  depreciation: 0
}, wa = {
  principal: 0,
  interest: 0,
  taxesFees: 0,
  totalCostToOwn: 0,
  totalCostToOwnAfterFees: 0
}, Uc = {
  depreciation: 0,
  downPayment: 0,
  cash: wa,
  lease: wa,
  leaseBuyout: wa,
  finance: wa,
  caas: wa,
  cashFlow: [
    {
      year: 0,
      cash: 0,
      lease: 0,
      leaseBuyout: 0,
      finance: 0,
      caas: 0
    }
  ],
  resaleValue: 0
}, AW = {
  chargers: Uc,
  electricVehicle: Uc,
  fossilVehicle: Uc
}, $W = Q(tw)(() => "max-width: 100%;"), Sm = Q(ew)(({ theme: e }) => `
  width: 160px;
  height: 35px;
  border-radius: 16px;
  border: 1px solid ${e.palette.primary.main};
  color: ${e.palette.primary.main};
  font-size:  ${e.typography.label.fontSize};

  &:hover {
    background-color: ${e.palette.common.white};
    opacity: 0.75;

  }

  &.Mui-selected {
    background-color: ${e.palette.primary.main};
    color: ${e.palette.common.white};

    &:hover {
      background-color: ${e.palette.primary.main};
      color: ${e.palette.common.white};  
      opacity: 1;
    }
  }
`);
Q(Lm)(({ theme: e }) => `
  margin: 16px 0 24px;
  border: 1px solid ${e.palette.text.disabled};
  border-radius: 5px;
  box-shadow: none;

  padding: 18px;
`);
Q(Bm)(({ theme: e }) => `
  .MuiAccordionSummary-content {
    margin: 0;
    font-size:  ${e.typography.h2.fontSize};
    font-family:  ${e.typography.fontFamily};
    font-weight:  ${e.typography.h2.fontWeight};
    color:  ${e.palette.text.primary};
  }
`);
var NW = Hu;
function FW(e) {
  return typeof e == "function" ? e : NW;
}
var VW = FW, jW = /\s/;
function LW(e) {
  for (var t = e.length; t-- && jW.test(e.charAt(t)); )
    ;
  return t;
}
var BW = LW, zW = BW, WW = /^\s+/;
function qW(e) {
  return e && e.slice(0, zW(e) + 1).replace(WW, "");
}
var HW = qW, UW = ms, YW = vi, GW = "[object Symbol]";
function KW(e) {
  return typeof e == "symbol" || YW(e) && UW(e) == GW;
}
var ZW = KW, QW = HW, Tm = Br, JW = ZW, _m = 0 / 0, XW = /^[-+]0x[0-9a-f]+$/i, eq = /^0b[01]+$/i, tq = /^0o[0-7]+$/i, nq = parseInt;
function rq(e) {
  if (typeof e == "number")
    return e;
  if (JW(e))
    return _m;
  if (Tm(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Tm(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = QW(e);
  var n = eq.test(e);
  return n || tq.test(e) ? nq(e.slice(2), n ? 2 : 8) : XW.test(e) ? _m : +e;
}
var oq = rq, iq = oq, Dm = 1 / 0, aq = 17976931348623157e292;
function sq(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = iq(e), e === Dm || e === -Dm) {
    var t = e < 0 ? -1 : 1;
    return t * aq;
  }
  return e === e ? e : 0;
}
var lq = sq, cq = lq;
function uq(e) {
  var t = cq(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var dq = uq, fq = og, pq = VW, mq = dq, hq = 9007199254740991, Yc = 4294967295, gq = Math.min;
function yq(e, t) {
  if (e = mq(e), e < 1 || e > hq)
    return [];
  var n = Yc, r = gq(e, Yc);
  t = pq(t), e -= Yc;
  for (var o = fq(r, t); ++n < e; )
    t(n);
  return o;
}
var bq = yq;
const Pm = /* @__PURE__ */ Mt(bq);
var _l = { exports: {} };
_l.exports;
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 800, i = 16, s = 9007199254740991, l = "[object Arguments]", u = "[object Array]", c = "[object AsyncFunction]", d = "[object Boolean]", m = "[object Date]", f = "[object Error]", p = "[object Function]", b = "[object GeneratorFunction]", g = "[object Map]", S = "[object Number]", C = "[object Null]", w = "[object Object]", v = "[object Proxy]", x = "[object RegExp]", T = "[object Set]", E = "[object String]", k = "[object Undefined]", I = "[object WeakMap]", P = "[object ArrayBuffer]", F = "[object DataView]", A = "[object Float32Array]", B = "[object Float64Array]", W = "[object Int8Array]", M = "[object Int16Array]", _ = "[object Int32Array]", O = "[object Uint8Array]", R = "[object Uint8ClampedArray]", N = "[object Uint16Array]", L = "[object Uint32Array]", $ = /[\\^$.*+?()[\]{}|]/g, H = /^\[object .+?Constructor\]$/, G = /^(?:0|[1-9]\d*)$/, q = {};
  q[A] = q[B] = q[W] = q[M] = q[_] = q[O] = q[R] = q[N] = q[L] = !0, q[l] = q[u] = q[P] = q[d] = q[F] = q[m] = q[f] = q[p] = q[g] = q[S] = q[w] = q[x] = q[T] = q[E] = q[I] = !1;
  var Y = typeof ot == "object" && ot && ot.Object === Object && ot, Z = typeof self == "object" && self && self.Object === Object && self, ie = Y || Z || Function("return this")(), X = t && !t.nodeType && t, se = X && !0 && e && !e.nodeType && e, fe = se && se.exports === X, le = fe && Y.process, ce = function() {
    try {
      var y = se && se.require && se.require("util").types;
      return y || le && le.binding && le.binding("util");
    } catch {
    }
  }(), ee = ce && ce.isTypedArray;
  function ae(y, D, V) {
    switch (V.length) {
      case 0:
        return y.call(D);
      case 1:
        return y.call(D, V[0]);
      case 2:
        return y.call(D, V[0], V[1]);
      case 3:
        return y.call(D, V[0], V[1], V[2]);
    }
    return y.apply(D, V);
  }
  function _e(y, D) {
    for (var V = -1, re = Array(y); ++V < y; )
      re[V] = D(V);
    return re;
  }
  function ue(y) {
    return function(D) {
      return y(D);
    };
  }
  function me(y, D) {
    return y == null ? void 0 : y[D];
  }
  function De(y, D) {
    return function(V) {
      return y(D(V));
    };
  }
  var he = Array.prototype, Ce = Function.prototype, K = Object.prototype, ne = ie["__core-js_shared__"], pe = Ce.toString, Me = K.hasOwnProperty, de = function() {
    var y = /[^.]+$/.exec(ne && ne.keys && ne.keys.IE_PROTO || "");
    return y ? "Symbol(src)_1." + y : "";
  }(), ye = K.toString, Te = pe.call(Object), Re = RegExp(
    "^" + pe.call(Me).replace($, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = fe ? ie.Buffer : void 0, ht = ie.Symbol, gt = ie.Uint8Array, Qt = We ? We.allocUnsafe : void 0, Lt = De(Object.getPrototypeOf, Object), yt = Object.create, dn = K.propertyIsEnumerable, Dn = he.splice, bt = ht ? ht.toStringTag : void 0, $t = function() {
    try {
      var y = ir(Object, "defineProperty");
      return y({}, "", {}), y;
    } catch {
    }
  }(), Bt = We ? We.isBuffer : void 0, rn = Math.max, Pn = Date.now, fn = ir(ie, "Map"), Pt = ir(Object, "create"), Hr = function() {
    function y() {
    }
    return function(D) {
      if (!zt(D))
        return {};
      if (yt)
        return yt(D);
      y.prototype = D;
      var V = new y();
      return y.prototype = void 0, V;
    };
  }();
  function He(y) {
    var D = -1, V = y == null ? 0 : y.length;
    for (this.clear(); ++D < V; ) {
      var re = y[D];
      this.set(re[0], re[1]);
    }
  }
  function Ut() {
    this.__data__ = Pt ? Pt(null) : {}, this.size = 0;
  }
  function On(y) {
    var D = this.has(y) && delete this.__data__[y];
    return this.size -= D ? 1 : 0, D;
  }
  function on(y) {
    var D = this.__data__;
    if (Pt) {
      var V = D[y];
      return V === r ? void 0 : V;
    }
    return Me.call(D, y) ? D[y] : void 0;
  }
  function Po(y) {
    var D = this.__data__;
    return Pt ? D[y] !== void 0 : Me.call(D, y);
  }
  function Oo(y, D) {
    var V = this.__data__;
    return this.size += this.has(y) ? 0 : 1, V[y] = Pt && D === void 0 ? r : D, this;
  }
  He.prototype.clear = Ut, He.prototype.delete = On, He.prototype.get = on, He.prototype.has = Po, He.prototype.set = Oo;
  function lt(y) {
    var D = -1, V = y == null ? 0 : y.length;
    for (this.clear(); ++D < V; ) {
      var re = y[D];
      this.set(re[0], re[1]);
    }
  }
  function _i() {
    this.__data__ = [], this.size = 0;
  }
  function Di(y) {
    var D = this.__data__, V = kn(D, y);
    if (V < 0)
      return !1;
    var re = D.length - 1;
    return V == re ? D.pop() : Dn.call(D, V, 1), --this.size, !0;
  }
  function Pi(y) {
    var D = this.__data__, V = kn(D, y);
    return V < 0 ? void 0 : D[V][1];
  }
  function Oi(y) {
    return kn(this.__data__, y) > -1;
  }
  function ki(y, D) {
    var V = this.__data__, re = kn(V, y);
    return re < 0 ? (++this.size, V.push([y, D])) : V[re][1] = D, this;
  }
  lt.prototype.clear = _i, lt.prototype.delete = Di, lt.prototype.get = Pi, lt.prototype.has = Oi, lt.prototype.set = ki;
  function vt(y) {
    var D = -1, V = y == null ? 0 : y.length;
    for (this.clear(); ++D < V; ) {
      var re = y[D];
      this.set(re[0], re[1]);
    }
  }
  function Mi() {
    this.size = 0, this.__data__ = {
      hash: new He(),
      map: new (fn || lt)(),
      string: new He()
    };
  }
  function Ei(y) {
    var D = En(this, y).delete(y);
    return this.size -= D ? 1 : 0, D;
  }
  function Ii(y) {
    return En(this, y).get(y);
  }
  function Ri(y) {
    return En(this, y).has(y);
  }
  function Ai(y, D) {
    var V = En(this, y), re = V.size;
    return V.set(y, D), this.size += V.size == re ? 0 : 1, this;
  }
  vt.prototype.clear = Mi, vt.prototype.delete = Ei, vt.prototype.get = Ii, vt.prototype.has = Ri, vt.prototype.set = Ai;
  function It(y) {
    var D = this.__data__ = new lt(y);
    this.size = D.size;
  }
  function $i() {
    this.__data__ = new lt(), this.size = 0;
  }
  function Ni(y) {
    var D = this.__data__, V = D.delete(y);
    return this.size = D.size, V;
  }
  function Fi(y) {
    return this.__data__.get(y);
  }
  function Vi(y) {
    return this.__data__.has(y);
  }
  function ji(y, D) {
    var V = this.__data__;
    if (V instanceof lt) {
      var re = V.__data__;
      if (!fn || re.length < n - 1)
        return re.push([y, D]), this.size = ++V.size, this;
      V = this.__data__ = new vt(re);
    }
    return V.set(y, D), this.size = V.size, this;
  }
  It.prototype.clear = $i, It.prototype.delete = Ni, It.prototype.get = Fi, It.prototype.has = Vi, It.prototype.set = ji;
  function qn(y, D) {
    var V = sr(y), re = !V && Jt(y), be = !V && !re && lr(y), Pe = !V && !re && !be && Gn(y), Fe = V || re || be || Pe, we = Fe ? _e(y.length, String) : [], Ve = we.length;
    for (var at in y)
      (D || Me.call(y, at)) && !(Fe && // Safari 9 has enumerable `arguments.length` in strict mode.
      (at == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      be && (at == "offset" || at == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Pe && (at == "buffer" || at == "byteLength" || at == "byteOffset") || // Skip index properties.
      Kr(at, Ve))) && we.push(at);
    return we;
  }
  function rr(y, D, V) {
    (V !== void 0 && !yn(y[D], V) || V === void 0 && !(D in y)) && or(y, D, V);
  }
  function Li(y, D, V) {
    var re = y[D];
    (!(Me.call(y, D) && yn(re, V)) || V === void 0 && !(D in y)) && or(y, D, V);
  }
  function kn(y, D) {
    for (var V = y.length; V--; )
      if (yn(y[V][0], D))
        return V;
    return -1;
  }
  function or(y, D, V) {
    D == "__proto__" && $t ? $t(y, D, {
      configurable: !0,
      enumerable: !0,
      value: V,
      writable: !0
    }) : y[D] = V;
  }
  var Bi = Qi();
  function Mn(y) {
    return y == null ? y === void 0 ? k : C : bt && bt in Object(y) ? Ji(y) : ea(y);
  }
  function Cr(y) {
    return an(y) && Mn(y) == l;
  }
  function wr(y) {
    if (!zt(y) || Hn(y))
      return !1;
    var D = Yn(y) ? Re : H;
    return D.test(oa(y));
  }
  function zi(y) {
    return an(y) && Zr(y.length) && !!q[Mn(y)];
  }
  function Ur(y) {
    if (!zt(y))
      return In(y);
    var D = Sr(y), V = [];
    for (var re in y)
      re == "constructor" && (D || !Me.call(y, re)) || V.push(re);
    return V;
  }
  function Yr(y, D, V, re, be) {
    y !== D && Bi(D, function(Pe, Fe) {
      if (be || (be = new It()), zt(Pe))
        Wi(y, D, Fe, V, Yr, re, be);
      else {
        var we = re ? re(ar(y, Fe), Pe, Fe + "", y, D, be) : void 0;
        we === void 0 && (we = Pe), rr(y, Fe, we);
      }
    }, cr);
  }
  function Wi(y, D, V, re, be, Pe, Fe) {
    var we = ar(y, V), Ve = ar(D, V), at = Fe.get(Ve);
    if (at) {
      rr(y, V, at);
      return;
    }
    var tt = Pe ? Pe(we, Ve, V + "", y, D, Fe) : void 0, Xt = tt === void 0;
    if (Xt) {
      var bn = sr(Ve), Qr = !bn && lr(Ve), ua = !bn && !Qr && Gn(Ve);
      tt = Ve, bn || Qr || ua ? sr(we) ? tt = we : ia(we) ? tt = Gi(we) : Qr ? (Xt = !1, tt = Ui(Ve, !0)) : ua ? (Xt = !1, tt = Gr(Ve, !0)) : tt = [] : aa(Ve) || Jt(Ve) ? (tt = we, Jt(we) ? tt = sa(we) : (!zt(we) || Yn(we)) && (tt = ko(Ve))) : Xt = !1;
    }
    Xt && (Fe.set(Ve, tt), be(tt, Ve, re, Pe, Fe), Fe.delete(Ve)), rr(y, V, tt);
  }
  function qi(y, D) {
    return na(ta(y, D, j), y + "");
  }
  var Hi = $t ? function(y, D) {
    return $t(y, "toString", {
      configurable: !0,
      enumerable: !1,
      value: ca(D),
      writable: !0
    });
  } : j;
  function Ui(y, D) {
    if (D)
      return y.slice();
    var V = y.length, re = Qt ? Qt(V) : new y.constructor(V);
    return y.copy(re), re;
  }
  function Yi(y) {
    var D = new y.constructor(y.byteLength);
    return new gt(D).set(new gt(y)), D;
  }
  function Gr(y, D) {
    var V = D ? Yi(y.buffer) : y.buffer;
    return new y.constructor(V, y.byteOffset, y.length);
  }
  function Gi(y, D) {
    var V = -1, re = y.length;
    for (D || (D = Array(re)); ++V < re; )
      D[V] = y[V];
    return D;
  }
  function Ki(y, D, V, re) {
    var be = !V;
    V || (V = {});
    for (var Pe = -1, Fe = D.length; ++Pe < Fe; ) {
      var we = D[Pe], Ve = re ? re(V[we], y[we], we, V, y) : void 0;
      Ve === void 0 && (Ve = y[we]), be ? or(V, we, Ve) : Li(V, we, Ve);
    }
    return V;
  }
  function Zi(y) {
    return qi(function(D, V) {
      var re = -1, be = V.length, Pe = be > 1 ? V[be - 1] : void 0, Fe = be > 2 ? V[2] : void 0;
      for (Pe = y.length > 3 && typeof Pe == "function" ? (be--, Pe) : void 0, Fe && Xi(V[0], V[1], Fe) && (Pe = be < 3 ? void 0 : Pe, be = 1), D = Object(D); ++re < be; ) {
        var we = V[re];
        we && y(D, we, re, Pe);
      }
      return D;
    });
  }
  function Qi(y) {
    return function(D, V, re) {
      for (var be = -1, Pe = Object(D), Fe = re(D), we = Fe.length; we--; ) {
        var Ve = Fe[y ? we : ++be];
        if (V(Pe[Ve], Ve, Pe) === !1)
          break;
      }
      return D;
    };
  }
  function En(y, D) {
    var V = y.__data__;
    return xr(D) ? V[typeof D == "string" ? "string" : "hash"] : V.map;
  }
  function ir(y, D) {
    var V = me(y, D);
    return wr(V) ? V : void 0;
  }
  function Ji(y) {
    var D = Me.call(y, bt), V = y[bt];
    try {
      y[bt] = void 0;
      var re = !0;
    } catch {
    }
    var be = ye.call(y);
    return re && (D ? y[bt] = V : delete y[bt]), be;
  }
  function ko(y) {
    return typeof y.constructor == "function" && !Sr(y) ? Hr(Lt(y)) : {};
  }
  function Kr(y, D) {
    var V = typeof y;
    return D = D ?? s, !!D && (V == "number" || V != "symbol" && G.test(y)) && y > -1 && y % 1 == 0 && y < D;
  }
  function Xi(y, D, V) {
    if (!zt(V))
      return !1;
    var re = typeof D;
    return (re == "number" ? Un(V) && Kr(D, V.length) : re == "string" && D in V) ? yn(V[D], y) : !1;
  }
  function xr(y) {
    var D = typeof y;
    return D == "string" || D == "number" || D == "symbol" || D == "boolean" ? y !== "__proto__" : y === null;
  }
  function Hn(y) {
    return !!de && de in y;
  }
  function Sr(y) {
    var D = y && y.constructor, V = typeof D == "function" && D.prototype || K;
    return y === V;
  }
  function In(y) {
    var D = [];
    if (y != null)
      for (var V in Object(y))
        D.push(V);
    return D;
  }
  function ea(y) {
    return ye.call(y);
  }
  function ta(y, D, V) {
    return D = rn(D === void 0 ? y.length - 1 : D, 0), function() {
      for (var re = arguments, be = -1, Pe = rn(re.length - D, 0), Fe = Array(Pe); ++be < Pe; )
        Fe[be] = re[D + be];
      be = -1;
      for (var we = Array(D + 1); ++be < D; )
        we[be] = re[be];
      return we[D] = V(Fe), ae(y, this, we);
    };
  }
  function ar(y, D) {
    if (!(D === "constructor" && typeof y[D] == "function") && D != "__proto__")
      return y[D];
  }
  var na = ra(Hi);
  function ra(y) {
    var D = 0, V = 0;
    return function() {
      var re = Pn(), be = i - (re - V);
      if (V = re, be > 0) {
        if (++D >= o)
          return arguments[0];
      } else
        D = 0;
      return y.apply(void 0, arguments);
    };
  }
  function oa(y) {
    if (y != null) {
      try {
        return pe.call(y);
      } catch {
      }
      try {
        return y + "";
      } catch {
      }
    }
    return "";
  }
  function yn(y, D) {
    return y === D || y !== y && D !== D;
  }
  var Jt = Cr(function() {
    return arguments;
  }()) ? Cr : function(y) {
    return an(y) && Me.call(y, "callee") && !dn.call(y, "callee");
  }, sr = Array.isArray;
  function Un(y) {
    return y != null && Zr(y.length) && !Yn(y);
  }
  function ia(y) {
    return an(y) && Un(y);
  }
  var lr = Bt || te;
  function Yn(y) {
    if (!zt(y))
      return !1;
    var D = Mn(y);
    return D == p || D == b || D == c || D == v;
  }
  function Zr(y) {
    return typeof y == "number" && y > -1 && y % 1 == 0 && y <= s;
  }
  function zt(y) {
    var D = typeof y;
    return y != null && (D == "object" || D == "function");
  }
  function an(y) {
    return y != null && typeof y == "object";
  }
  function aa(y) {
    if (!an(y) || Mn(y) != w)
      return !1;
    var D = Lt(y);
    if (D === null)
      return !0;
    var V = Me.call(D, "constructor") && D.constructor;
    return typeof V == "function" && V instanceof V && pe.call(V) == Te;
  }
  var Gn = ee ? ue(ee) : zi;
  function sa(y) {
    return Ki(y, cr(y));
  }
  function cr(y) {
    return Un(y) ? qn(y, !0) : Ur(y);
  }
  var la = Zi(function(y, D, V, re) {
    Yr(y, D, V, re);
  });
  function ca(y) {
    return function() {
      return y;
    };
  }
  function j(y) {
    return y;
  }
  function te() {
    return !1;
  }
  e.exports = la;
})(_l, _l.exports);
var vq = _l.exports;
const Cq = /* @__PURE__ */ Mt(vq);
function wq(e, t) {
  for (var n, r = -1, o = e.length; ++r < o; ) {
    var i = t(e[r]);
    i !== void 0 && (n = n === void 0 ? i : n + i);
  }
  return n;
}
function xq(e) {
  return e;
}
function Sq(e) {
  return e && e.length ? wq(e, xq) : 0;
}
var Tq = Sq;
const Om = /* @__PURE__ */ Mt(Tq), _q = (e, t) => {
  if (typeof e == "number" && typeof t == "number")
    return Om([e, t]);
  if (Array.isArray(e) && Array.isArray(t))
    return typeof (t == null ? void 0 : t[0]) == "number" ? t.map((r, o) => Om([e == null ? void 0 : e[o], t == null ? void 0 : t[o]])) : t.map((r, o) => ov(e == null ? void 0 : e[o], t == null ? void 0 : t[o]));
}, ov = (e, t) => dt({}, Cq(dt({}, e || {}), t, _q)), Dq = (e) => (t) => {
  const n = t.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
  if (n) {
    const r = parseInt(n[1]), o = parseInt(n[2]), i = parseInt(n[3]);
    return [
      e === "cash" ? t : `rgba(${r}, ${o}, ${i}, 90)`,
      e === "lease" ? t : `rgba(${r}, ${o}, ${i}, 90)`,
      e === "finance" ? t : `rgba(${r}, ${o}, ${i}, 90)`,
      e === "caas" ? t : `rgba(${r}, ${o}, ${i}, 90)`
    ];
  } else
    return [
      e === "cash" ? t : t + "90",
      e === "lease" ? t : t + "90",
      e === "finance" ? t : t + "90",
      e === "caas" ? t : t + "90"
    ];
}, Pq = (e, t) => (n) => {
  const r = e;
  let o = n.label.toLowerCase();
  o === "charging as a service" && (o = "caas");
  const i = [];
  if (r) {
    const s = n.datasetIndex > 0 ? "electricVehicle" : "fossilVehicle", l = r != null && r[s] ? r == null ? void 0 : r[s] : r == null ? void 0 : r.chargers, { principal: u, interest: c, taxesFees: d, totalCostToOwn: m } = (l == null ? void 0 : l[o]) || {};
    i.push(t("chartLabels.tooltips.principal", { value: u })), i.push(t("chartLabels.tooltips.interest", { value: c })), i.push(t("chartLabels.tooltips.fees", { value: d })), i.push(t("chartLabels.tooltips.total", { value: m })), i.push(t("chartLabels.tooltips.depreciation", { value: l == null ? void 0 : l.depreciation }));
  }
  return i;
}, Oq = (e, t) => (n) => {
  if (e) {
    const { cashFlow: r } = (e == null ? void 0 : e[n]) || {
      cashFlow: []
    }, o = [];
    return r.forEach((i) => {
      o.push(i[t]);
    }), o;
  } else
    return [];
};
function kq({ applyButtonCallback: e }) {
  const [t, n] = Xe(), [r, o] = Xe("simple"), [i] = Ke(["financials"]), { setValue: s } = $l(), l = qt(), u = Ot(null), [c, d, m, f] = Jo({ name: ["lifespanYears", "selectedSetId", "sets", "financeForm"] }), p = f == null ? void 0 : f.financeType;
  it(() => {
    var I;
    const k = d ? m == null ? void 0 : m.find((P) => P.id === d) : m == null ? void 0 : m.at(0);
    !k || k.id === u.current || (u.current = k.id, s("selectedSetId", k.id), n(k.financeResult), s(
      "financeForm",
      //for chargers, we only have an entity so we can use the price property to set the price of the charger
      //for vehicles, we have a price for each type of vehicle, electric or fossil, so we need to set the price in a structure that we can use it properly here
      //TODO: revisit this to get a unic structure for both entities
      dt({ ...k.finance }, { msrp: ((I = k.prices) == null ? void 0 : I.electric) || k.price })
    ));
  }, [d, m, s]);
  const b = Qe((k, I, P) => {
    var F, A;
    if (s("selectedSetId", P), P === "all") {
      const B = k.reduce((W, M) => M.financeResult ? ov(W, M.financeResult) : W, k[0].financeResult || AW);
      n(B), s(
        "financeForm",
        //for chargers, we only have an entity so we can use the price property to set the price of the charger
        //for vehicles, we have a price for each type of vehicle, electric or fossil, so we need to set the price in a structure that we can use it properly here
        //TODO: revisit this to get a unic structure for both entities
        dt({ ...k[0].finance }, { msrp: ((F = k[0].prices) == null ? void 0 : F.electric) || k[0].price })
      ), e == null || e(k, P);
    } else {
      const B = k[I];
      n(B.financeResult), s(
        "financeForm",
        //for chargers, we only have an entity so we can use the price property to set the price of the charger
        //for vehicles, we have a price for each type of vehicle, electric or fossil, so we need to set the price in a structure that we can use it properly here
        //TODO: revisit this to get a unic structure for both entities
        dt({ ...B.finance }, { msrp: ((A = B.prices) == null ? void 0 : A.electric) || B.price })
      ), e == null || e(k, B.id);
    }
  }, [s, e]), g = Qe((k) => Dq(p)(k), [p]), S = Qe((k) => Oq(t, p)(k), [t, p]), C = Qe(() => Pq(t, i), [t, i]), { fossilVehicle: w = xm, electricVehicle: v = xm, chargers: x } = t || {}, T = Ee(() => {
    var I, P, F, A, B, W, M, _, O, R, N, L, $;
    const k = {
      labels: [i("chartLabels.cash"), i("chartLabels.lease"), i("chartLabels.finance")]
    };
    return r === "simple" ? x && Object.keys(x).length > 0 ? (k.labels.push(i("chartLabels.caas")), dt({}, va, {
      data: {
        ...k,
        datasets: [
          {
            ...(I = va.data) == null ? void 0 : I.datasets[0],
            label: i("chartLabels.chargers"),
            backgroundColor: g(l.palette.charts.color3.main),
            data: [
              x.cash.totalCostToOwn,
              x.lease.totalCostToOwn,
              x.finance.totalCostToOwn,
              x.caas.totalCostToOwn
            ]
          }
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: (H) => i("chartLabels.tooltips.total", { value: H.raw })
            }
          }
        }
      }
    })) : dt({}, va, {
      data: {
        ...k,
        datasets: [
          {
            ...(P = va.data) == null ? void 0 : P.datasets[0],
            label: i("chartLabels.fossilFuel"),
            backgroundColor: g(l.palette.charts.color3.main),
            data: [
              w.cash.totalCostToOwn,
              w.lease.totalCostToOwn,
              w.finance.totalCostToOwn
            ]
          },
          {
            ...(F = va.data) == null ? void 0 : F.datasets[1],
            label: i("chartLabels.electricVehicle"),
            backgroundColor: g(l.palette.charts.color4.main),
            data: [
              v.cash.totalCostToOwn,
              v.lease.totalCostToOwn,
              v.finance.totalCostToOwn
            ]
          }
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: (H) => i("chartLabels.tooltips.total", { value: H.raw })
            }
          }
        }
      }
    }) : x && Object.keys(x).length > 0 ? dt({}, Cn, {
      data: {
        ...k,
        datasets: [
          {
            ...(A = Cn.data) == null ? void 0 : A.datasets[0],
            label: i("chartLabels.chargers"),
            backgroundColor: g(l.palette.charts.color3.main),
            data: [
              x.cash.totalCostToOwn,
              x.lease.totalCostToOwn,
              x.finance.totalCostToOwn,
              x.caas.totalCostToOwn
            ]
          },
          {
            ...(B = Cn.data) == null ? void 0 : B.datasets[1],
            label: i("chartLabels.principal"),
            backgroundColor: g(l.palette.charts.color4.dark),
            data: [
              x.cash.principal,
              x.lease.principal,
              x.finance.principal,
              x.caas.principal
            ]
          },
          {
            ...(W = Cn.data) == null ? void 0 : W.datasets[1],
            label: i("chartLabels.interest"),
            backgroundColor: g(l.palette.charts.color4.main),
            data: [
              x.cash.interest,
              (x.lease.interest || 0) + (x.depreciation || 0),
              x.finance.interest
            ]
          },
          {
            ...(M = Cn.data) == null ? void 0 : M.datasets[1],
            label: i("chartLabels.taxes"),
            backgroundColor: g(l.palette.charts.color4.light),
            data: [
              x.cash.taxesFees,
              x.lease.taxesFees,
              x.finance.taxesFees,
              x.caas.taxesFees
            ]
          }
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: C()
            }
          }
        }
      }
    }) : dt({}, Cn, {
      data: {
        ...k,
        datasets: [
          {
            ...(_ = Cn.data) == null ? void 0 : _.datasets[0],
            label: i("chartLabels.ice_principal"),
            backgroundColor: g(l.palette.charts.color3.dark),
            data: [
              w.cash.principal,
              w.lease.principal,
              w.finance.principal
            ]
          },
          {
            ...(O = Cn.data) == null ? void 0 : O.datasets[0],
            label: i("chartLabels.ice_interest"),
            backgroundColor: g(l.palette.charts.color3.main),
            data: [
              w.cash.interest,
              (w.lease.interest || 0) + (w.depreciation || 0),
              w.finance.interest
            ]
          },
          {
            ...(R = Cn.data) == null ? void 0 : R.datasets[0],
            label: i("chartLabels.ice_taxes"),
            backgroundColor: g(l.palette.charts.color3.light),
            data: [
              w.cash.taxesFees,
              w.lease.taxesFees,
              w.finance.taxesFees
            ]
          },
          {
            ...(N = Cn.data) == null ? void 0 : N.datasets[1],
            label: i("chartLabels.ev_principal"),
            backgroundColor: g(l.palette.charts.color4.dark),
            data: [
              v.cash.principal,
              v.lease.principal,
              v.finance.principal
            ]
          },
          {
            ...(L = Cn.data) == null ? void 0 : L.datasets[1],
            label: i("chartLabels.ev_interest"),
            backgroundColor: g(l.palette.charts.color4.main),
            data: [
              v.cash.interest,
              (v.lease.interest || 0) + (v.depreciation || 0),
              v.finance.interest
            ]
          },
          {
            ...($ = Cn.data) == null ? void 0 : $.datasets[1],
            label: i("chartLabels.ev_taxes"),
            backgroundColor: g(l.palette.charts.color4.light),
            data: [
              v.cash.taxesFees,
              v.lease.taxesFees,
              v.finance.taxesFees
            ]
          }
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: C()
            }
          }
        }
      }
    });
  }, [
    r,
    v,
    w,
    x,
    l,
    g,
    C,
    i
  ]), E = Ee(() => {
    var k, I, P;
    return x && Object.keys(x).length > 0 ? dt({}, Ca, {
      data: {
        labels: Pm(c, (F) => `Year ${F + 1}`),
        datasets: [
          {
            ...(k = Ca.data) == null ? void 0 : k.datasets[0],
            label: i("chartLabels.chargers"),
            data: S("chargers"),
            backgroundColor: l.palette.charts.color3.main,
            borderColor: l.palette.charts.color3.main
          }
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: (F) => {
                const A = i("chartLabels.chargers");
                return i("chartLabels.tooltips.cashFlow", { vehicleType: A, value: F.raw });
              },
              labelPointStyle: () => ({
                pointStyle: "circle",
                rotation: 0
              })
            }
          }
        }
      }
    }) : dt({}, Ca, {
      data: {
        labels: Pm(c, (F) => `Year ${F + 1}`),
        datasets: [
          {
            ...(I = Ca.data) == null ? void 0 : I.datasets[0],
            label: i("chartLabels.fossilFuel"),
            data: S("electricVehicle"),
            backgroundColor: l.palette.charts.color3.main,
            borderColor: l.palette.charts.color3.main
          },
          {
            ...(P = Ca.data) == null ? void 0 : P.datasets[1],
            label: i("chartLabels.electricVehicle"),
            data: S("fossilVehicle"),
            backgroundColor: l.palette.charts.color4.main,
            borderColor: l.palette.charts.color4.main
          }
        ]
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              title: () => "",
              label: (F) => {
                const A = F.datasetIndex > 0 ? i("chartLabels.electricVehicle") : i("chartLabels.fossilFuel");
                return i("chartLabels.tooltips.cashFlow", { vehicleType: A, value: F.raw });
              },
              labelPointStyle: () => ({
                pointStyle: "circle",
                rotation: 0
              })
            }
          }
        }
      }
    });
  }, [c, S, i, l, x]);
  return {
    detailedChart: r,
    setDetailedChart: o,
    firstChartData: T,
    secondChartProps: E,
    t: i,
    selectedSetId: d,
    financeType: p,
    financeData: dt({}, Zb, f),
    sets: m,
    onFinanceUpdated: b
  };
}
function vG({ boxProps: e, alertProps: t, alertIcon: n, financeFormProps: r, toggleBoxProps: o, titleFirstChartProps: i, captionFirstChartProps: s, titleSecondChartProps: l, captionSecondChartProps: u, financeFormStatusProps: c, isPreviewMode: d, applyButtonCallback: m }) {
  const [f, p] = Xe(!1), { detailedChart: b, setDetailedChart: g, firstChartData: S, secondChartProps: C, t: w, financeType: v, ...x } = kq({ applyButtonCallback: m });
  return J(Be, { paddingY: 2, paddingX: 5, maxWidth: "100%", boxSizing: "border-box", ...e, children: [h(xa, { "data-testid": "finance-info-alert", severity: "info", icon: n || h(LC, {}), ...t, children: w("alert") }), h(nW, { ...r, ...x, financeType: v, statusProps: c, isPreviewMode: d }), h(kt, { className: "noprint" }), h(Be, { width: "100%", display: "flex", justifyContent: "flex-end", marginTop: 6, ...o, children: J($W, { value: b, exclusive: !0, onChange: (T, E) => {
    g(E);
  }, "aria-label": "Chart data model", children: [h(Sm, { value: "simple", "aria-label": "simple model", "data-testid": "finance-financing-cost-chart-simple", children: w("simple") }), h(Sm, { value: "detailed", "aria-label": "detailed model", "data-testid": "finance-financing-cost-chart-detailed", children: w("detailed") })] }) }), h(ve, { marginTop: 6, variant: "h2", ...i, children: w("firstChart.title") }), h(nu, { ...S, "data-testid": "finance-financing-cost-chart" }), h(ve, { width: "100%", marginY: 6, variant: "label", ...s, children: w("firstChart.caption") }), h(ve, { marginTop: 6, variant: "h2", ...l, children: w("secondChart.title") }), h(nu, { ...C, "data-testid": "finance-cash-flow-chart" }), h(ve, { width: "100%", marginY: 6, variant: "label", ...u, children: w("secondChart.caption", { value: v }) }), v !== "caas" ? h(Be, { marginY: 3, children: h(tu, { title: w("summary"), expanded: f, onChange: () => p((T) => !T), children: h(Je, { container: !0, rowSpacing: 0, "data-testid": "finance-resale-value-assumptions", children: RW.map((T) => J(kr, { children: [h(ve, { marginTop: 4, variant: "tableHeader", children: w(`assumptions.${T.title}`) }), h(ve, { marginBottom: 4, variant: "tableBody", children: w(`assumptions.${T.text}`) })] }, T.title)) }) }) }) : h(Be, { marginY: 3, "data-testid": "finance-caas-details", children: h(tu, { title: w("whatIsCaas.title"), expanded: f, onChange: () => p((T) => !T), children: J(Je, { container: !0, children: [h(ve, { marginTop: 4, children: h(Vn, { t: w, i18nKey: "whatIsCaas.description", components: {
    br: h("br", {}),
    a: (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
      h("a", { target: "_blank", rel: "noreferrer noopener" })
    )
  } }) }), J(Kt.Row, { columnGap: 10, columnWidths: ["1fr", "1fr", "1fr"], mt: 16, children: [h(xa, { severity: "info", icon: h(zC, {}), ...t, children: w("whatIsCaas.reduceCosts") }), h(xa, { severity: "info", icon: h(BC, {}), ...t, children: w("whatIsCaas.predictExpenses") }), h(xa, { severity: "info", icon: h(WC, {}), ...t, children: w("whatIsCaas.simplifyProcess") })] })] }) }) })] });
}
function CG({ open: e }) {
  return h(Mq, { role: "status", "data-testid": "global-loader", "aria-label": "loading", "aria-hidden": !e, open: e, children: h(Pl, {}) });
}
const Mq = Q(nw)({
  zIndex: 9999
}), Eq = oe.object({
  sort: oe.string()
}), Iq = {
  sort: "estimated_amount:-1"
};
function iv({ children: e, zipcode: t, spacing: n }) {
  const [r] = Ke(["components.incentivesLayout"]), o = ui({
    values: Iq,
    resolver: Os(Eq),
    mode: "onChange"
  });
  return h(ws, { formContext: o, children: J(Ie, { gap: 4, pt: n, height: "100%", children: [J(Kt, { gap: 4, children: [h(ve, { variant: "h2", textTransform: "capitalize", children: r("title") }), h(ve, { children: r("description") }), h(ps, { severity: "info", IconProps: { id: "alert" }, children: h(Vn, { t: r, i18nKey: "infoBox", values: { zipcode: t }, components: { b: h("b", {}) } }) })] }), e] }) });
}
function Rq({ incentives: e, currentProject: t, EditModalProps: n }) {
  const [r, o] = Xe(!1), [i, s] = Xe(), { onEdit: l, isSaving: u, isError: c, isSuccess: d, onReset: m } = n ?? {}, f = (S) => {
    m == null || m(), s(e.find((C) => C.handle === S)), o(!0);
  }, p = () => {
    s(null), o(!1);
  }, b = ({ isEligibileIncentive: S, estimatedAmount: C }) => {
    l == null || l({
      incentives: {
        [i.handle]: {
          eligibility: S ? "eligible" : "ineligible",
          estimatedAmount: C
        }
      }
    });
  }, g = Ee(() => {
    var T;
    const { handle: S, eligibility: C, estimated_amount: w } = i ?? {}, { estimatedAmount: v, eligibility: x } = ((T = t == null ? void 0 : t.incentives) == null ? void 0 : T[S]) ?? {};
    return {
      isEligibileIncentive: x ? x === "eligible" : C === "eligible",
      estimatedAmount: v ?? w
    };
  }, [i, t]);
  return {
    isOpen: r,
    defaultValues: g,
    isError: c,
    isSuccess: d,
    isSubmitting: u,
    openIncentiveEditModal: f,
    onClose: p,
    onSubmit: b
  };
}
const Aq = oe.object({
  rating: oe.number(),
  feedback: oe.string().max(500).optional(),
  focusGroup: oe.boolean().optional()
});
function wG({ isOpen: e, isSubmitting: t, isSuccess: n, isError: r, clientName: o, defaultValues: i, onClose: s, onSubmit: l }) {
  const [u, c] = Ke(["components.surveyModal"]), d = Ee(() => Array.from({ length: 5 }, (m, f) => {
    const p = f + 1;
    return { id: p, label: p };
  }), []);
  return h(qd, { title: u("title"), isOpen: e, onClose: s, isSubmitting: t, isSuccess: n, isError: r, defaultValues: i, onSubmit: l, schema: Aq, secondaryButtonLabel: c("skip"), children: J(Kt, { children: [J($q, { columnWidths: ["auto", "1fr"], children: [h(Nq, { children: h(rw, {}) }), h(ve, { children: h(Vn, { t: u, i18nKey: "description", values: { clientName: o } }) })] }), h(kt, {}), J(Kt.Row, { cols: 1, rowGap: 4, children: [h(mr, { name: "feedback", multiline: !0, rows: 3, label: u("feedbackLabel"), disabled: n }), h(Fq, { disabled: n, children: h(_F, { label: u("ratingLabel"), name: "rating", options: d, disabled: n, enforceAtLeastOneSelected: !0, exclusive: !0, fullWidth: !0 }) }), h(Ed, { name: "focusGroup", label: h(Vn, { t: u, i18nKey: "signupCheckboxLabel", values: { clientName: o } }), disabled: n })] }), h(kt, {})] }) });
}
const $q = Q(Kt.Row)(({ theme: e }) => ({
  alignItems: "center",
  paddingBottom: e.spacing(6),
  [e.breakpoints.down("md")]: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center"
  }
})), Nq = Q(ow)(({ theme: e }) => ({
  width: 82,
  height: 82,
  backgroundColor: e.palette.primary.main,
  ".MuiSvgIcon-root": { fontSize: 44 }
})), Fq = Q(Be, {
  shouldForwardProp: (e) => e !== "disabled"
})(({ theme: e, disabled: t }) => ({
  "&& .MuiFormLabel-root": {
    color: t ? e.palette.text.disabled : e.palette.text.primary
  }
})), Vq = oe.object({
  isEligibileIncentive: oe.boolean(),
  estimatedAmount: oe.number()
});
function jq({ isOpen: e, isSubmitting: t, isSuccess: n, isError: r, defaultValues: o, onClose: i, onSubmit: s }) {
  const [l, u] = Ke(["components.incentiveEditModal"]);
  return h(qd, { title: l("title"), isOpen: e, onClose: i, isSubmitting: t, isSuccess: n, isError: r, defaultValues: o, onSubmit: s, schema: Vq, primaryButtonLabelValues: {
    fallback: u("save"),
    loading: u("saving")
  }, children: J(Kt, { children: [h(Vy, { name: "isEligibileIncentive", label: h(Jy, { title: l("toggleEligibilityStatus.tooltip"), children: l("toggleEligibilityStatus.label") }) }), h(Eu, { name: "estimatedAmount", label: l("estimatedAmountLabel"), numericInputProps: {
    decimalScale: 2,
    thousandSeparator: !0
  } })] }) });
}
const Lq = oe.object({
  isWelcomeModalDismissed: oe.boolean()
});
function xG({ showWelcomeModal: e, clientProgramName: t, handleModalDismiss: n }) {
  const [r, o] = Xe(!1), [i] = Ke(["components.welcomeModal"]);
  it(() => {
    o(e);
  }, [e]);
  const s = ui({
    values: {
      isWelcomeModalDismissed: !1
    },
    resolver: Os(Lq)
  }), l = Qe((c) => {
    c.isWelcomeModalDismissed && n(c), o(!1);
  }, [n]), u = Qe((c, d) => {
    d || s.handleSubmit(l)();
  }, [s, l]);
  return h(ks, { isOpen: r, title: i("title", { clientProgramName: t }), showCloseButton: !0, onClose: u, disableEscapeKeyDown: !0, "data-testid": "welcome-modal", children: h(ws, { formContext: s, onSuccess: l, children: J(Bq, { children: [h(ve, { children: i("description") }), h(Ed, { name: "isWelcomeModalDismissed", label: i("doNotShowAgain") })] }) }) });
}
const Bq = Q(Ie)(({ theme: e }) => ({
  rowGap: e.spacing(4),
  marginBottom: e.spacing(6),
  ".MuiCheckbox-root": {
    padding: 0,
    marginRight: e.spacing(2.5)
  }
})), zq = {
  eligible: {
    severity: "info",
    IconProps: { id: "attachMoneyIcon" }
  },
  ineligible: {
    severity: "error",
    IconProps: { id: "ineligible" }
  },
  forthcoming: {
    severity: "warning",
    IconProps: { id: "hourGlass" }
  }
}, Wq = 9;
function qq({ incentives: e, currentProject: t }) {
  var d;
  const [n, r] = Ke(["components.incentivesLayout", "common"]), o = Jo({ name: "sort" }), i = Ee(() => e.map((m) => {
    var g;
    const { handle: f } = m, { eligibility: p, estimatedAmount: b } = ((g = t == null ? void 0 : t.incentives) == null ? void 0 : g[f]) ?? {};
    return {
      ...m,
      eligibility: p ?? m.eligibility,
      estimated_amount: b ?? m.estimated_amount
    };
  }), [t, e]), s = Ee(() => [
    { id: "estimated_amount:-1", label: r("sortOptions.highest") },
    { id: "estimated_amount:1", label: r("sortOptions.lowest") },
    { id: "incentive_metadata.grantor_name:1", label: r("sortOptions.grantor_az") },
    { id: "incentive_metadata.grantor_name:-1", label: r("sortOptions.grantor_za") }
  ], [r]), l = Wx(i, o).reduce((m, f) => {
    const p = ["forthcoming", "hiatus", "upcoming", "waitlist"], b = f.eligibility;
    return b === "eligible" ? m.eligible.push({ ...f, _group: Hs.Eligible }) : p.includes(b) ? m.forthcoming.push({ ...f, _group: Hs.Forthcoming }) : m.ineligible.push({ ...f, _group: Hs.Ineligible }), m;
  }, {
    eligible: [],
    ineligible: [],
    forthcoming: []
  }), u = Ee(() => ["eligible", "forthcoming", "ineligible"].reduce((f, p) => f.concat(...l[p]), []), [l]);
  return {
    estimatedIncentives: (d = l.eligible) == null ? void 0 : d.reduce((m, f) => m + f.estimated_amount, 0),
    groupedIncentives: u,
    sortingOptions: s,
    translations: [n, r],
    totalIncentives: u.length,
    totalPages: Math.ceil(u.length / Wq)
  };
}
function Hq({ link: e, onEdit: t, isEdited: n }) {
  const [r] = Ke(["components.incentiveCard"]);
  return J(Uq, { children: [J(Gq, { children: [h(tr, { to: e, component: Qo, target: "_blank", rel: "noopener noreferrer", className: "learn-more-button", children: r("learnMore") }), t ? h(tr, { onClick: t, className: "edit-incentive-button", children: r("editIncentive") }) : null] }), h(Yq, { ...n && { alignSelf: "center" }, children: n ? h(ve, { variant: "fineprint", children: r("userEnteredValue") }) : J(Dt, { children: [h(ve, { variant: "fineprint", children: r("summarizedBy") }), h(Kq, { src: "/ZappyRide.png", alt: "summarized by ZappyRide" })] }) })] });
}
const Uq = Q(Ru)({
  padding: 0,
  flexWrap: "nowrap",
  justifyContent: "space-between",
  alignItems: "flex-end"
}), Yq = Q(Ie)(({ theme: e }) => ({
  display: "flex",
  justifyContent: "flex-end",
  flexDirection: "column",
  gap: e.spacing(1),
  ".MuiTypography-root": {
    lineHeight: 1,
    textIndent: e.spacing(1)
  },
  [e.breakpoints.up("md")]: {
    flexDirection: "row",
    alignItems: "flex-end"
  }
})), Gq = Q(Ie)(({ theme: e }) => ({
  gap: e.spacing(4),
  [e.breakpoints.up("md")]: {
    flexDirection: "row"
  }
})), Kq = Q("img")({
  width: 100
}), Zq = 2;
function av({ children: e, displayToggle: t = !0, showLessLabel: n, showMoreLabel: r, lines: o = Zq }) {
  const [i, s] = Xe(!1), [l, u] = Xe(!1), c = Ot(null), d = (m) => {
    m.preventDefault(), u((f) => !f);
  };
  return Dl(() => {
    if (c.current) {
      const { offsetHeight: m, scrollHeight: f } = c.current;
      s(m < f);
    }
  }, []), J(Be, { role: "region", children: [h(Qq, { isExpanded: l, ref: c, lines: o, children: e }), i && t ? h(di, { role: "button", color: "info.main", component: "button", onClick: d, "aria-expanded": l, variant: "tableBody", underline: "none", children: l ? n ?? "Less" : r ?? "More" }) : null] });
}
const Qq = Q(Be, {
  shouldForwardProp: (e) => e != "isExpanded" && e != "lines"
})(({ isExpanded: e, lines: t }) => ({
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  WebkitLineClamp: "unset",
  ...!e && { WebkitLineClamp: t }
}));
function ur({ title: e, description: t, showInline: n = !1 }) {
  const [r] = Ke(["common"]);
  return J(Jq, { showInline: n, children: [h(ve, { variant: "tableHeader", children: e }), h(av, { showMoreLabel: r("more"), showLessLabel: r("less"), children: h(ve, { variant: "tableBody", children: t }) })] });
}
const Jq = Q(Ie, {
  shouldForwardProp: (e) => e != "showInline"
})(({ theme: e, showInline: t }) => ({
  gap: e.spacing(2),
  [e.breakpoints.down("sm")]: {
    ...t && {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(50%, 1fr))",
      alignItems: "center",
      "& > *": {
        wordBreak: "break-word"
      }
    }
  }
})), Fo = () => h(iw, { mdUp: !0, children: h(kt, {}) });
function Xq({ max: e, assumptions: t, incentiveName: n, fundingToDate: r, applicability: o, organizations: i, expirationDate: s, totalAvailable: l, estimatedAmount: u, eligibilityRationale: c, incentiveDescription: d }) {
  const [m, f] = Ke(["components.incentiveCard"]), p = jr((b) => b.breakpoints.down("md"));
  return J(eH, { role: "region", "aria-label": "incentive card content", container: !0, component: Ol, rowSpacing: 8, columnSpacing: { sm: 6 }, children: [J(Gc, { item: !0, xs: 12, md: 7, children: [h(ve, { variant: "h2", children: f("currency", { value: u }) }), h(ur, { title: n, description: d }), h(ur, { title: m("eligibilityRationale"), description: c }), h(ur, { title: m("assumptions"), description: t })] }), J(Gc, { item: !0, xs: 12, md: 2.5, children: [h(ve, { variant: "tableHeader", children: f("details") }), h(Fo, {}), h(ur, { title: m("closingDate"), description: f("dateFormat", { value: s }), showInline: p }), h(Fo, {}), h(ur, { title: e.label, description: e.value, showInline: p }), h(Fo, {}), h(ur, { title: m("organizations"), description: i, showInline: p })] }), J(Gc, { item: !0, xs: 12, md: 2.5, children: [h(ve, { variant: "tableHeader", children: m("fundingBreakdown") }), h(Fo, {}), h(ur, { title: m("totalAvailable"), description: l ? f("currency", { value: l }) : f("notApplicable"), showInline: p }), h(Fo, {}), h(ur, { title: m("fundingToDate"), description: r ? f("currency", { value: r }) : "--", showInline: p }), h(Fo, {}), h(ur, { title: m("applicability"), description: o || f("notApplicable"), showInline: p })] })] });
}
const eH = Q(Je)({
  padding: 0
}), Gc = Q(Je)(({ theme: e }) => ({
  padding: 0,
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(4)
})), sv = {
  eligible: {
    borderColor: "info.main",
    backgroundColor: "common.white",
    color: "success.main"
  },
  ineligible: {
    borderColor: "primary.main",
    color: "error.main",
    backgroundColor: null
  },
  forthcoming: {
    borderColor: "secondary.main",
    backgroundColor: "common.white",
    color: "secondary.main"
  }
}, tH = {
  "Up to $1,000": { label: "Max", value: "$1,000" },
  "Up to $9,500 per charger": { label: "Max/Charger", value: "$9,500" },
  "Up to $9,500 per charging station": { label: "Max/Charger", value: "$9,500" },
  "Up to $9,500 per port": { label: "Max/Port", value: "$9,500" },
  "Up to $9,500 per vehicle": { label: "Max/Vehicle", value: "$9,500" },
  "Up to $9,500 per forklift": { label: "Max/Forklift", value: "$9,500" },
  "Up to $9,500 per project.": { label: "Max/Project", value: "$9,500" },
  "Up to $30,000 per project.": { label: "Max/Project", value: "$30,000" },
  "Up to $9,500 per site": { label: "Max/Site", value: "$9,500" },
  "Up to $9,500 per year": { label: "Max/Year", value: "$9,500" },
  "Up to 80%": { label: "Max/Project", value: "80%" },
  "Up to 30% discount": { label: "Max", value: "30%" },
  "Up to 80% of costs": { label: "Max % Costs", value: "80%" },
  "Up to 2% of tax": { label: "Max %Tax", value: "2%" }
};
function nH({ title: e, status: t }) {
  var o;
  const [n, r] = Ke(["components.incentiveCard.status", "common"]);
  return h(rH, { title: h(ve, { variant: "h2", children: e }), subheader: J(Ie, { direction: "row", component: "span", columnGap: 1, children: [J(ve, { variant: "h2", children: [r("status"), " "] }), "/", h(ve, { variant: "h2", color: (o = sv[t]) == null ? void 0 : o.color, textTransform: "capitalize", children: h(Vn, { t: n, i18nKey: t }) })] }) });
}
const rH = Q(zm)(({ theme: e }) => ({
  padding: 0,
  ".MuiCardHeader-content": {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: e.spacing(2),
    color: e.palette.text.primary
  },
  ".MuiCardHeader-subheader": { color: "inherit" }
})), oH = ["forthcoming", "upcoming", "hiatus", "waitlist"], iH = (e) => e === "eligible" ? "eligible" : oH.includes(e) ? "forthcoming" : "ineligible", aH = (e) => {
  const t = e.replace(/_/g, " ");
  return t.slice(0, 1).toUpperCase() + t.slice(1);
}, km = (e) => e.map(aH).join(", ");
function sH({ grantor_name: e, incentive_nature: t, incentive_name: n, incentive_description: r, eligibility: o, eligibility_rationale: i, assumptions: s, eligibility_assumptions: l, estimated_amount: u, expiration_date: c, typical_amount: d, eligible_organizations: m, current_funding: f, total_funding: p, incentive_focus: b, incentive_url: g }) {
  return {
    grantorName: e,
    incentiveNature: t,
    incentiveName: n,
    incentiveDescription: r,
    eligibilityRationale: i,
    estimatedAmount: u,
    typicalAmount: parseFloat(d),
    expirationDate: c,
    incentiveUrl: g,
    totalAvailable: f,
    fundingToDate: p,
    assumptions: s.concat(l),
    applicability: km(b ?? []),
    organizations: km(m),
    status: iH(o),
    max: tH[d] ?? {
      label: "Max",
      value: "--"
    }
  };
}
function lH({ CardProps: e, data: t }) {
  const { incentiveUrl: n, ...r } = sH(t), { onEdit: o, isEdited: i } = e ?? {}, s = typeof o == "function", l = Qe(() => {
    s && o(t.incentive_handle);
  }, [t, s, o]);
  return J(cH, { variant: "outlined", status: r.status, role: "region", "aria-label": "incentive card", children: [h(nH, { title: r.grantorName, status: r.status }), h(kt, {}), h(Xq, { ...r }), h(kt, {}), h(Hq, { link: n, onEdit: s ? l : void 0, isEdited: i })] });
}
const cH = Q(Co)(({ theme: e, status: t }) => {
  var o;
  const { backgroundColor: n, borderColor: r } = sv[t];
  return {
    padding: e.spacing(4),
    display: "flex",
    borderLeftWidth: 6,
    boxSizing: "border-box",
    flexDirection: "column",
    rowGap: e.spacing(4),
    borderRadius: e.shape.borderRadius,
    borderColor: (o = e.palette.shape) == null ? void 0 : o.border,
    borderLeftColor: At(e.palette, r, e.palette.primary.main),
    backgroundColor: At(e.palette, n, e.palette.background.default),
    [e.breakpoints.up("md")]: {
      borderLeftWidth: 8,
      rowGap: e.spacing(6),
      padding: e.spacing(6)
    }
  };
}), lv = Q(Co)(({ theme: e }) => ({
  height: 380,
  display: "flex",
  flexDirection: "column",
  borderTopWidth: 6,
  boxSizing: "border-box",
  rowGap: e.spacing(2),
  borderRadius: e.shape.borderRadius,
  borderTopColor: e.palette.primary.main,
  backgroundColor: e.palette.background.default
})), uH = Q(Ol)({ flex: 1, maxHeight: "85%", overflow: "hidden" }), dH = Q(Ol)({
  overflowY: "auto",
  flex: 1
}), cv = Q(Ru)({ justifyContent: "center" });
function fH({ onFlipBack: e, content: t, link: n }) {
  const [r] = Ke(["components.incentiveCard"]);
  return J(lv, { variant: "outlined", role: "region", "aria-label": "incentive card", children: [h(dH, { children: h(ve, { variant: "tableBody", children: t }) }), h(cv, { children: J(Ie, { spacing: 2, children: [h(tr, { size: "small", onClick: e, className: "flip-back-button", children: r("flipBack") }), h(Vl, { size: "small", href: n, component: di, target: "_blank", rel: "noopener noreferrer", className: "more-info-button", children: r("moreInfo") })] }) })] });
}
function pH(e) {
  const [t] = Ke(["components.incentiveCard"]), { grantor_type: n, incentive_url: r, incentive_nature: o, typical_amount: i, incentive_name: s, incentive_description: l } = e, [u, c] = Xe(!1), d = () => c((m) => !m);
  return u ? h(fH, { link: r, content: l, onFlipBack: d }) : J(lv, { variant: "outlined", role: "region", "aria-label": "incentive card", children: [h(uH, { children: J(Ie, { textAlign: "center", spacing: 6, children: [h(ve, { variant: "label", children: n }), h(ve, { variant: "label", children: o }), h(ve, { variant: "h2", children: i }), h(kt, { variant: "middle" }), h(av, { displayToggle: !1, children: h(ve, { variant: "tableBody", children: s }) })] }) }), h(cv, { children: h(Vl, { size: "small", onClick: d, className: "learn-more-button", children: t("learnMore") }) })] });
}
function SG({ animate: e }) {
  const t = e ? "pulse" : !1;
  return h(Co, { variant: "outlined", sx: { height: 380 }, children: J(Ie, { spacing: 3, padding: 2, children: [h(Or, { height: 30, animation: t }), h(Or, { height: 80, animation: t }), h(Or, { height: 150, variant: "rectangular", animation: t }), h(kt, { variant: "middle" }), h(Or, { variant: "rounded", height: 50, animation: t })] }) });
}
function mH({ currentEligibilityGroup: e, prevEligibilityGroup: t, translations: n, values: r }) {
  if (!t || e !== t) {
    const [o] = n, i = e;
    return h(Be, { mb: 4, children: h(ps, { ...zq[i], title: o(`eligibilitySection.${i}.title`), children: h(Vn, { t: o, i18nKey: `eligibilitySection.${i}.description`, values: r, components: { b: h("b", {}) } }) }) });
  }
  return null;
}
function hH({ item: { incentive_metadata: e, ...t }, index: n, shownItems: r, items: o, pageProps: { currentPage: i, itemsPerPage: s }, translations: l, estimatedIncentives: u, openIncentiveEditModal: c, currentProject: d }) {
  var m, f, p;
  return J(kr, { children: [h(mH, { currentEligibilityGroup: t._group, prevEligibilityGroup: ((m = r[n - 1]) == null ? void 0 : m._group) || ((f = o[(i - 1) * s - 1]) == null ? void 0 : f._group), translations: l, values: { estimatedIncentives: u } }), h(lH, { data: { ...e, ...t }, CardProps: {
    onEdit: c,
    isEdited: Object.keys(((p = d == null ? void 0 : d.incentives) == null ? void 0 : p[t.handle]) ?? {}).length != 0
  } })] }, `${e.incentive_handle}-${n}`);
}
function gH({ incentives: e, currentProject: t, openIncentiveEditModal: n }) {
  const { estimatedIncentives: r, groupedIncentives: o, sortingOptions: i, translations: s } = qq({ incentives: e, currentProject: t }), [l] = s;
  return h(Qb, { items: o, itemsCategory: l("incentives"), keyExtractor: (u) => u.incentive_metadata.incentive_handle, SortComponentProps: {
    sortingOptions: i
  }, renderItem: (u) => h(hH, { ...u, translations: s, estimatedIncentives: r, openIncentiveEditModal: n, currentProject: t }) });
}
function yH({ incentives: e, currentProject: t, EditModalProps: n, disabled: r, spacing: o }) {
  const { openIncentiveEditModal: i, ...s } = Rq({
    incentives: e,
    currentProject: t,
    EditModalProps: n
  }), { isAllowed: l } = fi(), u = !r && l("show", "incentiveCard", "edit");
  return J(iv, { zipcode: t == null ? void 0 : t.project.zipcode, spacing: o, children: [h(gH, { incentives: e, currentProject: t, openIncentiveEditModal: u ? i : void 0 }), u ? h(jq, { ...s }) : null] });
}
function uv({ incentivesType: e }) {
  const [t] = Ke(["common"], "incentives");
  return h(bH, { severity: "error", IconProps: { id: "alert" }, "data-testid": `${e}-incentives-error`, children: t("error") });
}
const bH = Q(ps)(({ theme: e }) => ({
  marginTop: e.spacing(10)
}));
function TG({ isPreviewMode: e, currentProject: t, getIncentives: n, useSaveProjectMutation: r, saveProjectAction: o }) {
  const i = ob(), [s] = Ke(["common"]), l = Ot(!1), { data: u = [], status: c } = n(), [, { isLoading: d, isError: m, isSuccess: f, reset: p }] = r({
    fixedCacheKey: "global-auto-save"
  }), b = (g) => {
    l.current = !0, i(o(g));
  };
  return it(() => {
    f && l.current && (l.current = !1);
  }, [f]), c === "error" ? h(uv, { incentivesType: "evaluation" }) : c === "loading" && !l.current ? null : u.length ? h(vH, { "data-testid": "output-incentives-wrapper", children: h(yH, { incentives: u, currentProject: t, EditModalProps: {
    onEdit: b,
    onReset: p,
    isError: m,
    isSaving: d,
    isSuccess: f
  }, disabled: e, spacing: 10 }) }) : h(ve, { variant: "body1", py: 10, children: s("noIncentives") });
}
const vH = Q(Ie)(({ theme: e }) => ({
  gap: e.spacing(4),
  height: "100%",
  form: {
    display: "flex",
    flex: 1
  }
})), CH = ({ children: e }) => h(Kt.Row, { columnWidths: ["repeat(auto-fill, minmax(240px, 1fr))"], children: e });
function wH({ incentives: e = [], zipcode: t, allowSorting: n = !1, spacing: r }) {
  const [o] = Ke(["common"]), i = Ee(() => [
    { id: "estimated_amount:-1", label: o("sortOptions.highest") },
    { id: "estimated_amount:1", label: o("sortOptions.lowest") },
    { id: "incentive_metadata.grantor_name:1", label: o("sortOptions.grantor_az") },
    { id: "incentive_metadata.grantor_name:-1", label: o("sortOptions.grantor_za") }
  ], [o]);
  return h(iv, { zipcode: t, spacing: r, children: h(Qb, { items: e, keyExtractor: (s) => s.incentive_handle, renderItem: ({ item: s }) => h(pH, { ...s }, s.incentive_handle), SortComponentProps: { ...n && { sortingOptions: i } }, ListWrapper: CH }) });
}
function _G({ mode: e, zipcode: t, allowSorting: n }) {
  const { data: r, isLoading: o, isError: i } = h2({
    mode: e,
    postcode: t
  });
  return i ? h(uv, { incentivesType: "commercial" }) : o ? null : h(xH, { "data-testid": "output-incentives-wrapper", children: h(wH, { incentives: r, zipcode: t, allowSorting: n }) });
}
const xH = Q(Ie)(({ theme: e }) => ({
  display: "grid",
  gridTemplateRows: "1fr",
  marginTop: e.spacing(10),
  height: "100%"
})), DG = ({ title: e, value: t, caption: n, tag: r, IconProps: o, TooltipProps: i, maxWidth: s, tagColor: l = "success", isLoading: u, ...c }) => {
  const d = h(ve, { variant: "tableHeader", children: e });
  return J(Ie, { direction: "row", gap: 4, maxWidth: s, ...c, children: [o && h(Be, { display: "flex", alignItems: "center", justifyContent: "center", children: h(Rr, { size: "2.25rem", color: "primary", ...o }) }), J(Ie, { justifyContent: "center", flex: 1, textAlign: "center", gap: 2, children: [i ? h(xo, { ...i, children: d }) : d, J(Be, { display: "flex", alignItems: "center", textAlign: "center", gap: 2, children: [r ? h(kl, { label: h(ve, { variant: "tableHeader", children: u ? h(Or, {}) : t }), color: l, size: "small" }) : h(ve, { variant: "h2", flex: 1, children: u ? h(Or, {}) : t }), n && h(ve, { variant: "tableBody", children: n })] })] })] });
}, Mm = (e, t) => {
  const n = e.findIndex(({ name: r }) => r === (t == null ? void 0 : t.split("/").at(-1)));
  return !t || n === -1 ? 0 : n;
};
function SH({ steps: e, lastPath: t, forceFirstStep: n }) {
  const r = Sv(), o = Tv(), i = Ee(() => Mm(e, r.step), [r.step, e]), s = i === 0, l = i === e.length - 1, u = e[i];
  return Dl(() => {
    if (t) {
      const m = Mm(e, t);
      if (i > m) {
        o(e[m].name, { replace: !0 });
        return;
      }
    }
    (!r.step || n) && o(`/onboarding/${e[0].name}`, { replace: !0 });
  }, []), {
    currentStepIndex: i,
    currentStep: u,
    isFirstStep: s,
    isLastStep: l,
    goToNextStep: () => {
      l || o(`/onboarding/${e[i + 1].name}`);
    },
    goToPreviousStep: () => {
      s || window.history.back();
    }
  };
}
const TH = Q(Ie)(({ theme: e }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  [e.breakpoints.only("xs")]: {
    justifyContent: "unset"
  }
})), Em = Q(pr)(({ theme: e }) => ({
  [e.breakpoints.only("xs")]: {
    flex: 1,
    marginLeft: e.spacing(3)
  }
}));
function _H({ isFirstStep: e, isLastStep: t, onBackClick: n, onNextClick: r }) {
  const [o] = Ke();
  return J(Ie, { spacing: 3, children: [h(kt, {}), J(TH, { children: [h(pr, { variant: "outlined", disabled: e, onClick: n, "data-testid": "onboarding-actions-back", children: o("back") }), t ? h(Em, { type: "submit", "data-testid": "onboarding-actions-submit", children: o("seeResults") }, "submit") : h(Em, { onClick: r, "data-testid": "onboarding-actions-next", children: o("next") }, "next")] })] });
}
const DH = ({ steps: e, children: t, ...n }) => {
  const r = Ee(() => typeof e == "number" ? Array.from({ length: e }) : Array.isArray(e) ? e : [], [e]), o = Array.isArray(e) && n.orientation !== "vertical";
  return J(lw, { alternativeLabel: o, ...n, children: [!t && r.map((i, s) => h(aw, { children: h(sw, { children: i }) }, `step-${s}`)), t] });
};
function PH({ active: e, steps: t, maxWidth: n = "sm" }) {
  return h(Nu, { maxWidth: n, children: h(DH, { activeStep: e, steps: t, "data-testid": "stepper" }) });
}
function PG({ steps: e, defaultValues: t, onStepNext: n, onSuccess: r, lastPath: o, forceFirstStep: i }) {
  const { currentStepIndex: s, currentStep: { schema: l, Component: u }, isFirstStep: c, isLastStep: d, goToNextStep: m, goToPreviousStep: f } = SH({ steps: e, lastPath: o, forceFirstStep: i }), p = e[s].Actions, b = ui({
    shouldUnregister: !1,
    resolver: Os(l),
    defaultValues: t,
    // common issue with type casting https://github.com/orgs/react-hook-form/discussions/3713
    mode: "onChange"
  }), g = async () => {
    const C = await b.trigger(), w = !!Object.keys(b.formState.errors).length;
    if (!C || d || w)
      return;
    const v = b.getValues();
    n == null || n(v, s), b.reset(v), m();
  }, S = () => {
    const C = b.getValues();
    r(C);
  };
  return J(Ie, { component: "main", display: "grid", gridTemplateRows: "auto 1fr", gap: 6, children: [h(Xb, { children: h(PH, { active: s, steps: e.length }) }), h(Jb, { spreadContent: !0, children: h(ws, { onSuccess: S, formContext: b, children: J(Ie, { justifyContent: "space-between", spacing: 3, children: [h(u, {}), p ? h(p, { onNext: g }) : h(_H, { isFirstStep: c, isLastStep: d, onNextClick: g, onBackClick: f })] }) }) })] });
}
const OG = ({
  // for now this parameter support encapsulated loading for saas.fleets by default using browser.fetch
  // and connect to redux toolkit if existing by passing the prop "getOrganizationTypesQuery"
  getOrganizationTypesQuery: e,
  displaySelectedDescription: t,
  name: n,
  ...r
}) => {
  const { getAllowedFields: o } = fi(), i = Ee(() => o("show", "organizationTypes").join(","), [o]), [s, { isLoading: l, data: u }] = e(), c = Jo({ name: n }), d = Ee(() => {
    var m;
    return (m = u == null ? void 0 : u.find(({ id: f }) => f === c)) == null ? void 0 : m.description;
  }, [u, c]);
  return it(() => {
    s(i);
  }, [i, s]), t ? J(Ie, { gap: 1, children: [h(co, { name: n, options: u, isLoading: l, fullWidth: !0, ...r }), h(ve, { children: d })] }) : h(co, { name: n, options: u, isLoading: l, fullWidth: !0, ...r });
}, OH = process.env.REACT_APP_ZR_API_URL, kH = async (e, t) => (await (await fetch(`${OH}/organization-types?values=${e}`, {
  headers: { authorization: `Bearer ${t}` }
})).json())["organization-types"].map(({ value: i, display_name: s }) => ({ id: i, label: s })), kG = (e) => () => {
  const [t, n] = Xe(!0), [r, o] = Xe([]);
  return [Qe(async (s) => {
    if (!e)
      return;
    n(!0);
    const l = await kH(s, e);
    o(l), n(!1);
  }, [e]), { data: r, isLoading: t }];
}, dv = ai({}), MH = Ml.defaults.animation, EH = () => {
  Ml.defaults.animation = !1;
}, IH = () => {
  Ml.defaults.animation = MH;
}, MG = ({ children: e }) => {
  const [t, n] = Xe(!1), r = Qe(() => {
    n(!0), EH();
  }, []), o = () => {
    r(), setTimeout(() => {
      window.print();
    }, 300);
  };
  it(() => {
    const s = () => {
      n(!1), IH();
    };
    return addEventListener("afterprint", s), addEventListener("beforeprint", r), () => {
      removeEventListener("beforeprint", r), removeEventListener("afterprint", s);
    };
  }, [r]);
  const i = t ? { values: { md: 0 } } : {};
  return h(dv.Provider, { value: { isPrinting: t, print: o, breakpoints: i }, children: e });
}, fv = () => si(dv), RH = Q(Zc, {
  shouldForwardProp: (e) => e !== "divider"
})(({ theme: e, divider: t }) => {
  var n;
  return {
    borderRightColor: (n = e.palette.shape) == null ? void 0 : n.border,
    borderRightStyle: "solid",
    borderRightWidth: t ? 1 : 0
  };
});
function AH({ currentTab: e, tabs: t }) {
  const [n, r] = Xe(e), [o] = Ke(["pages.output"]), i = Object.keys(t).length > 6, s = (l, u) => {
    r(u);
  };
  return it(() => {
    e !== n && r(e);
  }, [e, n]), h(Jm, { value: n, onChange: s, role: "navigation", variant: i ? "scrollable" : "fullWidth", scrollButtons: i, children: t.map(({ key: l, url: u, dividerAfter: c }) => h(RH, { label: h(ve, { variant: l === n ? "tabActive" : "tabInactive", children: o(`${l}.navigation`) }), component: Qo, to: u, id: `label-panel-${l}`, "aria-controls": `panel-${l}`, role: "tab", value: l, divider: c }, l)) });
}
function EG({ activeTab: e, isLoading: t, tabs: n, Filters: r }) {
  const o = jr((f) => f.breakpoints.up("md")), [i, s] = Xe(o), { print: l } = fv();
  it(() => {
    s(o);
  }, [o]);
  const [u] = Ke(["pages.output"]);
  if (t)
    return null;
  const { displayFilters: c, Component: d, key: m } = e;
  return J(Je, { container: o, justifyContent: "center", component: "main", columnSpacing: 6, className: `${e.key}-tab`, children: [J(Ie, { spacing: 4, display: i || !c ? "none" : "block", children: [J(Ie, { alignItems: "center", justifyContent: "space-between", direction: "row", "data-testid": "output-filters-toggle", children: [h(ve, { variant: "h2", children: u(`${m}.navigation`) }), h(Tl, { onClick: () => {
    s(!0);
  }, children: h(Rr, { id: "rules" }) })] }), h(Be, { children: h(kt, {}) })] }), h(Je, { className: "noprint print-button-container", item: !0, md: 3, display: o ? "flex" : "none", children: h(tr, { fullWidth: !0, startIcon: h(Rr, { id: "print" }), onClick: l, "data-testid": "output-print", children: u("print") }) }), h($H, { item: !0, md: 9, className: "print-full-width", children: h(AH, { tabs: n, currentTab: m }) }), c && i && h(r, { className: "noprint output-sidebar", onReturn: () => {
    s(!1);
  } }), h(Je, { display: o || !i ? "block" : "none", item: !0, md: c ? 9 : 12, className: "print-full-width", children: h(Yx, { children: h(d, {}) }) })] });
}
const $H = uC(Je)(({ theme: e }) => ({
  [e.breakpoints.down("md")]: { display: "none" }
}));
function IG({ className: e, onReturn: t, children: n, Actions: r, Disclaimer: o }) {
  const [i] = Ke(["pages.output.sidebar"]);
  return J(NH, { className: e, item: !0, md: 3, children: [J(Ie, { direction: "row", alignItems: "center", display: { xs: "flex", md: "none" }, "data-testid": "output-sidebar-mobiletoggle", children: [h(Tl, { variant: "text", onClick: t, children: h(th, { fontSize: "small" }) }), h(ve, { variant: "h2", children: i("title") })] }), h(Ie, { children: n }), r, o] });
}
const NH = Q(Je)(({ theme: e }) => ({
  [e.breakpoints.up("md")]: { marginTop: e.spacing(6) },
  display: "flex",
  flexDirection: "column",
  rowGap: e.spacing(4)
})), FH = Vt(function(t, n) {
  const { onChange: r, ...o } = t;
  return h(T_, { getInputRef: n, onValueChange: (i) => {
    r && r({
      target: {
        name: t.name,
        value: i.value
      }
    });
  }, ...o });
}), RG = ({ patternInputProps: e, ...t }) => {
  const { InputProps: n } = t;
  return h(mr, { ...t, InputProps: {
    ...n,
    inputComponent: FH,
    inputProps: { ...e }
  } });
}, pv = ({ defaultValue: e, value: t }) => Array.isArray(e) && e.length > 1 || Array.isArray(t) && t.length > 1;
function VH(e) {
  const { children: t, ...n } = e;
  return h(dw, { ...n, children: h(Be, { children: t }) });
}
function mv(e) {
  return function(n) {
    const { enableFloatingLabel: r = !1, valueLabelDisplay: o = "on", ...i } = n;
    let s = {};
    return !r && !pv(n) && (s = { valueLabel: VH }), h(e, { slots: s, valueLabelDisplay: o, ...i });
  };
}
function jH(e) {
  const t = mv(uw);
  return h(t, { ...e });
}
jH.displayName = "Slider";
const LH = Q(Be)(({ theme: e }) => ({
  ".MuiFormLabel-root": {
    marginBottom: e.spacing(1)
  }
}));
function BH(e) {
  const t = Ee(() => mv(TF), []);
  return h(LH, { children: h(t, { ...e }) });
}
BH.displayName = "RhfMuiSlider";
const hv = (e) => {
  const { active: t, completed: n, icon: r } = e, o = r && typeof r != "number", i = Ee(() => n ? pw : t ? fw : mw, [t, n]);
  return o ? h(Dt, { children: r }) : h(i, { fontSize: "large", color: n || t ? "primary" : "disabled" });
}, zH = Q(ve)(() => ({ position: "absolute", left: "-25px" })), WH = (e) => {
  const t = e.icon && typeof e.icon != "number";
  return J(Dt, { children: [h(ef, {}), J(Be, { display: "flex", flexDirection: "row", alignItems: "center", position: "relative", children: [!t && J(Dt, { children: [h(zH, { variant: "h2", color: "grey.200", children: e.icon }), h(hv, { ...e })] }), t && e.icon] }), h(ef, { classes: { active: "Mui-disabled" } })] });
};
function qH(e) {
  const { orientation: t } = si(cw);
  return t === "vertical" ? h(WH, { ...e }) : h(hv, { ...e });
}
const AG = ({ children: e }) => h(Be, { marginY: 5, children: h(ve, { variant: "h2", children: e }) }), HH = { values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 } }, UH = {}, YH = {
  MuiButton: {
    defaultProps: {
      size: "medium",
      variant: "contained"
    },
    styleOverrides: {
      containedSizeSmall: ({ theme: e }) => ({
        padding: e.spacing(2.215, 4)
      }),
      containedSizeMedium: ({ theme: e }) => ({
        padding: e.spacing(3, 6)
      }),
      containedSizeLarge: ({ theme: e }) => ({
        padding: e.spacing(3.79, 8)
      }),
      outlinedSizeSmall: ({ theme: e }) => ({
        padding: e.spacing(1.965, 3.75)
      }),
      outlinedSizeMedium: ({ theme: e }) => ({
        padding: e.spacing(2.75, 5.75)
      }),
      outlinedSizeLarge: ({ theme: e }) => ({
        padding: e.spacing(2.975, 7.75)
      }),
      root: ({ theme: e }) => ({
        textTransform: "none",
        fontWeight: e.typography.fontWeightRegular
      })
    }
  },
  MuiButtonBase: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        "&.MuiButtonBase-root": {
          textTransform: "initial",
          borderRadius: e.shape.buttonBorderRadius
        }
      })
    }
  },
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme: e }) => {
        const { shape: { buttonBorderRadius: t, borderWidth: n }, palette: { primary: { main: r, contrastText: o }, shape: i } } = e;
        return {
          borderRadius: t,
          borderWidth: n,
          borderColor: i == null ? void 0 : i.border,
          borderStyle: "solid",
          gap: e.spacing(4),
          padding: e.spacing(1.5),
          "& .MuiButtonBase-root, & .MuiButtonBase-root.Mui-disabled": {
            borderColor: "transparent"
          },
          "&& .MuiToggleButton-standard": {
            borderRadius: t,
            backgroundColor: "transparent",
            color: r,
            "&.Mui-selected, &.Mui-selected:hover": {
              backgroundColor: r,
              color: o
            },
            "&.Mui-disabled": { opacity: 0.6 }
          },
          "&& .MuiToggleButton-sizeSmall": {
            padding: e.spacing(1.965, 4)
          },
          "&& .MuiToggleButton-sizeMedium": {
            padding: e.spacing(2.75, 6)
          },
          "&& .MuiToggleButton-sizeLarge": {
            padding: e.spacing(3.54, 8)
          }
        };
      }
    }
  },
  MuiRadio: {
    defaultProps: {
      disableRipple: !0
    },
    styleOverrides: {
      colorPrimary: ({ theme: e }) => {
        const { main: t } = e.palette.primary;
        return {
          color: t,
          "&.Mui-checked": {
            color: t
          }
        };
      },
      root: ({ theme: e }) => ({
        "&.MuiRadio-root": {
          borderRadius: "50%",
          paddingLeft: 0
        },
        "& + .MuiFormControlLabel-label": e.typography.label
      })
    }
  },
  MuiSwitch: {
    defaultProps: {
      disableRipple: !0
    },
    styleOverrides: {
      colorPrimary: ({ theme: e }) => {
        const { main: t } = e.palette.primary, { white: n } = e.palette.common, { grey: r } = e.palette;
        return {
          "&.MuiSwitch-switchBase": {
            ".MuiSwitch-thumb": {
              backgroundColor: t
            },
            "& + .MuiSwitch-track": {
              opacity: 1,
              backgroundColor: "transparent",
              borderColor: t
            },
            "&.Mui-checked": {
              "& + .MuiSwitch-track": {
                backgroundColor: t
              },
              "& .MuiSwitch-thumb": {
                backgroundColor: n
              },
              "&.Mui-disabled .MuiSwitch-thumb": {
                backgroundColor: "transparent"
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                borderColor: "transparent",
                backgroundColor: r[400]
              }
            },
            "&.Mui-disabled": {
              "& + .MuiSwitch-track": {
                borderColor: r[400],
                backgroundColor: "transparent"
              },
              ".MuiSwitch-thumb": {
                backgroundColor: r[400]
              }
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
              backgroundColor: t,
              border: "6px solid transparent"
            }
          }
        };
      },
      root: ({ theme: e }) => ({
        width: 40,
        height: 26,
        padding: 0,
        overflow: "hidden",
        marginRight: e.spacing(2),
        "& .MuiSwitch-switchBase": {
          padding: 0,
          margin: e.spacing(0.75),
          transitionDuration: "300ms",
          color: "currentColor",
          ".MuiSwitch-thumb": {
            backgroundColor: "transparent",
            boxSizing: "border-box",
            width: 20,
            height: 20
          },
          "& + .MuiSwitch-track": {
            boxSizing: "border-box",
            borderRadius: 100,
            borderStyle: "solid",
            borderColor: "transparent",
            borderWidth: e.shape.buttonBorderWidth
          },
          "&.Mui-checked": {
            transform: "translateX(14px)",
            "& + .MuiSwitch-track": {
              opacity: 1
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
              opacity: 1,
              backgroundColor: "transparent"
            },
            "&.Mui-disabled + .MuiSwitch-track": {
              opacity: 0.5
            }
          },
          "&.Mui-disabled .MuiSwitch-thumb": {
            opacity: 0.5,
            backgroundColor: "transparent"
          },
          "&.Mui-disabled + .MuiSwitch-track": {
            opacity: 0.5
          },
          "&.Mui-focusVisible .MuiSwitch-thumb": {
            backgroundColor: "currentColor",
            border: "6px solid transparent"
          }
        },
        "& + .MuiFormControlLabel-label": e.typography.label
      })
    }
  }
}, GH = {}, KH = {}, ZH = {
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme: e }) => {
        var t;
        return {
          minWidth: "30%",
          "& .MuiDialogContent-root": {
            paddingTop: e.spacing(8),
            paddingBottom: e.spacing(4),
            borderBottomColor: "transparent",
            borderTopColor: (t = e.palette.shape) == null ? void 0 : t.border
          },
          "& .MuiDialogActions-root": {
            marginTop: e.spacing(-2),
            padding: e.spacing(6),
            gap: e.spacing(3),
            "& .MuiButton-outlined": {
              minWidth: "30%"
            }
          },
          "& .MuiDialogTitle-root.MuiTypography-root": {
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr max-content",
            paddingTop: e.spacing(6),
            ...e.typography.h3,
            "& .MuiButtonBase-root": {
              padding: 0
            }
          }
        };
      }
    }
  },
  MuiAlert: {
    styleOverrides: {
      root: ({ vertical: e }) => ({
        alignItems: "center",
        ...e ? {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          "& .MuiAlert-icon": {
            marginRight: 0
          }
        } : void 0
      })
    }
  }
}, QH = {
  MuiInputLabel: {
    defaultProps: {
      shrink: !0,
      size: "small"
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        marginBottom: e.spacing(1),
        ...e.typography.label,
        color: e.palette.text.primary
      }),
      formControl: {
        position: "relative",
        transform: "none"
      }
    }
  },
  MuiInputBase: {
    defaultProps: {},
    styleOverrides: {
      root: ({ theme: e }) => ({
        minWidth: 200,
        backgroundColor: e.palette.background.paper,
        // To fix helper text alignment
        "& + .MuiFormHelperText-root": {
          marginLeft: 0
        },
        // hide arrows from input
        "& input[type=number]::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
          display: "none"
        },
        "& input[type=number]": {
          MozAppearance: "textfield"
        },
        "&.MuiInputBase-readOnly": {
          backgroundColor: e.palette.grey[100],
          pointerEvents: "none"
        }
      })
    }
  },
  MuiOutlinedInput: {
    defaultProps: {
      notched: !1
    },
    styleOverrides: {
      root: ({ theme: e, ownerState: { size: t } }) => {
        var n;
        return {
          ...e.typography.label,
          ...e.typography.body2,
          ...t === "medium" && {
            ".MuiOutlinedInput-input:not(.MuiInputBase-inputMultiline)": {
              paddingTop: e.spacing(3.125),
              paddingBottom: e.spacing(3.125)
            }
          },
          ...t === "large" && {
            ".MuiOutlinedInput-input:not(.MuiInputBase-inputMultiline)": {
              paddingTop: e.spacing(4.125),
              paddingBottom: e.spacing(4.125)
            }
          },
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: (n = e.palette.shape) == null ? void 0 : n.border
          }
        };
      }
    }
  },
  MuiTextField: {
    defaultProps: {
      size: "medium"
    }
  },
  MuiSelect: {
    defaultProps: {
      size: "medium"
    }
  }
}, JH = {
  MuiAppBar: {
    defaultProps: {
      style: {
        maxWidth: "100vw"
      }
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        ...Yd(e)
      })
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: () => ({
        "&.MuiButtonBase-root.MuiMenuItem-gutters": {
          borderRadius: 0
        }
      })
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        "&.MuiButtonBase-root": {
          borderRadius: 0
        }
      }
    }
  }
}, XH = {
  MuiSlider: {
    styleOverrides: {
      root: ({ theme: e, ownerState: t }) => {
        const { main: n } = e.palette.primary, { common: { white: r }, grey: o } = e.palette;
        return {
          color: o[200],
          height: 4,
          "& .MuiSlider-rail": {
            height: 4,
            opacity: 1
          },
          "& .MuiSlider-track": {
            border: "none",
            color: !t.disabled && pv(t) ? n : "currentColor"
          },
          "& .MuiSlider-thumb": {
            height: 18,
            width: 18,
            backgroundColor: r,
            border: `5px solid ${n}`,
            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
              boxShadow: `0 0 0 8px ${sn(n, 0.16)}`
            },
            "&:before": {
              display: "none"
            },
            "input + .MuiSlider-valueLabelOpen": {
              marginTop: e.spacing(6.5)
            }
          },
          "&.Mui-disabled .MuiSlider-thumb": {
            borderColor: o[200]
          },
          "&.Mui-disabled": {
            color: o[200]
          },
          ".MuiSlider-valueLabel": {
            backgroundColor: "transparent",
            position: "relative",
            transform: "unset",
            top: e.spacing(4),
            ".MuiSlider-valueLabelLabel": {
              display: "none"
            },
            "&.MuiSlider-valueLabelOpen": {
              transform: "unset",
              ".MuiSlider-valueLabelLabel": {
                display: "initial",
                opacity: t.disabled ? 0.5 : 1,
                color: e.palette.text.primary,
                ...e.typography.label
              }
            }
          }
        };
      }
    }
  }
}, eU = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: () => ({
        // Fix negative margin-left added at RHF-MUI switch element
        "&.MuiFormControlLabel-labelPlacementEnd": {
          marginLeft: 0
        }
      })
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        color: e.palette.text.primary,
        ...e.typography.label,
        ".MuiFormLabel-asterisk": {
          color: e.palette.error.main
        }
      })
    }
  }
}, tU = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme: e }) => {
        const { palette: t, presets: n, typography: r, spacing: o } = e, { tooltip: i } = n ?? {}, { main: s, contrastText: l } = en(t, i == null ? void 0 : i.backgroundColor);
        return {
          fontSize: r.body.fontSize,
          fontWeight: r.fontWeightRegular,
          padding: o(2, 4),
          backgroundColor: s,
          color: l,
          a: Fu(e, s)
        };
      },
      arrow: ({ theme: { palette: e, presets: t } }) => {
        const { tooltip: n } = t ?? {}, { main: r } = en(e, n == null ? void 0 : n.backgroundColor);
        return {
          color: r
        };
      }
    }
  }
}, Im = {
  MuiCssBaseline: {
    styleOverrides: (e) => ({
      "@media print": {
        ".MuiCollapse-root": {
          height: "auto !important",
          visibility: "visible !important"
        },
        ":not(.overview-tab) > .print-full-width": {
          flexBasis: "100%",
          minWidth: "100%"
        },
        ".overview-tab": {
          ".output-sidebar, .print-button-container": {
            display: "block !important"
          }
        },
        ".MuiTabs-indicator": {
          display: "none"
        },
        "html, body": {
          minWidth: "297mm !important"
        },
        "@page": {
          size: "A4",
          margin: 0
        },
        ".chart-print-config": {
          "&, canvas, div": {
            width: "100% !important",
            height: "230px !important"
          }
        },
        ".noprintshadow": { boxShadow: "none !important", overflow: "unset !important" },
        ".noprint": {
          display: "none !important"
        },
        "*": {
          // This prop is to force display the background colors
          // in the PDF print.
          // It should have the Webkit prefix set
          // otherwise it only works in Firefox.
          printColorAdjust: "exact",
          WebkitPrintColorAdjust: "exact"
        }
      },
      a: Fu(e, e.palette.background.default)
    })
  }
}, nU = {
  MuiTypography: {
    defaultProps: {
      variant: "body",
      variantMapping: {
        hero: "h1"
      }
    }
  }
}, rU = {
  MuiStepper: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        color: e.palette.primary.main,
        [`& > :first-of-type .${pn.root}:first-of-type`]: {
          visibility: "hidden"
        },
        [`& > :last-of-type .${pn.root}:last-child:not(.Mui-active)`]: {
          visibility: "hidden"
        },
        [`& > :not(:has(.${tf.root})):last-child .${pn.root}:last-child`]: {
          visibility: "hidden"
        },
        [`& .${fa.vertical}`]: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start"
        },
        [`& .${fa.vertical} .${tf.root}`]: {
          borderLeft: "2px solid",
          borderLeftColor: e.palette.grey[200],
          marginLeft: "16px",
          width: "100%"
        },
        [`& .${fa.horizontal}`]: {
          display: "flex",
          padding: 0,
          margin: "0 -3px"
        },
        [`& .${fa.horizontal}.${fa.alternativeLabel}`]: {
          display: "block",
          padding: 0
        }
      })
    }
  },
  MuiStepLabel: {
    defaultProps: {
      StepIconComponent: qH
    },
    styleOverrides: {
      root: ({ theme: e }) => ({
        [`& .${Mo.label}`]: {
          ...e.typography.label
        },
        [`&.${Mo.vertical}`]: {
          marginTop: "0 !important",
          padding: 0,
          width: "100%"
        },
        [`&.${Mo.vertical} .${Mo.iconContainer}`]: {
          alignSelf: "stretch",
          flexDirection: "column"
        },
        [`.${Mo.alternativeLabel}`]: {
          marginTop: "0 !important"
        },
        [`.${Mo.iconContainer}`]: {
          paddingRight: 0
        }
      })
    }
  },
  MuiStepConnector: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        [`&.${pn.alternativeLabel}`]: {
          top: "19px",
          left: "calc(-50% + 23px)",
          right: "calc(50% + 16px)"
        },
        [`&.${pn.active}, &.${pn.completed}`]: {
          [`& .${pn.line}`]: {
            backgroundColor: e.palette.primary.main
          }
        },
        [`&.${pn.disabled}`]: {
          [`& .${pn.line}`]: {
            backgroundColor: e.palette.grey[200]
          }
        },
        [`& .${pn.line}`]: {
          border: 0,
          backgroundColor: e.palette.grey[200]
        },
        [`& .${pn.lineHorizontal}`]: {
          height: "2px"
        },
        [`&.${pn.vertical}`]: {
          display: "flex",
          flexDirection: "column",
          marginLeft: "19px",
          marginTop: "-3px",
          marginBottom: "-3px"
        },
        [`& .${pn.lineVertical}`]: {
          width: "2px",
          flexGrow: 1
        }
      })
    }
  }
}, oU = {
  MuiChip: {
    styleOverrides: {
      root: ({ theme: e }) => ({
        borderRadius: e.shape.borderRadius
      }),
      filled: ({ theme: e, ownerState: t }) => ({
        ...t.color && t.color !== "default" && {
          backgroundColor: Vo(e.palette[t.color].light, 0.9),
          color: e.palette[t.color].main
        }
      }),
      label: ({ theme: e }) => ({
        paddingLeft: e.spacing(2),
        paddingRight: e.spacing(2)
      })
    }
  }
}, iU = {
  MuiDivider: {
    styleOverrides: {
      root: ({ theme: e }) => {
        var t;
        return {
          borderColor: (t = e.palette.shape) == null ? void 0 : t.border
        };
      }
    }
  }
}, aU = {
  ...UH,
  ...YH,
  ...oU,
  ...GH,
  ...Im,
  ...KH,
  ...ZH,
  ...eU,
  ...QH,
  ...JH,
  ...XH,
  ...tU,
  ...nU,
  ...Im,
  ...rU,
  ...iU
}, sU = {
  primary: {
    main: "#172536",
    // Zappy Dark Navy
    contrastText: "#FFF"
  },
  secondary: {
    main: "#FDA536"
    // Zappy Orange
  },
  background: {
    paper: "#FFF",
    // white paper on top of default gray
    default: "#F6F6F6"
    // default gray background
  },
  charts: {
    color1: {
      main: "#172536",
      dark: da("#172536", 0.3),
      light: Vo("#172536", 0.3)
    },
    color2: {
      main: "#FDA536",
      dark: da("#FDA536", 0.3),
      light: Vo("#FDA536", 0.3)
    },
    color3: {
      main: "#95893D",
      dark: da("#95893D", 0.3),
      light: Vo("#95893D", 0.3)
    },
    color4: {
      main: "#2E6F0F",
      dark: da("#2E6F0F", 0.3),
      light: Vo("#2E6F0F", 0.3)
    },
    color5: {
      main: "#000000",
      dark: da("#000000", 0.3),
      light: Vo("#000000", 0.3)
    }
  },
  shape: {
    border: "#B9BCC0"
  },
  link: {
    main: "#66B2FF",
    light: "#0079F4"
  },
  success: {
    main: "#008443",
    light: "#339C68"
  },
  warning: {
    main: "#FDA536",
    light: "#FDB85E"
  },
  error: {
    main: "#EE0004",
    light: "#F13336"
  },
  info: {
    main: "#003C88",
    light: "#33649F"
  },
  grey: {
    100: "#F6F6F6",
    200: "#B9BCC0",
    300: "#707070",
    400: "#333333",
    500: "#151515",
    600: "#000000"
  },
  custom: []
}, lU = {
  button: {
    primary: {
      variant: "contained",
      color: "primary"
    },
    secondary: {
      variant: "outlined",
      color: "primary"
    }
  },
  tooltip: {
    backgroundColor: "primary"
  },
  salesContactButton: {
    icon: "contact",
    buttonBackgroundColor: "secondary",
    bannerBackgroundColor: "primary"
  },
  header: {
    /**
     * backgroundColor and color fields can only have those values
     * which when chained to `theme.palette` would return hexcode or color value.
     * In here, `primary.main` gives the hexcode.
     * If we pass a hexcode which is not available in the theme directly
     * then the hexcode value will be returned
     * For fontweight, the value can either be string or number:
     * - `fontWeightRegular` or `fontWeightLight` or `fontWeightMedium` or `fontWeightBold`
     * - `light` or `normal` or `medium` or `bold` or `bolder`
     * - 100 | 200 | 300 | 400 | 500 | 600 | 700
     */
    backgroundColor: "primary.main",
    fontWeight: "fontWeightMedium",
    fontFamily: "Roboto"
  },
  footer: { backgroundColor: "primary", fontWeight: "fontWeightMedium", fontFamily: "Roboto" }
}, cU = {
  logo: {
    name: "resources.logo-d.svg",
    url: "https://images.squarespace-cdn.com/content/v1/60c3c0c4e6193a3137d44071/8d670981-19b0-4f91-8d0a-4003e3277ca0/Site+Logo.png",
    fileType: "svg+xml"
  }
}, uU = {
  checkboxBorderRadius: 3,
  buttonBorderRadius: 5,
  borderRadius: 4,
  buttonBorderWidth: 1,
  borderWidth: 1
}, dU = 4, Rm = {
  hero: {
    fontSize: 4,
    lineHeight: 1.0625,
    fontWeight: 700
  },
  h1: {
    fontSize: 2,
    lineHeight: 1.6875,
    fontWeight: 400
  },
  h2: {
    fontSize: 1.375,
    lineHeight: 1.0909,
    fontWeight: 400
  },
  h3: {
    fontSize: 1.125,
    lineHeight: 1.2222,
    fontWeight: 700
  },
  body: {
    fontSize: 1,
    lineHeight: 1.125,
    fontWeight: 400
  },
  fineprint: {
    fontSize: 0.75,
    lineHeight: 1.1666,
    fontWeight: 400
  },
  tableHeader: {
    fontSize: 0.875,
    lineHeight: 1.1428,
    fontWeight: 700
  },
  tableBody: {
    fontSize: 0.875,
    lineHeight: 1.1428,
    fontWeight: 400
  },
  button: {
    fontSize: 1,
    lineHeight: 1.5,
    fontWeight: 400,
    textTransform: "initial"
  },
  tabActive: {
    fontSize: 1,
    lineHeight: 1.125,
    fontWeight: 600
  },
  tabInactive: {
    fontSize: 1,
    lineHeight: 1.125,
    fontWeight: 400
  },
  label: {
    fontSize: 0.875,
    fontWeight: 400,
    lineHeight: 1.1428
  }
}, gv = ({ typography: e }) => {
  const { fontSize: t } = e || {};
  return Object.keys(Rm).reduce((n, r) => {
    const o = n[r];
    return o.fontSize = o.fontSize * t, n;
  }, dt({}, Rm));
}, fU = {
  htmlFontSize: 16,
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  ...gv({ typography: { fontSize: 16 } })
}, pU = {
  typography: fU,
  palette: sU,
  components: aU,
  spacing: dU,
  shape: uU,
  presets: lU,
  resources: cU,
  breakpoints: HH
}, $G = ({ theme: e, children: t }) => {
  const { breakpoints: n } = fv(), r = dt({}, e, { breakpoints: n }), o = dt({}, pU, r), i = Ee(() => ({ typography: gv(o) }), [o]), s = Ee(() => ({ palette: u1(o.palette) }), [o]), l = jm(o, i, s);
  return h(Dv, { theme: l, children: t });
};
function NG({
  alertName: e,
  IconProps: t,
  ...n
}) {
  return /* @__PURE__ */ h(pi, { I: "show", on: "alerts", field: e, children: /* @__PURE__ */ h(ps, { IconProps: t, ...n }) });
}
function mU(e, t, n = "USD", r, o = "-") {
  return t === null ? o : Intl.NumberFormat(e, {
    style: "currency",
    currency: n,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...r
  }).format(t);
}
Ye.extend(ph);
Ye.extend(uh);
Ye.tz.setDefault("America/New_York");
function hU(e, t, n = "long") {
  const r = Ye(t).toDate();
  return Intl.DateTimeFormat(e, {
    dateStyle: n
  }).format(r);
}
function gU(e, t, n, r = "-") {
  return t === null ? r : Intl.NumberFormat(e, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...n
  }).format(t);
}
var yv = /* @__PURE__ */ ((e) => (e.EN = "en", e.ES = "es", e.FR = "fr", e))(yv || {});
const FG = Object.values(yv), Am = "translation", VG = {
  lng: "en",
  fallbackLng: "en",
  debug: process.env.NODE_ENV !== "production",
  defaultNS: Am,
  fallbackNS: ["fallback", Am],
  partialBundledLanguages: !0,
  keySeparator: ".",
  interpolation: {
    format: (e, t, n, r = {}) => {
      if (!t || !n)
        return e;
      const [o, ...i] = t.split(",").map((l) => l.trim()), { formatOptions: s = {} } = r;
      switch (o) {
        case "currency":
          return mU(n, e, i[0], s);
        case "numberMaxDigits":
          return gU(n, e, s);
        case "date":
          return hU(n, e);
        default:
          return e;
      }
    }
  },
  react: {
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "b"]
  }
}, yU = "{{value, numberMaxDigits}} amps", bU = "Back", vU = "Battery Capacity", CU = "Cancel", wU = "Change", xU = "Close", SU = "All", TU = {
  charger: {
    amps: "Amps",
    ampsValue: "{{value}} amps",
    cableLength: "Cable Length",
    certifications: "Certifications",
    charger: "Charger Model",
    chargerModelLabel: "Charger model",
    chargerMSRP: "Charger Price",
    chargerOutput: "Charger kW output",
    chargerType: "Charger Type",
    connectivity: "Connectivity",
    dc_fast_charging: "DCFC",
    dualPort: "Dual Port",
    estimatedCost: "Estimated Cost",
    formFactor: "Form Factor",
    lengthValue: "{{value}} ft",
    level_1: "Level 1",
    level_2: "Level 2",
    multiPort: "Dual Port",
    ocpp: "OCPP",
    oscp: "OSCP",
    outlets: "Outlet(s)",
    plugTypes: "Plug Type(s)",
    port_one: "Port",
    port_other: "Ports",
    portkw: "Port kW",
    replaceCharger: "Select from Charger Catalog",
    selected: "Selected charger",
    singlePort: "Single Port",
    vehicleToGrid: "Vehicle to Grid",
    warranty: "Warranty",
    warrantyValue_one: "{{count}} Year",
    warrantyValue_other: "{{count}} Years"
  },
  dragDropFileUpload: {
    acceptedSizes: "{{maxWidth}}px x {{maxHeight}}px",
    allowedFilesFormats: "Acceptable file format: {{formats}}",
    allowedMaxFiles: ". Max: {{maxFiles}} files.",
    allowedSizes: ", {{sizes}}",
    bytes: "Bytes",
    dropDescription: "<p>Drop your {{label}} file here to upload</p> or <strong>select from storage</strong>",
    fileSizeError: "File too big. Max size: {{maxSize}}",
    gb: "GB",
    imageDimensionsError: "Image too big. Max allowed dimensions: {{maxWidth}}px x {{maxHeight}}px",
    kb: "KB",
    mb: "MB",
    "n/a": "n/a",
    tb: "TB",
    upload: "Upload"
  },
  leavingAppModal: {
    message: "Are you sure you want to navigate away from {{clientProgramName}}’s website? {{clientName}} holds no liability for content outside its website.",
    title: "Leaving {{clientProgramName}}"
  },
  supportModal: {
    email: "Email",
    issueDescription: "Issue Description",
    name: "Name",
    subject: "Subject",
    title: "Support"
  },
  surveyModal: {
    description: "Congratulations, you did it!<br /> We at {{clientName}} wish you the best with your charging journey!",
    feedbackLabel: "Anything we can improve? Share your feedback:",
    ratingLabel: "Rate your experience using this tool:",
    signupCheckboxLabel: "Sign me up to engage with {{clientName}} in future focus groups",
    title: "Project Complete!"
  },
  welcomeModal: {
    description: "Thanks for sharing your charging needs! You have completed the first step, and can now delve through the estimations we’ve generated for your project. Be sure to check out our partners to help facilitate your charger installation project.",
    doNotShowAgain: "Do not show again",
    title: "Welcome to {{clientProgramName}}"
  }
}, _U = "Confirm", DU = "Showing {{count}} of {{totalItems}} {{category}}", PU = "{{value, currency, USD}}", OU = "Date", kU = "{{value, date}}", MU = {
  no: "No",
  unset: "I don't know",
  yes: "Yes"
}, EU = "Details", IU = "{{value}} selected", RU = "Download", AU = "Efficiency", $U = "Electric Vehicle", NU = "Something went wrong. Please try again!", FU = "Estimated Price", VU = "EV solutions provided by ZappyRide, a J.D. Power business.<br /><br />Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor {{clientName}} provides tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.", jU = "Fossil Fuel Vehicle", LU = "Fuel", BU = "Generic", zU = "{{value, numberMaxDigits}} kW", WU = "{{value, numberMaxDigits}} kWh", qU = "Log Out", HU = "{{value, numberMaxDigits}} mi", UU = {
  jan: "JAN",
  feb: "FEB",
  mar: "MAR",
  apr: "APR",
  may: "MAY",
  jun: "JUN",
  jul: "JUL",
  aug: "AUG",
  sep: "SEP",
  oct: "OCT",
  nov: "NOV",
  dec: "DEC"
}, YU = "{{value, numberMaxDigits}} MPG", GU = "{{value, numberMaxDigits}} MPGe", KU = "Next", ZU = "No", QU = "No results found based on your inputs. If you think there is a mistake, you may update your inputs.", JU = "N/A", XU = "Page {{currentPage}} of {{totalPages}}", e3 = "Range", t3 = "Recommended", n3 = "Retry", r3 = "Save", o3 = "Saving", i3 = "See Results", a3 = "Send", s3 = "Sending", l3 = "Skip", c3 = "Sort By", u3 = "Success", d3 = {
  am: "{{value}} AM",
  pm: "{{value}} PM"
}, f3 = "{{value, numberMaxDigits}} tons", p3 = "Total", m3 = {
  year_one: "{{count}} year",
  year_other: "{{count}} years"
}, h3 = {
  sun: "SUN",
  mon: "MON",
  tue: "TUE",
  wed: "WED",
  thu: "THU",
  fri: "FRI",
  sat: "SAT"
}, g3 = "Weight Class", y3 = "Yes", b3 = {
  errorMessage: "Not valid zip code format",
  helperText: "Used to check incentive applicability",
  label: "Zip code",
  tooltip: "The zip or postal code of your project will be used to determine electricity pricing and potentially identify incentives.",
  apiErrorMessage: "Unable to retrieve data"
}, jG = {
  amps: yU,
  back: bU,
  batteryCapacity: vU,
  cancel: CU,
  change: wU,
  close: xU,
  all: SU,
  components: TU,
  confirm: _U,
  continue: "Continue",
  countDisplay: DU,
  currency: PU,
  date: OU,
  dateFormat: kU,
  decisionOptions: MU,
  delete: "Delete",
  details: EU,
  displayCount: IU,
  download: RU,
  efficiency: AU,
  electricVehicle: $U,
  error: NU,
  estimatedPrice: FU,
  footer: VU,
  fossilFuelVehicle: jU,
  fuel: LU,
  generic: BU,
  kW: zU,
  kWh: WU,
  logout: qU,
  miles: HU,
  monthsShort: UU,
  mpg: YU,
  mpge: GU,
  next: KU,
  no: ZU,
  noResults: QU,
  notApplicable: JU,
  paginationInfo: XU,
  range: e3,
  recommended: t3,
  retry: n3,
  save: r3,
  saving: o3,
  seeResults: i3,
  send: a3,
  sending: s3,
  skip: l3,
  sortBy: c3,
  success: u3,
  time: d3,
  tons: f3,
  total: p3,
  values: m3,
  weekDaysShort: h3,
  weightClass: g3,
  yes: y3,
  zipcode: b3
}, v3 = {
  noIncentives: "No incentives found!",
  sortOptions: {
    highest: "Highest First",
    lowest: "Lowest First",
    grantor_az: "Grantor A-Z",
    grantor_za: "Grantor Z-A"
  },
  more: "More",
  less: "Less",
  status: "Status",
  details: "Details",
  sortBy: "Sort By"
}, C3 = {
  incentiveCard: {
    eligibilityRationale: "Project Eligibility Analysis",
    assumptions: "Assumptions",
    closingDate: "Closing date",
    totalAvailable: "Total Available",
    fundingToDate: "Funding to Date",
    applicability: "Applicability",
    organizations: "Organizations",
    fundingBreakdown: "Funding Breakdown",
    summarizedBy: "summarized by",
    userEnteredValue: "User entered value",
    learnMore: "Learn More",
    editIncentive: "Edit Incentive",
    status: {
      eligible: "Eligible",
      ineligible: "ineligible",
      forthcoming: "On Hiatus"
    },
    flipBack: "FLIP BACK",
    moreInfo: "MORE INFO"
  },
  incentivesLayout: {
    title: "Potential eligible incentives",
    description: "Please be aware you must apply directly with the organization referenced and confirm eligibility and amount directly with that organization. Funding amounts estimated here are estimates only and are not guaranteed.",
    infoBox: "These are available incentives based on the zipcode <b>{{zipcode}}</b> you entered. You can update this in the assumptions to the left.",
    "eligibilitySection.eligible": {
      title: "",
      description: "Estimated incentives <b>{{estimatedIncentives, currency, USD}}</b>"
    },
    "eligibilitySection.ineligible": {
      title: "Ineligible Incentives",
      description: "Your project is ineligible for the incentives below"
    },
    "eligibilitySection.forthcoming": {
      title: "Possibly forthcoming incentives",
      description: "The following incentives are upcoming, on hiatus or have a waitlist meaning they may open in the future"
    },
    incentives: "incentives"
  },
  incentiveEditModal: {
    title: "Edit Incentive",
    estimatedAmountLabel: "Revised estimated Incentive value ($)",
    toggleEligibilityStatus: {
      label: "This incentive is applicable to my project",
      tooltip: "An incentive that is applicable to a project is counted in the total incentives amount. To exclude this incentive amount, change the toggle to the off position."
    }
  }
}, LG = {
  common: v3,
  components: C3
};
export {
  RY as AbilityConsumer,
  AY as AbilityProvider,
  ps as Alert,
  NG as AlertFleet,
  IY as AnalyticsProvider,
  Eh as BaseAccordion,
  TT as BorderedBox,
  wo as Button,
  pi as Can,
  BY as CandleChart,
  tu as CardAccordion,
  FY as CardSlider,
  iG as CatalogContainer,
  LY as ChargerModelCard,
  cG as ChargerTypesDropdown,
  nu as Chart,
  Qy as Checkbox,
  bG as CommonLayout,
  _G as CompactIncentives,
  wH as CompactIncentivesView,
  Jy as ComponentWithTooltip,
  lf as ConditionalCan,
  BV as ContactUsButton,
  Z2 as ContactUsButtonWithConfig,
  MY as DateUtil,
  VT as DescriptionTable,
  TG as DetailedIncentives,
  yH as DetailedIncentivesView,
  lG as Disclaimer,
  wz as DragDropFileUpload,
  uG as FieldArray,
  $Y as FilterAccordion,
  nW as FinanceForm,
  vG as FinanceTab,
  mW as Footer,
  hW as FooterWithConfig,
  Ed as FormCheckbox,
  zY as FormCheckboxButtonGroup,
  aG as FormDatePicker,
  sG as FormDateTimePicker,
  mG as FormMultipleDragDropFileUpload,
  dG as FormPasswordElement,
  fG as FormPasswordRepeatElement,
  co as FormSelectElement,
  pG as FormSwitchElement,
  mr as FormTextField,
  ba as FormTextFieldElement,
  CG as GlobalLoader,
  OW as Header,
  kW as HeaderWithConfig,
  Rr as Icon,
  Tl as IconButton,
  lH as IncentiveCard,
  pH as IncentiveCardCompact,
  SG as IncentiveCardCompactLoading,
  jq as IncentiveEditModal,
  DG as InfoCard,
  yv as Languages,
  EW as LeavingAppModal,
  rG as LoadingContainer,
  nG as LoadingContextProvider,
  kh as LoadingIndicator,
  NY as MarketingCard,
  ks as Modal,
  jY as MultiColumnDescriptionTable,
  _z as MultipleDragDropFileUpload,
  Am as NAMESPACE,
  Eu as NumericFieldElement,
  PG as Onboarding,
  PH as OnboardingHeader,
  OG as OrganizationTypes,
  EG as Output,
  yG as OutputLayout,
  IG as OutputSidebar,
  Qb as PaginatedLayout,
  RG as PatternFieldElement,
  Vl as PrimaryButton,
  MG as PrintProvider,
  BH as RhfMuiSlider,
  tr as SecondaryButton,
  Kt as Section,
  N2 as SectionRow,
  oG as SectionTemplate,
  hG as SelectElement,
  jH as Slider,
  AG as StepGroupLabel,
  hv as StepIcon,
  DH as Stepper,
  qH as StepperIcon,
  G2 as SupportModal,
  wG as SurveyModal,
  Yx as SuspenseLoader,
  B2 as TextField,
  $G as ThemeProvider,
  I2 as TitleSubtitle,
  xo as Tooltip,
  av as Truncate,
  xG as WelcomeModal,
  Ib as WithLoadingContext,
  Kx as abilityBuilder,
  VG as baseI18nextOptions,
  Bx as buildChargerPortsName,
  Lx as buildChargerTypeName,
  UT as connectivityIconsMap,
  jG as fallbackTranslations,
  gG as financeFormSchema,
  oW as financeStateSchema,
  Ph as flattenObject,
  LG as incentivesTranslations,
  Fu as makeLinkStyles,
  EY as matchFilter,
  zx as operators,
  u1 as parseCustomColors,
  en as resolveReferenceColors,
  Wx as sortArray,
  FG as supportedLngs,
  pU as unbrandedOptions,
  fi as useAbility,
  Ux as useAnalytics,
  VY as useGetConfigChargerTypes,
  kG as useGetOrganizationTypesQuery,
  E2 as useLoading,
  fv as usePrintMode,
  K2 as useSupportModal,
  Ke as useTranslation,
  rW as vehicleSetStateSchema,
  Xy as withAbility,
  Es as withDisabledOnSubmit
};
